/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/rmeta/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 353);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(360);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return monthNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ratings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return toTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return parseJwt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CKsettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObserverEcoachMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return message; });
/* unused harmony export confirmmessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return objToSlashString; });
/* unused harmony export objToQueryString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return showHide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reactLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reactLoaderk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setTokenData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTokenData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return winResize; });
/* unused harmony export jsUpdateSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return composcroll; });
/* unused harmony export fnRefreshDDAccordion */
/* unused harmony export fnscrollContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return updateScrollLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return showconleft; });
/* unused harmony export getVisibleMenuId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return headerLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return contentResizeLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isAccordionInit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ddaccordionInIt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return showLargeLeftMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return showSmallLeftMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return downTabClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return leftClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return scrollToTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hideleftbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_Config__ = __webpack_require__(2);
var $=window.$;var jQuery=window.jQuery;var monthNames=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];var ratings=['','(Poor).','(Below Average).','(Average).','(Above Average).','(Good).','(Excellent).','(Outstanding).'];var toTimestamp=function toTimestamp(strDate){var datum=Date.parse(strDate);return datum/1000;};var parseJwt=function parseJwt(token){if(token){var base64Url=token.split('.')[1];var base64=base64Url.replace('-','+').replace('_','/');return JSON.parse(window.atob(base64));}else{return false;}};var isset=function isset(strVariableName){if(typeof strVariableName=='undefined'||strVariableName===null){return false;}return true;};var CKsettings={toolbarGroups:[{name:'clipboard',groups:['clipboard','undo']},{name:'links',groups:['links']},'/',{name:'basicstyles',groups:['basicstyles','cleanup']},{name:'paragraph',groups:['list','indent','align','paragraph']},{name:'styles',groups:['styles']},{name:'colors',groups:['colors']}]};var $scrollbarleft3=jQuery('#semana-scroll-left3');var range=function range(start,count){return Array.apply(0,Array(count)).map(function(element,index){return index+start;});};var ObserverEcoachMessage=function ObserverEcoachMessage(obj){var pamessage="";if(getUserData("mentor",true)){if(obj.evaluation_mentor==1&&obj.evaluation_ecoach==1&&obj.mentor_perform==1&&obj.ecoach_perform==1){pamessage="This component will be rated by your Observer(s) and E Coach. Please choose the Observer(s) from the list below.";}if(obj.evaluation_mentor==1&&obj.evaluation_ecoach==1&&obj.mentor_view==1&&obj.ecoach_view==1){pamessage="This component will be viewed by your Observer(s) and E Coach. Please choose the Observer(s) from the following list.";}if(obj.evaluation_mentor==1&&obj.evaluation_ecoach==0&&obj.mentor_perform==1){pamessage=" This component will be rated by your Observer(s). Please choose the Observer(s) from the following list.";}if(obj.evaluation_mentor==1&&obj.evaluation_ecoach==0&&obj.mentor_view==1){pamessage="This component will be viewed by your Observer(s). Please choose the Observer(s) from the following list.";}if(obj.evaluation_mentor==0&&obj.evaluation_ecoach==1&&obj.ecoach_perform==1){pamessage="This will be rated by your E Coach.";}if(obj.evaluation_mentor==0&&obj.evaluation_ecoach==1&&obj.ecoach_view==1){pamessage="This will be viewed by your E Coach.";}if(obj.evaluation_mentor==1&&obj.evaluation_ecoach==1&&obj.mentor_perform==0&&obj.ecoach_perform==1&&obj.ecoach_view==0&&obj.mentor_view==1){pamessage="This will be rated by your E Coach and viewed by your Observer(s). Please choose the Observer(s) from the following list.";}if(obj.evaluation_mentor==1&&obj.evaluation_ecoach==1&&obj.mentor_perform==1&&obj.ecoach_perform==0&&obj.ecoach_view==1&&obj.mentor_view==0){pamessage="This component will be rated by your Observer(s) and viewed by your E Coach. Please choose Observer(s) from the following list.";}}else if(obj.evaluation_ecoach==1){pamessage="This will be rated by your E Coach.";}return pamessage;};var message=function message(title,_message,type){//window.swal(title, message, type);
if(type=='error'){window.swal(title,_message,type);}else if(type=='library'){window.swal(title,_message,'');}else{window.swal({text:_message,animation:false});}};var confirmmessage=function confirmmessage(title,message,type){window.swal({//title: title,
text:message,//type: type,
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){return 1;}else{return 0;}});};var objToSlashString=function objToSlashString(obj){var keyValuePairs=[];for(var key in obj){keyValuePairs.push(encodeURIComponent(obj[key]));}return"/"+keyValuePairs.join('/');};var objToQueryString=function objToQueryString(obj){var keyValuePairs=[];for(var key in obj){keyValuePairs.push(encodeURIComponent(key)+'='+encodeURIComponent(obj[key]));}return keyValuePairs.join('&');};var showHide=function showHide(showEle,hideEle){$(showEle).show();$(hideEle).hide();};var reactLoader=function reactLoader(visible){var text=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";if(visible=="show"){$('#overlay').show();}else if(visible=="hide"){$("#overlay").hide();}if(text!=""){$("#overlay #text").html(text);}};var reactLoaderk=function reactLoaderk(visible){var text=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";if(visible=="show"){$('#overlay1').show();}else if(visible=="hide"){$("#overlay1").hide();}};var setTokenData=function setTokenData(key){var val=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";localStorage.setItem("token"+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */],val);};var getTokenData=function getTokenData(){if(localStorage.getItem("token"+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */])!=undefined){return localStorage.getItem("token"+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */]);}else{return false;}};var setUserData=function setUserData(key){var val=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var isUserData=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(isUserData){// let sessData = localStorage.getItem("token"+app_name);
//localStorage.setItem("token"+app_name, responseJson.token);
if(getTokenData()){// let userData = decode(getTokenData());
// 	userData[key] = val;
// 	return localStorage.setItem("token"+app_name, JSON.stringify(userData));
return fetch(__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */]+'update-data',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+getTokenData()},body:JSON.stringify({update:getTokenData(),key:key,val:val})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==2){localStorage.removeItem("token"+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */]);return localStorage.setItem("token"+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */],responseJson.token);//return getTokenData();
}});}}return localStorage.setItem(key+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */],val);};var getUserData=function getUserData(key){var isUserData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(isUserData){var tokenData=getTokenData();if(tokenData){var userData=parseJwt(tokenData);// console.log(userData)
return userData&&userData[key]||false;}}else{return localStorage.getItem(key+__WEBPACK_IMPORTED_MODULE_0__config_Config__["c" /* app_name */])||false;}// if (isUserData) {
// 	let sessData = localStorage.getItem("user"+app_name);
// 	return sessData && JSON.parse(sessData)[key] || false;
// } else {
// 	return localStorage.getItem(key+app_name) || false;
// }
};var clearUserData=function clearUserData(){// localStorage.removeItem("user"+app_name);
// localStorage.removeItem("isLoggedIn"+app_name);
// localStorage.removeItem("sessMax"+app_name);
localStorage.clear();return true;};var winResize=function winResize(){jQuery(window).resize(function(){jsUpdateSize();var width=jQuery(window).width();var height=jQuery(window).height();fnscrollContent(height);});};var jsUpdateSize=function jsUpdateSize(){var width=jQuery(window).width();var height=jQuery(window).height();jQuery("#contentsection").css({'border-left-width':'1px'});// Hide/Show Fullwidth Content Area
if(width<=1023){jQuery('#contentsection').removeClass("halfcontent");}else{if(jQuery('#leftnavsec').is(':visible')){jQuery('#leftnavsec').addClass("leftnavshow");jQuery('#leftnavsec').removeClass("leftnavhide");jQuery('#contentsection').css('width','');jQuery('#contentsection').addClass("halfcontent");jQuery('#contentsection').css({'border-left-width':'1px'});}else{jQuery('#leftnavsec').removeClass("leftnavshow");jQuery('#contentsection').removeClass("halfcontent");}}// Hide/Show Fullwidth Content Area
jQuery("#contentsection").css({'border-left-width':'1px'});// Mobile mmenu Starts
if(width>=768){jQuery("html").removeClass("mm-opened mm-background mm-right mm-opening");jQuery("nav#menu").removeClass("mm-current mm-opened");}};var composcroll=function composcroll(){if(jQuery('#semana-scroll').length>0){var $scrollbarContent=jQuery('#semana-scroll').tinyscrollbar();var scrollbarContent=$scrollbarContent.data("plugin_tinyscrollbar");scrollbarContent.update(0);}};var fnRefreshDDAccordion=function fnRefreshDDAccordion(){/* $scrollbar5 = jQuery('#semana-scroll-inner');
	$scrollbar5.tinyscrollbar();
		*/$scrollbarleft3.tinyscrollbar();jQuery('#semana-scroll').tinyscrollbar();jQuery('#semana-scroll-left').tinyscrollbar();jQuery('#semana-scroll-left1').tinyscrollbar();jQuery('#semana-scroll-left2').tinyscrollbar();jQuery('#semana-scroll-mobile').tinyscrollbar();jQuery('#semana-scroll-mobile1').tinyscrollbar();jQuery('#semana-scroll-register').tinyscrollbar();};var fnscrollContent=function fnscrollContent(arg){if(arg>700){jQuery('#semana-scroll-left .viewport').css({'height':arg-326+'px'});jQuery('.contentarea').css({'min-height':arg-180+'px'});jQuery('.left-nav').css({'min-height':arg-160+'px'});}else{jQuery('#semana-scroll-inner .viewport','#semana-scroll-left .viewport').css({'height':''});}jQuery('#semana-scroll-left').tinyscrollbar();};var updateScrollLeft=function updateScrollLeft(){var scrollbarleft3=$scrollbarleft3.data("plugin_tinyscrollbar");if(scrollbarleft3){scrollbarleft3.update("relative");}};var showconleft=function showconleft(){jQuery("#contentsection").css({'border-left-width':'1px'});// Hide/Show Fullwidth Content Area
jQuery('.showconleft').click(function(){var childLen=jQuery("div.silverheader").length;if(jQuery(window).width()<=1023){if(jQuery('#leftmenuarrow').hasClass('closearrow')){jQuery("#menularge").show();jQuery("#menusmall").hide();}else{jQuery("#menusmall").show();}jQuery('#leftnavsec').toggle('slide',{direction:'left'},800,function(){// Animation complete.
/* if( jQuery('#leftmenuarrow').hasClass('closearrow') ) {
				 jQuery("#menusmall").show();
				}else{
				 //jQuery("#menusmall").show();
				} */});//Toggle Arrow
if(jQuery('#leftmenuarrow').hasClass('closearrow')){jQuery('#leftmenuarrow').addClass("openarrow");jQuery('#leftmenuarrow').removeClass("closearrow");//jQuery("#menusmall").hide();
//jQuery("#menularge").show();
}else{jQuery('#leftmenuarrow').addClass("closearrow");jQuery('#leftmenuarrow').removeClass("openarrow");}//Toggle Arrow
}else{if(jQuery('#leftnavsec').is(':visible')){if(childLen>2){jQuery("div.silverheader").eq(getVisibleMenuId()-2).trigger("click");}else{jQuery("div.silverheader").eq(0).trigger("click");}jQuery('#leftmenuarrow').addClass("closearrow");jQuery('#leftmenuarrow').removeClass("openarrow");//jQuery('#leftnavsec').hide(900,'linear',function(){
jQuery('#leftnavsec').toggle('slide',{direction:'left'},800,function(){jQuery("#menusmall").show();jQuery("#menularge").hide();jQuery('#leftnavsec').addClass("leftnavhide");jQuery('#leftnavsec').removeClass("leftnavshow");jQuery('#contentsection').removeClass("halfcontent");});jQuery("#contentsection").animate({width:"92.2%"},600,function(){/*	var scrollbar5 = $scrollbar5.data("plugin_tinyscrollbar");
					 if(!scrollbar5){

					 }else{
					 scrollbar5.update("relative");
					 } */});jQuery('#contentsection').css({'border-left-width':'1px'});//Toggle Arrow
}else{if(childLen>2){jQuery("div.silverheader").eq(getVisibleMenuId()+2).trigger("click");}else{jQuery("div.silverheader").eq(1).trigger("click");}jQuery("#menusmall").hide();jQuery("#menularge").show();//jQuery('#leftnavsec').show(800);
jQuery('#leftnavsec').toggle('slide',{direction:'left'},650,function(){});jQuery("#contentsection").animate({width:"66%"},700,function(){});jQuery('#leftnavsec').addClass("leftnavshow");jQuery('#leftnavsec').removeClass("leftnavhide");//jQuery('#contentsection').css('width', '');
jQuery('#contentsection').addClass("halfcontent");jQuery('#contentsection').css({'border-left-width':'1px'});/*	var scrollbar5 = $scrollbar5.data("plugin_tinyscrollbar");
				if(!scrollbar5){

				}else{
				 scrollbar5.update("relative");
				} *///Toggle Arrow
jQuery('#leftmenuarrow').addClass("openarrow");jQuery('#leftmenuarrow').removeClass("closearrow");}}});};var getVisibleMenuId=function getVisibleMenuId(){var triggerChild=0;jQuery("div.silverheader").map(function(key,obj){if($(obj).next().is(':visible')){triggerChild=key;}});return triggerChild;};var headerLoad=function headerLoad(){$(".landing-page header").sticky({topSpacing:0});$('#mobNav').mmenu();jQuery('.others').click(function(){jQuery(".details").slideToggle(600);});$('body').on('click',function(evt){if(evt.target.tagName!=='LI'&&evt.target.tagName!=='IMG'){jQuery(".details").slideUp(600);}});};var contentResizeLoad=function contentResizeLoad(){fnRefreshDDAccordion();var height=jQuery(window).height();fnscrollContent(height);};var isAccordionInit=function isAccordionInit(){return!jQuery.isEmptyObject(window.ddaccordion.headergroup);};var ddaccordionInIt=function ddaccordionInIt(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";window.ddaccordion.init({headerclass:"silverheader",//Shared CSS class name of headers group
contentclass:"submenu",//Shared CSS class name of contents group
revealtype:"click",//Reveal content when user clicks or onmouseover the header? Valid value: "click", "clickgo", or "mouseover"
mouseoverdelay:200,//if revealtype="mouseover", set delay in milliseconds before header expands onMouseover
collapseprev:true,//Collapse previous content (so only one open at any time)? true/false
defaultexpanded:[0],//index of content(s) open by default [index1, index2, etc] [] denotes no content
onemustopen:true,//Specify whether at least one header should be open always (so never all headers closed)
animatedefault:false,//Should contents open by default be animated into view?
persiststate:true,//persist state of opened contents within browser session?
toggleclass:["","selected"],//Two CSS classes to be applied to the header when it's collapsed and expanded, respectively ["class1", "class2"]
togglehtml:["","",""],//Additional HTML added to the header when it's collapsed and expanded, respectively  ["position", "html1", "html2"] (see docs)
animatespeed:"normal",//speed of animation: integer in milliseconds (ie: 200), or keywords "fast", "normal", or "slow"
oninit:function oninit(headers,expandedindices){//custom code to run when headers have initalized
if(type=='big'){var triggerChild=jQuery("div.silverheader").length>2?2:1;jQuery("div.silverheader").eq(triggerChild).trigger("click");if(jQuery('#lr3_scroll_dlr').length>0){jQuery('#lr3_scroll_dlr').tinyscrollbar();}if(jQuery("#lr2_scroll_guided").length>0){jQuery("#lr2_scroll_guided").tinyscrollbar();}}else{}//jQuery("div.silverheader").eq(0).trigger( "click" );
//jQuery('#lr-wise-big').show();
//jQuery("div.silverheader").eq(2).trigger( "click" );
//jQuery("div.silverheader").eq(1).
//do nothing
//jQuery('#lr-wise-big').show();
//jQuery('#lr-wise-small').show();
//jQuery('#module-wise-small').hide();
//jQuery('#module-wise-big').hide();
jQuery('.lr-small').click(function(){if(jQuery('#lr-wise-small').is(':visible')){}else{//jQuery('#module-wise-small').hide();
//jQuery('#module-wise-big').hide();
//jQuery('#lr-wise-big').show();
}});jQuery('.module-small').click(function(){if(jQuery('#module-wise-small').is(':visible')){}else{//jQuery('#lr-wise-small').hide();
//jQuery('#lr-wise-big').hide();
//jQuery('#module-wise-big').show();
}});jQuery('.lr-big').click(function(){if(jQuery('#lr-wise-big').is(':visible')){}else{//jQuery('#module-wise-big').hide();
//jQuery('#module-wise-small').hide();
//jQuery('#lr-wise-small').show();
}});jQuery('.module-big').click(function(){if(jQuery('#module-wise-big').is(':visible')){// jQuery('#module-wise-big').show();
}else{//showing modulewise big here
//jQuery("div.silverheader").eq(1).trigger( "click" );
/* jQuery("div.silverheader").eq(0).removeClass('selected');
					jQuery("div.silverheader").eq(1).addClass('selected');
					// jQuery('#lr-wise-big').hide();
					jQuery('#lr-wise-small').hide();
					jQuery('#module-wise-small').show(); */}});},onopenclose:function onopenclose(header,index,state,isuseractivated){//custom code to run whenever a header is opened or closed
//do nothing
//closechecknot(index,state);
}});jQuery('.accordion-item-1 .accordion-content').show();jQuery("#module-wise ul li").click(function(){if(jQuery(this).first().hasClass("active-accordion")){jQuery(this).first().removeClass("active-accordion");}else{jQuery('#module-wise ul li').each(function(){jQuery(this).first().removeClass("active-accordion");});jQuery(this).first().addClass("active-accordion");}if(jQuery('#semana-scroll-left1').length>0){var $scrollbar=jQuery('#semana-scroll-left1');$scrollbar.tinyscrollbar();var scrollbarData=$scrollbar.data("plugin_tinyscrollbar");scrollbarData.update();}if(jQuery('#lr3_scroll_dlr').length>0){var $scrollbar=jQuery('#lr3_scroll_dlr');$scrollbar.tinyscrollbar();var scrollbarData=$scrollbar.data("plugin_tinyscrollbar");scrollbarData.update();}});};var showLargeLeftMenu=function showLargeLeftMenu(){var childLen=jQuery("div.silverheader").length;if(childLen>2){jQuery("div.silverheader").eq(getVisibleMenuId()+2).trigger("click");}else{jQuery("div.silverheader").eq(1).trigger("click");}jQuery('#leftnavsec').show();jQuery('#leftmenuarrow').addClass("openarrow");jQuery('#leftmenuarrow').removeClass("closearrow");jQuery("#menularge").show();jQuery("#menusmall").hide();};var showSmallLeftMenu=function showSmallLeftMenu(){var childLen=jQuery("div.silverheader").length;if(childLen>2){var count=getVisibleMenuId()-2;if(count>=0){jQuery("div.silverheader").eq(count).trigger("click");}}else{jQuery("div.silverheader").eq(0).trigger("click");}jQuery('#leftnavsec').hide();jQuery("#menularge").hide();jQuery("#menusmall").show();jQuery('#leftnavsec').addClass("leftnavhide");jQuery('#leftnavsec').removeClass("leftnavshow");jQuery('#contentsection').removeClass("halfcontent");jQuery("#contentsection").animate({width:"92.2%"},600,function(){/*	var scrollbar5 = $scrollbar5.data("plugin_tinyscrollbar");
		 if(!scrollbar5){

		 }else{
		 scrollbar5.update("relative");
		 } */jQuery('#contentsection').css({'border-left-width':'1px'});//jQuery("div.silverheader").eq(0).trigger( "click" );
// jQuery('#module-wise-small').hide();
// jQuery('#module-wise-big').hide();
// jQuery('#module-wise-small').hide();
});};var downTabClose=function downTabClose(){jQuery('.tab-close').click();};var leftClose=function leftClose(){$('#qlinks aside').each(function(){$(this).removeClass('opened');});};var scrollToTop=function scrollToTop(){$('html, body').animate({scrollTop:0},300);};var hideleftbar=function hideleftbar(){var width=jQuery(window).width();if(width<768){if(jQuery('#leftmenuarrow').hasClass('openarrow')){$('#leftmenuarrow').click();}}};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return domainUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rootDomainUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rootChatUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rootEcoachChatUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onLineUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return app_name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appImgAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return routeAfterLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sessExpire; });
// export const domainUrl="http://90.0.1.48/361/api/";
// export const rootDomainUrl="http://90.0.1.48/demo361/";
// export const rootChatUrl="http://90.0.1.48/361/mchat/";
// export const rootEcoachChatUrl="http://90.0.1.48/361/chat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361_dev";
// export const domainUrl="http://90.0.1.45/361/api/";
// export const rootDomainUrl="http://90.0.0.51/imetaproject/";
// export const rootChatUrl="http://90.0.1.45/361/mchat/";
// export const rootEcoachChatUrl="http://90.0.1.45/361/chat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361_dev";
//  export const domainUrl="https://www.361dm.com/api/";
//  export const rootDomainUrl="http://90.0.0.51/imetaproject/";
//  export const rootChatUrl="http://localhost/361/mchat/";
//  export const rootEcoachChatUrl="http://localhost/361/chat/";
//  export const onLineUrl="https://www.361online.com/";
//  export const app_name="_361_dev";
// export const domainUrl="http://90.0.0.51/imetaproject/imeta_qa/api/";
// export const rootDomainUrl="http://361dm.com/";
// export const rootChatUrl="http://90.0.0.51/imetaproject/mchat/";
// export const rootEcoachChatUrl="http://90.0.0.51/imetaproject/chat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361_test";
var domainUrl="https://www.361dm.com/api/";var rootDomainUrl="https://www.361dm.com/";var rootChatUrl="https://www.361dm.com/rmchat/";var rootEcoachChatUrl="https://www.361dm.com/rchat/";var onLineUrl="https://www.361online.com/";var app_name="_361dm_live";// export const domainUrl="http://beta.361dm.com/api/";
// export const rootDomainUrl="http://beta.361dm.com/";
// export const rootChatUrl="http://beta.361dm.com/rmchat/";
// export const rootEcoachChatUrl="http://beta.361dm.com/rchat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361dm_qa";
var appFullName="361 Minds dm";var appImgAlt="361°minds™";var routeAfterLogin="learningroom";var sessExpire=28800;// eight hours

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(367)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Username; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasGlobalRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGlobalRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isLoggedIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_Common__ = __webpack_require__(1);
var Username=function Username(){var sessData=Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["h" /* getTokenData */])());return sessData.fullName||false;};var UserId=function UserId(){var sessData=Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["h" /* getTokenData */])());return sessData.id||false;};var hasGlobalRoute=function hasGlobalRoute(){var sessData=Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["h" /* getTokenData */])());return sessData.globalAccess||false;};var getGlobalRoute=function getGlobalRoute(){var userData=Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["h" /* getTokenData */])());var beforeRoutes=userData.beforeRoutes||[];var afterRoutes=userData.afterRoutes||[];if(beforeRoutes.length>0){return beforeRoutes[0].url;}else if(afterRoutes.length>0){return afterRoutes[0].url;}else{return"/";}};var isLoggedIn=function isLoggedIn(){var sessMax=Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["i" /* getUserData */])("sessMax");if(sessMax&&sessMax<new Date().getTime()){Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["c" /* clearUserData */])();}return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_Common__["i" /* getUserData */])("isLoggedIn");};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleDoubleRadio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return validateTxtbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleTextbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleRadio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleFormErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowOnlyNumberInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return autoFocusNext; });
/* unused harmony export isValidEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isMatchesEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return validateFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return countWords; });
var $=window.$;/*export const getText = (name) => {
    return $('input[name="' + name + '"]').val();
}
export const setText = (name, val) => {
    $('input[name="' + name + '"]').val(val);
}
export const setLabelText = (name, val) => {
    $('#label_' + name).html(val);
}
export const setFile = (name, val) => {
    if ($('input[name="' + name + '"]').parent().find('.link').length == 0) {
        $('<br/><a class="link" target="_blank" style="color:black;text-decoration: underline;" href="' + val.link + '">' + val.name + '</a>').insertAfter('input[name="' + name + '"]');
    }
}
export const setFile_link = (id, val) => {
    if ($('#' + id).parent().find('.link').length == 0) {
        $('<br/><a class="link" target="_blank" style="color:black;text-decoration: underline;" href="' + val.link + '">' + val.name + '</a>').insertAfter('#' + id);
    }
}
export const setHiddenText = (name, val) => {
    $('input:hidden[name="' + name + '"]').val(val);
}
export const setImage = (name, val) => {
    $('img#file_' + name).attr('src', val.link);
}
export const setLinkImage = (name, val) => {
    var extension = val.split('.').pop();
    if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'gif') {
        $('img#file_' + name).attr('src', val).remove();
        if ($('img#file_' + name).length == 0) {
            $('<a class="link" target="_blank" href="' + val + '"><img id="file_' + name + '" width="150" style="margin-top: 15px;" src="' + val + '"/></a>').insertAfter('input[name="file_' + name + '"]');
        }
    } else {
        $('img#file_' + name).attr('src', val).remove();
        if ($('input[name="file_' + name + '"]').parent().find('.imagelink').length == 0) {
            $('<a class="imagelink" target="_blank" style="color:black;text-decoration: underline;" href="' + val + '">' + val + '</a>').insertAfter('input[name="file_' + name + '"]');
        }
    }
}
export const setDImage = (name, val) => {
    $('img#file_' + name).attr('src', val);
}
export const setSelect = (name, val) => {
    $('select[name="' + name + '"]').val(val);
}
export const getSelect = (name) => {
    return $('select[name="' + name + '"]').val();
}
export const setMultiSelect = (name, val) => {
    $('select[name="' + name + '"]').val(val);
    $('select[name="' + name + '"]').multiselect("refresh");
}
export const setTextArea = (name, val) => {
    $('textarea[name="' + name + '"]').val(val);
}
export const getTextArea = (name) => {
    return $('textarea[name="' + name + '"]').val();
}
export const getDateText = (name) => {
    return $('input[name="' + name + '"]').val();
}
export const setDateText = (name, val) => {
    $('input[name="' + name + '"]').val(val);
}
export const setKeywords = (name, val) => {
    var values = [];
    if (val.length > 0) {
        val.map((key, index) => {
            values.push(key.name);
        });
        $('textarea[name="' + name + '"]').val(values.toString());
    }
}*/var handleDoubleRadio=function handleDoubleRadio(event){var inputVal=[];var leastval='';var mostval='';$('input[name="'+event.target.getAttribute("data-id")+'_least"]').attr('disabled',false);$('input[name="'+event.target.getAttribute("data-id")+'_most"]').attr('disabled',false);var i=1;$('input[name="'+event.target.getAttribute("data-id")+'_most"]').each(function(){if($(this).prop("checked")==true){inputVal.push('m'+i);mostval=$(this).val();}i++;});i=1;$('input[name="'+event.target.getAttribute("data-id")+'_least"]').each(function(){if($(this).prop("checked")==true){inputVal.push('l'+i);leastval=$(this).val();}if(mostval==$(this).val()){$(this).attr('disabled',true);}i++;});$('input[name="'+event.target.getAttribute("data-id")+'_hidden"]').val(inputVal.join("-"));};var validateTxtbox=function validateTxtbox(event){var charCode=event.which?event.which:event.keyCode;if($.inArray(charCode,[49,50,51,52,53,54,55])>=0){}else{event.preventDefault();}};var handleTextbox=function handleTextbox(event){var txtval=$('input[name="'+event.target.name+'_hidden"]').val();var curval=event.target.value;if(txtval){var txtarr=txtval.split('-');if($.inArray(curval,txtarr)>=0){event.target.value='';}}var inputVal=[];$('input[name="'+event.target.name+'"]').each(function(){if($(this).val()!==""){inputVal.push($(this).val());}});$('input[name="'+event.target.name+'_hidden"]').val(inputVal.join("-"));};var handleCheckbox=function handleCheckbox(event){var checkedInputs=$('input[name="'+event.target.name+'"]:checked'),targetTag=$('input[name="'+event.target.name+'_hidden"]'),inputVal=[];if(targetTag.attr("data-max-option")){var maxOption=parseInt(targetTag.attr("data-max-option"));if(maxOption!==0&&checkedInputs.length>maxOption){event.preventDefault();alert("You can't select more than "+maxOption+" options.");return false;}}checkedInputs.each(function(){inputVal.push($(this).val());});targetTag.val(inputVal.join(","));};var handleRadio=function handleRadio(event){$('input[name="'+event.target.name+'_hidden"]').val(event.target.value);};var handleSequence=function handleSequence(event){var inputVal=[];$('input[name="'+event.target.name+'"]').each(function(){if($(this).val()!==""){inputVal.push($(this).val());}});$('input[name="'+event.target.name+'_hidden"]').val(inputVal.join("-"));};var handleFormErrors=function handleFormErrors(formErrors){$("div.error_reg").remove();$.each(formErrors,function(key,val){if($('[name="'+key+'"]')){$('[name="'+key+'"]').after('<div class="error_reg"><font color="#cc0000">'+val+'</font></div>');}});};var allowOnlyNumberInput=function allowOnlyNumberInput(event){var charCode=event.which?event.which:event.keyCode;if(charCode>31&&(charCode<48||charCode>57)){event.preventDefault();}};var autoFocusNext=function autoFocusNext(event,parentEle){$(event.target).closest(parentEle).next().find('.auto-focus').focus();};var isValidEmail=function isValidEmail(str){var pattern=/^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;return pattern.test(str);};var isMatchesEmail=function isMatchesEmail(str){var pattern=/^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,9}\b$/i;return pattern.test(str);};var getFormValues=function getFormValues(jsonList){jsonList.questions.map(function(qVal,qKey){var inputValue="";if($.inArray(qVal.questionType,["textbox","textarea","combo"])>=0){inputValue=$("#"+qVal.questionId).val();}else if($.inArray(qVal.questionType,["radio","checkbox"])>=0){inputValue=$('input[name="'+qVal.questionId+'_hidden"]').val();}jsonList.questions[qKey].questionAnswer=inputValue;});return jsonList;};var validateFile=function validateFile(e){$("p.error").remove();var files=e.target.files,isValidated=true;if(!files||files===undefined){isValidated=false;$(e.target).after('<p class="error">Please upgrade your browser to upload file(s)');}else{// Get the allowed file types
var allowedTypes=$(e.target).attr("data-valid-types")!==undefined?$(e.target).attr("data-valid-types").split(","):[];// Get the individual file max size
var eachMaxSize=$(e.target).attr("data-each-max-limit")!==undefined?$(e.target).attr("data-each-max-limit"):0;// Get the all file max size
var allMaxSize=$(e.target).attr("data-max-limit")!==undefined?$(e.target).attr("data-max-limit"):0;var invalidType=0,eachMaxSizeExceeded=0,totalSize=0;for(var i=0;i<files.length;i++){totalSize+=files[i].size;if(eachMaxSize>0&&eachMaxSize<files[i].size){eachMaxSizeExceeded++;}var fSegments=files[i].name.split("."),ext=fSegments[fSegments.length-1].toLowerCase();if(allowedTypes.length>0&&$.inArray(ext,allowedTypes)<0){invalidType++;}}if(eachMaxSizeExceeded>0){isValidated=false;$(e.target).after('<p class="error">Please check the maximum file size limit.');}else if(invalidType>0){isValidated=false;$(e.target).after('<p class="error">Please choose valid file type.');}else if(allMaxSize>0&&allMaxSize<totalSize){isValidated=false;$(e.target).after('<p class="error">Please check the maximum file size limit.');}}if(isValidated===false){$(e.target).val("");}return isValidated;};var countWords=function countWords(event){//alert();
var inputTag=$(event.target),inputValue=$.trim(inputTag.val()),wordSegments=inputValue.split(/\s+/),wordCount=inputValue!==""?wordSegments.length:0,noOfWord=parseInt(inputTag.attr("data-total-words"));// Remove the word exceed notify message
$(".word-limit-note").remove();$('.balance-words, .typing-words').show();if(wordCount<=noOfWord){var balWordsTag=inputTag.parent().find(".balance-words"),wordCountTag=inputTag.parent().find(".typing-words"),actualWordLen=noOfWord-wordCount;if(balWordsTag&&wordCountTag){balWordsTag.html("Remaining Words: "+actualWordLen);wordCountTag.html("Words Count: "+wordCount);}}if(wordCount>noOfWord){$('<p class="error word-limit-note">You have exceeded the maximum word limit. Please rephrase the contents to fit within the word limit specified.</p>').insertAfter(inputTag);var tempWords="";for(var i=0;i<noOfWord;i++){tempWords=tempWords+wordSegments[i]+" ";}tempWords=tempWords.replace(/(^\s*)|(\s*$)/gi,"");tempWords=tempWords.replace(/[ ]{2,}/gi," ");tempWords=tempWords.replace(/\n /,"\n");inputTag.val(tempWords);}};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(204);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["default"]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(361);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var win=window;var $=window.$;var Flowplayer=function(_React$Component){_inherits(Flowplayer,_React$Component);function Flowplayer(props){_classCallCheck(this,Flowplayer);var _this=_possibleConstructorReturn(this,(Flowplayer.__proto__||Object.getPrototypeOf(Flowplayer)).call(this,props));_this.state={randomid:new Date().getTime(),videosrtime:''};return _this;}_createClass(Flowplayer,[{key:'addvideocomponentcount',value:function addvideocomponentcount(){/** video component count adding while play button click */var vcdata=this.props.vcdata;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'videocomponent/addvideocount',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({vcdata:vcdata})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.islogout==1){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Note!',"Your account expired",'info');__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */]();window.location.href=window.location+"/#/login";}});}},{key:'componentDidMount',value:function componentDidMount(){// console.log(this.props);
var vcdata=this.props.vcdata;var corporate_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var self=this;var count=0;var againstart=0;var flowPlayer=win.flowplayer($("#fphlsjs_"+this.state.randomid),this.props.playlist);//custom code
$("#fphlsjs_"+this.state.randomid).find(".fp-engine").attr('preload','metadata');// .on('load', function(){
// 	/** video component count adding while play button click */
// 	if(vcdata!=undefined && vcdata.compo_type=='videocomponent'){
// 		self.addvideocomponentcount();
// 	}
// })
flowPlayer.on("progress.seek",function(e,api){//console.log(e);
//player time-each 10 sec call function
// console.log(api);
if(Math.round(api.video.time*Math.pow(10,0))/Math.pow(10,0)%10==0&&count<Math.round(api.video.time*Math.pow(10,0))/Math.pow(10,0)){count=Math.round(api.video.time*Math.pow(10,0))/Math.pow(10,0);//self.tracker(api.video,'progress');   temporary comment by sampath 23-10-2019
self.setState({videosrtime:api.video});}}).on("ready",function(e,api){var thumbheight=Math.round($(root).height()/8);$(".fp-player:first",root).append($("<canvas/>").attr({height:thumbheight,width:Math.round(thumbheight*api.video.width/api.video.height)}));againstart=1;// first play
//self.tracker(api.video,'ready');
//console.log(" in ready")
// $("a[href$='player']").css("display", "none");
if(corporate_id==87){$("a[href$='player']").html('<marquee direction="down" behavior="alternate" style="border:solid"> <marquee behavior="alternate">  Downloading this video illegal </marquee> </marquee>');}$("a[href$='player']").css("background-image","none");$("a[href$='player']").css("width","400px");$("a[href$='player']").css("pointer-events","none");//$("a[href$='player']").attr("href", "");
}).on("pause",function(e,api){self.tracker(api.video,'pause');//console.log(" in pause")
//video end    
if(corporate_id==87){$("a[href$='player']").html('<marquee direction="down" behavior="alternate" style="border:solid"> <marquee behavior="alternate">  Downloading this video illegal </marquee> </marquee>');}$("a[href$='player']").css("background-image","none");$("a[href$='player']").css("width","400px");$("a[href$='player']").css("pointer-events","none");//$("a[href$='player']").attr("href", "");
}).on("resume",function(e,api){//alert(againstart);
if(corporate_id==87){$("a[href$='player']").html('<marquee direction="down" behavior="alternate" style="border:solid"> <marquee behavior="alternate">  Downloading this video illegal </marquee> </marquee>');}$("a[href$='player']").css("background-image","none");$("a[href$='player']").css("width","400px");$("a[href$='player']").css("pointer-events","none");//$("a[href$='player']").attr("href", "");
if(againstart==1){againstart=0;self.tracker(api.video,'ready');if(vcdata!=undefined&&vcdata.compo_type=='videocomponent'){self.addvideocomponentcount();}}else{self.tracker(api.video,'resume');}// console.log(" in resume")
//video end    
}).on("finish",function(e,api){count=0;againstart=1;//console.log(" in end")
self.tracker(api.video,'end');});}},{key:'tracker',value:function tracker(details,state){if(this.props.trackData!=undefined){var trackData=this.props.trackData;// console.log(trackData);
trackData['geo_location']=localStorage.getItem("geo_location"+__WEBPACK_IMPORTED_MODULE_1__config_Config__["c" /* app_name */])!=undefined?localStorage.getItem("geo_location"+__WEBPACK_IMPORTED_MODULE_1__config_Config__["c" /* app_name */]):"";trackData['product_id']=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);trackData['corporate_id']=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);trackData['total_duration']=details.duration;trackData['watched_time']=details.time;trackData['url']=details.url;trackData['media_type']=details.type;trackData['status']=state;// fetch(Config.domainUrl + 'learner-video-track-logs/video-track', {
// 	method: 'POST',
// 	headers: {
// 		'Accept': 'application/json',
// 		'Content-Type': 'application/json'
// 	},
// 	body: JSON.stringify({ trackData })
// }).then((response) => response.json()).then((responseJson) => {
// 	// console.log(responseJson);
// });    temporary comment on 22-05-2020 told by subbu
}}},{key:'componentWillUnmount',value:function componentWillUnmount(){// alert('tt');
//let videotime=localStorage.getItem('videosrtime');
var videotime=this.state.videosrtime;this.tracker(videotime,'progress');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var randkey=this.state.randomid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'fphlsjs_'+randkey});}}]);return Flowplayer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Flowplayer);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONST_VAR = {
  SORT_DESC: 'desc',
  SORT_ASC: 'asc',
  AWAIT_BEFORE_CELL_EDIT: 1,
  SIZE_PER_PAGE: 10,
  NEXT_PAGE: '>',
  NEXT_PAGE_TITLE: 'next page',
  LAST_PAGE: '>>',
  LAST_PAGE_TITLE: 'last page',
  PRE_PAGE: '<',
  PRE_PAGE_TITLE: 'previous page',
  FIRST_PAGE: '<<',
  FIRST_PAGE_TITLE: 'first page',
  PAGE_START_INDEX: 1,
  ROW_SELECT_BG_COLOR: '',
  ROW_SELECT_NONE: 'none',
  ROW_SELECT_SINGLE: 'radio',
  ROW_SELECT_MULTI: 'checkbox',
  CELL_EDIT_NONE: 'none',
  CELL_EDIT_CLICK: 'click',
  CELL_EDIT_DBCLICK: 'dbclick',
  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
  PAGINATION_SIZE: 5,
  PAGINATION_POS_TOP: 'top',
  PAGINATION_POS_BOTTOM: 'bottom',
  PAGINATION_POS_BOTH: 'both',
  TOOLBAR_POS_TOP: 'top',
  TOOLBAR_POS_BOTTOM: 'bottom',
  TOOLBAR_POS_BOTH: 'both',
  NO_DATA_TEXT: 'There is no data to display',
  SHOW_ONLY_SELECT: 'Show Selected Only',
  SHOW_ALL: 'Show All',
  EXPORT_CSV_TEXT: 'Export to CSV',
  INSERT_BTN_TEXT: 'New',
  DELETE_BTN_TEXT: 'Delete',
  SAVE_BTN_TEXT: 'Save',
  CLOSE_BTN_TEXT: 'Close',
  FILTER_DELAY: 500,
  SCROLL_TOP: 'Top',
  SCROLL_BOTTOM: 'Bottom',
  FILTER_TYPE: {
    TEXT: 'TextFilter',
    REGEX: 'RegexFilter',
    SELECT: 'SelectFilter',
    NUMBER: 'NumberFilter',
    DATE: 'DateFilter',
    CUSTOM: 'CustomFilter',
    ARRAY: 'ArrayFilter'
  },
  FILTER_COND_EQ: 'eq',
  FILTER_COND_LIKE: 'like',
  EXPAND_BY_ROW: 'row',
  EXPAND_BY_COL: 'column',
  REMOTE_SORT: 'sort',
  REMOTE_PAGE: 'pagination',
  REMOTE_CELL_EDIT: 'cellEdit',
  REMOTE_INSERT_ROW: 'insertRow',
  REMOTE_DROP_ROW: 'dropRow',
  REMOTE_FILTER: 'filter',
  REMOTE_SEARCH: 'search',
  REMOTE_EXPORT_CSV: 'exportCSV',
  INSERT_FAIL_INDICATOR: 'Validation errors, please check!',
  DEFAULT_CSV_SEPARATOR: ',',
  CSV_STRING_TYPE: 'string',
  CSV_NUMBER_TYPE: 'number',
  AUTO_COLLAPSE_WHEN_SORT: false,
  AUTO_COLLAPSE_WHEN_SEARCH: false,
  AUTO_COLLAPSE_WHEN_FILTER: false
};

CONST_VAR.REMOTE = {};
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SORT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_PAGE] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_CELL_EDIT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_INSERT_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_DROP_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_FILTER] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SEARCH] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_EXPORT_CSV] = false;

var _default = CONST_VAR;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CONST_VAR, 'CONST_VAR', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');
}();

;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export showValidationError */
/* unused harmony export hideValidationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return runValidation; });
var $=window.$;var showValidationError=function showValidationError(obj,msg){var errLength=$(obj).parent().find(".error_reg").length;if(errLength===0){$(obj).parent().append('<div class="error_reg"><font color="#cc0000">'+msg+'</font></div>');//$(obj).css("border-color", "red");
}if(errLength===1){$(obj).parent().find(".error_reg font").html(msg);}};var hideValidationError=function hideValidationError(obj){$(obj).parent().find(".error_reg").remove();//$(obj).css("border-color", "");
};var runValidation=function runValidation(){var sectionClass=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var flag=true,blockClass="";if(sectionClass!==""){blockClass='.'+sectionClass;}$(blockClass+'.required:visible, input[type="hidden"]'+blockClass+'.required').each(function(i,obj){// let select_val = $(this).val();
// if ((select_val.indexOf('m') > -1) || (select_val.indexOf('l') > -1)) { 
//     if (select_val.indexOf('-') > -1) {
//         hideValidationError(obj);
//     } else {
//         let errMsg = $(this).attr("data-error-required") || "Please answer.";
//         showValidationError(obj, errMsg);
//         flag = false;
//     }
// } else {
//     var count = select_val.split("-").length;
//     var count1 = count-1;
//     if(count1 < 6) {
//         let errMsg = $(this).attr("data-error-required") || " Please answer.";
//         showValidationError(obj, errMsg);
//         flag = false;
//     } else {
//         hideValidationError(obj);
//     }
// }
if($(this).parent().is(':visible')&&($.trim($(this).val())==""||$(this).val()=="Select"||$(this).val().indexOf("Select")>=0)){var select_val=$(this).val();if(select_val==""){var errMsg=$(this).attr("data-error-required")||"Please answer.";showValidationError(obj,errMsg);flag=false;}// let errMsg = $(this).attr("data-error-required") || "Please answer.";
// showValidationError(obj, errMsg);
// flag = false;
}else{hideValidationError(obj);}});$('textarea'+blockClass+', input'+blockClass).each(function(i,obj){/* The rules must has input value goes here */if($(this).val()!=undefined&&$.trim($(this).val())!=""){if($(this).hasClass('alpha')){if(!$(this).val().match(/^[A-Za-z ]+$/)){showValidationError(obj,"* This field may contain only alphabets.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('digit')){if(!$(this).val().match(/^[0-9]+$/)){showValidationError(obj,"* Enter valid positive number.");flag=false;}else if($(this).attr("data-minvalue")&&$(this).attr("data-maxvalue")&&!(parseInt($(this).val())>=parseInt($(this).attr("data-minvalue"))&&parseInt($(this).val())<=parseInt($(this).attr("data-maxvalue")))){showValidationError(obj,"* The number must be between "+$(this).attr("data-minvalue")+" to "+$(this).attr("data-maxvalue"));flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('numeric')){if(isNaN($(this).val())){showValidationError(obj,"* Enter numeric value.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('alphanumeric')){if(!$(this).val().match(/^[A-Za-z0-9]+$/)){showValidationError(obj,"* Enter alphanumeric value.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('alphanumericspace')){if(!$(this).val().match(/^[ .?A-Za-z0-9]+$/)){showValidationError(obj,"* Enter alphanumeric value.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('onlyalphanumeric')){if(!$(this).val().match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/)){showValidationError(obj,"* Entered value must contain alphanumeric.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('email')){var regEx=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;if(!regEx.test($(this).val())){showValidationError(obj,"* Enter valid email address.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('minlength')){if($(this).val().length<$(this).attr("minlength")){showValidationError(obj,"* Minimum "+$(this).attr("minlength")+" characters required.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('maxlength')){if($(this).val().length>$(this).attr("maxlength")){showValidationError(obj,"* Maximum "+$(this).attr("maxlength")+" characters only allowed.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('pincode')){if(!$(this).val().match(/^[0-9]+$/)||$(this).val().length<=5||$(this).val().length>6){showValidationError(obj,"* Only number with 5-6 digits are allowed.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('age')){if(!$(this).val().match(/^[0-9]+$/)||$(this).val()<1||$(this).val()>120){showValidationError(obj,"* Age must be number and between 1-120.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('sequence')){var tempArr=[],seqSegments=$(this).val().split("-"),maxSeqNum=parseInt($(this).attr("data-max-seq"));for(var _i=0;_i<seqSegments.length;_i++){if(seqSegments[_i].match(/^[0-9]+$/)&&$.inArray(seqSegments[_i],tempArr)<0){tempArr.push(seqSegments[_i]);}}if(tempArr.length!==maxSeqNum||Math.min.apply(Math,tempArr)<=0||Math.max.apply(Math,tempArr)>maxSeqNum){showValidationError(obj,"* The sequence order must be with-in 1-"+maxSeqNum+".");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('with-in-options')){var options=$(this).attr("data-options").split(",");if($.inArray($.trim($(this).val()),options)<0){showValidationError(obj,"* The entered value must be with-in above options.");flag=false;}else{hideValidationError(obj);}}if($(this).hasClass('word-count-check')){var maxWords=parseInt($(this).attr("data-total-words")),totWords=$.trim($(this).val()).split(/\s+/);if(totWords.length>maxWords){showValidationError(obj,"* You have exceeded the maximum word limit. Please rephrase the contents to fit within the word limit specified.");flag=false;}else{hideValidationError(obj);}}}/* The rules that does not depend on user input value goes here */if($(this).hasClass('minmaxdate')){var minDate=$($(this).attr("data-mindate")).val(),maxDate=$($(this).attr("data-maxdate")).val();if(minDate!=undefined&&minDate!=""&&maxDate!=undefined&&maxDate!=""){var _minDate=new Date(_minDate),_maxDate=new Date(_maxDate);if(_minDate>_maxDate){var errMsg=$(this).attr("data-error-minmaxdate")||"End date should not be lesser than start date.";showValidationError(obj,errMsg);flag=false;}else{hideValidationError(obj);}}}if($(this).hasClass('rangedate')){var _minDate2=$($(this).attr("data-mindate")).val(),_maxDate2=$($(this).attr("data-maxdate")).val(),rangeDate=$($(this).attr("data-rangedate")).val();if(rangeDate!=undefined&&rangeDate!=""&&_minDate2!=undefined&&_minDate2!=""&&_maxDate2!=undefined&&_maxDate2!=""){var _minDate3=new Date(_minDate3),_maxDate3=new Date(_maxDate3),_rangeDate=new Date(_rangeDate);if(_rangeDate<_minDate3||_rangeDate>_maxDate3){var _errMsg=$(this).attr("data-error-rangedate")||"Date should be between minimum and maximum date.";showValidationError(obj,_errMsg);flag=false;}else{hideValidationError(obj);}}}});if(!flag){$('html, body').animate({scrollTop:$("div.error_reg:visible").parent().offset().top-200},500);}return flag;};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setLearningRoom */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLearningRoom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
function setLearningRoom(learningRoom){return{type:"SET_LEARNING_ROOM",learningRoom:learningRoom};}function getLearningRoom(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","please wait...");fetch(__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */]+'guidedpath/glearning',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_1__helpers_User__["a" /* UserId */]()})}).then(function(response){return response.json();}).then(function(responseJson){dispatch(setLearningRoom(responseJson.learningroom));//Common.reactLoader("hide");
}).catch(function(error){console.error(error);});};}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint no-fallthrough: off */


var _dateArithmetic = __webpack_require__(707);

var _dateArithmetic2 = _interopRequireDefault(_dateArithmetic);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLI = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24
};

var MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

var dates = _extends({}, _dateArithmetic2.default, {
  monthsInYear: function monthsInYear(year) {
    var date = new Date(year, 0, 1);

    return MONTHS.map(function (i) {
      return dates.month(date, i);
    });
  },
  firstVisibleDay: function firstVisibleDay(date, culture) {
    var firstOfMonth = dates.startOf(date, 'month');

    return dates.startOf(firstOfMonth, 'week', _localizer2.default.startOfWeek(culture));
  },
  lastVisibleDay: function lastVisibleDay(date, culture) {
    var endOfMonth = dates.endOf(date, 'month');

    return dates.endOf(endOfMonth, 'week', _localizer2.default.startOfWeek(culture));
  },
  visibleDays: function visibleDays(date, culture) {
    var current = dates.firstVisibleDay(date, culture),
        last = dates.lastVisibleDay(date, culture),
        days = [];

    while (dates.lte(current, last, 'day')) {
      days.push(current);
      current = dates.add(current, 1, 'day');
    }

    return days;
  },
  ceil: function ceil(date, unit) {
    var floor = dates.startOf(date, unit);

    return dates.eq(floor, date) ? floor : dates.add(floor, 1, unit);
  },
  range: function range(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';

    var current = start,
        days = [];

    while (dates.lte(current, end, unit)) {
      days.push(current);
      current = dates.add(current, 1, unit);
    }

    return days;
  },
  merge: function merge(date, time) {
    if (time == null && date == null) return null;

    if (time == null) time = new Date();
    if (date == null) date = new Date();

    date = dates.startOf(date, 'day');
    date = dates.hours(date, dates.hours(time));
    date = dates.minutes(date, dates.minutes(time));
    date = dates.seconds(date, dates.seconds(time));
    return dates.milliseconds(date, dates.milliseconds(time));
  },
  eqTime: function eqTime(dateA, dateB) {
    return dates.hours(dateA) === dates.hours(dateB) && dates.minutes(dateA) === dates.minutes(dateB) && dates.seconds(dateA) === dates.seconds(dateB);
  },
  isJustDate: function isJustDate(date) {
    return dates.hours(date) === 0 && dates.minutes(date) === 0 && dates.seconds(date) === 0 && dates.milliseconds(date) === 0;
  },
  duration: function duration(start, end, unit, firstOfWeek) {
    if (unit === 'day') unit = 'date';
    return Math.abs(dates[unit](start, undefined, firstOfWeek) - dates[unit](end, undefined, firstOfWeek));
  },
  diff: function diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB);

    // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour
    return Math.round(Math.abs(+dates.startOf(dateA, unit) / MILLI[unit] - +dates.startOf(dateB, unit) / MILLI[unit]));
  },
  total: function total(date, unit) {
    var ms = date.getTime(),
        div = 1;

    switch (unit) {
      case 'week':
        div *= 7;
      case 'day':
        div *= 24;
      case 'hours':
        div *= 60;
      case 'minutes':
        div *= 60;
      case 'seconds':
        div *= 1000;
    }

    return ms / div;
  },
  week: function week(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
  },
  today: function today() {
    return dates.startOf(new Date(), 'day');
  },
  yesterday: function yesterday() {
    return dates.add(dates.startOf(new Date(), 'day'), -1, 'day');
  },
  tomorrow: function tomorrow() {
    return dates.add(dates.startOf(new Date(), 'day'), 1, 'day');
  }
});

exports.default = dates;
module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.set = set;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var localePropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);

function _format(localizer, formatter, value, format, culture) {
  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);

  !(result == null || typeof result === 'string') ?  false ? (0, _invariant2.default)(false, '`localizer format(..)` must return a string, null, or undefined') : (0, _invariant2.default)(false) : void 0;

  return result;
}

var DateLocalizer = function DateLocalizer(spec) {
  var _this = this;

  _classCallCheck(this, DateLocalizer);

  !(typeof spec.format === 'function') ?  false ? (0, _invariant2.default)(false, 'date localizer `format(..)` must be a function') : (0, _invariant2.default)(false) : void 0;
  !(typeof spec.parse === 'function') ?  false ? (0, _invariant2.default)(false, 'date localizer `parse(..)` must be a function') : (0, _invariant2.default)(false) : void 0;
  !(typeof spec.firstOfWeek === 'function') ?  false ? (0, _invariant2.default)(false, 'date localizer `firstOfWeek(..)` must be a function') : (0, _invariant2.default)(false) : void 0;

  this.propType = spec.propType || localePropType;

  this.formats = spec.formats;
  this.startOfWeek = spec.firstOfWeek;

  this.format = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _format.apply(undefined, [_this, spec.format].concat(args));
  };

  this.parse = function (value, format, culture) {
    var result = spec.parse.call(_this, value, format, culture);

    !(result == null || result instanceof Date && !isNaN(result.getTime())) ?  false ? (0, _invariant2.default)(false, 'date localizer `parse(..)` must return a valid Date, null, or undefined') : (0, _invariant2.default)(false) : void 0;

    return result;
  };
};

var localizer = {
  parse: error,
  format: error,
  startOfWeek: error
};

function set(newLocalizer) {
  if (!newLocalizer.__isLocalizer__) {
    newLocalizer = new DateLocalizer(newLocalizer);
    newLocalizer.__isLocalizer__ = true;
  }

  localizer = newLocalizer;
  return localizer;
}

var exp = {
  parse: function parse() {
    var _localizer;

    return (_localizer = localizer).parse.apply(_localizer, arguments);
  },
  format: function format() {
    var _localizer2;

    return (_localizer2 = localizer).format.apply(_localizer2, arguments);
  },
  startOfWeek: function startOfWeek() {
    var _localizer3;

    return (_localizer3 = localizer).startOfWeek.apply(_localizer3, arguments);
  }
};

exports.default = exp;


function error() {
  throw new Error('You have not selected a localization strategy for Big Calendar. ' + 'Please use either of the two included.');
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThanksMessage=function(_Component){_inherits(ThanksMessage,_Component);function ThanksMessage(props){_classCallCheck(this,ThanksMessage);var _this=_possibleConstructorReturn(this,(ThanksMessage.__proto__||Object.getPrototypeOf(ThanksMessage)).call(this,props));_this.state={};return _this;}_createClass(ThanksMessage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg',style:{width:'100%'}},this.props.message);}}]);return ThanksMessage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ThanksMessage);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var VoiceRecorder=function(_Component){_inherits(VoiceRecorder,_Component);function VoiceRecorder(props){_classCallCheck(this,VoiceRecorder);var _this=_possibleConstructorReturn(this,(VoiceRecorder.__proto__||Object.getPrototypeOf(VoiceRecorder)).call(this,props));_this.state={recordButton:true,statusMsg:""};return _this;}_createClass(VoiceRecorder,[{key:'audioRecord',value:function audioRecord(){window.Fr.voice.record(false,function(){this.setState({recordButton:false,stopButton:true,recordProgress:true,playButton:false,completeButton:false});}.bind(this));}},{key:'audioStop',value:function audioStop(){window.Fr.voice.pause();this.setState({stopButton:false,recordButton:true,playButton:true,completeButton:true,recordProgress:false});}},{key:'audioPlay',value:function audioPlay(){var uniqueID=this.props.questionData.question_id,audioTag=$("#audio"+uniqueID);window.Fr.voice.export(function(url){audioTag.attr("src",url);audioTag[0].play();},"URL");}},{key:'audioComplete',value:function audioComplete(){var uniqueID=this.props.questionData.question_id,audioTag=$("#audio"+uniqueID),hiddenTag=$('input[name="'+uniqueID+'"]');window.Fr.voice.export(function(base64){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"upload/recorded-voice",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({"audio":base64})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{window.Fr.voice.stop();audioTag.attr("src",responseJson.path);hiddenTag.val(responseJson.name);_this2.setState({recordButton:false,playButton:false,completeButton:false,statusMsg:responseJson.message});}});}.bind(this),"base64");}},{key:'render',value:function render(){var _this3=this;var questionData=this.props.questionData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3',className:'voice-record'},this.state.recordProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/recording-icon.gif",width:'50',height:'50',alt:''}),'Recording...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.state.recordButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button recordButton',style:{borderRadius:"25px",padding:"10px 40px",marginLeft:"50px"},onClick:function onClick(){return _this3.audioRecord();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.state.stopButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button ply-btn',style:{borderRadius:"25px",padding:"10px 40px"},onClick:function onClick(){return _this3.audioStop();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-stop'}),'Stop'),this.state.playButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button ply-btn',style:{borderRadius:"25px",padding:"10px 40px"},onClick:function onClick(){return _this3.audioPlay();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),'Play'),this.state.completeButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button complete-btn',style:{borderRadius:"25px",padding:"10px 40px",marginLeft:"20px"},onClick:function onClick(){return _this3.audioComplete();}},'Submit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio'+questionData.question_id,controlsList:'nodownload',controls:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:"green"}},this.state.statusMsg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:questionData.question_id,className:'required'}))));}}]);return VoiceRecorder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VoiceRecorder);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.views = exports.dateRangeFormat = exports.dateFormat = exports.accessor = exports.eventComponent = exports.elementType = undefined;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _elementType = __webpack_require__(705);

var _elementType2 = _interopRequireDefault(_elementType);

var _all = __webpack_require__(706);

var _all2 = _interopRequireDefault(_all);

var _constants = __webpack_require__(29);

var _createChainableTypeChecker = __webpack_require__(173);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.elementType = _elementType2.default;

// export contextShape = React.PropTypes.shape({
//   formats: React.PropTypes.object.isRequired,
//   messages: React.PropTypes.object.isRequired,
//   accessors: React.PropTypes.shape({
//     titleAccessor: accessor,
//     startAccessor: accessor,
//     endAccessor: accessor,
//     allDayAccessor: accessor,
//   }).isRequired,
// }).isRequired,

var eventComponent = exports.eventComponent = _propTypes2.default.oneOfType([_elementType2.default, _propTypes2.default.shape({
  month: _elementType2.default,
  week: _elementType2.default,
  day: _elementType2.default,
  agenda: _elementType2.default
})]);

var viewNames = Object.keys(_constants.views).map(function (k) {
  return _constants.views[k];
});

var accessor = exports.accessor = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]);

var dateFormat = exports.dateFormat = (0, _createChainableTypeChecker2.default)(function () {
  return _localizer2.default.propType && _localizer2.default.propType.apply(_localizer2.default, arguments);
});

var dateRangeFormat = exports.dateRangeFormat = _propTypes2.default.func;

/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */
var views = exports.views = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.oneOf(viewNames)), (0, _all2.default)(_propTypes2.default.object, function (props, name) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var prop = props[name],
      err = void 0;

  Object.keys(prop).every(function (key) {
    var isBuiltinView = viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';

    return isBuiltinView || !(err = _elementType2.default.apply(undefined, [prop, key].concat(args)));
  });

  return err || null;
})]);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){var monthNames=monthNames;var d=new Date(),jYear=d.getFullYear();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Copyright \xA9 2017-',jYear,','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Threesixtyone Degree Minds Consulting Pvt Ltd.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'All Rights Reserved.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f-lnk'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/privacy.php',target:'_blank',rel:'noopener noreferrer'},'Privacy'),'\xA0\xA0|\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/legal.php',target:'_blank',rel:'noopener noreferrer'},'Legal')));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  renderReactSortCaret: function renderReactSortCaret(order, isBootstrap4) {
    var orderClass = void 0;
    if (isBootstrap4) {
      orderClass = (0, _classnames2.default)('fa', {
        'fa-sort-asc': order === _Const2.default.SORT_ASC,
        'fa-sort-desc': order === _Const2.default.SORT_DESC
      });
      return _react2.default.createElement('span', { className: orderClass, style: { margin: '10px 5px' } });
    } else {
      orderClass = (0, _classnames2.default)('order', {
        'dropup': order === _Const2.default.SORT_ASC
      });
      return _react2.default.createElement(
        'span',
        { className: orderClass },
        _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 5px' } })
      );
    }
  },
  isFunction: function isFunction(obj) {
    return obj && typeof obj === 'function';
  },
  getScrollBarWidth: function getScrollBarWidth() {
    var inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.getBoundingClientRect().width;
    outer.style.overflow = 'scroll';
    var w2 = inner.getBoundingClientRect().width;

    if (w1 === w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return w1 - w2;
  },
  canUseDOM: function canUseDOM() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
  },


  // We calculate an offset here in order to properly fetch the indexed data,
  // despite the page start index not always being 1
  getNormalizedPage: function getNormalizedPage(pageStartIndex, page) {
    pageStartIndex = this.getFirstPage(pageStartIndex);
    if (page === undefined) page = pageStartIndex;
    var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
    return page + offset;
  },
  getFirstPage: function getFirstPage(pageStartIndex) {
    return pageStartIndex !== undefined ? pageStartIndex : _Const2.default.PAGE_START_INDEX;
  },
  isBootstrap4: function isBootstrap4(version) {
    return version === '4';
  },
  isSelectRowDefined: function isSelectRowDefined(mode) {
    return mode === _Const2.default.ROW_SELECT_SINGLE || mode === _Const2.default.ROW_SELECT_MULTI;
  },
  renderColGroup: function renderColGroup(columns, selectRow) {
    var expandColumnOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var version = arguments[3];

    var selectRowHeader = null;
    var expandRowHeader = null;
    var isBootstrap4 = this.isBootstrap4(version);
    var isSelectRowDefined = this.isSelectRowDefined(selectRow.mode);
    var columnWidth = isBootstrap4 ? '38px' : '30px';
    if (isSelectRowDefined) {
      var style = {
        width: selectRow.columnWidth || columnWidth,
        minWidth: selectRow.columnWidth || columnWidth
      };
      if (!selectRow.hideSelectColumn) {
        selectRowHeader = _react2.default.createElement('col', { key: 'select-col', style: style });
      }
    }
    if (expandColumnOptions.expandColumnVisible) {
      var _style = {
        width: expandColumnOptions.columnWidth || columnWidth,
        minWidth: expandColumnOptions.columnWidth || columnWidth
      };
      expandRowHeader = _react2.default.createElement('col', { key: 'expand-col', style: _style });
    }
    var theader = columns.map(function (column, i) {
      var style = {
        display: column.hidden ? 'none' : null
      };
      if (column.width) {
        var width = !isNaN(column.width) ? column.width + 'px' : column.width;
        style.width = width;
        /** add min-wdth to fix user assign column width
        not eq offsetWidth in large column table **/
        style.minWidth = width;
      }
      return _react2.default.createElement('col', { style: style, key: i });
    });

    return _react2.default.createElement(
      'colgroup',
      null,
      expandColumnOptions.expandColumnVisible && expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      selectRowHeader,
      expandColumnOptions.expandColumnVisible && !expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      theader
    );
  }
}; /* eslint react/display-name: 0 */

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/util.js');
}();

;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(365);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectLearnerObserver=function(_Component){_inherits(SelectLearnerObserver,_Component);function SelectLearnerObserver(props){_classCallCheck(this,SelectLearnerObserver);var _this=_possibleConstructorReturn(this,(SelectLearnerObserver.__proto__||Object.getPrototypeOf(SelectLearnerObserver)).call(this,props));_this.state={ActiveObservers:[],checkedValues:[],pageOfItems:[],checkedmails:[]};_this.onRowSelect=_this.onRowSelect.bind(_this);_this.onSelectAll=_this.onSelectAll.bind(_this);return _this;}_createClass(SelectLearnerObserver,[{key:'onRowSelect',value:function onRowSelect(row,isSelected){// alert(isSelected);
var email=row['assessor_id'];//this.getSelectedRowKeys(email);
if(isSelected==true){//this.setState({checkedmails: this.state.checkedmails.concat([email])});
var joined=this.state.checkedmails.concat(email);this.setState({checkedmails:joined});}else if(isSelected==false){//  	this.setState({
//   data: update(this.state.data, {$splice: [[index, 1]]})
// })
var array=this.state.checkedmails;var index=array.indexOf(email);array.splice(index,1);this.setState({checkedmails:array});// var joined = this.state.checkedmails.filter(function(email) { return user.id != member.id });
// this.setState({ users: users });
//alert(this.state.checkedmails);
}}},{key:'onSelectAll',value:function onSelectAll(isSelected,currentDisplayAndSelectedData){// alert("is select all: " + isSelected);
// alert("Current display and selected data: ");
if(isSelected==true){var mails=this.state.checkedmails;for(var i=0;i<currentDisplayAndSelectedData.length;i++){//alert(currentDisplayAndSelectedData[i]['email']);
var email=currentDisplayAndSelectedData[i]['assessor_id'];//alert(email);
var mail=mails.push(email);//alert(mail);
//let mail = mail.join(',');
}this.setState({mails:mails});//alert(this.state.checkedmails);
}else if(isSelected==false){//  	this.setState({
//   data: update(this.state.data, {$splice: [[index, 1]]})
// })
var array=this.state.checkedmails;for(var _i=0;_i<currentDisplayAndSelectedData.length;_i++){//alert(currentDisplayAndSelectedData[i]['email']);
var _email=currentDisplayAndSelectedData[_i]['assessor_id'];//alert(email);
var index=array.indexOf(_email);array.splice(index,1);}this.setState({checkedmails:array});}}},{key:'getActiveObserver',value:function getActiveObserver(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("productID",true);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'personal/observers-view',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this2.setState({ActiveObservers:responseJson.actyetact[0].activeob});}});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(){if(this.state.checkedmails.length==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]('Attention','You have to select atleast one Observer','warning');}else{this.props.submitObserverandProceed(this.state.checkedmails);}}},{key:'componentDidMount',value:function componentDidMount(){this.getActiveObserver();}},{key:'render',value:function render(){var _this3=this;var selectRowProp={mode:'checkbox',clickToSelect:true,onSelect:this.onRowSelect,onSelectAll:this.onSelectAll};var options={noDataText:'You have no Active Observers.'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'observer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title_assessors'},'Observers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["BootstrapTable"],{data:this.state.ActiveObservers,containerClass:'myjourney-table',ref:'table',selectRow:selectRowProp,options:options},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{hidden:true,dataField:'assessor_id',isKey:true},'Observer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'name'},'Observer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'relationship'},'Relationship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'email'},'Email ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'contact'},'Contact No'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onClick:function onClick(e){return _this3.submitObserverandProceed();},value:'Continue',alt:'Continue',title:'Continue',className:'button_org mail-icon',type:'button',style:{float:"right"}})));}}]);return SelectLearnerObserver;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectLearnerObserver);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Imagezoom=function(_React$Component){_inherits(Imagezoom,_React$Component);function Imagezoom(props){_classCallCheck(this,Imagezoom);return _possibleConstructorReturn(this,(Imagezoom.__proto__||Object.getPrototypeOf(Imagezoom)).call(this,props));}_createClass(Imagezoom,[{key:'render',value:function render(){var datasof=this.props;var izkey=datasof.izkey?datasof.izkey:new Date().getTime();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:datasof.izsrc,'data-chittizoom':true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:datasof.izsrc,key:izkey,height:datasof.izheight,width:datasof.izwidth})));}}]);return Imagezoom;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Imagezoom);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Confidencemeter=function(_React$Component){_inherits(Confidencemeter,_React$Component);function Confidencemeter(props){_classCallCheck(this,Confidencemeter);return _possibleConstructorReturn(this,(Confidencemeter.__proto__||Object.getPrototypeOf(Confidencemeter)).call(this,props));}_createClass(Confidencemeter,[{key:'render',value:function render(){var dynamic_confidence=this.props;var confidence_result='';var coorectanswer='';/*let checked_one=false;
        let checked_two=false;
        let checked_three=false;*/var gobackanser=0;if(dynamic_confidence.goback_confanswer){gobackanser=dynamic_confidence.goback_confanswer;}if(dynamic_confidence.confidence_result){confidence_result=dynamic_confidence.confidence_result;}/*if(dynamic_confidence.correct_ans)
        {
           coorectanswer=dynamic_confidence.correct_ans;
           
           if(confidence_result===1)
           {
             checked_one=true;
             
           }
           else if(confidence_result===2)
           {
             checked_two=true;
           }
           else if(confidence_result===3)
           {
             checked_three=true;
           }
        }*/if(coorectanswer===''&&confidence_result==''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'How confident are you about this answer ?'),gobackanser==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'not_sure',id:'notsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'1',checked:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' Not sure ')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'not_sure',id:'notsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'1'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' Not sure ')),gobackanser==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'somewhat_sure',id:'somewhatsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'2',checked:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Somewhat sure ')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'somewhat_sure',id:'somewhatsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'2'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Somewhat sure ')),gobackanser==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'very_sure',id:'verysure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'3',checked:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Very sure'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'very_sure',id:'verysure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'3'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Very sure'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error_reg',style:{display:"none"},id:'errorconfident_'+dynamic_confidence.dynamic_confidence},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{color:'#cc0000'},'You should select either one from the given below options.')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'How confident are you about this answer ?'),confidence_result==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'not_sure',id:'notsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'1',disabled:'disabled',checked:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' Not sure '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/tick.gif',className:'confidence_'+dynamic_confidence.dynamic_confidence,alt:'',border:'0'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'not_sure',id:'notsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'1',disabled:'disabled'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,' Not sure ')),confidence_result==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'somewhat_sure',id:'somewhatsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'2',disabled:'disabled',checked:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Somewhat sure '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/tick.gif',className:'confidence_'+dynamic_confidence.dynamic_confidence,alt:'',border:'0'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'somewhat_sure',id:'somewhatsure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'2',disabled:'disabled'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Somewhat sure ')),confidence_result==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'very_sure',id:'verysure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'3',disabled:'disabled',checked:true}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Very sure'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/tick.gif',className:'confidence_'+dynamic_confidence.dynamic_confidence,alt:'',border:'0'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ca_releas4-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'very_sure',id:'verysure_'+dynamic_confidence.dynamic_confidence,name:'confidence_'+dynamic_confidence.dynamic_confidence,value:'3',disabled:'disabled'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Very sure'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}}]);return Confidencemeter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Confidencemeter);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(275);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var navigate = exports.navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};

var views = exports.views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssessementViewList=function(_Component){_inherits(AssessementViewList,_Component);function AssessementViewList(props){_classCallCheck(this,AssessementViewList);var _this=_possibleConstructorReturn(this,(AssessementViewList.__proto__||Object.getPrototypeOf(AssessementViewList)).call(this,props));_this.state={};return _this;}_createClass(AssessementViewList,[{key:"render",value:function render(){var data=this.props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"grey-lite"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bluetxt"},"This component will be rated/viewed by"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cwrespage"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{width:"100%",cellPadding:"0",cellSpacing:"0",id:"view",className:"myjourney-table descriptive",border:"0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Score"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Assessed on"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Remarks"))),data.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,data.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:"assesment_"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,key.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,key.score),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,key.assessed_on),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,key.remark));})))),data.length==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"abbrevation margbtm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"YTA")," - Yet to Assess"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"NA")," - Not Applicable, only for View."))));}}]);return AssessementViewList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AssessementViewList);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onChangePage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,initialPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};var defaultProps={initialPage:1};var Pagination=function(_React$Component){_inherits(Pagination,_React$Component);function Pagination(props){_classCallCheck(this,Pagination);var _this=_possibleConstructorReturn(this,(Pagination.__proto__||Object.getPrototypeOf(Pagination)).call(this,props));_this.state={pager:{}};return _this;}_createClass(Pagination,[{key:'componentWillMount',value:function componentWillMount(){// set page if items array isn't empty
if(this.props.items&&this.props.items.length){this.setPage(this.props.initialPage);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// reset page if items array has changed
if(this.props.items!==prevProps.items){this.setPage(this.props.initialPage);}}},{key:'setPage',value:function setPage(page){var items=this.props.items;var pager=this.state.pager;if(page<1||page>pager.totalPages){return;}// get new pager object for specified page
pager=this.getPager(items.length,page);// get new page of items from items array
var pageOfItems=items.slice(pager.startIndex,pager.endIndex+1);// update state
this.setState({pager:pager});// call change page function in parent component
this.props.onChangePage(pageOfItems);}},{key:'getPager',value:function getPager(totalItems,currentPage,pageSize){// default to first page
currentPage=currentPage||1;// default page size is 10
pageSize=pageSize||10;// calculate total pages
var totalPages=Math.ceil(totalItems/pageSize);var startPage,endPage;if(totalPages<=10){// less than 10 total pages so show all
startPage=1;endPage=totalPages;}else{// more than 10 total pages so calculate start and end pages
if(currentPage<=6){startPage=1;endPage=10;}else if(currentPage+4>=totalPages){startPage=totalPages-9;endPage=totalPages;}else{startPage=currentPage-5;endPage=currentPage+4;}}// calculate start and end item indexes
var startIndex=(currentPage-1)*pageSize;var endIndex=Math.min(startIndex+pageSize-1,totalItems-1);// create an array of pages to ng-repeat in the pager control
//var pages = _.range(startPage, endPage + 1);
var pages=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["s" /* range */](startPage,endPage);// return object with all pager properties required by the view
return{totalItems:totalItems,currentPage:currentPage,pageSize:pageSize,totalPages:totalPages,startPage:startPage,endPage:endPage,startIndex:startIndex,endIndex:endIndex,pages:pages};}},{key:'render',value:function render(){var _this2=this;var pager=this.state.pager;if(!pager.pages||pager.pages.length<=1){// don't display pager if there is only 1 page
return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pagination'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:pager.currentPage===1?'disabled':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.setPage(1);}},'First')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:pager.currentPage===1?'disabled':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.setPage(pager.currentPage-1);}},'Previous')),pager.pages.map(function(page,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pager_'+index,className:pager.currentPage===page?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.setPage(page);}},page));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:pager.currentPage===pager.totalPages?'disabled':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.setPage(pager.currentPage+1);}},'Next')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:pager.currentPage===pager.totalPages?'disabled':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this2.setPage(pager.totalPages);}},'Last')));}}]);return Pagination;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Pagination.propTypes=propTypes;Pagination.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(66);
var IE8_DOM_DEFINE = __webpack_require__(245);
var toPrimitive = __webpack_require__(135);
var dP = Object.defineProperty;

exports.f = __webpack_require__(42) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(67)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Inputgenerator=function(_Component){_inherits(Inputgenerator,_Component);function Inputgenerator(){_classCallCheck(this,Inputgenerator);return _possibleConstructorReturn(this,(Inputgenerator.__proto__||Object.getPrototypeOf(Inputgenerator)).apply(this,arguments));}_createClass(Inputgenerator,[{key:'getValidationAttributes',value:function getValidationAttributes(qDetails){var minLength="",maxLength="",minDate="",maxDate="",maxWords=0,qConstraints=qDetails.constraints,inputClass=qDetails.attribute.class!==undefined?qDetails.attribute.class:'dynamic-question',style=qDetails.attribute.style!==undefined?qDetails.attribute.style:{},rows=qDetails.attribute.rows!==undefined?qDetails.attribute.rows:"",cols=qDetails.attribute.cols!==undefined?qDetails.attribute.cols:"";if(qDetails.questionMandatory!==undefined&&qDetails.questionMandatory){inputClass+=" required";}if(qConstraints!==undefined&&qConstraints.charactersType!==undefined){inputClass+=qConstraints.charactersType===0?" digit":"";inputClass+=qConstraints.charactersType===1?" numeric":"";inputClass+=qConstraints.charactersType===2?" alpha":"";inputClass+=qConstraints.charactersType===3?" alphanumeric":"";}if(qConstraints!==undefined&&qConstraints.min!==undefined){inputClass+=" minlength";minLength=qConstraints.min;}if(qConstraints!==undefined&&qConstraints.max!==undefined){inputClass+=" maxlength";maxLength=qConstraints.max;}if(qConstraints!==undefined&&qConstraints.maxWords!==undefined){inputClass+=" word-count-check";maxWords=qConstraints.maxWords;}if(qConstraints!==undefined&&qConstraints.minyear!==undefined){minDate=qConstraints.minyear;}if(qConstraints!==undefined&&qConstraints.maxyear!==undefined){maxDate=qConstraints.maxyear;}return{"fieldName":qDetails.questionId,"value":qDetails.questionAnswer,"questionType":qDetails.questionType,"inputClass":inputClass,"style":style,"rows":rows,"cols":cols,"minLength":minLength,"maxLength":maxLength,"minDate":minDate,"maxDate":maxDate,"maxWords":maxWords};}},{key:'render',value:function render(){var qDetails=this.props.qDetails;var qAttributes=this.getValidationAttributes(qDetails),scoreboard="";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},qDetails.questionType==="textbox"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:qAttributes.inputClass,type:'text',name:qAttributes.fieldName,id:qAttributes.fieldName,minLength:qAttributes.minLength,maxLength:qAttributes.maxLength,style:qAttributes.style,defaultValue:qAttributes.value,onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':qAttributes.maxWords}),qAttributes.maxWords!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red'},'Max words: ',qAttributes.maxWords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'})))),qDetails.questionType==="textarea"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:qAttributes.inputClass,name:qAttributes.fieldName,id:qAttributes.fieldName,minLength:qAttributes.minLength,maxLength:qAttributes.maxLength,style:qAttributes.style,cols:qAttributes.cols,rows:qAttributes.rows,defaultValue:qAttributes.value,onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':qAttributes.maxWords}),qAttributes.maxWords!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red'},'Max words: ',qAttributes.maxWords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'})))),qDetails.questionType==="radio"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-items'},qDetails.questionChoice.map(function(choicedetails){if(choicedetails.choice!==""){if(qDetails.questionAnswer===""&&choicedetails.score!==undefined){choicedetails.score===0?scoreboard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/crossmark.gif",width:'11',height:'11',alt:'',border:'0',style:{display:'none'}}):scoreboard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/tick.gif",width:'15',height:'14',alt:'',border:'0',style:{display:'none'}});}else{choicedetails.id===qDetails.questionAnswer?choicedetails.score===0?scoreboard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/crossmark.gif",width:'11',height:'11',alt:'',border:'0',style:{display:'inline-block'}}):scoreboard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/tick.gif",width:'15',height:'14',alt:'',border:'0',style:{display:'inline-block'}}):choicedetails.score===0?scoreboard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/crossmark.gif",width:'11',height:'11',alt:'',border:'0',style:{display:'none'}}):scoreboard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/tick.gif",width:'15',height:'14',alt:'',border:'0',style:{display:'none'}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'list_'+qAttributes.fieldName+'_'+choicedetails.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:qAttributes.fieldName,type:'radio',value:choicedetails.id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["h" /* handleRadio */])(e);},defaultChecked:$.inArray(choicedetails.id,qAttributes.value)>=0,style:qAttributes.style}),' ',choicedetails.choice,'\xA0\xA0',scoreboard));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:qAttributes.inputClass,type:'hidden',name:qAttributes.fieldName+"_hidden",defaultValue:qAttributes.value.toString()}))),qDetails.questionType==="checkbox"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-items'},qDetails.questionChoice.map(function(choicedetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+qAttributes.fieldName+'_'+choicedetails.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:qAttributes.fieldName,type:'checkbox',value:choicedetails.id,onChange:function onChange(e){return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["e" /* handleCheckbox */])(e);},defaultChecked:$.inArray(choicedetails.id,qAttributes.value)>=0,style:qAttributes.style}),' ',choicedetails.choice);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:qAttributes.inputClass,type:'hidden',name:qAttributes.fieldName+"_hidden",defaultValue:qAttributes.value.toString()}))),qDetails.questionType==="combo"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:qAttributes.inputClass,name:qAttributes.fieldName,id:qAttributes.fieldName,defaultValue:qAttributes.value.toString(),style:qAttributes.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),qDetails.questionChoice.map(function(choicedetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'option_'+qAttributes.fieldName+'_'+choicedetails.id,value:choicedetails.id},choicedetails.choice);})));}}]);return Inputgenerator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Inputgenerator);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(611),
    getValue = __webpack_require__(616);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.endOfRange = endOfRange;
exports.eventSegments = eventSegments;
exports.segStyle = segStyle;
exports.eventLevels = eventLevels;
exports.inRange = inRange;
exports.segsOverlap = segsOverlap;
exports.sortEvents = sortEvents;

var _findIndex = __webpack_require__(729);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _accessors = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function endOfRange(dateRange) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';

  return {
    first: dateRange[0],
    last: _dates2.default.add(dateRange[dateRange.length - 1], 1, unit)
  };
}

function eventSegments(event, first, last, _ref, range) {
  var startAccessor = _ref.startAccessor,
      endAccessor = _ref.endAccessor;

  var slots = _dates2.default.diff(first, last, 'day');
  var start = _dates2.default.max(_dates2.default.startOf((0, _accessors.accessor)(event, startAccessor), 'day'), first);
  var end = _dates2.default.min(_dates2.default.ceil((0, _accessors.accessor)(event, endAccessor), 'day'), last);

  var padding = (0, _findIndex2.default)(range, function (x) {
    return _dates2.default.eq(x, start, 'day');
  });
  var span = _dates2.default.diff(start, end, 'day');

  span = Math.min(span, slots);
  span = Math.max(span, 1);

  return {
    event: event,
    span: span,
    left: padding + 1,
    right: Math.max(padding + span, 1)
  };
}

function segStyle(span, slots) {
  var per = span / slots * 100 + '%';
  return { WebkitFlexBasis: per, flexBasis: per, maxWidth: per // IE10/11 need max-width. flex-basis doesn't respect box-sizing
  };
}

function eventLevels(rowSegments) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

  var i = void 0,
      j = void 0,
      seg = void 0,
      levels = [],
      extra = [];

  for (i = 0; i < rowSegments.length; i++) {
    seg = rowSegments[i];

    for (j = 0; j < levels.length; j++) {
      if (!segsOverlap(seg, levels[j])) break;
    }if (j >= limit) {
      extra.push(seg);
    } else {
      ;(levels[j] || (levels[j] = [])).push(seg);
    }
  }

  for (i = 0; i < levels.length; i++) {
    levels[i].sort(function (a, b) {
      return a.left - b.left;
    }); //eslint-disable-line
  }

  return { levels: levels, extra: extra };
}

function inRange(e, start, end, _ref2) {
  var startAccessor = _ref2.startAccessor,
      endAccessor = _ref2.endAccessor;

  var eStart = _dates2.default.startOf((0, _accessors.accessor)(e, startAccessor), 'day');
  var eEnd = (0, _accessors.accessor)(e, endAccessor);

  var startsBeforeEnd = _dates2.default.lte(eStart, end, 'day');
  // when the event is zero duration we need to handle a bit differently
  var endsAfterStart = !_dates2.default.eq(eStart, eEnd, 'minutes') ? _dates2.default.gt(eEnd, start, 'minutes') : _dates2.default.gte(eEnd, start, 'minutes');

  return startsBeforeEnd && endsAfterStart;
}

function segsOverlap(seg, otherSegs) {
  return otherSegs.some(function (otherSeg) {
    return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
  });
}

function sortEvents(evtA, evtB, _ref3) {
  var startAccessor = _ref3.startAccessor,
      endAccessor = _ref3.endAccessor,
      allDayAccessor = _ref3.allDayAccessor;

  var startSort = +_dates2.default.startOf((0, _accessors.accessor)(evtA, startAccessor), 'day') - +_dates2.default.startOf((0, _accessors.accessor)(evtB, startAccessor), 'day');

  var durA = _dates2.default.diff((0, _accessors.accessor)(evtA, startAccessor), _dates2.default.ceil((0, _accessors.accessor)(evtA, endAccessor), 'day'), 'day');

  var durB = _dates2.default.diff((0, _accessors.accessor)(evtB, startAccessor), _dates2.default.ceil((0, _accessors.accessor)(evtB, endAccessor), 'day'), 'day');

  return startSort || // sort by start Day first
  Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
  !!(0, _accessors.accessor)(evtB, allDayAccessor) - !!(0, _accessors.accessor)(evtA, allDayAccessor) || // then allDay single day events
  +(0, _accessors.accessor)(evtA, startAccessor) - +(0, _accessors.accessor)(evtB, startAccessor); // then sort by start time
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(34);

var _Actions = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setNewPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = getNewPost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
function setNewPost(newPost){return{type:"SET_NEW_POST",newPost:newPost};}function getNewPost(){return function(dispatch){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var fullName=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("fullName",true);var blog=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("blog",true);var library=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("library",true);var poll=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("poll",true);var forum=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("forum",true);var corpID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);//For Temporary new post comment 10-05-2019
fetch(__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */]+'left/new-post',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,lr_product:productID,fullName:fullName,blog:blog,library:library,poll:poll,forum:forum,corpID:corpID,pinID:pinID,role:role,pinNo:pinNo})}).then(function(response){return response.json();}).then(function(responseJson){// Common.reactLoader("hide");
dispatch(setNewPost(responseJson.posts));}).catch(function(error){console.error(error);});};}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(37);
var ctx = __webpack_require__(244);
var hide = __webpack_require__(53);
var has = __webpack_require__(43);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(41);
var createDesc = __webpack_require__(86);
module.exports = __webpack_require__(42) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(249);
var defined = __webpack_require__(134);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(139)('wks');
var uid = __webpack_require__(88);
var Symbol = __webpack_require__(36).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(148);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(93);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(60),
    getRawTag = __webpack_require__(612),
    objectToString = __webpack_require__(613);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.accessor = accessor;
/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */
function accessor(data, field) {
  var value = null;

  if (typeof field === 'function') value = field(data);else if (typeof field === 'string' && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null && field in data) value = data[field];

  return value;
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setInbox */
/* harmony export (immutable) */ __webpack_exports__["a"] = getInbox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
function setInbox(inbox){return{type:"SET_INBOX",inbox:inbox};}function getInbox(){return function(dispatch){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var admin_role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);fetch(__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */]+'messages-site/get-inbox',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,admin_role:admin_role})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){dispatch(setInbox(responseJson));}}).catch(function(error){console.error(error);});};}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Pdfview=function(_React$Component){_inherits(Pdfview,_React$Component);function Pdfview(){_classCallCheck(this,Pdfview);return _possibleConstructorReturn(this,(Pdfview.__proto__||Object.getPrototypeOf(Pdfview)).apply(this,arguments));}_createClass(Pdfview,[{key:'render',value:function render(){var styled={width:'100%',padding:'15px 1.9%',minHeight:'500px'};var pdf_files='https://www.361dm.com/announcementpdf/index.html?type=pdf#'+this.props.pdfpath;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'pdf_files',className:'border-bo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'',title:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:'announcement',src:pdf_files,style:styled}));}}]);return Pdfview;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Pdfview);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_countdown_clock__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_countdown_clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_countdown_clock__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimerCountDown=function(_Component){_inherits(TimerCountDown,_Component);function TimerCountDown(props){_classCallCheck(this,TimerCountDown);var _this=_possibleConstructorReturn(this,(TimerCountDown.__proto__||Object.getPrototypeOf(TimerCountDown)).call(this,props));_this.state={};return _this;}_createClass(TimerCountDown,[{key:'onComplete',value:function onComplete(){this.props.onComplete();}},{key:'render',value:function render(){var _this2=this;var seconds=this.props.seconds;var timerStyle={position:'fixed',right:0,top:'6px',padding:'7px',zIndex:198,background:'#fff'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timerCountDown',style:timerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_countdown_clock___default.a,{seconds:seconds,showMilliseconds:true,color:'#D24D57',alpha:0.9,size:80,onComplete:function onComplete(e){return _this2.onComplete();}}));}}]);return TimerCountDown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TimerCountDown);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(94);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(264);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(58);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(537);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Virtualkeyboard=function(_React$Component){_inherits(Virtualkeyboard,_React$Component);function Virtualkeyboard(props){_classCallCheck(this,Virtualkeyboard);return _possibleConstructorReturn(this,(Virtualkeyboard.__proto__||Object.getPrototypeOf(Virtualkeyboard)).call(this,props));}// VirtualKeyboard(seqof) {
//     var languages = {
//         "ar": {
//             layout: "ms-Arabic (101)",
//             name: "Arabic (\u0627\u0644\u0639\u0631\u0628\u064a\u0629)"
//         },
//         "de": {
//             layout: "ms-German",
//             name: "German (Deutsch)"
//         },
//         "en": {
//             layout: "qwerty",
//             name: "English"
//         },
//         "tr": {
//             layout: "ms-Turkish F",
//             name: "Turkish (T\u00fcrk\u00e7e)"
//         },
//         "tm": {
//             layout: "ms-Tamil",
//             name: "ms-Tamil"
//         },
//         "fr": {
//             layout: "ms-Belgian French",
//             name: "ms-Belgian French"
//         }
//     }
//     function selectLang(kb, lang) {
//         var obj = languages[lang];
//         if (obj) {
//             kb.options.language = lang;
//             kb.redraw(obj.layout);
//         }
//     };
//     function addLang(kb) {
//         var html = '';
//         //console.log("call");
//         html = '<div>Select Language: <select>';
//         Object.keys(languages).forEach(function (language) {
//             html += `<option value="${language}">${languages[language].name}</option>`;
//         });
//         kb.$keyboard.prepend(html + '</select></div>');
//         kb.$keyboard.find('select')
//             .val(kb.options.language || "en")
//             .click(function () {
//                 var el = this;
//                 setTimeout(function () {
//                     el.focus();
//                 }, 100);
//             })
//             .change(function () {
//                 selectLang(kb, this.value);
//             });
//     }
//     $('#keyboard' + seqof).on('beforeVisible', function (e, kb) {
//         addLang(kb);
//     }).keyboard({ usePreview: false })             // activate the typing extension
//         .addTyping({ showTyping: true, delay: 250 });
//     $("#vkbox_" + seqof).prop('disabled', true);
//     // $('#keyboard' + seqof).focus();
//     // $('#keyboard' + seqof).focusout();
//     var clipboard = new Clipboard('.bf');
//     clipboard.on('success', function(e) {
//     console.log(e); 
//     });
//     clipboard.on('error', function(e) {
//     console.log(e);
//     });
// }
_createClass(Virtualkeyboard,[{key:'alpha',value:function alpha(item){var quesid=document.getElementById('keyboard'+this.props.qus_id);var input=quesid;if(document.selection){input.focus();var range=document.selection.createRange();range.text=item;range.select();}else if(input.selectionStart||input.selectionStart==='0'){var startPos=input.selectionStart;var endPos=input.selectionEnd;var cursorPos=startPos;var scrollTop=input.scrollTop;var baselength=0;input.value=input.value.substring(0,startPos)+item+input.value.substring(endPos,input.value.length);cursorPos+=item.length;input.focus();input.selectionStart=cursorPos;input.selectionEnd=cursorPos;input.scrollTop=scrollTop;}else{input.value+=item;input.focus();}}// copier() {
//     document.conversion.saisie.focus();
//     document.conversion.saisie.select();
//     let CopiedTxt = document.selection.createRange();
//     CopiedTxt.execCommand("Copy");
// }
//  copy() {
//     let textRange = document.conversion.saisie.createTextRange();
//     textRange.execCommand("Copy");
//     textRange = "";
// }
// annuler() {
//     let car;
//     car = document.conversion.saisie.value;
//     car = car.replace(/\u200b/g, "");
//     document.conversion.saisie.value = car;
// }
},{key:'render',value:function render(){var _this2=this;var vkdata=this.props;// var ca;
// function transit() {
// ca = document.conversion.saisie.value;
// document.bp.typedText.value=ca;
// document.bp.submit(); 
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:vkdata.qus_id,id:'keyboard'+vkdata.qus_id,className:vkdata.validate,rows:'3',onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':vkdata.data_maxword,defaultValue:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tab-kb',style:{backgroundColor:'#2b93d8'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('À');},defaultValue:'\xC0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Â');},defaultValue:'\xC2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Æ');},defaultValue:'\xC6'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ç');},defaultValue:'\xC7'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('É');},defaultValue:'\xC9'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('È');},defaultValue:'\xC8'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ê');},defaultValue:'\xCA'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ë');},defaultValue:'\xCB'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Î');},defaultValue:'\xCE'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ï');},defaultValue:'\xCF'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ô');},defaultValue:'\xD4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Œ');},defaultValue:'\u0152'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ù');},defaultValue:'\xD9'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Û');},defaultValue:'\xDB'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ü');},defaultValue:'\xDC'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('Ÿ');},defaultValue:'\u0178'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('à');},defaultValue:'\xE0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('â');},defaultValue:'\xE2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('æ');},defaultValue:'\xE6'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ç');},defaultValue:'\xE7'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('é');},defaultValue:'\xE9'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('è');},defaultValue:'\xE8'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ê');},defaultValue:'\xEA'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ë');},defaultValue:'\xEB'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('î');},defaultValue:'\xEE'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ï');},defaultValue:'\xEF'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ô');},defaultValue:'\xF4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('œ');},defaultValue:'\u0153'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ù');},defaultValue:'\xF9'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('û');},defaultValue:'\xFB'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ü');},defaultValue:'\xFC'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('ÿ');},defaultValue:'\xFF'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tab-kb',style:{backgroundColor:'#2b93d8'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('«');},defaultValue:'\xAB'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('“');},defaultValue:'\u201C'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('”');},defaultValue:'\u201D'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('—');},defaultValue:'\u2014'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('»');},defaultValue:'\xBB'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('–');},defaultValue:'\u2013'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('’');},defaultValue:'\u2019'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha('…');},defaultValue:'\u2026'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button1',className:'bt',onClick:function onClick(){return _this2.alpha(' ');},defaultValue:'\u202F',title:'Narrow no-break space'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return Virtualkeyboard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Virtualkeyboard);

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(282),
    baseKeys = __webpack_require__(643),
    isArrayLike = __webpack_require__(72);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(159),
    isLength = __webpack_require__(166);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(286),
    baseAssignValue = __webpack_require__(169);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.notify = notify;
exports.instanceId = instanceId;
exports.isFirstFocusedRender = isFirstFocusedRender;
var idCount = 0;

function uniqueId(prefix) {
  return '' + ((prefix == null ? '' : prefix) + ++idCount);
}

function notify(handler, args) {
  handler && handler.apply(null, [].concat(args));
}

function instanceId(component) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  component.__id || (component.__id = uniqueId('rw_'));
  return (component.props.id || component.__id) + suffix;
}

function isFirstFocusedRender(component) {
  return component._firstFocus || component.state.focused && (component._firstFocus = true);
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(110));

var _isWindow = _interopRequireDefault(__webpack_require__(77));

var _ownerDocument = _interopRequireDefault(__webpack_require__(174));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isSelected = isSelected;
exports.slotWidth = slotWidth;
exports.getCellAtX = getCellAtX;
exports.pointInBox = pointInBox;
exports.dateCellSelection = dateCellSelection;
function isSelected(event, selected) {
  if (!event || selected == null) return false;
  return [].concat(selected).indexOf(event) !== -1;
}

function slotWidth(rowBox, slots) {
  var rowWidth = rowBox.right - rowBox.left;
  var cellWidth = rowWidth / slots;

  return cellWidth;
}

function getCellAtX(rowBox, x, cellWidth, rtl, slots) {
  return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}

function pointInBox(box, _ref) {
  var x = _ref.x,
      y = _ref.y;

  return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}

function dateCellSelection(start, rowBox, box, slots, rtl) {
  var startIdx = -1;
  var endIdx = -1;
  var lastSlotIdx = slots - 1;

  var cellWidth = slotWidth(rowBox, slots);

  // cell under the mouse
  var currentSlot = getCellAtX(rowBox, box.x, cellWidth, rtl, slots);

  // Identify row as either the initial row
  // or the row under the current mouse point
  var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
  var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y;

  // this row's position relative to the start point
  var isAboveStart = start.y > rowBox.bottom;
  var isBelowStart = rowBox.top > start.y;
  var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom;

  // this row is between the current and start rows, so entirely selected
  if (isBetween) {
    startIdx = 0;
    endIdx = lastSlotIdx;
  }

  if (isCurrentRow) {
    if (isBelowStart) {
      startIdx = 0;
      endIdx = currentSlot;
    } else if (isAboveStart) {
      startIdx = currentSlot;
      endIdx = lastSlotIdx;
    }
  }

  if (isStartRow) {
    // select the cell under the initial point
    startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);

    if (isCurrentRow) {
      if (currentSlot < startIdx) startIdx = currentSlot;else endIdx = currentSlot; //select current range
    } else if (start.y < box.y) {
      // the current row is below start row
      // select cells to the right of the start cell
      endIdx = lastSlotIdx;
    } else {
      // select cells to the left of the start cell
      startIdx = 0;
    }
  }

  return { startIdx: startIdx, endIdx: endIdx };
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(174);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(75);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(397);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setActiongoalAction */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiongoalAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
function setActiongoalAction(actionGoal){return{type:"GET_ACTION_GOAL",actionGoal:actionGoal};}function getActiongoalAction(id){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","please wait...");fetch(__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */]+'action-goal/'+id,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");dispatch(setActiongoalAction(responseJson.data));}).catch(function(error){console.error(error);});};}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(248);
var enumBugKeys = __webpack_require__(140);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactJss = __webpack_require__(526);

var _reactJss2 = _interopRequireDefault(_reactJss);

var _modal = __webpack_require__(579);

var _modal2 = _interopRequireDefault(_modal);

var _styles = __webpack_require__(584);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactJss2.default)(_styles2.default)(_modal2.default);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('__THEMING__');

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(58);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(536);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(601),
    listCacheDelete = __webpack_require__(602),
    listCacheGet = __webpack_require__(603),
    listCacheHas = __webpack_require__(604),
    listCacheSet = __webpack_require__(605);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(70);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(625);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(28),
    stubFalse = __webpack_require__(641);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)(module)))

/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(645),
    Map = __webpack_require__(158),
    Promise = __webpack_require__(646),
    Set = __webpack_require__(647),
    WeakMap = __webpack_require__(648),
    baseGetTag = __webpack_require__(59),
    toSource = __webpack_require__(276);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(283);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ctestonebyone=function(_Component){_inherits(Ctestonebyone,_Component);function Ctestonebyone(props){_classCallCheck(this,Ctestonebyone);var _this=_possibleConstructorReturn(this,(Ctestonebyone.__proto__||Object.getPrototypeOf(Ctestonebyone)).call(this,props));_this.compeletestatus="";_this.state={testseqfields:[],componentStatus:_this.props.data.status,testquestions:[],testcont:[],statusMessage:"",is_answered_all:0,resultthank:''};return _this;}_createClass(Ctestonebyone,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getonebyonedet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){setTimeout(function(){_this2.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,is_answered_all:responseJson.Mcq_details.is_answered_all});Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},2000);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;this.props.switchback(data);}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',//type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',animation:false,cancelButtonColor:'#0082c9',confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt){var opaudio_style={width:'90%'};var op_val='';switch(ans_opt.options){case'image':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submittest',value:function submittest(cur_question_id){var _this4=this;if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.componentStatus=='completed'){_this4.gotoresult();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}else{setTimeout(function(){_this4.goback(responseJson.next_id);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);}});}}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft',key:quest_det.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,key:ans_opt.mcq_answer_id_pk,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft',key:quest_det.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft',key:quest_det.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:ans_opt.mcq_answer_id_pk,key:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft testopt',key:quest_det.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft',key:quest_det.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:ans_opt.mcq_answer_id_pk,key:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft',key:quest_det.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:''}))),this.getoptions(ans_opt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg',defaultValue:mk.answered[r]})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:mk.fullanswer})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,learner_id:data.learner_id,divider_id:data.divider_id,dlr_id:data.dlr_id,compo_type:data.compo_type,video_id:data.id};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{key:Date.now(),playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,className:validationClass,cols:'70',rows:'7',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords},mk.fullanswer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},' Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed!=undefined&&testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'';var sequenceClass=data.allowskip==0?'required ':'';var optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),data.learner_msg!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this6.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+testquestions.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt fleft'},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn fleft',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques',key:'TE'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select',key:'ST'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:qas.inserted_answer!=undefined?qas.inserted_answer:''}),' -'));}return _this6.getquestion(testquestions,qas,i+1);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple,defaultValue:testquestions.fullanswer}))),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length,defaultValue:testquestions.fullanswer}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(','),defaultValue:testquestions.answered})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.goback(pre_question_id);}}))))))))));}}]);return Ctestonebyone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ctestonebyone);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(682)
var ieee754 = __webpack_require__(683)
var isArray = __webpack_require__(684)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.set = set;
exports.default = format;

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function inSame12Hr(start, end) {
  var s = 12 - _dates2.default.hours(start);
  var e = 12 - _dates2.default.hours(end);
  return s <= 0 && e <= 0 || s >= 0 && e >= 0;
}

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 'h:mmtt', culture) + ' — ' + local.format(end, inSame12Hr(start, end) ? 'h:mm' : 'h:mmtt', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start,
      end = _ref3.end;
  return local.format(start, 'h:mmtt', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var start = _ref4.start,
      end = _ref4.end;
  return ' — ' + local.format(end, 'h:mmtt', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = {
  dateFormat: 'dd',
  dayFormat: 'ddd dd/MM',
  weekdayFormat: 'ddd',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: 'h:mm tt',

  monthHeaderFormat: 'MMMM yyyy',
  dayHeaderFormat: 'dddd MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'ddd MMM dd',
  agendaTimeFormat: 'hh:mm tt',
  agendaTimeRangeFormat: timeRangeFormat
};

function set(_formats) {
  var _formats2;

  if (arguments.length > 1) _formats = (_formats2 = {}, _formats2[_formats] = arguments[1], _formats2);

  _extends(formats, _formats);
}

function format(fmts) {
  return _extends({}, formats, fmts);
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.set = set;
exports.result = result;
exports.default = messages;

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMessages = {
  date: 'Date',
  time: 'Time',
  event: 'Event',
  allDay: 'all day',
  week: 'week',
  work_week: 'work week',
  day: 'day',
  month: 'month',
  previous: 'back',
  next: 'next',
  yesterday: 'yesterday',
  tomorrow: 'tomorrow',
  today: 'today',
  agenda: 'agenda',

  showMore: function showMore(total) {
    return '+' + total + ' more';
  }
};

function set(key, msg) {
  !messages.hasOwnProperty(key) ?  false ? (0, _invariant2.default)(false, 'The message key: "' + key + '" is not a valid message name. ' + ('valid keys are: ' + Object.keys(messages).join(', '))) : (0, _invariant2.default)(false) : void 0;

  messages[key] = msg;
}

function result(msg) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof msg === 'function' ? msg(args) : msg;
}

function messages(msgs) {
  return _extends({}, defaultMessages, msgs);
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(70),
    isArrayLike = __webpack_require__(72),
    isIndex = __webpack_require__(164),
    isObject = __webpack_require__(31);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(731),
    baseMatchesProperty = __webpack_require__(734),
    identity = __webpack_require__(113),
    isArray = __webpack_require__(23),
    property = __webpack_require__(744);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23),
    isKey = __webpack_require__(182),
    stringToPath = __webpack_require__(736),
    toString = __webpack_require__(739);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(386);

var _PathUtils = __webpack_require__(34);

var _runTransitionHook = __webpack_require__(118);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(81);

var _LocationUtils = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(50);

var _DOMUtils = __webpack_require__(82);

var _DOMStateStorage = __webpack_require__(199);

var _PathUtils = __webpack_require__(34);

var _ExecutionEnvironment = __webpack_require__(120);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setProfile */
/* harmony export (immutable) */ __webpack_exports__["a"] = getProfile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
function setProfile(profile){return{type:"SET_PROFILE",profile:profile};}function getProfile(){return function(dispatch){var lr_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var username=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('primaryEmail',true);var domain_url=__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */];fetch(__WEBPACK_IMPORTED_MODULE_0__config_Config__["d" /* domainUrl */]+"user/change-profile",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:lr_id,username:username,domain:domain_url})}).then(function(response){return response.json();}).then(function(responseJson){// Common.reactLoader("hide");
dispatch(setProfile(responseJson));}).catch(function(error){console.error(error);});};}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertTools = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var actualGlobalConfig = void 0;

    var sAlertTools = {
        randomId: function randomId() {
            return Math.random().toString(36).split('.')[1];
        },
        returnFirstDefined: function returnFirstDefined() {
            var value = void 0;
            var i = void 0;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            for (i = 0; i < args.length; i++) {
                if (typeof args[i] !== 'undefined') {
                    value = args[i];
                    break;
                }
            }
            return value;
        },
        styleToObj: function styleToObj(input) {
            var result = {},
                i = void 0,
                entry = void 0,
                attributes = input && input.split(';').filter(Boolean);

            for (i = 0; i < attributes.length; i++) {
                entry = attributes[i].split(':');
                result[entry.splice(0, 1)[0].trim()] = entry.join(':').trim();
            }
            return result;
        },
        setGlobalConfig: function setGlobalConfig(config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
                actualGlobalConfig = config;
            }
        },
        getGlobalConfig: function getGlobalConfig() {
            return actualGlobalConfig;
        }
    };

    exports.default = sAlertTools;
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertStore = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }

            return arr2;
        } else {
            return Array.from(arr);
        }
    }

    // custom simple store based on a awesome Redux library https://github.com/rackt/redux

    var createSAlertStore = function createSAlertStore(reducer) {
        var state = void 0;
        var listeners = [];
        var getState = function getState() {
            return state;
        };
        var dispatch = function dispatch(action) {
            state = reducer(state, action);
            listeners.forEach(function (listener) {
                return listener();
            });
        };
        var subscribe = function subscribe(listener) {
            listeners.push(listener);
            return function () {
                listeners = listeners.filter(function (l) {
                    return l !== listener;
                });
            };
        };
        dispatch({});
        return {
            getState: getState, dispatch: dispatch, subscribe: subscribe
        };
    };

    var insert = function insert(state, action) {
        return [].concat(_toConsumableArray(state), [action.data]);
    };

    var remove = function remove(state, action) {
        var elemToRemoveArray = state.slice().filter(function (item) {
            return item.id === action.data.id;
        });
        if (Array.isArray(elemToRemoveArray)) {
            var elemToRemoveIndex = state.indexOf(elemToRemoveArray[0]);
            return [].concat(_toConsumableArray(state.slice(0, elemToRemoveIndex)), _toConsumableArray(state.slice(elemToRemoveIndex + 1)));
        }
        return state;
    };

    var alertsReducer = function alertsReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case 'INSERT':
                return insert(state, action);
            case 'REMOVE':
                return remove(state, action);
            case 'REMOVEALL':
                return [];
            default:
                return state;
        }
    };

    var sAlertStore = createSAlertStore(alertsReducer);

    exports.default = sAlertStore;
});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(468);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ckeditor = __webpack_require__(481);

var _ckeditor2 = _interopRequireDefault(_ckeditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ckeditor2["default"];
module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(482);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(498);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(54);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(66);
var dPs = __webpack_require__(488);
var enumBugKeys = __webpack_require__(140);
var IE_PROTO = __webpack_require__(138)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(246)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(492).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(139)('keys');
var uid = __webpack_require__(88);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(37);
var global = __webpack_require__(36);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(85) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(41).f;
var has = __webpack_require__(43);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(56);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(37);
var LIBRARY = __webpack_require__(85);
var wksExt = __webpack_require__(142);
var defineProperty = __webpack_require__(41).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(508);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(512);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.3';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)(module)))

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGenerateClassNameDefault = exports.SheetsManager = exports.getDynamicStyles = exports.SheetsRegistry = undefined;

var _jss = __webpack_require__(261);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsRegistry;
  }
});
Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _jss.getDynamicStyles;
  }
});
Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsManager;
  }
});
Object.defineProperty(exports, 'createGenerateClassNameDefault', {
  enumerable: true,
  get: function get() {
    return _jss.createGenerateClassName;
  }
});

var _jssPresetDefault = __webpack_require__(551);

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _jss.create)((0, _jssPresetDefault2['default'])());

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(93);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(262);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(95);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_inboxAction__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ComponentComplete=function(_Component){_inherits(ComponentComplete,_Component);function ComponentComplete(props){_classCallCheck(this,ComponentComplete);var _this=_possibleConstructorReturn(this,(ComponentComplete.__proto__||Object.getPrototypeOf(ComponentComplete)).call(this,props));_this.state={lrCount:"",performanceScore:"",totalPerformanceTest:"",cumulativeScore:""};_this.props.getInbox();return _this;}_createClass(ComponentComplete,[{key:'getLrCompletedPage',value:function getLrCompletedPage(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"get-lr-completed-page",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({user_id:data.learner_id,learning_room_id:data.learning_room_id})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this2.setState({lrCount:responseJson.lrCount,performanceScore:responseJson.performanceScore,totalPerformanceTest:responseJson.totalPerformanceTest,cumulativeScore:responseJson.cumulativeScore});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getLrCompletedPage(data);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getLrCompletedPage(data);}},{key:'goBackToComponentList',value:function goBackToComponentList(){var data=this.props.data;this.props.switchback("component_list",data.learning_room_id,data.dlr_id);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thanks-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'contract',action:'',method:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Congratulations !',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'You have successfully completed LR ',this.state.lrCount,'.')),this.state.totalPerformanceTest!=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Your performance scores in this LR are given below.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),this.state.totalPerformanceTest!=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'bluetxt libtm'},'Performance Score',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'orangenolnk',nohref:'',title:this.state.performanceScore},this.state.performanceScore),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/performance-icon.jpg',alt:'',title:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),this.state.totalPerformanceTest!=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'allover-score'},'Cumulative Performance Score : ',this.state.cumulativeScore)),this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thanks-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',title:'Next',type:'button',onClick:function onClick(){return _this3.goBackToComponentList();}})):""))))))));}}]);return ComponentComplete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({getInbox:__WEBPACK_IMPORTED_MODULE_5__actions_inboxAction__["a" /* getInbox */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null,mapDispatchToProps)(ComponentComplete));

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var win=window;var $=win.$;var Timercount=function(_React$Component){_inherits(Timercount,_React$Component);function Timercount(props){_classCallCheck(this,Timercount);var _this=_possibleConstructorReturn(this,(Timercount.__proto__||Object.getPrototypeOf(Timercount)).call(this,props));_this.state={apicall:'',num1of:1,num2of:1};return _this;}_createClass(Timercount,[{key:'componentDidMount',value:function componentDidMount(){var self=this;var vcdata=self.props;var minuts=25;var seconds=vcdata.seconds;//1min 5seconds
var timer=undefined;var isStarted=false;var isPaused=false;var n1='';var n2='';var num1=void 0,num2=1;if(!isStarted){this.timer=setInterval(function(){seconds++;n1=Math.floor(seconds/60);n2=seconds%60;n1=n1.toString();n2=n2.toString();num1=n1.length>1?n1:'0'+n1;num2=n2.length>1?n2:"0"+n2;self.setState({num1of:num1,num2of:num2});$("#timer").text(num1+":"+num2);if(seconds==0){clearInterval(this.timer);}},1000);self.setState({apicall:'1'});if(this.props.allowaddtimer==undefined||this.props.allowaddtimer==1){this.myInterval=setInterval(function(){if(self.state.apicall=='1'){self.addtimer(vcdata.details,num1,num2,vcdata.question_number);}},3000);}isStarted=true;}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.myInterval);clearInterval(this.timer);var vcdata=this.props;if(vcdata.allowaddtimer==undefined||vcdata.allowaddtimer==1){this.addtimer(vcdata.details,this.state.num1of,this.state.num2of,vcdata.question_number);}}},{key:'addtimer',value:function addtimer(data,min,seconds,question_number){fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savetimerdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data,'min':min,'seconds':seconds,'question_number':question_number})}).then(function(response){return response.json();}).then(function(responseJson){});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'floatdiv',className:'timer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Time Taken - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'timer',className:'text-center'},'00:00')));}}]);return Timercount;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Timercount);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var win=window;var $=win.$;var Timecountdown=function(_React$Component){_inherits(Timecountdown,_React$Component);function Timecountdown(props){_classCallCheck(this,Timecountdown);var _this=_possibleConstructorReturn(this,(Timecountdown.__proto__||Object.getPrototypeOf(Timecountdown)).call(this,props));_this.state={apicall:'',num1of:1,num2of:1};return _this;}_createClass(Timecountdown,[{key:'componentDidMount',value:function componentDidMount(){var self=this;var vcdata=self.props;var minuts=25;//dummy - not using anywhere
var seconds=vcdata.seconds;//1min 5seconds
var timer=undefined;var isStarted=false;var isPaused=false;var n1=void 0,n2=void 0,n3=void 0,hrs='';var num1=void 0,num2=1;if(!isStarted){this.timer=setInterval(function(){seconds--;hrs=Math.floor(seconds/3600);n1=Math.floor(seconds/60);n3=n1>60?n1%60:n1;n2=seconds%60;num1=self.cuntdown(n1);num2=self.cuntdown(n2);self.setState({num1of:num1,num2of:num2});if(hrs>0){$("#timer").text(hrs+":"+n3+":"+num2);}else{$("#timer").text(self.cuntdown(n3)+":"+num2);}if(seconds==0){clearInterval(this.timer);if(vcdata.allowaddtimer==undefined||vcdata.allowaddtimer==1){self.questionautocompelete(vcdata.details);}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Note!','Sorry, Your time is exceeded','info');self.props.tfs({componentStatus:'incompleted'});}}},1000);self.setState({apicall:'1'});if(this.props.allowaddtimer==undefined||this.props.allowaddtimer==1){this.myInterval=setInterval(function(){if(self.state.apicall=='1'){self.addtimer(vcdata.details,num1,num2,vcdata.question_number);}},3000);}isStarted=true;}}},{key:'questionautocompelete',value:function questionautocompelete(data){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/autosaveall',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */]();if(responseJson.isCompletedFully){_this2.props.goToThanksPage();}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Note!','Sorry, Your time is exceeded','info');_this2.props.tfs(responseJson);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");}});}},{key:'cuntdown',value:function cuntdown(num){num=num.toString();return num.length>1?num:'0'+num;}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.myInterval);clearInterval(this.timer);var vcdata=this.props;if(vcdata.allowaddtimer==undefined||vcdata.allowaddtimer==1){this.addtimer(vcdata.details,this.state.num1of,this.state.num2of,vcdata.question_number);}}},{key:'addtimer',value:function addtimer(data,min,seconds,question_number){fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savetimerdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data,'min':min,'seconds':seconds,'question_number':question_number})}).then(function(response){return response.json();}).then(function(responseJson){});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'floatdiv',className:'timer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timer_txt'},'Time Taken - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'timer',className:'text-center'},'00:00')));}}]);return Timecountdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Timecountdown);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(598);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(600),
    isObjectLike = __webpack_require__(38);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(97),
    stackClear = __webpack_require__(606),
    stackDelete = __webpack_require__(607),
    stackGet = __webpack_require__(608),
    stackHas = __webpack_require__(609),
    stackSet = __webpack_require__(610);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isObject = __webpack_require__(31);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(617),
    mapCacheDelete = __webpack_require__(624),
    mapCacheGet = __webpack_require__(626),
    mapCacheHas = __webpack_require__(627),
    mapCacheSet = __webpack_require__(628);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(638),
    stubArray = __webpack_require__(281);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(640),
    isObjectLike = __webpack_require__(38);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(642),
    baseUnary = __webpack_require__(102),
    nodeUtil = __webpack_require__(167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(275);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)(module)))

/***/ }),
/* 168 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(287);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(282),
    baseKeysIn = __webpack_require__(652),
    isArrayLike = __webpack_require__(72);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(278);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Addmore=function(_Component){_inherits(Addmore,_Component);function Addmore(props){_classCallCheck(this,Addmore);var _this=_possibleConstructorReturn(this,(Addmore.__proto__||Object.getPrototypeOf(Addmore)).call(this,props));_this.state={more_fields:[{deleteoption:false}]};return _this;}_createClass(Addmore,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// if(nextProps.newstate!=undefined){
//   nextProps.newstate.map((key,index)=>{
//    this.state.more_fields.push({deleteoption: key.deleteoption});
//  }
// )
// }
if(nextProps.editType!=undefined){if(nextProps.editType=='edit'&&nextProps.compType=='parent'){this.setState({more_fields:[{deleteoption:true}]});}}}},{key:'addRow',value:function addRow(){var _props=this.props,limit=_props.limit,selector=_props.selector,refreshScroll=_props.refreshScroll,compType=_props.compType,parent=_props.parent,editType=_props.editType,startId=_props.startId;if(editType=='edit'&&compType=='parent'){// $("#"+selector+startId);
var div_id=$('div[id^="'+selector+'"]').last().attr('id');$("#"+div_id).css('display','block');$('#'+div_id+' :input').removeAttr('disabled');//alert($('div[id^="'+selector+'"]').length);
if(limit>$('div[id^="'+selector+'"]').length){var more_fields=[].concat(_toConsumableArray(this.state.more_fields),[{deleteoption:true}]);this.setState({more_fields:more_fields});if(refreshScroll!=undefined){refreshScroll('add_'+selector);}}else{__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]('Oops!!','You can add only '+limit+' Question(s).','error');}}else if(compType=='parent'&&editType=="form"){if(limit>$('div[id^="'+selector+'"]').length){var _more_fields=[].concat(_toConsumableArray(this.state.more_fields),[{deleteoption:true}]);this.setState({more_fields:_more_fields});if(refreshScroll!=undefined){refreshScroll('add_'+selector);}}else{__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]('Oops!!','You can add only '+limit+' '+selector+'(s).','error');}}if(editType=='edit'&&compType=='child'){var parentid="";if(this.refs.node.parentNode!=""){parentid=this.refs.node.parentNode.id;}//  alert(selector);
var _div_id=$("#"+parent+"_"+parentid+" div[id^='"+selector+"']").last().attr('id');//alert(div_id);
$("#"+parent+"_"+parentid+" #"+_div_id+' :input').removeAttr('disabled');$("#"+parent+"_"+parentid+" #"+_div_id).css('display','block');// $("#"+parent+"_"+parentid+" #"+div_id +' :input').attr('disabled',false);
//ddd  alert($("#"+parent+"_"+parentid+" div[id^='"+selector+"']").length);
if(limit>$("#"+parent+"_"+parentid+" div[id^='"+selector+"']").length){var _more_fields2=[].concat(_toConsumableArray(this.state.more_fields),[{deleteoption:true}]);this.setState({more_fields:_more_fields2});if(refreshScroll!=undefined){refreshScroll('add_'+selector);}}else{__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]('Oops!!','You can add only '+limit+' Answer(s).','error');}}else if(compType=='child'&&editType=="form"){// alert('here');
var _parentid="";if(this.refs.node.parentNode!=""){_parentid=this.refs.node.parentNode.id;}if(limit>$("#"+parent+"_"+_parentid+" div[id^='"+selector+"']").length){var _more_fields3=[].concat(_toConsumableArray(this.state.more_fields),[{deleteoption:true}]);this.setState({more_fields:_more_fields3});if(refreshScroll!=undefined){refreshScroll('add_'+selector);}}else{__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]('Oops!!','You can add only '+limit+' '+selector+'(s).','error');}}}},{key:'deleteRow',value:function deleteRow(index){//alert(index);
var _props2=this.props,selector=_props2.selector,refreshScroll=_props2.refreshScroll,parent=_props2.parent,compType=_props2.compType;//alert(selector);
if(compType=='parent'){if($('div#'+selector+'_'+index).length>0){$('div#'+selector+'_'+index).remove();}if(refreshScroll!=undefined){refreshScroll('remove_'+selector);}}if(compType=='child'){var parentid="";if(this.refs.node.parentNode!=""){parentid=this.refs.node.parentNode.id;}// alert(parentid);
//alert("#"+parent+"_"+parentid+" div#"+selector+"_"+index);
if($("#"+parent+"_"+parentid+" div#"+selector+"_"+index).length>0){$("#"+parent+"_"+parentid+" div#"+selector+"_"+index).remove();}if(refreshScroll!=undefined){refreshScroll('remove_'+selector);}}}// setAdmoreFields(data){
//
//
//     if (data.length>0) {
//         $('#imageloader').show();
//
//             var moreFieldsValue=[];
//
//               for(var J=0;J<data.length;J++){
//
//                 if(J==0){
//                   moreFieldsValue.push({deleteoption: false});
//
//                 }else{
//                   moreFieldsValue.push({deleteoption: true});
//                 }
//
//               }
//
//             $('#imageloader').hide();
//
//         }
//
//     this.setState({
//         more_fields:moreFieldsValue
//     });
// }
},{key:'componentDidMount',value:function componentDidMount(){var _props3=this.props,editType=_props3.editType,subType=_props3.subType,compType=_props3.compType,polls_sent=_props3.polls_sent;if(editType=='edit'&&subType=='subtype'&&compType=='child'&&polls_sent!=""){this.setState({more_fields:[{deleteoption:true}]});}}},{key:'render',value:function render(){var _this2=this;// alert(JSON.stringify(this.state.more_fields));
var _props4=this.props,selector=_props4.selector,onChange=_props4.onChange,AddLabel=_props4.AddLabel,DeleteLabel=_props4.DeleteLabel,compType=_props4.compType,editType=_props4.editType,startId=_props4.startId,polls_sent=_props4.polls_sent,subType=_props4.subType;var more_fields=null;//alert(JSON.stringify(this.state.more_fields));
if(editType=='edit'&&compType=='parent'){var id_sent=startId+1;// alert(startId);
//alert(id_sent);
more_fields=this.state.more_fields.map(function(key,inde){var id_show=id_sent;id_sent++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'pac_'+id_sent},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:selector+'_'+id_show,style:{display:'none'}},key.deleteoption==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-red pull-right remove_'+selector,onClick:function onClick(e){return _this2.deleteRow(id_show);}},DeleteLabel):'',_this2.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));});}else if(compType=='parent'&&editType=="form"){more_fields=this.state.more_fields.map(function(key,inde){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'parentco_'+inde,id:selector+'_'+inde},key.deleteoption==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-red pull-right remove_'+selector,onClick:function onClick(e){return _this2.deleteRow(inde);}},DeleteLabel):'',_this2.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}));});}if(editType=='edit'&&compType=='child'&&subType=='subtype'&&polls_sent!=""){//alert(selector);
var _id_sent=startId;more_fields=this.state.more_fields.map(function(key,inde){_id_sent++;var id_show=_id_sent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'chc_'+_id_sent},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:selector+'_'+id_show,className:'child_inputs',style:{display:'none'}},key.deleteoption==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-red pull-right remove_'+selector,onClick:function onClick(e){return _this2.deleteRow(id_show);}},DeleteLabel):'',_this2.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));});}else if(compType=='child'&&polls_sent==""||polls_sent==undefined){// alert('im here');
more_fields=this.state.more_fields.map(function(key,inde){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'childco_'+inde,id:selector+'_'+inde,className:'child_inputs'},key.deleteoption==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-red pull-right remove_'+selector,onClick:function onClick(e){return _this2.deleteRow(inde);}},DeleteLabel):'',_this2.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'node'},polls_sent?polls_sent:'',more_fields,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn-green pull-right add_'+selector,onClick:function onClick(e){return _this2.addRow();}},AddLabel));}}]);return Addmore;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Addmore);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(77));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(313);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(112),
    toKey = __webpack_require__(80);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(23),
    isSymbol = __webpack_require__(75);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _requestAnimationFrame = __webpack_require__(311);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _DayColumn = __webpack_require__(760);

var _DayColumn2 = _interopRequireDefault(_DayColumn);

var _TimeColumn = __webpack_require__(325);

var _TimeColumn2 = _interopRequireDefault(_TimeColumn);

var _DateContentRow = __webpack_require__(314);

var _DateContentRow2 = _interopRequireDefault(_DateContentRow);

var _Header = __webpack_require__(320);

var _Header2 = _interopRequireDefault(_Header);

var _width = __webpack_require__(326);

var _width2 = _interopRequireDefault(_width);

var _scrollbarSize = __webpack_require__(327);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _messages = __webpack_require__(108);

var _messages2 = _interopRequireDefault(_messages);

var _propTypes3 = __webpack_require__(20);

var _helpers = __webpack_require__(74);

var _accessors = __webpack_require__(61);

var _eventLevels = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeGrid = function (_Component) {
  _inherits(TimeGrid, _Component);

  function TimeGrid(props) {
    _classCallCheck(this, TimeGrid);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleSelectAllDaySlot = function (slots, slotInfo) {
      var onSelectSlot = _this.props.onSelectSlot;

      (0, _helpers.notify)(onSelectSlot, {
        slots: slots,
        start: slots[0],
        end: slots[slots.length - 1],
        action: slotInfo.action
      });
    };

    _this.checkOverflow = function () {
      if (_this._updatingOverflow) return;

      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;

      if (_this.state.isOverflowing !== isOverflowing) {
        _this._updatingOverflow = true;
        _this.setState({ isOverflowing: isOverflowing }, function () {
          _this._updatingOverflow = false;
        });
      }
    };

    _this.state = { gutterWidth: undefined, isOverflowing: null };
    _this.handleSelectEvent = _this.handleSelectEvent.bind(_this);
    _this.handleDoubleClickEvent = _this.handleDoubleClickEvent.bind(_this);
    _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
    return _this;
  }

  TimeGrid.prototype.componentWillMount = function componentWillMount() {
    this._gutters = [];
    this.calculateScroll();
  };

  TimeGrid.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.checkOverflow();

    if (this.props.width == null) {
      this.measureGutter();
    }
    this.applyScroll();

    this.positionTimeIndicator();
    this.triggerTimeIndicatorUpdate();

    window.addEventListener('resize', function () {
      _requestAnimationFrame2.default.cancel(_this2.rafHandle);
      _this2.rafHandle = (0, _requestAnimationFrame2.default)(_this2.checkOverflow);
    });
  };

  TimeGrid.prototype.componentWillUnmount = function componentWillUnmount() {
    window.clearTimeout(this._timeIndicatorTimeout);
  };

  TimeGrid.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.width == null && !this.state.gutterWidth) {
      this.measureGutter();
    }

    this.applyScroll();
    this.positionTimeIndicator();
    //this.checkOverflow()
  };

  TimeGrid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        range = _props.range,
        scrollToTime = _props.scrollToTime;
    // When paginating, reset scroll

    if (!_dates2.default.eq(nextProps.range[0], range[0], 'minute') || !_dates2.default.eq(nextProps.scrollToTime, scrollToTime, 'minute')) {
      this.calculateScroll(nextProps);
    }
  };

  TimeGrid.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        events = _props2.events,
        range = _props2.range,
        width = _props2.width,
        startAccessor = _props2.startAccessor,
        endAccessor = _props2.endAccessor,
        getNow = _props2.getNow,
        resources = _props2.resources,
        allDayAccessor = _props2.allDayAccessor,
        showMultiDayTimes = _props2.showMultiDayTimes;


    width = width || this.state.gutterWidth;

    var start = range[0],
        end = range[range.length - 1];

    this.slots = range.length;

    var allDayEvents = [],
        rangeEvents = [];

    events.forEach(function (event) {
      if ((0, _eventLevels.inRange)(event, start, end, _this3.props)) {
        var eStart = (0, _accessors.accessor)(event, startAccessor),
            eEnd = (0, _accessors.accessor)(event, endAccessor);

        if ((0, _accessors.accessor)(event, allDayAccessor) || _dates2.default.isJustDate(eStart) && _dates2.default.isJustDate(eEnd) || !showMultiDayTimes && !_dates2.default.eq(eStart, eEnd, 'day')) {
          allDayEvents.push(event);
        } else {
          rangeEvents.push(event);
        }
      }
    });

    allDayEvents.sort(function (a, b) {
      return (0, _eventLevels.sortEvents)(a, b, _this3.props);
    });

    var gutterRef = function gutterRef(ref) {
      return _this3._gutters[1] = ref && (0, _reactDom.findDOMNode)(ref);
    };

    var eventsRendered = this.renderEvents(range, rangeEvents, getNow(), resources || [null]);

    return _react2.default.createElement(
      'div',
      { className: 'rbc-time-view' },
      this.renderHeader(range, allDayEvents, width, resources),
      _react2.default.createElement(
        'div',
        { ref: 'content', className: 'rbc-time-content' },
        _react2.default.createElement(_TimeColumn2.default, _extends({}, this.props, {
          showLabels: true,
          style: { width: width },
          ref: gutterRef,
          className: 'rbc-time-gutter'
        })),
        eventsRendered,
        _react2.default.createElement('div', { ref: 'timeIndicator', className: 'rbc-current-time-indicator' })
      )
    );
  };

  TimeGrid.prototype.renderEvents = function renderEvents(range, events, today, resources) {
    var _this4 = this;

    var _props3 = this.props,
        min = _props3.min,
        max = _props3.max,
        endAccessor = _props3.endAccessor,
        startAccessor = _props3.startAccessor,
        resourceAccessor = _props3.resourceAccessor,
        resourceIdAccessor = _props3.resourceIdAccessor,
        components = _props3.components;


    return range.map(function (date, idx) {
      var daysEvents = events.filter(function (event) {
        return _dates2.default.inRange(date, (0, _accessors.accessor)(event, startAccessor), (0, _accessors.accessor)(event, endAccessor), 'day');
      });

      return resources.map(function (resource, id) {
        var eventsToDisplay = !resource ? daysEvents : daysEvents.filter(function (event) {
          return (0, _accessors.accessor)(event, resourceAccessor) === (0, _accessors.accessor)(resource, resourceIdAccessor);
        });

        return _react2.default.createElement(_DayColumn2.default, _extends({}, _this4.props, {
          min: _dates2.default.merge(date, min),
          max: _dates2.default.merge(date, max),
          resource: resource && resource.id,
          eventComponent: components.event,
          eventWrapperComponent: components.eventWrapper,
          dayWrapperComponent: components.dayWrapper,
          className: (0, _classnames2.default)({ 'rbc-now': _dates2.default.eq(date, today, 'day') }),
          style: (0, _eventLevels.segStyle)(1, _this4.slots),
          key: idx + '-' + id,
          date: date,
          events: eventsToDisplay
        }));
      });
    });
  };

  TimeGrid.prototype.renderHeader = function renderHeader(range, events, width, resources) {
    var _this5 = this;

    var _props4 = this.props,
        messages = _props4.messages,
        rtl = _props4.rtl,
        selectable = _props4.selectable,
        components = _props4.components,
        getNow = _props4.getNow;

    var _ref = this.state || {},
        isOverflowing = _ref.isOverflowing;

    var style = {};
    if (isOverflowing) style[rtl ? 'marginLeft' : 'marginRight'] = (0, _scrollbarSize2.default)() + 'px';

    var headerRendered = resources ? this.renderHeaderResources(range, resources) : (0, _messages2.default)(messages).allDay;

    return _react2.default.createElement(
      'div',
      {
        ref: 'headerCell',
        className: (0, _classnames2.default)('rbc-time-header', isOverflowing && 'rbc-overflowing'),
        style: style
      },
      _react2.default.createElement(
        'div',
        { className: 'rbc-row' },
        _react2.default.createElement('div', { className: 'rbc-label rbc-header-gutter', style: { width: width } }),
        this.renderHeaderCells(range)
      ),
      resources && _react2.default.createElement(
        'div',
        { className: 'rbc-row rbc-row-resource' },
        _react2.default.createElement('div', { className: 'rbc-label rbc-header-gutter', style: { width: width } }),
        headerRendered
      ),
      _react2.default.createElement(
        'div',
        { className: 'rbc-row' },
        _react2.default.createElement(
          'div',
          {
            ref: function ref(_ref2) {
              return _this5._gutters[0] = _ref2;
            },
            className: 'rbc-label rbc-header-gutter',
            style: { width: width }
          },
          (0, _messages2.default)(messages).allDay
        ),
        _react2.default.createElement(_DateContentRow2.default, {
          getNow: getNow,
          minRows: 2,
          range: range,
          rtl: this.props.rtl,
          events: events,
          className: 'rbc-allday-cell',
          selectable: selectable,
          onSelectSlot: this.handleSelectAllDaySlot,
          dateCellWrapper: components.dateCellWrapper,
          dayPropGetter: this.props.dayPropGetter,
          eventComponent: this.props.components.event,
          eventWrapperComponent: this.props.components.eventWrapper,
          titleAccessor: this.props.titleAccessor,
          tooltipAccessor: this.props.tooltipAccessor,
          startAccessor: this.props.startAccessor,
          endAccessor: this.props.endAccessor,
          allDayAccessor: this.props.allDayAccessor,
          eventPropGetter: this.props.eventPropGetter,
          selected: this.props.selected,
          isAllDay: true,
          onSelect: this.handleSelectEvent,
          onDoubleClick: this.handleDoubleClickEvent,
          longPressThreshold: this.props.longPressThreshold
        })
      )
    );
  };

  TimeGrid.prototype.renderHeaderResources = function renderHeaderResources(range, resources) {
    var _this6 = this;

    var _props5 = this.props,
        resourceTitleAccessor = _props5.resourceTitleAccessor,
        getNow = _props5.getNow;

    var today = getNow();
    return range.map(function (date, i) {
      return resources.map(function (resource, j) {
        return _react2.default.createElement(
          'div',
          {
            key: i + '-' + j,
            className: (0, _classnames2.default)('rbc-header', _dates2.default.eq(date, today, 'day') && 'rbc-today'),
            style: (0, _eventLevels.segStyle)(1, _this6.slots)
          },
          _react2.default.createElement(
            'span',
            null,
            (0, _accessors.accessor)(resource, resourceTitleAccessor)
          )
        );
      });
    });
  };

  TimeGrid.prototype.renderHeaderCells = function renderHeaderCells(range) {
    var _this7 = this;

    var _props6 = this.props,
        dayFormat = _props6.dayFormat,
        culture = _props6.culture,
        components = _props6.components,
        dayPropGetter = _props6.dayPropGetter,
        getDrilldownView = _props6.getDrilldownView,
        getNow = _props6.getNow;

    var HeaderComponent = components.header || _Header2.default;
    var today = getNow();

    return range.map(function (date, i) {
      var drilldownView = getDrilldownView(date);
      var label = _localizer2.default.format(date, dayFormat, culture);

      var _ref3 = dayPropGetter && dayPropGetter(date) || {},
          className = _ref3.className,
          dayStyles = _ref3.style;

      var header = _react2.default.createElement(HeaderComponent, {
        date: date,
        label: label,
        localizer: _localizer2.default,
        format: dayFormat,
        culture: culture
      });

      return _react2.default.createElement(
        'div',
        {
          key: i,
          className: (0, _classnames2.default)('rbc-header', className, _dates2.default.eq(date, today, 'day') && 'rbc-today'),
          style: _extends({}, dayStyles, (0, _eventLevels.segStyle)(1, _this7.slots))
        },
        drilldownView ? _react2.default.createElement(
          'a',
          {
            href: '#',
            onClick: function onClick(e) {
              return _this7.handleHeaderClick(date, drilldownView, e);
            }
          },
          header
        ) : _react2.default.createElement(
          'span',
          null,
          header
        )
      );
    });
  };

  TimeGrid.prototype.handleHeaderClick = function handleHeaderClick(date, view, e) {
    e.preventDefault();
    (0, _helpers.notify)(this.props.onDrillDown, [date, view]);
  };

  TimeGrid.prototype.handleSelectEvent = function handleSelectEvent() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (0, _helpers.notify)(this.props.onSelectEvent, args);
  };

  TimeGrid.prototype.handleDoubleClickEvent = function handleDoubleClickEvent() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (0, _helpers.notify)(this.props.onDoubleClickEvent, args);
  };

  TimeGrid.prototype.handleSelectAlldayEvent = function handleSelectAlldayEvent() {
    //cancel any pending selections so only the event click goes through.
    this.clearSelection();

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    (0, _helpers.notify)(this.props.onSelectEvent, args);
  };

  TimeGrid.prototype.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  TimeGrid.prototype.measureGutter = function measureGutter() {
    var width = this.state.gutterWidth;
    var gutterCells = this._gutters;

    if (!width) {
      width = Math.max.apply(Math, gutterCells.map(_width2.default));

      if (width) {
        this.setState({ gutterWidth: width });
      }
    }
  };

  TimeGrid.prototype.applyScroll = function applyScroll() {
    if (this._scrollRatio) {
      var content = this.refs.content;

      content.scrollTop = content.scrollHeight * this._scrollRatio;
      // Only do this once
      this._scrollRatio = null;
    }
  };

  TimeGrid.prototype.calculateScroll = function calculateScroll() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
    var min = props.min,
        max = props.max,
        scrollToTime = props.scrollToTime;


    var diffMillis = scrollToTime - _dates2.default.startOf(scrollToTime, 'day');
    var totalMillis = _dates2.default.diff(max, min);

    this._scrollRatio = diffMillis / totalMillis;
  };

  TimeGrid.prototype.positionTimeIndicator = function positionTimeIndicator() {
    var _props7 = this.props,
        rtl = _props7.rtl,
        min = _props7.min,
        max = _props7.max,
        getNow = _props7.getNow;

    var current = getNow();

    var secondsGrid = _dates2.default.diff(max, min, 'seconds');
    var secondsPassed = _dates2.default.diff(current, min, 'seconds');

    var timeIndicator = this.refs.timeIndicator;
    var factor = secondsPassed / secondsGrid;
    var timeGutter = this._gutters[this._gutters.length - 1];

    if (timeGutter && current >= min && current <= max) {
      var pixelHeight = timeGutter.offsetHeight;
      var offset = Math.floor(factor * pixelHeight);

      timeIndicator.style.display = 'block';
      timeIndicator.style[rtl ? 'left' : 'right'] = 0;
      timeIndicator.style[rtl ? 'right' : 'left'] = timeGutter.offsetWidth + 'px';
      timeIndicator.style.top = offset + 'px';
    } else {
      timeIndicator.style.display = 'none';
    }
  };

  TimeGrid.prototype.triggerTimeIndicatorUpdate = function triggerTimeIndicatorUpdate() {
    var _this8 = this;

    // Update the position of the time indicator every minute
    this._timeIndicatorTimeout = window.setTimeout(function () {
      _this8.positionTimeIndicator();

      _this8.triggerTimeIndicatorUpdate();
    }, 60000);
  };

  return TimeGrid;
}(_react.Component);

TimeGrid.propTypes = {
  events: _propTypes2.default.array.isRequired,
  resources: _propTypes2.default.array,

  step: _propTypes2.default.number,
  range: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
  min: _propTypes2.default.instanceOf(Date),
  max: _propTypes2.default.instanceOf(Date),
  getNow: _propTypes2.default.func.isRequired,

  scrollToTime: _propTypes2.default.instanceOf(Date),
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  dayFormat: _propTypes3.dateFormat,
  showMultiDayTimes: _propTypes2.default.bool,
  culture: _propTypes2.default.string,

  rtl: _propTypes2.default.bool,
  width: _propTypes2.default.number,

  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,
  resourceAccessor: _propTypes3.accessor.isRequired,

  resourceIdAccessor: _propTypes3.accessor.isRequired,
  resourceTitleAccessor: _propTypes3.accessor.isRequired,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onNavigate: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func,
  onSelectEnd: _propTypes2.default.func,
  onSelectStart: _propTypes2.default.func,
  onSelectEvent: _propTypes2.default.func,
  onDoubleClickEvent: _propTypes2.default.func,
  onDrillDown: _propTypes2.default.func,
  getDrilldownView: _propTypes2.default.func.isRequired,

  messages: _propTypes2.default.object,
  components: _propTypes2.default.object.isRequired
};
TimeGrid.defaultProps = {
  step: 30,
  min: _dates2.default.startOf(new Date(), 'day'),
  max: _dates2.default.endOf(new Date(), 'day'),
  scrollToTime: _dates2.default.startOf(new Date(), 'day'),
  /* this is needed to satisfy requirements from TimeColumn required props
   * There is a strange bug in React, using ...TimeColumn.defaultProps causes weird crashes
   */
  type: 'gutter'
};
exports.default = TimeGrid;
module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(768),
    keys = __webpack_require__(71);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundWrapper = function (_React$Component) {
  _inherits(BackgroundWrapper, _React$Component);

  function BackgroundWrapper() {
    _classCallCheck(this, BackgroundWrapper);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  BackgroundWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return BackgroundWrapper;
}(_react2.default.Component);

BackgroundWrapper.propTypes = {
  children: _propTypes2.default.element,
  value: _propTypes2.default.instanceOf(Date),
  range: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date))
};

exports.default = BackgroundWrapper;
module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(356);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(193);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(376);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(377);
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(379);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(380);
/* unused harmony reexport IndexRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(194);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(33);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(115);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(117);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(382);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(198);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(49);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(387);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(388);
/* unused harmony reexport browserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(195);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(374);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(116);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(62);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(383);

var _runTransitionHook = __webpack_require__(118);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(50);

var _PathUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(118);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(198);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(202);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(403);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32), __webpack_require__(402)(module)))

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(206);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(122);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Header__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Left__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_Footer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Rqulinks__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_Qlinks__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_Contbtm__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__learning_records_MyJourney__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__learning_records_MyJourneyDemo__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__learning_records_MyDiary__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__learning_records_my_performance_MyPerformance__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__learning_records_my_performance_MyPerformanceDemo__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__learning_records_my_performance_AssessementComp__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__learning_records_recap_Recap__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__learning_records_LoginHistory__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lr_dlr_components_Componetlist__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lr_dlr_components_Anouncement__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__my_profile_MyProfile__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__learning_resources_Courseware__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__learning_resources_library_Mylibrary__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__personal_interactions_iseek_IseekFeedback__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__personal_interactions_observer_MyObserver__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__personal_interactions_technical_support_TechSupport__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__personal_interactions_telecall_request_TelecallRequest__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__personal_interactions_messages_PersonalMessages__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__personal_interactions_ecoach_Ecoach__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__personal_interactions_ecoach_request_ChatRequest__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__group_interactions_OpinionPoll__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__group_interactions_Collaborate__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__challenge_score_card_Challenge__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__practice_PracticeNokia__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__xrecap_XRecap__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__practice_DatewiseComp__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__practice_PracticewiseComp__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__lr_dlr_components_Notes__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__lr_dlr_components_EcProfile__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__radio_Radio__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__lr_dlr_components_Careerlauncherrc__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_geolocation__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__actions_newPostAction__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var Main=function(_Component){_inherits(Main,_Component);function Main(props){_classCallCheck(this,Main);var _this=_possibleConstructorReturn(this,(Main.__proto__||Object.getPrototypeOf(Main)).call(this,props));_this.getsetStatus=function(val){_this.setState({statusBuddyChat:val});// if(val !== ''){
// 	this.refs.RqUpdate.changeStatus(val);
// 	this.refs.BotUpdate.changeStatus(val);
// }
};_this.passLrid=_this.passLrid.bind(_this);_this.getPostions=_this.getPostions.bind(_this);_this.state={contentPanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__lr_dlr_components_Componetlist__["a" /* default */],{switchPanel:_this.passLrid,lr_id:'0',dlr_id:'0'}),leftPanel:"big",defaultLrID:__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]('defaultLRID',true)!=undefined?__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]('defaultLRID',true):0,page_id:'',fnHideCorporateIDs:__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]('fnHideCorporateIDs',true),changed_status:'',statusBuddyChat:__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]("statusBuddyChat",true)!=false?__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]("statusBuddyChat",true):0,cprofile:""};return _this;}_createClass(Main,[{key:'getPostions',value:function getPostions(obj){var coords=obj.coords;fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng='+coords.latitude+','+coords.longitude+'&sensor=true',{method:'GET'}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status=='OK'){if(__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["m" /* isset */](responseJson.results[0])){localStorage.setItem("geo_location"+__WEBPACK_IMPORTED_MODULE_9__config_Config__["c" /* app_name */],responseJson.results[0].formatted_address);}}});}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;document.body.id="bodyid";document.body.className="";setTimeout(function(){jQuery(document).on("click",":not(.cont-btm, .top-links, #qlinks, #qlinks1,select#cmbStatus,#statusforms *)",function(e){jQuery('.cont-btm ul li').each(function($){jQuery(this).find(".f-popup").slideUp();jQuery(this).find("a").removeClass('act-tab');});jQuery('aside').each(function($){jQuery(this).removeClass('opened');});e.stopPropagation();});jQuery('select#cmbStatus,#statusforms,input#jquerysubject,textarea#jqueryquery,input#jqueryfile').click(function(event){event.stopPropagation();});jQuery('.cont-btm, .top-links, #qlinks, #qlinks1').click(function(event){if(jQuery(event.target).hasClass('cntbtm')){if(jQuery(event.target).parent().find(".f-popup").css('display')=='none'){jQuery('.cont-btm ul li').each(function($){jQuery(this).find(".f-popup").slideUp();jQuery(this).find("a").removeClass('act-tab');});var currentPopUpHeight=jQuery(event.target).parent().find(".f-popup").height();// jQuery(event.target).parent().find( ".f-popup" ).css({"height":+currentPopUpHeight+'px'});
jQuery(event.target).parent().find(".f-popup").slideToggle();jQuery(event.target).addClass('act-tab');}else{jQuery(event.target).parent().find(".f-popup").slideUp();jQuery(event.target).removeClass('act-tab');}event.stopPropagation();}else if(jQuery(jQuery(event.target).parent()).hasClass('slide-out')){if(jQuery(event.target).parent().hasClass('opened')){jQuery(event.target).parent().removeClass('opened');}else{jQuery('aside').each(function(){jQuery(this).removeClass('opened');});jQuery(event.target).parent().addClass('opened');}event.stopPropagation();}});},500);//new post call every 30 mins 
// setTimeout(() => {setInterval(() => {this.props.getNewPost();},1800000)},1800000);
//new post call every 6hr
setTimeout(function(){setInterval(function(){_this2.props.getNewPost();},21600000);},21600000);}},{key:'defaultComponents',value:function defaultComponents(){this.setState({contentPanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__lr_dlr_components_Componetlist__["a" /* default */],{switchPanel:this.passLrid,key:'default_0',lr_id:'0',dlr_id:'0'}),leftPanel:"big"});// Common.showLargeLeftMenu();
}// onChangeProf(val){
//   this.refs.headerUpdate.updatePhoto(val);
// }
},{key:'passLrid',value:function passLrid(type){var lr_id=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var dlr_id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";this.setRouteContentPanel(type,lr_id,dlr_id);}},{key:'headerMenu',value:function headerMenu(type){this.setRouteContentPanel(type);}},{key:'getSentmessage',value:function getSentmessage(new_msg){// this.setState({message : new_msg});
// this.refs.headerUpdate.updateMessage(new_msg);
this.refs.RqUpdate.updateMessage(new_msg);this.refs.BotUpdate.updateMessage(new_msg);//this.props.inboxUnread(new_msg);
}// getopinion(count_poll){
//   this.refs.BotUpdate.updateOpinion(count_poll);
// }
},{key:'setRouteContentPanel',value:function setRouteContentPanel(type){var _this3=this;var lr_id=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var dlr_id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";jQuery('.slide-out').removeClass('opened');if(type=="Challenge"||type=="PracticeNokia"||type=="practice_datewise"||type=='practice_score'){jQuery(".leftposstatic").css('display','none');}else{jQuery(".leftposstatic").css('display','block');}// alert(type);
var panel=this.state.contentPanel;var leftPanel=this.state.leftPanel;switch(type){case'componet_list':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__lr_dlr_components_Componetlist__["a" /* default */],{key:Date.now(),switchPanel:this.passLrid,lr_id:lr_id,dlr_id:dlr_id});leftPanel='big';break;case'my_journey':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__learning_records_MyJourney__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'my_journey_demo':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__learning_records_MyJourneyDemo__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'seek_notes':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__lr_dlr_components_Notes__["a" /* default */],{type:'seek_notes'});leftPanel='small';break;case'sharek_notes':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__lr_dlr_components_Notes__["a" /* default */],{type:'sharek_notes'});leftPanel='small';break;case'share_requests':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__lr_dlr_components_Notes__["a" /* default */],{type:'share_requests'});leftPanel='small';break;case'all_notes':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__lr_dlr_components_Notes__["a" /* default */],{type:'all_notes'});leftPanel='small';break;case'my_diary':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__learning_records_MyDiary__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'my_performance':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__learning_records_my_performance_MyPerformance__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'my_performance_demo':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__learning_records_my_performance_MyPerformanceDemo__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'recap':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__learning_records_recap_Recap__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'my_profile':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__my_profile_MyProfile__["a" /* default */],null);leftPanel='small';break;case'Observers':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__personal_interactions_observer_MyObserver__["a" /* default */],null);leftPanel='small';break;case'login_history':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__learning_records_LoginHistory__["a" /* default */],null);leftPanel='small';break;case'Seekfeedback':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__personal_interactions_iseek_IseekFeedback__["a" /* default */],null);leftPanel='small';break;case'ecoach':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__personal_interactions_ecoach_Ecoach__["a" /* default */],null);leftPanel='small';break;case'chat_request':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__personal_interactions_ecoach_request_ChatRequest__["a" /* default */],null);leftPanel='small';break;case'courseware':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__learning_resources_Courseware__["a" /* default */],null);leftPanel='small';break;case'library':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__learning_resources_library_Mylibrary__["a" /* default */],null);leftPanel='small';break;case'Techsupport':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__personal_interactions_technical_support_TechSupport__["a" /* default */],null);leftPanel='small';break;case'Telecall':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__personal_interactions_telecall_request_TelecallRequest__["a" /* default */],null);leftPanel='small';break;case'messages':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__personal_interactions_messages_PersonalMessages__["a" /* default */],null);leftPanel='small';break;case'opinion_poll':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__group_interactions_OpinionPoll__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'collaborate':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__group_interactions_Collaborate__["a" /* default */],{switchPanel:this.passLrid});leftPanel='small';break;case'radio':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__radio_Radio__["a" /* default */],null);leftPanel='small';break;case'anouncement':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__lr_dlr_components_Anouncement__["a" /* default */],{lr_id:lr_id,dlr_id:dlr_id});leftPanel='big';break;case'Challenge':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__challenge_score_card_Challenge__["a" /* default */],null);leftPanel='small';break;case'PracticeNokia':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__practice_PracticeNokia__["a" /* default */],{switchPanel:function switchPanel(e){return _this3.setRouteContentPanel(e);}});leftPanel='small';break;case'Xrecap':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__xrecap_XRecap__["a" /* default */],null);leftPanel='small';break;case'practice_datewise':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__practice_DatewiseComp__["a" /* default */],{switchPanel:function switchPanel(e){return _this3.setRouteContentPanel(e);}});leftPanel='small';break;case'practice_score':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__practice_PracticewiseComp__["a" /* default */],{switchPanel:function switchPanel(e){return _this3.setRouteContentPanel(e);}});leftPanel='small';break;case'ec_profile':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__lr_dlr_components_EcProfile__["a" /* default */],null);leftPanel='small';break;case'assessement_status':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__learning_records_my_performance_AssessementComp__["a" /* default */],null);leftPanel='small';break;}this.setState({contentPanel:panel,leftPanel:leftPanel,cprofile:type});setTimeout(function(){if(leftPanel=='small'){__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["e" /* contentResizeLoad */]();}else{__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["A" /* showLargeLeftMenu */]();__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["e" /* contentResizeLoad */]();}},500);}},{key:'isSessionExist',value:function isSessionExist(){if(!__WEBPACK_IMPORTED_MODULE_8__helpers_User__["e" /* isLoggedIn */]()){this.props.router.push("login");}}},{key:'clback',value:function clback(){this.setState({cprofile:""});}},{key:'render',value:function render(){var _this4=this;this.isSessionExist();var practiceCorner=__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]("practiceCorner",true);var practiceCornerMini=__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]("practiceCornerMini",true);var challenge_score=__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]('challenge_score',true);var xrecap_id=__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]('xrecap_id',true);var is_careerlauncher=__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["i" /* getUserData */]('is_careerlauncher',true);var practice_nokia='';if(practiceCorner!=false){practice_nokia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:xrecap_id!=''||xrecap_id!=0?"getpractice practice_minii":"getpractice practice_minii",href:'javascript:void(0);',onClick:function onClick(e){return _this4.setRouteContentPanel('PracticeNokia');},title:'Practice Corner Mini'});}else if(practiceCornerMini!=false){practice_nokia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:xrecap_id!=''||xrecap_id!=0?"getpractice practice_minii":"getpractice practice_minii",href:'javascript:void(0);',onClick:function onClick(e){return _this4.setRouteContentPanel('PracticeNokia');},title:'Practice Corner Mini'});}else{}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'361_wall_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_react_geolocation__["a" /* default */],{onSuccess:this.getPostions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'window_trans'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'page'},!is_careerlauncher&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.state.fnHideCorporateIDs===false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Rqulinks__["a" /* default */],{ref:'RqUpdate',setStatusUpdate:this.getsetStatus,statusBuddyChat:this.state.statusBuddyChat,switchPanel:function switchPanel(e){return _this4.setRouteContentPanel(e);}}),practice_nokia,xrecap_id!=''||xrecap_id!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{zIndex:'999'},className:'getxpractice practiceback',href:'javascript:void(0);',onClick:function onClick(e){return _this4.setRouteContentPanel('Xrecap');},title:'Recaps'}):'',challenge_score>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'getchallenge challengeback',href:'javascript:void(0);',onClick:function onClick(e){return _this4.setRouteContentPanel('Challenge');},title:'Challenge Score Card'}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_Qlinks__["a" /* default */],{switchPanel:function switchPanel(e){return _this4.setRouteContentPanel(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__partials_Header__["a" /* default */],{switchPanel:function switchPanel(){return _this4.defaultComponents();},menuClick:function menuClick(e){return _this4.headerMenu(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent fixed_cont',id:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__partials_Left__["a" /* default */],{leftMenuType:this.state.leftPanel,onClick:this.passLrid}),this.state.contentPanel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_Contbtm__["a" /* default */],{ref:'BotUpdate',setStatusUpdate:this.getsetStatus,statusBuddyChat:this.state.statusBuddyChat,switchPanel:function switchPanel(e){return _this4.setRouteContentPanel(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__partials_Footer__["a" /* default */],null)),is_careerlauncher&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_Qlinks__["a" /* default */],{switchPanel:function switchPanel(e){return _this4.setRouteContentPanel(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__partials_Header__["a" /* default */],{switchPanel:function switchPanel(e){return _this4.defaultComponents();},menuClick:function menuClick(e){return _this4.headerMenu(e);}}),this.state.cprofile!="my_profile"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent fixed_cont',id:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__lr_dlr_components_Careerlauncherrc__["a" /* default */],null)),this.state.cprofile=="my_profile"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent fixed_cont carrlan',id:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completedcomp cldiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/smctick.png'}),' \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.clback();}},'\xA0 Click here to Go Back')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__my_profile_MyProfile__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__partials_Footer__["a" /* default */],null))));}}]);return Main;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_43_redux__["b" /* bindActionCreators */])({getNewPost:__WEBPACK_IMPORTED_MODULE_44__actions_newPostAction__["a" /* getNewPost */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_42_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Main));

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Dmwall=function(_Component){_inherits(Dmwall,_Component);function Dmwall(props){_classCallCheck(this,Dmwall);var _this=_possibleConstructorReturn(this,(Dmwall.__proto__||Object.getPrototypeOf(Dmwall)).call(this,props));_this.state={groupTopPerformers:[],productTopPerformers:[],universalTopPerformers:[],birthdayList:[],buddyAjaxCallCompleted:false};return _this;}_createClass(Dmwall,[{key:'getWallPerformers',value:function getWallPerformers(){var _this2=this;$("#performerLoader").show();fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"getwall-performers",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({learner_id:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){$("#performerLoader").hide();if(responseJson.status!==0){_this2.setState({groupTopPerformers:responseJson.groupTopPerformers,productTopPerformers:responseJson.productTopPerformers,universalTopPerformers:responseJson.universalTopPerformers});}});}},{key:'getWallBuddiesBirthday',value:function getWallBuddiesBirthday(){var _this3=this;$("#birthdayLoader").show();fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"getwall-birthday",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({learner_id:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){$("#birthdayLoader").hide();if(responseJson.status!==0){_this3.setState({buddyAjaxCallCompleted:true,birthdayList:responseJson.birthdayList});}});}},{key:'loadWallData',value:function loadWallData(){this.getWallPerformers();this.getWallBuddiesBirthday();}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.autoload){this.getWallPerformers();this.getWallBuddiesBirthday();}$('.owl-carousel').owlCarousel({loop:true,items:3,dots:false,nav:true,margin:15,autoplay:true,autoplayTimeout:3500,autoplayHoverPause:true,responsive:{0:{items:1,margin:0},640:{items:1,margin:15},768:{items:3,margin:15},1024:{items:4}}});$(".top-perform h1").attr('style','font-family: "Great Vibes", cursive !important');}},{key:'render',value:function render(){var d=new Date(),jYear=d.getFullYear();var topPerformerHtml1=this.state.groupTopPerformers.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:val.photoPath,alt:''}),val.name!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-name'},val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-product'},val.product)),val.name!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-group'},'GROUP TOP PERFORMER'),val.name===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-group'},'NO GROUP TOP PERFORMER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-corporate'},val.corporate));});var topPerformerHtml2=this.state.productTopPerformers.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:val.photoPath,alt:''}),val.name!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-name'},val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-product'},val.product)),val.name!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-group'},'PRODUCT TOP PERFORMER'),val.name===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-group'},'NO PRODUCT TOP PERFORMER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-corporate'},val.corporate));});var topPerformerHtml3=this.state.universalTopPerformers.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:val.photoPath,alt:''}),val.name!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-name'},val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-product'},val.product)),val.name!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-group'},'UNIVERSAL TOP PERFORMER'),val.name===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-group'},'NO UNIVERSAL TOP PERFORMER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-corporate'},val.corporate));});var birthdayHtml=this.state.birthdayList.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:val.photoPath,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-name'},val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'performer-product'},val.email));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-pad'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo wall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo-361dm-180x62.png',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-perform'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Top Performers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'owl-carousel-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'performerLoader',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/loader.gif',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'owl-carousel'},topPerformerHtml1,topPerformerHtml2,topPerformerHtml3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'birthday-today'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/gift-box.png',className:'gift-box',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Birthdays Today',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true))),this.state.buddyAjaxCallCompleted&&this.state.birthdayList.length<=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'b-day-not'},'No buddies found!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'owl-carousel-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'birthdayLoader',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/loader.gif',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'owl-carousel'},birthdayHtml)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'foot-pad'},' \xA9 ',jYear,'. www.361DM.com All rights reserved'));}}]);return Dmwall;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Dmwall);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Fr=window.Fr;var timerinc=void 0;var RecordPlayer=function(_Component){_inherits(RecordPlayer,_Component);function RecordPlayer(props){_classCallCheck(this,RecordPlayer);var _this=_possibleConstructorReturn(this,(RecordPlayer.__proto__||Object.getPrototypeOf(RecordPlayer)).call(this,props));_this.state={timer:"00:00:00",displayareas:'1',audiosrc:'',discardvoice:false};return _this;}_createClass(RecordPlayer,[{key:'formatTime',value:function formatTime(seconds){var hours=Math.floor(seconds/60);hours=hours>=10?hours:"0"+hours;var minutes=Math.floor(seconds/60);minutes=minutes>=10?minutes:"0"+minutes;seconds=Math.floor(seconds%60);seconds=seconds>=10?seconds:"0"+seconds;return hours+":"+minutes+":"+seconds;}},{key:'recordoption_fn',value:function recordoption_fn(){// console.log("recordoption_fn");
if(typeof timerinc!=='undefined')clearInterval(timerinc);var thisref=this;thisref.setState({timer:"00:00:00",discardvoice:false});Fr.voice.record($("#record").is(":checked"),function(){// recordid.hide();    
// pauseid.show();
thisref.setState({displayareas:'2'});setTimeout(function(){timerinc=setInterval(function(){//console.log("===loop 1==");
var time_shown=thisref.state.timer;var time_chunks=time_shown.split(":");var hour=void 0,mins=void 0,secs=void 0;hour=Number(time_chunks[0]);mins=Number(time_chunks[1]);secs=Number(time_chunks[2]);secs++;if(secs==60){secs=0;mins=mins+1;}if(mins==60){mins=0;hour=hour+1;}hour=hour+'';if(hour<10){hour="0"+hour;}mins=mins+'';if(mins<10){mins="0"+mins;}secs=secs+'';if(secs<10){secs="0"+secs;}thisref.setState({timer:hour+":"+mins+":"+secs});},1000);},1500);});}},{key:'recordpauseoption_fn',value:function recordpauseoption_fn(){// console.log("recordpauseoption_fn");
if(typeof timerinc!=='undefined')clearInterval(timerinc);Fr.voice.pause();this.setState({timer:"00:00:00",displayareas:'3'});}},{key:'recordplayoption_fn',value:function recordplayoption_fn(){//console.log("recordplayoption_fn");
if(typeof timerinc!=='undefined')clearInterval(timerinc);var thisref=this;Fr.voice.export(function(url){thisref.setState({audiosrc:url,displayareas:'5',discardvoice:true});$("#audio").attr("src",url);},"URL");setTimeout(function(){if(typeof timerinc!=='undefined')clearInterval(timerinc);$("#audio")[0].play();timerinc=setInterval(function(){// console.log("===loop 2==");
var aud=$("#audio")[0];var timing=thisref.formatTime(aud.currentTime);if(thisref.formatTime(aud.duration)<=timing){clearInterval(timerinc);thisref.setState({displayareas:'3',timer:"00:00:00"});}else thisref.setState({timer:timing});},500);},500);}},{key:'recordplayagain_fn',value:function recordplayagain_fn(){//console.log("recordplayagain_fn");
if(typeof timerinc!=='undefined')clearInterval(timerinc);var thisref=this;thisref.setState({displayareas:'5',discardvoice:true});setTimeout(function(){if(typeof timerinc!=='undefined')clearInterval(timerinc);$("#audio")[0].play();timerinc=setInterval(function(){//console.log("===loop 3==");
var aud=$("#audio")[0];var timing=thisref.formatTime(aud.currentTime);if(thisref.formatTime(aud.duration)<=timing){clearInterval(timerinc);thisref.setState({displayareas:'3',timer:"00:00:00"});}else thisref.setState({timer:timing});},500);},500);}},{key:'recordplaypause_fn',value:function recordplaypause_fn(){//console.log("recordplaypause_fn");
var aud=$("#audio")[0];aud.pause();if(typeof timerinc!=='undefined')clearInterval(timerinc);this.setState({displayareas:'4',discardvoice:true});if(this.formatTime(aud.duration)<=this.formatTime(aud.currentTime)){this.setState({timer:"00:00:00"});}}},{key:'recorddiscard_fn',value:function recorddiscard_fn(){//console.log("recorddiscard_fn");
if(typeof timerinc!=='undefined')clearInterval(timerinc);Fr.voice.stop();if($("#audio")[0])$("#audio")[0].pause();this.setState({discardvoice:false,audiosrc:'',displayareas:'1',timer:"00:00:00"});}},{key:'render',value:function render(){var _this2=this;var displayareas=this.state.displayareas;var discardvoice=this.state.discardvoice;return(//  <div data-type="mp3" className="recordPlayer">
//   <ul className="btn-ul">
//    <li>
//    <a id="record" className="button recordButton" style={{borderRadius: "25px",padding:"10px 40px",marginLeft:"50px"}}><i className="fa fa-microphone"></i>Record</a>
//    </li>
//    <li><a id="pause" className="button ply-btn " style={{display:"none",borderRadius: "25px",padding:"10px 40px"}}> <i className="fa fa-pause"></i> Pause </a> <a id="play" className="button ply-btn" style={{display:"none",borderRadius:"25px",padding:"10px 40px"}} > <i className=" fa fa-play"></i>Play</a></li>
//    <li className="widht-100">
//    <audio className="audio-btm" id="audio" controlsList="nodownload" controls></audio>
//    </li>
//   </ul>
//   </div>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wav-tst'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'wav',className:'wave-new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'audiotimedur'},this.state.timer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button recordButton',style:{display:displayareas=='1'?'':'none'},id:'record',onClick:function onClick(e){return _this2.recordoption_fn();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'caption'},'Record Audio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'pause',style:{'display':displayareas=='2'?'':'none'},onClick:function onClick(e){return _this2.recordpauseoption_fn();}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-pause'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'caption'},'Stop Recording'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{'display':displayareas=='3'?'':'none'},id:'play',onClick:function onClick(e){return _this2.recordplayoption_fn();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'caption'},'Play Audio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'playagain',style:{display:displayareas=='4'?'':'none'},id:'playagain',onClick:function onClick(e){return _this2.recordplayagain_fn();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-play'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'caption'},'Play Audio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'playpause',onClick:function onClick(e){return _this2.recordplaypause_fn();},style:{display:displayareas=='5'?'':'none'},id:'playpause'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-pause'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'caption'},'Pause Audio')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:'',id:'audio',style:{display:'none',position:'relative'},src:this.state.audiosrc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{'clear':'both'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'discardvoice',onClick:function onClick(e){return _this2.recorddiscard_fn();},style:{display:discardvoice?'':'none'}},'Discard'))))));}}]);return RecordPlayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RecordPlayer);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var NoticeBoard=function(_Component){_inherits(NoticeBoard,_Component);function NoticeBoard(props){_classCallCheck(this,NoticeBoard);var _this=_possibleConstructorReturn(this,(NoticeBoard.__proto__||Object.getPrototypeOf(NoticeBoard)).call(this,props));_this.state={noticeboard:[],count:0,noticecount:0};return _this;}_createClass(NoticeBoard,[{key:'getNoticeBoard',value:function getNoticeBoard(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("productID",true);var fullName=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("fullName",true);var corpID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("corporateID",true);var pinID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("pinID",true);// let productID = 209;
// let pinID = 149;
// let corpID = 11;
fetch(__WEBPACK_IMPORTED_MODULE_5__config_Config__["d" /* domainUrl */]+'left/notice-board',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,lr_product:productID,fullName:fullName,corpID:corpID,pinID:pinID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
_this2.setState({noticeboard:responseJson.noticeboards,noticecount:responseJson.noticecount});});}},{key:'componentDidMount',value:function componentDidMount(){this.getNoticeBoard();}},{key:'render',value:function render(){var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('corporateID',true);var noticeboards=null;var Webview=this.props.Webview;if(this.state.noticeboard!=undefined||this.state.noticeboard!=null){noticeboards=this.state.noticeboard.map(function(notices,keys){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'noticed_'+keys,dangerouslySetInnerHTML:{__html:notices}});});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide1'},Webview===undefined&&Webview!=='webview'&&corporateID!=77&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handle',href:'javascript:void(0);',id:'noticeboard'},'Notice Board'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/img1.jpg',align:'texttop',alt:'',border:'0'}),' Notice Board'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'400px',overflow:'hidden !important',float:'left',width:'100%',overflowY:'scroll'}},noticeboards),Webview===undefined&&Webview!=='webview'&&corporateID!=77&&this.state.noticecount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge-noticeboard','data-badge':this.state.noticecount}):'');}}]);return NoticeBoard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NoticeBoard);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_newPostAction__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var NewPost=function(_Component){_inherits(NewPost,_Component);function NewPost(props){_classCallCheck(this,NewPost);var _this=_possibleConstructorReturn(this,(NewPost.__proto__||Object.getPrototypeOf(NewPost)).call(this,props));_this.state={newpost:[],count:0,noticecount:0};_this.redirectPage=_this.redirectPage.bind(_this);_this.props.getNewPost();return _this;}_createClass(NewPost,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({newpost:nextProps.newPost.newposts,count:nextProps.newPost.count});}},{key:'redirectPage',value:function redirectPage(type){var Webview=this.props.Webview;if(Webview!==undefined&&Webview==='webview'){return false;}else{this.props.redirectprops(type);}}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this2=this;var newpost=null;var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('corporateID',true);var Webview=this.props.Webview;if(this.state.newpost!=undefined||this.state.newpost!=null){if(Webview!==undefined&&Webview==='webview'){var appcode=this.props.appcode;var device_id=this.props.device_id;var url_courseware="#/learning-resources/"+appcode+"/"+device_id+"/courseware";var url_poll="#/group-Interactions/"+appcode+"/"+device_id+"/opinionpolls";var url_library="#/learning-resources/"+appcode+"/"+device_id+"/library";var url_message="#/personal-interaction/"+appcode+"/"+device_id+"/messages";newpost=this.state.newpost.map(function(post,is){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'post_'+is},post.blog?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.blog}})):'',post.courseware?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url_courseware},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.courseware}}))):'',post.dlr?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.dlr}})):'',post.forum?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.forum}})):'',post.lr?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.lr}})):'',post.library?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url_library},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.library}}))):'',post.message?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url_message},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.message}}))):'',post.poll?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url_poll},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.poll}}))):'');});}else{newpost=this.state.newpost.map(function(post,is){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'post_'+is},post.blog?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.blog}}))):'',post.courseware?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this2.redirectPage('courseware');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.courseware}}))):'',post.dlr?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this2.redirectPage('componet_list');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.dlr}}))):'',post.forum?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.forum}}))):'',post.lr?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this2.redirectPage('componet_list');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.lr}}))):'',post.library?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this2.redirectPage('library');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.library}}))):'',post.message?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this2.redirectPage('messages');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.message}}))):'',post.poll?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this2.redirectPage('opinion_poll');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:post.poll}}))):'');});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide3'},Webview===undefined&&Webview!=='webview'&&corporateID!=77&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handle',href:'javascript:void(0);',id:'newpost'},'New posts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/img1.jpg',align:'texttop',alt:'',border:'0'}),' New posts'),newpost,Webview===undefined&&Webview!=='webview'&&corporateID!=77&&this.state.count>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge-noticeboard','data-badge':this.state.count}):'');}}]);return NewPost;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{newPost:state.newPost};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({getNewPost:__WEBPACK_IMPORTED_MODULE_8__actions_newPostAction__["a" /* getNewPost */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(NewPost));

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var DoyouKnow=function(_Component){_inherits(DoyouKnow,_Component);function DoyouKnow(props){_classCallCheck(this,DoyouKnow);var _this=_possibleConstructorReturn(this,(DoyouKnow.__proto__||Object.getPrototypeOf(DoyouKnow)).call(this,props));_this.state={doyou:[],count:0,noticecount:0};// alert(User.UserId());
_this.getDoyouknow=_this.getDoyouknow.bind(_this);return _this;}_createClass(DoyouKnow,[{key:'getDoyouknow',value:function getDoyouknow(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("productID",true);var fullName=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("fullName",true);fetch(__WEBPACK_IMPORTED_MODULE_5__config_Config__["d" /* domainUrl */]+'left/doyou-know',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,lr_product:productID,fullName:fullName})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
_this2.setState({doyou:responseJson.results.completing_lr});});}},{key:'componentDidMount',value:function componentDidMount(){this.getDoyouknow();}},{key:'render',value:function render(){var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('corporateID',true);var doyouknow=this.state.doyou;var Webview=this.props.Webview;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide2'},Webview===undefined&&Webview!=='webview'&&corporateID!=77&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handle',href:'javascript:void(0);',id:'doyouk'},'Do you know?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/img1.jpg',align:'texttop',alt:'',border:'0'}),' Do you know?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:doyouknow}}));}}]);return DoyouKnow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DoyouKnow);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var SupportDesk=function(_Component){_inherits(SupportDesk,_Component);function SupportDesk(props){_classCallCheck(this,SupportDesk);var _this=_possibleConstructorReturn(this,(SupportDesk.__proto__||Object.getPrototypeOf(SupportDesk)).call(this,props));_this.state={doyou:[],count:0,noticecount:0};return _this;}_createClass(SupportDesk,[{key:'sendSupportQuery',value:function sendSupportQuery(){var formData=new FormData();formData.append("user_id",__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */]());formData.append("subject",this.refs.subject.value);formData.append("query",this.refs.query.value);if(this.refs.attachment.files[0]!=undefined){formData.append("attachment",this.refs.attachment.files[0]);}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_5__config_Config__["d" /* domainUrl */]+"user/supportdesk/query",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("",responseJson.message,"success");$('form#qtechsupport')[0].reset();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["n" /* leftClose */]();}});}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this2=this;var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('corporateID',true);var Webview=this.props.Webview;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out support'},Webview===undefined&&Webview!=='webview'&&corporateID!=77&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'support-ico',href:'javascript:void(0);',title:'Support Desk',id:'supportd'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'#',id:'qtechsupport',method:'POST',encType:'multipart/form-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/support-ico2.png',align:'texttop',alt:'',border:'0'}),' Support Desk'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For technical queries and clarifications about the program.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'subject',id:'jquerysubject',type:'text',placeholder:'Subject'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{ref:'query',id:'jqueryquery',placeholder:'Query'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'attachment',type:'file',id:'jqueryfile',style:{border:"none"},'data-valid-types':'jpg,jpeg,png,gif','data-max-limit':'2097152',onChange:function onChange(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["l" /* validateFile */])(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg'},'Maximum upload size is 2MB. (Only JPEG, GIF Formats)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Send',onClick:function onClick(){return _this2.sendSupportQuery();}})));}}]);return SupportDesk;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SupportDesk);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Highcharts__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MyJourneyLists__ = __webpack_require__(430);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var MyJourney=function(_Component){_inherits(MyJourney,_Component);function MyJourney(props){_classCallCheck(this,MyJourney);var _this=_possibleConstructorReturn(this,(MyJourney.__proto__||Object.getPrototypeOf(MyJourney)).call(this,props));_this.state={myjourney_results:[],chartvalue:[],chart:'',dynamicchart:'',pending_lrs:'',completed_lrs:'',pending_dlrs:'',completed_dlrs:'',learningcount:'',dynamiclearningcount:'',lrroomwisetab:[],lrroomwisetablist:[],//	lrmodule:[],
//lrmodulewise:[],
dlrroomwise:[],// dlr_module_name_list:[],
//dlrroomwise_array_list:[],
specialExpiryDate:''};_this.getLrinfo=_this.getLrinfo.bind(_this);return _this;}_createClass(MyJourney,[{key:'getTabs',value:function getTabs(){window.$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});}},{key:'getJourney',value:function getJourney(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);// let d = new Date(specialExpiry);
// let specialExpiryDate = d.toDateString('d-M-Y');
//alert(learnerID+'learnerID '+pinNo+'pinNo '+pinID+'pinID '+corporateID+'corporateID productID'+productID); return;
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learning/myjourney',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){//alert(responseJson.myjourney_results.pending_lrs);
//learning room
if(responseJson.status!=0){var pending_lrs=responseJson.myjourney_results.pending_lrs!=undefined?responseJson.myjourney_results.pending_lrs:'';var completed_lrs=responseJson.myjourney_results.completed_lrs!=undefined?responseJson.myjourney_results.completed_lrs:'';if(responseJson.myjourney_results.completed_lrs==undefined||responseJson.myjourney_results.completed_lrs==0){completed_lrs=0;}if(responseJson.myjourney_results.pending_lrs==undefined||responseJson.myjourney_results.pending_lrs==0){pending_lrs=0;}var data=[{name:'Completed',y:completed_lrs,sliced:true,selected:true},{name:'Pending',y:pending_lrs}];var learningcount=responseJson.myjourney_results.total_lrs!=undefined?responseJson.myjourney_results.total_lrs:'';var chart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Highcharts__["a" /* default */],{key:'chart_1',data:data,title:'Learning Rooms = '+learningcount,name:'Learning Rooms',charttype:'pie'});//dynamic learning room
var pending_dlrs=responseJson.myjourney_results.pending_dlrs!=undefined?responseJson.myjourney_results.pending_dlrs:'';var completed_dlrs=responseJson.myjourney_results.completed_dlrs!=undefined?responseJson.myjourney_results.completed_dlrs:'';if(responseJson.myjourney_results.completed_dlrs==undefined||responseJson.myjourney_results.completed_dlrs==0){completed_dlrs=0;}if(responseJson.myjourney_results.pending_dlrs==undefined||responseJson.myjourney_results.pending_dlrs==0){pending_dlrs=0;}var dynamicdata=[{name:'Completed',y:completed_dlrs,sliced:true,selected:true},{name:'Pending',y:pending_dlrs}];var dynamiclearningcount=responseJson.myjourney_results.total_dlrs!=undefined?responseJson.myjourney_results.total_dlrs:'';var dynamicchart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Highcharts__["a" /* default */],{key:'dynamicchart_1',data:dynamicdata,title:'Dynamic Learning Rooms = '+dynamiclearningcount,name:'Dynamic Learning Rooms',charttype:'pie'});setTimeout(function(){if(completed_lrs!=0||pending_lrs!=0){$("#lritem").show();}if(completed_dlrs!=0||pending_dlrs!=0){$("#dlritem").show();}if(learningcount>0){$(".lrwise").hide();$(".lrroomwise").show();}else{$(".lrroomwise").hide();$(".lrwise").show();}if(dynamiclearningcount>0){$(".dlrroomwise").show();}else{$(".dlrroomwise").hide();}},2000);var lrroomwisetab=responseJson.myjourney_results.lrroomwise!=undefined?responseJson.myjourney_results.lrroomwise:'';var lrroomwisetablist=responseJson.myjourney_results.loopinfo!=undefined?responseJson.myjourney_results.loopinfo:'';// let lrmodule          = (responseJson.myjourney_results.lrmodule!=undefined) ? responseJson.myjourney_results.lrmodule : '';
// let lrmodulewise      = (responseJson.myjourney_results.lrmodulewise!=undefined) ? responseJson.myjourney_results.lrmodulewise : '';
var dlrroomwise=responseJson.myjourney_results.dlrroomwise!=undefined?responseJson.myjourney_results.dlrroomwise:'';// let dlr_module_name_list = (responseJson.myjourney_results.dlr_module_name_list!=undefined) ? responseJson.myjourney_results.dlr_module_name_list : '';
// let dlrroomwise_array_list = (responseJson.myjourney_results.dlrroomwise_array_list!=undefined) ? responseJson.myjourney_results.dlrroomwise_array_list : '';
//console.log(dlrroomwise);
_this2.setState({myjourney_results:responseJson.myjourney_results,chart:chart,dynamicchart:dynamicchart,pending_lrs:pending_lrs,completed_lrs:completed_lrs,pending_dlrs:pending_dlrs,completed_dlrs:completed_dlrs,learningcount:learningcount,dynamiclearningcount:dynamiclearningcount,lrroomwisetab:lrroomwisetab,lrroomwisetablist:lrroomwisetablist,//lrmodule:lrmodule,
// lrmodulewise:lrmodulewise,
dlrroomwise:dlrroomwise,// dlr_module_name_list:dlr_module_name_list,
//dlrroomwise_array_list:dlrroomwise_array_list,
specialExpiryDate:specialExpiryDate});}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}// roomChange(e){
// 			$(".rooms").hide();
// 			$("#"+e).show();
// 			$("."+e).css('background','#23a64d');
// }
},{key:'componentDidMount',value:function componentDidMount(){$("#lritem").hide();$("#dlritem").hide();//$(".lrwise").hide();
//$(".dlrroomwise").hide();
$(".rooms").hide();$("#room1").show();this.getJourney();this.getTabs();//Common.showSmallLeftMenu();
}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){// alert(type);
this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var Webview=this.props.Webview;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-myjourney.jpg',align:'absmiddle',alt:'',border:'0'}),' '),' My Journey',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'A quick view of my progress in the program'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll- ',className:'scroll1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourneychart-left'},this.state.chart,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-complete',id:'lritem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-legends'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'complete-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Completed : ',this.state.completed_lrs)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-legends'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'in-complete-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Pending : ',this.state.pending_lrs)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourneychart-right'},this.state.dynamicchart,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-complete',id:'dlritem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-legends'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'complete-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Completed : ',this.state.completed_dlrs)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-legends'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'in-complete-bg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Pending : ',this.state.pending_dlrs)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartstatus'},' Program : ',this.state.myjourney_results.product_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Your login expires on: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.specialExpiryDate),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myourney-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'abbrevationmyjourner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/status-completed.png",alt:'',title:''}),' - Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/status-notcompleted.png",alt:'',title:''}),' - In Progress'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/start-small.png",alt:'',title:''}),' - Yet to start'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab',className:'tab_wide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lrroomwise'},'LRs-wise')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'dlrroomwise'},'DLRs-wise')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MyJourneyLists__["a" /* default */],{tabsdata:this.state.lrroomwisetab,view_type:Webview,tabsdatalist:this.state.lrroomwisetablist/*lrmodule={this.state.lrmodule}*//* lrmodulewiselist={this.state.lrmodulewise} */,dlrroomwiselist:this.state.dlrroomwise/*dlr_module_name_list={this.state.dlr_module_name_list} *//*dlrroomwise_array_list={this.state.dlrroomwise_array_list}*/,getLrinfo:this.getLrinfo}))))))))));}}]);return MyJourney;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyJourney);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Bookaccordian__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var MyDiary=function(_Component){_inherits(MyDiary,_Component);function MyDiary(props){_classCallCheck(this,MyDiary);var _this=_possibleConstructorReturn(this,(MyDiary.__proto__||Object.getPrototypeOf(MyDiary)).call(this,props));_this.state={lrwise:[],dlrwise:[],modulewise:[],bookBlock:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Bookaccordian__["a" /* default */],{key:'0_initial',shows:[]})};return _this;}_createClass(MyDiary,[{key:'fnShowid',value:function fnShowid(e){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'learning/mydiary',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({showid:e,learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var shows=responseJson.mydiary.shows!=undefined?responseJson.mydiary.shows:[];_this2.setState({mydiary:responseJson.mydiary,bookBlock:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Bookaccordian__["a" /* default */],{key:e+'_mydiary',shows:shows})});}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["g" /* downTabClose */]();});}},{key:'getTabs',value:function getTabs(){$(".accordion_coach1").smk_Accordion();$("#tblleftcontents").click(function(){$('.acc-menu-pop').show();});$(".icon-pop-close").click(function(){$('.acc-menu-pop').hide();});$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});$('#ChildVerticalTab_1').easyResponsiveTabs({type:'vertical',width:'auto',fit:true,tabidentify:'ver_1'// The tab groups identifier
//resp-tab-active
/* activate: function (event) { // Callback function if tab is switched
			                alert('sdf');
			               $('[aria-controls="ver_1_tab_item-2"]').click();
			               alert('dd');
			            } */});}},{key:'getDiary',value:function getDiary(){var _this3=this;var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'learning/mydiary',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var lrwise=responseJson.mydiary.lrwise!=undefined?responseJson.mydiary.lrwise:'';var dlrwise=responseJson.mydiary.dlrwise!=undefined?responseJson.mydiary.dlrwise:'';var modulewise=responseJson.mydiary.modulewise!=undefined?responseJson.mydiary.modulewise:'';var shows=responseJson.mydiary.shows!=undefined?responseJson.mydiary.shows:[];_this3.setState({mydiary:responseJson.mydiary,lrwise:lrwise,dlrwise:dlrwise,modulewise:modulewise,bookBlock:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Bookaccordian__["a" /* default */],{key:'1_mydiary',shows:shows})});}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["g" /* downTabClose */]();});}},{key:'componentDidMount',value:function componentDidMount(){var _this4=this;setTimeout(function(){_this4.getTabs();_this4.getDiary();//Common.showSmallLeftMenu();
},500);}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this5=this;var lrwise_list=null;if(this.state.lrwise!=null||this.state.lrwise!=undefined){lrwise_list=this.state.lrwise.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrwise'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li-lrwise'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'alrwise'+index,onClick:function onClick(e){return _this5.fnShowid(key['show_id']);},className:'lr_name',id:''},key['lrwise_name']),' '));});}var dlrwise_list=null;if(this.state.dlrwise!=null||this.state.dlrwise!=undefined){dlrwise_list=this.state.dlrwise.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlrwise'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li-dlrwise'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'adlrwise'+index,onClick:function onClick(e){return _this5.fnShowid(key['show_id']);},className:'dlr_name',id:''},key['main_title']),' '));});}var modulewise_list=null;if(this.state.modulewise!=null||this.state.modulewise!=undefined){modulewise_list=this.state.modulewise.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'m-wise'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'li-mlrwise'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'a-mwise'+index,onClick:function onClick(e){return _this5.fnShowid('mwise_'+key['show_id']);},className:'module_name',id:''},key['module_name']),' '));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea',style:{width:'92.2%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/seekfdback.jpg',align:'absmiddle',alt:'',border:'0'})),'My Diary',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'My Diary'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'diary_form',id:'diary_form',action:'',method:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-menu-pop'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'icon-pop-close',href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/close-icon.png',align:'absmiddle',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_coach1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lrwisediv',className:'accordion_in acc_active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head'},'LR Wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pop-menu-list'},lrwise_list))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'dlrwisediv',className:'accordion_in '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head'},'DLR Wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pop-menu-list'},dlrwise_list))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'modulewisediv',className:'accordion_in  last'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head'},'Module Wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pop-menu-list module_name_wise'},modulewise_list))))),this.state.bookBlock))))))));}}]);return MyDiary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyDiary);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Linecharts__ = __webpack_require__(217);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var MyPerformance=function(_Component){_inherits(MyPerformance,_Component);function MyPerformance(props){_classCallCheck(this,MyPerformance);var _this=_possibleConstructorReturn(this,(MyPerformance.__proto__||Object.getPrototypeOf(MyPerformance)).call(this,props));_this.state={chart:'',dynamic_li:[],lrroom:[],dlrroom:[],reporttemp:[],reporttemp2:[],module_wise:[],module_wise_main:[],module_wise_linechart:[],//mod_option:[],
//dlr_module_wise:[],
lr_dlr_module_wise:[],//dlr_module_wise_main:[],
//dlr_module_wise_linechart:[],
lrdlrmodulewise_linechart:[],//dlr_mod_option:[]
lr_dlr_mod_option:[]};return _this;}_createClass(MyPerformance,[{key:'fnChart',value:function fnChart(){var select_module=$("#select_module").val();$(".all_module").css('display','none');$("#moduleContainer"+select_module).css('display','block');}},{key:'dlrfnChart',value:function dlrfnChart(){var select_module=$("#dlr_select_module").val();$(".dlr_all_module").css('display','none');$("#dlrmoduleContainer"+select_module).css('display','block');}},{key:'getAssesStatus',value:function getAssesStatus(type){this.props.switchPanel(type);}},{key:'getTabs',value:function getTabs(){window.$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});window.$('#ChildVerticalTab_1').easyResponsiveTabs({type:'vertical',width:'auto',fit:true,tabidentify:'ver_1'// The tab groups identifier
//resp-tab-active
/* activate: function (event) { // Callback function if tab is switched
                 alert('sdf');
                $('[aria-controls="ver_1_tab_item-2"]').click();
                alert('dd');
             } */});}},{key:'getPerformance',value:function getPerformance(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learning/my-performance',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){var data=[{name:'Completed',y:'3',sliced:true,selected:true},{name:'Pending',y:'2'}];$(".timebox_new").css('display','block');$(".myperformance").css('display','block');if(responseJson.status!=0){var dynamic_li=responseJson.myperformance.dynamic_li!=undefined?responseJson.myperformance.dynamic_li:'';var lrroom=responseJson.myperformance.lrroom!=undefined?responseJson.myperformance.lrroom:'';var dlrroom=responseJson.myperformance.dlrroom!=undefined?responseJson.myperformance.dlrroom:'';var reporttemp=responseJson.myperformance.reporttemp!=undefined?responseJson.myperformance.reporttemp:'';var reporttemp2=responseJson.myperformance.reporttemp2!=undefined?responseJson.myperformance.reporttemp2:'';var module_wise=responseJson.myperformance.module_wise!=undefined?responseJson.myperformance.module_wise:'';var module_wise_main=responseJson.myperformance.module_wise_main!=undefined?responseJson.myperformance.module_wise_main:'';var dlr_module_wise_main=responseJson.myperformance.dlr_module_wise_main!=undefined?responseJson.myperformance.dlr_module_wise_main:'';var module_wise_linechart='';if(module_wise_main.str_tot_scr!=undefined){module_wise_linechart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Linecharts__["a" /* default */],{belowtitle:'Learning Rooms',key:'chart_3',data:module_wise_main.str_tot_scr,title:'Module Wise',categories:module_wise_main.module_name,name:'Learning Rooms',charttype:'line'});}//merge lr and dlr array
var lrdlrmodulewise={"module_name":[],"str_tot_scr":[]};if(module_wise_main['module_name']!=undefined&&module_wise_main['module_name'].length>0)Array.prototype.push.apply(lrdlrmodulewise.module_name,module_wise_main['module_name']);if(module_wise_main['str_tot_scr']!=undefined&&module_wise_main['str_tot_scr'].length>0)Array.prototype.push.apply(lrdlrmodulewise['str_tot_scr'],module_wise_main['str_tot_scr']);if(dlr_module_wise_main['module_name']!=undefined&&dlr_module_wise_main['module_name'].length>0)Array.prototype.push.apply(lrdlrmodulewise['module_name'],dlr_module_wise_main['module_name']);if(dlr_module_wise_main['str_tot_scr']!=undefined&&dlr_module_wise_main['str_tot_scr'].length>0)Array.prototype.push.apply(lrdlrmodulewise['str_tot_scr'],dlr_module_wise_main['str_tot_scr']);//console.log(lrdlrmodulewise);
var mod_option=responseJson.myperformance.mod_option!=undefined?responseJson.myperformance.mod_option:'';//alert(JSON.stringify(module_wise_linechart));
var dlr_module_wise=responseJson.myperformance.dlr_module_wise!=undefined?responseJson.myperformance.dlr_module_wise:'';//merge lr and dlr array
var lr_dlr_module_wise=[];if(module_wise!=''){//set flag lr or dlr (lr:1,Dlr:2)
for(var y=0;y<module_wise.length;y++){module_wise[y]['lrdlrflag']='1';}Array.prototype.push.apply(lr_dlr_module_wise,module_wise);}if(dlr_module_wise!=''){//set flag lr or dlr (lr:1,Dlr:2)
for(var z=0;z<dlr_module_wise.length;z++){dlr_module_wise[z]['lrdlrflag']='2';}Array.prototype.push.apply(lr_dlr_module_wise,dlr_module_wise);}// console.log(lr_dlr_module_wise);
//  let dlr_module_wise_linechart = <Linecharts key={`chart_3`} data={dlr_module_wise_main.str_tot_scr} title="Dlr Module Wise" categories={dlr_module_wise_main.module_name} name='Dynamic Learning Rooms' charttype='line' />
var lrdlrmodulewise_linechart=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Linecharts__["a" /* default */],{belowtitle:'Learning Rooms and Dynamic Learning Rooms',key:'chart_3',data:lrdlrmodulewise.str_tot_scr,title:'LR & DLR Module Wise',categories:lrdlrmodulewise.module_name,name:'Learning Rooms and Dynamic Learning Rooms',charttype:'line'});var dlr_mod_option=responseJson.myperformance.dlr_mod_option!=undefined?responseJson.myperformance.dlr_mod_option:'';//merge lr and dlr array
var lr_dlr_mod_option=[];if(mod_option!='')Array.prototype.push.apply(lr_dlr_mod_option,mod_option);if(dlr_mod_option!='')Array.prototype.push.apply(lr_dlr_mod_option,dlr_mod_option);// console.log(lr_dlr_mod_option);
_this2.setState({myperformance:responseJson.myperformance,dynamic_li:dynamic_li,lrroom:lrroom,dlrroom:dlrroom,reporttemp:reporttemp,reporttemp2:reporttemp2,module_wise:module_wise,module_wise_linechart:module_wise_linechart,//  mod_option:mod_option,
//dlr_module_wise:dlr_module_wise,
lr_dlr_module_wise:lr_dlr_module_wise,//dlr_module_wise_linechart:dlr_module_wise_linechart,										 
lrdlrmodulewise_linechart:lrdlrmodulewise_linechart,//dlr_mod_option:dlr_mod_option
lr_dlr_mod_option:lr_dlr_mod_option});_this2.getTabs();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");$(".myjourney-table").tablesorter({widthFixed:true});},3000);}});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;$(".timebox_new").css('display','none');$(".myperformance").css('display','none');setTimeout(function(){_this3.getPerformance();//Common.showSmallLeftMenu();				
},500);}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this4=this;/* hide 
        let dynamic_li_list = null;
        if(this.state.dynamic_li != null || this.state.dynamic_li != undefined){
            dynamic_li_list=this.state.dynamic_li.map((key,index)=>{
                 return <li className={`${index==0?'resp-tab-active':''}`} key={`ver_1_tab_item-${index}`}>{key}<br />
                     <span></span></li>
            });
        }
        */var dynamic_li_list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'resp-tab-active'},'LRs-wise',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'DLRs-wise',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Module-wise',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)));var lrrooms=null;if(this.state.lrroom!=null||this.state.lrroom!=undefined){lrrooms=this.state.lrroom.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Linecharts__["a" /* default */],{belowtitle:'Learning Rooms',key:'chart_'+index,data:key['lr_roomscore'],title:key['title'],categories:key['data_cat'],name:'Learning Rooms',charttype:'line'});});}var module_wise=null;if(this.state.module_wise!=null||this.state.module_wise!=undefined){module_wise=this.state.module_wise.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'mod-wise'+index,style:{display:'none'},className:'all_module',id:'moduleContainer'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Linecharts__["a" /* default */],{key:'chart_2',data:key['lrMod_roomscore'],title:key['title'],categories:key['data_cat'],name:'Learning Rooms',belowtitle:'Learning Rooms',charttype:'line'}));});}/*	let mod_option = null;
            if(this.state.mod_option != null || this.state.mod_option != undefined){
                mod_option= this.state.mod_option.map((key,index)=>{
                    return <option key={`mod-${index}`} value={index}>{key['module_name']}</option>
                });
            }
            */var dlrrooms=null;if(this.state.dlrroom!=null||this.state.dlrroom!=undefined){dlrrooms=this.state.dlrroom.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Linecharts__["a" /* default */],{belowtitle:'Dynamic Learning Rooms',key:'dlr_chart_'+index,data:key['lr_roomscore'],title:'Dynamic Learning Rooms',categories:key['data_cat'],name:'Learning Rooms',charttype:'line'});});}/*
		let dlr_module_wise = null;
		if(this.state.dlr_module_wise != null || this.state.dlr_module_wise != undefined){
			dlr_module_wise= this.state.dlr_module_wise.map((key,index)=>{
				return <div key={`dlr_module_wise-${index}`} style={{display:'none'}} className="dlr_all_module" id={`dlrmoduleContainer${index}`}><Linecharts key={`dlr_chart_2`} data={key['lrMod_roomscore']} title={key['title']} categories={key['data_cat']} name='Learning Rooms' charttype='line' /></div>
			});
		}
		*/var lr_dlr_module_wise=null;if(this.state.lr_dlr_module_wise!=null||this.state.lr_dlr_module_wise!=undefined){lr_dlr_module_wise=this.state.lr_dlr_module_wise.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lr_dlr_module_wise-'+index,style:{display:'none'},className:'dlr_all_module',id:'dlrmoduleContainer'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Linecharts__["a" /* default */],{belowtitle:key['lrdlrflag']=='1'?'Learning Rooms':'Dynamic Learning Rooms',key:'dlr_chart_2',data:key['lrMod_roomscore'],title:key['title'],categories:key['data_cat'],name:key['lrdlrflag']=='1'?'Learning Rooms':'Dynamic Learning Rooms',charttype:'line'}));});}// let dlr_mod_option = null;
// if(this.state.dlr_mod_option != null || this.state.dlr_mod_option != undefined){
// 	dlr_mod_option= this.state.dlr_mod_option.map((key,index)=>{
// 		return <option key={`dlrmod-${index}`} value={index}>{key['module_name']}</option>
// 	});
// }
var lr_dlr_mod_option=null;if(this.state.lr_dlr_mod_option!=null||this.state.lr_dlr_mod_option!=undefined){lr_dlr_mod_option=this.state.lr_dlr_mod_option.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'lrdlrmod-'+index,value:index},key['module_name']);});}var reporttemps=null;if(this.state.reporttemp!=null||this.state.reporttemp!=undefined){reporttemps=this.state.reporttemp.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'temp-tr-'+index,className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['room']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['module_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['component_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['ka']),key['asms']=="YTA"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.getAssesStatus('assessement_status');},title:'My assessement status'},key['asms'])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['asms']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['percentage']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['g_percentage']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,key['u_percentage']));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-myperformance.jpg',align:'absmiddle',alt:'',border:'0'}),' '),' My Performance',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'My cumulative performance in completed Learning Rooms.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Performance Chart',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/activetab.png',alt:'',title:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Percentile Report',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/activetab.png',alt:'',title:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 tapmargntop',id:'responsivediv_show'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ChildVerticalTab_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list ver_1'},dynamic_li_list),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container ver_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrwise',className:'performance-chart'},lrrooms!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,lrrooms,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartstatuscontent'},'My Performance Score in each Learning Room.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new'},'Please complete at least one Learning Room to view this performance chart.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content'},dlrrooms!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,dlrrooms):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new'},'Please complete at least one Dynamic Learning Room to view this performance chart.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content'},lr_dlr_module_wise!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'dlrmoduleContainer'},this.state.lrdlrmodulewise_linechart),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartselectoption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selectoptionright'},lr_dlr_mod_option?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'greentxt'},'Select Module :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'dlr_select_module',id:'dlr_select_module',onChange:function onChange(e){return _this4.dlrfnChart();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),lr_dlr_mod_option)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,lr_dlr_module_wise))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new'},'Please complete at least one Dynamic Learning Room to view this performance chart.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content table-cont4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'abbrevation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K/A'),' - Knowledge / Action Component'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'AS'),' - Actual Score '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'MS'),' - Maximum Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'%'),' - Percentage Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G %ile'),' - Group Percentile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'U %ile'),' - Universal Percentile'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%',className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rooms ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Module Name ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Component Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'K/A ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:'component - Indicates components that test knowledge / component - Indicates components that are action or practice based'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'AS/MS ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:'Indicates the actual scores made by the learner / Indicates the maximum score out of which the learner\'s performance was measured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'% ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:'Indicates the percentage score made by the learner so far (AS divided by MS'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'G %ile ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:'Indicates the learner\'s position among the current group of learners'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'U %ile ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sort-arrow.png',alt:'',title:'Indicates the learner\'s universal position among all the group of learners as on date'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reporttemps)))))))))));}}]);return MyPerformance;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyPerformance);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//const $=window.$;
var win=window;var Linecharts=function(_Component){_inherits(Linecharts,_Component);function Linecharts(props){_classCallCheck(this,Linecharts);return _possibleConstructorReturn(this,(Linecharts.__proto__||Object.getPrototypeOf(Linecharts)).call(this,props));}_createClass(Linecharts,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var titleText=this.props.title;var types=this.props.charttype;var thisdata=this.props.data;for(var key in thisdata){if(thisdata.hasOwnProperty(key)){thisdata[key]=Math.round(thisdata[key]*100)/100;}}// window.test();
setTimeout(function(){win.Highcharts.chart(_this2.refs.highcharts,{chart:{// borderColor:'white',
// borderWidth:0.5,
width:731,height:400,zoomType:'none'},title:{text:_this2.props.title},credits:{enabled:false},xAxis:{categories:_this2.props.categories,title:{text:_this2.props.belowtitle!=undefined?_this2.props.belowtitle:'Learning Rooms'}},yAxis:{title:{text:'Percentage (%)'},plotLines:[{value:0,width:1,color:'#808080'}]},tooltip:{valueSuffix:'%',formatter:function formatter(){return this.y>0?'<p style="font-size: 10px">'+this.x+'</p><br><p><span style="color:#7cb5ec" >●</span> Performance Score:  <b>'+this.y+' %</b>':'<p style="font-size: 10px">'+this.x+'</p><br><p><span style="color:#7cb5ec" >●</span> Performance Score:  <b> N.A </b>';}},legend:{verticalAlign:'bottom',layout:'horizontal'},series:[{name:'Performance Score',data:thisdata}]});},200);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'highcharts',style:{width:'98%'}});}}]);return Linecharts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Linecharts);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Prevnext__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Recap_list__ = __webpack_require__(437);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Recap=function(_Component){_inherits(Recap,_Component);function Recap(props){_classCallCheck(this,Recap);var _this=_possibleConstructorReturn(this,(Recap.__proto__||Object.getPrototypeOf(Recap)).call(this,props));_this.state={lr_count:'',dlr_count:'',lr_lists:[],lr_module_name_lists:[],module_lr_lists:[],module_name_list:[],dlr_wise:[],dlr_wise_list:[],dlr_module_wise:[],dlr_module_wise_list:[],dlr_module_name_lists:[],dlr_lear_count:[],dlr_module_name_lists_count:[],table_lr:[],table_dlr:[],recap_module_list:[]};return _this;}_createClass(Recap,[{key:'componentDidMount',value:function componentDidMount(){$(".timebox_new").css('display','none');this.getRecap();// this.showRecapNext();
// setTimeout(()=>{
// 	Common.showSmallLeftMenu();				
// },500)
}},{key:'getRecap',value:function getRecap(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learning/recap',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var lr_count=responseJson.recap.lr_count!=undefined?responseJson.recap.lr_count:'';var dlr_count=responseJson.recap.dlr_count!=undefined?responseJson.recap.dlr_count:'0';var lr_lists=responseJson.recap.lr_lists!=undefined?responseJson.recap.lr_lists:'';var lr_module_name_lists=responseJson.recap.lr_module_name_lists!=undefined?responseJson.recap.lr_module_name_lists:'';var module_lr_lists=responseJson.recap.module_lr_lists!=undefined?responseJson.recap.module_lr_lists:'';var module_name_list=responseJson.recap.module_name_list!=undefined?responseJson.recap.module_name_list:'';var dlr_wise_list=responseJson.recap.dlr_wise!=undefined?responseJson.recap.dlr_wise:'';var dlr_module_wise_list=responseJson.recap.dlr_module_wise!=undefined?responseJson.recap.dlr_module_wise:'';//alert(JSON.stringify(dlr_module_wise_list));
var dlr_module_name_lists=responseJson.recap.dlr_module_name_lists!=undefined?responseJson.recap.dlr_module_name_lists:'';var dlr_module_name_lists_count=responseJson.recap.dlr_module_name_lists_count!=undefined?responseJson.recap.dlr_module_name_lists_count:'';var dlr_lear_count=responseJson.recap.dlr_lear_count!=undefined?responseJson.recap.dlr_lear_count:'';var table_lr=responseJson.recap.table_lr!=undefined?responseJson.recap.table_lr:'';var table_dlr=responseJson.recap.table_dlr!=undefined?responseJson.recap.table_dlr:'';//alert(JSON.stringify(lrroom));dlr_lear_count
var recap_module_list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Recap_list__["a" /* default */],{lr_count:lr_count,dlr_count:dlr_count,lr_lists:lr_lists,lr_module_name_lists:lr_module_name_lists,module_lr_lists:module_lr_lists,module_name_list:module_name_list,dlr_wise_list:dlr_wise_list,dlr_module_wise_list:dlr_module_wise_list,dlr_module_name_lists:dlr_module_name_lists,dlr_lear_count:dlr_lear_count,dlr_module_name_lists_count:dlr_module_name_lists_count});_this2.setState({recap:responseJson.recap,lr_count:lr_count,dlr_count:dlr_count,recap_module_list:recap_module_list,table_lr:table_lr,table_dlr:table_dlr});}setTimeout(function(){_this2.getTabs();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();},1000);});}},{key:'getTabs',value:function getTabs(){window.$(this.refs.parentHorizontalTab).easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var table_lr=null;if(this.state.table_lr!=null||this.state.table_lr!=undefined){table_lr=this.state.table_lr.map(function(table_val,table_key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'table-tr'+table_key,bgcolor:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',style:{textAlign:'center'}},table_val['lr_room_count']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',style:{textAlign:'center'}},table_val['module_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{key:'table-tr-table'+table_key,cellPadding:'0',cellSpacing:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{valign:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:table_val['component_name']['spanclass'],style:{marginRight:'0'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{paddingLeft:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{border:'#FF0000 0px solid'},className:'title_rc'},table_val['component_name']['name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',clear:'both'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lm_subtitle'},table_val['component_name']['icon'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',clear:'both',width:'350px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,table_val['component_name']['base_line']))))))));});}var table_dlr=null;if(this.state.table_dlr!=null||this.state.table_dlr!=undefined){table_dlr=this.state.table_dlr.map(function(table_val,table_key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'table-tr'+table_key,bgcolor:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',style:{textAlign:'center'}},table_val['lr_room_count']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',style:{textAlign:'center'}},table_val['module_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{key:'table-tr-table'+table_key,cellPadding:'0',cellSpacing:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{valign:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:table_val['component_name']['spanclass'],style:{marginRight:'0'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{paddingLeft:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{border:'#FF0000 0px solid'},className:'title_rc'},table_val['component_name']['name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',clear:'both'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lm_subtitle'},table_val['component_name']['icon'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',clear:'both',width:'350px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,table_val['component_name']['base_line']))))))));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/recap-icon.jpg',align:'absmiddle',alt:'',border:'0'}),' '),' Recap',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Collection of notes prepared in Learning Rooms and Recaps of Learning Rooms.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-blue-box'},'Any time during your program sessions, you can view recap of your completed Learning Rooms, and the Notes prepared by you alongside.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab',ref:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'tab_0'},'LR-wise Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'tab_1'},'Module-wise Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'tab_2'},'DLR-wise Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'tab_3'},'DLR Module-wise Recap')),this.state.recap_module_list)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-table-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'recap-blue-title'},'Repeatable Components'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-blue-box'},'Any time during the program, you can visit the repeatable components. You can visit these any number of times, but scores will not change.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-table viewobservers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'0',className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'LR#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Module name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Component Name'))),table_lr!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'recap-tab'},table_lr):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'recap-tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{bgcolor:'#FFFFFF'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',align:'center',style:{textAlign:'center'}},'There are no repeatable components available at the moment.')))),table_dlr!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'0',className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DLR#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Module name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Component Name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'recap-tab'},table_dlr)):'')))))));}}]);return Recap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Recap);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return showRecapPre; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showRecapNext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showRecapPreDLR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showRecapNextDLR; });
/* unused harmony export showModuleLr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return showRecapPreMod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showRecapNextMod; });
/* unused harmony export DLRModuleshowModuleLr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DLRModuleshowModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DLRModuleshowRecapPreMod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DLRModuleshowRecapNextMod; });
var $=window.$;var showRecapPre=function showRecapPre(){var curent=$('#txthidden').val();var previous=curent-1;var tot=$('#txttothid').val();var tocheck=tot+1;for(var i=0;i<tot;i++){$('#Hire'+i).css('display','none');}if(previous>tocheck){$('#NextBut').css('display','block');$('#PreviousBut').css('display','block');}else{$('#NextBut').css('display','block');$('#PreviousBut').css('display','block');}if(previous==0)$('#PreviousBut').css('display','none');$('#Hire'+previous).css('display','block');$('#txthidden').val(previous);};var showRecapNext=function showRecapNext(){var curent=$('#txthidden').val();var next=parseInt(curent)+1;var tot=$('#txttothid').val();var tocheck=tot-1;for(var i=0;i<tot;i++){$('#Hire'+i).css('display','none');}if(next<tocheck){$('#NextBut').css('display','block');$('#PreviousBut').css('display','block');}else{$('#NextBut').css('display','none');$('#PreviousBut').css('display','block');}$('#Hire'+next).css('display','block');$('#txthidden').val(next);};var showRecapPreDLR=function showRecapPreDLR(){var curent=$('#DLRtxthidden').val();var previous=curent-1;var tot=$('#DLRtxttothid').val();var tocheck=tot+1;for(var i=0;i<tot;i++){$('#DLRHire'+i).css('display','none');}if(previous>tocheck){$('#DLRNextBut').css('display','block');$('#DLRPreviousBut').css('display','block');}else{$('#DLRNextBut').css('display','block');$('#DLRPreviousBut').css('display','block');}if(previous==0)$('#DLRPreviousBut').css('display','none');$('#DLRHire'+previous).css('display','block');$('#DLRtxthidden').val(previous);};var showRecapNextDLR=function showRecapNextDLR(){var curent=$('#DLRtxthidden').val();var next=parseInt(curent)+1;var tot=$('#DLRtxttothid').val();var tocheck=tot-1;for(var i=0;i<tot;i++){$('#DLRHire'+i).css('display','none');}if(next<tocheck){$('#DLRNextBut').css('display','block');$('#DLRPreviousBut').css('display','block');}else{$('#DLRNextBut').css('display','none');$('#DLRPreviousBut').css('display','block');}$('#DLRHire'+next).css('display','block');$('#DLRtxthidden').val(next);};var showModuleLr=function showModuleLr(x){$('#ModuleHier'+x).css('display','block');};var showModule=function showModule(){var currrentModule=$('#lstModuleSelect').val();var b=currrentModule.split("#");var Totalmodule=$('#TotalModuleValue').val();$(".allcss").css('display','none');$('#Mod1'+b[0]).css('display','block');$('#Mod'+b[0]).css('display','block');$('#ButtonShow'+b[0]).css('display','block');$('#LROOM'+b[1]).css('display','block');showModuleLr(b[1]);};var showRecapPreMod=function showRecapPreMod(x){var overll=$('#moduleLrIds'+x).val();var tot=$('#txtOverallCount'+x).val();var curCnt=$('#CurrentCount'+x).val();var toshow=parseInt(curCnt)-1;var toCheck=parseInt(toshow)-1;var a=overll.split(",");$(".lrroomcss").css('display','none');$('#ModuleHier'+a[toshow]).css('display','block');if(tot>toshow){$('#NextButModule'+x).css('display','block');$('#PreviousButModule'+x).css('display','block');}else{$('#NextButModule'+x).css('display','block');$('#PreviousButModule'+x).css('display','block');}if(toshow==0){$('#PreviousButModule'+x).css('display','none');}$('#CurrentCount'+x).val(toshow);};var showRecapNextMod=function showRecapNextMod(x){var overll=$('#moduleLrIds'+x).val();var tot=$('#txtOverallCount'+x).val();var curCnt=$('#CurrentCount'+x).val();var toshow=parseInt(curCnt)+1;var toCheck=parseInt(toshow)+1;//let a=JSON.stringify(overll).split(",");
var a=overll.split(",");$(".lrroomcss").css('display','none');$('#ModuleHier'+a[toshow]).css('display','block');//this.showModuleLr(a[toshow]);
if(tot>toshow){$('#NextButModule'+x).css('display','block');$('#PreviousButModule'+x).css('display','block');}else{$('#NextButModule'+x).css('display','block');$('#PreviousButModule'+x).css('display','block');}if(tot==toCheck){$('#NextButModule'+x).css('display','none');}$('#CurrentCount'+x).val(toshow);};var DLRModuleshowModuleLr=function DLRModuleshowModuleLr(x){$('#DLRModuleModuleHier'+x).css('display','block');};var DLRModuleshowModule=function DLRModuleshowModule(){var currrentModule=$('#DLRModulelstModuleSelect').val();var b=currrentModule.split("#");var Totalmodule=$('#DLRModuleTotalModuleValue').val();//alert(b);
$('.dlr_allcss').css('display','none');$('#DLRModuleMod1'+b[0]).css('display','block');$('#DLRModuleMod'+b[0]).css('display','block');$('#DLRModuleModuleHier'+b[1]).css('display','block');$('#DLRModuleButtonShow'+b[0]).css('display','block');DLRModuleshowModuleLr(b[1]);};var DLRModuleshowRecapPreMod=function DLRModuleshowRecapPreMod(x){var overll=$('#DLRModuletxtOverallLearningRoom'+x).val();var tot=$('#DLRModuletxtOverallCount'+x).val();var curCnt=$('#DLRModuleCurrentCount'+x).val();var toshow=parseInt(curCnt)-1;var toCheck=parseInt(toshow)-1;var a=overll.split(",");$(".dlrroomcss").css('display','none');$('#DLRModuleModuleHier'+a[toshow]).css('display','block');if(tot>toshow){$('#DLRModuleNextButModule'+x).css('display','block');$('#DLRModulePreviousButModule'+x).css('display','block');}else{$('#DLRModuleNextButModule'+x).css('display','block');$('#DLRModulePreviousButModule'+x).css('display','block');}if(toshow==0){$('#DLRModulePreviousButModule'+x).css('display','none');}$('#DLRModuleCurrentCount'+x).val(toshow);};var DLRModuleshowRecapNextMod=function DLRModuleshowRecapNextMod(x){var overll=$('#DLRModuletxtOverallLearningRoom'+x).val();var tot=$('#DLRModuletxtOverallCount'+x).val();var curCnt=$('#DLRModuleCurrentCount'+x).val();var toshow=parseInt(curCnt)+1;var toCheck=parseInt(toshow)+1;var a=overll.split(",");$(".dlrroomcss").css('display','none');$('#DLRModuleModuleHier'+a[toshow]).css('display','block');if(tot>toshow){$('#DLRModuleNextButModule'+x).css('display','block');$('#DLRModulePreviousButModule'+x).css('display','block');}else{$('#DLRModuleNextButModule'+x).css('display','block');$('#DLRModulePreviousButModule'+x).css('display','block');}if(tot==toCheck){$('#DLRModuleNextButModule'+x).css('display','none');}$('#DLRModuleCurrentCount'+x).val(toshow);};

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Pagination__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
var LoginHistory=function(_Component){_inherits(LoginHistory,_Component);function LoginHistory(props){_classCallCheck(this,LoginHistory);var _this=_possibleConstructorReturn(this,(LoginHistory.__proto__||Object.getPrototypeOf(LoginHistory)).call(this,props));_this.state={learnerHistorytime:[],startDate:'',endDate:'',pageOfItems:[],total_co:0};_this.onSubmit=_this.onSubmit.bind(_this);return _this;}_createClass(LoginHistory,[{key:'handleDateChange',value:function handleDateChange(e){if(e.target.name=="datestart"){this.setState({startDate:$("#datestart").datepicker().val()});}if(e.target.name=="dateend"){this.setState({endDate:$("#dateend").datepicker().val()});}}},{key:'onSubmit',value:function onSubmit(e){this.getLearnerLoginHistory();e.preventDefault();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(next){this.getLearnerLoginHistory();}},{key:'getLearnerLoginHistory',value:function getLearnerLoginHistory(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+'learning/login-history',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,start_date:this.state.startDate,end_date:this.state.endDate})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this2.setState({pageOfItems:[],learnerHistorytime:responseJson.learnerHistorytime,total_co:responseJson.total_count});}__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();});}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});}},{key:'componentDidMount',value:function componentDidMount(){this.getLearnerLoginHistory();$("#datestart").datepicker({dateFormat:'yy-mm-dd',changeMonth:true,yearRange:"-10:+0",changeYear:true,onSelect:function(selected,evnt){this.setState({startDate:selected});}.bind(this)});$("#dateend").datepicker({dateFormat:'yy-mm-dd',changeMonth:true,yearRange:"-10:+0",changeYear:true,onSelect:function(selected,evnt){this.setState({endDate:selected});}.bind(this)});//Common.showSmallLeftMenu();
}},{key:'render',value:function render(){var _this3=this;//alert(JSON.stringify(this.state.learnerHistorytime));<Left onClick={this.showComponetDetails} />
var learnerHistorytime=this.state.pageOfItems.map(function(learnerHistorytime,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'learnerHistorytime_'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'evenbg'},learnerHistorytime.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'evenbg'},learnerHistorytime.count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:learnerHistorytime.login_timing}})));});learnerHistorytime.length==0?learnerHistorytime=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3'},'No Histories found.')):learnerHistorytime=learnerHistorytime;var radio=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('radio',true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/login_history_img.png",alt:'',border:'0',align:'absmiddle'})),'Login History',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Date and time of past logins.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance opinion-polls login-history'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},radio!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-li'},'No. of hours spent till date:'),' 6 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-li'},'hrs'),' 10 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-li'},'min'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-rgt'},'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-li'},'Average No. of hours spent by all:'),' 22 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-li'},'hrs'),' 10 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'his-li'},'min'),' ')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'My total visits till date - ',this.state.total_co),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-history-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'loginhistory_form',onSubmit:this.onSubmit,action:'',method:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-history-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'From Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.state.startDate,name:'datestart',id:'datestart',className:'txtdate'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'To Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.state.endtDate,name:'dateend',id:'dateend',className:'txtdate'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Search',name:'',title:'Search'}))))),radio!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mockupdemo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tblResponsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'15%'},'Login Data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'15%'},'No. of Logins'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'70%'},'Time of Login(IST)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'05-Dec-2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'12.50 PM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'09.45 PM')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'04-Dec-2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'10.20 AM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'10.09 PM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'1.09 PM')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'03-Dec-2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'12.12 PM')))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-table table-cont-login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{border:'0',width:'100%',cellPadding:'0',cellSpacing:'0',className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Login Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No. of logins'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Time of login ( IST )'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,learnerHistorytime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__helpers_Pagination__["a" /* default */],{items:this.state.learnerHistorytime,onChangePage:function onChangePage(e){return _this3.onChangePage(e);}}))))))))));}}]);return LoginHistory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginHistory);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contractpartials_Contentproceed__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contractpartials_Decline__ = __webpack_require__(440);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contracts=function(_Component){_inherits(Contracts,_Component);function Contracts(props){_classCallCheck(this,Contracts);var _this=_possibleConstructorReturn(this,(Contracts.__proto__||Object.getPrototypeOf(Contracts)).call(this,props));_this.goToThanksPage=_this.goToThanksPage.bind(_this);_this.state={contract:[],proceedBlock:true};return _this;}_createClass(Contracts,[{key:'getContract',value:function getContract(id){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'contracts/'+id,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){_this2.setState({contract:responseJson.data,proceedBlock:true});__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'declineBlock',value:function declineBlock(){this.setState({proceedBlock:false});__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();}},{key:'continueContract',value:function continueContract(){var data=this.props.data;this.getContract(data.id);}},{key:'declineContract',value:function declineContract(){var _this3=this;var data=this.props.data;var query_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id};window.swal({//title: 'Attention!',
text:'Are you sure want to proceed this action?',//type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'contracts/decline',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify(query_data)}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==2){if(_this3.props.usableType=="webapp"){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["c" /* clearUserData */]();window.location=window.location+"/#/login";}}});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getContract(data.id);}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'render',value:function render(){var _this4=this;var contract=this.state.contract;var _props=this.props,data=_props.data,usableType=_props.usableType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:contract.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Contract',className:'ct_complete_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,contract.contract_name?contract.contract_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,contract.base_line?contract.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.proceedBlock?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__contractpartials_Contentproceed__["a" /* default */],{data:data,usableType:usableType,contract:contract,backToComponentList:function backToComponentList(e){return _this4.backToComponentList();},declineBlock:function declineBlock(e){return _this4.declineBlock();}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__contractpartials_Decline__["a" /* default */],{usableType:usableType,continueContract:function continueContract(e){return _this4.continueContract();},declineContract:function declineContract(e){return _this4.declineContract();},goToThanksPage:this.goToThanksPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)));}}]);return Contracts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Contracts);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pdfview__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_learningRoomAction__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
//import Previous_Next from '../components/Previous_Next';
var $=window.$;var Anouncement=function(_Component){_inherits(Anouncement,_Component);function Anouncement(props){_classCallCheck(this,Anouncement);var _this=_possibleConstructorReturn(this,(Anouncement.__proto__||Object.getPrototypeOf(Anouncement)).call(this,props));_this.compeletestatus="";_this.state={anouncet:[],anouncesorting:[],learner_id:'',learningroom_id:''};return _this;}_createClass(Anouncement,[{key:'getAnnouncement',value:function getAnnouncement(id,learner_id){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'anouncement/getanouncement',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({a_id:id,learner_id:learner_id})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({anouncet:responseJson.allvalues,anouncesorting:responseJson.sorting});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},2000);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.state.learner_id=data.learner_id;this.state.learningroom_id=data.learning_room_id;this.compeletestatus=data.status;this.getAnnouncement(data.id,data.learner_id);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;this.getAnnouncement(data.id,data.learner_id);}},{key:'pdf_frame',value:function pdf_frame(pdf_files){var styled={width:'100%',padding:'15px 1.9%',minHeight:'500px'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'1',className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'',title:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'PDF Annoncement')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'announcementpdf',className:'announcement',src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_pdf_files/'+pdf_files,style:styled}));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var v_file_extension=video_files.split(".");var playlist='';if(v_file_extension[1]=='mp4'){playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_video_files/'+video_files}]}};}else if(v_file_extension[1]=='m3u8'){playlist={share:false,splash:true,ratio:9/16,//playlist: [
clip:{title:"",hlsjs:{// enable subtitle display
subtitles:true,// enable audio ABR
audioABR:true},// template based vod quality selector plugin configuration
vodQualities:{template:"//edge.flowplayer.org/functional-{q}.{ext}",qualities:["160p",{label:"260p",src:"//edge.flowplayer.org/functional.{ext}"},"530p","800p"]},sources:[{type:"application/x-mpegurl",//src: "http://localhost/videosrc/leela.m3u8"
src:"https://dn9p8lkvkvcok.cloudfront.net/"+video_files}],rtmp:"rtmp://s3b78u0kbtx79q.cloudfront.net/cfx/st"},//],
embed:false};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_video',className:'announcement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:Date.now(),className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{width:'320',height:'240',controls:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_video_files/'+video_files,type:'video/mp4'}),'Your browser does not support the video tag.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'v_text',dangerouslySetInnerHTML:{__html:text}}));}},{key:'audio_frame',value:function audio_frame(audio_files,text){var control_style={position:'relative'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_audio',className:'announcement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{style:control_style,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_audio_files/'+audio_files,type:'audio/mpeg',width:'400',height:'50'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_text',dangerouslySetInnerHTML:{__html:text}}));}},{key:'image_frame',value:function image_frame(image_files,image_description,text_message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_image',className:'announcement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcementtext'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/announcement_image_files/"+image_files,alt:'',className:'announceimg',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:image_description}}));}},{key:'text_frame',value:function text_frame(text_files){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_text',className:'announcement announcement-nw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:text_files}}));}},{key:'onsubmit',value:function onsubmit(){var _this3=this;var data=this.props.data;var cant=this.state.anouncet;if(cant.audio_file!=''||cant.video_file!=''){var message='Finished watching/listening? ';message=cant.audio_file!=''&&cant.video_file==''?'Finished listening? ':message;message=cant.audio_file==''&&cant.video_file!=''?'Finished watching? ':message;var rsfbacl=cant.Isvisible!='1'?'You will not be able to come back to it later.':'';window.swal({//title: 'View!',
text:message+rsfbacl,// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){_this3.saveallfn();}});}else{this.saveallfn();}}},{key:'saveallfn',value:function saveallfn(){var _this4=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'anouncement/saveall',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),dlr_id:data.dlr_id})}).then(function(response){return response.json();}).then(function(responseJson){_this4.props.getLearningRoom();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */]();if(responseJson.isCompletedFully){_this4.goToThanksPage();}else{_this4.props.switchback(responseJson.result);}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */]();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},900);});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'sortinglists',value:function sortinglists(type){var data=this.state.anouncet;var retval='';switch(type){case'pdf':if(data.pdf_file!=null&&data.pdf_file!=''){var pdfpath=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_pdf_files/'+data.pdf_file;retval=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Pdfview__["a" /* default */],{key:'pdf_view_0',pdfpath:pdfpath,title:'PDF'});//this.pdf_frame(data.pdf_file);
}break;case'video':if(data.video_file!=null&&data.video_file!=''||data.video_filename!=null&&data.video_filename!=''){if(data.video_filename!=''){retval=this.video_frame(data.video_filename,data.video_description);}else if(data.video_file!=''){retval=this.video_frame(data.video_file,data.video_description);}}break;case'audio':if(data.audio_file!=null&&data.audio_file!=''){retval=this.audio_frame(data.audio_file,data.audio_description);}break;case'image':if(data.image_file!=null&&data.image_file!=''){retval=this.image_frame(data.image_file,data.image_description,data.message);}break;case'text':if(data.message!=null&&data.message!=''){retval=this.text_frame(data.message);}break;}return retval;}},{key:'submitbuttons',value:function submitbuttons(){var _this5=this;if(this.compeletestatus=='completed'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active',className:'button annonbtn gotobtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnsubmit',value:'Continue',alt:'Continue',title:'Continue',type:'button',onClick:function onClick(e){return _this5.onsubmit();}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active',className:'button annonbtn gotobtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnsubmit',value:'Go to next page',alt:'Go to next page',title:'Go to next page',type:'button',onClick:function onClick(e){return _this5.onsubmit();}}));}}},{key:'render',value:function render(){var _this6=this;var data=this.state.anouncet;var asorting=this.state.anouncesorting;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Annoncement',className:'an_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.anouncement_name?data.anouncement_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},asorting.map(function(val,key){return _this6.sortinglists(val);}),this.submitbuttons()))))));}}]);return Anouncement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_8__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Anouncement));

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TimerCountDown__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_actiongoalAction__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_ckeditor_wrapper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_ckeditor_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_ckeditor_wrapper__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import * as Common from '../helpers/Common';
var $=window.$;var Courseworkcomp=function(_React$Component){_inherits(Courseworkcomp,_React$Component);function Courseworkcomp(props){_classCallCheck(this,Courseworkcomp);var _this=_possibleConstructorReturn(this,(Courseworkcomp.__proto__||Object.getPrototypeOf(Courseworkcomp)).call(this,props));_this.state={observerViewBlock:"none",courseWorkViewBlock:"none",AssessementViewData:[],front_image:'',coursework:[],reportbtn:"block",reportBlock:"none",courseworkAnswerBlock:'none',reportText:'',Rating:"",CourseworkAnswer:[],LearningCompletedStatus:null,greaterdate:'',removeImage:'',isMentorCheck:false,OBmessage:"",CANWSstatus:0,timeForCompletion:0,timerSeconds:0,allow_latersubmit:0,display_date_tolater:''};_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);return _this;}_createClass(Courseworkcomp,[{key:'onChangeCKEditor',value:function onChangeCKEditor(name,value){this.setState(_defineProperty({},name,value));}},{key:'getLearningCompletedStatus',value:function getLearningCompletedStatus(){var _this2=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");//let query_data=Common.objToSlashString({
var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learner-component-status/view'+query_data+'?expand=completed_date,Cscore',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){_this2.setState({LearningCompletedStatus:responseJson.data});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getAssess',value:function getAssess(){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),seq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,comp_id:data.id,type:'course_work'});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'mentor-assess/view'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){_this3.setState({AssessementViewData:responseJson.data});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getCoursework',value:function getCoursework(id){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'coursework/'+id+'?expand=course_work_file,validity_date',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){var cw=responseJson.data;var greaterdate=null;var expiryDate=null;var newExpiryDate=null;if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true)){greaterdate=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true);expiryDate=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true).split("-");newExpiryDate=new Date(expiryDate[0]+"/"+expiryDate[1]+"/"+expiryDate[2]);if(cw.submitlater_due>0){_this4.setState({allow_latersubmit:cw.submitlater_due});if(cw.validity_date.timestamp<Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["D" /* toTimestamp */])(newExpiryDate)){_this4.setState({display_date_tolater:cw.validity_date.display});greaterdate=cw.validity_date.display;}}}var isMentor=true;if(cw.evaluation_mentor==0){isMentor=false;}var ObEcoObj={evaluation_mentor:cw.evaluation_mentor,evaluation_ecoach:cw.evaluation_ecoach,mentor_perform:cw.mentor_perform,ecoach_perform:cw.ecoach_perform,mentor_view:cw.mentor_view,ecoach_view:cw.ecoach_view};var pamessage=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["b" /* ObserverEcoachMessage */])(ObEcoObj);_this4.setState({coursework:cw,greaterdate:greaterdate,isMentorCheck:isMentor,OBmessage:pamessage,timeForCompletion:cw.total_duration,timerSeconds:cw.total_duration*60});_this4.getLearningCompletedStatus();_this4.getAssess();_this4.switchBlock();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'handleImageAllChange',value:function handleImageAllChange(e){if(this.refs.reportfile.files[0]!=undefined){var reader=new FileReader();var self=this;var removeAnchor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return self.removeImage();},style:{color:'#ff0000',textDecoration:'underline'}},'X Remove Attachment');reader.onload=function(e){if(e.target.result.match(/image/g)){self.setState({front_image:e.target.result,removeImage:removeAnchor});}else{self.setState({front_image:'',removeImage:removeAnchor});}};reader.readAsDataURL(this.refs.reportfile.files[0]);}}},{key:'removeImage',value:function removeImage(){this.refs.reportfile.value='';this.setState({front_image:'',removeImage:''});}},{key:'viewReportBlock',value:function viewReportBlock(type){if(type=="proceed"){this.setState({reportbtn:'none',reportBlock:'block'});}if(type=="cancel"){this.setState({reportbtn:'block',reportBlock:'none'});}}},{key:'getCourseworkAnswer',value:function getCourseworkAnswer(){var _this5=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),comp_id:data.id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,seq_id:data.compseq_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'coursework-answer/view'+query_data+'?expand=filename',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){// alert(responseJson.status);
if(responseJson.status==1){_this5.setState({reportbtn:"none",reportBlock:"none",CourseworkAnswer:responseJson.data,CANWSstatus:1});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this6=this;var data=this.props.data;var request_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,observers:obj,coursework:this.state.coursework,ag:data.is_ag!=""?data.ag_id:""};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'coursework/observer-proceed',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==2){_this6.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this6.goToThanksPage();}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,'success');if(_this6.props.usableType=="webapp"){_this6.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('Something went wrong.','error');}});}},{key:'submitReport',value:function submitReport(){var _this7=this;var data=this.props.data;var formData=new FormData();var request_data={reportText:this.state.reportText,comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,ag:data.is_ag!=""?data.ag_id:""};for(var key in request_data){formData.append(key,request_data[key]);}if(this.state.coursework.learnerefortrating==1){formData.append('Rating',this.state.Rating);}if(this.refs.reportfile.files[0]!=undefined){formData.append('reportfile',this.refs.reportfile.files[0]);}else{formData.append('reportfile','');}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"coursework/submit-report",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');//message('error',responseJson.message,responseJson.errors);
}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();_this7.props.getLearningRoom();if(responseJson.isCompletedFully){_this7.goToThanksPage();}else{if(responseJson.observerblock){_this7.setState({LearningCompletedStatus:responseJson.data,observerViewBlock:"block",courseWorkViewBlock:"none"});}else{//Common.message(responseJson.message,'','success');
//Common.message('Submitted successfully','','success');
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])("","Submitted successfully.");if(_this7.props.usableType=="webapp"){_this7.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}}});}},{key:'submitLater',value:function submitLater(){var _this8=this;window.swal({//title: 'Attention!',
text:'Complete the course work and submit by  '+this.state.greaterdate+'.',//type: 'question',
//showCancelButton: true,
confirmButtonColor:'#14a430',animation:false,//cancelButtonColor: '#d33',
confirmButtonText:'Ok'}).then(function(result){//console.log(result.value);
//console.log(result.dismiss);
if(result){var data=_this8.props.data;var request_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,due_date:_this8.state.greaterdate,ag:data.is_ag!=""?data.ag_id:""};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"coursework/submit-report-later",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{// Common.message("Submitted successfully.",'','success');
if(_this8.props.usableType=="webapp"){_this8.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}});}});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'switchBlock',value:function switchBlock(){var _this9=this;var data=this.props.data;setTimeout(function(){if(data.status=="completed"){_this9.setState({observerViewBlock:"none",courseWorkViewBlock:"block",courseworkAnswerBlock:"block"});}else if(data.status=="incompleted"){//alert(this.state.isMentorCheck);
if(_this9.state.isMentorCheck){if(_this9.state.CANWSstatus==1){_this9.setState({courseWorkViewBlock:"none",courseworkAnswerBlock:"none",observerViewBlock:"block"});}else{_this9.setState({courseWorkViewBlock:"block",courseworkAnswerBlock:"none",observerViewBlock:"none"});}}else{// this.setState({
//  observerViewBlock:"none",
//  courseWorkViewBlock:"none",
//  courseworkAnswerBlock:"block"
// });
if(_this9.state.CANWSstatus==1){_this9.setState({courseWorkViewBlock:"none",courseworkAnswerBlock:"block",observerViewBlock:"none"});}else{_this9.setState({courseWorkViewBlock:"block",courseworkAnswerBlock:"none",observerViewBlock:"none"});}}}else{_this9.setState({observerViewBlock:"none",courseWorkViewBlock:"block",courseworkAnswerBlock:"none"});}},400);}},{key:'timeUp',value:function timeUp(){var _this10=this;var data=this.props.data;var formData=new FormData();var request_data={reportText:this.state.reportText,comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,ag:data.is_ag!=""?data.ag_id:""};for(var key in request_data){formData.append(key,request_data[key]);}if(this.state.coursework.learnerefortrating==1){formData.append('Rating',this.state.Rating);}if(this.refs.reportfile.files[0]!=undefined){formData.append('reportfile',this.refs.reportfile.files[0]);}else{formData.append('reportfile','');}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"coursework/submit-timeup",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{_this10.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this10.goToThanksPage();}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errorMsg,'warning');if(_this10.props.usableType=="webapp"){_this10.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getCourseworkAnswer();this.getCoursework(data.id);if(data.is_ag){this.props.getActiongoalAction(data.ag_id);}}},{key:'render',value:function render(){var _this11=this;var data=this.props.data;var cw=this.state.coursework;var CwAnswer=this.state.CourseworkAnswer;var LCStatus=this.state.LearningCompletedStatus;var Ratings=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["t" /* ratings */];var video_player=null;var audio_player=null;var front_image=null;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};if(cw.course_work_video!=undefined&&cw.course_work_video!=''){var video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/course_work_video/'+cw.course_work_video}]}};video_player=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{playlist:video_playlist,trackData:trackData});}if(cw.coursework_audio!=undefined&&cw.coursework_audio!=''){var control_style={position:'relative'};audio_player=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/course_work_audio/'+cw.coursework_audio,type:'audio/mpeg',width:'400',height:'50'}));}if(this.state.front_image!=''){front_image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'front_image',src:this.state.front_image,width:'150'});}var subMitLaterButton=null;if(cw.submit_later>0){if(LCStatus==null&&data.status==""){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit Later',alt:'Submit Later',className:'button-cancel',value:'Submit Later',id:'submitlater',name:'submitlater',onClick:function onClick(e){return _this11.submitLater();}});}if(this.state.allow_latersubmit>0&&this.state.display_date_tolater!=''&&LCStatus!=null){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'submit_laterdate'},'Last date of submission - ',this.state.display_date_tolater);}else if(LCStatus!=null){if(LCStatus.allow_later!=1){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit Later',alt:'Submit Later',className:'button-cancel',value:'Submit Later',id:'submitlater',name:'submitlater',onClick:function onClick(e){return _this11.submitLater();}});}}}var Score=null;if(LCStatus!=null){if(LCStatus.Cscore!=""&&this.state.CANWSstatus!=0){Score=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_scorePA'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Score: '),LCStatus.Cscore);}}var DontShow=0;var AssessementViewListBlock=null;if(cw.evaluation_mentor!=undefined){if(cw.evaluation_mentor==0&&cw.evaluation_ecoach==0){DontShow=1;}}if(DontShow==0&&this.state.CANWSstatus!=0&&LCStatus!=null){if(LCStatus.allow_later==0){AssessementViewListBlock=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_AssessementViewList__["a" /* default */],{data:this.state.AssessementViewData});}}var Timer=null;if(cw.total_duration>0&&this.state.CANWSstatus==0&&data.dlr_id){Timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_TimerCountDown__["a" /* default */],{seconds:this.state.timerSeconds,onComplete:function onComplete(e){return _this11.timeUp();}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},Timer,data.is_ag!=""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img_action_goal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img_action_goal1.gif",width:'58',height:'82',alt:'Action Goal',title:'Action Goal',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ag_title_arrow'},this.props.actionGoal.ag_name!=undefined?this.props.actionGoal.ag_name:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cw.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:cw.alt_text?cw.alt_text:'',className:'cw_completed_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,cw.course_work_name?cw.course_work_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},cw.base_line?cw.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scroll',id:'semana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview',style:{top:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.observerViewBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__partials_ThanksMessage__["a" /* default */],{message:this.state.OBmessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.courseWorkViewBlock}},this.state.CANWSstatus!=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LCStatus!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,cw.learnerefortrating==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LCStatus.state!=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,DontShow==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LERresult'},'My effort rating of this component is - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,LCStatus.self_rating!=undefined?LCStatus.self_rating:0,' / 7 ',LCStatus.self_rating!=undefined?Ratings[LCStatus.self_rating]:"",'  ')):"")))),DontShow==0?Score:"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),AssessementViewListBlock,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txtnoP '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox-inner'},video_player!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player),audio_player!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:cw.instruction?cw.instruction:''}}),cw.course_work_file!=undefined&&cw.course_work_file!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_left'},cw.course_work_file.length>0&&cw.course_work_file.map(function(i,j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'downloadfile_'+j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/course_work_file/'+i,className:'redlnk',target:'_blank',style:{lineHeight:'20px',float:'left',margin:"0px 10px"},title:'Download file '+(j+1)},'Download file ',i,' ',''+(j+1)),'\xA0\xA0');})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.reportbtn},id:'submitlink',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reportbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this11.viewReportBlock('proceed');},title:'Submit',alt:'Submit',className:'button-accept',value:'Submit'})),subMitLaterButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'report',style:{position:'relative',display:this.state.reportBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PACWans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Report ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{lass:'txtareaborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_ckeditor_wrapper___default.a,{value:this.state.reportText,onChange:this.onChangeCKEditor.bind(this,'reportText'),config:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["a" /* CKsettings */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},'File  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'reportfile',ref:'reportfile',size:'80',id:'reportfile',onChange:function onChange(e){return _this11.handleImageAllChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),front_image,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.removeImage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg',style:{color:'#ff5400'}},'Max file size accepted: 5 MB (Single file)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG'))),cw.learnerefortrating==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learnerratingPACW'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate'},'I would rate my efforts in actioning this component as ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'Rating',id:'Rating',value:this.state.Rating,onChange:function onChange(e){return _this11.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Poor ( 1 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Below Average ( 2 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Average ( 3 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'Above Average ( 4 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'Good ( 5 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'Excellent ( 6 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'Outstanding ( 7 )')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ShowSubmit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',style:{float:'right'},name:'btnreport',value:'Submit',onClick:function onClick(e){return _this11.submitReport();},className:'button-accept',alt:'Submit',title:'Submit'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',style:{float:'right'},name:'btncancel',value:'Cancel',className:'button-cancel',alt:'Cancel',title:'Cancel',onClick:function onClick(e){return _this11.viewReportBlock('cancel');}})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.courseworkAnswerBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Report'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:CwAnswer.message?CwAnswer.message:''}}),CwAnswer.filename!=null&&CwAnswer.filename!=""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/course_work_file/'+CwAnswer.filename,className:'redlnk',target:'_blank',style:{float:'left',marginTop:0},title:'Download file'},'Download file ',CwAnswer.filename))):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this11.backToComponentList();},name:'btnsubmit',value:'Continue',className:'button_org',alt:'Continue',title:'Continue'})))))))));}}]);return Courseworkcomp;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state,ownProps){return{actionGoal:state.actionGoal};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_11__actions_learningRoomAction__["a" /* getLearningRoom */],getActiongoalAction:__WEBPACK_IMPORTED_MODULE_12__actions_actiongoalAction__["a" /* getActiongoalAction */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Courseworkcomp));

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizePerPageDropDown = exports.ButtonGroup = exports.SearchField = exports.ClearSearchButton = exports.ExportCSVButton = exports.ShowSelectedOnlyButton = exports.DeleteButton = exports.InsertButton = exports.InsertModalFooter = exports.InsertModalBody = exports.InsertModalHeader = exports.TableHeaderColumn = exports.BootstrapTable = undefined;

var _BootstrapTable = __webpack_require__(441);

var _BootstrapTable2 = _interopRequireDefault(_BootstrapTable);

var _TableHeaderColumn = __webpack_require__(227);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _InsertModalHeader = __webpack_require__(234);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalBody = __webpack_require__(236);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

var _InsertModalFooter = __webpack_require__(235);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertButton = __webpack_require__(237);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(238);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(239);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(240);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _ClearSearchButton = __webpack_require__(242);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

var _SearchField = __webpack_require__(241);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ButtonGroup = __webpack_require__(479);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _SizePerPageDropDown = __webpack_require__(230);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof window !== 'undefined') {
  window.BootstrapTable = _BootstrapTable2.default;
  window.TableHeaderColumn = _TableHeaderColumn2.default;
  window.InsertModalHeader = _InsertModalHeader2.default;
  window.InsertModalBody = _InsertModalBody2.default;
  window.InsertModalFooter = _InsertModalFooter2.default;
  window.InsertButton = _InsertButton2.default;
  window.DeleteButton = _DeleteButton2.default;
  window.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
  window.ExportCSVButton = _ExportCSVButton2.default;
  window.ClearSearchButton = _ClearSearchButton2.default;
  window.SearchField = _SearchField2.default;
  window.ButtonGroup = _ButtonGroup2.default;
  window.SizePerPageDropDown = _SizePerPageDropDown2.default;
}
exports.BootstrapTable = _BootstrapTable2.default;
exports.TableHeaderColumn = _TableHeaderColumn2.default;
exports.InsertModalHeader = _InsertModalHeader2.default;
exports.InsertModalBody = _InsertModalBody2.default;
exports.InsertModalFooter = _InsertModalFooter2.default;
exports.InsertButton = _InsertButton2.default;
exports.DeleteButton = _DeleteButton2.default;
exports.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
exports.ExportCSVButton = _ExportCSVButton2.default;
exports.ClearSearchButton = _ClearSearchButton2.default;
exports.SearchField = _SearchField2.default;
exports.ButtonGroup = _ButtonGroup2.default;
exports.SizePerPageDropDown = _SizePerPageDropDown2.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(442);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(7), __webpack_require__(3), __webpack_require__(126), __webpack_require__(127), __webpack_require__(443)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('prop-types'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-store'), require('./SAlertContentTmpl'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.propTypes, global.sAlertTools, global.sAlertStore, global.SAlertContentTmpl);
        global.SAlertContent = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _propTypes, _sAlertTools, _sAlertStore, _SAlertContentTmpl) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _SAlertContentTmpl2 = _interopRequireDefault(_SAlertContentTmpl);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContent = function (_React$Component) {
        _inherits(SAlertContent, _React$Component);

        function SAlertContent(props) {
            _classCallCheck(this, SAlertContent);

            return _possibleConstructorReturn(this, (SAlertContent.__proto__ || Object.getPrototypeOf(SAlertContent)).call(this, props));
        }

        _createClass(SAlertContent, [{
            key: 'handleCloseAlert',
            value: function handleCloseAlert() {
                var closingTimeout = void 0;
                var alertId = this.props.id;
                var currentAlertElem = _reactDom2.default.findDOMNode(this);
                var animationClose = function animationClose() {
                    currentAlertElem.style.display = 'none';
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                    clearTimeout(closingTimeout);
                };
                if (document.hidden || document.webkitHidden || !currentAlertElem.classList.contains('s-alert-is-effect')) {
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                } else {
                    currentAlertElem.classList.remove('s-alert-show');
                    closingTimeout = setTimeout(function () {
                        currentAlertElem.classList.add('s-alert-hide');
                    }, 100);
                    currentAlertElem.removeEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.removeEventListener('animationend', animationClose, false);
                    currentAlertElem.addEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.addEventListener('animationend', animationClose, false);
                }
                // stop audio when closing
                this.alertAudio && this.alertAudio.load();
            }
        }, {
            key: 'componentWillMount',
            value: function componentWillMount() {
                var beep = this.props.beep;
                var condition = this.props.condition;
                if (beep && typeof beep === 'string') {
                    this.alertAudio = new Audio(beep);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'info') {
                    this.alertAudio = new Audio(beep.info);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'error') {
                    this.alertAudio = new Audio(beep.error);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'success') {
                    this.alertAudio = new Audio(beep.success);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'warning') {
                    this.alertAudio = new Audio(beep.warning);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                if (typeof this.props.timeout === 'number') {
                    this.closeTimer = setTimeout(function () {
                        _this2.handleCloseAlert();
                    }, this.props.timeout);
                }
                if (this.props.onShow) {
                    this.props.onShow();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer);
                }
                if (this.props.onClose) {
                    this.props.onClose();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var classNames = 's-alert-box s-alert-' + this.props.condition + ' s-alert-' + this.props.position + ' ' + (this.props.effect ? 's-alert-is-effect s-alert-effect-' + this.props.effect : '') + ' s-alert-show';
                var message = this.props.html ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.message } }) : this.props.message;
                var styles = this.props.boxPosition ? _sAlertTools2.default.styleToObj(this.props.boxPosition) : {};
                var id = this.props.id;
                var handleClose = this.handleCloseAlert.bind(this);
                var contentTemplate = this.props.contentTemplate || _SAlertContentTmpl2.default;
                var customFields = this.props.customFields || {};
                var condition = this.props.condition;

                return _react2.default.createElement(contentTemplate, { classNames: classNames, id: id, styles: styles, message: message, handleClose: handleClose, customFields: customFields, condition: condition });
            }
        }]);

        return SAlertContent;
    }(_react2.default.Component);

    SAlertContent.propTypes = {
        condition: _propTypes2.default.string.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
        position: _propTypes2.default.string.isRequired,
        boxPosition: _propTypes2.default.string,
        id: _propTypes2.default.string.isRequired,
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlertContent;
});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

var _Date = __webpack_require__(445);

var _Date2 = _interopRequireDefault(_Date);

var _Text = __webpack_require__(446);

var _Text2 = _interopRequireDefault(_Text);

var _Regex = __webpack_require__(447);

var _Regex2 = _interopRequireDefault(_Regex);

var _Select = __webpack_require__(448);

var _Select2 = _interopRequireDefault(_Select);

var _Number = __webpack_require__(449);

var _Number2 = _interopRequireDefault(_Number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint default-case: 0 */
/* eslint guard-for-in: 0 */


var TableHeaderColumn = function (_Component) {
  _inherits(TableHeaderColumn, _Component);

  function TableHeaderColumn(props) {
    _classCallCheck(this, TableHeaderColumn);

    var _this = _possibleConstructorReturn(this, (TableHeaderColumn.__proto__ || Object.getPrototypeOf(TableHeaderColumn)).call(this, props));

    _this.handleColumnClick = function () {
      return _this.__handleColumnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilter = _this.handleFilter.bind(_this);
    return _this;
  }

  _createClass(TableHeaderColumn, [{
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      return this.__handleColumnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.cleanFiltered();
      }

      // If column not displaying the same dataField, reset the filter accordingly
      if (nextProps.filter && nextProps.dataField !== this.props.dataField) {
        var emitter = nextProps.filter.emitter || {};
        var currentFilter = emitter.currentFilter || {};
        var filter = currentFilter[nextProps.dataField];
        var value = filter ? filter.value : '';

        var _ref = this.getFilters(nextProps) || {},
            ref = _ref.ref;

        if (this.refs[ref]) {
          this.refs[ref].setState({ value: value });
        }
      }
    }
  }, {
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      if (this.props.isOnlyHead || !this.props.dataSort) return;
      var order = this.props.sort;

      if (!order && this.props.defaultASC) order = _Const2.default.SORT_ASC;else order = this.props.sort === _Const2.default.SORT_DESC ? _Const2.default.SORT_ASC : _Const2.default.SORT_DESC;
      this.props.onSort(order, this.props.dataField);
    }
  }, {
    key: 'handleFilter',
    value: function handleFilter(value, type) {
      var filter = this.props.filter;

      filter.emitter.handleFilter(this.props.dataField, value, type, filter);
    }
  }, {
    key: 'getFilters',
    value: function getFilters() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var headerText = props.headerText,
          children = props.children;

      switch (props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            return _react2.default.createElement(_Text2.default, _extends({ ref: function ref(n) {
                return _this2.textFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            return _react2.default.createElement(_Regex2.default, _extends({ ref: function ref(n) {
                return _this2.regexFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            return _react2.default.createElement(_Select2.default, _extends({ ref: function ref(n) {
                return _this2.selectFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            return _react2.default.createElement(_Number2.default, _extends({ ref: function ref(n) {
                return _this2.numberFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            return _react2.default.createElement(_Date2.default, _extends({ ref: function ref(n) {
                return _this2.dateFilter = n;
              } }, props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            var elm = props.filter.getElement(this.handleFilter, props.filter.customFilterParameters);

            return _react2.default.cloneElement(elm, { ref: function ref(n) {
                return _this2.customFilter = n;
              } });
          }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.headerCol.setAttribute('data-field', this.props.dataField);
    }
  }, {
    key: 'renderDefaultCaret',
    value: function renderDefaultCaret(dataSort, isBootstrap4) {
      if (!dataSort) return null;
      if (isBootstrap4) {
        return _react2.default.createElement('span', { className: 'order fa fa-sort',
          style: { margin: '10px 0 10px 5px', color: '#ccc' } });
      } else {
        return _react2.default.createElement(
          'span',
          { className: 'order' },
          _react2.default.createElement(
            'span',
            { className: 'dropdown' },
            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0 10px 5px', color: '#ccc' } })
          ),
          _react2.default.createElement(
            'span',
            { className: 'dropup' },
            _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0', color: '#ccc' } })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var defaultCaret = void 0;
      var sortCaret = void 0;
      var sortClass = void 0;
      var _props = this.props,
          headerText = _props.headerText,
          dataAlign = _props.dataAlign,
          dataField = _props.dataField,
          headerAlign = _props.headerAlign,
          headerTitle = _props.headerTitle,
          hidden = _props.hidden,
          sort = _props.sort,
          dataSort = _props.dataSort,
          sortIndicator = _props.sortIndicator,
          children = _props.children,
          caretRender = _props.caretRender,
          className = _props.className,
          isOnlyHead = _props.isOnlyHead,
          version = _props.version,
          customSortClass = _props.sortHeaderColumnClassName,
          style = _props.thStyle;

      var thStyle = _extends({
        textAlign: headerAlign || dataAlign,
        display: hidden ? 'none' : null
      }, style);
      var isBootstrap4 = _util2.default.isBootstrap4(version);
      if (!isOnlyHead) {
        if (sortIndicator) {
          defaultCaret = this.renderDefaultCaret(dataSort, isBootstrap4);
        }
        sortCaret = sort ? _util2.default.renderReactSortCaret(sort, isBootstrap4) : defaultCaret;
        if (caretRender) {
          sortCaret = caretRender(sort, dataField);
        }
      }

      if (sort) {
        sortClass = _util2.default.isFunction(customSortClass) ? customSortClass(sort, dataField) : customSortClass;
      }
      var classes = (0, _classnames2.default)(_util2.default.isFunction(className) ? className() : className, !isOnlyHead && dataSort ? 'sort-column' : '', sortClass);

      var attr = {};
      if (headerTitle) {
        if (typeof children === 'string' && !headerText) {
          attr.title = children;
        } else {
          attr.title = headerText;
        }
      }
      return _react2.default.createElement(
        'th',
        _extends({ ref: function ref(node) {
            return _this3.headerCol = node;
          },
          className: classes,
          style: thStyle,
          onClick: this.handleColumnClick,
          rowSpan: this.props.rowSpan,
          colSpan: this.props.colSpan,
          'data-is-only-head': this.props.isOnlyHead
        }, attr),
        children,
        sortCaret,
        _react2.default.createElement(
          'div',
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          this.props.filter && !isOnlyHead ? this.getFilters() : null
        )
      );
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      if (!this.props.filter) return;

      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.textFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.regexFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.selectFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.numberFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.dateFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            this.customFilter.cleanFiltered();
            break;
          }
      }
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(val) {
      if (!this.props.filter) return;
      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.textFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.regexFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.selectFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.numberFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.dateFilter.applyFilter(val);
            break;
          }
      }
    }
  }]);

  return TableHeaderColumn;
}(_react.Component);

var filterTypeArray = [];
for (var key in _Const2.default.FILTER_TYPE) {
  filterTypeArray.push(_Const2.default.FILTER_TYPE[key]);
}

TableHeaderColumn.propTypes = {
  dataField: _propTypes2.default.string,
  dataAlign: _propTypes2.default.string,
  headerAlign: _propTypes2.default.string,
  headerTitle: _propTypes2.default.bool,
  headerText: _propTypes2.default.string,
  dataSort: _propTypes2.default.bool,
  onSort: _propTypes2.default.func,
  dataFormat: _propTypes2.default.func,
  csvFormat: _propTypes2.default.func,
  csvHeader: _propTypes2.default.string,
  csvFieldType: _propTypes2.default.oneOf([_Const2.default.CSV_STRING_TYPE, _Const2.default.CSV_NUMBER_TYPE]),
  isKey: _propTypes2.default.bool,
  editable: _propTypes2.default.any,
  hidden: _propTypes2.default.bool,
  hiddenOnInsert: _propTypes2.default.bool,
  searchable: _propTypes2.default.bool,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  width: _propTypes2.default.string,
  sortFunc: _propTypes2.default.func,
  sortFuncExtraData: _propTypes2.default.any,
  sortHeaderColumnClassName: _propTypes2.default.any,
  columnClassName: _propTypes2.default.any,
  editColumnClassName: _propTypes2.default.any,
  invalidEditColumnClassName: _propTypes2.default.any,
  columnTitle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.string]),
  filterFormatted: _propTypes2.default.bool,
  filterValue: _propTypes2.default.func,
  sort: _propTypes2.default.string,
  caretRender: _propTypes2.default.func,
  formatExtraData: _propTypes2.default.any,
  csvFormatExtraData: _propTypes2.default.any,
  filter: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(filterTypeArray),
    delay: _propTypes2.default.number,
    options: _propTypes2.default.oneOfType([_propTypes2.default.object, // for SelectFilter
    _propTypes2.default.arrayOf(_propTypes2.default.number) // for NumberFilter
    ]),
    numberComparators: _propTypes2.default.arrayOf(_propTypes2.default.string),
    emitter: _propTypes2.default.object,
    placeholder: _propTypes2.default.string,
    getElement: _propTypes2.default.func,
    customFilterParameters: _propTypes2.default.object,
    condition: _propTypes2.default.oneOf([_Const2.default.FILTER_COND_EQ, _Const2.default.FILTER_COND_LIKE])
  }),
  sortIndicator: _propTypes2.default.bool,
  export: _propTypes2.default.bool,
  expandable: _propTypes2.default.bool,
  tdAttr: _propTypes2.default.object,
  editTdAttr: _propTypes2.default.object,
  tdStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  thStyle: _propTypes2.default.object,
  keyValidator: _propTypes2.default.bool,
  defaultASC: _propTypes2.default.bool
};

TableHeaderColumn.defaultProps = {
  dataAlign: 'left',
  headerAlign: undefined,
  headerTitle: true,
  dataSort: false,
  dataFormat: undefined,
  csvFormat: undefined,
  csvHeader: undefined,
  csvFieldType: _Const2.default.CSV_STRING_TYPE,
  isKey: false,
  editable: true,
  onSort: undefined,
  hidden: false,
  hiddenOnInsert: false,
  searchable: true,
  className: '',
  columnTitle: false,
  width: null,
  sortFunc: undefined,
  columnClassName: '',
  editColumnClassName: '',
  invalidEditColumnClassName: '',
  filterFormatted: false,
  filterValue: undefined,
  sort: undefined,
  formatExtraData: undefined,
  sortFuncExtraData: undefined,
  filter: undefined,
  sortIndicator: true,
  expandable: true,
  tdAttr: undefined,
  editTdAttr: undefined,
  tdStyle: undefined,
  thStyle: undefined,
  keyValidator: false,
  defaultASC: false
};

var _default = TableHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableHeaderColumn, 'TableHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(filterTypeArray, 'filterTypeArray', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
}();

;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editor = function editor(editable, attr, format, editorClass, defaultValue, ignoreEditable, row) {
  if (editable === true || editable === false && ignoreEditable || typeof editable === 'string') {
    // simple declare
    var type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: type, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (!editable) {
    var _type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type, defaultValue: defaultValue,
      disabled: 'disabled',
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable && (editable.type === undefined || editable.type === null || editable.type.trim() === '')) {
    var _type2 = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type2, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable.type) {
    // standard declare
    // put style if exist
    editable.style && (attr.style = editable.style);
    // put class if exist
    attr.className = (editorClass || '') + ' form-control editor edit-' + editable.type + (editable.className ? ' ' + editable.className : '');

    if (editable.type === 'select') {
      // process select input
      var options = [];
      var values = editable.options.values;
      var _editable$options = editable.options,
          textKey = _editable$options.textKey,
          valueKey = _editable$options.valueKey;

      if (_util2.default.isFunction(values)) {
        values = values(row);
      }
      if (Array.isArray(values)) {
        // only can use arrray data for options
        var text = void 0;
        var value = void 0;
        options = values.map(function (option, i) {
          if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
            text = textKey ? option[textKey] : option.text;
            value = valueKey ? option[valueKey] : option.value;
          } else {
            text = format ? format(option) : option;
            value = option;
          }
          return _react2.default.createElement(
            'option',
            { key: 'option' + i, value: value },
            text
          );
        });
      }
      return _react2.default.createElement(
        'select',
        _extends({}, attr, { defaultValue: defaultValue }),
        options
      );
    } else if (editable.type === 'textarea') {
      // process textarea input
      // put other if exist
      editable.cols && (attr.cols = editable.cols);
      editable.rows && (attr.rows = editable.rows);
      var saveBtn = void 0;
      var keyUpHandler = attr.onKeyDown;
      if (keyUpHandler) {
        attr.onKeyDown = function (e) {
          if (e.keyCode !== 13) {
            // not Pressed ENTER
            keyUpHandler(e);
          }
        };
        saveBtn = _react2.default.createElement(
          'button',
          {
            className: 'btn btn-info btn-xs textarea-save-btn',
            onClick: keyUpHandler },
          'save'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('textarea', _extends({}, attr, { defaultValue: defaultValue })),
        saveBtn
      );
    } else if (editable.type === 'checkbox') {
      var _values = 'true:false';
      if (editable.options && editable.options.values) {
        // values = editable.options.values.split(':');
        _values = editable.options.values;
      }
      attr.className = attr.className.replace('form-control', '');
      attr.className += ' checkbox pull-right';

      var checked = defaultValue && defaultValue.toString() === _values.split(':')[0] ? true : false;

      return _react2.default.createElement('input', _extends({}, attr, { type: 'checkbox',
        value: _values, defaultChecked: checked }));
    } else if (editable.type === 'datetime') {
      return _react2.default.createElement('input', _extends({}, attr, { type: 'datetime-local', defaultValue: defaultValue }));
    } else {
      // process other input type. as password,url,email...
      return _react2.default.createElement('input', _extends({}, attr, { type: editable.type, defaultValue: defaultValue }));
    }
  }
  // default return for other case of editable
  return _react2.default.createElement('input', _extends({}, attr, { type: 'text',
    className: (editorClass || '') + ' form-control editor edit-text' }));
};

var _default = editor;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(editor, 'editor', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');
}();

;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notice = undefined;

var _reactSAlert = __webpack_require__(225);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notice = function notice(type, msg, title) {
  var titleHTML = title ? '<h4><strong>' + title + '</strong></h4>' : '';

  var bodyHTML = '\n    ' + titleHTML + '\n    <div>\n      <span class=\'fa fa-exclamation-triangle glyphicon glyphicon-alert\'></span>&nbsp;\n      <span>' + msg + '</span>\n    </div>\n  ';

  _reactSAlert2.default.error(bodyHTML, {
    position: 'top-right',
    timeout: 3000,
    html: true,
    effect: 'scale'
  });
};

exports.notice = notice;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(notice, 'notice', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');
}();

;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';

var SizePerPageDropDown = function (_Component) {
  _inherits(SizePerPageDropDown, _Component);

  function SizePerPageDropDown() {
    _classCallCheck(this, SizePerPageDropDown);

    return _possibleConstructorReturn(this, (SizePerPageDropDown.__proto__ || Object.getPrototypeOf(SizePerPageDropDown)).apply(this, arguments));
  }

  _createClass(SizePerPageDropDown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          hidden = _props.hidden,
          onClick = _props.onClick,
          onBlur = _props.onBlur,
          options = _props.options,
          className = _props.className,
          variation = _props.variation,
          btnContextual = _props.btnContextual,
          isBootstrap4 = _props.isBootstrap4,
          currSizePerPage = _props.currSizePerPage;


      if (hidden) return null;

      var openClass = open ? 'open show' : '';

      var renderOptions = function renderOptions() {
        var attrs = {
          className: 'dropdown-menu ' + openClass,
          role: 'menu',
          'aria-labelledby': 'pageDropDown'
        };
        var type = isBootstrap4 ? 'div' : 'ul';

        return _react2.default.createElement(type, attrs, options);
      };

      return _react2.default.createElement(
        'span',
        {
          className: variation + ' ' + openClass + ' ' + className + ' ' + sizePerPageDefaultClass },
        _react2.default.createElement(
          'button',
          { className: 'btn ' + btnContextual + ' dropdown-toggle',
            id: 'pageDropDown', 'data-toggle': 'dropdown',
            'aria-expanded': open,
            'aria-haspopup': !open,
            onClick: onClick,
            onBlur: onBlur },
          currSizePerPage,
          _react2.default.createElement(
            'span',
            null,
            ' ',
            _react2.default.createElement('span', { className: 'caret' })
          )
        ),
        renderOptions()
      );
    }
  }]);

  return SizePerPageDropDown;
}(_react.Component);

SizePerPageDropDown.propTypes = {
  open: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  currSizePerPage: _propTypes2.default.string,
  options: _propTypes2.default.array,
  variation: _propTypes2.default.oneOf(['dropdown', 'dropup']),
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onBlur: _propTypes2.default.func
};
SizePerPageDropDown.defaultProps = {
  open: false,
  hidden: false,
  btnContextual: 'btn-default btn-secondary',
  variation: 'dropdown',
  className: ''
};

var _default = SizePerPageDropDown;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sizePerPageDefaultClass, 'sizePerPageDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(SizePerPageDropDown, 'SizePerPageDropDown', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
}();

;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(467);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalHeader = function (_Component) {
  _inherits(InsertModalHeader, _Component);

  function InsertModalHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalHeader.__proto__ || Object.getPrototypeOf(InsertModalHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalHeader, [{
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onModalClose = _props.onModalClose,
          beforeClose = _props.beforeClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: 'renderContent',
    value: function renderContent(closeBtn) {
      var _props2 = this.props,
          version = _props2.version,
          titleText = _props2.title;

      var title = _react2.default.createElement(
        'h4',
        { key: 'title', className: 'modal-title' },
        titleText
      );
      if (_util2.default.isBootstrap4(version)) {
        return [title, closeBtn];
      } else {
        return _react2.default.createElement(
          'span',
          null,
          closeBtn,
          title
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          hideClose = _props3.hideClose,
          className = _props3.className,
          children = _props3.children;


      var closeBtn = hideClose ? null : _react2.default.createElement(
        'button',
        { type: 'button',
          className: 'close', onClick: this.handleCloseBtnClick },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        ),
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          'Close'
        )
      );

      var content = children || this.renderContent(closeBtn);

      return _react2.default.createElement(
        'div',
        { className: 'modal-header ' + className },
        content
      );
    }
  }]);

  return InsertModalHeader;
}(_react.Component);

InsertModalHeader.propTypes = {
  version: _propTypes2.default.string,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  onModalClose: _propTypes2.default.func,
  hideClose: _propTypes2.default.bool,
  beforeClose: _propTypes2.default.func
};
InsertModalHeader.defaultProps = {
  version: '3',
  className: '',
  title: 'Add Row',
  onModalClose: undefined,
  hideClose: false,
  beforeClose: undefined
};

var _default = InsertModalHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalHeader, 'InsertModalHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');
}();

;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalFooter = function (_Component) {
  _inherits(InsertModalFooter, _Component);

  function InsertModalFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalFooter.__proto__ || Object.getPrototypeOf(InsertModalFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleSaveBtnClick = function () {
      var _this3;

      return (_this3 = _this).__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalFooter, [{
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__() {
      return this.__handleCloseBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          beforeClose = _props.beforeClose,
          onModalClose = _props.onModalClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(e) {
      var _props2 = this.props,
          beforeSave = _props2.beforeSave,
          onSave = _props2.onSave;

      beforeSave && beforeSave(e);
      onSave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          saveBtnText = _props3.saveBtnText,
          closeBtnText = _props3.closeBtnText,
          closeBtnContextual = _props3.closeBtnContextual,
          saveBtnContextual = _props3.saveBtnContextual,
          closeBtnClass = _props3.closeBtnClass,
          saveBtnClass = _props3.saveBtnClass,
          children = _props3.children;


      var content = children || [_react2.default.createElement(
        'button',
        {
          key: 'closeBtn',
          type: 'button',
          className: 'btn ' + closeBtnContextual + ' ' + closeBtnClass,
          onClick: this.handleCloseBtnClick },
        closeBtnText
      ), _react2.default.createElement(
        'button',
        {
          key: 'saveBtn',
          type: 'button',
          className: 'btn ' + saveBtnContextual + ' ' + saveBtnClass,
          onClick: this.handleSaveBtnClick },
        saveBtnText
      )];

      return _react2.default.createElement(
        'div',
        { className: 'modal-footer ' + className },
        content
      );
    }
  }]);

  return InsertModalFooter;
}(_react.Component);

InsertModalFooter.propTypes = {
  className: _propTypes2.default.string,
  saveBtnText: _propTypes2.default.string,
  closeBtnText: _propTypes2.default.string,
  closeBtnContextual: _propTypes2.default.string,
  saveBtnContextual: _propTypes2.default.string,
  closeBtnClass: _propTypes2.default.string,
  saveBtnClass: _propTypes2.default.string,
  beforeClose: _propTypes2.default.func,
  beforeSave: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func
};
InsertModalFooter.defaultProps = {
  className: '',
  saveBtnText: _Const2.default.SAVE_BTN_TEXT,
  closeBtnText: _Const2.default.CLOSE_BTN_TEXT,
  closeBtnContextual: 'btn-default btn-secondary',
  saveBtnContextual: 'btn-primary',
  closeBtnClass: '',
  saveBtnClass: '',
  beforeClose: undefined,
  beforeSave: undefined
};

var _default = InsertModalFooter;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalFooter, 'InsertModalFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');
}();

;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editor = __webpack_require__(228);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/display-name: 0 */


var InsertModalBody = function (_Component) {
  _inherits(InsertModalBody, _Component);

  function InsertModalBody() {
    _classCallCheck(this, InsertModalBody);

    return _possibleConstructorReturn(this, (InsertModalBody.__proto__ || Object.getPrototypeOf(InsertModalBody)).apply(this, arguments));
  }

  _createClass(InsertModalBody, [{
    key: 'getFieldValue',
    value: function getFieldValue() {
      var _this2 = this;

      var newRow = {};
      this.props.columns.forEach(function (column, i) {
        var inputVal = void 0;
        if (column.autoValue) {
          // when you want same auto generate value and not allow edit, example ID field
          var time = new Date().getTime();
          inputVal = typeof column.autoValue === 'function' ? column.autoValue() : 'autovalue-' + time;
        } else if (column.hiddenOnInsert || !column.field) {
          inputVal = '';
        } else {
          var dom = _this2.refs[column.field + i];
          inputVal = dom.value;

          if (column.editable && column.editable.type === 'checkbox') {
            var values = inputVal.split(':');
            inputVal = dom.checked ? values[0] : values[1];
          } else if (column.customInsertEditor) {
            inputVal = inputVal || dom.getFieldValue();
          }
        }
        newRow[column.field] = inputVal;
      }, this);
      return newRow;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          validateState = _props.validateState,
          ignoreEditable = _props.ignoreEditable;

      return _react2.default.createElement(
        'div',
        { className: 'modal-body' },
        columns.map(function (column, i) {
          var editable = column.editable,
              format = column.format,
              field = column.field,
              name = column.name,
              autoValue = column.autoValue,
              hiddenOnInsert = column.hiddenOnInsert,
              customInsertEditor = column.customInsertEditor;

          var attr = {
            ref: field + i,
            placeholder: editable.placeholder ? editable.placeholder : name
          };
          var fieldElement = void 0;
          var defaultValue = editable.defaultValue || undefined;
          if (customInsertEditor) {
            var getElement = customInsertEditor.getElement;

            fieldElement = getElement(column, attr, 'form-control', ignoreEditable, defaultValue);
          }

          // fieldElement = false, means to use default editor when enable custom editor
          // Becasuse some users want to have default editor based on some condition.
          if (!customInsertEditor || fieldElement === false) {
            fieldElement = (0, _Editor2.default)(editable, attr, format, '', defaultValue, ignoreEditable);
          }

          if (autoValue || hiddenOnInsert || !column.field) {
            // when you want same auto generate value
            // and not allow edit, for example ID field
            return null;
          }
          var error = validateState[field] ? _react2.default.createElement(
            'span',
            { className: 'help-block bg-danger' },
            validateState[field]
          ) : null;
          return _react2.default.createElement(
            'div',
            { className: 'form-group', key: field },
            _react2.default.createElement(
              'label',
              null,
              name
            ),
            fieldElement,
            error
          );
        })
      );
    }
  }]);

  return InsertModalBody;
}(_react.Component);

InsertModalBody.propTypes = {
  columns: _propTypes2.default.array,
  validateState: _propTypes2.default.object,
  ignoreEditable: _propTypes2.default.bool
};

InsertModalBody.defaultProps = {
  validateState: {},
  ignoreEditable: false
};

var _default = InsertModalBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalBody, 'InsertModalBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');
}();

;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var insertBtnDefaultClass = 'react-bs-table-add-btn';

var InsertButton = function (_Component) {
  _inherits(InsertButton, _Component);

  function InsertButton() {
    _classCallCheck(this, InsertButton);

    return _possibleConstructorReturn(this, (InsertButton.__proto__ || Object.getPrototypeOf(InsertButton)).apply(this, arguments));
  }

  _createClass(InsertButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + insertBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return InsertButton;
}(_react.Component);

InsertButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
InsertButton.defaultProps = {
  btnText: _Const2.default.INSERT_BTN_TEXT,
  btnContextual: 'btn-info',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-plus fa-plus'
};

var _default = InsertButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(insertBtnDefaultClass, 'insertBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(InsertButton, 'InsertButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
}();

;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deleteBtnDefaultClass = 'react-bs-table-del-btn';

var DeleteButton = function (_Component) {
  _inherits(DeleteButton, _Component);

  function DeleteButton() {
    _classCallCheck(this, DeleteButton);

    return _possibleConstructorReturn(this, (DeleteButton.__proto__ || Object.getPrototypeOf(DeleteButton)).apply(this, arguments));
  }

  _createClass(DeleteButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + deleteBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return DeleteButton;
}(_react.Component);

DeleteButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
DeleteButton.defaultProps = {
  btnText: _Const2.default.DELETE_BTN_TEXT,
  btnContextual: 'btn-warning',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-trash fa-trash'
};

var _default = DeleteButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(deleteBtnDefaultClass, 'deleteBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(DeleteButton, 'DeleteButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
}();

;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var exportCsvBtnDefaultClass = 'react-bs-table-csv-btn';

var ExportCSVButton = function (_Component) {
  _inherits(ExportCSVButton, _Component);

  function ExportCSVButton() {
    _classCallCheck(this, ExportCSVButton);

    return _possibleConstructorReturn(this, (ExportCSVButton.__proto__ || Object.getPrototypeOf(ExportCSVButton)).apply(this, arguments));
  }

  _createClass(ExportCSVButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'fa glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + exportCsvBtnDefaultClass + ' ' + className + ' hidden-print',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ExportCSVButton;
}(_react.Component);

ExportCSVButton.propTypes = {
  btnText: _propTypes2.default.string,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  btnGlyphicon: _propTypes2.default.string
};
ExportCSVButton.defaultProps = {
  btnText: _Const2.default.EXPORT_CSV_TEXT,
  btnContextual: 'btn-success',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-export fa-download'
};

var _default = ExportCSVButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(exportCsvBtnDefaultClass, 'exportCsvBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(ExportCSVButton, 'ExportCSVButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
}();

;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var showSelectedOnlyBtnDefaultClass = 'react-bs-table-show-sel-only-btn';

var ShowSelectedOnlyButton = function (_Component) {
  _inherits(ShowSelectedOnlyButton, _Component);

  function ShowSelectedOnlyButton() {
    _classCallCheck(this, ShowSelectedOnlyButton);

    return _possibleConstructorReturn(this, (ShowSelectedOnlyButton.__proto__ || Object.getPrototypeOf(ShowSelectedOnlyButton)).apply(this, arguments));
  }

  _createClass(ShowSelectedOnlyButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          toggle = _props.toggle,
          showAllText = _props.showAllText,
          showOnlySelectText = _props.showOnlySelectText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'toggle', 'showAllText', 'showOnlySelectText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        toggle ? showAllText : showOnlySelectText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          'aria-pressed': 'false',
          'data-toggle': 'button',
          className: 'btn ' + btnContextual + ' ' + showSelectedOnlyBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ShowSelectedOnlyButton;
}(_react.Component);

ShowSelectedOnlyButton.propTypes = {
  showAllText: _propTypes2.default.string,
  showOnlySelectText: _propTypes2.default.string,
  toggle: _propTypes2.default.bool,
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
ShowSelectedOnlyButton.defaultProps = {
  showAllText: _Const2.default.SHOW_ALL,
  showOnlySelectText: _Const2.default.SHOW_ONLY_SELECT,
  toggle: false,
  btnContextual: 'btn-primary',
  className: '',
  onClick: undefined
};

var _default = ShowSelectedOnlyButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(showSelectedOnlyBtnDefaultClass, 'showSelectedOnlyBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(ShowSelectedOnlyButton, 'ShowSelectedOnlyButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
}();

;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchField = function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).apply(this, arguments));
  }

  _createClass(SearchField, [{
    key: 'getValue',
    value: function getValue() {
      return _reactDom2.default.findDOMNode(this).value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      _reactDom2.default.findDOMNode(this).value = value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          onKeyUp = _props.onKeyUp,
          rest = _objectWithoutProperties(_props, ['className', 'defaultValue', 'placeholder', 'onKeyUp']);

      return _react2.default.createElement('input', _extends({
        className: 'form-control ' + className,
        type: 'text',
        defaultValue: defaultValue,
        placeholder: placeholder || SearchField.defaultProps.placeholder,
        onKeyUp: onKeyUp,
        style: { zIndex: 0 }
      }, rest));
    }
  }]);

  return SearchField;
}(_react.Component);

SearchField.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onKeyUp: _propTypes2.default.func
};
SearchField.defaultProps = {
  className: '',
  defaultValue: '',
  placeholder: 'Search',
  onKeyUp: undefined
};

var _default = SearchField;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchField, 'SearchField', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');
}();

;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var clearBtnDefaultClass = 'react-bs-table-search-clear-btn';

var ClearSearchButton = function (_Component) {
  _inherits(ClearSearchButton, _Component);

  function ClearSearchButton() {
    _classCallCheck(this, ClearSearchButton);

    return _possibleConstructorReturn(this, (ClearSearchButton.__proto__ || Object.getPrototypeOf(ClearSearchButton)).apply(this, arguments));
  }

  _createClass(ClearSearchButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({
          className: 'btn ' + btnContextual + ' ' + className + ' ' + clearBtnDefaultClass,
          type: 'button',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ClearSearchButton;
}(_react.Component);

ClearSearchButton.propTypes = {
  btnContextual: _propTypes2.default.string,
  className: _propTypes2.default.string,
  btnText: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
ClearSearchButton.defaultProps = {
  btnContextual: 'btn-default btn-secondary',
  className: '',
  btnText: 'Clear',
  onClick: undefined
};

var _default = ClearSearchButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(clearBtnDefaultClass, 'clearBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(ClearSearchButton, 'ClearSearchButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
}();

;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(85);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(247);
var hide = __webpack_require__(53);
var Iterators = __webpack_require__(136);
var $iterCreate = __webpack_require__(487);
var setToStringTag = __webpack_require__(141);
var getPrototypeOf = __webpack_require__(493);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(486);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(42) && !__webpack_require__(67)(function () {
  return Object.defineProperty(__webpack_require__(246)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
var document = __webpack_require__(36).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(53);


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(43);
var toIObject = __webpack_require__(55);
var arrayIndexOf = __webpack_require__(489)(false);
var IE_PROTO = __webpack_require__(138)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(250);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(134);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(248);
var hiddenKeys = __webpack_require__(140).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(89);
var createDesc = __webpack_require__(86);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(135);
var has = __webpack_require__(43);
var IE8_DOM_DEFINE = __webpack_require__(245);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(42) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TimerCountDown__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_actiongoalAction__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import * as Common from '../helpers/Common';
var $=window.$;var Practiceassigment=function(_Component){_inherits(Practiceassigment,_Component);function Practiceassigment(props){_classCallCheck(this,Practiceassigment);var _this=_possibleConstructorReturn(this,(Practiceassigment.__proto__||Object.getPrototypeOf(Practiceassigment)).call(this,props));_this.state={observerViewBlock:"none",PractiseAssViewBlock:"none",AssessementViewData:[],LearningCompletedStatus:null,paAnswerBlock:'none',PaAnswer:[],front_image:'',reportText:'',Rating:"",practiceAssignment:[],reportbtn:'block',reportBlock:'none',insttypeOption:'',greaterdate:'',removeImage:'',instructionBlockB:'block',instructionBlockA:'block',isMentorCheck:false,OBmessage:"",Pastatus:0,timeForCompletion:0,timerSeconds:0,allow_latersubmit:0,display_date_tolater:''};_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);return _this;}_createClass(Practiceassigment,[{key:'onChangeCKEditor',value:function onChangeCKEditor(name,value){this.setState(_defineProperty({},name,value));}},{key:'getAssess',value:function getAssess(){var _this2=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),seq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,comp_id:data.id,type:'practise_assignment'});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'mentor-assess/view'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){_this2.setState({AssessementViewData:responseJson.data});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getPaAnswer',value:function getPaAnswer(){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),comp_id:data.id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,seq_id:data.compseq_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'pa-answer/view'+query_data+'?expand=filename',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){var instructionBlockA="none";var instructionBlockB="none";if(responseJson.data.instruction_type==="b"){instructionBlockA="none";instructionBlockB="block";}if(responseJson.data.instruction_type==="a"){instructionBlockA="block";instructionBlockB="none";}_this3.setState({reportbtn:"none",reportBlock:"none",instructionBlockA:instructionBlockA,instructionBlockB:instructionBlockB,PaAnswer:responseJson.data,Pastatus:1});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getPracticeAssignment',value:function getPracticeAssignment(id){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice-assignment/'+id+'?expand=validity_date',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){var pa=responseJson.data;var greaterdate=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true);var expiryDate=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true).split("-");var newExpiryDate=new Date(expiryDate[0]+"/"+expiryDate[1]+"/"+expiryDate[2]);if(pa.submitlater_due>0){_this4.setState({allow_latersubmit:pa.submitlater_due});//this.state.allow_latersubmit=pa.submitlater_due;
if(pa.validity_date.timestamp<Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["D" /* toTimestamp */])(newExpiryDate)){_this4.setState({display_date_tolater:pa.validity_date.display});greaterdate=pa.validity_date.display;}}var isMentor=true;if(pa.evaluation_mentor===0){isMentor=false;}var ObEcoObj={evaluation_mentor:pa.evaluation_mentor,evaluation_ecoach:pa.evaluation_ecoach,mentor_perform:pa.mentor_perform,ecoach_perform:pa.ecoach_perform,mentor_view:pa.mentor_view,ecoach_view:pa.ecoach_view};var pamessage=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["b" /* ObserverEcoachMessage */])(ObEcoObj);_this4.setState({practiceAssignment:pa,greaterdate:greaterdate,isMentorCheck:isMentor,OBmessage:pamessage,timeForCompletion:pa.total_duration,timerSeconds:pa.total_duration*60});_this4.getLearningCompletedStatus();_this4.getAssess();_this4.switchBlock();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getLearningCompletedStatus',value:function getLearningCompletedStatus(){var _this5=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learner-component-status/view'+query_data+'?expand=completed_date,Cscore',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){_this5.setState({LearningCompletedStatus:responseJson.data});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'handleImageAllChange',value:function handleImageAllChange(e){if(this.refs.reportfile.files[0]!==undefined){var reader=new FileReader();var self=this;var removeAnchor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return self.removeImage();},style:{color:'#ff0000',textDecoration:'underline'}},'X Remove Attachment');reader.onload=function(e){if(e.target.result.match(/image/g)){self.setState({front_image:e.target.result,removeImage:removeAnchor});}else{self.setState({front_image:'',removeImage:removeAnchor});}};reader.readAsDataURL(this.refs.reportfile.files[0]);}}},{key:'removeImage',value:function removeImage(){this.refs.reportfile.value='';this.setState({front_image:'',removeImage:''});}},{key:'instruction',value:function instruction(e){this.setState({insttypeOption:e.target.value});}},{key:'viewReportBlock',value:function viewReportBlock(type){if(type==="proceed"){if(!this.state.insttypeOption){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('Attention','Please select an option to submit your report.','warning');}else{this.setState({reportbtn:'none',reportBlock:'block'});}}if(type==="cancel"){this.setState({reportbtn:'block',reportBlock:'none'});}}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this6=this;var data=this.props.data;var request_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,observers:obj,practiceAssignment:this.state.practiceAssignment,ag:data.is_ag!==""?data.ag_id:""};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice-assignment/observer-proceed',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===2){_this6.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this6.goToThanksPage();}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,'','success');_this6.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('','Something went wrong.','error');}});}},{key:'submitReport',value:function submitReport(){var _this7=this;var data=this.props.data;var formData=new FormData();var request_data={instruction_type:this.state.insttypeOption,reportText:this.state.reportText,comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,ag:data.is_ag!==""?data.ag_id:""};for(var key in request_data){formData.append(key,request_data[key]);}if(this.state.practiceAssignment.learnerefortrating===1){formData.append('Rating',this.state.Rating);}if(this.refs.reportfile.files[0]!==undefined){formData.append('reportfile',this.refs.reportfile.files[0]);}else{formData.append('reportfile','');}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"practice-assignment/submit-report",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{_this7.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this7.goToThanksPage();}else{if(responseJson.observerblock){_this7.setState({LearningCompletedStatus:responseJson.data,observerViewBlock:"block",PractiseAssViewBlock:"none"});}else{//Common.message(responseJson.message, '', 'success');
//message("Submitted successfully",'','success');
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])("","Submitted successfully.");if(_this7.props.usableType==="webapp"){_this7.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}}});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitLater',value:function submitLater(){var _this8=this;window.swal({title:'Attention!',text:'Complete the Practice assigment and submit by '+this.state.greaterdate+'.',//type: 'question',
//showCancelButton: true,
confirmButtonColor:'#3085d6',animation:false,//cancelButtonColor: '#d33',
confirmButtonText:'Ok'}).then(function(result){//console.log(result.value);
//console.log(result.dismiss);
if(result){var data=_this8.props.data;var request_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,due_date:_this8.state.greaterdate,ag:data.is_ag!==""?data.ag_id:""};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"practice-assignment/submit-report-later",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{// Common.message("Submitted successfully.",'','success');
if(_this8.props.usableType==="webapp"){_this8.props.getLearningRoom();_this8.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}});}});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'switchBlock',value:function switchBlock(){var _this9=this;var data=this.props.data;setTimeout(function(){if(data.status==="completed"){//  console.log("completed");
_this9.setState({observerViewBlock:"none",PractiseAssViewBlock:"block",paAnswerBlock:"block"});}else if(data.status==="incompleted"){if(_this9.state.isMentorCheck){if(_this9.state.Pastatus===1){_this9.setState({PractiseAssViewBlock:"none",paAnswerBlock:"none",observerViewBlock:"block"});}else{_this9.setState({PractiseAssViewBlock:"block",paAnswerBlock:"none",observerViewBlock:"none"});}}else{// this.setState({
//     observerViewBlock: "none",
//     PractiseAssViewBlock: "none",
//     paAnswerBlock: "block"
// });
if(_this9.state.Pastatus===1){_this9.setState({PractiseAssViewBlock:"none",paAnswerBlock:"block",observerViewBlock:"none"});}else{_this9.setState({PractiseAssViewBlock:"block",paAnswerBlock:"none",observerViewBlock:"none"});}}}else{_this9.setState({observerViewBlock:"none",PractiseAssViewBlock:"block",paAnswerBlock:"none"});}},400);}},{key:'timeUp',value:function timeUp(){var _this10=this;var data=this.props.data;var formData=new FormData();var request_data={instruction_type:this.state.insttypeOption,reportText:this.state.reportText,comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,ag:data.is_ag!==""?data.ag_id:""};for(var key in request_data){formData.append(key,request_data[key]);}if(this.state.practiceAssignment.learnerefortrating===1){formData.append('Rating',this.state.Rating);}if(this.refs.reportfile.files[0]!==undefined){formData.append('reportfile',this.refs.reportfile.files[0]);}else{formData.append('reportfile','');}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"practice-assignment/submit-timeup",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{_this10.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this10.goToThanksPage();}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errorMsg,'warning');_this10.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getPaAnswer();this.getPracticeAssignment(data.id);if(data.is_ag){this.props.getActiongoalAction(data.ag_id);}setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'render',value:function render(){var _this11=this;var data=this.props.data;var paData=this.state.practiceAssignment;var LCStatus=this.state.LearningCompletedStatus;var PaAnswer=this.state.PaAnswer;var Ratings=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["t" /* ratings */];var control_style={position:'relative',zIndex:1};var video_player_a=null;var audio_player_a=null;var download_file_a=null;var front_image=null;var video_player_b=null;var audio_player_b=null;var download_file_b=null;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};if(paData.pa_video!==undefined){if(paData.pa_video!==''){var video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/pa_video/'+paData.pa_video}]}};video_player_a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:'vplayer_0',playlist:video_playlist,trackData:trackData});}}if(paData.pa_video_b!==undefined){if(paData.pa_video_b!==''){var _video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/pa_video/'+paData.pa_video_b}]}};video_player_b=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:'vplayer_1',playlist:_video_playlist,trackData:trackData});}}if(paData.pa_file_name!==undefined){if(paData.pa_file_name!==''){download_file_a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/pa_file/'+paData.pa_file_name,className:'redlnk',target:'_blank',style:{lineHeight:'20px'},title:'Download file'},'Download file');}}if(paData.pa_audio!==undefined){if(paData.pa_audio!==''){audio_player_a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/pa_audio/'+paData.pa_audio,type:'audio/mpeg',width:'400',height:'50'}));}}if(paData.pa_audio_b!==undefined){if(paData.pa_audio_b!==''){audio_player_b=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/pa_audio/'+paData.pa_audio_b,type:'audio/mpeg',width:'400',height:'50'}));}}if(paData.pa_file_name_b!==undefined){if(paData.pa_file_name_b!==''){download_file_b=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/pa_file/'+paData.pa_file_name_b,className:'redlnk',target:'_blank',style:{lineHeight:'20px'},title:'Download file'},'Download file');}}if(this.state.front_image!==''){front_image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'front_image',src:this.state.front_image,width:'150'});}var subMitLaterButton=null;if(paData.submit_later>0){if(LCStatus===null&&data.status===""){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit Later',alt:'Submit Later',className:'button-cancel',value:'Submit Later',id:'submitlater',name:'submitlater',onClick:function onClick(e){return _this11.submitLater();}});}if(this.state.allow_latersubmit>0&&this.state.display_date_tolater!=''&&LCStatus!=null){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'submit_laterdate'},'Last date of submission - ',this.state.display_date_tolater);}else if(LCStatus!==null){if(LCStatus.allow_later!==1){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit Later',alt:'Submit Later',className:'button-cancel',value:'Submit Later',id:'submitlater',name:'submitlater',onClick:function onClick(e){return _this11.submitLater();}});}}}var Score=null;if(LCStatus!==null){if(LCStatus.Cscore!==""&&this.state.Pastatus!==0){Score=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_scorePA'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Score: '),LCStatus.Cscore);}}var DontShow=0;var AssessementViewListBlock=null;if(paData.evaluation_mentor===0&&paData.evaluation_ecoach===0){DontShow=1;}if(DontShow===0&&this.state.Pastatus!==0&&LCStatus!==null){if(LCStatus.allow_later===0){AssessementViewListBlock=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_AssessementViewList__["a" /* default */],{data:this.state.AssessementViewData});}}var Timer=null;if(paData.total_duration>0&&this.state.Pastatus===0&&data.dlr_id){Timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_TimerCountDown__["a" /* default */],{seconds:this.state.timerSeconds,onComplete:function onComplete(e){return _this11.timeUp();}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},Timer,data.is_ag!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img_action_goal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img_action_goal1.gif",width:'58',height:'82',alt:'Action Goal',title:'Action Goal',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ag_title_arrow'},this.props.actionGoal.ag_name!==undefined?this.props.actionGoal.ag_name:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:paData.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:paData.alt_text?paData.alt_text:'',className:'cw_completed_button'}),paData.pa_name?paData.pa_name:'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,paData.base_line?paData.base_line:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scroll',id:'semana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview',style:{top:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.observerViewBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__["a" /* default */],{message:this.state.OBmessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.PractiseAssViewBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'practice-assignment'},this.state.Pastatus!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LCStatus!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LCStatus.state!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,paData.learnerefortrating===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,DontShow===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LERresult'},'My effort rating of this component is - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,LCStatus.self_rating?LCStatus.self_rating:0,' / 7 ',LCStatus.self_rating?Ratings[LCStatus.self_rating]:"",'  ')):"")))),DontShow===0?Score:"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),AssessementViewListBlock,paData.evaluation_mentor===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:'both',height:'17px'}}),PaAnswer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:'both',padding:'0px 0 10px 7px'}},'There are 2 options for this PA. Please read both and choose any one to work on.'):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox',style:{display:this.state.instructionBlockA}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},PaAnswer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'instruction',id:'instruction',value:'a',checked:this.state.insttypeOption==='a',type:'radio',onChange:function onChange(e){return _this11.instruction(e);}}):"",' Option A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_a!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_a),audio_player_a!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_a),download_file_a?download_file_a:''),paData.pa_instruction_a!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:paData.pa_instruction_a?paData.pa_instruction_a:''}})))),PaAnswer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'or'},'(or)'):"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test',style:{display:this.state.instructionBlockB}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},PaAnswer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'instruction',id:'instruction',value:'b',checked:this.state.insttypeOption==='b',type:'radio',onChange:function onChange(e){return _this11.instruction(e);}}):"",' Option B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_b!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_b),audio_player_b!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_b),download_file_b?download_file_b:''),paData.pa_instruction_b!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:paData.pa_instruction_b?paData.pa_instruction_b:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.reportbtn},id:'submitlink',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reportbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this11.viewReportBlock('proceed');},title:'Submit Your Report',alt:'Submit Your Report',className:'button-accept',value:'Submit'})),subMitLaterButton)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'report',style:{position:'relative',display:this.state.reportBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PACWans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Report ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{lass:'txtareaborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper___default.a,{value:this.state.reportText,onChange:this.onChangeCKEditor.bind(this,'reportText'),config:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["a" /* CKsettings */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},'File ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'reportfile',ref:'reportfile',size:'80',id:'reportfile',onChange:function onChange(e){return _this11.handleImageAllChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),front_image,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.removeImage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg',style:{color:'#ff5400'}},'Max file size accepted: 5 MB (Single file)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG'))),paData.learnerefortrating===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learnerratingPACW'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate'},'I would rate my efforts in actioning this component as ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'Rating',id:'Rating',value:this.state.Rating,onChange:function onChange(e){return _this11.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Poor ( 1 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Below Average ( 2 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Average ( 3 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'Above Average ( 4 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'Good ( 5 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'Excellent ( 6 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'Outstanding ( 7 )')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ShowSubmit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',style:{float:'right'},name:'btnreport',value:'Submit',onClick:function onClick(e){return _this11.submitReport();},className:'button-accept',alt:'Submit',title:'Submit'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',style:{float:'right'},name:'btncancel',value:'Cancel',className:'button-cancel',alt:'Cancel',title:'Cancel',onClick:function onClick(e){return _this11.viewReportBlock('cancel');}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.paAnswerBlock}},PaAnswer.pa_message!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Report'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:PaAnswer.pa_message?PaAnswer.pa_message:''}}),PaAnswer.filename!==null&&PaAnswer.filename!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/pa_file/'+PaAnswer.filename,className:'redlnk',target:'_blank',style:{float:'left',marginTop:0},title:'Download file'},'Download file'))):""),this.props.usableType==="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this11.backToComponentList();},name:'btnsubmit',value:'Continue',className:'button_org',alt:'Continue',title:'Continue'})):""))))))));}}]);return Practiceassigment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{actionGoal:state.actionGoal};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_12__actions_learningRoomAction__["a" /* getLearningRoom */],getActiongoalAction:__WEBPACK_IMPORTED_MODULE_13__actions_actiongoalAction__["a" /* getActiongoalAction */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Practiceassigment));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputgenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TimerCountDown__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_AssessementViewList__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContextQuestionnaire=function(_Component){_inherits(ContextQuestionnaire,_Component);function ContextQuestionnaire(props){_classCallCheck(this,ContextQuestionnaire);var _this=_possibleConstructorReturn(this,(ContextQuestionnaire.__proto__||Object.getPrototypeOf(ContextQuestionnaire)).call(this,props));_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.state={questionaireName:"",questionaireType:"",welcomeMessage:"",noOfQuestions:"",timeForCompletion:0,timerSeconds:0,canRate:false,canAccessLR:false,altText:"",agInfo:"",questions:[],dynamicFormData:"",componentStatus:_this.props.data.status,statusMessage:"",AssessementViewData:[],showCompletedMessage:false,showAssessementTable:false,ratingText:"",rating:""};return _this;}_createClass(ContextQuestionnaire,[{key:'getContextDetails',value:function getContextDetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"get-context-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({mentor:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("mentor",true),data:data})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{var assessementTable=responseJson.data.observerEvaluation||responseJson.data.evaluationEcoach==='1',ratingText=void 0,rating=void 0;if(_this2.props.data.status==="completed"&&responseJson.data.canRate){ratingText=responseJson.data.ratingText;rating=responseJson.data.rating;}_this2.setState({questionaireName:responseJson.data.questionaireName,questionaireType:responseJson.data.questionaireType,welcomeMessage:responseJson.data.welcomeMessage,noOfQuestions:responseJson.data.noOfQuestions,timeForCompletion:responseJson.data.timeForCompletion,timerSeconds:responseJson.data.timeForCompletion*60,canRate:responseJson.data.canRate,canAccessLR:responseJson.data.canAccessLR,agInfo:responseJson.data.agInfo,altText:responseJson.data.altText,questions:responseJson.data.questions,dynamicFormData:responseJson.data,showAssessementTable:assessementTable,ratingText:ratingText,rating:rating,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.data.evaluationMentor,evaluation_ecoach:responseJson.data.evaluationEcoach,mentor_perform:responseJson.data.mentorPerform,ecoach_perform:responseJson.data.ecoachPerform,mentor_view:responseJson.data.mentorView,ecoach_view:responseJson.data.ecoachView})});if(assessementTable&&data.status==="completed"){_this2.getAssessors();}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");},200);}});}},{key:'getAssessors',value:function getAssessors(){var _this3=this;var data=this.props.data;var query_data=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["q" /* objToSlashString */])({learner_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])(),seq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,comp_id:data.id,type:"context_questionaire"});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"mentor-assess/view"+query_data,{method:"GET",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){_this3.setState({AssessementViewData:responseJson.data});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getContextDetails(data);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getContextDetails(data);}},{key:'submitContextForm',value:function submitContextForm(){var _this4=this;if(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_Validation__["a" /* runValidation */])()){var dynamicFormData=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["d" /* getFormValues */])(this.state.dynamicFormData);var rating=this.refs.rating!==undefined?this.refs.rating.value:0;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"post-context-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({mentor:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("mentor",true),form_data:dynamicFormData,rating:rating,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this4.goToThanksPage();}else{var showCompletedMessage=responseJson.componentStatus==="completed"?true:false,ratingText=_this4.state.canRate?responseJson.ratingText:"",_rating=_this4.state.canRate?responseJson.rating:"",questions=responseJson.componentStatus==="completed"?responseJson.questions:_this4.state.questions;_this4.setState({componentStatus:responseJson.componentStatus,showCompletedMessage:showCompletedMessage,questions:questions,ratingText:ratingText,rating:_rating});}}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this5=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"context/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.dynamicFormData,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this5.goToThanksPage();}else{var ratingText=_this5.state.canRate?responseJson.ratingText:"",rating=_this5.state.canRate?responseJson.rating:"";_this5.setState({questions:responseJson.questions,componentStatus:"completed",showCompletedMessage:true,ratingText:ratingText,rating:rating});}}});}},{key:'goBackToComponentList',value:function goBackToComponentList(){var data=this.props.data;this.props.switchback("component_list",data.learning_room_id,data.dlr_id);}},{key:'render',value:function render(){var _this6=this;var questionHtml=this.state.questions.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'context_question_'+key,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},'Q',key+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:val.questionLabel}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},val.questionAnswer!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'analog-ans-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:"#1e7bc0",fontWeight:"500"}},'Answer: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:"400"}},val.questionAnswer)),val.questionAnswer===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt_an'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Inputgenerator__["a" /* default */],{qDetails:val}))));});var timer,timerNote;if(this.state.componentStatus===""&&this.state.timeForCompletion>0){timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_TimerCountDown__["a" /* default */],{seconds:this.state.timerSeconds,onComplete:function onComplete(e){return _this6.submitContextForm();}});timerNote=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'To attend the next live session, you must complete this component in ',this.state.timeForCompletion,' minute(s).'));}var centerHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scroll',id:'semana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview',style:{top:"0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content analog'},this.state.componentStatus==="incompleted"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},this.state.welcomeMessage!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation',dangerouslySetInnerHTML:{__html:this.state.welcomeMessage}}),timerNote,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt noofques'},'Number of Questions : ',this.state.noOfQuestions),questionHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:"both"}})),this.state.canRate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learnerrating3 ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate'},'I would rate my efforts in actioning this component as ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'rating',className:'required','data-error-required':'Please rate your performance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select rating'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Poor ( 1 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Below Average ( 2 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Average ( 3 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'Above Average ( 4 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'Good ( 5 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'Excellent ( 6 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'Outstanding ( 7 )'))))),this.state.canAccessLR&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Submit',title:'Submit',onClick:function onClick(){return _this6.submitContextForm();}}))),this.state.componentStatus==="completed"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},this.state.showCompletedMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation success-msg'},'Successfully completed the Session.'),this.state.showAssessementTable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__partials_AssessementViewList__["a" /* default */],{data:this.state.AssessementViewData}),this.state.canRate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LERresult'},'My effort rating of this component is - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.rating,' ',this.state.ratingText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt noofques'},'Number of Questions : ',this.state.noOfQuestions),questionHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:"both"}}),this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this6.goBackToComponentList();}})):"")))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},this.state.agInfo!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action_goals'},timer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img_action_goal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img_action_goal1.gif",width:'58',height:'82',alt:'Action Goal',title:'Action Goal',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ag_title_arrow'},this.state.agInfo.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_adAG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'left',className:'aq_active_button',title:this.state.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pgad_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pgad_title'},this.state.questionaireName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lm_subtitle'},this.state.questionaireType))),centerHtml),this.state.agInfo===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},timer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.questionaireType?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aq_complete_button',title:this.state.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,this.state.questionaireName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},this.state.questionaireType)),centerHtml)));}}]);return ContextQuestionnaire;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContextQuestionnaire);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackForm=function(_Component){_inherits(FeedbackForm,_Component);function FeedbackForm(props){_classCallCheck(this,FeedbackForm);var _this=_possibleConstructorReturn(this,(FeedbackForm.__proto__||Object.getPrototypeOf(FeedbackForm)).call(this,props));_this.state={formName:"",altText:"",icon:"",questions:[],dynamicFormData:{},button_show:"",completed_ornot:""};return _this;}_createClass(FeedbackForm,[{key:'getFeedbackForm',value:function getFeedbackForm(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"get-feedback-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this2.setState({formName:responseJson.data.formName,altText:responseJson.data.altText,icon:responseJson.data.icon,button_show:responseJson.data.fb_reopen_hidebutton,completed_ornot:responseJson.data.button_showor_hide,questions:responseJson.data.questions,dynamicFormData:responseJson.data});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");},200);}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getFeedbackForm(data);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getFeedbackForm(data);}},{key:'submitFeedbackForm',value:function submitFeedbackForm(){var _this3=this;if(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Validation__["a" /* runValidation */])()){var dynamicFormData=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["d" /* getFormValues */])(this.state.dynamicFormData);var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"post-feedback-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data,form_data:dynamicFormData})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this3.goToThanksPage();}else{//alert(responseJson.message_show);
if(responseJson.message_show==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])("",responseJson.message,"success");}if(_this3.props.usableType=="webapp"){_this3.props.switchback("component_list",data.learning_room_id,data.dlr_id);}}}});}}},{key:'goToComponentlist',value:function goToComponentlist(){var data=this.props.data;this.props.switchback("component_list",data.learning_room_id,data.dlr_id);}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'render',value:function render(){var _this4=this;var feedbackQuestionsHtml=this.state.questions.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key,className:'fdbk-questn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:val.questionLabel}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greenbg'},key+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'codeno'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__["a" /* default */],{qDetails:val}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box tit-new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fb_complete_button',title:this.state.altText},this.state.icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,this.state.formName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},feedbackQuestionsHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),this.state.button_show==1&&this.state.completed_ornot=='not completed'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Continue',title:'Continue',onClick:function onClick(){return _this4.submitFeedbackForm();}})):'',this.state.button_show==1&&this.state.completed_ornot=='completed'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Continue',title:'Continue',onClick:function onClick(){return _this4.submitFeedbackForm();}})):'',this.state.button_show==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Continue',title:'Continue',onClick:function onClick(){return _this4.submitFeedbackForm();}})):''))))));}}]);return FeedbackForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FeedbackForm);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_live_clock__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_live_clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_live_clock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Webcastlive=function(_Component){_inherits(Webcastlive,_Component);function Webcastlive(props){_classCallCheck(this,Webcastlive);var _this=_possibleConstructorReturn(this,(Webcastlive.__proto__||Object.getPrototypeOf(Webcastlive)).call(this,props));_this.compeletestatus="";_this.state={vediocnt:[]};return _this;}_createClass(Webcastlive,[{key:'getLivesessiondet',value:function getLivesessiondet(data){var _this2=this;__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'webcastlive/getlivesessiondetails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data,learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */]()})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({vediocnt:responseJson});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");},200);});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var data=this.props.data;this.compeletestatus=data.status;this.getLivesessiondet(data);setInterval(function(){_this3.getLivesessiondet(data);},55000);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this4=this;var data=nextProps.data;this.compeletestatus=data.status;setTimeout(function(){_this4.getLivesessiondet(data);},300);}},{key:'golivesession',value:function golivesession(durl){if(durl!=null){window.open(durl,'_blank');}}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'render',value:function render(){var _this5=this;var vdata=this.state.vediocnt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box tit-new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Recorded Session',className:'vc_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Live Session'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wc_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cont_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blue-txt'},'Live session scheduled for: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt_bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_live_clock___default.a,{date:vdata.scheduled_start_date,format:'DD-MMM-YYYY, hh:mm a'}),' to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_live_clock___default.a,{date:vdata.scheduled_end_date,format:'hh:mm a'}),' IST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cont_dright'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blue-txt'},'Current Date and time: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt_bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_live_clock___default.a,{format:'DD-MMM-YYYY hh:mm:ss a',ticking:true}),' IST'))),vdata.session_status==='join'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'center',className:'btn_jw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ShowButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnsubmit',value:'Join the live session',alt:'Join the live session',title:'Join the live session',type:'button',onClick:function onClick(e){return _this5.golivesession(vdata.live_session_url);}}))),vdata.session_status==='expired'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'center',id:'ShowButtonExpired'},this.props.usableType==="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ShowButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnsubmit',value:'Session Lost Go to home',alt:'Session Lost Go to home',title:'Session Lost Go to home',type:'button',onClick:function onClick(e){return _this5.backToComponentList();}})):""),vdata.session_status==='missed'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'center',id:'ShowMissed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Sorry, you have missed the live session.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',null,'You will be intimated as soon as the recorded session is available for scheduling. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You may go back to the Learning Room for now.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note_gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},'Note :'),' Please make sure you have the following, before you view the session:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'blist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,'1. Internet speed of 512 kbps and higher. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,'2. Flash player 10 plugin installed in your browser. To upgrade your Flash player, please ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://get.adobe.com/flashplayer/',target:'_blank',rel:'noopener noreferrer'},'click here'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,'3. Headphones plugged in your computer. Check your headphones functioning by clicking on the play button.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('object',{classid:'clsid:D27CDB6E-AE6D-11cf-96B8-444553540000',codebase:'http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,19,0',width:'60',height:'17'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('param',{name:'movie',value:'media/click_test.swf'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('param',{name:'quality',value:'high'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('embed',{src:'media/click_test.swf',quality:'high',pluginspage:'http://www.macromedia.com/go/getflashplayer',type:'application/x-shockwave-flash',width:'60',height:'17'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'webcastbg'},'Best viewed at 1024x768 screen resolution using Firefox 2+, Internet Explorer 7+, Opera 9.6, Chrome 2+ or Safari 4 browsers.'))))))));}}]);return Webcastlive;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Webcastlive);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputgenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TimerCountDown__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_responsive_modal__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_responsive_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_responsive_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_responsive_modal_lib_react_responsive_modal_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_responsive_modal_lib_react_responsive_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_responsive_modal_lib_react_responsive_modal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var EvaluationForm=function(_Component){_inherits(EvaluationForm,_Component);function EvaluationForm(props){_classCallCheck(this,EvaluationForm);var _this=_possibleConstructorReturn(this,(EvaluationForm.__proto__||Object.getPrototypeOf(EvaluationForm)).call(this,props));_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.state={welcomeMessage:"",selfWelcomeMessage:"",scoringExplanation:"",questionName:"",questionType:"",noOfQuestions:"",selfEvaluation:false,assesorEvaluation:false,timeForCompletion:0,timerSeconds:0,canRate:false,canAccessLR:false,altText:"",agInfo:"",questions:[],dynamicFormData:"",componentStatus:_this.props.data.status,statusMessage:"",AssessementViewData:[],showCompletedMessage:false,showAssessementTable:false,completedAssessment:0,completedEvaluators:[],completedEvaluatorNames:'',acceptedEvaluators:[],notAcceptedEvaluators:[],isLearnerAnswered:false,ratingText:"",rating:"",openModal:false,relations:[]};return _this;}_createClass(EvaluationForm,[{key:'getEvaluationForm',value:function getEvaluationForm(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"get-evaluation-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({mentor:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("mentor",true),data:data})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{var assessementTable=responseJson.observerEvaluation||responseJson.evaluationEcoach==='1',ratingText=void 0,rating=void 0,isLearnerAnswered=false,completedAssessment=0,completedEvaluators=[],completedEvaluatorNames='',acceptedEvaluators=[],notAcceptedEvaluators=[];if(_this2.props.data.status==="completed"&&responseJson.canRate){ratingText=responseJson.ratingText;rating=responseJson.rating;}if(responseJson.selfEvaluation){isLearnerAnswered=responseJson.isLearnerAnswered;}if(responseJson.assesorEvaluation){completedAssessment=responseJson.completedAssessment;completedEvaluators=responseJson.completedEvaluators;completedEvaluatorNames=responseJson.completedEvaluatorNames;acceptedEvaluators=responseJson.acceptedEvaluators;notAcceptedEvaluators=responseJson.notAcceptedEvaluators;}_this2.setState({welcomeMessage:responseJson.welcomeMessage,selfWelcomeMessage:responseJson.selfWelcomeMessage,scoringExplanation:responseJson.scoringExplanation,questionName:responseJson.questionName,questionType:responseJson.questionType,noOfQuestions:responseJson.noOfQuestions,selfEvaluation:responseJson.selfEvaluation,assesorEvaluation:responseJson.assesorEvaluation,timeForCompletion:responseJson.timeForCompletion,timerSeconds:responseJson.timeForCompletion*60,canRate:responseJson.canRate,canAccessLR:responseJson.canAccessLR,agInfo:responseJson.agInfo,altText:responseJson.altText,questions:responseJson.questions,dynamicFormData:responseJson,showAssessementTable:assessementTable,completedAssessment:completedAssessment,completedEvaluators:completedEvaluators,completedEvaluatorNames:completedEvaluatorNames,acceptedEvaluators:acceptedEvaluators,notAcceptedEvaluators:notAcceptedEvaluators,isLearnerAnswered:isLearnerAnswered,ratingText:ratingText,rating:rating,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.evaluationMentor,evaluation_ecoach:responseJson.evaluationEcoach,mentor_perform:responseJson.mentorPerform,ecoach_perform:responseJson.ecoachPerform,mentor_view:responseJson.mentorView,ecoach_view:responseJson.ecoachView})});if(assessementTable&&data.status==="completed"){_this2.getAssessors();}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");},200);}});}},{key:'getAssessors',value:function getAssessors(){var _this3=this;var data=this.props.data;var query_data=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["q" /* objToSlashString */])({learner_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])(),seq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,comp_id:data.id,type:"evaluation_questionaire"});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"mentor-assess/view"+query_data,{method:"GET",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){_this3.setState({AssessementViewData:responseJson.data});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getEvaluationForm(data);this.getRelations(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("productID",true));}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getEvaluationForm(data);this.getRelations(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("productID",true));}},{key:'submitEvaluationForm',value:function submitEvaluationForm(){var _this4=this;if(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_Validation__["a" /* runValidation */])()){var dynamicFormData=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["d" /* getFormValues */])(this.state.dynamicFormData);var rating=this.refs.rating!==undefined?this.refs.rating.value:0;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"post-evaluation-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({mentor:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("mentor",true),form_data:dynamicFormData,rating:rating,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this4.goToThanksPage();}else{var showCompletedMessage=responseJson.componentStatus==="completed"?true:false,ratingText=_this4.state.canRate?responseJson.ratingText:"",_rating=_this4.state.canRate?responseJson.rating:"",questions=responseJson.componentStatus==="completed"?responseJson.questions:_this4.state.questions;_this4.setState({componentStatus:responseJson.componentStatus,showCompletedMessage:showCompletedMessage,questions:questions,ratingText:ratingText,rating:_rating});}}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this5=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluation/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.dynamicFormData,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this5.goToThanksPage();}else{var ratingText=_this5.state.canRate?responseJson.ratingText:"",rating=_this5.state.canRate?responseJson.rating:"";_this5.setState({questions:responseJson.questions,componentStatus:"completed",showCompletedMessage:true,ratingText:ratingText,rating:rating});}}});}},{key:'goBackToComponentList',value:function goBackToComponentList(){var data=this.props.data;this.props.switchback("component_list",data.learning_room_id,data.dlr_id);}},{key:'sendEvaluation',value:function sendEvaluation(){var _this6=this;if(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_Validation__["a" /* runValidation */])('evaluator-block')){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluation/send",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({evaluators:this.refs.evaluators_hidden.value,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{_this6.setState({completedEvaluators:responseJson.completedEvaluators,acceptedEvaluators:responseJson.acceptedEvaluators});$("#SendEvaluator")[0].reset();}});}}},{key:'resendEvaluation',value:function resendEvaluation(id,assessor_id){var _this7=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluation/resend",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({assessor_id:assessor_id,assessor_eval_id:id,learner_id:data.learner_id,id:data.id,learning_room_id:data.learning_room_id,compseq_id:data.compseq_id})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("",responseJson.message,"success");_this7.setState({completedEvaluators:responseJson.completedEvaluators});});}},{key:'resendEvaluationNotify',value:function resendEvaluationNotify(){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("","You can resend it tomorrow.","info");}},{key:'withDrawEvaluation',value:function withDrawEvaluation(id,assessor_id){var _this8=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluation/withdraw",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({assessor_id:assessor_id,assessor_eval_id:id,learner_id:data.learner_id,id:data.id,learning_room_id:data.learning_room_id,compseq_id:data.compseq_id})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("",responseJson.message,"success");_this8.setState({completedEvaluators:responseJson.completedEvaluators,acceptedEvaluators:responseJson.acceptedEvaluators});});}},{key:'addEvaluator',value:function addEvaluator(){var _this9=this;if(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_Validation__["a" /* runValidation */])('add-evl-block')){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluators",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({email:this.refs.email.value,assessor_name:this.refs.assessor_name.value,relationship:this.refs.relationship.value,gender:this.refs.gender_hidden.value,phone:this.refs.phone.value,learner_id:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("id",true),product_name:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */])("productName",true)})}).then(function(response){return response.json();}).then(function(responseJson){_this9.getNotAcceptedEvaluators();setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){$("#addEvaluator")[0].reset();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this9.closeEvaluatorModal();Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */])("Success!","Evaluator has been added successfully.","success");}},400);});}}},{key:'getNotAcceptedEvaluators',value:function getNotAcceptedEvaluators(){var _this10=this;var data=this.props.data;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluation/get-not-accepted-evaluator-list",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this10.setState({notAcceptedEvaluators:responseJson.notAcceptedEvaluators});});}},{key:'removeEvaluator',value:function removeEvaluator(id){var _this11=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"evaluators/delete-evaluators",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({learner_id:data.learner_id,assessor_id:id})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */])("hide");_this11.setState({notAcceptedEvaluators:responseJson.notAcceptedEvaluators});});}},{key:'getRelations',value:function getRelations(product_id){var _this12=this;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'products/'+product_id+'?expand=relationship',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){_this12.setState({relations:responseJson.data.relationship});}});}},{key:'openEvaluatorModal',value:function openEvaluatorModal(){this.setState({openModal:true});}},{key:'closeEvaluatorModal',value:function closeEvaluatorModal(){this.setState({openModal:false});}},{key:'showHide',value:function showHide(ele){var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"show";if(action==="show"){$(ele).show();}else{$(ele).hide();}}},{key:'goWithSelfEvaluation',value:function goWithSelfEvaluation(){this.setState({selfEvaluation:false,assesorEvaluation:false});}},{key:'render',value:function render(){var _this13=this;var data=this.props.data;var relationShipHtml=this.state.relations.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'relation_'+key,value:val.name},val.name);});var questionHtml=this.state.questions.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'evaluation_question_'+key,className:'fdbk-questn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greenbg'},key+1),val.questionLabel,val.questionAnswer!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'analog-ans-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:"#1e7bc0",fontWeight:"500"}},'Answer: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:"400"}},val.questionAnswer)),val.questionAnswer===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Inputgenerator__["a" /* default */],{qDetails:val})));});var completedEvaluatorHtml=this.state.completedEvaluators.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'completed_evaluator_'+key,style:val.attribute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},!val.isCompleted&&val.canResend&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button-accept mail-icon',title:'Resend',value:'Resend',onClick:function onClick(){return _this13.resendEvaluation(val.id,val.assessor_id);}}),!val.isCompleted&&!val.canResend&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button-accept mail-icon',title:'Resend',value:'Resend',onClick:function onClick(){return _this13.resendEvaluationNotify();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button-cancel',title:'Withdraw',value:'Withdraw',onClick:function onClick(){return _this13.withDrawEvaluation(val.id,val.assessor_id);}})),val.isCompleted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'--')));});var acceptedEvaluatorHtml=this.state.acceptedEvaluators.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'accepted_evaluator_'+key,style:val.attribute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'evaluators',value:val.id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["e" /* handleCheckbox */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.relationship),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.phone));});var notAcceptedEvaluatorHtml=this.state.notAcceptedEvaluators.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'not_accepted_evaluator_'+key,style:val.attribute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.relationship),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.phone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/mail_delete.gif",width:'14',height:'14',alt:'',border:'0',style:{cursor:"pointer"},onClick:function onClick(e){return _this13.removeEvaluator(val.id);}})));});var timer,timerNote;if(this.state.componentStatus===""&&this.state.timeForCompletion>0){timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_TimerCountDown__["a" /* default */],{seconds:this.state.timerSeconds,onComplete:function onComplete(e){return _this13.submitEvaluationForm();}});timerNote=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'To attend the next live session, you must complete this component in ',this.state.timeForCompletion,' minute(s).'));}var evaluatorHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'digitalquestion'},this.state.welcomeMessage!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dqmsg'},this.state.welcomeMessage),this.state.selfEvaluation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.state.questionType,' by me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'click'},!this.state.isLearnerAnswered&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'button-blue1',title:'Click here to enter',onClick:function onClick(){return _this13.goWithSelfEvaluation();}},'Click here to enter'),this.state.isLearnerAnswered&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'button-blue1',title:'Click here to view my answers',onClick:function onClick(){return _this13.goWithSelfEvaluation();}},'Click here to view my answers'))),this.state.assesorEvaluation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ppe'},this.state.questionType,' by my Evaluators'),this.state.completedAssessment<15&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bold_black'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.questionType,' Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg_txt'},'Please note that atleast 2 Evaluators should evaluate this questionnaire.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tbl_main',id:'StatusAssessor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tbl_brd_green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'1',style:{borderCollapse:"collapse"},width:'100%',id:'tbl_brd_green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'tbl_head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Evaluator\'s Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sent on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Current Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Resend/Withdraw'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,completedEvaluatorHtml)),this.state.completedEvaluators.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'manage-assessors-white'},'You have not sent the questionnaire to any Evaluator.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orange-border'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'uparrowcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/uparrow.png",alt:'',width:'35',height:'34',border:'0'})))),this.state.completedAssessment>15&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'1',style:{borderCollapse:"collapse",border:"solid 1px #e7e7e7"},width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Completed by Evaluators ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.completedEvaluatorNames))))),this.state.completedAssessment<15&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bold_black'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Accepted Evaluators to choose from')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg_txt'},'Please select the Evaluators from this list to send this questionnaire.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tbl_main tbl_brd_blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'SendEvaluator',action:'#',method:'POST'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'1',style:{borderCollapse:"collapse"},width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'tbl_head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Evaluator\'s Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Relationship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Contact No'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,acceptedEvaluatorHtml))),this.state.acceptedEvaluators.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'manage-assessors-white'},'There are no Active Evaluators. Please add new Evaluators to complete this evaluation.'),this.state.acceptedEvaluators.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'evaluators_hidden',ref:'evaluators_hidden',className:'required evaluator-block'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Send Evaluation',onClick:function onClick(){return _this13.sendEvaluation();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bold_black orange-border1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Evaluators yet to accept'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'orgtxt button-blue1',title:'Add new Evaluator',onClick:function onClick(){return _this13.openEvaluatorModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Add new Evaluator'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg_txt'},'Please contact these Evaluators to get their acceptance.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tbl_main tbl_brd_gray',id:'Awaitinglist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%',id:'tbl_brd_gray',style:{borderCollapse:"collapse",border:"solid 1px #0e63a2"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'tbl_head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Evaluator\'s Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Relationship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Contact No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,notAcceptedEvaluatorHtml)),this.state.notAcceptedEvaluators.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'manage-assessors-white'},'You have no pending Evaluators.')))));var componentHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noevalution'},this.state.componentStatus==="incompleted"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.selfWelcomeMessage!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txtLP_dq',dangerouslySetInnerHTML:{__html:this.state.selfWelcomeMessage}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt noofques'},'Number of Questions : ',this.state.noOfQuestions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'score_explanation'},'Rating Explanation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.state.scoringExplanation}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:"15px",clear:"both"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'rat_alg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'evaluation_form'},timerNote,questionHtml,this.state.canRate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate'},'I would rate my efforts in actioning this component as ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'rating',className:'required','data-error-required':'Please rate your performance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Poor ( 1 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Below Average ( 2 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Average ( 3 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'Above Average ( 4 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'Good ( 5 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'Excellent ( 6 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'Outstanding ( 7 )'))))))),this.state.canAccessLR&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Submit',title:'Submit',onClick:function onClick(){return _this13.submitEvaluationForm();}}))),this.state.componentStatus==="completed"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.showCompletedMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation success-msg'},'Successfully completed the Session.'),this.state.showAssessementTable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__partials_AssessementViewList__["a" /* default */],{data:this.state.AssessementViewData}),this.state.canRate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LERresult'},'My effort rating of this component is - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.rating,' ',this.state.ratingText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt noofques'},'Number of Questions : ',this.state.noOfQuestions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'rat_alg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'evaluation_form'},questionHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:"both"}}),this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this13.goBackToComponentList();}})):""));var centerHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview',style:{top:"0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},(this.state.selfEvaluation||this.state.assesorEvaluation)&&evaluatorHtml,!this.state.selfEvaluation&&!this.state.assesorEvaluation&&componentHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_responsive_modal___default.a,{open:this.state.openModal,onClose:function onClose(){return _this13.closeEvaluatorModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'addEvaluator',action:'#',method:'POST'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{align:'center',border:'0',width:'100%',cellPadding:'5',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title_assessors',width:'80%',colSpan:'2'},'Evaluator Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'15%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:"0",textAlign:"right"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2',height:'35',valign:'top'},'Please fill the details here for the new Evaluator.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'20%',valign:'top',className:'formlabel'},'Email ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',ref:'email',className:'txtbox required add-evl-block',onFocus:function onFocus(e){return _this13.showHide('#msgEmailChk');},onBlur:function onBlur(e){return _this13.showHide('#msgEmailChk','hide');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'msgEmailChk',className:'errorObserver',style:{display:"none"}},'Please ensure that this Email ID is correct and active, as the Evaluator will receive communication on this ID only'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{valign:'middle',className:'formlabel'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',ref:'assessor_name',className:'txtbox required add-evl-block'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Relationship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'relationship',className:'required add-evl-block'},relationShipHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Gender'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',value:'1',name:'gender',className:'rdbtn',onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);}}),' Male \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',value:'0',name:'gender',className:'rdbtn',onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);}}),' Female',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'gender_hidden',name:'gender_hidden',className:'required add-evl-block'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{valign:'middle',className:'formlabel'},'Contact No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',ref:'phone',maxLength:'10',className:'txtbox required add-evl-block',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dqbutton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit',value:'Submit',className:'button-accept',onClick:function onClick(){return _this13.addEvaluator();}}),' \xA0\xA0\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Exit',value:'Exit',className:'button-cancel',onClick:function onClick(){return _this13.closeEvaluatorModal();}})))))))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.agInfo!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action_goals'},timer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img_action_goal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img_action_goal1.gif",width:'58',height:'82',alt:'Action Goal',title:'Action Goal',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ag_title_arrow'},this.state.agInfo.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_adAG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.spanclass,title:this.state.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pgad_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pgad_title'},this.state.questionaireName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lm_subtitle'},this.state.questionaireType))),centerHtml),this.state.agInfo===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},timer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.questionType?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon-box '+data.spanclass,title:this.state.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,this.state.questionName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},this.state.questionType)),centerHtml)));}}]);return EvaluationForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EvaluationForm);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return channel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "themeListener", function() { return themeListener; });
/* harmony export (immutable) */ __webpack_exports__["createTheming"] = createTheming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_theme_provider__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_with_theme__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_theme_listener__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(92);





var channel = __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* default */];
var withTheme = Object(__WEBPACK_IMPORTED_MODULE_1__create_with_theme__["a" /* default */])();
var ThemeProvider = Object(__WEBPACK_IMPORTED_MODULE_0__create_theme_provider__["a" /* default */])();
var themeListener = Object(__WEBPACK_IMPORTED_MODULE_2__create_theme_listener__["a" /* default */])();
function createTheming() {
  var customChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* default */];

  return {
    channel: customChannel,
    withTheme: Object(__WEBPACK_IMPORTED_MODULE_1__create_with_theme__["a" /* default */])(customChannel),
    ThemeProvider: Object(__WEBPACK_IMPORTED_MODULE_0__create_theme_provider__["a" /* default */])(customChannel),
    themeListener: Object(__WEBPACK_IMPORTED_MODULE_2__create_theme_listener__["a" /* default */])(customChannel)
  };
}

/* harmony default export */ __webpack_exports__["default"] = ({
  channel: __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* default */],
  withTheme: withTheme,
  ThemeProvider: ThemeProvider,
  themeListener: themeListener,
  createTheming: createTheming
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createThemeListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(92);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function createThemeListener() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__channel__["a" /* default */];

  var contextTypes = _defineProperty({}, CHANNEL, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired);

  function initial(context) {
    if (!context[CHANNEL]) {
      throw new Error('[' + this.displayName + '] Please use ThemeProvider to be able to use WithTheme');
    }

    return context[CHANNEL].getState();
  }

  function subscribe(context, cb) {
    if (context[CHANNEL]) {
      return context[CHANNEL].subscribe(cb);
    }
  }

  function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }

  return {
    contextTypes: contextTypes,
    initial: initial,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(534);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(93);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(262);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(535);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(68);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(149);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(265);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(539);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(204);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(266);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(538);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(264);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(68);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(3);

var _ns = __webpack_require__(151);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(268);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(270));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TimerCountDown__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_actiongoalAction__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Descriptivetask3=function(_Component){_inherits(Descriptivetask3,_Component);function Descriptivetask3(props){_classCallCheck(this,Descriptivetask3);var _this=_possibleConstructorReturn(this,(Descriptivetask3.__proto__||Object.getPrototypeOf(Descriptivetask3)).call(this,props));_this.state={observerViewBlock:"none",Dt3ViewBlock:"none",AssessementViewData:[],LearningCompletedStatus:null,dtAnswerBlock:'none',dt3Answer:[],front_image_A:'',front_image_B:'',front_image_C:'',reportText_A:'',reportText_B:'',reportText_C:'',Rating:"",dt3Data:[],reportbtn:'block',reportBlock_A:'none',reportBlock_B:'none',reportBlock_C:'none',insttypeOption:[],insttypeOption_A:'',insttypeOption_B:'',insttypeOption_C:'',greaterdate:'',removeImage_A:'',removeImage_B:'',removeImage_C:'',instructionBlockB:'none',instructionBlockA:'none',instructionBlockC:'none',isMentorCheck:false,OBmessage:"",DT3status:0,timeForCompletion:0,timerSeconds:0};_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);return _this;}_createClass(Descriptivetask3,[{key:'onChangeCKEditor',value:function onChangeCKEditor(name,value){this.setState(_defineProperty({},name,value));}},{key:'getAssess',value:function getAssess(){var _this2=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),seq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,comp_id:data.id,type:'dt3'});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'mentor-assess/view'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){_this2.setState({AssessementViewData:responseJson.data});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getdt3Answer',value:function getdt3Answer(){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),comp_id:data.id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id,seq_id:data.compseq_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'descriptive-task3-answer/view'+query_data+'?expand=report_file_a,report_file_b,report_file_c',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){var instructionBlockA="none";var instructionBlockB="none";var instructionBlockC="none";var instruction_type=responseJson.data.instruction_type.split(",");if(instruction_type.length>0){instruction_type.map(function(key,i){if(key==='a'){instructionBlockA="block";}if(key==='b'){instructionBlockB="block";}if(key==='c'){instructionBlockC="block";}});}_this3.setState({reportbtn:"none",instructionBlockA:instructionBlockA,instructionBlockB:instructionBlockB,instructionBlockC:instructionBlockC,dt3Answer:responseJson.data,DT3status:1});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getDt3',value:function getDt3(id){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'descriptive-task3/'+id+'?expand=validity_date',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){var dt3=responseJson.data;var greaterdate=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true);var expiryDate=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("specialExpiryDate",true).split("-");var newExpiryDate=new Date(expiryDate[0]+"/"+expiryDate[1]+"/"+expiryDate[2]);if(dt3.submitlater_due>0){if(dt3.validity_date.timestamp<Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["D" /* toTimestamp */])(newExpiryDate)){greaterdate=dt3.validity_date.display;}}var isMentor=true;if(dt3.evaluation_mentor===0){isMentor=false;}var ObEcoObj={evaluation_mentor:dt3.evaluation_mentor,evaluation_ecoach:dt3.evaluation_ecoach,mentor_perform:dt3.mentor_perform,ecoach_perform:dt3.ecoach_perform,mentor_view:dt3.mentor_view,ecoach_view:dt3.ecoach_view};var dt3message=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["b" /* ObserverEcoachMessage */])(ObEcoObj);_this4.setState({dt3Data:dt3,greaterdate:greaterdate,isMentorCheck:isMentor,OBmessage:dt3message,timeForCompletion:dt3.total_duration,timerSeconds:dt3.total_duration*60});_this4.getLearningCompletedStatus();_this4.getAssess();_this4.switchBlock();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'getLearningCompletedStatus',value:function getLearningCompletedStatus(){var _this5=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */])({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learner-component-status/view'+query_data+'?expand=completed_date,Cscore',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){_this5.setState({LearningCompletedStatus:responseJson.data});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'handleImageAllChange',value:function handleImageAllChange(e,name){//console.log(e);
//console.log(name);
if(this.refs[name].files[0]!==undefined){var suffix=name.split("_");var reader=new FileReader();var self=this;var removeAnchor=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return self.removeImage(name);},style:{color:'#ff0000',textDecoration:'underline'}},'X Remove Attachment');reader.onload=function(e){if(e.target.result.match(/image/g)){var _self$setState;self.setState((_self$setState={},_defineProperty(_self$setState,'front_image_'+suffix[1],e.target.result),_defineProperty(_self$setState,'removeImage_'+suffix[1],removeAnchor),_self$setState));}else{var _self$setState2;self.setState((_self$setState2={},_defineProperty(_self$setState2,'front_image_'+suffix[1],''),_defineProperty(_self$setState2,'removeImage_'+suffix[1],removeAnchor),_self$setState2));}};reader.readAsDataURL(this.refs[name].files[0]);}}},{key:'removeImage',value:function removeImage(name){var _setState2;var suffix=name.split("_");this.refs[name].value='';this.setState((_setState2={},_defineProperty(_setState2,'front_image_'+suffix[1],''),_defineProperty(_setState2,'removeImage_'+suffix[1],''),_setState2));}},{key:'instruction',value:function instruction(e){if(e.target.name==='instruction'){var instruction=document.querySelectorAll('input[name=instruction]');var instructionChecked=document.querySelectorAll('input[name=instruction]:checked');for(var i=0;i<instruction.length;i++){if(instruction[i].checked===true){if(instructionChecked.length>2){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('Attention!','You can only select two options.','error');if(instruction[i].value===e.target.value){instruction[i].checked=false;continue;}}else{if(instruction[i].value==='a'&&e.target.value==='a'){this.setState({reportBlock_A:'block'});}if(instruction[i].value==='b'&&e.target.value==='b'){this.setState({reportBlock_B:'block'});}if(instruction[i].value==='c'&&e.target.value==='c'){this.setState({reportBlock_C:'block'});}}}else{if(instruction[i].value==='a'&&e.target.value==='a'){this.setState({reportBlock_A:'none'});}if(instruction[i].value==='b'&&e.target.value==='b'){this.setState({reportBlock_B:'none'});}if(instruction[i].value==='c'&&e.target.value==='c'){this.setState({reportBlock_C:'none'});}}}var instructions=[];var newinstructionCheckedValues=document.querySelectorAll('input[name=instruction]:checked');for(var j=0;j<newinstructionCheckedValues.length;j++){instructions.push(newinstructionCheckedValues[j].value);}if(instructions.length>0){this.setState({insttypeOption:instructions});}}}},{key:'viewReportBlock',value:function viewReportBlock(type){if(type==="proceed"){if(!this.state.insttypeOption){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('Attention','Please select an option to submit your report.','warning');}else{this.setState({reportbtn:'none'});}}if(type==="cancel"){this.setState({reportbtn:'block'});}}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this6=this;var data=this.props.data;var request_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,observers:obj,dt3Data:this.state.dt3Data,ag:data.is_ag!==""?data.ag_id:""};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'descriptive-task3/observer-proceed',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===2){_this6.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this6.goToThanksPage();}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,'','success');if(_this6.props.usableType==="webapp"){_this6.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('','Something went wrong.','error');}});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitReport',value:function submitReport(){var _this7=this;var data=this.props.data;var formData=new FormData();var request_data={instruction_type:this.state.insttypeOption,reportText_A:this.state.reportText_A,reportText_B:this.state.reportText_B,reportText_C:this.state.reportText_C,comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,ag:data.is_ag!==""?data.ag_id:""};for(var key in request_data){formData.append(key,request_data[key]);}if(this.state.dt3Data.learnerefortrating===1){formData.append('Rating',this.state.Rating);}if(this.refs.reportfile_A.files[0]!==undefined){formData.append('reportfile_A',this.refs.reportfile_A.files[0]);}else{formData.append('reportfile_A','');}if(this.refs.reportfile_B.files[0]!==undefined){formData.append('reportfile_B',this.refs.reportfile_B.files[0]);}else{formData.append('reportfile_B','');}if(this.refs.reportfile_C.files[0]!==undefined){formData.append('reportfile_C',this.refs.reportfile_C.files[0]);}else{formData.append('reportfile_C','');}if(this.state.insttypeOption.length===0||this.state.insttypeOption.length<2){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('Attention!','You have to select two options.','error');}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"descriptive-task3/submit-report",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{_this7.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this7.goToThanksPage();}else{if(responseJson.observerblock){_this7.setState({LearningCompletedStatus:responseJson.data,observerViewBlock:"block",Dt3ViewBlock:"none"});}else{//Common.message(responseJson.message,'','success');
//message("Submitted successfully",'','success');
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])("","Submitted successfully.");_this7.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}});}}},{key:'submitLater',value:function submitLater(){var _this8=this;window.swal({// title: 'Attention!',
text:'Complete the Practice assigment and submit by '+this.state.greaterdate+'.',//type: 'question',
//showCancelButton: true,
confirmButtonColor:'#14a430',animation:false,//cancelButtonColor: '#d33',
confirmButtonText:'Ok'}).then(function(result){//console.log(result.value);
//console.log(result.dismiss);
if(result){var data=_this8.props.data;var request_data={comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,due_date:_this8.state.greaterdate,ag:data.is_ag!==""?data.ag_id:""};Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"descriptive-task3/submit-report-later",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{// Common.message("Submitted successfully.",'','success');
if(_this8.props.usableType==="webapp"){_this8.props.getLearningRoom();_this8.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}});}});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'switchBlock',value:function switchBlock(){var _this9=this;var data=this.props.data;setTimeout(function(){if(data.status==="completed"){//console.log("completed");
_this9.setState({observerViewBlock:"none",Dt3ViewBlock:"none",dtAnswerBlock:"block"});}else if(data.status==="incompleted"){if(_this9.state.isMentorCheck){// console.log("incompleted if");
if(_this9.state.DT3status===1){_this9.setState({Dt3ViewBlock:"none",dtAnswerBlock:"none",observerViewBlock:"block"});}else{_this9.setState({Dt3ViewBlock:"block",dtAnswerBlock:"none",observerViewBlock:"none"});}}else{// console.log("incompleted else");
//   this.setState({
//    observerViewBlock:"none",
//    Dt3ViewBlock:"none",
//    dtAnswerBlock:"block"
//   });
if(_this9.state.DT3status===1){_this9.setState({Dt3ViewBlock:"none",dtAnswerBlock:"block",observerViewBlock:"none"});}else{_this9.setState({Dt3ViewBlock:"block",dtAnswerBlock:"none",observerViewBlock:"none"});}}}else{//  console.log("empty");
_this9.setState({observerViewBlock:"none",Dt3ViewBlock:"block",dtAnswerBlock:"none"});}},400);}},{key:'timeUp',value:function timeUp(){var _this10=this;var data=this.props.data;var formData=new FormData();var request_data={instruction_type:this.state.insttypeOption,reportText_A:this.state.reportText_A,reportText_B:this.state.reportText_B,reportText_C:this.state.reportText_C,comp_id:data.id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,mentor:this.state.isMentorCheck,ag:data.is_ag!==""?data.ag_id:""};for(var key in request_data){formData.append(key,request_data[key]);}if(this.state.dt3Data.learnerefortrating===1){formData.append('Rating',this.state.Rating);}if(this.refs.reportfile_A.files[0]!==undefined){formData.append('reportfile_A',this.refs.reportfile_A.files[0]);}else{formData.append('reportfile_A','');}if(this.refs.reportfile_B.files[0]!==undefined){formData.append('reportfile_B',this.refs.reportfile_B.files[0]);}else{formData.append('reportfile_B','');}if(this.refs.reportfile_C.files[0]!==undefined){formData.append('reportfile_C',this.refs.reportfile_C.files[0]);}else{formData.append('reportfile_C','');}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"descriptive-task3/submit-timeup",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{_this10.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(responseJson.isCompletedFully){_this10.goToThanksPage();}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errorMsg,'warning');if(_this10.props.usableType==="webapp"){_this10.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getdt3Answer();this.getDt3(data.id);if(data.is_ag){this.props.getActiongoalAction(data.ag_id);}setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();this.currentTime=0;}});});},500);}},{key:'render',value:function render(){var _this11=this;var data=this.props.data;var dt3=this.state.dt3Data;var LCStatus=this.state.LearningCompletedStatus;var dt3Answer=this.state.dt3Answer;var Ratings=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["t" /* ratings */];var control_style={position:'relative',zIndex:1};var video_player_a=null;var audio_player_a=null;var download_file_a=null;var front_image_A=null;var front_image_B=null;var front_image_C=null;var video_player_b=null;var audio_player_b=null;var download_file_b=null;var video_player_c=null;var audio_player_c=null;var download_file_c=null;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var subMitLaterButton=null;if(dt3.submit_later>0){if(LCStatus===null&&data.status===""){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit Later',alt:'Submit Later',className:'button-cancel',value:'Submit Later',id:'submitlater',name:'submitlater',onClick:function onClick(e){return _this11.submitLater();}});}if(LCStatus!==null){if(LCStatus.allow_later!==1){subMitLaterButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Submit Later',alt:'Submit Later',className:'button-cancel',value:'Submit Later',id:'submitlater',name:'submitlater',onClick:function onClick(e){return _this11.submitLater();}});}}}if(dt3.pa_video!==undefined){if(dt3.pa_video!==''){var video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_video/'+dt3.pa_video}]}};video_player_a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:'vplayer_0',trackData:trackData,playlist:video_playlist});}}if(dt3.pa_video_b!==undefined){if(dt3.pa_video_b!==''){var _video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_video/'+dt3.pa_video_b}]}};video_player_b=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:'vplayer_1',trackData:trackData,playlist:_video_playlist});}}if(dt3.pa_video_c!==undefined){if(dt3.pa_video_c!==''){var _video_playlist2={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_video/'+dt3.pa_video_c}]}};video_player_c=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:'vplayer_1',trackData:trackData,playlist:_video_playlist2});}}if(dt3.pa_file_name!==undefined){if(dt3.pa_file_name!==''){download_file_a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_file/'+dt3.pa_file_name,className:'redlnk',target:'_blank',style:{lineHeight:'20px'},title:'Download file'},'Download file');}}if(dt3.pa_audio!==undefined){if(dt3.pa_audio!==''){audio_player_a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_audio/'+dt3.pa_audio,type:'audio/mpeg',width:'400',height:'50'}));}}if(dt3.pa_audio_b!==undefined){if(dt3.pa_audio_b!==''){audio_player_b=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_audio/'+dt3.pa_audio_b,type:'audio/mpeg',width:'400',height:'50'}));}}if(dt3.pa_audio_c!==undefined){if(dt3.pa_audio_c!==''){audio_player_c=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_audio/'+dt3.pa_audio_c,type:'audio/mpeg',width:'400',height:'50'}));}}if(dt3.pa_file_name_b!==undefined){if(dt3.pa_file_name_b!==''){download_file_b=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_file/'+dt3.pa_file_name_b,className:'redlnk',target:'_blank',style:{lineHeight:'20px'},title:'Download file'},'Download file');}}if(dt3.pa_file_name_c!==undefined){if(dt3.pa_file_name_c!==''){download_file_c=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/task3_file/'+dt3.pa_file_name_c,className:'redlnk',target:'_blank',style:{lineHeight:'20px'},title:'Download file'},'Download file');}}if(this.state.front_image_A!==''){front_image_A=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'front_image',src:this.state.front_image_A,width:'150'});}if(this.state.front_image_B!==''){front_image_B=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'front_image',src:this.state.front_image_B,width:'150'});}if(this.state.front_image_C!==''){front_image_C=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'front_image',src:this.state.front_image_C,width:'150'});}var Score=null;if(LCStatus!==null){if(LCStatus.Cscore!==""&&this.state.DT3status!==0){Score=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_scorePA'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Score: '),LCStatus.Cscore);}}var DontShow=0;var AssessementViewListBlock=null;if(dt3.evaluation_mentor===0&&dt3.evaluation_ecoach===0){DontShow=1;}if(DontShow===0&&this.state.DT3status!==0&&LCStatus!==null){if(LCStatus.allow_later===0){AssessementViewListBlock=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_AssessementViewList__["a" /* default */],{data:this.state.AssessementViewData});}}var Timer=null;if(dt3.total_duration>0&&this.state.DT3status===0&&data.dlr_id){Timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_TimerCountDown__["a" /* default */],{seconds:this.state.timerSeconds,onComplete:function onComplete(e){return _this11.timeUp();}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},Timer,data.is_ag!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img_action_goal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img_action_goal1.gif",width:'58',height:'82',alt:'Action Goal',title:'Action Goal',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ag_title_arrow'},this.props.actionGoal.ag_name!==undefined?this.props.actionGoal.ag_name:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dt3.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:dt3.alt_text?dt3.alt_text:'',className:'cw_completed_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,dt3.pa_name?dt3.pa_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},dt3.base_line?dt3.base_line:'','    ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scroll',id:'semana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview',style:{top:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.observerViewBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__["a" /* default */],{message:this.state.OBmessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.Dt3ViewBlock}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'practice-assignment'},dt3.evaluation_mentor===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:'both',height:'17px'}}),dt3Answer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:'both',padding:'0px 0 10px 7px'}},'There are 3 options for this PA. Please read both and choose any two to work on.'):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},dt3Answer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'instruction',id:'instruction_a',value:'a',type:'checkbox',onChange:function onChange(e){return _this11.instruction(e);}}):"",' Option A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_a!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_a),audio_player_a!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_a),download_file_a?download_file_a:''),dt3.pa_instruction_a!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:dt3.pa_instruction_a?dt3.pa_instruction_a:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.reportBlock_A}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PACWans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Report A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{lass:'txtareaborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper___default.a,{value:this.state.reportText_A,onChange:this.onChangeCKEditor.bind(this,'reportText_A'),config:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["a" /* CKsettings */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},'File  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'reportfile_A',ref:'reportfile_A',size:'80',id:'reportfile',onChange:function onChange(e){return _this11.handleImageAllChange(e,'reportfile_A');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),front_image_A,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.removeImage_A,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg',style:{color:'#ff5400'}},'Max file size accepted: 5 MB (Single file)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'or'},'(or)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},dt3Answer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'instruction',id:'instruction_b',value:'b',type:'checkbox',onChange:function onChange(e){return _this11.instruction(e);}}):"",' Option B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_b!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_b),audio_player_b!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_b),download_file_b?download_file_b:''),dt3.pa_instruction_b!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:dt3.pa_instruction_b?dt3.pa_instruction_b:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.reportBlock_B}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PACWans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Report B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{lass:'txtareaborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper___default.a,{value:this.state.reportText_B,onChange:this.onChangeCKEditor.bind(this,'reportText_B'),config:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["a" /* CKsettings */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},'File  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'reportfile_B',ref:'reportfile_B',size:'80',id:'reportfile',onChange:function onChange(e){return _this11.handleImageAllChange(e,'reportfile_B');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),front_image_B,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.removeImage_B,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg',style:{color:'#ff5400'}},'Max file size accepted: 5 MB (Single file)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'or'},'(or)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},dt3Answer.instruction_type===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'instruction',id:'instruction_c',value:'c',type:'checkbox',onChange:function onChange(e){return _this11.instruction(e);}}):"",' Option C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_c!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_c),audio_player_c!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_c),download_file_c?download_file_c:''),dt3.pa_instruction_c!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:dt3.pa_instruction_c?dt3.pa_instruction_c:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.reportBlock_C}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PACWans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Report C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{lass:'txtareaborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_ckeditor_wrapper___default.a,{value:this.state.reportText_C,onChange:this.onChangeCKEditor.bind(this,'reportText_C'),config:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["a" /* CKsettings */]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},'File  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'reportfile_C',ref:'reportfile_C',size:'80',id:'reportfile',onChange:function onChange(e){return _this11.handleImageAllChange(e,'reportfile_C');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),front_image_C,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.removeImage_C,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg',style:{color:'#ff5400'}},'Max file size accepted: 5 MB (Single file)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'File formats accepted: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, JPEG and PNG'))))))),dt3.learnerefortrating===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learnerratingPACW'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate'},'I would rate my efforts in actioning this component as ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'myrate-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'Rating',id:'Rating',value:this.state.Rating,onChange:function onChange(e){return _this11.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Poor ( 1 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Below Average ( 2 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Average ( 3 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'Above Average ( 4 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'Good ( 5 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'Excellent ( 6 )'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'Outstanding ( 7 )')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reportbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',style:{float:'right'},name:'btnreport',value:'Submit',onClick:function onClick(e){return _this11.submitReport();},className:'button-accept',alt:'Submit Your Report',title:'Submit Your Report'})),subMitLaterButton))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.dtAnswerBlock}},this.state.DT3status!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LCStatus!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,LCStatus.state!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,dt3.learnerefortrating===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,DontShow===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LERresult'},'My effort rating of this component is - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,LCStatus.self_rating?LCStatus.self_rating:0,' / 7 ',LCStatus.self_rating?Ratings[LCStatus.self_rating]:"",'  ')):"")))),DontShow===0?Score:"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),AssessementViewListBlock,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox',style:{display:this.state.instructionBlockA,float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},'Option A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_a!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_a),audio_player_a!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_a),download_file_a?download_file_a:''),dt3.pa_instruction_a!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:dt3.pa_instruction_a?dt3.pa_instruction_a:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Report A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:dt3Answer.option_a_answer?dt3Answer.option_a_answer:''}}),dt3Answer.report_file_a!==null&&dt3Answer.report_file_a!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/dt3_report_file/'+dt3Answer.report_file_a,className:'redlnk',target:'_blank',style:{float:'left',marginTop:0},title:'Download file'},'Download file'))):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test',style:{display:this.state.instructionBlockB,float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},'Option B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_b!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_b),audio_player_b!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_b),download_file_b?download_file_b:''),dt3.pa_instruction_b!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:dt3.pa_instruction_b?dt3.pa_instruction_b:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Report B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:dt3Answer.option_b_answer?dt3Answer.option_b_answer:''}}),dt3Answer.report_file_b!==null&&dt3Answer.report_file_b!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/dt3_report_file/'+dt3Answer.report_file_b,className:'redlnk',target:'_blank',style:{float:'left',marginTop:0},title:'Download file'},'Download file'))):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_test',style:{display:this.state.instructionBlockC,float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_top'},'Option C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruction_txt coursewrkvideo'},video_player_c!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},video_player_c),audio_player_c!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcement testtimevideo'},audio_player_c),download_file_c?download_file_c:''),dt3.pa_instruction_c!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt edtxttop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ddcomp',dangerouslySetInnerHTML:{__html:dt3.pa_instruction_c?dt3.pa_instruction_c:''}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Report C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:dt3Answer.option_c_answer?dt3Answer.option_c_answer:''}}),dt3Answer.report_file_c!==null&&dt3Answer.report_file_c!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/dt3_report_file/'+dt3Answer.report_file_c,className:'redlnk',target:'_blank',style:{float:'left',marginTop:0},title:'Download file'},'Download file'))):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this11.backToComponentList();},name:'btnsubmit',value:'Continue',className:'button_org',alt:'Continue',title:'Continue'}))))))))));}}]);return Descriptivetask3;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{actionGoal:state.actionGoal};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_12__actions_learningRoomAction__["a" /* getLearningRoom */],getActiongoalAction:__WEBPACK_IMPORTED_MODULE_13__actions_actiongoalAction__["a" /* getActiongoalAction */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Descriptivetask3));

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grid_partials_GridTile__ = __webpack_require__(593);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GridComp=function(_Component){_inherits(GridComp,_Component);function GridComp(props){_classCallCheck(this,GridComp);var _this=_possibleConstructorReturn(this,(GridComp.__proto__||Object.getPrototypeOf(GridComp)).call(this,props));_this.goToThanksPage=_this.goToThanksPage.bind(_this);_this.state={LearningCompletedStatus:null,gridData:[],gridComponentsData:[],timeForCompletion:0,timerSeconds:0};return _this;}_createClass(GridComp,[{key:'getLearningCompletedStatus',value:function getLearningCompletedStatus(){var _this2=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */]({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learner-component-status/view'+query_data+'?expand=completed_date,Cscore',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){_this2.setState({LearningCompletedStatus:responseJson.data});}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'getGrid',value:function getGrid(id){var _this3=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'girdcomponent/'+id+'?expand=components',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){var grid=responseJson.data;_this3.setState({gridData:grid,gridComponentsData:grid.components,timeForCompletion:grid.total_duration,timerSeconds:grid.total_duration*60});_this3.getLearningCompletedStatus();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'backToList',value:function backToList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;///this.getCourseworkAnswer();
this.getGrid(data.id);}},{key:'render',value:function render(){var _this4=this;var _props=this.props,data=_props.data,usableType=_props.usableType;var gridData=this.state.gridData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:gridData.gridcomp_desc?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:gridData.alt_text?gridData.alt_text:'',className:'gc_complete_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,gridData.gridcomp_name?gridData.gridcomp_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},gridData.gridcomp_desc?gridData.gridcomp_desc:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scroll',id:'semana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview',style:{top:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__grid_partials_GridTile__["a" /* default */],{data:this.state.gridComponentsData,usableType:usableType,compData:data,learningCompletedStatus:this.state.LearningCompletedStatus,switchbackList:function switchbackList(e){return _this4.backToList();},goToThanksPage:this.goToThanksPage})))))));}}]);return GridComp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GridComp);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 276 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(629),
    arraySome = __webpack_require__(632),
    cacheHas = __webpack_require__(633);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(280),
    getSymbols = __webpack_require__(162),
    keys = __webpack_require__(71);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(161),
    isArray = __webpack_require__(23);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(639),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(101),
    isIndex = __webpack_require__(164),
    isTypedArray = __webpack_require__(165);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(157),
    arrayEach = __webpack_require__(285),
    assignValue = __webpack_require__(286),
    baseAssign = __webpack_require__(650),
    baseAssignIn = __webpack_require__(651),
    cloneBuffer = __webpack_require__(654),
    copyArray = __webpack_require__(655),
    copySymbols = __webpack_require__(656),
    copySymbolsIn = __webpack_require__(657),
    getAllKeys = __webpack_require__(279),
    getAllKeysIn = __webpack_require__(289),
    getTag = __webpack_require__(103),
    initCloneArray = __webpack_require__(658),
    initCloneByTag = __webpack_require__(659),
    initCloneObject = __webpack_require__(664),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(101),
    isMap = __webpack_require__(665),
    isObject = __webpack_require__(31),
    isSet = __webpack_require__(667),
    keys = __webpack_require__(71);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 285 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(169),
    eq = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(161),
    getPrototype = __webpack_require__(104),
    getSymbols = __webpack_require__(162),
    stubArray = __webpack_require__(281);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(280),
    getSymbolsIn = __webpack_require__(288),
    keysIn = __webpack_require__(170);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collapsible = function (_Component) {
  _inherits(Collapsible, _Component);

  function Collapsible(props) {
    _classCallCheck(this, Collapsible);

    // Bind class methods
    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));

    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_this);
    _this.setInnerRef = _this.setInnerRef.bind(_this);

    // Defaults the dropdown to be closed
    if (props.open) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: 'height ' + props.transitionTime + 'ms ' + props.easing,
        hasBeenOpened: false,
        overflow: 'hidden',
        inTransition: false
      };
    }
    return _this;
  }

  _createClass(Collapsible, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }

      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      }

      // If there has been a change in the open prop (controlled by accordion)
      if (prevProps.open !== this.props.open) {
        if (this.props.open === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'closeCollapsible',
    value: function closeCollapsible() {
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.innerRef.offsetHeight,
        transition: 'height ' + (this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime) + 'ms ' + this.props.easing,
        inTransition: true
      });
    }
  }, {
    key: 'openCollapsible',
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: 'continueOpenCollapsible',
    value: function continueOpenCollapsible() {
      this.setState({
        height: this.innerRef.offsetHeight,
        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
        isClosed: false,
        hasBeenOpened: true,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: 'handleTriggerClick',
    value: function handleTriggerClick(event) {
      event.preventDefault();

      if (this.props.triggerDisabled) {
        return;
      }

      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else {
        if (this.state.isClosed === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'renderNonClickableTriggerElement',
    value: function renderNonClickableTriggerElement() {
      if (this.props.triggerSibling && typeof this.props.triggerSibling === 'string') {
        return _react2.default.createElement(
          'span',
          { className: this.props.classParentString + '__trigger-sibling' },
          this.props.triggerSibling
        );
      } else if (this.props.triggerSibling) {
        return _react2.default.createElement(this.props.triggerSibling, null);
      }

      return null;
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      // Switch to height auto to make the container responsive
      if (!this.state.isClosed) {
        this.setState({ height: 'auto', overflow: this.props.overflowWhenOpen, inTransition: false });
        this.props.onOpen();
      } else {
        this.setState({ inTransition: false });
        this.props.onClose();
      }
    }
  }, {
    key: 'setInnerRef',
    value: function setInnerRef(ref) {
      this.innerRef = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var dropdownStyle = {
        height: this.state.height,
        WebkitTransition: this.state.transition,
        msTransition: this.state.transition,
        transition: this.state.transition,
        overflow: this.state.overflow
      };

      var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
      var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';

      //If user wants different text when tray is open
      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;

      // If user wants a trigger wrapping element different than 'span'
      var TriggerElement = this.props.triggerTagName;

      // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
      var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;

      // Construct CSS classes strings
      var triggerClassString = this.props.classParentString + '__trigger ' + openClass + ' ' + disabledClass + ' ' + (this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName);
      var parentClassString = this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName);
      var outerClassString = this.props.classParentString + '__contentOuter ' + this.props.contentOuterClassName;
      var innerClassString = this.props.classParentString + '__contentInner ' + this.props.contentInnerClassName;

      return _react2.default.createElement(
        'div',
        { className: parentClassString.trim() },
        _react2.default.createElement(
          TriggerElement,
          {
            className: triggerClassString.trim(),
            onClick: this.handleTriggerClick,
            style: this.props.triggerStyle && this.props.triggerStyle,
            onKeyPress: function onKeyPress(event) {
              var key = event.key;

              if (key === ' ' || key === 'Enter') {
                _this3.handleTriggerClick(event);
              }
            },
            tabIndex: this.props.tabIndex && this.props.tabIndex
          },
          trigger
        ),
        this.renderNonClickableTriggerElement(),
        _react2.default.createElement(
          'div',
          {
            className: outerClassString.trim(),
            style: dropdownStyle,
            onTransitionEnd: this.handleTransitionEnd
          },
          _react2.default.createElement(
            'div',
            {
              className: innerClassString.trim(),
              ref: this.setInnerRef
            },
            children
          )
        )
      );
    }
  }]);

  return Collapsible;
}(_react.Component);

Collapsible.propTypes = {
  transitionTime: _propTypes2.default.number,
  transitionCloseTime: _propTypes2.default.number,
  triggerTagName: _propTypes2.default.string,
  easing: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  classParentString: _propTypes2.default.string,
  openedClassName: _propTypes2.default.string,
  triggerStyle: _propTypes2.default.object,
  triggerClassName: _propTypes2.default.string,
  triggerOpenedClassName: _propTypes2.default.string,
  contentOuterClassName: _propTypes2.default.string,
  contentInnerClassName: _propTypes2.default.string,
  accordionPosition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  handleTriggerClick: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onOpening: _propTypes2.default.func,
  onClosing: _propTypes2.default.func,
  trigger: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerWhenOpen: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerDisabled: _propTypes2.default.bool,
  lazyRender: _propTypes2.default.bool,
  overflowWhenOpen: _propTypes2.default.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
  triggerSibling: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  tabIndex: _propTypes2.default.number
};

Collapsible.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  triggerTagName: 'span',
  easing: 'linear',
  open: false,
  classParentString: 'Collapsible',
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: 'hidden',
  openedClassName: '',
  triggerStyle: null,
  triggerClassName: '',
  triggerOpenedClassName: '',
  contentOuterClassName: '',
  contentInnerClassName: '',
  className: '',
  triggerSibling: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onOpening: function onOpening() {},
  onClosing: function onClosing() {},
  tabIndex: null
};

exports.default = Collapsible;



/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TestGraph__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var Testresults=function(_Component){_inherits(Testresults,_Component);function Testresults(props){_classCallCheck(this,Testresults);var _this=_possibleConstructorReturn(this,(Testresults.__proto__||Object.getPrototypeOf(Testresults)).call(this,props));_this.state={flowresult:false,componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",chart_graph:"",quscomd:[],videoTracks:[],actualToScore:"",percentage:"",winningAmount:"",losingAmount:"",performanceAmount:"",betStatus:"",isCompletedFully:false,isrepeatcomp:'N',mcq_type:"",anskeyshow:false};return _this;}_createClass(Testresults,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getresults',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({corporate_id:responseJson.corporate_id,testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,quscomd:responseJson.QuestionCom,chart_graph:responseJson.Mcq_details.showgraph>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TestGraph__["a" /* default */],{scoredet:responseJson.Mcq_details}):'',isrepeatcomp:responseJson.isrepeatcomp,percentage:responseJson.Mcq_details.score_percentage,mcq_type:responseJson.Mcq_details.mcq_type});if(responseJson.Mcq_details.is_betcomponent>0){_this2.setState({actualToScore:responseJson.bet_details.actualToScore,percentage:responseJson.bet_details.percentage,winningAmount:responseJson.bet_details.winningAmount,losingAmount:responseJson.bet_details.losingAmount,performanceAmount:responseJson.bet_details.performanceAmount,betStatus:responseJson.bet_details.betStatus,videoTracks:responseJson.bet_details.videoTracks,isCompletedFully:responseJson.isCompletedFully});}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;if(data.flowresult){this.setState({flowresult:true});}this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getTestdetails(data);}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;if(this.state.isCompletedFully){this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}else{this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}}},{key:'showhidevideo',value:function showhidevideo(){if($("#showhidevideobtn").val()==="Show video"){$("#showhidevideobtn").val('Hide video');$("#showhideplayer").toggle();}else{// stop playing video 
var flowplayerelement=$(".flowplayer");var flowplapi=win.flowplayer(flowplayerelement);flowplapi.stop(flowplayerelement);$("#showhidevideobtn").val('Show video');$("#showhideplayer").toggle();$("html, body").animate({scrollTop:0},"slow");}}},{key:'continueToComplete',value:function continueToComplete(){this.setState({flowresult:false});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'submitbuttons',value:function submitbuttons(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Submit',className:'button_org_inactive',type:'button',onClick:function onClick(e){return _this3.submittest();}}));}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var questionaire_id=quest_det.questionaire_id;var showanswer=quest_det.showanswer;var question_type=quest_det.question_type;var rs_img=ans_opt.score>0?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},showanswer=="1"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 9:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'0.5em'}},ans_opt.options),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:quest_det.question_id}));break;case 10:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'0.5em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,ans_opt.options)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'1.5em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{float:'right',marginRight:'480px'},type:'radio',name:quest_det.question_id+'_most'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{float:'right',marginRight:'-87px'},type:'radio',name:quest_det.question_id+'_least'}));break;default:qty_val='';break;}return qty_val;}},{key:'getquestion_anskey',value:function getquestion_anskey(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var rs_img=ans_opt.score>0?"/rmeta"+'/images/tick.gif':'';var getcorrecans=quest_det.correct_answer.split(",");switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},rs_img!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,getcorrecans)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},rs_img!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,getcorrecans)>=0,type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},rs_img!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,getcorrecans)>=0,type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this4=this;var sdf=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this4.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt',style:{width:"40px"},title:'Enter one digit numeric input',onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r],readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mc.match_correct_ans_order==mk.answered[r]?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this4.video_frame(mc.match_ans_src,'')))));})))));return sdf;}},{key:'matchfillfun_anskey',value:function matchfillfun_anskey(mk,imagezoomopt){var _this5=this;var sdf=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){//console.log(mc);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt',style:{width:"40px"},title:'Enter one digit numeric input',onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mc.match_correct_ans_order,readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/tick.gif',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));})))));return sdf;}},{key:'video_frame',value:function video_frame(video_files){var text=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:Date.now(),playlist:playlist,trackData:trackData});}},{key:'video_frameexp',value:function video_frameexp(video_files){var text=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_exp_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:Date.now(),playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var disp=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bluetxt'},'Your Answer:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align'},mk.answered)));return disp;}},{key:'repeatcomptakeretest',value:function repeatcomptakeretest(){var _this6=this;var getthisobj=this;var data=this.props.data;var mcqtype=this.state.mcq_type;if(mcqtype=="normaltest")data.compo_type="repeatnormaltest";else if(mcqtype=="testonebyone"||mcqtype=="testgoback")data.compo_type="repeattestonebyone";else if(mcqtype=="fixedtimetest")data.compo_type="repeatfixedtimetest";else if(mcqtype=="timevariabletest")data.compo_type="repeattimevariabletest";window.swal({//title: 'View!',
text:'You can repeat this test but your score will not change.',// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){_this6.props.switchrepeatretest(data);}},function(dismiss){if(dismiss=='cancel'){getthisobj.setState({anskeyshow:true});$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'showanswerkey',value:function showanswerkey(){var _this7=this;window.swal({//title: 'View!',
text:'You cannot repeat this test after viewing the answer key.',// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){_this7.setState({anskeyshow:true});$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'openendquestions_anskey',value:function openendquestions_anskey(mk){var disp=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bluetxt'},'Correct Answer:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nostlyespan'},' YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*')))));return disp;}},{key:'render',value:function render(){var _this8=this;var data=this.state.testcont;var quscomd=this.state.quscomd;var isrepeatcomp=this.state.isrepeatcomp;var optionText=[];var Propdata=this.props.data;var trackData={compseq_id:Propdata.compseq_id,lroom_id:Propdata.learning_room_id,divider_id:Propdata.divider_id,learner_id:Propdata.learner_id,dlr_id:Propdata.dlr_id,compo_type:data.compo_type};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.flowresult&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg'},'Successfully completed the Session.'),data.score_disable==false&&data.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box'},' You have scored ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.state.percentage!=''?this.state.percentage+'%':'',' (',(data.actual_score!=undefined?data.actual_score:'')+'/'+(data.out_of_score!=undefined?data.out_of_score:''),')'),' ',data.show_yta==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nostlyespan'},', YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'.'),'\xA0\xA0',isrepeatcomp=='N'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'orange',onClick:function onClick(){return _this8.continueToComplete();}},'Click here'),' to view correct answers.')),data.score_disable==false&&!data.is_performance&&isrepeatcomp=='N'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'orange',onClick:function onClick(){return _this8.continueToComplete();}},'Click here'),' to view correct answers.'),data.score_disable==false&&data.score_comment!=undefined&&data.is_performance=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testperformance'},data.score_comment),data.is_betcomponent>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test_result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bet_table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' Your Challenge was to score ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'set_challenge'},this.state.actualToScore))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_score'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Your Performance Score is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lrpercentage'},this.state.percentage,'%'),' in the Challenge')),this.state.betStatus==="lost"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You have Lost ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lost'},this.state.losingAmount),' Points in the Challenge')),this.state.betStatus==="won"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You have Won ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'won'},this.state.winningAmount),' Points in the Challenge')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You have got ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'perfamnt'},this.state.performanceAmount),' Points for your Performance'))))),data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grey-lite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'Few open ended questions and Audio Answers are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment')),this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this8.backToComponentList();}}),'\xA0\xA0',data.is_betcomponent>0&&data.bet_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Show video',title:'Show video',id:'showhidevideobtn',style:{display:'block'},className:'button_org',onClick:function onClick(){return _this8.showhidevideo();}})):""),this.state.videoTracks.length!=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'showhideplayer',className:'lr-gray-box videogray ',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:Date.now(),playlist:this.state.videoTracks,trackData:trackData})),isrepeatcomp=='Y'&&this.state.anskeyshow==false&&this.state.flowresult==false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Message:'),'  Your final score for this test is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.state.percentage!=''?this.state.percentage+'%':'',' (',(data.actual_score!=undefined?data.actual_score:'')+'/'+(data.out_of_score!=undefined?data.out_of_score:''),')'),' ',data.show_yta==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nostlyespan'},', YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'.'),' .  You can repeat this test if you want to, until you choose to view the answer key.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this8.backToComponentList();},style:{float:'right'}}),'\xA0\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Answer Key',title:'Answer Key',className:'button_org',onClick:function onClick(){return _this8.showanswerkey();},style:{float:'right'}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Repeat',title:'Repeat',className:'button_org',onClick:function onClick(){return _this8.repeatcomptakeretest();},style:{float:'right'}}))),isrepeatcomp=='Y'&&this.state.anskeyshow==true&&this.state.flowresult==false&&this.state.testquestions.map(function(mk,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt bluetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_type==10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'441px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Most'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'32px'}},'Least'))),mk.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izkey:'img_'+index,izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:mk.img_width?mk.img_width:'400'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+index,src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width?mk.img_width:'400'}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+aindex,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this8.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Correct Answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mk.correct_answer)),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}return _this8.getquestion_anskey(mk,qas,i+1,data.imagezoom);}),mk.question_type==6&&_this8.openendquestions_anskey(mk),mk.question_type==7&&_this8.matchfillfun_anskey(mk,data.imagezoom)),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'audiorecord'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bluetxt'},'Correct Answer:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nostlyespan'},' YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*')))))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Correct Answer : ',mk.correct_answer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dottedline'})),mk.is_answer_explained=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Answer Explanation'),quscomd[mk.question_id].videoexpfile!=''&&_this8.video_frameexp(quscomd[mk.question_id].videoexpfile,''),quscomd[mk.question_id].audiofile!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'comd',controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+quscomd[mk.question_id].audiofile,type:'audio/mpeg'})),quscomd[mk.question_id].imagefile!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-exp-img'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"/admin/test_image_files/"+quscomd[mk.question_id].imagefile,izalt:'',izwidth:'300'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"/admin/test_image_files/"+quscomd[mk.question_id].imagefile,alt:'',width:'300'})),quscomd[mk.question_id].answer_comment!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:quscomd[mk.question_id].answer_comment}}))),_this8.state.testcont.confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Confidencemeter__["a" /* default */],{dynamic_confidence:mk.question_id,confidence_result:mk.confidence_result,correct_ans:mk.correct_answer}):''));}),isrepeatcomp=='Y'&&this.state.anskeyshow==true&&this.state.flowresult==false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this8.backToComponentList();}})),!this.state.flowresult&&isrepeatcomp=='N'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},data.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testscoretop'},data.is_betcomponent>0&&data.bet_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Show video',title:'Show video',id:'showhidevideobtn',style:{display:'block'},className:'button_org',onClick:function onClick(){return _this8.showhidevideo();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'test-score'},'Score:\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.percentage!=''?this.state.percentage+'%':'',' (',(data.actual_score!=undefined?data.actual_score:'')+'/'+(data.out_of_score!=undefined?data.out_of_score:''),')',data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', '),data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'))))),data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grey-lite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'Few Open ended questions and Audio answer questions are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment'))),this.state.chart_graph,data.min_taken!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimeresult'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Time taken: ',data.hrs_taken>0&&data.hrs_taken+'hrs : ',' ',data.min_taken,' min : ',data.sec_taken,' sec')),this.state.testquestions.map(function(mk,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt bluetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_type==10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'441px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Most'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'32px'}},'Least'))),mk.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izkey:'img_'+index,izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:mk.img_width?mk.img_width:'400'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+index,src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width?mk.img_width:'400'}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+aindex,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this8.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Your Answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mk.answered,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mk.is_correct_ans>0?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif',alt:''}))),mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Correct Answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mk.correct_answer)),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}return _this8.getquestion(mk,qas,i+1,data.imagezoom);}),mk.question_type==6&&_this8.openendquestions(mk),mk.question_type==7&&_this8.matchfillfun(mk,data.imagezoom)),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'audiorecord'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'raudio_'+index,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"upload/recorded-voice/"+mk.answered,type:'audio/mpeg'}))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Your Answer : ',mk.answered,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mk.score>0?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif',alt:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Correct Answer : ',mk.correct_answer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dottedline'}),$.inArray(mk.question_type,[1,2,3,4,5,6,7,8])>=0&&data.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dottedline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt score'},'Your Score - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,mk.is_YTA>0&&mk.score<1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},'YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*')):mk.score),mk.is_hint_viewed>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'(You have viewed hint for this question)'),' ')))),mk.is_answer_explained=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Answer Explanation'),quscomd[mk.question_id].videoexpfile!=''&&_this8.video_frameexp(quscomd[mk.question_id].videoexpfile,''),quscomd[mk.question_id].audiofile!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'comd',controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+quscomd[mk.question_id].audiofile,type:'audio/mpeg'})),quscomd[mk.question_id].imagefile!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-exp-img'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"/admin/test_image_files/"+quscomd[mk.question_id].imagefile,izalt:'',izwidth:'300'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"/admin/test_image_files/"+quscomd[mk.question_id].imagefile,alt:'',width:'300'})),quscomd[mk.question_id].answer_comment!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:quscomd[mk.question_id].answer_comment}}))),_this8.state.testcont.confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Confidencemeter__["a" /* default */],{dynamic_confidence:mk.question_id,confidence_result:mk.confidence_result,correct_ans:mk.correct_answer}):''));}),data.score_disable==false&&data.score_comment!=undefined&&data.is_performance=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'testperformance'},data.score_comment),this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this8.backToComponentList();}})):"")))))));}}]);return Testresults;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Testresults);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var win=window;var $=win.$;var TestGraph=function(_React$Component){_inherits(TestGraph,_React$Component);function TestGraph(props){_classCallCheck(this,TestGraph);var _this=_possibleConstructorReturn(this,(TestGraph.__proto__||Object.getPrototypeOf(TestGraph)).call(this,props));_this.state={apicall:''};return _this;}_createClass(TestGraph,[{key:'componentDidMount',value:function componentDidMount(){var self=this;var cgdata=self.props.scoredet;var greater=cgdata.greaterscorecount;var currentp=cgdata.currentscorecount;var lesser=cgdata.lesserscorecount;var score=cgdata.actual_score;setTimeout(function(){var chartData=[{year:"% people with the score",greater:greater,current:currentp,lesser:lesser}];//SERIALL CHART
var chart=new win.AmCharts.AmSerialChart();chart.dataProvider=chartData;chart.categoryField="year";chart.plotAreaBorderAlpha=0;chart.rotate=true;chart.depth3D=30;chart.angle=20;// AXES
// Category
var categoryAxis=chart.categoryAxis;categoryAxis.gridAlpha=0;categoryAxis.axisAlpha=0;categoryAxis.gridPosition="start";// value
var valueAxis=new win.AmCharts.ValueAxis();valueAxis.stackType="regular";valueAxis.gridAlpha=0;valueAxis.axisAlpha=0;valueAxis.labelsEnabled=false;chart.addValueAxis(valueAxis);// GRAPHS
// firstgraph
var graph1=new win.AmCharts.AmGraph();graph1.title="Score < "+score;graph1.labelText="[[value]]%";graph1.balloonText="[[value]]%";graph1.valueField="lesser";graph1.type="column";graph1.lineAlpha=0;graph1.fillAlphas=1;graph1.lineColor="#ff3c8f";chart.addGraph(graph1);// second graph
var graph2=new win.AmCharts.AmGraph();graph2.title="Score = "+score;graph2.labelText="[[value]]%";graph2.balloonText="[[value]]%";graph2.valueField="current";graph2.type="column";graph2.lineAlpha=0;graph2.fillAlphas=1;graph2.lineColor="#10ea10";chart.addGraph(graph2);// thirdt graph
var graph3=new win.AmCharts.AmGraph();graph3.title="Score > "+score;graph3.labelText="[[value]]%";graph3.balloonText="[[value]]%";graph3.valueField="greater";graph3.type="column";graph3.lineAlpha=0;graph3.fillAlphas=1;graph3.lineColor="#0090ff";chart.addGraph(graph3);// LEGEND
var legend=new win.AmCharts.AmLegend();legend.position="bottom";legend.borderAlpha=0;legend.horizontalGap=0;legend.switchType="v";legend.switchable=false;legend.textClickEnabled=false;chart.addLegend(legend);// WRITE
chart.write("chartdiv");},300);}},{key:'render',value:function render(){var self=this;var cgdata=self.props;var paddingleft=parseFloat(410*(cgdata.lesser/100)+25);var width=parseFloat(410*(cgdata.currentp/100));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resultchart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Your Perfomance in this Quiz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:'165px',paddingLeft:paddingleft+'px',width:width+'px',textAlign:'center',marginRight:'0',paddingRight:'0',marginTop:'20px',marginBottom:'-25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"images/yourscore.jpg",border:'0',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'chartdiv',id:'chartdiv',style:{width:'100%',height:'180px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return TestGraph;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TestGraph);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cwsubject__ = __webpack_require__(675);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Courseware=function(_Component){_inherits(Courseware,_Component);function Courseware(props){_classCallCheck(this,Courseware);var _this=_possibleConstructorReturn(this,(Courseware.__proto__||Object.getPrototypeOf(Courseware)).call(this,props));_this.state={materials:[],material_title:'',subject_id:'',display:'none',show:'block',contentmsg:'Loading...'};_this.getMatdetails=_this.getMatdetails.bind(_this);return _this;}_createClass(Courseware,[{key:'getMatdetails',value:function getMatdetails(sub_id,tmp_id,sub,e){var subject_id=sub_id+'_'+tmp_id+'_'+sub;//alert(subject_id);
this.setState({show:'none',display:'block',subject_id:subject_id});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({show:'block',display:'none'});__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();}},{key:'getCourseMats',value:function getCourseMats(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);//alert(learnerID);
var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("productID",true);//alert(productID);
var corpID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("corporateID",true);var pinID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("pinID",true);// let learnerID = '25711';
// let productID = '159';
// let corpID = '34';
// let pinID  = '468';
fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'resources/course-mats',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,corp_id:corpID,pinid:pinID,product:productID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status!=0){_this2.setState({materials:responseJson.materials,contentmsg:responseJson.materials.length==0?" No Records Found.":" Loading...",material_title:responseJson.material_title});}});__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();}},{key:'componentDidMount',value:function componentDidMount(){this.getCourseMats();// $('#part2').hide();
}},{key:'render',value:function render(){var _this3=this;var contentmsgof=this.state.contentmsg;var materials=this.state.materials.map(function(material,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'materials_'+material.subject_id_pk+'_'+i,onClick:function onClick(e){return _this3.getMatdetails(material.subject_id_pk,material.template_id_fk,material.subject,e);},id:material.subject_id_pk,className:'even'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)'},material.subject));});//(this.state.materials.length == 0) ? materials = ' No records found.' : materials = materials
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'part1',style:{display:this.state.show}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img-courseware.jpg",align:'absmiddle',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.material_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'MBA study material'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner',id:'courseware'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box-gray title-box-blue'},'My Subjects'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sublist'},materials.length>0?materials:contentmsgof)))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'part2',style:{display:this.state.display}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Cwsubject__["a" /* default */],{subject_id:this.state.subject_id,materials:this.state.materials}))));}}]);return Courseware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Courseware);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_newPostAction__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Mylibrary=function(_Component){_inherits(Mylibrary,_Component);function Mylibrary(props){_classCallCheck(this,Mylibrary);var _this=_possibleConstructorReturn(this,(Mylibrary.__proto__||Object.getPrototypeOf(Mylibrary)).call(this,props));_this.state={leftnav:[],rightnav:[],contentmsg:'Loading...',id:'',video:'',catvid:'Category',catdown:'Video Library',typeshow:'category',catvidimg:'video-cam-icon.png',show:'show',local:''};_this.getLibrary=_this.getLibrary.bind(_this);_this.getSublists=_this.getSublists.bind(_this);_this.getRightlst=_this.getRightlst.bind(_this);_this.updateViews=_this.updateViews.bind(_this);return _this;}_createClass(Mylibrary,[{key:'getMedia',value:function getMedia(file){var trackData={compseq_id:'',lroom_id:'',divider_id:'',learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */](),dlr_id:'',compo_type:'my_library'};var play="";var domain='';if(this.state.local==""){domain=__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'admin/library_files/';}else{domain=this.state.local+'library_files/';}if(file){var filename=file;// let file_type = filename.substr(-3);
var file_type=filename.split('.').pop();if(file_type=='mp4'||file_type=='MP4'){var new_file=domain+file;var video_playlist={splash:true,share:false,ratio:9/16,clip:{sources:[{type:"video/"+file_type,src:new_file}]}};play=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:Date.now(),playlist:video_playlist,trackData:trackData});}}return play;}},{key:'getContent',value:function getContent(content){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]('',content,'library');}},{key:'updateViews',value:function updateViews(post_id){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'left/update-newpost',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,post_id:post_id,type:'library'})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){setTimeout(function(){_this2.props.getNewPost();},5000);}});}},{key:'downFiles',value:function downFiles(file){var usableType=this.props.usableType;var domain=__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'download/admin/';var file_path=domain+file;if(usableType=='mobileapp'){// document.location=file_path;      
window.location.href=file_path;}else{// window.location.href = file_path;
window.open(file_path,'_blank');}}},{key:'getFiles',value:function getFiles(file){var domain=__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'admin/library_files/';var trackData={compseq_id:'',lroom_id:'',divider_id:'',learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */](),dlr_id:'',compo_type:'my_library'};if(file){var filename=file;//let file_type = filename.substr(-3);
var file_type=filename.split('.').pop();if(file_type=='mp4'||file_type=='MP4'){var new_file=domain+file;var video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/"+file_type,src:new_file}]}};this.setState({video:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{playlist:video_playlist,trackData:trackData})});}else{this.setState({video:''});var file_path=domain+file;window.open(file_path,'_blank');}}}},{key:'getSublists',value:function getSublists(e){var checkElement=$(e.target).parent();var gw_nav=$('.gw-nav');gw_nav.find('li').removeClass('active');$('.gw-nav > li > ul > li').removeClass('active');var ulDom=checkElement.find('.library_submenu')[0];// alert(ulDom);
if(ulDom==undefined){checkElement.addClass('active');$('.gw-nav').find('li').find('ul:visible').slideUp();return;}if(checkElement.css('display')!='block'){// $(".library_submenu").css('display','block');
gw_nav.find('li').find('ul:visible').slideUp();gw_nav.find('li.init-arrow-up').removeClass('init-arrow-up').addClass('arrow-down');gw_nav.find('li.arrow-up').removeClass('arrow-up').addClass('arrow-down');checkElement.removeClass('init-arrow-down');checkElement.removeClass('arrow-down');checkElement.addClass('arrow-up');checkElement.addClass('active');checkElement.find('ul').slideDown(300);}else{checkElement.removeClass('init-arrow-up');checkElement.removeClass('arrow-up');checkElement.removeClass('active');checkElement.addClass('arrow-down');checkElement.find('ul').slideUp(300);}}},{key:'getRightlst',value:function getRightlst(subcat_id){var old_id=this.state.id;$("#"+old_id).css('display','none');$("#"+subcat_id).css('display','block');this.setState({id:subcat_id,video:''});//right side scroll bar
var scrollbar=$('#right_scrollof_'+subcat_id);if(scrollbar.height()>500){$('.semana-scroll-innerr-right_'+subcat_id).tinyscrollbar();$('.semana-scroll-innerr-right_'+subcat_id+' .scrollbar').show();}// let scrollbar = $('.library_cat_right #'+subcat_id+' .semana-scroll-innerr');
// scrollbar.tinyscrollbar();
// let scrollbar_data = scrollbar.data("plugin_tinyscrollbar");
// scrollbar_data.update();
}},{key:'getTabs',value:function getTabs(){// let scrollbar99 = $('#semana-scroll-inner4');
//scrollbar99.tinyscrollbar();
// let scrollbar = $('#semana-scroll-innerr');
// scrollbar.tinyscrollbar();
$('.gw-nav > li > ul > li > a').click(function(){$(this).parent().parent().parent().removeClass('active');$('.gw-nav > li > ul > li').removeClass('active');$(this).parent().addClass('active');});}},{key:'getLibrary',value:function getLibrary(type){var _this3=this;__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();//alert(type);
var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("productID",true);var pinID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("pinID",true);//alert(pinID);
__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'resources/get-library',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,product:productID,type:type,pin:pinID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
//alert(responseJson.type.catvid);
if(responseJson.status!=0){_this3.setState({leftnav:responseJson.lib_left,rightnav:responseJson.lib_right,typeshow:responseJson.type.typeshow,catvid:responseJson.type.catvid,catdown:responseJson.type.catdown,catvidimg:responseJson.type.catvidimg,show:responseJson.type.show,local:responseJson.type.local,contentmsg:responseJson.lib_left.length==0?"No Records Found.":"Loading..."});//left side scroll bar
var scrollbar99=$('.library_list');if(scrollbar99.height()>500){$('#semana-scroll-inner4').tinyscrollbar();$('#semana-scroll-inner4 .scrollbar').show();}//scrollbar99.tinyscrollbar();
}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// this.getTabs();
this.getLibrary('category');}},{key:'componentDidMount',value:function componentDidMount(){this.getTabs();this.getLibrary(this.state.typeshow);}},{key:'render',value:function render(){var _this4=this;//alert(this.state.show);
var left_nav="";var value=0;var contentmsgof=this.state.contentmsg;//console.log(contentmsgof);
if(this.state.leftnav!=null||this.state.leftnav!=undefined){left_nav=this.state.leftnav.map(function(libleft,i){var sub_left='';if(libleft.sub_lst!=undefined){sub_left=libleft.sub_lst.map(function(sublst,k){if(sublst!=''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'sublst_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this4.getRightlst(sublst.lib_sub_cat_id_pk);},href:'javascript:void(0);',className:'libtxt1'},sublst.lib_subcategory,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sublst.img}})));}});}if(libleft!=''){value++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'leftlst_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:libleft.class,onClick:function onClick(e){return _this4.getSublists(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'list-num'},value),libleft.cat_name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:libleft.img}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'library_submenu'},sub_left));}});}var right_nav='';if(this.state.rightnav!=null||this.state.rightnav!=undefined){right_nav=this.state.rightnav.map(function(rightlst,i){var sub_right='';var lib_right='';if(rightlst!=''){lib_right=rightlst.sub_lst.map(function(libright,index){if(libright.right!=undefined){sub_right=libright.right.map(function(subrightlst,k){if(subrightlst!=''){if(subrightlst.file_upload!=''){var filename=subrightlst.file_upload;// let file_type = filename.substr(-3);
var file_type=filename.split('.').pop();//alert(file_type);
var file_sent=__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'admin/library_files/'+filename;var new_file=new Buffer(file_sent).toString("base64");if(_this4.state.typeshow=='video'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'subrightlst_'+k},file_type=="pdf"||file_type=="jpg"||file_type=="gif"||file_type=="JPG"||file_type=="GIF"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(){return _this4.downFiles(new_file);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'20',src:"/rmeta"+"/images/cat-video-icon.png",border:'0',align:'absmiddle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.updateViews(subrightlst.library_id_pk);},className:'liblink',title:'Click here to open the file'},subrightlst.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt'},'('+subrightlst.file_size+')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:subrightlst.img}}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(){return _this4.getFiles(subrightlst.file_upload);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'20',src:"/rmeta"+"/images/cat-video-icon.png",border:'0',align:'absmiddle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.updateViews(subrightlst.library_id_pk);},className:'liblink',title:'Click here to open the file'},subrightlst.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt'},'('+subrightlst.file_size+')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:subrightlst.img}}))),file_type=='mp4'||file_type=='MP4'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'display_vid'},_this4.state.video):'');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'ssubrightlst_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.updateViews(subrightlst.library_id_pk);},className:'liblink'},subrightlst.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:subrightlst.img}}))),file_type=='mp4'||file_type=='MP4'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'display_vid'},_this4.getMedia(subrightlst.file_upload)):'');}}if(subrightlst.external_url!=''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'subrightlstk_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'20',src:"/rmeta"+"/images/cat-video-icon.png",border:'0',align:'absmiddle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(e){return _this4.updateViews(subrightlst.library_id_pk);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:subrightlst.external_url,target:'_blank'},subrightlst.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:subrightlst.img}}))));}if(subrightlst.content!=''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'subrightlstc_'+k,style:{borderBottom:'1px solid #c9c2b9',float:'left',padding:'0px 0px 10px 0px',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.updateViews(subrightlst.library_id_pk);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',width:'20px',marginRight:'14px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/cnt.png",width:'20',height:'21',border:'0',align:'absmiddle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left'},className:'content-lib'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this4.getContent(subrightlst.content);},className:'liblink',title:'Click here to read the content'},subrightlst.name)));}}});}if(libright!=''){value++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'rightlst_'+index,id:libright.subcat_id,name:libright.subcat_id,style:{display:'none'},className:'cat_right_list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'cat_head_rgt'},libright.subcat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-innerr',className:'scrollbar1 semana-scroll-innerr-right_'+libright.subcat_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cat_right_list',id:'right_scrollof_'+libright.subcat_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,sub_right))))));}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'rightlstkey_'+i},lib_right);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/library_img.jpg",align:'absmiddle',alt:'',border:'0'})),'Library',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Collection of reading materials to expand learning'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myobservers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content inner-library-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'library_cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'library_cat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'library_cat_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cat_head'},' ',this.state.catvid,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner4',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'library_list gw-nav gw-nav-list',id:'leftcont'},left_nav.length>0?left_nav:contentmsgof))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'library_cat_right'},right_nav,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',value:this.state.id}))))))))));}}]);return Mylibrary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({getNewPost:__WEBPACK_IMPORTED_MODULE_7__actions_newPostAction__["a" /* getNewPost */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Mylibrary));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106).Buffer))

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IseekView__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IseekResults__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IseekForm__ = __webpack_require__(688);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import * as User from '../../helpers/User';
var $=window.$;var IseekFeedback=function(_Component){_inherits(IseekFeedback,_Component);function IseekFeedback(props){_classCallCheck(this,IseekFeedback);var _this=_possibleConstructorReturn(this,(IseekFeedback.__proto__||Object.getPrototypeOf(IseekFeedback)).call(this,props));_this.state={feedbacks:[],feedbacks_results:[],submitted:''};_this.getSeekFeedback=_this.getSeekFeedback.bind(_this);// this.geteditSubmit = this.geteditSubmit.bind(this);
return _this;}_createClass(IseekFeedback,[{key:'getSeekFeedback',value:function getSeekFeedback(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);// alert(learnerID);
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/iseek-feedback',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");_this2.setState({feedbacks:responseJson.feedbacks,feedbacks_results:responseJson.feedbacks_results});}});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){//alert('im in');
$("#formfeed").click();this.getSeekFeedback();//this.getTabs();
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}},{key:'componentWillMount',value:function componentWillMount(){this.getSeekFeedback();}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;setTimeout(function(){var self=_this3;$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});$('.resp-accordion').click(function(){if($(this).next().hasClass('viewiseek')){self.getSeekFeedback();}if($(this).next().hasClass('viewfeedback')){self.getSeekFeedback();}});},2000);// Common.showSmallLeftMenu();
}},{key:'render',value:function render(){var _this4=this;// var lrfeedbacks = this.state.feedbacks;
//alert(JSON.stringify(this.state.feedbacks));
// var lrfeedbacksresult = this.state.feedbacks_results;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/seekfdback.jpg",alt:'',border:'0',align:'absmiddle'})),'I Seek Feedback',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Ask for feedback from people'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance opinion-polls seekfdbktab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seek-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',id:'formfeed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Create & Seek',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',id:'viewfeed',onClick:function onClick(e){return _this4.getSeekFeedback(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'View Feedback Form',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:function onClick(e){return _this4.getSeekFeedback(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'View Feedback Results',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__IseekForm__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content viewiseek'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IseekView__["a" /* default */],{feedbacks:this.state.feedbacks})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content viewfeedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IseekResults__["a" /* default */],{feedbacksResults:this.state.feedbacks_results})))))))))));}}]);return IseekFeedback;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekFeedback);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Addmore__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekCreateform=function(_Component){_inherits(IseekCreateform,_Component);function IseekCreateform(props){_classCallCheck(this,IseekCreateform);var _this=_possibleConstructorReturn(this,(IseekCreateform.__proto__||Object.getPrototypeOf(IseekCreateform)).call(this,props));_this.state={};_this.submit=_this.submit.bind(_this);return _this;}_createClass(IseekCreateform,[{key:'renameInput',value:function renameInput(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";setTimeout(function(){$('div[id^="Questions"]').each(function(){var mainid=$(this).attr('id').split("_");if($('#Questions_'+mainid[1]).find(".dummy_text_select")){$('#Questions_'+mainid[1]).find(".dummy_text_select").attr("name",'snap_poll_type['+mainid[1]+']').removeClass('dummy_text_select');}if($('#Questions_'+mainid[1]).find(".dummy_text_parent")){$('#Questions_'+mainid[1]).find(".dummy_text_parent").attr("name",'snap_poll_question['+mainid[1]+']').removeClass('dummy_text_parent');}if($('#Questions_'+mainid[1]).find(".dummy_text")){$('#Questions_'+mainid[1]).find(".dummy_text").attr("name",'snap_poll_answer['+mainid[1]+'][]').removeClass('dummy_text');// $('#Questions_'+mainid[1]).find('.answers_input').append('<input type="text" name="snap_poll_answer['+mainid[1]+'][]" class="txtbox"  />');
}if($('#Questions_'+mainid[1]).find(".addanswers")){$('#Questions_'+mainid[1]).find(".addanswers").attr("id",mainid[1]).removeClass('addanswers');}});},200);}},{key:'submit',value:function submit(e){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");//let learnerID = Common.getUserData("id", true);
var formData=new FormData();var snap_poll_add_new_form=$('#snap_poll_add_new_form').serializeArray();var details=[];snap_poll_add_new_form.map(function(key,index){details.push(_defineProperty({},key.name,key.value));formData.append(key.name,key.value);});//alert(JSON.stringify(details));
fetch(__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+"personal",{method:"POST",//data: formData,
headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()//'Content-Type': 'application/json'
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",'You have created a new feedback form. You can choose to send it to persons of your choice from below.',"success");$('form#snap_poll_add_new_form')[0].reset();$("#savedform").click();}});}},{key:'getQuestype',value:function getQuestype(e){// var div = this.refs.node.parentNode.parentNode.id;
// //alert("#"+div+" #cmbPollQuestionType");
// let id = div.split('_');
// id= id[1];
// id="cmbPollQuestionType"+id;
var qtype=document.querySelectorAll('.qtype');var ansdiv=document.querySelectorAll('.ansdiv');// Set their ids
for(var i=0;i<qtype.length;i++){qtype[i].id='cmbPollQuestionType_'+i;}for(var i=0;i<ansdiv.length;i++){ansdiv[i].id='PollAnswertr_'+i;}var id=e.target.id;var ansid=id.split('_');ansid=ansid[1];if($("#"+id).val()==2){$("#PollAnswertr_"+ansid).hide();//$("#PollAnswertr_"+ansid +' :input').attr('disabled',true);
}else{$("#PollAnswertr_"+ansid).show();// $("#PollAnswertr_"+ansid +' :input').removeAttr('disabled');
}}},{key:'componentDidMount',value:function componentDidMount(){var qtype=document.querySelectorAll('.qtype');var ansdiv=document.querySelectorAll('.ansdiv');// Set their ids
for(var i=0;i<qtype.length;i++){qtype[i].id='cmbPollQuestionType_'+i;}for(var i=0;i<ansdiv.length;i++){ansdiv[i].id='Poll_Answer_tr'+i;}}},{key:'render',value:function render(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var date=new Date();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content_poll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'snap_poll_add_new_form',name:'snap_poll_add_new_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gradientbg gradientbg1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Form Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'created_date',value:date,format:'Y-m-d'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'lr_id',value:learnerID}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'snap_poll_title',id:'txtPollTitle',className:'snap_textbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-content',id:'Main_Question_div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Addmore__["a" /* default */],{selector:'Questions',limit:6,AddLabel:'+ Add Questions',DeleteLabel:'X',compType:'parent',editType:'form',refreshScroll:function refreshScroll(e){return _this2.renameInput(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox',id:'question1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdback-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Question type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'snap_poll_type[0]',className:'qtype dummy_text_select',onChange:function onChange(e){return _this2.getQuestype(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Multiple choice question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Open ended question')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'snap_poll_question[0]',id:'txtPollQuestion',className:'snap_textbox dummy_text_parent'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-right ansdiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'Main_answer_div1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'answer_div11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Answer Choices'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl addanswers',id:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Addmore__["a" /* default */],{selector:'answers',limit:4,AddLabel:'+ Add Choices',DeleteLabel:'X',compType:'child',editType:'form',refreshScroll:function refreshScroll(e){return _this2.renameInput(e);},parent:'Questions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'snap_poll_answer[0][0]',className:'txtbox dummy_text',type:'text'}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSubmit',id:'',value:'Save',alt:'Save',title:'Save',className:'button-accept',onClick:function onClick(e){return _this2.submit(e);}})))));}}]);return IseekCreateform;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekCreateform);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObserverView__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mentorhistory__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ObserverForm__ = __webpack_require__(697);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Left from '../../partials/Left';
// import * as User from '../../helpers/User';
var $=window.$;var MyObserver=function(_Component){_inherits(MyObserver,_Component);function MyObserver(props){_classCallCheck(this,MyObserver);var _this=_possibleConstructorReturn(this,(MyObserver.__proto__||Object.getPrototypeOf(MyObserver)).call(this,props));_this.state={actyetact:[],mentorhistory:[],formtodata:[]};_this.getObserverView=_this.getObserverView.bind(_this);// this.get = this.get.bind(this);
return _this;}_createClass(MyObserver,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){$("#actob").click();this.getObserverView();//this.getTabs();
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}},{key:'getTabs',value:function getTabs(){var self=this;$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});$('#ChildVerticalTab_1').easyResponsiveTabs({type:'vertical',width:'auto',fit:true,tabidentify:'ver_1'});//Common.showSmallLeftMenu();
$('.resp-accordion').click(function(){if($(this).next().hasClass('activeobs')){self.getObserverView();}if($(this).next().hasClass('inactiveobs')){self.getObserverView();}if($(this).next().hasClass('viewobserver')){self.getObserverView();}if($(this).next().hasClass('mentorhis')){self.getObserverView();}});}},{key:'getObserverView',value:function getObserverView(){var _this2=this;//alert("in");
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/observers-view',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this2.setState({actyetact:responseJson.actyetact,mentorhistory:responseJson.mentorhistory,formtodata:responseJson.formtodata});}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}//   	get(){
// 	//alert(JSON.stringify(this.state.actyetact));
// 	this.setState({
//        	actyetact : this.state.actyetact
//        });
// }
},{key:'componentWillMount',value:function componentWillMount(){this.getObserverView();}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;setTimeout(function(){_this3.getTabs();},2000);}},{key:'render',value:function render(){//alert(JSON.stringify(this.state.actyetact));//
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img-myobserver.jpg",align:'absmiddle',alt:'',border:'0'})),'My Observers',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'My learning support - my peers, friends, family members, seniors'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance myobservers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:this.getObserverView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'View my Observers ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',title:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Add new Observer ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',title:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:this.getObserverView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'View Observer\'s footprint ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',title:'',border:'0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 tapmargntop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content viewobserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ObserverView__["a" /* default */],{actyetact:this.state.actyetact,callFun:this.getObserverView})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ObserverForm__["a" /* default */],{formtodata:this.state.formtodata})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content mentorhis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Mentorhistory__["a" /* default */],{mentorhistory:this.state.mentorhistory}))))))))));}}]);return MyObserver;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyObserver);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var TechSupport=function(_Component){_inherits(TechSupport,_Component);function TechSupport(props){_classCallCheck(this,TechSupport);//alert('im in');
var _this=_possibleConstructorReturn(this,(TechSupport.__proto__||Object.getPrototypeOf(TechSupport)).call(this,props));_this.state={};return _this;}// componentWillReceiveProps(next) {
// }
_createClass(TechSupport,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();//alert('im in');
}},{key:'sendSupportQuery',value:function sendSupportQuery(){var formData=new FormData();formData.append("user_id",__WEBPACK_IMPORTED_MODULE_4__helpers_User__["a" /* UserId */]());formData.append("subject",this.refs.subject.value);formData.append("query",this.refs.query.value);if(this.refs.attachment.files[0]!=undefined){formData.append("attachment",this.refs.attachment.files[0]);}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/supportdesk/query",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");$('form#techsupport')[0].reset();}});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/support_desk_img.jpg",alt:'',border:'0',align:'absmiddle'})),'Tech Support Desk',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'For Technical Queries and Clarifications about the program.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{top:'0px'},className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'techsupport',id:'techsupport',method:'post',encType:'multipart/form-data',action:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'viewobservers addobservers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-observer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-form-left tech-support'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'To')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'bluetxt'},'Tech Support Desk'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Subject')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',ref:'subject',className:'textbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Query')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{ref:'query',className:'textarea'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Attachment')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'attachment',type:'file',style:{border:"none"},'data-valid-types':'jpg,jpeg,png,gif','data-max-limit':'2097152',onChange:function onChange(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["l" /* validateFile */])(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltextreg',style:{color:"#ff5400"}},'Maximum upload size is 2MB. (Only JPEG, GIF Formats)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Send',alt:'Send',title:'Send',onClick:function onClick(){return _this2.sendSupportQuery();}}))))))))))))));}}]);return TechSupport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TechSupport);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelecallBook__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TeleCalender__ = __webpack_require__(699);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var TelecallRequest=function(_Component){_inherits(TelecallRequest,_Component);function TelecallRequest(props){_classCallCheck(this,TelecallRequest);var _this=_possibleConstructorReturn(this,(TelecallRequest.__proto__||Object.getPrototypeOf(TelecallRequest)).call(this,props));_this.state={component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TelecallBook__["a" /* default */],{setCalender:_this.Calender.bind(_this),updateComp:_this.onChangedComp.bind(_this)})};return _this;}_createClass(TelecallRequest,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TelecallBook__["a" /* default */],{setCalender:this.Calender.bind(this),updateComp:this.onChangedComp.bind(this)})});}},{key:'onChangedComp',value:function onChangedComp(val){if(val){this.setState({component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TelecallBook__["a" /* default */],{setCalender:this.Calender.bind(this),updateComp:this.onChangedComp.bind(this)})});}}},{key:'Calender',value:function Calender(call_id,tele_id){this.setState({component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TeleCalender__["a" /* default */],{call_id:call_id,tele_id:tele_id,ChangedComp:this.onChangedComp.bind(this)})});}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/telecalreq-icon.png",alt:'',border:'0',align:'absmiddle'})),'Telecalls Request',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Schedule a one-on-one telecall with your E Coach'))),this.state.component);}}]);return TelecallRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TelecallRequest);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Calendar = __webpack_require__(701);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _EventWrapper = __webpack_require__(329);

var _EventWrapper2 = _interopRequireDefault(_EventWrapper);

var _BackgroundWrapper = __webpack_require__(186);

var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);

var _localizer = __webpack_require__(17);

var _moment = __webpack_require__(795);

var _moment2 = _interopRequireDefault(_moment);

var _globalize = __webpack_require__(796);

var _globalize2 = _interopRequireDefault(_globalize);

var _move = __webpack_require__(302);

var _move2 = _interopRequireDefault(_move);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_extends(_Calendar2.default, {
  setLocalizer: _localizer.set,
  globalizeLocalizer: _globalize2.default,
  momentLocalizer: _moment2.default,
  Views: _constants.views,
  Navigate: _constants.navigate,
  move: _move2.default,
  components: {
    eventWrapper: _EventWrapper2.default,
    dayWrapper: _BackgroundWrapper2.default,
    dateCellWrapper: _BackgroundWrapper2.default
  }
});

exports.default = _Calendar2.default;
module.exports = exports['default'];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = moveDate;

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = __webpack_require__(29);

var _Views = __webpack_require__(303);

var _Views2 = _interopRequireDefault(_Views);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function moveDate(View, _ref) {
  var action = _ref.action,
      date = _ref.date,
      today = _ref.today,
      props = _objectWithoutProperties(_ref, ['action', 'date', 'today']);

  View = typeof View === 'string' ? _Views2.default[View] : View;

  switch (action) {
    case _constants.navigate.TODAY:
      date = today || new Date();
      break;
    case _constants.navigate.DATE:
      break;
    default:
      !(View && typeof View.navigate === 'function') ?  false ? (0, _invariant2.default)(false, 'Calendar View components must implement a static `.navigate(date, action)` method.s') : (0, _invariant2.default)(false) : void 0;
      date = View.navigate(date, action, props);
  }
  return date;
}
module.exports = exports['default'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VIEWS;

var _constants = __webpack_require__(29);

var _Month = __webpack_require__(708);

var _Month2 = _interopRequireDefault(_Month);

var _Day = __webpack_require__(759);

var _Day2 = _interopRequireDefault(_Day);

var _Week = __webpack_require__(328);

var _Week2 = _interopRequireDefault(_Week);

var _WorkWeek = __webpack_require__(780);

var _WorkWeek2 = _interopRequireDefault(_WorkWeek);

var _Agenda = __webpack_require__(781);

var _Agenda2 = _interopRequireDefault(_Agenda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWS = (_VIEWS = {}, _VIEWS[_constants.views.MONTH] = _Month2.default, _VIEWS[_constants.views.WEEK] = _Week2.default, _VIEWS[_constants.views.WORK_WEEK] = _WorkWeek2.default, _VIEWS[_constants.views.DAY] = _Day2.default, _VIEWS[_constants.views.AGENDA] = _Agenda2.default, _VIEWS);

exports.default = VIEWS;
module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(306);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(710);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(711));

var _offset = _interopRequireDefault(__webpack_require__(76));

var _offsetParent = _interopRequireDefault(__webpack_require__(712));

var _scrollTop = _interopRequireDefault(__webpack_require__(175));

var _scrollLeft = _interopRequireDefault(__webpack_require__(310));

var _style = _interopRequireDefault(__webpack_require__(308));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(309));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(714));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(716));

var _removeStyle = _interopRequireDefault(__webpack_require__(717));

var _properties = __webpack_require__(718);

var _isTransform = _interopRequireDefault(__webpack_require__(719));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(713));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(77));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _propTypes3 = __webpack_require__(20);

var _accessors = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  event: _propTypes2.default.object.isRequired,
  slotStart: _propTypes2.default.instanceOf(Date),
  slotEnd: _propTypes2.default.instanceOf(Date),

  selected: _propTypes2.default.bool,
  isAllDay: _propTypes2.default.bool,
  eventPropGetter: _propTypes2.default.func,
  titleAccessor: _propTypes3.accessor,
  tooltipAccessor: _propTypes3.accessor,
  allDayAccessor: _propTypes3.accessor,
  startAccessor: _propTypes3.accessor,
  endAccessor: _propTypes3.accessor,

  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onDoubleClick: _propTypes2.default.func.isRequired
};

var EventCell = function (_React$Component) {
  _inherits(EventCell, _React$Component);

  function EventCell() {
    _classCallCheck(this, EventCell);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventCell.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        event = _props.event,
        selected = _props.selected,
        isAllDay = _props.isAllDay,
        eventPropGetter = _props.eventPropGetter,
        startAccessor = _props.startAccessor,
        endAccessor = _props.endAccessor,
        titleAccessor = _props.titleAccessor,
        tooltipAccessor = _props.tooltipAccessor,
        slotStart = _props.slotStart,
        slotEnd = _props.slotEnd,
        onSelect = _props.onSelect,
        _onDoubleClick = _props.onDoubleClick,
        Event = _props.eventComponent,
        EventWrapper = _props.eventWrapperComponent,
        props = _objectWithoutProperties(_props, ['className', 'event', 'selected', 'isAllDay', 'eventPropGetter', 'startAccessor', 'endAccessor', 'titleAccessor', 'tooltipAccessor', 'slotStart', 'slotEnd', 'onSelect', 'onDoubleClick', 'eventComponent', 'eventWrapperComponent']);

    var title = (0, _accessors.accessor)(event, titleAccessor),
        tooltip = (0, _accessors.accessor)(event, tooltipAccessor),
        end = (0, _accessors.accessor)(event, endAccessor),
        start = (0, _accessors.accessor)(event, startAccessor),
        isAllDayEvent = isAllDay || (0, _accessors.accessor)(event, props.allDayAccessor) || _dates2.default.diff(start, _dates2.default.ceil(end, 'day'), 'day') > 1,
        continuesPrior = _dates2.default.lt(start, slotStart, 'day'),
        continuesAfter = _dates2.default.gte(end, slotEnd, 'day');

    if (eventPropGetter) var _eventPropGetter = eventPropGetter(event, start, end, selected),
          style = _eventPropGetter.style,
          xClassName = _eventPropGetter.className;

    return _react2.default.createElement(
      EventWrapper,
      { event: event },
      _react2.default.createElement(
        'div',
        {
          style: _extends({}, props.style, style),
          className: (0, _classnames2.default)('rbc-event', className, xClassName, {
            'rbc-selected': selected,
            'rbc-event-allday': isAllDayEvent,
            'rbc-event-continues-prior': continuesPrior,
            'rbc-event-continues-after': continuesAfter
          }),
          onClick: function onClick(e) {
            return onSelect(event, e);
          },
          onDoubleClick: function onDoubleClick(e) {
            return _onDoubleClick(event, e);
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'rbc-event-content', title: tooltip || undefined },
          Event ? _react2.default.createElement(Event, { event: event, title: title, isAllDay: isAllDayEvent }) : title
        )
      )
    );
  };

  return EventCell;
}(_react2.default.Component);

EventCell.propTypes = propTypes;

exports.default = EventCell;
module.exports = exports['default'];

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _height = __webpack_require__(315);

var _height2 = _interopRequireDefault(_height);

var _querySelectorAll = __webpack_require__(180);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _propTypes3 = __webpack_require__(20);

var _eventLevels2 = __webpack_require__(46);

var _BackgroundCells = __webpack_require__(747);

var _BackgroundCells2 = _interopRequireDefault(_BackgroundCells);

var _EventRow = __webpack_require__(753);

var _EventRow2 = _interopRequireDefault(_EventRow);

var _EventEndingRow = __webpack_require__(754);

var _EventEndingRow2 = _interopRequireDefault(_EventEndingRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};

var propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  events: _propTypes2.default.array.isRequired,
  range: _propTypes2.default.array.isRequired,

  rtl: _propTypes2.default.bool,
  renderForMeasure: _propTypes2.default.bool,
  renderHeader: _propTypes2.default.func,

  container: _propTypes2.default.func,
  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onShowMore: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func,
  onSelectEnd: _propTypes2.default.func,
  onSelectStart: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,

  getNow: _propTypes2.default.func.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,

  dateCellWrapper: _propTypes3.elementType,
  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  minRows: _propTypes2.default.number.isRequired,
  maxRows: _propTypes2.default.number.isRequired
};

var defaultProps = {
  minRows: 0,
  maxRows: Infinity
};

var DateContentRow = function (_React$Component) {
  _inherits(DateContentRow, _React$Component);

  function DateContentRow() {
    _classCallCheck(this, DateContentRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _this.handleSelectSlot = function (slot) {
      var _this$props = _this.props,
          range = _this$props.range,
          onSelectSlot = _this$props.onSelectSlot;


      onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
    };

    _this.handleShowMore = function (slot) {
      var _this$props2 = _this.props,
          range = _this$props2.range,
          onShowMore = _this$props2.onShowMore;

      var row = (0, _querySelectorAll2.default)((0, _reactDom.findDOMNode)(_this), '.rbc-row-bg')[0];

      var cell = void 0;
      if (row) cell = row.children[slot - 1];

      var events = _this.segments.filter(function (seg) {
        return isSegmentInSlot(seg, slot);
      }).map(function (seg) {
        return seg.event;
      });

      onShowMore(events, range[slot - 1], cell, slot);
    };

    _this.createHeadingRef = function (r) {
      _this.headingRow = r;
    };

    _this.createEventRef = function (r) {
      _this.eventRow = r;
    };

    _this.getContainer = function () {
      var container = _this.props.container;

      return container ? container() : (0, _reactDom.findDOMNode)(_this);
    };

    _this.renderHeadingCell = function (date, index) {
      var _this$props3 = _this.props,
          renderHeader = _this$props3.renderHeader,
          range = _this$props3.range,
          getNow = _this$props3.getNow;


      return renderHeader({
        date: date,
        key: 'header_' + index,
        style: (0, _eventLevels2.segStyle)(1, range.length),
        className: (0, _classnames2.default)('rbc-date-cell', _dates2.default.eq(date, getNow(), 'day') && 'rbc-now')
      });
    };

    _this.renderDummy = function () {
      var _this$props4 = _this.props,
          className = _this$props4.className,
          range = _this$props4.range,
          renderHeader = _this$props4.renderHeader;

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'rbc-row-content' },
          renderHeader && _react2.default.createElement(
            'div',
            { className: 'rbc-row', ref: _this.createHeadingRef },
            range.map(_this.renderHeadingCell)
          ),
          _react2.default.createElement(
            'div',
            { className: 'rbc-row', ref: _this.createEventRef },
            _react2.default.createElement(
              'div',
              { className: 'rbc-row-segment', style: (0, _eventLevels2.segStyle)(1, range.length) },
              _react2.default.createElement(
                'div',
                { className: 'rbc-event' },
                _react2.default.createElement(
                  'div',
                  { className: 'rbc-event-content' },
                  '\xA0'
                )
              )
            )
          )
        )
      );
    };

    return _this;
  }

  DateContentRow.prototype.getRowLimit = function getRowLimit() {
    var eventHeight = (0, _height2.default)(this.eventRow);
    var headingHeight = this.headingRow ? (0, _height2.default)(this.headingRow) : 0;
    var eventSpace = (0, _height2.default)((0, _reactDom.findDOMNode)(this)) - headingHeight;

    return Math.max(Math.floor(eventSpace / eventHeight), 1);
  };

  DateContentRow.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        rtl = _props.rtl,
        events = _props.events,
        range = _props.range,
        className = _props.className,
        selectable = _props.selectable,
        dayPropGetter = _props.dayPropGetter,
        renderForMeasure = _props.renderForMeasure,
        startAccessor = _props.startAccessor,
        endAccessor = _props.endAccessor,
        getNow = _props.getNow,
        renderHeader = _props.renderHeader,
        minRows = _props.minRows,
        maxRows = _props.maxRows,
        dateCellWrapper = _props.dateCellWrapper,
        eventComponent = _props.eventComponent,
        eventWrapperComponent = _props.eventWrapperComponent,
        onSelectStart = _props.onSelectStart,
        onSelectEnd = _props.onSelectEnd,
        longPressThreshold = _props.longPressThreshold,
        props = _objectWithoutProperties(_props, ['date', 'rtl', 'events', 'range', 'className', 'selectable', 'dayPropGetter', 'renderForMeasure', 'startAccessor', 'endAccessor', 'getNow', 'renderHeader', 'minRows', 'maxRows', 'dateCellWrapper', 'eventComponent', 'eventWrapperComponent', 'onSelectStart', 'onSelectEnd', 'longPressThreshold']);

    if (renderForMeasure) return this.renderDummy();

    var _endOfRange = (0, _eventLevels2.endOfRange)(range),
        first = _endOfRange.first,
        last = _endOfRange.last;

    var segments = this.segments = events.map(function (evt) {
      return (0, _eventLevels2.eventSegments)(evt, first, last, {
        startAccessor: startAccessor,
        endAccessor: endAccessor
      }, range);
    });

    var _eventLevels = (0, _eventLevels2.eventLevels)(segments, Math.max(maxRows - 1, 1)),
        levels = _eventLevels.levels,
        extra = _eventLevels.extra;

    while (levels.length < minRows) {
      levels.push([]);
    }return _react2.default.createElement(
      'div',
      { className: className },
      _react2.default.createElement(_BackgroundCells2.default, {
        date: date,
        getNow: getNow,
        rtl: rtl,
        range: range,
        selectable: selectable,
        container: this.getContainer,
        dayPropGetter: dayPropGetter,
        onSelectStart: onSelectStart,
        onSelectEnd: onSelectEnd,
        onSelectSlot: this.handleSelectSlot,
        cellWrapperComponent: dateCellWrapper,
        longPressThreshold: longPressThreshold
      }),
      _react2.default.createElement(
        'div',
        { className: 'rbc-row-content' },
        renderHeader && _react2.default.createElement(
          'div',
          { className: 'rbc-row', ref: this.createHeadingRef },
          range.map(this.renderHeadingCell)
        ),
        levels.map(function (segs, idx) {
          return _react2.default.createElement(_EventRow2.default, _extends({}, props, {
            key: idx,
            start: first,
            end: last,
            segments: segs,
            slots: range.length,
            eventComponent: eventComponent,
            eventWrapperComponent: eventWrapperComponent,
            startAccessor: startAccessor,
            endAccessor: endAccessor
          }));
        }),
        !!extra.length && _react2.default.createElement(_EventEndingRow2.default, _extends({}, props, {
          start: first,
          end: last,
          segments: extra,
          onShowMore: this.handleShowMore,
          eventComponent: eventComponent,
          eventWrapperComponent: eventWrapperComponent,
          startAccessor: startAccessor,
          endAccessor: endAccessor
        }))
      )
    );
  };

  return DateContentRow;
}(_react2.default.Component);

DateContentRow.propTypes = propTypes;
DateContentRow.defaultProps = defaultProps;

exports.default = DateContentRow;
module.exports = exports['default'];

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = height;

var _offset = _interopRequireDefault(__webpack_require__(76));

var _isWindow = _interopRequireDefault(__webpack_require__(77));

function height(node, client) {
  var win = (0, _isWindow.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
}

module.exports = exports["default"];

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isEvent = isEvent;
exports.objectsCollide = objectsCollide;
exports.getBoundsForNode = getBoundsForNode;

var _contains = __webpack_require__(110);

var _contains2 = _interopRequireDefault(_contains);

var _closest = __webpack_require__(748);

var _closest2 = _interopRequireDefault(_closest);

var _events = __webpack_require__(750);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addEventListener(type, handler) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;

  _events2.default.on(target, type, handler);
  return {
    remove: function remove() {
      _events2.default.off(target, type, handler);
    }
  };
}

function isOverContainer(container, x, y) {
  return !container || (0, _contains2.default)(container, document.elementFromPoint(x, y));
}

function isEvent(node, _ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;

  var target = document.elementFromPoint(clientX, clientY);
  return !!(0, _closest2.default)(target, '.rbc-event', node);
}

function getEventCoordinates(e) {
  var target = e;

  if (e.touches && e.touches.length) {
    target = e.touches[0];
  }

  return {
    clientX: target.clientX,
    clientY: target.clientY,
    pageX: target.pageX,
    pageY: target.pageY
  };
}

var clickTolerance = 5;
var clickInterval = 250;

var Selection = function () {
  function Selection(node) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$global = _ref2.global,
        global = _ref2$global === undefined ? false : _ref2$global,
        _ref2$longPressThresh = _ref2.longPressThreshold,
        longPressThreshold = _ref2$longPressThresh === undefined ? 250 : _ref2$longPressThresh;

    _classCallCheck(this, Selection);

    this.container = node;
    this.globalMouse = !node || global;
    this.longPressThreshold = longPressThreshold;

    this._listeners = Object.create(null);

    this._handleInitialEvent = this._handleInitialEvent.bind(this);
    this._handleMoveEvent = this._handleMoveEvent.bind(this);
    this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
    this._keyListener = this._keyListener.bind(this);

    // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
    // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
    this._onTouchMoveWindowListener = addEventListener('touchmove', function () {}, window);
    this._onKeyDownListener = addEventListener('keydown', this._keyListener);
    this._onKeyUpListener = addEventListener('keyup', this._keyListener);
    this._addInitialEventListener();
  }

  Selection.prototype.on = function on(type, handler) {
    var handlers = this._listeners[type] || (this._listeners[type] = []);

    handlers.push(handler);

    return {
      remove: function remove() {
        var idx = handlers.indexOf(handler);
        if (idx !== -1) handlers.splice(idx, 1);
      }
    };
  };

  Selection.prototype.emit = function emit(type) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var result = void 0;
    var handlers = this._listeners[type] || [];
    handlers.forEach(function (fn) {
      if (result === undefined) result = fn.apply(undefined, args);
    });
    return result;
  };

  Selection.prototype.teardown = function teardown() {
    this.listeners = Object.create(null);
    this._onTouchMoveWindowListener && this._onTouchMoveWindowListener.remove();
    this._onInitialEventListener && this._onInitialEventListener.remove();
    this._onEndListener && this._onEndListener.remove();
    this._onMoveListener && this._onMoveListener.remove();
    this._onKeyUpListener && this._onKeyUpListener.remove();
    this._onKeyDownListener && this._onKeyDownListener.remove();
  };

  Selection.prototype.isSelected = function isSelected(node) {
    var box = this._selectRect;

    if (!box || !this.selecting) return false;

    return objectsCollide(box, getBoundsForNode(node));
  };

  Selection.prototype.filter = function filter(items) {
    var box = this._selectRect;

    //not selecting
    if (!box || !this.selecting) return [];

    return items.filter(this.isSelected, this);
  };

  // Adds a listener that will call the handler only after the user has pressed on the screen
  // without moving their finger for 250ms.


  Selection.prototype._addLongPressListener = function _addLongPressListener(handler, initialEvent) {
    var _this = this;

    var timer = null;
    var touchMoveListener = null;
    var touchEndListener = null;
    var handleTouchStart = function handleTouchStart(initialEvent) {
      timer = setTimeout(function () {
        cleanup();
        handler(initialEvent);
      }, _this.longPressThreshold);
      touchMoveListener = addEventListener('touchmove', function () {
        return cleanup();
      });
      touchEndListener = addEventListener('touchend', function () {
        return cleanup();
      });
    };
    var touchStartListener = addEventListener('touchstart', handleTouchStart);
    var cleanup = function cleanup() {
      if (timer) {
        clearTimeout(timer);
      }
      if (touchMoveListener) {
        touchMoveListener.remove();
      }
      if (touchEndListener) {
        touchEndListener.remove();
      }

      timer = null;
      touchMoveListener = null;
      touchEndListener = null;
    };

    if (initialEvent) {
      handleTouchStart(initialEvent);
    }

    return {
      remove: function remove() {
        cleanup();
        touchStartListener.remove();
      }
    };
  };

  // Listen for mousedown and touchstart events. When one is received, disable the other and setup
  // future event handling based on the type of event.


  Selection.prototype._addInitialEventListener = function _addInitialEventListener() {
    var _this2 = this;

    var mouseDownListener = addEventListener('mousedown', function (e) {
      _this2._onInitialEventListener.remove();
      _this2._handleInitialEvent(e);
      _this2._onInitialEventListener = addEventListener('mousedown', _this2._handleInitialEvent);
    });
    var touchStartListener = addEventListener('touchstart', function (e) {
      _this2._onInitialEventListener.remove();
      _this2._onInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
    });

    this._onInitialEventListener = {
      remove: function remove() {
        mouseDownListener.remove();
        touchStartListener.remove();
      }
    };
  };

  Selection.prototype._handleInitialEvent = function _handleInitialEvent(e) {
    var _getEventCoordinates = getEventCoordinates(e),
        clientX = _getEventCoordinates.clientX,
        clientY = _getEventCoordinates.clientY,
        pageX = _getEventCoordinates.pageX,
        pageY = _getEventCoordinates.pageY;

    var node = this.container(),
        collides = void 0,
        offsetData = void 0;

    // Right clicks
    if (e.which === 3 || e.button === 2 || !isOverContainer(node, clientX, clientY)) return;

    if (!this.globalMouse && node && !(0, _contains2.default)(node, e.target)) {
      var _normalizeDistance = normalizeDistance(0),
          top = _normalizeDistance.top,
          left = _normalizeDistance.left,
          bottom = _normalizeDistance.bottom,
          right = _normalizeDistance.right;

      offsetData = getBoundsForNode(node);

      collides = objectsCollide({
        top: offsetData.top - top,
        left: offsetData.left - left,
        bottom: offsetData.bottom + bottom,
        right: offsetData.right + right
      }, { top: pageY, left: pageX });

      if (!collides) return;
    }

    var result = this.emit('beforeSelect', this._initialEventData = {
      isTouch: /^touch/.test(e.type),
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });

    if (result === false) return;

    switch (e.type) {
      case 'mousedown':
        this._onEndListener = addEventListener('mouseup', this._handleTerminatingEvent);
        this._onMoveListener = addEventListener('mousemove', this._handleMoveEvent);
        break;
      case 'touchstart':
        this._handleMoveEvent(e);
        this._onEndListener = addEventListener('touchend', this._handleTerminatingEvent);
        this._onMoveListener = addEventListener('touchmove', this._handleMoveEvent);
        break;
      default:
        break;
    }
  };

  Selection.prototype._handleTerminatingEvent = function _handleTerminatingEvent(e) {
    var _getEventCoordinates2 = getEventCoordinates(e),
        pageX = _getEventCoordinates2.pageX,
        pageY = _getEventCoordinates2.pageY;

    this.selecting = false;

    this._onEndListener && this._onEndListener.remove();
    this._onMoveListener && this._onMoveListener.remove();

    if (!this._initialEventData) return;

    var inRoot = !this.container || (0, _contains2.default)(this.container(), e.target);
    var bounds = this._selectRect;
    var click = this.isClick(pageX, pageY);

    this._initialEventData = null;

    if (click && !inRoot) {
      return this.emit('reset');
    }

    if (click && inRoot) {
      return this._handleClickEvent(e);
    }

    // User drag-clicked in the Selectable area
    if (!click) return this.emit('select', bounds);
  };

  Selection.prototype._handleClickEvent = function _handleClickEvent(e) {
    var _getEventCoordinates3 = getEventCoordinates(e),
        pageX = _getEventCoordinates3.pageX,
        pageY = _getEventCoordinates3.pageY,
        clientX = _getEventCoordinates3.clientX,
        clientY = _getEventCoordinates3.clientY;

    var now = new Date().getTime();

    if (this._lastClickData && now - this._lastClickData.timestamp < clickInterval) {
      // Double click event
      this._lastClickData = null;
      return this.emit('doubleClick', {
        x: pageX,
        y: pageY,
        clientX: clientX,
        clientY: clientY
      });
    }

    // Click event
    this._lastClickData = {
      timestamp: now
    };
    return this.emit('click', {
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
  };

  Selection.prototype._handleMoveEvent = function _handleMoveEvent(e) {
    var _initialEventData = this._initialEventData,
        x = _initialEventData.x,
        y = _initialEventData.y;

    var _getEventCoordinates4 = getEventCoordinates(e),
        pageX = _getEventCoordinates4.pageX,
        pageY = _getEventCoordinates4.pageY;

    var w = Math.abs(x - pageX);
    var h = Math.abs(y - pageY);

    var left = Math.min(pageX, x),
        top = Math.min(pageY, y),
        old = this.selecting;

    this.selecting = true;
    this._selectRect = {
      top: top,
      left: left,
      x: pageX,
      y: pageY,
      right: left + w,
      bottom: top + h
    };

    if (!old) {
      this.emit('selectStart', this._initialEventData);
    }

    if (!this.isClick(pageX, pageY)) this.emit('selecting', this._selectRect);

    e.preventDefault();
  };

  Selection.prototype._keyListener = function _keyListener(e) {
    this.ctrl = e.metaKey || e.ctrlKey;
  };

  Selection.prototype.isClick = function isClick(pageX, pageY) {
    var _initialEventData2 = this._initialEventData,
        x = _initialEventData2.x,
        y = _initialEventData2.y,
        isTouch = _initialEventData2.isTouch;

    return !isTouch && Math.abs(pageX - x) <= clickTolerance && Math.abs(pageY - y) <= clickTolerance;
  };

  return Selection;
}();

/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */


function normalizeDistance() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if ((typeof distance === 'undefined' ? 'undefined' : _typeof(distance)) !== 'object') distance = {
    top: distance,
    left: distance,
    right: distance,
    bottom: distance
  };

  return distance;
}

/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */
function objectsCollide(nodeA, nodeB) {
  var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var _getBoundsForNode = getBoundsForNode(nodeA),
      aTop = _getBoundsForNode.top,
      aLeft = _getBoundsForNode.left,
      _getBoundsForNode$rig = _getBoundsForNode.right,
      aRight = _getBoundsForNode$rig === undefined ? aLeft : _getBoundsForNode$rig,
      _getBoundsForNode$bot = _getBoundsForNode.bottom,
      aBottom = _getBoundsForNode$bot === undefined ? aTop : _getBoundsForNode$bot;

  var _getBoundsForNode2 = getBoundsForNode(nodeB),
      bTop = _getBoundsForNode2.top,
      bLeft = _getBoundsForNode2.left,
      _getBoundsForNode2$ri = _getBoundsForNode2.right,
      bRight = _getBoundsForNode2$ri === undefined ? bLeft : _getBoundsForNode2$ri,
      _getBoundsForNode2$bo = _getBoundsForNode2.bottom,
      bBottom = _getBoundsForNode2$bo === undefined ? bTop : _getBoundsForNode2$bo;

  return !( // 'a' bottom doesn't touch 'b' top
  aBottom - tolerance < bTop ||
  // 'a' top doesn't touch 'b' bottom
  aTop + tolerance > bBottom ||
  // 'a' right doesn't touch 'b' left
  aRight - tolerance < bLeft ||
  // 'a' left doesn't touch 'b' right
  aLeft + tolerance > bRight);
}

/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */
function getBoundsForNode(node) {
  if (!node.getBoundingClientRect) return node;

  var rect = node.getBoundingClientRect(),
      left = rect.left + pageOffset('left'),
      top = rect.top + pageOffset('top');

  return {
    top: top,
    left: left,
    right: (node.offsetWidth || 0) + left,
    bottom: (node.offsetHeight || 0) + top
  };
}

function pageOffset(dir) {
  if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
  if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}
exports.default = Selection;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _EventCell = __webpack_require__(312);

var _EventCell2 = _interopRequireDefault(_EventCell);

var _height = __webpack_require__(315);

var _height2 = _interopRequireDefault(_height);

var _propTypes3 = __webpack_require__(20);

var _eventLevels = __webpack_require__(46);

var _selection = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types */
exports.default = {
  propTypes: {
    slots: _propTypes2.default.number.isRequired,
    end: _propTypes2.default.instanceOf(Date),
    start: _propTypes2.default.instanceOf(Date),

    selected: _propTypes2.default.object,
    isAllDay: _propTypes2.default.bool,
    eventPropGetter: _propTypes2.default.func,
    titleAccessor: _propTypes3.accessor,
    tooltipAccessor: _propTypes3.accessor,
    allDayAccessor: _propTypes3.accessor,
    startAccessor: _propTypes3.accessor,
    endAccessor: _propTypes3.accessor,

    eventComponent: _propTypes3.elementType,
    eventWrapperComponent: _propTypes3.elementType.isRequired,
    onSelect: _propTypes2.default.func,
    onDoubleClick: _propTypes2.default.func
  },

  defaultProps: {
    segments: [],
    selected: {},
    slots: 7
  },

  renderEvent: function renderEvent(props, event) {
    var eventPropGetter = props.eventPropGetter,
        selected = props.selected,
        isAllDay = props.isAllDay,
        start = props.start,
        end = props.end,
        startAccessor = props.startAccessor,
        endAccessor = props.endAccessor,
        titleAccessor = props.titleAccessor,
        tooltipAccessor = props.tooltipAccessor,
        allDayAccessor = props.allDayAccessor,
        eventComponent = props.eventComponent,
        eventWrapperComponent = props.eventWrapperComponent,
        onSelect = props.onSelect,
        onDoubleClick = props.onDoubleClick;


    return _react2.default.createElement(_EventCell2.default, {
      event: event,
      eventWrapperComponent: eventWrapperComponent,
      eventPropGetter: eventPropGetter,
      onSelect: onSelect,
      onDoubleClick: onDoubleClick,
      selected: (0, _selection.isSelected)(event, selected),
      isAllDay: isAllDay,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      titleAccessor: titleAccessor,
      tooltipAccessor: tooltipAccessor,
      allDayAccessor: allDayAccessor,
      slotStart: start,
      slotEnd: end,
      eventComponent: eventComponent
    });
  },
  renderSpan: function renderSpan(props, len, key) {
    var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
    var slots = props.slots;


    return _react2.default.createElement(
      'div',
      {
        key: key,
        className: 'rbc-row-segment',
        style: (0, _eventLevels.segStyle)(Math.abs(len), slots)
      },
      content
    );
  },
  getRowHeight: function getRowHeight() {
    (0, _height2.default)((0, _reactDom.findDOMNode)(this));
  }
};
module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var label = _ref.label;

  return _react2.default.createElement(
    'span',
    null,
    label
  );
};

Header.propTypes = {
  label: _propTypes2.default.node
};

exports.default = Header;
module.exports = exports['default'];

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(161),
    isFlattenable = __webpack_require__(764);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(113),
    overRest = __webpack_require__(323),
    setToString = __webpack_require__(324);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(774);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(775),
    shortOut = __webpack_require__(777);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _propTypes3 = __webpack_require__(20);

var _BackgroundWrapper = __webpack_require__(186);

var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);

var _TimeSlotGroup = __webpack_require__(778);

var _TimeSlotGroup2 = _interopRequireDefault(_TimeSlotGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeColumn = function (_Component) {
  _inherits(TimeColumn, _Component);

  function TimeColumn() {
    _classCallCheck(this, TimeColumn);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TimeColumn.prototype.renderTimeSliceGroup = function renderTimeSliceGroup(key, isNow, date, resource) {
    var _props = this.props,
        dayWrapperComponent = _props.dayWrapperComponent,
        timeslots = _props.timeslots,
        showLabels = _props.showLabels,
        step = _props.step,
        slotPropGetter = _props.slotPropGetter,
        dayPropGetter = _props.dayPropGetter,
        timeGutterFormat = _props.timeGutterFormat,
        culture = _props.culture;


    return _react2.default.createElement(_TimeSlotGroup2.default, {
      key: key,
      isNow: isNow,
      value: date,
      step: step,
      slotPropGetter: slotPropGetter,
      dayPropGetter: dayPropGetter,
      culture: culture,
      timeslots: timeslots,
      resource: resource,
      showLabels: showLabels,
      timeGutterFormat: timeGutterFormat,
      dayWrapperComponent: dayWrapperComponent
    });
  };

  TimeColumn.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        children = _props2.children,
        style = _props2.style,
        getNow = _props2.getNow,
        min = _props2.min,
        max = _props2.max,
        step = _props2.step,
        timeslots = _props2.timeslots,
        resource = _props2.resource;

    var totalMin = _dates2.default.diff(min, max, 'minutes');
    var numGroups = Math.ceil(totalMin / (step * timeslots));
    var renderedSlots = [];
    var groupLengthInMinutes = step * timeslots;

    var date = min;
    var next = date;
    var now = getNow();
    var isNow = false;

    for (var i = 0; i < numGroups; i++) {
      isNow = _dates2.default.inRange(now, date, _dates2.default.add(next, groupLengthInMinutes - 1, 'minutes'), 'minutes');

      next = _dates2.default.add(date, groupLengthInMinutes, 'minutes');
      renderedSlots.push(this.renderTimeSliceGroup(i, isNow, date, resource));

      date = next;
    }

    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(className, 'rbc-time-column'), style: style },
      renderedSlots,
      children
    );
  };

  return TimeColumn;
}(_react.Component);

TimeColumn.propTypes = {
  step: _propTypes2.default.number.isRequired,
  culture: _propTypes2.default.string,
  timeslots: _propTypes2.default.number.isRequired,
  getNow: _propTypes2.default.func.isRequired,
  min: _propTypes2.default.instanceOf(Date).isRequired,
  max: _propTypes2.default.instanceOf(Date).isRequired,
  showLabels: _propTypes2.default.bool,
  timeGutterFormat: _propTypes3.dateFormat,
  type: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  resource: _propTypes2.default.string,

  slotPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  dayWrapperComponent: _propTypes3.elementType
};
TimeColumn.defaultProps = {
  step: 30,
  timeslots: 2,
  showLabels: false,
  type: 'day',
  className: '',
  dayWrapperComponent: _BackgroundWrapper2.default
};
exports.default = TimeColumn;
module.exports = exports['default'];

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = width;

var _offset = _interopRequireDefault(__webpack_require__(76));

var _isWindow = _interopRequireDefault(__webpack_require__(77));

function width(node, client) {
  var win = (0, _isWindow.default)(node);
  return win ? win.innerWidth : client ? node.clientWidth : (0, _offset.default)(node).width;
}

module.exports = exports["default"];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _constants = __webpack_require__(29);

var _TimeGrid = __webpack_require__(184);

var _TimeGrid2 = _interopRequireDefault(_TimeGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Week = function (_React$Component) {
  _inherits(Week, _React$Component);

  function Week() {
    _classCallCheck(this, Week);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Week.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        props = _objectWithoutProperties(_props, ['date']);

    var range = Week.range(date, this.props);

    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 15 }));
  };

  return Week;
}(_react2.default.Component);

Week.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired
};
Week.defaultProps = _TimeGrid2.default.defaultProps;


Week.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -1, 'week');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, 1, 'week');

    default:
      return date;
  }
};

Week.range = function (date, _ref) {
  var culture = _ref.culture;

  var firstOfWeek = _localizer2.default.startOfWeek(culture);
  var start = _dates2.default.startOf(date, 'week', firstOfWeek);
  var end = _dates2.default.endOf(date, 'week', firstOfWeek);

  return _dates2.default.range(start, end);
};

Week.title = function (date, _ref2) {
  var formats = _ref2.formats,
      culture = _ref2.culture;

  var _Week$range = Week.range(date, { culture: culture }),
      start = _Week$range[0],
      rest = _Week$range.slice(1);

  return _localizer2.default.format({ start: start, end: rest.pop() }, formats.dayRangeHeaderFormat, culture);
};

exports.default = Week;
module.exports = exports['default'];

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventWrapper = function (_React$Component) {
  _inherits(EventWrapper, _React$Component);

  function EventWrapper() {
    _classCallCheck(this, EventWrapper);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return EventWrapper;
}(_react2.default.Component);

exports.default = EventWrapper;
module.exports = exports['default'];

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Getinbox__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Getarchive__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Compose__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sent__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_inboxAction__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var PersonalMessages=function(_Component){_inherits(PersonalMessages,_Component);function PersonalMessages(props){_classCallCheck(this,PersonalMessages);var _this=_possibleConstructorReturn(this,(PersonalMessages.__proto__||Object.getPrototypeOf(PersonalMessages)).call(this,props));_this.state={mailType:'inbox',new_inbox:0// this.getComponent = this.getComponent.bind(this);
};return _this;}_createClass(PersonalMessages,[{key:'getTabs',value:function getTabs(){var self=this;$('#ChildVerticalTab_1').easyResponsiveTabs({type:'vertical',width:'auto',fit:true,tabidentify:'ver_1'});$('.resp-accordion').click(function(){if($(this).next().hasClass('inbox')){self.getComponent('inbox');}if($(this).next().hasClass('compose')){self.getComponent('compose');}if($(this).next().hasClass('compose')){self.getComponent('compose');}if($(this).next().hasClass('csent')){self.getComponent('sent');}if($(this).next().hasClass('archieve')){self.getComponent('archieve');}});Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */])();}},{key:'getComponent',value:function getComponent(type){this.setState({mailType:type});this.props.getInbox();}},{key:'componentWillMount',value:function componentWillMount(){this.props.getInbox();}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.getTabs();$("#inbox_click").click();},2000);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if($(window).width()<768){$(".verticaltab-content.inbox").prev().find('span.txt-red-msg').html('('+nextProps.message+' New )');// console.log('in');
}}},{key:'render',value:function render(){var _this3=this;var message_count="";if(this.props.message!==undefined){message_count='('+this.props.message+' New )';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/message_title_img.jpg",alt:'',border:'0',align:'absmiddle'})),'Messages',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Inbox, Compose, Send'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 tapmargntop message-tab',id:'responsivediv_show'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ChildVerticalTab_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list ver_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',id:'inbox_click',onClick:function onClick(){return _this3.getComponent('inbox');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Inbox ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red-msg'},message_count))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.getComponent('compose');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Compose Mail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.getComponent('sent');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Sent Mail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.getComponent('archieve');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Archive Mails '),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container ver_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content inbox'},this.state.mailType==="inbox"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Getinbox__["a" /* default */],null):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content compose'},this.state.mailType==="compose"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Compose__["a" /* default */],null):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content csent'},this.state.mailType==="sent"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sent__["a" /* default */],null):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content archieve'},this.state.mailType==="archieve"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Getarchive__["a" /* default */],null):""))))))))));}}]);return PersonalMessages;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{message:state.inbox.unread};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({getInbox:__WEBPACK_IMPORTED_MODULE_8__actions_inboxAction__["a" /* getInbox */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PersonalMessages));

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tinymce__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tinymce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var jQuery=window.jQuery;var $=window.$;var Reply=function(_Component){_inherits(Reply,_Component);function Reply(props){_classCallCheck(this,Reply);var _this=_possibleConstructorReturn(this,(Reply.__proto__||Object.getPrototypeOf(Reply)).call(this,props));_this.state={mailids:props.to_address,subject:props.to_subject,message:props.to_content,AllDatas:props.to_datas,editorcontent:props.to_content};_this.Submit=_this.Submit.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleEditorChange=_this.handleEditorChange.bind(_this);return _this;}_createClass(Reply,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'handleEditorChange',value:function handleEditorChange(e){this.setState({editorcontent:e.target.getContent()});}},{key:'Submit',value:function Submit(){var _this2=this;var formData=new FormData();var compose=$('form#compose_replydata').serializeArray();var role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);var details=[];formData.append("lr_id",__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true));formData.append("message",this.state.editorcontent);formData.append("lr_name",__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("fullName",true));formData.append("allData",this.state.AllDatas);compose.map(function(key,index){details.push(_defineProperty({},key.name,key.value));formData.append(key.name,key.value);});var val=0;$.each($('form#compose_replydata').find('input[type="file"]'),function(i,tag){$.each($(tag)[0].files,function(i,file){formData.append(tag.name+val,file);val++;});});formData.append("count",val);formData.append("admin_role",role);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"messages-site/compose",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.setState({mailids:'',AllDatas:[],subject:'',message:''});_this2.props.Rerender('clear');}});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'componentDidMount',value:function componentDidMount(){$("input[type=file].multi").MultiFile();}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Messages - Compose'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'compose',id:'compose_replydata',encType:'multipart/form-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-form-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'To :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divToaddress',className:'toaddress',style:{width:"574px"}},this.state.mailids)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Subject :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'subject',id:'txtSubject',className:'txtbox',value:this.state.subject,onChange:function onChange(e){return _this3.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Message :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tinymce___default.a,{ref:'noteseditor',content:this.state.editorcontent,config:{menubar:true,plugins:'autolink link image lists print preview',toolbar:'bold italic | alignleft aligncenter alignright',branding:false},onChange:this.handleEditorChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'div_writing_txtarea',className:'error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'last-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Attachment :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'attachments',name:'attachment',size:'80',className:'multi',accept:'xls|pdf|doc|ppt|pps|jpg|gif|txt',maxLength:'6'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-text'},'( Only XLS,Doc,PDF,PPT,PPS,JPG,GIF,TXT Format )')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnsend',value:'Send',alt:'Send',title:'Send',onClick:function onClick(e){return _this3.Submit(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'toaddress',id:'toaddress',value:this.state.mailids})))));}}]);return Reply;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Reply);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ecoach=function(_Component){_inherits(Ecoach,_Component);function Ecoach(props){_classCallCheck(this,Ecoach);var _this=_possibleConstructorReturn(this,(Ecoach.__proto__||Object.getPrototypeOf(Ecoach)).call(this,props));_this.state={ecoachlist:[],faqlist:[],task_question_count:'',faq_questions:[],txtQuestion:''};_this.fnAskquestionSubmit=_this.fnAskquestionSubmit.bind(_this);_this.fnViewAnswerRate=_this.fnViewAnswerRate.bind(_this);return _this;}_createClass(Ecoach,[{key:'getTabs',value:function getTabs(){window.$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});}},{key:'getCoach',value:function getCoach(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);//alert(learnerID);
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach/ecoachlist',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({productID:productID,learnerID:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){//alert(responseJson);
var faqlist=responseJson.ecoachlist.faqlist!=undefined?responseJson.ecoachlist.faqlist:'';var task_question_count=responseJson.ecoachlist.task_question_count!=undefined?responseJson.ecoachlist.task_question_count:'';var faq_questions=responseJson.ecoachlist.faq_questions!=undefined?responseJson.ecoachlist.faq_questions:'';//alert(task_question_count);
_this2.setState({ecoachlist:responseJson.ecoachlist,faqlist:faqlist,task_question_count:task_question_count,faq_questions:faq_questions});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}},{key:'fnChange',value:function fnChange(e){var tabdiv=e;$(".accordion_in").removeClass('acc_active');if($('.answer'+tabdiv+':visible').length==0){$(".allfaqs").hide();$(".mainfaq"+tabdiv).addClass('acc_active');$(".answer"+tabdiv).show();}else{$(".answer"+tabdiv).hide();}}},{key:'fnAskquestion',value:function fnAskquestion(){if($('#tr_askEC:visible').length==0){$('#tr_askEC').show();}else{$('#tr_askEC').hide();}}},{key:'fnAskquestionSubmit',value:function fnAskquestionSubmit(){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productName=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productName",true);var formVal=$("#txtQuestion").val();if(formVal!=''){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach/askquestion',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,formVal:formVal,corporateID:corporateID,productName:productName})}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{$("#txtQuestion").val('');__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",'Your question has been sent to your E Coach. You will get reply in your message inbox.',"success");}//alert(responseJson.ecoach_count);
});}else{$('#error_qus').css('display','block');}}},{key:'fnViewAnswerRate',value:function fnViewAnswerRate(e){//let pdata =  $('#qtoec_rate_form'+e).serialize();
var cmbRate=$('#cmbRate'+e).val();var formData=new FormData(),pdata=$('#qtoec_rate_form'+e).serializeArray();formData.append("learnerID",__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true));formData.append("productName",__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productName",true));pdata.map(function(val){formData.append(val.name,val.value);});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach/viewanswerrate',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");$('#cmbrating'+e).html(cmbRate);$('#ansajax'+e).show();$('#ratebox'+e).hide();});}},{key:'componentDidMount',value:function componentDidMount(){this.getTabs();this.getCoach();//Common.showSmallLeftMenu();
}},{key:'render',value:function render(){var _this3=this;var faqcontent=this.state.faqlist.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'faqcontent_'+index,className:'accordion_in mainfaq'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head',onClick:function onClick(e){return _this3.fnChange(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_icon_expand'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_icon_expand'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,index+1),key.question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'answer'+index+' allfaqs acc_content',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:key.answer?key.answer:''}})));});var faq_questions=this.state.faq_questions.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'faqques_'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'qtoec_rate_form'+index,id:'qtoec_rate_form'+index,action:'javascript:void(0);',method:'post',onSubmit:function onSubmit(e){return _this3.fnViewAnswerRate(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidcnt',id:'hidcnt',value:''+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidqtoec_id'+index,id:'hidqtoec_id'+index,value:key.faq_id_pk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidqtoec_id_pk'+index,id:'hidqtoec_id_pk'+index,value:key.faq_id_pk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidquestion'+index,id:'hidquestion'+index,value:key.question}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidanswer'+index,id:'hidanswer'+index,value:key.answer==null?'':key.answer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'para-black'},key.question),key.isanswered==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'titleorng'},'Your E Coach replied :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orng-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:key.answer?key.answer:''}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ecoach-ratings'},key.answered_date!=""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ecoach-ratings1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{border:'0',alt:'',src:"/rmeta"+'/images/calendar-icon-grn.png'}),'Answered on :  ',key.answered_date):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),key.learner_rating!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ecoach-ratings2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{border:'0',alt:'',src:"/rmeta"+'/images/star-icon-yellow.png'}),'Your rating for this answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,key.learner_rating,'/10')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ansajax'+index,style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ecoach-ratings2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{border:'0',alt:'',src:"/rmeta"+'/images/star-icon-yellow.png'}),'Your rating for this answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'cmbrating'+index}),'/10'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox',id:'ratebox'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Rate this Answer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'cmbRate'+index,name:'cmbRate'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--Select--'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'div_rate'+index,className:'error'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',name:'btnRate',value:'Rate',alt:'Rate',title:'Rate'}))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noecoachans'},'Answer yet to be posted.'))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/ask_ecoach_img.jpg",align:'absmiddle',alt:'',border:'0'})),'Ask E Coach ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/ecoach-men.png",alt:'',className:'ecoach-men',align:'absmiddle',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Ask questions, clarify doubts'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance e-coach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'block',width:'100%'},id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'FAQs',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Ask a Question',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'View Answers & Rate',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'block'},className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_coach1 smk_accordion acc_with_icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divQuestion'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orng-box-ecoach'},'Please find below the Frequently Asked Questions. If you cannot find your answer here please click on the "Ask a Question" tab.'),faqcontent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'qtoec_form',id:'qtoec_form',action:'javascript:void(0);',onSubmit:function onSubmit(e){return _this3.fnAskquestionSubmit();},method:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ecoach-btn-rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onClick:function onClick(e){return _this3.fnAskquestion();},value:'Ask E Coach',className:'ask-btn',name:'',alt:'Ask E Coach',title:'Ask E Coach',type:'button'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',src:"/rmeta"+"/images/ask_ecoach_line.jpg",border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tr_askEC',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title-blue'},'Ask E Coach'),this.state.task_question_count>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'txtQuestion',id:'txtQuestion',placeholder:'Enter your Question'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divQuestionask',className:'errornoTM'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'send-ecoach-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',style:{height:'40px'},value:'Send to E Coach',name:'send',alt:'Send to E Coach',title:'Send to E Coach'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'error_qus',style:{display:'none'},className:'errornoTM'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please Enter Your Question.'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'light-graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No E Coach assigned yet')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'sent_askEC',className:'success-msg',style:{display:'none'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},faq_questions!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title-blue'},'You asked your E Coach :'),faq_questions):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'light-graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This page will show up your questions to E Coach and the reply you received. You can rate your E Coach based on the answer.')))))))))));}}]);return Ecoach;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ecoach);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChatBook__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChatSummary__ = __webpack_require__(808);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ChatRequest=function(_Component){_inherits(ChatRequest,_Component);function ChatRequest(props){_classCallCheck(this,ChatRequest);var _this=_possibleConstructorReturn(this,(ChatRequest.__proto__||Object.getPrototypeOf(ChatRequest)).call(this,props));_this.state={chat_request:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ChatBook__["a" /* default */],null),chat_summary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ChatSummary__["a" /* default */],null)};_this.setComp=_this.setComp.bind(_this);return _this;}_createClass(ChatRequest,[{key:'setComp',value:function setComp(type){switch(type){case'chat_req':this.setState({chat_request:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ChatBook__["a" /* default */],null)});break;case'chat_sum':this.setState({chat_summary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ChatSummary__["a" /* default */],null)});break;}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){$("#req").click();}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){var self=_this2;$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});$('#ChildVerticalTab_1').easyResponsiveTabs({type:'vertical',width:'auto',fit:true,tabidentify:'ver_1'});$('.resp-accordion').click(function(){if($(this).next().hasClass('requestcha')){self.setComp('chat_req');}if($(this).next().hasClass('summarycha')){self.setComp('chat_sum');}});},2000);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/Ecoach-chat-icon.jpg",align:'absmiddle',alt:'',border:'0'})),'E Coach Chat',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Schedule a one-on-one chat with your E Coach'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance ecoach-chat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'req',onClick:function onClick(){return _this3.setComp('chat_req');}},'E Coach chat request',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',title:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'sum',onClick:function onClick(){return _this3.setComp('chat_sum');}},'My chat summary ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',title:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content requestcha'},this.state.chat_request),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content summarycha'},this.state.chat_summary)))))))));}}]);return ChatRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatRequest);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_newPostAction__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var OpinionPoll=function(_Component){_inherits(OpinionPoll,_Component);function OpinionPoll(props){_classCallCheck(this,OpinionPoll);var _this=_possibleConstructorReturn(this,(OpinionPoll.__proto__||Object.getPrototypeOf(OpinionPoll)).call(this,props));_this.state={poll_qust_value:[],view_results:[]};_this.getLrinfo=_this.getLrinfo.bind(_this);return _this;}_createClass(OpinionPoll,[{key:'fnadd_poll',value:function fnadd_poll(i,assigned_id){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var div_poll="div_poll"+i;var rdopoll_ans=i+"rdopoll_ans[]";var poll_div="poll_div"+i;var chkedpoll_ans=0;var count=0;$('.rdopoll'+i).each(function(){$(this).val()+"-"+(this.checked?chkedpoll_ans=$(this).val():count);});if(chkedpoll_ans==0){$('#poll_div'+i).css('display','block');return false;}else{var answer_poll='answer_poll';var hidPoll_id=$("#hidPoll_id"+i).val();// alert(learnerID+'--'+answer_poll+'--'+chkedpoll_ans+'--'+hidPoll_id+'--'+assigned_id);
// return false;
if(chkedpoll_ans!=""&&hidPoll_id!=""&&assigned_id!=""){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'group-interactions/answerpoll',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,q:answer_poll,trid:i,chkedpoll_ans:chkedpoll_ans,hidPoll_id:hidPoll_id,assigned_id:assigned_id,pinID:pinID})}).then(function(response){return response.json();}).then(function(responseJson){_this2.getOpinionpolls();setTimeout(function(){_this2.props.getNewPost();},5000);// let opinion_polls_count=(responseJson.opinion_polls_count!=undefined || responseJson.opinion_polls_count!=null)?responseJson.opinion_polls_count:0;
// Common.setUserData('opinion_polls_count',opinion_polls_count,true);	
// this.props.opinion(opinion_polls_count);
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}//count end else
}}},{key:'getTabs',value:function getTabs(){window.$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});window.$('#ChildVerticalTab_1').easyResponsiveTabs({type:'vertical',width:'auto',fit:true,tabidentify:'ver_1'// The tab groups identifier
//resp-tab-active
/* activate: function (event) { // Callback function if tab is switched
			                alert('sdf');
			               $('[aria-controls="ver_1_tab_item-2"]').click();
			               alert('dd');
			            } */});}},{key:'getOpinionpolls',value:function getOpinionpolls(){var _this3=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'group-interactions/opinionpolls',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var poll_qust_value=responseJson.opinionpolls.poll_qust_value!=undefined?responseJson.opinionpolls.poll_qust_value:'';var view_results=responseJson.opinionpolls.view_results!=undefined?responseJson.opinionpolls.view_results:'';_this3.setState({opinionpolls:responseJson.opinionpolls,poll_qust_value:poll_qust_value,view_results:view_results});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}});}},{key:'componentDidMount',value:function componentDidMount(){this.getTabs();this.getOpinionpolls();}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this4=this;var poll_qust_value=null;if(this.state.poll_qust_value!=null||this.state.poll_qust_value!=undefined){poll_qust_value=this.state.poll_qust_value.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'polls_contents'+index,className:'polls-content',id:'div_poll'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,key.poll_question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'polls-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,key['question'].map(function(values,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'poll_ans_key'+i},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'rdopoll'+index+' rdbtn',name:'i_rdopoll_ans[]',id:'i_rdopoll_ans[]',value:values.poll_ans_id_pk}),'\xA0',values.poll_answer));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'poll_div'+index,className:'errornoTM',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{color:'#FF0000'},'Please select the opinion polls'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'poll_div'+index,className:'errornoTM'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'poll-submit poll-btn-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Vote',title:'Vote',alt:'Vote',name:'vote',onClick:function onClick(e){return _this4.fnadd_poll(index,key.assigned_poll_id_pk);}}),'         ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidPoll_id'+index,id:'hidPoll_id'+index,value:key.poll_id_pk}));});}var view_results=null;if(this.state.view_results!=null||this.state.view_results!=undefined){view_results=this.state.view_results.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'view_poll_contents'+index,className:'polls-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,key.poll_question,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'view_poll_votes'+index,className:'votes'},' Total Votes : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,key.total_vote),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'view_poll_form_results'+index,className:'polls-form polls-results'},key['view_res'].map(function(view_key,view_i){var strsingle_vote_mul_width=view_key.strsingle_vote_mul;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'key12'+view_i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'key1'+view_i,className:'arrow-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'opp_arrow'},view_key.poll_answer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'meter orange'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:strsingle_vote_mul_width+'%'}})),'    ',view_key.strsingle_vote_mul,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-red1'},'(Votes : ',view_key.single_vote,')')));})));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/opinion_polls_img.png',align:'absmiddle',alt:'',border:'0'}),' '),' Opinion Polls',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Let us know what you think and view the trends.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance opinion-polls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Opinion Polls',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/activetab.png',alt:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pgeLoad'},'View Results',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/activetab.png',alt:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'poll_form',id:'poll_form',action:'',method:'post'},poll_qust_value!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,poll_qust_value):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox light-graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Currently there is no active opinion poll. Please check back later.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},view_results!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,view_results):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox light-graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' You have not answered any of the opinion polls yet.')))))))))));}}]);return OpinionPoll;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({getNewPost:__WEBPACK_IMPORTED_MODULE_6__actions_newPostAction__["a" /* getNewPost */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null,mapDispatchToProps)(OpinionPoll));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var PracticeNokia=function(_Component){_inherits(PracticeNokia,_Component);function PracticeNokia(props){_classCallCheck(this,PracticeNokia);var _this=_possibleConstructorReturn(this,(PracticeNokia.__proto__||Object.getPrototypeOf(PracticeNokia)).call(this,props));_this.state={practice_nokia:[],practice_nokia_deatils:[],prctce_id:'',practice_name:''};_this.getLrinfo=_this.getLrinfo.bind(_this);_this.switchPanel=_this.switchPanel.bind(_this);return _this;}_createClass(PracticeNokia,[{key:'getPracticenokia',value:function getPracticenokia(){var _this2=this;var page_flag='';var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);var practiceCorner=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("practiceCorner",true);var practiceCornerMini=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("practiceCornerMini",true);//alert(practiceCorner+'--'+practiceCornerMini);
if(practiceCorner!=false){page_flag=1;}else if(practiceCornerMini!=false){page_flag=2;}else{}//alert(page_flag);
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice/practice-nokia',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID,page_flag:page_flag})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var practice_nokia_deatils=responseJson.practice_nokia.practice_nokia_deatils!=undefined?responseJson.practice_nokia.practice_nokia_deatils:'';var name_list=responseJson.practice_nokia.name_list!=undefined?responseJson.practice_nokia.name_list:'';//alert(JSON.stringify(name_list.first_id));
var p_id=name_list.first_id;var p_name=name_list.first_name;if(practice_nokia_deatils&&name_list){_this2.setState({practice_nokia:responseJson.practice_nokia,practice_nokia_deatils:practice_nokia_deatils,prctce_id:p_id,practice_name:p_name});}}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}},{key:'fnPractice',value:function fnPractice(id,name){$('#error_comment').hide();$('.balance-words').hide();$('.typing-words').hide();$('#comment').val('');$('.allact').removeClass('active');$('#act'+id).addClass('active');$("#comment_insert").css('display','none');this.setState({prctce_id:id,practice_name:name});}},{key:'fnValidate',value:function fnValidate(){var comment=$('#comment').val();var prctce_id=$('#prctce_id').val();var practice_name=$('#practice_name').val();if(comment==''){$('#error_comment').html("Please enter your Comment");$('#error_comment').show();return false;}else{var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");$('.balance-words').hide();$('.typing-words').hide();fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice/practice-nokia-insert',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,comment:comment,prctce_id:prctce_id,practice_name:practice_name})}).then(function(response){return response.json();}).then(function(responseJson){var insert=responseJson.insert!=undefined?responseJson.insert:'';if(insert==1){$('#comment').val('');$("#comment_insert").css('display','block');}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}}},{key:'fnSelected',value:function fnSelected(e){$('.mainsilvercss').removeClass('selected');$('.ulmainsilver').css('display','none');$('#mainsilver'+e).addClass('selected');$('#ulmainsilver'+e).css('display','block');}},{key:'fnAccordion',value:function fnAccordion(main,e){$('.allaccordion').css('display','none');$('#accordion'+main).addClass('active-accordion');$('#ulaccordion'+main+e).css('display','block');}},{key:'componentDidMount',value:function componentDidMount(){this.getPracticenokia();}},{key:'switchPanel',value:function switchPanel(type){this.props.switchPanel(type);}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this3=this;var practice_nokia_deatils=null;if(this.state.practice_nokia_deatils!=null||this.state.practice_nokia_deatils!=undefined){practice_nokia_deatils=this.state.practice_nokia_deatils.map(function(key,index){var css_sliver="";{index==0?css_sliver="silverheader mainsilvercss selected":css_sliver="silverheader mainsilvercss";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'main'+index},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mainsilver'+index,onClick:function onClick(e){return _this3.fnSelected(index);},className:css_sliver},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'guide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,key['title']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'ulmainsilver'+index,className:'ulmainsilver',style:{display:''+(index==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'accordion'+index},key['group_name'].map(function(g_key,g_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'group'+g_index,onClick:function onClick(e){return _this3.fnAccordion(index,g_index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},g_key['sno']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'},g_key['g_name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'ulaccordion'+index+g_index,className:'allaccordion',style:{display:'none'}},key['practice_name'][g_index].map(function(p_key,p_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pract'+p_index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'act'+p_key['p_id'],className:'allact',onClick:function onClick(e){return _this3.fnPractice(p_key['p_id'],p_key['p_name']);},href:'javascript:void(0);'},p_key['p_name']))));})));})))))));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent practicescore choose'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leftposstatic1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'practice_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'leftnavsec',className:'left-nav',style:{display:'block',zIndex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{border:'0',align:'absmiddle',src:"/rmeta"+'/images/img-lr1.png',alt:''})),'Choose the practice')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applemenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link-txt',href:'javascript:void(0)',onClick:function onClick(e){return _this3.switchPanel('practice_datewise');}},'Practice Score -  Datewise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link-txt1',href:'javascript:void(0)',onClick:function onClick(e){return _this3.switchPanel('practice_score');}},'Practice Score -  Practicewise'),practice_nokia_deatils)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.state.practice_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'valitxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Please type in the action taken here.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Maximum of 100 words.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Your action will be shared with your mentor.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{method:'post',action:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'comment',id:'comment',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':'100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: 100')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'error_comment',className:'errornoTM',style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Submit',name:'submit',onClick:function onClick(e){return _this3.fnValidate();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'comment_insert',style:{display:'none'},className:'chartstatus'},'Comment Saved Successfully')))));}}]);return PracticeNokia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PracticeNokia);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var XRecap=function(_Component){_inherits(XRecap,_Component);function XRecap(props){_classCallCheck(this,XRecap);var _this=_possibleConstructorReturn(this,(XRecap.__proto__||Object.getPrototypeOf(XRecap)).call(this,props));_this.state={image_xrecap:[]};return _this;}_createClass(XRecap,[{key:'show_image',value:function show_image(x,y){var dd=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/dlr_video_files/xRecap/'+x;$('#thumbnail').css('display','none');$('#showimage').css('display','block');$("#image_title_name").html(y);$("#image_change").attr("src",dd);}},{key:'hide_image',value:function hide_image(){$('#thumbnail').css('display','block');$('#showimage').css('display','none');}},{key:'getXrecap',value:function getXrecap(){var _this2=this;//let xrecap_id = Common.getUserData("xrecap_id", true);
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'xrecap/xrecap',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */]()// xrecap_id:xrecap_id
})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!==0){var image_xrecap=responseJson.xrecap.image_xrecap!==undefined?responseJson.xrecap.image_xrecap:'';_this2.setState({xrecap:responseJson.xrecap,image_xrecap:image_xrecap});}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;setTimeout(function(){_this3.getXrecap();//Common.showSmallLeftMenu();  
},500);}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this4=this;var image_xrecap_list=null;if(this.state.image_xrecap!==null||this.state.image_xrecap!==undefined){image_xrecap_list=this.state.image_xrecap.map(function(key,index){var dh=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrwise'+index,className:'fleft'},key['xreimage'].map(function(val,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img_xrecap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/dlr_video_files/xRecap/'+val,onClick:function onClick(e){return _this4.show_image(val,key['xreimage_title'][ind]);},alt:'',width:'400',height:'200',style:{cursor:'pointer'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc_xrecap'},key['xreimage_title'][ind]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'number'},key['image_num']));}));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea',style:{width:'92.2%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xrecap_title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Recaps')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xrecap_body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'thumbnail'},image_xrecap_list),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'showimage',style:{display:'none',border:'0px solid #342356',width:'90%',height:'75%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.hide_image();}},'Close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'image_title_name'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'image_change',src:'',alt:''}))));}}]);return XRecap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (XRecap);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var DatewiseComp=function(_Component){_inherits(DatewiseComp,_Component);function DatewiseComp(props){_classCallCheck(this,DatewiseComp);var _this=_possibleConstructorReturn(this,(DatewiseComp.__proto__||Object.getPrototypeOf(DatewiseComp)).call(this,props));_this.state={scores:[],records:[],startDate:'',endDate:'',open:false,report:[]};_this.getReports=_this.getReports.bind(_this);_this.onCloseModal=_this.onCloseModal.bind(_this);_this.getBack=_this.getBack.bind(_this);return _this;}_createClass(DatewiseComp,[{key:'getReports',value:function getReports(practice_id){var _this2=this;this.setState({open:true});var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice/practice-report',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,practice_id:practice_id})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){_this2.setState({report:responseJson.report});}});}},{key:'getBack',value:function getBack(type){this.props.switchPanel(type);}},{key:'onCloseModal',value:function onCloseModal(){this.setState({open:false});}},{key:'getDetails',value:function getDetails(){var _this3=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var start_date=this.state.startDate;var end_date=this.state.endDate;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice/practice-time',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID,start_date:start_date,end_date:end_date})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this3.setState({scores:responseJson.scores,records:responseJson.submitted_datas});}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}},{key:'componentDidMount',value:function componentDidMount(){this.getDetails();$("#datestart").datepicker({dateFormat:'yy-mm-dd',changeMonth:true,yearRange:"-10:+0",changeYear:true,onSelect:function(selected,evnt){$("#dateend").datepicker({minDate:selected,dateFormat:'yy-mm-dd',changeMonth:true,yearRange:"-10:+0",changeYear:true,onSelect:function(date_select,evnt){this.setState({endDate:date_select});this.getDetails();}.bind(this)});this.setState({startDate:selected});}.bind(this)});}},{key:'render',value:function render(){var _this4=this;var open=this.state.open;var date_from="";var scores=this.state.scores.map(function(score,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'score_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{color:'rgb(0, 0, 0)',borderBottom:'1px solid rgb(17, 165, 74)',background:'rgb(255, 255, 255) none repeat scroll 0px 0px'}},score.submtted),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{color:'rgb(0, 0, 0)',borderBottom:'1px solid rgb(17, 165, 74)',background:'rgb(255, 255, 255) none repeat scroll 0px 0px'}},score.rejected),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{color:'rgb(0, 0, 0)',borderBottom:'1px solid rgb(17, 165, 74)',background:'rgb(255, 255, 255) none repeat scroll 0px 0px'}},score.score));});var records=this.state.records.map(function(record,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'record_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,record.sno),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,record.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,record.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,record.score),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{nohref:'true',onClick:function onClick(){return _this4.getReports(record.practice_id);}},'View Report')));});var report_data=this.state.report.map(function(repo,l){var value=l+1;var date=new Date(repo.created_date).toLocaleString();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'repo_'+l},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,repo.comment),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,repo.score));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner practice fillter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bg date-pad'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellSpacing:'0',cellPadding:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:'2',className:'headfill'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Practice Submitted')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Practice Rejected')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Practice Score'))),!scores?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},'No Records Found')):scores)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{nohref:'true',onClick:function onClick(e){return _this4.getBack('PracticeNokia');}},'Back to Practice Corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bordernonetab',width:'100%',cellSpacing:'0',cellPadding:'0',border:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Filter by Date wise :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'datestart',value:this.state.startDate,className:'txtdob',id:'datestart'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'dateend',value:this.state.endDate,className:'txtdob',id:'dateend'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ovlscrll'},this.state.startDate!=""&&this.state.endDate!=""?date_from=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartstatus',style:{textAlign:'left'}},'Data shows :\xA0 From  \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#000',fontStyle:'italic'}},this.state.startDate),' \xA0\xA0To \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#000',fontStyle:'italic'}},this.state.endDate)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'1',style:{borderCollapse:'collapse',border:'solid 1px #e5e5e5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'S.No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Practice Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Submitted Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Report Details')),records.length>0?records:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},'No Records Found')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal___default.a,{open:open,onClose:this.onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'practice fillter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'1',style:{borderCollapse:'collapse',border:'solid 1px #e5e5e5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'S.No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Report as per learner'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Submitted Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Score')),report_data.length>0?report_data:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},'No Data')))))));}}]);return DatewiseComp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DatewiseComp);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var PracticewiseComp=function(_Component){_inherits(PracticewiseComp,_Component);function PracticewiseComp(props){_classCallCheck(this,PracticewiseComp);var _this=_possibleConstructorReturn(this,(PracticewiseComp.__proto__||Object.getPrototypeOf(PracticewiseComp)).call(this,props));_this.state={records_score:[],old_id:'',old_idd:'',old_parent:'',oldpr_id:'',oldpr_idd:'',oldpr_parent:''};_this.getBack=_this.getBack.bind(_this);_this.getBottom=_this.getBottom.bind(_this);_this.getSubbottom=_this.getSubbottom.bind(_this);return _this;}_createClass(PracticewiseComp,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'getSubbottom',value:function getSubbottom(pr_id,pr_idscr,id_practice){var oldpr_id=this.state.oldpr_id;var oldpr_idd=this.state.oldpr_idd;var oldpr_parent=this.state.oldpr_parent;$('#'+pr_idscr).addClass('selected');$('#'+pr_id+' #'+id_practice).show();if(oldpr_parent!=''){$('#'+oldpr_id).removeClass('selected');$('#'+oldpr_parent+' #'+oldpr_idd).hide();}if(oldpr_idd==id_practice){$('#'+pr_idscr).addClass('selected');$('#'+pr_id+' #'+id_practice).show();}this.setState({oldpr_id:pr_idscr,oldpr_idd:id_practice,oldpr_parent:pr_id});}},{key:'getBottom',value:function getBottom(id,id_scr,id_score){var old_id=this.state.old_id;var old_idd=this.state.old_idd;var old_parent=this.state.old_parent;$('#'+id_scr).addClass('selected');$('#'+id+' .submenu').show();if(old_parent!=''){$('#'+old_id).removeClass('selected');$('#'+old_parent+' .submenu').hide();}if(old_idd=id_score){$('#'+id_scr).addClass('selected');$('#'+id+' .submenu').show();}this.setState({old_id:id_scr,old_idd:id_score,old_parent:id});}},{key:'getBack',value:function getBack(type){this.props.switchPanel(type);}},{key:'getPractice',value:function getPractice(){var _this2=this;var page_flag='';var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var practiceCorner=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("practiceCorner",true);var practiceCornerMini=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("practiceCornerMini",true);//alert(practiceCorner+'--'+practiceCornerMini);
if(practiceCorner!=false){page_flag=1;}else if(practiceCornerMini!=false){page_flag=2;}else{}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'practice/practice-wise',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,flag:page_flag})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this2.setState({records_score:responseJson.records});}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();});}},{key:'componentDidMount',value:function componentDidMount(){this.getPractice();}},{key:'render',value:function render(){var _this3=this;var records_data=this.state.records_score.map(function(rec_score,k){var id=k+1;var id_scr='scr_'+id;var id_score='score_'+id;var group_data='';if(rec_score.groups!=undefined){group_data=rec_score.groups.map(function(grp_score,ke){var pract=ke+1;var id_practice='practice_'+pract;var prac_data='';if(grp_score.practices!=undefined){prac_data=grp_score.practices.map(function(pra_score,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'prascore_'+key,id:id_practice,className:'subpractice practice-wise'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},pra_score.pr_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score-icon1'},'Score  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,pra_score.pr_score>0?pra_score.pr_score:'0')))));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'grpscore_'+ke,className:'submenu',id:id_score,style:{display:'none'},onClick:function onClick(e){return _this3.getSubbottom(id,id_score,id_practice);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'accordion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},grp_score.sno),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'},grp_score.group),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score-icon'},'Score  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,grp_score.group_score>0?grp_score.group_score:'0'))),prac_data)))));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'score_'+k,id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader',id:id_scr,onClick:function onClick(e){return _this3.getBottom(id,id_scr,id_score);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'guide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,rec_score.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',null,'Score  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,rec_score.over_score>0?rec_score.over_score:'0'),' ')))),group_data);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'',className:'contentarea main-inner practicescore scoreround'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-lr1.png',align:'absmiddle',alt:'',border:'0'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Practice Score - Total Practice report submitted')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{nohref:'true',onClick:function onClick(e){return _this3.getBack('PracticeNokia');}},'Back to Practice Corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applemenu'},records_data))))))));}}]);return PracticewiseComp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PracticewiseComp);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Panel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__(821);


/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */]);
var Panel = __WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */].Panel;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(831), __esModule: true };

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(340);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_ThanksMessage__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Cnormaltest=function(_Component){_inherits(Cnormaltest,_Component);function Cnormaltest(props){_classCallCheck(this,Cnormaltest);/*this.submitObserverandProceed = this.submitObserverandProceed.bind(this);*/var _this=_possibleConstructorReturn(this,(Cnormaltest.__proto__||Object.getPrototypeOf(Cnormaltest)).call(this,props));_this.state={componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:""};return _this;}_createClass(Cnormaltest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettestdetails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getTestdetails(data);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',// type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt){switch(ans_opt.options){case'image':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':return this.video_frame(ans_opt.add_on_answer_video,'');break;default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}}},{key:'submittest',value:function submittest(){var _this3=this;if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()){var data=this.props.data;var testForm=$("#frm_mcq").serializeArray();var formData=new FormData();testForm.map(function(val,index){formData.append(val.name,val.value);});formData.append("questions",JSON.stringify(this.state.testquestions));formData.append("data",JSON.stringify(data));Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/saveall",{method:"POST",headers:{"Accept":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this3.gotoresult();}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitbuttons',value:function submitbuttons(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Submit',className:'button_org_inactive',type:'button',onClick:function onClick(e){return _this4.submittest();}}));}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:''})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{key:video_files,playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,className:validationClass,rows:'3',style:{height:"inherit",resize:"none"},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont,seq_op=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),data.learner_msg!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq'},this.state.testquestions.map(function(mk,index){var optionText=[],vcla=mk.is_hint_viewed>0?'block':'none';var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},mk.hint_for_learner!=''&&mk.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+index,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this6.hintopen(mk.question_id,mk.hint_reduce_per,mk.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+mk.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+mk.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_images.map(function(val,iex){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+iex,src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width,height:mk.img_height}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}else if(mk.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'span_'+i,className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+mk.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}return _this6.getquestion(mk,qas,i+1);}),mk.question_type==6&&_this6.openendquestions(mk),mk.question_type==7&&_this6.matchfillfun(mk),$.inArray(mk.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':mk.max_multiple,defaultValue:''}))),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:mk}),mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:sequenceClass,'data-max-seq':mk.question_option_answers.length,defaultValue:''}))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:optionClass,'data-options':optionText.join(',')})))))));}),this.submitbuttons())))))));}}]);return Cnormaltest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Cnormaltest);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Timecountdown__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Cfixedtimetest=function(_Component){_inherits(Cfixedtimetest,_Component);function Cfixedtimetest(props){_classCallCheck(this,Cfixedtimetest);var _this=_possibleConstructorReturn(this,(Cfixedtimetest.__proto__||Object.getPrototypeOf(Cfixedtimetest)).call(this,props));_this.goToThanksPage=_this.goToThanksPage.bind(_this);_this.sback=_this.sback.bind(_this);_this.compeletestatus="";_this.state={componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessages:"",testseqfields:[],time_left:'',time_state:0,is_answered_all:0,resultthank:''};return _this;}_createClass(Cfixedtimetest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettimevariable',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({time_left:'',testseqfields:{'seconds':responseJson.time_left_seconds,'question_number':responseJson.Mcq_details.question_number},testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,is_answered_all:responseJson.Mcq_details.is_answered_all});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({// title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',// type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt){var op_val='';switch(ans_opt.options){case'image':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submittest',value:function submittest(cur_question_id){var _this4=this;if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){_this4.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();// if (responseJson.isCompletedFully) {
//     this.goToThanksPage();
// } else {
if(responseJson.componentStatus=='completed'){_this4.gotoresult();}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this4.setState({componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:responseJson.is_answered_all});}else{setTimeout(function(){_this4.goback(responseJson.next_id);},200);}//}
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");});}}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:''}))),this.getoptions(ans_opt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:mk.fullanswer})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,className:validationClass,cols:'70',rows:'7',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords},mk.fullanswer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'sback',value:function sback(sdata){if(sdata.componentStatus=='completed'){this.gotoresult();}else{var evaluationPanel=sdata.componentStatus=="incompleted"?true:false;this.setState({componentStatus:sdata.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:sdata.is_answered_all});}//const {data}=this.props;
//this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'opentest',value:function opentest(){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");this.setState({time_state:1});var vdf=this.state.testseqfields;this.setState({time_left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Timecountdown__["a" /* default */],{seconds:vdf.seconds,details:data,question_number:vdf.question_number,state:this.state.time_state,tfs:this.sback,goToThanksPage:this.goToThanksPage})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},1000);}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},data.base_line?data.base_line:'')),data.learner_msg!==""&&data.question_number=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimedeg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ftime_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-allot-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/timer.gif",width:'74',border:'0',height:'74'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-cont-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-cont-box'},'Questions completed: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.question_completed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Time taken: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.time_left_mintues_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' mins'),' ',data.time_left_seconds_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' secs'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-align'},'Time Alloted:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-red'},data.time_duration,' mins')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-divider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/divider.gif',width:'1',height:'54',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnroom',title:'Continue',type:'button',className:'Btgoback',value:'Continue',onClick:function onClick(e){return _this6.opentest();}}))),this.state.is_answered_all!=1&&this.state.time_left,this.state.time_state!=0&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this6.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+testquestions.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt fleft'},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn fleft',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:qas.inserted_answer!=undefined?qas.inserted_answer:''}),' -'));}return _this6.getquestion(testquestions,qas,i+1);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple,defaultValue:testquestions.fullanswer}))),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length,defaultValue:testquestions.fullanswer}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(','),defaultValue:testquestions.answered})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.goback(pre_question_id);}}))))))))));}}]);return Cfixedtimetest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Cfixedtimetest);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Timercount__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ctimevariabletest=function(_Component){_inherits(Ctimevariabletest,_Component);function Ctimevariabletest(props){_classCallCheck(this,Ctimevariabletest);var _this=_possibleConstructorReturn(this,(Ctimevariabletest.__proto__||Object.getPrototypeOf(Ctimevariabletest)).call(this,props));_this.compeletestatus="";_this.state={componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",testseqfields:[],time_left:'',time_state:0,is_answered_all:0};return _this;}_createClass(Ctimevariabletest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettimevariable',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({time_left:'',testseqfields:{'seconds':responseJson.time_left_seconds,'question_number':responseJson.Mcq_details.question_number},testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,is_answered_all:responseJson.Mcq_details.is_answered_all});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',//type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt){var op_val='';switch(ans_opt.options){case'image':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submittest',value:function submittest(cur_question_id){var _this4=this;if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this4.props.getLearningRoom();if(responseJson.componentStatus=='completed'){_this4.gotoresult();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}else{setTimeout(function(){_this4.goback(responseJson.next_id);},200);}Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:'',controlsList:'nodownload'}))),this.getoptions(ans_opt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tatement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tatement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg',defaultValue:mk.answered[r]})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:mk.fullanswer})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,className:validationClass,cols:'70',rows:'7',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords},mk.fullanswer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'opentest',value:function opentest(){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");this.setState({time_state:1});var vdf=this.state.testseqfields;this.setState({time_left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Timercount__["a" /* default */],{seconds:vdf.seconds,details:data,question_number:vdf.question_number,state:this.state.time_state})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},1000);}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},data.base_line?data.base_line:'')),data.learner_msg!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimedeg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-allot-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/timer.gif',width:'74',border:'0',height:'74'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tk-txt '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qc-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',null,'Questions completed: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.question_completed))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},'Time taken: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.time_left_hours_string!='00'?data.time_left_hours_string+' hrs':'',' ',data.time_left_mintues_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' mins'),' ',data.time_left_seconds_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' secs'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnroom',title:'Continue',type:'button',className:'Btgoback',value:'Continue',onClick:function onClick(e){return _this6.opentest();}}))),this.state.time_state!=0&&this.state.is_answered_all!=1&&this.state.time_left,this.state.time_state!=0&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this6.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+testquestions.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt fleft'},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn fleft',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:qas.inserted_answer!=undefined?qas.inserted_answer:''}),' -'));}return _this6.getquestion(testquestions,qas,i+1);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple,defaultValue:testquestions.fullanswer}))),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length,defaultValue:testquestions.fullanswer}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(','),defaultValue:testquestions.answered})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.goback(pre_question_id);}}))))))))));}}]);return Ctimevariabletest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Ctimevariabletest);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TestGraph__ = __webpack_require__(293);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ctestresults=function(_Component){_inherits(Ctestresults,_Component);function Ctestresults(props){_classCallCheck(this,Ctestresults);var _this=_possibleConstructorReturn(this,(Ctestresults.__proto__||Object.getPrototypeOf(Ctestresults)).call(this,props));_this.state={flowresult:false,componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",chart_graph:"",quscomd:[],actualToScore:"",percentage:"",winningAmount:"",losingAmount:"",performanceAmount:"",betStatus:""};return _this;}_createClass(Ctestresults,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getresults',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,quscomd:responseJson.QuestionCom,chart_graph:responseJson.Mcq_details.showgraph>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TestGraph__["a" /* default */],{scoredet:responseJson.Mcq_details}):''});if(responseJson.Mcq_details.is_betcomponent>0){_this2.setState({actualToScore:responseJson.bet_details.actualToScore,percentage:responseJson.bet_details.percentage,winningAmount:responseJson.bet_details.winningAmount,losingAmount:responseJson.bet_details.losingAmount,performanceAmount:responseJson.bet_details.performanceAmount,betStatus:responseJson.bet_details.betStatus});}setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");},200);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;if(data.flowresult){this.setState({flowresult:true});}this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getTestdetails(data);}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback(data);}},{key:'continueToComplete',value:function continueToComplete(){this.setState({flowresult:false});}},{key:'getoptions',value:function getoptions(ans_opt){var op_val='';switch(ans_opt.options){case'image':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'submitbuttons',value:function submitbuttons(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Submit',className:'button_org_inactive',type:'button',onClick:function onClick(e){return _this3.submittest();}}));}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i){var qty_val=[];var question_type=quest_det.question_type;var rs_img=ans_opt.score>0?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:rs_img,alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk){var _this4=this;var sdf=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this4.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt',style:{width:"40px"},title:'Enter one digit numeric input',onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r],readonly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mc.match_correct_ans_order==mk.answered[r]?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this4.video_frame(mc.match_ans_src,'')))));})))));return sdf;}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type,video_id:data.id};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{key:Date.now(),playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var disp=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bluetxt'},'Your Answer:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align'},mk.answered)));return disp;}},{key:'render',value:function render(){var _this5=this;var data=this.state.testcont,testquestions=this.state.testquestions,seq_op=[];var quscomd=this.state.quscomd;var optionText=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.flowresult&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg'},'Successfully completed the Session.'),data.is_betcomponent>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test_result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'bet_table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' Your Challenge was to score ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'set_challenge'},this.state.actualToScore))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_score'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Your Performance Score is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lrpercentage'},this.state.percentage,'%'),' in the Challenge')),this.state.betStatus==="lost"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You have Lost ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lost'},this.state.losingAmount),' Points in the Challenge')),this.state.betStatus==="won"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You have Won ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'won'},this.state.winningAmount),' Points in the Challenge')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'challenge_status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You have got ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'perfamnt'},this.state.performanceAmount),' Points for your Performance'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box'},' You have scored ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',data.actual_score+'/'+data.out_of_score),', YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'.\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'orange',onClick:function onClick(){return _this5.continueToComplete();}},'Click here'),' to view correct answers.'),data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grey-lite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'Few open ended questions and Audio Answers are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment')),data.score_comment!=undefined&&data.is_performance=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testperformance'},data.score_comment),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this5.backToComponentList();}}))),!this.state.flowresult&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testscoretop'},data.actual_score!=undefined&&data.out_of_score!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'test-score'},'Score:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.score_percentage,'% (',data.actual_score+'/'+data.out_of_score,')',data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,', '),data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'))))),data.show_yta=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grey-lite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*'),'Few Open ended questions and Audio answer questions are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment'))),this.state.chart_graph,data.min_taken!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimeresult'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Time taken: ',data.hrs_taken>0&&data.hrs_taken+'hrs : ',' ',data.min_taken,' min : ',data.sec_taken,' sec')),this.state.testquestions.map(function(mk,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt bluetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+index,src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width,height:mk.img_height}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+aindex,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this5.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Your Answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mk.answered,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mk.is_correct_ans>0?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif'}))),mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Correct Answer - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,mk.correct_answer)),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}return _this5.getquestion(mk,qas,i+1);}),mk.question_type==6&&_this5.openendquestions(mk),mk.question_type==7&&_this5.matchfillfun(mk)),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'audiorecord'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'raudio_'+index,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"upload/recorded-voice"+mk.answered,type:'audio/mpeg'}))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Your Answer : ',mk.answered,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mk.score>0?"/rmeta"+'/images/tick.gif':"/rmeta"+'/images/crossmark.gif',alt:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Correct Answer : ',mk.correct_answer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dottedline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dottedline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt score'},'Your Score - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,mk.is_YTA>0&&mk.score<1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},'YTA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'*')):mk.score),mk.is_hint_viewed>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'(You have viewed hint for this question)'),' ')))),mk.is_answer_explained=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Answer Explanation'),quscomd[mk.question_id].videoexpfile!=''&&_this5.video_frame(quscomd[mk.question_id].videoexpfile,''),quscomd[mk.question_id].audiofile!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'comd',controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+quscomd[mk.question_id].audiofile,type:'audio/mpeg'})),quscomd[mk.question_id].imagefile!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-exp-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"/admin/test_image_files/"+quscomd[mk.question_id].imagefile})),quscomd[mk.question_id].answer_comment!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:quscomd[mk.question_id].answer_comment}})))));}),data.score_comment!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'testperformance'},data.score_comment),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this5.backToComponentList();}})))))))));}}]);return Ctestresults;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ctestresults);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pdfview__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var Cvideocomponent=function(_Component){_inherits(Cvideocomponent,_Component);function Cvideocomponent(props){_classCallCheck(this,Cvideocomponent);var _this=_possibleConstructorReturn(this,(Cvideocomponent.__proto__||Object.getPrototypeOf(Cvideocomponent)).call(this,props));_this.compeletestatus="";_this.state={vediocnt:[],isAdimage:null,videotracks:[],videosizes:[],images:[],playersem:null};return _this;}_createClass(Cvideocomponent,[{key:'getVideocomponents',value:function getVideocomponents(data){var _this2=this;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'videocomponent/getvideocomponent',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */]()})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({playersem:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:responseJson.videotracks,trackData:trackData,vcdata:data}),vediocnt:responseJson.data,isAdimage:responseJson.isAdimage,videotracks:responseJson.videotracks,videosizes:responseJson.videosizes,videosources:responseJson.sources});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},200);});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var data=this.props.data;this.compeletestatus=data.status;this.getVideocomponents(data);var imageArr=[];imageArr[0]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/Bennett.jpg';imageArr[1]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/IFIM.jpg';imageArr[2]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/Manav.jpg';imageArr[3]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/RMS.jpg';this.setState({images:imageArr});setTimeout(function(){_this3.changeImage(1);},10000);}},{key:'changeImage',value:function changeImage(x){var _this4=this;if(this.state.isAdimage=='1'){$('.videoadd').show();var img=document.getElementById("img");if(img!=null){img.src=this.state.images[x];x++;}if(x>=this.state.images.length){x=0;}setTimeout(function(){_this4.changeImage(x);},5000);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;this.getVideocomponents(data);}},{key:'adimaes',value:function adimaes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'videoadd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'img',src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/IFIM.jpg'}));}},{key:'onsubmit',value:function onsubmit(){var _this5=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'videocomponent/saveall',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),dlr_id:data.dlr_id})}).then(function(response){return response.json();}).then(function(responseJson){_this5.props.switchback(data);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback(data);}},{key:'submitbuttons',value:function submitbuttons(){var _this6=this;if(this.compeletestatus=='completed'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'cancel',id:'cancel',value:'Continue',className:'button_org_inactive',alt:'Continue',title:'Continue',type:'button',onClick:function onClick(e){return _this6.backToComponentList();}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'cancel',id:'cancel',value:'Will watch later',className:'button-cancel',alt:'Will watch later',title:'Will watch later',type:'button',onClick:function onClick(e){return _this6.backToComponentList();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'pqqroceed',id:'pqqroceed',value:'Next',className:'button-accept',alt:'Next',title:'Next',type:'submit',onClick:function onClick(e){return _this6.onsubmit();}}));}}},{key:'render',value:function render(){var vdata=this.state.vediocnt;var videotracks=this.state.videotracks;var videosources=this.state.videosources;var videosizes=this.state.videosizes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:vdata.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'vc_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,vdata.videocomponent_name?vdata.videocomponent_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,vdata.base_line?vdata.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box videogray'},this.state.playersem,this.state.isAdimage=='1'?this.adimaes():'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txtLP rgbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},this.submitbuttons())))))))));}}]);return Cvideocomponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Cvideocomponent);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pdfview__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var Canouncement=function(_Component){_inherits(Canouncement,_Component);function Canouncement(props){_classCallCheck(this,Canouncement);var _this=_possibleConstructorReturn(this,(Canouncement.__proto__||Object.getPrototypeOf(Canouncement)).call(this,props));_this.compeletestatus="";_this.state={anouncet:[],anouncesorting:[]};return _this;}_createClass(Canouncement,[{key:'getAnnouncement',value:function getAnnouncement(id){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'anouncement/getanouncement',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({a_id:id})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({anouncet:responseJson.allvalues,anouncesorting:responseJson.sorting});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},2000);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getAnnouncement(data.id);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;this.getAnnouncement(data.id);}},{key:'pdf_frame',value:function pdf_frame(pdf_files){var styled={width:'100%',padding:'15px 1.9%',minHeight:'500px'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'1',className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'',title:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'PDF Annoncement')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'announcementpdf',className:'announcement',src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_pdf_files/'+pdf_files,style:styled}));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_video',className:'announcement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:Date.now(),className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'v_text',dangerouslySetInnerHTML:{__html:text}}));}},{key:'audio_frame',value:function audio_frame(audio_files,text){var control_style={position:'relative'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_audio',className:'announcement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{style:control_style,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_audio_files/'+audio_files,type:'audio/mpeg',width:'400',height:'50'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_text',dangerouslySetInnerHTML:{__html:text}}));}},{key:'image_frame',value:function image_frame(image_files,image_description,text_message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_image',className:'announcement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'announcementtext'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/announcement_image_files/"+image_files,alt:'',className:'announceimg',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:image_description}}));}},{key:'text_frame',value:function text_frame(text_files){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'an_text',className:'announcemen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:text_files}}));}},{key:'onsubmit',value:function onsubmit(){var _this3=this;var data=this.props.data;var cant=this.state.anouncet;if(cant.audio_file!==''||cant.video_file!==''){var message='Finished watching/listening? ';message=cant.audio_file!==''&&cant.video_file===''?'Finished listening? ':message;message=cant.audio_file===''&&cant.video_file!==''?'Finished watching? ':message;var rsfbacl=cant.Isvisible!=='1'?'You will not be able to come back to it afterwards.':'';window.swal({//title: 'View!',
text:message+rsfbacl,//type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){_this3.saveallfn();}});}else{this.saveallfn();}}},{key:'saveallfn',value:function saveallfn(){var _this4=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'anouncement/saveall',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),dlr_id:data.dlr_id})}).then(function(response){return response.json();}).then(function(responseJson){_this4.props.switchback(data);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'sortinglists',value:function sortinglists(type){var data=this.state.anouncet;var retval='';switch(type){case'pdf':if(data.pdf_file!==null&&data.pdf_file!==''){var pdfpath=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/announcement_pdf_files/'+data.pdf_file;retval=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Pdfview__["a" /* default */],{key:'pdf_view_0',pdfpath:pdfpath,title:'PDF - Annoncement'});//this.pdf_frame(data.pdf_file);
}break;case'video':if(data.video_file!==null&&data.video_file!==''){retval=this.video_frame(data.video_file,data.video_description);}break;case'audio':if(data.audio_file!==null&&data.audio_file!==''){retval=this.audio_frame(data.audio_file,data.audio_description);}break;case'image':if(data.image_file!==null&&data.image_file!==''){retval=this.image_frame(data.image_file,data.image_description,data.message);}break;case'text':if(data.message!==null&&data.message!==''){retval=this.text_frame(data.message);}break;}return retval;}},{key:'submitbuttons',value:function submitbuttons(){var _this5=this;if(this.compeletestatus==='completed'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active',className:'button annonbtn gotobtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnsubmit',value:'Continue',alt:'Continue',title:'Continue',type:'button',onClick:function onClick(e){return _this5.onsubmit();}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active',className:'button annonbtn gotobtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnsubmit',value:'Continue',alt:'Continue',title:'Continue',type:'button',onClick:function onClick(e){return _this5.onsubmit();}}));}}},{key:'render',value:function render(){var _this6=this;var data=this.state.anouncet;var asorting=this.state.anouncesorting;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Annoncement',className:'an_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.anouncement_name?data.anouncement_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},asorting.map(function(val,key){return _this6.sortinglists(val);}),this.submitbuttons()))))));}}]);return Canouncement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Canouncement);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cfeedbackform=function(_Component){_inherits(Cfeedbackform,_Component);function Cfeedbackform(props){_classCallCheck(this,Cfeedbackform);var _this=_possibleConstructorReturn(this,(Cfeedbackform.__proto__||Object.getPrototypeOf(Cfeedbackform)).call(this,props));_this.state={formName:"",altText:"",icon:"",questions:[],dynamicFormData:{}};return _this;}_createClass(Cfeedbackform,[{key:'getFeedbackForm',value:function getFeedbackForm(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"get-feedback-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this2.setState({formName:responseJson.data.formName,altText:responseJson.data.altText,icon:responseJson.data.icon,questions:responseJson.data.questions,dynamicFormData:responseJson.data});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");},200);}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getFeedbackForm(data);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getFeedbackForm(data);}},{key:'submitFeedbackForm',value:function submitFeedbackForm(){var _this3=this;if(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Validation__["a" /* runValidation */])()){var dynamicFormData=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["d" /* getFormValues */])(this.state.dynamicFormData);var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"post-feedback-form",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data,form_data:dynamicFormData})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();_this3.props.switchback(data);}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'render',value:function render(){var _this4=this;var feedbackQuestionsHtml=this.state.questions.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'feedback_question_'+key,className:'fdbk-questn'},val.questionLabel,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greenbg'},key+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'codeno'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__["a" /* default */],{qDetails:val}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box tit-new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fb_complete_button',title:this.state.altText},this.state.icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,this.state.formName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},feedbackQuestionsHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Continue',title:'Continue',onClick:function onClick(){return _this4.submitFeedbackForm();}}))))))));}}]);return Cfeedbackform;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Cfeedbackform);

/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(354);
module.exports = __webpack_require__(359);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(355).enable();
  window.Promise = __webpack_require__(357);
}

// fetch() polyfill for making API calls.
__webpack_require__(358);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(47);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(187);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(187);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_configureStore__ = __webpack_require__(875);
// import {Router, Route, hashHistory, BrowserRouter, browserHistory} from 'react-router';
var store=__WEBPACK_IMPORTED_MODULE_6__store_configureStore__["a" /* default */];__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* hashHistory */],routes:__WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */]})),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(47),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;
if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.7.0",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(47),ba=__webpack_require__(362);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function z(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(z.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});z.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
z.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(z);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=z.extend({data:null}),nb=z.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=mc(a.type);c=null;d&&(c=mc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
wc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function xc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ac(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
function Cc(a,b){Bc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Dc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Dc(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ec(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Dc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Fc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Gc(a,b,c){a=z.getPooled(Fc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Gc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Fc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Gc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Dc(e,"number",e.value)}},Wc=z.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=z.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=z.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=z.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=z}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function H(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=z.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function de(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=de(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
function ie(a,b){var c=yc(b.value),d=yc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&H(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a,b,c,d,e){a[Ha]=e;"input"===c&&"radio"===e.type&&null!=e.name&&Bc(a,e);we(c,d);d=we(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?te(a,h):"dangerouslySetInnerHTML"===g?oe(a,h):"children"===g?pe(a,h):xc(a,g,h,d)}switch(c){case "input":Cc(a,e);break;case "textarea":ie(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?fe(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?fe(a,!!e.multiple,e.defaultValue,
!0):fe(a,!!e.multiple,e.multiple?[]:"",!1))}}function Ge(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function He(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Ie=[],Je=-1;function I(a){0>Je||(a.current=Ie[Je],Ie[Je]=null,Je--)}function J(a,b){Je++;Ie[Je]=a.current;a.current=b}var Ke={},K={current:Ke},L={current:!1},Le=Ke;
function Me(a,b){var c=a.type.contextTypes;if(!c)return Ke;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ne(a){I(L,a);I(K,a)}function Oe(a){I(L,a);I(K,a)}
function Pe(a,b,c){K.current!==Ke?t("168"):void 0;J(K,b,a);J(L,c,a)}function Qe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Re(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Ke;Le=K.current;J(K,b,a);J(L,L.current,a);return!0}
function Se(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Qe(a,b,Le),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Te=null,Ue=null;function Ve(a){return function(b){try{return a(b)}catch(c){}}}
function We(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Te=Ve(function(a){return b.onCommitFiberRoot(c,a)});Ue=Ve(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Xe(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Xe(a,b,c,d)}
function Ye(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ze(a){if("function"===typeof a)return Ye(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function $e(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function af(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ye(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return bf(c.children,e,f,b);case fc:return cf(c,e|3,f,b);case bc:return cf(c,e|2,f,b);case cc:return a=N(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=N(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function bf(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function cf(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function df(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
function ef(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ff(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);gf(b,a)}
function hf(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);gf(b,a)}function jf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}
function gf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var kf=!1;function lf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function of(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=lf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=lf(a.memoizedState),e=c.updateQueue=lf(c.memoizedState)):d=a.updateQueue=mf(e):null===e&&(e=c.updateQueue=mf(d));null===e||d===e?of(d,b):null===d.lastUpdate||null===e.lastUpdate?(of(d,b),of(e,b)):(of(d,b),e.lastUpdate=b)}
function qf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=lf(a.memoizedState):rf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function rf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=mf(b));return b}
function sf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:kf=!0}return d}
function tf(a,b,c,d,e){kf=!1;b=rf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=sf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var r=k.expirationTime;r<e?(null===m&&(m=k,null===g&&(f=l)),h<r&&(h=r)):(l=sf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function uf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);vf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;vf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function vf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function wf(a,b){return{value:a,source:b,stack:nc(b)}}var xf={current:null},yf=null,zf=null,Af=null;function Bf(a,b){var c=a.type._context;J(xf,c._currentValue,a);c._currentValue=b}function Cf(a){var b=xf.current;I(xf,a);a.type._context._currentValue=b}function Df(a){yf=a;Af=zf=null;a.firstContextDependency=null}
function Ef(a,b){if(Af!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Af=a,b=1073741823;b={context:a,observedBits:b,next:null};null===zf?(null===yf?t("293"):void 0,yf.firstContextDependency=zf=b):zf=zf.next=b}return a._currentValue}var Ff={},O={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?t("174"):void 0;return a}
function Jf(a,b){J(Hf,b,a);J(Gf,a,a);J(O,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}I(O,a);J(O,b,a)}function Kf(a){I(O,a);I(Gf,a);I(Hf,a)}function Lf(a){If(Hf.current);var b=If(O.current);var c=me(b,a.type);b!==c&&(J(Gf,a,a),J(O,c,a))}function Mf(a){Gf.current===a&&(I(O,a),I(Gf,a))}
function P(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Nf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Of=Xb.ReactCurrentOwner,Pf=(new aa.Component).refs;
function Qf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Vf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Rf();d=Sf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Tf();pf(a,e);Uf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Rf();d=Sf(d,a);var e=nf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Tf();pf(a,e);Uf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Rf();c=Sf(c,a);var d=nf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Tf();pf(a,d);Uf(a,c)}};function Wf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Xf(a,b,c){var d=!1,e=Ke;var f=b.contextType;"object"===typeof f&&null!==f?f=Of.currentDispatcher.readContext(f):(e=M(b)?Le:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Me(a,e):Ke);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Vf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Zf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Vf.enqueueReplaceState(b,b.state,null)}
function $f(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Pf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Of.currentDispatcher.readContext(f):(f=M(b)?Le:K.current,e.context=Me(a,f));f=a.updateQueue;null!==f&&(tf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Qf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Vf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(tf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var ag=Array.isArray;
function bg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Pf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function cg(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function dg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=$e(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=bg(a,b,c),d.return=a,d;d=af(c.type,c.key,c.props,null,a.mode,d);d.ref=bg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=bf(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function r(a,b,c){if("string"===typeof b||"number"===typeof b)return b=df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=af(b.type,b.key,b.props,null,a.mode,c),c.ref=bg(a,null,b),c.return=a,c;case $b:return b=ef(b,a.mode,c),b.return=a,b}if(ag(b)||
lc(b))return b=bf(b,a.mode,c,null),b.return=a,b;cg(a,b)}return null}function w(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(ag(c)||lc(c))return null!==e?null:m(a,b,c,d,null);cg(a,c)}return null}function y(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(ag(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);cg(b,d)}return null}function B(e,g,h,k){for(var l=null,q=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=w(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===q?l=v:q.sibling=v;q=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=r(e,h[u],k))g=f(m,g,u),null===q?l=m:q.sibling=m,q=m;return l}for(m=d(e,m);u<h.length;u++)if(p=y(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===q?l=p:q.sibling=p,q=p;a&&m.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,q=g,u=g=0,p=null,v=h.next();null!==q&&!v.done;u++,v=h.next()){q.index>u?(p=q,q=null):p=q.sibling;var A=w(e,q,v.value,k);if(null===A){q||(q=p);break}a&&q&&null===A.alternate&&b(e,q);g=f(A,g,u);null===m?l=A:m.sibling=A;m=A;q=p}if(v.done)return c(e,q),l;if(null===q){for(;!v.done;u++,v=h.next())v=r(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(q=d(e,q);!v.done;u++,v=h.next())v=y(q,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&q.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=bg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=bf(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=af(f.type,f.key,f.props,null,a.mode,h),h.ref=bg(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=df(f,a.mode,h),d.return=a,a=d),g(a);if(ag(f))return B(a,d,f,h);if(lc(f))return R(a,d,f,h);l&&cg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var eg=dg(!0),fg=dg(!1),gg=null,hg=null,ig=!1;
function jg(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function kg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function lg(a){if(ig){var b=hg;if(b){var c=b;if(!kg(a,b)){b=Ge(c);if(!b||!kg(a,b)){a.effectTag|=2;ig=!1;gg=a;return}jg(gg,c)}gg=a;hg=He(b)}else a.effectTag|=2,ig=!1,gg=a}}function mg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;gg=a}function ng(a){if(a!==gg)return!1;if(!ig)return mg(a),ig=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=hg;b;)jg(a,b),b=Ge(b);mg(a);hg=gg?Ge(a.stateNode):null;return!0}function og(){hg=gg=null;ig=!1}var pg=Xb.ReactCurrentOwner;
function Q(a,b,c,d){b.child=null===a?fg(b,null,c,d):eg(b,a.child,c,d)}function qg(a,b,c,d,e){c=c.render;var f=b.ref;Df(b,e);d=c(d,f);b.effectTag|=1;Q(a,b,d,e);return b.child}
function rg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ye(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,sg(a,b,g,d,e,f);a=af(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return tg(a,b,f);b.effectTag|=1;a=$e(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function sg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?tg(a,b,f):ug(a,b,c,d,f)}function vg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function ug(a,b,c,d,e){var f=M(c)?Le:K.current;f=Me(b,f);Df(b,e);c=c(d,f);b.effectTag|=1;Q(a,b,c,e);return b.child}
function wg(a,b,c,d,e){if(M(c)){var f=!0;Re(b)}else f=!1;Df(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Xf(b,c,d,e),$f(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Of.currentDispatcher.readContext(l):(l=M(c)?Le:K.current,l=Me(b,l));var m=c.getDerivedStateFromProps,r="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;r||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Zf(b,g,d,l);kf=!1;var w=b.memoizedState;k=g.state=w;var y=b.updateQueue;null!==y&&(tf(b,y,d,g,e),k=b.memoizedState);h!==d||w!==k||L.current||kf?("function"===typeof m&&(Qf(b,c,m,d),k=b.memoizedState),(h=kf||Wf(b,c,h,d,w,k,l))?(r||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:P(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Of.currentDispatcher.readContext(l):(l=M(c)?Le:K.current,l=Me(b,l)),m=c.getDerivedStateFromProps,
(r="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Zf(b,g,d,l),kf=!1,k=b.memoizedState,w=g.state=k,y=b.updateQueue,null!==y&&(tf(b,y,d,g,e),w=b.memoizedState),h!==d||k!==w||L.current||kf?("function"===typeof m&&(Qf(b,c,m,d),w=b.memoizedState),(m=kf||Wf(b,c,h,d,k,w,l))?(r||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return xg(a,b,c,d,f,e)}
function xg(a,b,c,d,e,f){vg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Se(b,c,!1),tg(a,b,f);d=b.stateNode;pg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=eg(b,a.child,null,f),b.child=eg(b,null,h,f)):Q(a,b,h,f);b.memoizedState=d.state;e&&Se(b,c,!0);return b.child}function yg(a){var b=a.stateNode;b.pendingContext?Pe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Pe(a,b.context,!1);Jf(a,b.containerInfo)}
function zg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=bf(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=bf(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=fg(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=$e(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=$e(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=eg(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=bf(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=bf(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=eg(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function tg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=$e(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=$e(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Ag(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!L.current&&d<c){switch(b.tag){case 3:yg(b);og();break;case 5:Lf(b);break;case 1:M(b.type)&&Re(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Bf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return zg(a,b,c);b=tg(a,b,c);return null!==b?b.sibling:null}}return tg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Me(b,K.current);Df(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(M(d)){var f=!0;Re(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Qf(b,d,g,a);e.updater=Vf;b.stateNode=e;e._reactInternalFiber=b;$f(b,d,a,c);b=xg(null,b,d,!0,f,c)}else b.tag=0,Q(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Nf(e);b.type=a;e=b.tag=Ze(a);f=P(a,f);g=void 0;switch(e){case 0:g=ug(null,b,a,f,c);break;case 1:g=wg(null,b,a,f,c);break;case 11:g=qg(null,b,a,f,c);break;case 14:g=rg(null,b,a,P(a.type,f),d,c);break;default:t("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),ug(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),wg(a,b,
d,e,c);case 3:yg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;tf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)og(),b=tg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)hg=He(b.stateNode.containerInfo),gg=b,e=ig=!0;e?(b.effectTag|=2,b.child=fg(b,null,d,c)):(Q(a,b,d,c),og());b=b.child}return b;case 5:return Lf(b),null===a&&lg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),vg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(Q(a,b,g,c),b=b.child),b;case 6:return null===a&&lg(b),null;case 13:return zg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=eg(b,null,d,c):Q(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),qg(a,b,d,e,c);case 7:return Q(a,b,b.pendingProps,c),b.child;case 8:return Q(a,b,b.pendingProps.children,c),b.child;case 12:return Q(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Bf(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=tg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=nf(c);k.tag=2;pf(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}Q(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Df(b,c),e=Ef(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,Q(a,b,d,c),b.child;case 14:return e=b.type,f=P(e,b.pendingProps),f=P(e.type,f),rg(a,b,e,f,d,c);case 15:return sg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=
!0,Re(b)):a=!1,Df(b,c),Xf(b,d,e,c),$f(b,d,e,c),xg(null,b,d,!0,a,c);default:t("156")}}function Bg(a){a.effectTag|=4}var Cg=void 0,Gg=void 0,Hg=void 0,Ig=void 0;Cg=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Gg=function(){};
Hg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(O.current);a=null;switch(c){case "input":f=zc(g,f);d=zc(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&Bg(b)}};Ig=function(a,b,c,d){c!==d&&Bg(b)};
var Jg="function"===typeof WeakSet?WeakSet:Set;function Kg(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Lg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Mg(a,c)}else b.current=null}
function Ng(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=se("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function Og(a){"function"===typeof Ue&&Ue(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Mg(e,f)}}c=c.next}while(c!==b)}break;case 1:Lg(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Mg(a,f)}break;case 5:Lg(a);break;case 4:Pg(a)}}
function Qg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Rg(a){a:{for(var b=a.return;null!==b;){if(Qg(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Qg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Pg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Og(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Og(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Sg(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Fe(c,f,e,a,d,b)}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Rf()));null!==a&&Ng(a,d);c=b.updateQueue;
if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new Jg);c.forEach(function(a){var c=Tg.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:t("163")}}var Ug="function"===typeof WeakMap?WeakMap:Map;function Vg(a,b,c){c=nf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Wg(d);Kg(a,b)};return c}
function Xg(a,b,c){c=nf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Yg?Yg=new Set([this]):Yg.add(this));var c=b.value,e=b.stack;Kg(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Zg(a){switch(a.tag){case 1:M(a.type)&&Ne(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Oe(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Kf(a),null;case 10:return Cf(a),null;default:return null}}
var $g={readContext:Ef},ah=Xb.ReactCurrentOwner,bh=1073741822,ch=0,dh=!1,S=null,T=null,U=0,eh=-1,fh=!1,V=null,gh=!1,hh=null,ih=null,Yg=null;function jh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ne(b);break;case 3:Kf(b);Oe(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Cf(b)}a=a.return}T=null;U=0;eh=-1;fh=!1;S=null}function Tf(){null!==ih&&(ba.unstable_cancelCallback(hh),ih())}
function kh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){S=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&Ne(b);break;case 3:Kf(b);Oe(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)ng(b),b.effectTag&=-3;Gg(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)Hg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=If(O.current);if(ng(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,r=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)H(bb[l],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Ac(e,m);H("invalid",e);xe(r,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};H("invalid",e);xe(r,"onChange");break;case "textarea":he(e,m),H("invalid",e),xe(r,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(r,f));switch(h){case "input":Vb(e);Ec(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&Bg(b)}else{m=b;e=f;r=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof r.is?l=l.createElement(e,{is:r.is}):(l=l.createElement(e),"select"===e&&r.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Cg(e,b,!1,!1);r=e;l=f;m=g;var w=h,y=we(l,m);switch(l){case "iframe":case "object":H("load",
r);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)H(bb[h],r);h=m;break;case "source":H("error",r);h=m;break;case "img":case "image":case "link":H("error",r);H("load",r);h=m;break;case "form":H("reset",r);H("submit",r);h=m;break;case "details":H("toggle",r);h=m;break;case "input":Ac(r,m);h=zc(r,m);H("invalid",r);xe(w,"onChange");break;case "option":h=ee(r,m);break;case "select":r._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});H("invalid",r);xe(w,"onChange");break;case "textarea":he(r,
m);h=ge(r,m);H("invalid",r);xe(w,"onChange");break;default:h=m}ve(l,h);k=void 0;var B=l,R=r,v=h;for(k in v)if(v.hasOwnProperty(k)){var q=v[k];"style"===k?te(R,q):"dangerouslySetInnerHTML"===k?(q=q?q.__html:void 0,null!=q&&oe(R,q)):"children"===k?"string"===typeof q?("textarea"!==B||""!==q)&&pe(R,q):"number"===typeof q&&pe(R,""+q):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=q&&xe(w,k):null!=q&&xc(R,k,q,y))}switch(l){case "input":Vb(r);
Ec(r,m,!1);break;case "textarea":Vb(r);je(r,m);break;case "option":null!=m.value&&r.setAttribute("value",""+yc(m.value));break;case "select":h=r;h.multiple=!!m.multiple;r=m.value;null!=r?fe(h,!!m.multiple,r,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(r.onclick=ye)}(g=Be(f,g))&&Bg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Ig(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=If(Hf.current),If(O.current),ng(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&Bg(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;S=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g!==f||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);Gg(b);break;case 10:Cf(b);break;case 9:break;case 14:break;case 17:M(b.type)&&Ne(b);break;default:t("156")}S=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==S)return S;null!==c&&0===(c.effectTag&1024)&&(null===
c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Zg(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function lh(a){var b=Ag(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=kh(a));ah.current=null;return b}
function mh(a,b){dh?t("243"):void 0;Tf();dh=!0;ah.currentDispatcher=$g;var c=a.nextExpirationTimeToWorkOn;if(c!==U||a!==T||null===S)jh(),T=a,U=c,S=$e(T.current,null,U),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==S&&!nh();)S=lh(S);else for(;null!==S;)S=lh(S)}catch(B){if(Af=zf=yf=null,null===S)d=!0,Wg(B);else{null===S?t("271"):void 0;var e=S,f=e.return;if(null===f)d=!0,Wg(B);else{a:{var g=a,h=f,k=e,l=B;f=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var r=-1,w=-1;do{if(13===l.tag){var y=l.alternate;if(null!==y&&(y=y.memoizedState,null!==y)){w=10*(1073741822-y.timedOutAt);break}y=l.pendingProps.maxDuration;if("number"===typeof y)if(0>=y)r=0;else if(-1===r||y<r)r=y}l=l.return}while(null!==l);l=h;do{if(y=13===l.tag)y=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(y){h=l.updateQueue;null===h?l.updateQueue=new Set([m]):h.add(m);if(0===(l.mode&1)){l.effectTag|=64;k.effectTag&=-1957;
1===k.tag&&(null===k.alternate?k.tag=17:(f=nf(1073741823),f.tag=2,pf(k,f)));k.expirationTime=1073741823;break a}k=g.pingCache;null===k?(k=g.pingCache=new Ug,h=new Set,k.set(m,h)):(h=k.get(m),void 0===h&&(h=new Set,k.set(m,h)));h.has(f)||(h.add(f),k=oh.bind(null,g,m,f),m.then(k,k));-1===r?g=1073741823:(-1===w&&(w=10*(1073741822-jf(g,f))-5E3),g=w+r);0<=g&&eh<g&&(eh=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
nc(k))}fh=!0;l=wf(l,k);g=h;do{switch(g.tag){case 3:g.effectTag|=2048;g.expirationTime=f;f=Vg(g,l,f);qf(g,f);break a;case 1:if(m=l,r=g.type,w=g.stateNode,0===(g.effectTag&64)&&("function"===typeof r.getDerivedStateFromError||null!==w&&"function"===typeof w.componentDidCatch&&(null===Yg||!Yg.has(w)))){g.effectTag|=2048;g.expirationTime=f;f=Xg(g,m,f);qf(g,f);break a}}g=g.return}while(null!==g)}S=kh(e);continue}}}break}while(1);dh=!1;Af=zf=yf=ah.currentDispatcher=null;if(d)T=null,a.finishedWork=null;
else if(null!==S)a.finishedWork=null;else{d=a.current.alternate;null===d?t("281"):void 0;T=null;if(fh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){hf(a,c);ph(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;ph(a,d,c,b,-1);return}}b&&-1!==eh?(hf(a,c),b=10*(1073741822-jf(a,c)),b<eh&&(eh=b),b=10*(1073741822-Rf()),b=eh-b,ph(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=
c,a.finishedWork=d)}}function Mg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Yg||!Yg.has(d))){a=wf(b,a);a=Xg(c,a,1073741823);pf(c,a);Uf(c,1073741823);return}break;case 3:a=wf(b,a);a=Vg(c,a,1073741823);pf(c,a);Uf(c,1073741823);return}c=c.return}3===a.tag&&(c=wf(b,a),c=Vg(a,c,1073741823),pf(a,c),Uf(a,1073741823))}
function Sf(a,b){0!==ch?a=ch:dh?a=gh?1073741823:U:b.mode&1?(a=qh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==T&&a===U&&--a):a=1073741823;qh&&(0===rh||a<rh)&&(rh=a);return a}function oh(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==T&&U===c)T=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;gf(c,a);c=a.expirationTime;0!==c&&sh(a,c)}}
function Tg(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=Rf();b=Sf(b,a);a=th(a,b);null!==a&&(ff(a,b),b=a.expirationTime,0!==b&&sh(a,b))}
function th(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function Uf(a,b){a=th(a,b);null!==a&&(!dh&&0!==U&&b>U&&jh(),ff(a,b),dh&&!gh&&T===a||sh(a,a.expirationTime),uh>vh&&(uh=0,t("185")))}function wh(a,b,c,d,e){var f=ch;ch=1073741823;try{return a(b,c,d,e)}finally{ch=f}}var xh=null,W=null,yh=0,zh=void 0,X=!1,Ah=null,Y=0,rh=0,Bh=!1,Ch=null,Z=!1,Dh=!1,qh=!1,Eh=null,Fh=ba.unstable_now(),Gh=1073741822-(Fh/10|0),Hh=Gh,vh=50,uh=0,Ih=null;function Jh(){Gh=1073741822-((ba.unstable_now()-Fh)/10|0)}
function Kh(a,b){if(0!==yh){if(b<yh)return;null!==zh&&ba.unstable_cancelCallback(zh)}yh=b;a=ba.unstable_now()-Fh;zh=ba.unstable_scheduleCallback(Lh,{timeout:10*(1073741822-b)-a})}function ph(a,b,c,d,e){a.expirationTime=d;0!==e||nh()?0<e&&(a.timeoutHandle=De(Mh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Mh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Jh();Hh=Gh;Nh(a,c)}function Rf(){if(X)return Hh;Oh();if(0===Y||1===Y)Jh(),Hh=Gh;return Hh}
function sh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===W?(xh=W=a,a.nextScheduledRoot=a):(W=W.nextScheduledRoot=a,W.nextScheduledRoot=xh)):b>a.expirationTime&&(a.expirationTime=b);X||(Z?Dh&&(Ah=a,Y=1073741823,Ph(a,1073741823,!1)):1073741823===b?Qh(1073741823,!1):Kh(a,b))}
function Oh(){var a=0,b=null;if(null!==W)for(var c=W,d=xh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===W?t("244"):void 0;if(d===d.nextScheduledRoot){xh=W=d.nextScheduledRoot=null;break}else if(d===xh)xh=e=d.nextScheduledRoot,W.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===W){W=c;W.nextScheduledRoot=xh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===W)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}Ah=b;Y=a}var Rh=!1;function nh(){return Rh?!0:ba.unstable_shouldYield()?Rh=!0:!1}function Lh(){try{if(!nh()&&null!==xh){Jh();var a=xh;do{var b=a.expirationTime;0!==b&&Gh<=b&&(a.nextExpirationTimeToWorkOn=Gh);a=a.nextScheduledRoot}while(a!==xh)}Qh(0,!0)}finally{Rh=!1}}
function Qh(a,b){Oh();if(b)for(Jh(),Hh=Gh;null!==Ah&&0!==Y&&a<=Y&&!(Rh&&Gh>Y);)Ph(Ah,Y,Gh>Y),Oh(),Jh(),Hh=Gh;else for(;null!==Ah&&0!==Y&&a<=Y;)Ph(Ah,Y,!1),Oh();b&&(yh=0,zh=null);0!==Y&&Kh(Ah,Y);uh=0;Ih=null;if(null!==Eh)for(a=Eh,Eh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Bh||(Bh=!0,Ch=d)}}if(Bh)throw a=Ch,Ch=null,Bh=!1,a;}function Nh(a,b){X?t("253"):void 0;Ah=a;Y=b;Ph(a,b,!1);Qh(1073741823,!1)}
function Ph(a,b,c){X?t("245"):void 0;X=!0;if(c){var d=a.finishedWork;null!==d?Sh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),mh(a,c),d=a.finishedWork,null!==d&&(nh()?a.finishedWork=d:Sh(a,d,b)))}else d=a.finishedWork,null!==d?Sh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),mh(a,c),d=a.finishedWork,null!==d&&Sh(a,d,b));X=!1}
function Sh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===Eh?Eh=[d]:Eh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Ih?uh++:(Ih=a,uh=0);gh=dh=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(d<a.latestPingedTime&&(a.latestPingedTime=0),e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ff(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ff(a,d)):d>e&&ff(a,d));gf(0,a);ah.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in
e)var f={start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,r=-1,w=0,y=0,B=e,R=null;b:for(;;){for(var v;;){B!==f||0!==h&&3!==B.nodeType||(m=l+h);B!==k||0!==g&&3!==B.nodeType||(r=l+g);3===B.nodeType&&(l+=B.nodeValue.length);if(null===(v=B.firstChild))break;R=B;B=v}for(;;){if(B===
e)break b;R===f&&++w===h&&(m=l);R===k&&++y===g&&(r=l);if(null!==(v=B.nextSibling))break;B=R;R=B.parentNode}B=v}f=-1===m||-1===r?null:{start:m,end:r}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(V=d;null!==V;){e=!1;f=void 0;try{for(;null!==V;){if(V.effectTag&256)a:{var q=V.alternate;h=V;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==q){var u=q.memoizedProps,A=q.memoizedState,Yf=h.stateNode,Vh=Yf.getSnapshotBeforeUpdate(h.elementType===
h.type?u:P(h.type,u),A);Yf.__reactInternalSnapshotBeforeUpdate=Vh}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}V=V.nextEffect}}catch(db){e=!0,f=db}e&&(null===V?t("178"):void 0,Mg(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){q=!1;u=void 0;try{for(;null!==V;){var x=V.effectTag;x&16&&pe(V.stateNode,"");if(x&128){var C=V.alternate;if(null!==C){var p=C.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(x&14){case 2:Rg(V);V.effectTag&=-3;break;case 6:Rg(V);
V.effectTag&=-3;Sg(V.alternate,V);break;case 4:Sg(V.alternate,V);break;case 8:A=V;Pg(A);A.return=null;A.child=null;A.memoizedState=null;A.updateQueue=null;var G=A.alternate;null!==G&&(G.return=null,G.child=null,G.memoizedState=null,G.updateQueue=null)}V=V.nextEffect}}catch(db){q=!0,u=db}q&&(null===V?t("178"):void 0,Mg(V,u),null!==V&&(V=V.nextEffect))}p=Ae;C=Td();x=p.focusedElem;q=p.selectionRange;if(C!==x&&x&&x.ownerDocument&&Sd(x.ownerDocument.documentElement,x)){null!==q&&Ud(x)&&(C=q.start,p=q.end,
void 0===p&&(p=C),"selectionStart"in x?(x.selectionStart=C,x.selectionEnd=Math.min(p,x.value.length)):(p=(C=x.ownerDocument||document)&&C.defaultView||window,p.getSelection&&(p=p.getSelection(),u=x.textContent.length,G=Math.min(q.start,u),q=void 0===q.end?G:Math.min(q.end,u),!p.extend&&G>q&&(u=q,q=G,G=u),u=Rd(x,G),A=Rd(x,q),u&&A&&(1!==p.rangeCount||p.anchorNode!==u.node||p.anchorOffset!==u.offset||p.focusNode!==A.node||p.focusOffset!==A.offset)&&(C=C.createRange(),C.setStart(u.node,u.offset),p.removeAllRanges(),
G>q?(p.addRange(C),p.extend(A.node,A.offset)):(C.setEnd(A.node,A.offset),p.addRange(C))))));C=[];for(p=x;p=p.parentNode;)1===p.nodeType&&C.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof x.focus&&x.focus();for(x=0;x<C.length;x++)p=C[x],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(V=d;null!==V;){d=!1;x=void 0;try{for(C=c;null!==V;){var Fb=V.effectTag;if(Fb&36){var Gb=V.alternate;p=V;G=C;switch(p.tag){case 0:case 11:case 15:break;
case 1:var Hc=p.stateNode;if(p.effectTag&4)if(null===Gb)Hc.componentDidMount();else{var ii=p.elementType===p.type?Gb.memoizedProps:P(p.type,Gb.memoizedProps);Hc.componentDidUpdate(ii,Gb.memoizedState,Hc.__reactInternalSnapshotBeforeUpdate)}var Dg=p.updateQueue;null!==Dg&&uf(p,Dg,Hc,G);break;case 3:var Eg=p.updateQueue;if(null!==Eg){q=null;if(null!==p.child)switch(p.child.tag){case 5:q=p.child.stateNode;break;case 1:q=p.child.stateNode}uf(p,Eg,q,G)}break;case 5:var ji=p.stateNode;null===Gb&&p.effectTag&
4&&Be(p.type,p.memoizedProps)&&ji.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=V.ref;if(null!==Ic){var Fg=V.stateNode;switch(V.tag){case 5:var ce=Fg;break;default:ce=Fg}"function"===typeof Ic?Ic(ce):Ic.current=ce}}V=V.nextEffect}}catch(db){d=!0,x=db}d&&(null===V?t("178"):void 0,Mg(V,x),null!==V&&(V=V.nextEffect))}dh=gh=!1;"function"===typeof Te&&Te(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Yg=
null);a.expirationTime=b;a.finishedWork=null}function Wg(a){null===Ah?t("246"):void 0;Ah.expirationTime=0;Bh||(Bh=!0,Ch=a)}function Th(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||X||Qh(1073741823,!1)}}function Uh(a,b){if(Z&&!Dh){Dh=!0;try{return a(b)}finally{Dh=!1}}return a(b)}function Wh(a,b,c){if(qh)return a(b,c);Z||X||0===rh||(Qh(rh,!1),rh=0);var d=qh,e=Z;Z=qh=!0;try{return a(b,c)}finally{qh=d,(Z=e)||X||Qh(1073741823,!1)}}
function Xh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=Qe(c,h,g);break a}}c=g}else c=Ke;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Tf();pf(f,e);Uf(f,d);return d}function Yh(a,b,c,d){var e=b.current,f=Rf();e=Sf(f,e);return Xh(a,b,c,e,d)}function Zh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function $h(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Cc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Cc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function ai(a){var b=1073741822-25*(((1073741822-Rf()+500)/25|0)+1);b>=bh&&(b=bh-1);this._expirationTime=bh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ai.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new bi;Xh(a,b,null,c,d._onCommit);return d};
ai.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ai.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Nh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ai.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function bi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}bi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
bi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function ci(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
ci.prototype.render=function(a,b){var c=this._internalRoot,d=new bi;b=void 0===b?null:b;null!==b&&d.then(b);Yh(a,c,null,d._onCommit);return d};ci.prototype.unmount=function(a){var b=this._internalRoot,c=new bi;a=void 0===a?null:a;null!==a&&c.then(a);Yh(null,b,null,c._onCommit);return c};ci.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new bi;c=void 0===c?null:c;null!==c&&e.then(c);Yh(b,d,a,e._onCommit);return e};
ci.prototype.createBatch=function(){var a=new ai(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function di(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Th;Lb=Wh;Mb=function(){X||0===rh||(Qh(rh,!1),rh=0)};
function ei(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ci(a,!1,b)}
function fi(a,b,c,d,e){di(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Zh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ei(c,d);if("function"===typeof e){var h=e;e=function(){var a=Zh(f._internalRoot);h.call(a)}}Uh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Zh(f._internalRoot)}
function gi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;di(b)?void 0:t("200");return $h(a,b,null,c)}
var ki={createPortal:gi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return fi(null,a,b,!0,c)},render:function(a,b,c){return fi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return fi(a,b,c,!1,d)},unmountComponentAtNode:function(a){di(a)?
void 0:t("40");return a._reactRootContainer?(Uh(function(){fi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return gi.apply(void 0,arguments)},unstable_batchedUpdates:Th,unstable_interactiveUpdates:Wh,flushSync:function(a,b){X?t("187"):void 0;var c=Z;Z=!0;try{return wh(a,b)}finally{Z=c,Qh(1073741823,!1)}},unstable_createRoot:hi,unstable_flushControlled:function(a){var b=Z;Z=!0;try{wh(a)}finally{(Z=b)||X||Qh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]}};function hi(a,b){di(a)?void 0:t("299","unstable_createRoot");return new ci(a,!0,null!=b&&!0===b.hydrate)}(function(a){var b=a.findFiberByHostInstance;return We(n({},a,{overrideProps:null,findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.7.0",rendererPackageName:"react-dom"});
var li={default:ki},mi=li&&ki||li;module.exports=mi.default||mi;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(363);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.12.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var c=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=c.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=c,b=c.next;if(c===b)c=null;else{var d=c.previous;c=d.next=b;b.previous=d}a.next=a.previous=null;d=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=d()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===c)c=g.next=g.previous=g;else{d=null;a=c;do{if(a.expirationTime>=b){d=a;break}a=a.next}while(a!==c);null===d?d=c:d===c&&(c=g,p());b=d.previous;b.next=d.previous=g;g.next=d;g.previous=
b}}function v(){if(-1===k&&null!==c&&1===c.priorityLevel){m=!0;try{do u();while(null!==c&&1===c.priorityLevel)}finally{m=!1,null!==c?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==c;){var d=exports.unstable_now();if(c.expirationTime<=d){do u();while(null!==c&&c.expirationTime<=d)}else break}else if(null!==c){do u();while(null!==c&&!w())}}finally{m=!1,f=b,null!==c?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var d=exports.unstable_now(),e=!1;if(0>=P-d)if(-1!==b&&b<=d)e=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var d=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=d,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var d=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=d+b.timeout;else switch(h){case 1:b=d+-1;break;case 2:b=d+250;break;case 5:b=d+1073741823;break;case 4:b=d+1E4;break;default:b=d+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===c)c=a.next=a.previous=a,p();else{d=null;var e=c;do{if(e.expirationTime>b){d=e;break}e=e.next}while(e!==c);null===d?d=c:d===c&&(c=a,p());
b=d.previous;b.next=d.previous=a;a.next=d;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)c=null;else{a===c&&(c=b);var d=a.previous;d.next=b;b.previous=d}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var d=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=d,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==c&&c.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==c&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return c};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(47);

var emptyObject = __webpack_require__(366);
var _invariant = __webpack_require__(189);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(368);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(49);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(114);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(49);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(191);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(49);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(193);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(117);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(62);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(62);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRoute);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(62);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(384);
var objectAssign = __webpack_require__(47);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(50);

var _PathUtils = __webpack_require__(34);

var _createHistory = __webpack_require__(119);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(200);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(120);

var _BrowserProtocol = __webpack_require__(121);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(390);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(82);

var _createHistory = __webpack_require__(119);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(121);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(50);

var _PathUtils = __webpack_require__(34);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(200);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(120);

var _DOMUtils = __webpack_require__(82);

var _HashProtocol = __webpack_require__(393);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(119);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(121);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(50);

var _DOMUtils = __webpack_require__(82);

var _DOMStateStorage = __webpack_require__(199);

var _PathUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(122);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(83);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(407);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(205);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(205);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(206);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(408);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(122);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/rmeta",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/rmeta"+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_Login__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Home__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layouts_Main__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_Register__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_BirthdayWish__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_CorporateLogin__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_TcsLogin__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_ChatRate__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_TeleCall__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_TeleCallFeedback__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Feathers__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_PinExpired__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_WaitForLogin__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_ContractCancelled__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_PinDeactivated__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_LoginAddObserver__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_ScheduleDlr__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__personal_interactions_iseek_Feedback__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lr_dlr_components_Evaluator__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lr_dlr_components_DigitalEvaluation__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__practice_PracticeResponse__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mchat_Mchat__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__chat_Chat__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__layouts_RoomCompLayout__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__layouts_PersonalInteractionsLayout__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__layouts_LearningRecordsLayout__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__layouts_PracticeLayout__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__layouts_RightMenuLayout__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__layouts_LearningResourcesLayout__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__layouts_GroupInteractionsLayout__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__layouts_XrecapLayout__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__layouts_DmWallLayout__ = __webpack_require__(874);
// All checks goes here
var requireAuthAndGlobalRoute=function requireAuthAndGlobalRoute(nextState,replace){if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["d" /* hasGlobalRoute */])()){replace({pathname:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["c" /* getGlobalRoute */])()});}};var requireGlobalRoute=function requireGlobalRoute(nextState,replace){if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var userEntryAuth=function userEntryAuth(nextState,replace){if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()&&!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["d" /* hasGlobalRoute */])()){replace({pathname:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["c" /* getGlobalRoute */])()});}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()&&Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["d" /* hasGlobalRoute */])()){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var birthdayAuth=function birthdayAuth(nextState,replace){var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("afterRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(afterRoutes.length<=0||afterRoutes[0].identifier!=="birthdayNotify"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var chatRateAuth=function chatRateAuth(nextState,replace){var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("afterRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(afterRoutes.length<=0||afterRoutes[0].identifier!=="chatRating"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var teleCallAuth=function teleCallAuth(nextState,replace){var beforeRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("beforeRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(beforeRoutes.length<=0||beforeRoutes[0].identifier!=="teleCall"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var teleCallFeedbackAuth=function teleCallFeedbackAuth(nextState,replace){var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("afterRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(afterRoutes.length<=0||afterRoutes[0].identifier!=="teleCallFeedback"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var feathersAuth=function feathersAuth(nextState,replace){var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("afterRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(afterRoutes.length<=0||afterRoutes[0].identifier!=="feathers"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var pinExpiredAuth=function pinExpiredAuth(nextState,replace){var beforeRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("beforeRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(beforeRoutes.length<=0||beforeRoutes[0].identifier!=="pinExpired"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var waitForLoginAuth=function waitForLoginAuth(nextState,replace){var beforeRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("beforeRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(beforeRoutes.length<=0||beforeRoutes[0].identifier!=="waitForLogin"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var contractCancelledAuth=function contractCancelledAuth(nextState,replace){var beforeRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("beforeRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(beforeRoutes.length<=0||beforeRoutes[0].identifier!=="contractCancelled"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var pinDeactivatedAuth=function pinDeactivatedAuth(nextState,replace){var beforeRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("beforeRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(beforeRoutes.length<=0||beforeRoutes[0].identifier!=="pinDeactivated"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var LoginAddObserverAuth=function LoginAddObserverAuth(nextState,replace){var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("afterRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(afterRoutes.length<=0||afterRoutes[0].identifier!=="addObserver"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var ScheduleDlrAuth=function ScheduleDlrAuth(nextState,replace){var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("afterRoutes",true);if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=window.location.origin;}else if(afterRoutes.length<=0||afterRoutes[0].identifier!=="scheduleDlr"){replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var customLogincheck=function customLogincheck(nextState,replace){if(!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["e" /* isLoggedIn */])()){window.location=__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */];}else{replace({pathname:__WEBPACK_IMPORTED_MODULE_4__config_Config__["i" /* routeAfterLogin */]});}};var routes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],null,'// Website home route',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_6__Home__["a" /* default */],onEnter:requireGlobalRoute}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/login_user/:username/:password',component:__WEBPACK_IMPORTED_MODULE_5__auth_Login__["a" /* default */],onEnter:userEntryAuth}),'// User authentication routes',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/login',component:__WEBPACK_IMPORTED_MODULE_5__auth_Login__["a" /* default */],onEnter:customLogincheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/register',component:__WEBPACK_IMPORTED_MODULE_8__auth_Register__["a" /* default */],onEnter:userEntryAuth}),'// Basic routes after login',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/birthday',component:__WEBPACK_IMPORTED_MODULE_9__pages_BirthdayWish__["a" /* default */],onEnter:birthdayAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/ecoach/rating',component:__WEBPACK_IMPORTED_MODULE_12__pages_ChatRate__["a" /* default */],onEnter:chatRateAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/telecall/schedule',component:__WEBPACK_IMPORTED_MODULE_13__pages_TeleCall__["a" /* default */],onEnter:teleCallAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/telecall/feedback',component:__WEBPACK_IMPORTED_MODULE_14__pages_TeleCallFeedback__["a" /* default */],onEnter:teleCallFeedbackAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/observer/feathers',component:__WEBPACK_IMPORTED_MODULE_15__pages_Feathers__["a" /* default */],onEnter:feathersAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/pinexpired',component:__WEBPACK_IMPORTED_MODULE_16__pages_PinExpired__["a" /* default */],onEnter:pinExpiredAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/wait-for-login',component:__WEBPACK_IMPORTED_MODULE_17__pages_WaitForLogin__["a" /* default */],onEnter:waitForLoginAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/contract-cancelled',component:__WEBPACK_IMPORTED_MODULE_18__pages_ContractCancelled__["a" /* default */],onEnter:contractCancelledAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/pin-deactivated',component:__WEBPACK_IMPORTED_MODULE_19__pages_PinDeactivated__["a" /* default */],onEnter:pinDeactivatedAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/observer/add',component:__WEBPACK_IMPORTED_MODULE_20__pages_LoginAddObserver__["a" /* default */],onEnter:LoginAddObserverAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/user/schedule/dlr',component:__WEBPACK_IMPORTED_MODULE_21__pages_ScheduleDlr__["a" /* default */],onEnter:ScheduleDlrAuth}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/corporate-login/:accessCode',component:__WEBPACK_IMPORTED_MODULE_10__auth_CorporateLogin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/tcs-login/:accessCode',component:__WEBPACK_IMPORTED_MODULE_11__auth_TcsLogin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/learningroom',component:__WEBPACK_IMPORTED_MODULE_7__layouts_Main__["a" /* default */],onEnter:requireAuthAndGlobalRoute}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/feedback/:ass_id/:poll_id/:lr_id/:domain',component:__WEBPACK_IMPORTED_MODULE_22__personal_interactions_iseek_Feedback__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/evaluator/:asse_id/:lear_id',component:__WEBPACK_IMPORTED_MODULE_23__lr_dlr_components_Evaluator__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/digital-evaluation/:det',component:__WEBPACK_IMPORTED_MODULE_24__lr_dlr_components_DigitalEvaluation__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/buddychat',component:__WEBPACK_IMPORTED_MODULE_26__mchat_Mchat__["a" /* default */],onEnter:requireAuthAndGlobalRoute}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/chat/:ec_id/:time_slot_id',component:__WEBPACK_IMPORTED_MODULE_27__chat_Chat__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/practice_response/:score_id',component:__WEBPACK_IMPORTED_MODULE_25__practice_PracticeResponse__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/mobileapp-learning-room/:app_code/:device_id/:room_id/:dlr_id/:compseq_id/:divider_id',component:__WEBPACK_IMPORTED_MODULE_28__layouts_RoomCompLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/personal-interaction/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_29__layouts_PersonalInteractionsLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/learning-records/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_30__layouts_LearningRecordsLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/practice/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_31__layouts_PracticeLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/qlinks/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_32__layouts_RightMenuLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/learning-resources/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_33__layouts_LearningResourcesLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/group-interactions/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_34__layouts_GroupInteractionsLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/xrecap/:app_code/:device_id/:type',component:__WEBPACK_IMPORTED_MODULE_35__layouts_XrecapLayout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Route */],{path:'/dmwall/:app_code/:device_id',component:__WEBPACK_IMPORTED_MODULE_36__layouts_DmWallLayout__["a" /* default */]}));/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { Routes, Route, useParams } from 'react-router-dom';
var $=window.$;var Login=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.state={username:_this.props.params.username,password:_this.props.params.password};return _this;}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var authUser=this.state.username;var authPwd=this.state.password;if(authUser.trim()==""||authPwd.trim()==""){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["g" /* handleFormErrors */])({'authpwd':"Please enter your username and password"});//Common.message("Validation error occurred.", "Please enter your username and password", "error");
}else{Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["g" /* handleFormErrors */])({});__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");if(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["k" /* isMatchesEmail */])(authUser)){fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"user/infactlogin",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({authuser:authUser,authpwd:authPwd})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{try{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["x" /* setTokenData */]("token",responseJson.token);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("isLoggedIn",true);var msg=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("expiryDate",true);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("Info",msg,'');var date=new Date();date.setSeconds(date.getSeconds()+__WEBPACK_IMPORTED_MODULE_2__config_Config__["j" /* sessExpire */]);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("sessMax",date.getTime());var decodeJson=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */](responseJson.token);setTimeout(function(){if(decodeJson.beforeRoutes.length>0){_this2.props.redirect(decodeJson.beforeRoutes[0].url);}else if(decodeJson.afterRoutes.length>0){_this2.props.redirect(decodeJson.afterRoutes[0].url);}else{window.location.reload();_this2.props.redirect(decodeJson.routePath);}},500);}catch(e){alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');_this2.props.router.goBack();}}});}else{fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+"imeta/includes/metaajax_control.php?q=metalogin&name="+authUser+"&pword="+authPwd,{method:"GET"}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson=="Sucess"){window.location.href=__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+"home.php";}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("Validation error occurred.","Username (or) password incorrect.","error");}});}}}},{key:'render',value:function render(){var _this3=this;var appFullName=__WEBPACK_IMPORTED_MODULE_2__config_Config__["a" /* appFullName */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'head-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/learningroom',title:appFullName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo-361dm.png',alt:appFullName}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{id:'main-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'smoothmenu1',className:'ddsmoothmenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["e" /* onLineUrl */]+'network/'},'Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'institutions/'},'Institutions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'corporates/'},'Corporates')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+__WEBPACK_IMPORTED_MODULE_2__config_Config__["e" /* onLineUrl */]},'Individuals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'asps/'},'ASPs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'governments/'},'Governments')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/get-app-code.php'},'361DM App')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php'},'Careers'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-rgt-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hd-phn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/phone-icon.png',alt:'',width:'19',height:'19'}),'+91 44 39361361'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-ico'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',id:'toggle',className:'open'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/menu-icon.png',alt:'',width:'19',height:'13'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),' MENU'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'menu',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'our-science.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this3.hide();}},'Our Science')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'our-technology.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this3.hide();}},'Our technology')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+__WEBPACK_IMPORTED_MODULE_2__config_Config__["e" /* onLineUrl */],target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this3.hide();}},'Our Products')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'our-alliances.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this3.hide();}},'Our Alliances')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/get-app-code.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this3.hide();}},'361DM App')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(e){return _this3.showhide();},onMouseOver:function onMouseOver(e){return _this3.showhide();}},'About Us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'about-us-menu',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/company-profile.php',target:'_blank',rel:'noopener noreferrer'},'Company profile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/tech-platform.php',target:'_blank',rel:'noopener noreferrer'},'Tech Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/media-center.php',target:'_blank',rel:'noopener noreferrer'},'Media Centre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/students-corner.php',target:'_blank',rel:'noopener noreferrer'},'Students Corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/alumni.php',target:'_blank',rel:'noopener noreferrer'},'Alumni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php',target:'_blank',rel:'noopener noreferrer'},'Careers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/contact-us.php',target:'_blank',rel:'noopener noreferrer'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/privacy.php',target:'_blank',rel:'noopener noreferrer'},'Privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/terms.php',target:'_blank',rel:'noopener noreferrer'},'Terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/legal.php',target:'_blank',rel:'noopener noreferrer'},'Legal')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this3.hide();}},'Careers')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexslider loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'slides'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/dm_banner.jpg',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/dm_banner2.jpg',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/dm_banner3.jpg',alt:''})))),!__WEBPACK_IMPORTED_MODULE_4__helpers_User__["e" /* isLoggedIn */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learner-login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-right',id:'loginPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Learner ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'new_learner'},' New learner? ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'reg',title:'Register PIN here',href:'#/register'},'Register PIN here'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'authuser',ref:'authuser',placeholder:'Username',onKeyPress:function onKeyPress(e){return _this3._handleKeyPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'user-ico'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',id:'password',maxLength:'100',name:'authpwd',ref:'authpwd',placeholder:'Password',onKeyPress:function onKeyPress(e){return _this3._handleKeyPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'pwd-ico'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'eye_icon unmask',onClick:function onClick(){return _this3.maskunmask();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Login',title:'Login',onClick:function onClick(){return _this3.userLogin();}}),'\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3__helpers_Common__["z" /* showHide */]("#forgotPanel","#loginPanel");}},'Forgot password?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-right',id:'forgotPanel',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Forgot ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frgt-pwd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'authemail',ref:'authemail',placeholder:'Username',onKeyPress:function onKeyPress(e){return _this3._handleKeyEnterPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'user-ico'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:"both"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Request Password',title:'Request Password',className:'mail-icon',onClick:function onClick(){return _this3.userForgotPassword();}}),'\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3__helpers_Common__["z" /* showHide */]("#loginPanel","#forgotPanel");}},'Login'),' '))))),__WEBPACK_IMPORTED_MODULE_4__helpers_User__["e" /* isLoggedIn */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{background:'#14a430 none repeat scroll 0 0',borderTop:'5px solid #14a430',padding:'18px',position:'absolute',right:'63px',top:'85px',width:'420px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{color:'white',fontSize:'18px',fontWeight:'bold'},title:'Go to learning room',href:'#/learningroom'},'Go to learning room')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-ban'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/361dm',title:'Facebook',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/fb-ico.jpg',alt:'Facebook',width:'45',height:'43'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://plus.google.com/s/361DM/top',title:'Google+',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/gplus-ico.jpg',alt:'Google+',width:'45',height:'45'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/361dm',title:'Twitter',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/tw-ico.jpg',alt:'Twitter',width:'45',height:'42'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.linkedin.com/company/361-degree-minds?',target:'_blank',rel:'noopener noreferrer',title:'Linkedin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/in-ico.jpg',alt:'Linkedin',width:'45',height:'46'})))))));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_HomeLayout__ = __webpack_require__(413);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.redirect=_this.redirect.bind(_this);return _this;}_createClass(Home,[{key:'redirect',value:function redirect(url){this.props.router.push(url);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__layouts_HomeLayout__["a" /* default */],{redirect:this.redirect});}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_HomeHeader__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Ourservices__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_Quotes__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_LatestThinking__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_Ourtechnology__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_Ourmission__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_ManagementTeam__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_Ourclients__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_Homefooter__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeLayout=function(_Component){_inherits(HomeLayout,_Component);function HomeLayout(){_classCallCheck(this,HomeLayout);return _possibleConstructorReturn(this,(HomeLayout.__proto__||Object.getPrototypeOf(HomeLayout)).apply(this,arguments));}_createClass(HomeLayout,[{key:'componentWillMount',value:function componentWillMount(){document.body.className="landing-page";document.body.id="";}},{key:'render',value:function render(){var appFullName=__WEBPACK_IMPORTED_MODULE_10__config_Config__["a" /* appFullName */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mobNav',className:'mobNav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'mobi-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/#/',title:appFullName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo-361dm.png',alt:appFullName}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Institutions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Corporates')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Our Science')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Our technology')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Our Products')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Our Alliances')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'361DM App')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Careers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'About Us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Company profile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Tech Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'>Media Centre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Students Corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Alumni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Careers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Legal')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Careers')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__partials_HomeHeader__["a" /* default */],{redirect:this.props.redirect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__partials_Ourservices__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__partials_Quotes__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_LatestThinking__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_Ourtechnology__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__partials_Ourmission__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__partials_ManagementTeam__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_Ourclients__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_Homefooter__["a" /* default */],null)));}}]);return HomeLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeLayout);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var HomeHeader=function(_Component){_inherits(HomeHeader,_Component);function HomeHeader(){_classCallCheck(this,HomeHeader);return _possibleConstructorReturn(this,(HomeHeader.__proto__||Object.getPrototypeOf(HomeHeader)).apply(this,arguments));}_createClass(HomeHeader,[{key:'userLogin',value:function userLogin(){var _this2=this;var authUser=this.refs.authuser.value;var authPwd=this.refs.authpwd.value;if(authUser.trim()==""||authPwd.trim()==""){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["g" /* handleFormErrors */])({'authpwd':"Please enter your username and password"});//Common.message("Validation error occurred.", "Please enter your username and password", "error");
}else{Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["g" /* handleFormErrors */])({});__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");if(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["k" /* isMatchesEmail */])(authUser)){fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"user/login",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({authuser:authUser,authpwd:authPwd})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{try{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["x" /* setTokenData */]("token",responseJson.token);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("isLoggedIn",true);var date=new Date();date.setSeconds(date.getSeconds()+__WEBPACK_IMPORTED_MODULE_2__config_Config__["j" /* sessExpire */]);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("sessMax",date.getTime());var decodeJson=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */](responseJson.token);setTimeout(function(){if(decodeJson.beforeRoutes.length>0){_this2.props.redirect(decodeJson.beforeRoutes[0].url);}else if(decodeJson.afterRoutes.length>0){_this2.props.redirect(decodeJson.afterRoutes[0].url);}else{_this2.props.redirect(decodeJson.routePath);}},500);}catch(e){alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');_this2.props.router.goBack();}}});}else{fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+"imeta/includes/metaajax_control.php?q=metalogin&name="+authUser+"&pword="+authPwd,{method:"GET"}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson=="Sucess"){window.location.href=__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+"home.php";}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("Validation error occurred.","Username (or) password incorrect.","error");}});}}}},{key:'userForgotPassword',value:function userForgotPassword(){var _this3=this;var authEmail=this.refs.authemail.value;if(authEmail==""){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["g" /* handleFormErrors */])({'authemail':"Please enter a valid E-mail address"});//Common.message("Validation error occurred.", "Please enter a valid E-mail address", "error");
}else{Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["g" /* handleFormErrors */])({});__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"user/forgot-password",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({authemail:authEmail})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this3.refs.authemail.value='';__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("",responseJson.message,"success");}});}}},{key:'hide',value:function hide(){var div=document.getElementById("about-us-menu");div.style.display="none";$('.about a:first').css('color','#000000');}},{key:'showhide',value:function showhide(){var div=document.getElementById("about-us-menu");if(div.style.display!=="none"){div.style.display="none";$('.about a:first').css('color','#000000');}else{div.style.display="block";$('.about a:first').css('color','#ff0000');}}},{key:'maskunmask',value:function maskunmask(){if($('#password').attr('type')=='password'){$("#password").attr('type','text');$(".eye_icon").removeClass('unmask');}else{$("#password").attr('type','password');$(".eye_icon").addClass('unmask');}}},{key:'_handleKeyPress',value:function _handleKeyPress(e){if(e.key==="Enter"){this.userLogin();}}},{key:'_handleKeyEnterPress',value:function _handleKeyEnterPress(e){if(e.key==="Enter"){this.userForgotPassword();}}},{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){// flexslider
$('.flexslider').flexslider({animation:"slide",slideshowSpeed:4500,animationDuration:1200,directionNav:false});$('#toggle').click(function(){$('#menu').slideToggle();});$(".landing-page header").sticky({topSpacing:0});},100);}},{key:'render',value:function render(){var _this4=this;var appFullName=__WEBPACK_IMPORTED_MODULE_2__config_Config__["a" /* appFullName */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'head-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/learningroom',title:appFullName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo-361dm.png',alt:appFullName}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{id:'main-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'smoothmenu1',className:'ddsmoothmenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["e" /* onLineUrl */]+'network/'},'Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'institutions/'},'Institutions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'corporates/'},'Corporates')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+__WEBPACK_IMPORTED_MODULE_2__config_Config__["e" /* onLineUrl */]},'Individuals')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'asps/'},'ASPs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'governments/'},'Governments')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/get-app-code.php'},'361DM App')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php'},'Careers'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-rgt-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hd-phn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/phone-icon.png',alt:'',width:'19',height:'19'}),'+91 44 39361361'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-ico'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',id:'toggle',className:'open'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/menu-icon.png',alt:'',width:'19',height:'13'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),' MENU'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'menu',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'our-science.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this4.hide();}},'Our Science')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'our-technology.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this4.hide();}},'Our technology')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+__WEBPACK_IMPORTED_MODULE_2__config_Config__["e" /* onLineUrl */],target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this4.hide();}},'Our Products')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'our-alliances.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this4.hide();}},'Our Alliances')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/get-app-code.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this4.hide();}},'361DM App')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(e){return _this4.showhide();},onMouseOver:function onMouseOver(e){return _this4.showhide();}},'About Us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'about-us-menu',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/company-profile.php',target:'_blank',rel:'noopener noreferrer'},'Company profile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/tech-platform.php',target:'_blank',rel:'noopener noreferrer'},'Tech Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/media-center.php',target:'_blank',rel:'noopener noreferrer'},'Media Centre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/students-corner.php',target:'_blank',rel:'noopener noreferrer'},'Students Corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/alumni.php',target:'_blank',rel:'noopener noreferrer'},'Alumni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php',target:'_blank',rel:'noopener noreferrer'},'Careers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/contact-us.php',target:'_blank',rel:'noopener noreferrer'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/privacy.php',target:'_blank',rel:'noopener noreferrer'},'Privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/terms.php',target:'_blank',rel:'noopener noreferrer'},'Terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/legal.php',target:'_blank',rel:'noopener noreferrer'},'Legal')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_2__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php',target:'_blank',rel:'noopener noreferrer',onMouseOver:function onMouseOver(e){return _this4.hide();}},'Careers')))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexslider loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'slides'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/dm_banner.jpg',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/dm_banner2.jpg',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/dm_banner3.jpg',alt:''})))),!__WEBPACK_IMPORTED_MODULE_4__helpers_User__["e" /* isLoggedIn */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learner-login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-right',id:'loginPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Learner ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'new_learner'},' New learner? ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'reg',title:'Register PIN here',href:'#/register'},'Register PIN here'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'authuser',ref:'authuser',placeholder:'Username',onKeyPress:function onKeyPress(e){return _this4._handleKeyPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'user-ico'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',id:'password',maxLength:'100',name:'authpwd',ref:'authpwd',placeholder:'Password',onKeyPress:function onKeyPress(e){return _this4._handleKeyPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'pwd-ico'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'eye_icon unmask',onClick:function onClick(){return _this4.maskunmask();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Login',title:'Login',onClick:function onClick(){return _this4.userLogin();}}),'\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3__helpers_Common__["z" /* showHide */]("#forgotPanel","#loginPanel");}},'Forgot password?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-right',id:'forgotPanel',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Forgot ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frgt-pwd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'authemail',ref:'authemail',placeholder:'Username',onKeyPress:function onKeyPress(e){return _this4._handleKeyEnterPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'user-ico'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:"both"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Request Password',title:'Request Password',className:'mail-icon',onClick:function onClick(){return _this4.userForgotPassword();}}),'\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_3__helpers_Common__["z" /* showHide */]("#loginPanel","#forgotPanel");}},'Login'),' '))))),__WEBPACK_IMPORTED_MODULE_4__helpers_User__["e" /* isLoggedIn */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{background:'#14a430 none repeat scroll 0 0',borderTop:'5px solid #14a430',padding:'18px',position:'absolute',right:'63px',top:'85px',width:'420px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{color:'white',fontSize:'18px',fontWeight:'bold'},title:'Go to learning room',href:'#/learningroom'},'Go to learning room -->')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'social-ban'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/361dm',title:'Facebook',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/fb-ico.jpg',alt:'Facebook',width:'45',height:'43'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://plus.google.com/s/361DM/top',title:'Google+',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/gplus-ico.jpg',alt:'Google+',width:'45',height:'45'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/361dm',title:'Twitter',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/tw-ico.jpg',alt:'Twitter',width:'45',height:'42'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.linkedin.com/company/361-degree-minds?',target:'_blank',rel:'noopener noreferrer',title:'Linkedin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/in-ico.jpg',alt:'Linkedin',width:'45',height:'46'})))))));}}]);return HomeHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeHeader);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ourservices=function(_Component){_inherits(Ourservices,_Component);function Ourservices(){_classCallCheck(this,Ourservices);return _possibleConstructorReturn(this,(Ourservices.__proto__||Object.getPrototypeOf(Ourservices)).apply(this,arguments));}_createClass(Ourservices,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){//Fancy Box
$(".fancybox").fancybox({autoPlay:true,//  slideshow will start after opening the first gallery item
playSpeed:3000// 3sec pause between changing next item
});$('.fancybox-media').attr('rel','media-gallery').fancybox({openEffect:'none',closeEffect:'none',prevEffect:'none',nextEffect:'none',arrows:false,autoPlay:true,playSpeed:3000,helpers:{media:{},buttons:{}}});},100);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'servies-pad'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Our Biggest driver is our passion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'to explore, craft and delivery what our learners aspire to achieve.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fancybox-media',href:'https://www.youtube.com/embed/hursYeRv8qY?rel=0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/video-img1.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blu-head'},'Craft and delivery'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We enhance classroom learning with precise and realtime value adding knowledge ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Anytime. Anywhere. Any size learning.'))),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fancybox-media',href:'https://www.youtube.com/embed/aUGYpbidoVM?rel=0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/video-img2.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'gld-head'},'Our learners '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We have a passion to automate, digitize and deliver high quality, engaging, learner-centered education solutions. We want to change the way the world LEARNS.')),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fancybox-media',href:'https://youtu.be/1QptxdRMMXA'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/video-img3.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'vio-head'},'Aspire to achieve'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Achieving large access, high excellence by combining modernity with maturity.')),' '))));}}]);return Ourservices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ourservices);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Quotes=function(_Component){_inherits(Quotes,_Component);function Quotes(){_classCallCheck(this,Quotes);return _possibleConstructorReturn(this,(Quotes.__proto__||Object.getPrototypeOf(Quotes)).apply(this,arguments));}_createClass(Quotes,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){//Fancy Box
$(".fancybox").fancybox({autoPlay:true,//  slideshow will start after opening the first gallery item
playSpeed:3000// 3sec pause between changing next item
});$('.fancybox-media').attr('rel','media-gallery').fancybox({openEffect:'none',closeEffect:'none',prevEffect:'none',nextEffect:'none',arrows:false,autoPlay:true,playSpeed:3000,helpers:{media:{},buttons:{}}});},100);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'quote-pad parallax'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote-lft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/quote.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quote-rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'REDESIGN ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'/'),' INNOVATE ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'/'),' ENGAGE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'We believe \u2026 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'effective online learning is more than just a library of ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'recorded videos and some'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'e-books.'),' We constantly redesign and deliver effective courseware, ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'and innovate new ways of engaging with the learners. ')))));}}]);return Quotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Quotes);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var LatestThinking=function(_Component){_inherits(LatestThinking,_Component);function LatestThinking(){_classCallCheck(this,LatestThinking);return _possibleConstructorReturn(this,(LatestThinking.__proto__||Object.getPrototypeOf(LatestThinking)).apply(this,arguments));}_createClass(LatestThinking,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){//Fancy Box
$(".fancybox").fancybox({autoPlay:true,//  slideshow will start after opening the first gallery item
playSpeed:3000// 3sec pause between changing next item
});$('.fancybox-media').attr('rel','media-gallery').fancybox({openEffect:'none',closeEffect:'none',prevEffect:'none',nextEffect:'none',arrows:false,autoPlay:true,playSpeed:3000,helpers:{media:{},buttons:{}}});// Latest Thinking Carousel
var owl=$('#thinking-carousel');owl.owlCarousel({goToFirstSpeed:2000,loop:true,autoplay:true,autoplayTimeout:10000,autoplayHoverPause:true,responsive:{0:{items:1},640:{items:1},768:{items:1},1024:{items:2}},nav:true,dots:false,margin:15});},100);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'latest-thinking'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our Thought Leadership'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We interpret trends in education technology'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'thinking-carousel',className:'owl-carousel owl-loaded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think video'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fancybox-media',href:'https://youtu.be/HBUhKLw1GTI'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/OUUK_361DM_Agreement.jpg',alt:'',className:'video-img'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'vid-name'},'Steve Hill, Director of External Engagement, Open University, UK and P. Ram Mohan, Chairman and Managing Director, 361 Degree Minds exchange copies of their content licence agreement'),' '),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think video'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fancybox-media',href:'https://youtu.be/HBUhKLw1GTI'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/OUUK_361DM_interaction.jpg',alt:'',className:'video-img'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'vid-name'},'Steve Hill, Director of External Engagement, Open University, UK, makes a point at a media interaction in Chennai on Thursday. Others in the picture (Left to Right) are Viren Patel, Director,   University, UK, P. Ram Mohan, CMD, Threesixtyone Degree Minds and C.P. Gopinathan, Co-founder, Threesixtyone Degree Minds'),' '),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Online design course for engineering students'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'Threesixtyone Degree Minds, an online learning platform, is introducing online courses on design. In a press note, the platform stated that the Central government\u2019s proposal to make cities smart required integration of technology. For smart cities to be accessible and friendly, it is imperative that new visitors can make their way without them requiring help. The courses aim to address this lacunae, the release noted. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'The organisation has tied up with the Open University of the United Kingdom to offer two certificate courses \u2014 Design for Engineers and Business Management.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.thehindu.com/news/cities/chennai/online-design-course-for-engineering-students/article17396981.ece',target:'_blank',rel:'noopener noreferrer',className:'think-read'},'Read more'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Is online the way forward?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'Online learning and its pedagogy have to beengineered in a specific manner to meet theaspirations of a range of learners.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'States of Tamil Nadu and Andhra Pradesh see a strange conundrum. While almost all students who complete class XII and all those who can afford to pay, end up getting into some higher education programme, tens of thousands of seats go vacant every year in professional and arts/science colleges in these States. Very few youngsters, who can afford it, choose not to enter college.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.thehindu.com/todays-paper/tp-features/tp-educationplus/is-online-the-way-forward/article7120364.ece',target:'_blank',rel:'noopener noreferrer',className:'think-read'},'Read more'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'The engineering job slowdown has begun, what went wrong and how to fix it'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'With placements dropping by 40-50% this year compared to the last, the signs are clear that the days of bountiful recruitment are waning.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'The academic year 2016-17 is sure to go down as an inflexion point for higher education, particularly for engineering institutions in India.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.thenewsminute.com/article/engineering-job-slowdown-has-begun-what-went-wrong-and-how-fix-it-54105',target:'_blank',rel:'noopener noreferrer',className:'think-read'},'Read more'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'5 Trends That Will Completely Disrupt Indian Higher Education By 2025'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'A first year biology student in college uses a 3D virtual reality equipment to enter the human digestive system. There, he watches food getting digested in the body. Simultaneously, his classmate simulates different circumstances to watch from up close how a drug from a capsule gets metabolised and heals an injury inside a vein.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'justify'}},'Others in class are using simulation and gaming to see how atoms morph into alloys, or how electrons in a liquid get agitated when subjected to thermal radiation.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.huffingtonpost.in/k-ramachandran/5-trends-that-will-completely-disrupt-indian-higher-education-by/?utm_hp_ref=in-homepage',target:'_blank',rel:'noopener noreferrer',className:'think-read'},'Read more'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail our-think'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Degree of empowerment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Learn while you earn is the way forward in India, with many employees looking to add value to their jobs and themselves with online degrees, say experts '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Harvard University\u2019s Kennedy School of Government released an interesting report in October 2016, which had a significant finding.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'According to a research study, online education is increasing access to high quality higher education, at least among those pursuing postgraduate degree.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.dtnext.in/News/TamilNadu/2017/01/05120259/1024863/Degree-of-Empowerment.vpf?Tld=112131',target:'_blank',rel:'noopener noreferrer',className:'think-read'},'Read more'),' ')))));}}]);return LatestThinking;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LatestThinking);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ourtechnology=function(_Component){_inherits(Ourtechnology,_Component);function Ourtechnology(){_classCallCheck(this,Ourtechnology);return _possibleConstructorReturn(this,(Ourtechnology.__proto__||Object.getPrototypeOf(Ourtechnology)).apply(this,arguments));}_createClass(Ourtechnology,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){$(".fancybox").fancybox({autoPlay:true,//  slideshow will start after opening the first gallery item
playSpeed:3000// 3sec pause between changing next item
});$('.fancybox-media').attr('rel','media-gallery').fancybox({openEffect:'none',closeEffect:'none',prevEffect:'none',nextEffect:'none',arrows:false,autoPlay:true,playSpeed:3000,helpers:{media:{},buttons:{}}});},100);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'video-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-lft'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fancybox-media',href:'https://www.youtube.com/embed/SdxoGmqiE9Y'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'361dm_corporate/corporateimg/video-image.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-icon'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-txt-rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-txt-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-ico'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'technology'),' catalyzes new ways ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'of learning. A ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' new  pedagogy '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'is thus emerging.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-txt-btm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'At 361DM, we combine the best of classroom',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'learning experience with the flexibility ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'of online education.')))));}}]);return Ourtechnology;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ourtechnology);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ourmission=function(_Component){_inherits(Ourmission,_Component);function Ourmission(){_classCallCheck(this,Ourmission);return _possibleConstructorReturn(this,(Ourmission.__proto__||Object.getPrototypeOf(Ourmission)).apply(this,arguments));}_createClass(Ourmission,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"our-mission"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"red"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"our-science.php",target:"_blank"},"Our Science")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shadow"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"grn"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"our-technology.php",target:"_blank"}," Our Technology")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shadow"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"orng"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://www.361online.com/",target:"_blank"}," Our Products")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shadow"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"rose"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"our-alliances.php",target:"_blank"}," Our Alliances")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shadow"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mission-txt"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"Our Mission"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"line1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Make learning accessible, affordable for everyone. Anywhere. Anytime. In a wide ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"variety of disciplines"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/rmeta"+'/images/footicon.png',alt:"",className:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"361DM Alumni ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"txt-bold"},"25,000 professionals "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-div icon-div-pad"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/rmeta"+'/images/footicon1.png',alt:"",className:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Corporate Reach ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"txt-bold"},"50+ organizations")," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/rmeta"+'/images/foot_iconnew.png',alt:"",className:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Program Bouquet ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"txt-bold"},"60+ courses")," ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/rmeta"+'/images/degreecertificate1.png',alt:"",className:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Across the Globe",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"txt-bold"},"55+ Cities ")))))));}}]);return Ourmission;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ourmission);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ManagementTeam=function(_Component){_inherits(ManagementTeam,_Component);function ManagementTeam(){_classCallCheck(this,ManagementTeam);return _possibleConstructorReturn(this,(ManagementTeam.__proto__||Object.getPrototypeOf(ManagementTeam)).apply(this,arguments));}_createClass(ManagementTeam,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){// Team Carousel
var owl=$('#team-carousel');owl.owlCarousel({goToFirstSpeed:2500,loop:true,autoplay:true,autoplayTimeout:2000,autoplayHoverPause:true,responsive:{0:{items:1},500:{items:2},768:{items:3},1024:{items:4}},nav:true,dots:false});},100);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'manage-team'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Management Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Our leadership team has deep, rich and varied experience in different areas including academics, corporate leadership and strategic communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'team-carousel',className:'owl-carousel owl-loaded'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/gopi.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'GOPI'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Integrator'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/ram.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Ram'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Business Mind'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/ritu.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Ritu'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Creator'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/terence.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Terence'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Organization Man'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/sai.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Sai Sumanth B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Head \u2013 Enterprise Business'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/krc.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Krish Ramachandran'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Chief Strategy Officer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/suresh.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Suresh K'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Head \u2013 CoE \u2013 Big Data and Analytics'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/jayan.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Jayan N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Chief Marketing Officer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/viswanathan.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'team-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Viswanathan E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Head \u2013 Channels'))))));}}]);return ManagementTeam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManagementTeam);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Ourclients=function(_Component){_inherits(Ourclients,_Component);function Ourclients(){_classCallCheck(this,Ourclients);return _possibleConstructorReturn(this,(Ourclients.__proto__||Object.getPrototypeOf(Ourclients)).apply(this,arguments));}_createClass(Ourclients,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clietns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"our-clients"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"Our Clients"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"line1"})," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"client-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"red"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void();"},"Corporates"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sub-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Astra Zeneca")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Brakes India")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Career Launcher")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Cognizant Technology Solutions ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Covansys (CSC)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"GRO (Zenta)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Kantar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Manhattan Associates")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Nokia Siemens Networks")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Pearl Academy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Redington Foundation")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"SanDisk")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Visteon"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"blue"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void();"},"Colleges"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sub-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Anna Adarsh College for Women")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"B S Abdur Rahman University")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"M A M College of Engineering ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Pearl Academy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Rajalakshmi Engg College")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Rajalakshmi Instt of Technology")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"S A Engineering College")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Sri Ramakrishna Mission Vidyalaya"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"orng"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void();"}," Institutions "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sub-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"L V Prasad Eye Institute ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Sankara Nethralaya "))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",target:"_blank"}," ASPs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sub-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Career Launcher")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"CSC"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"grn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void();"}," Government"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sub-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#"},"Election Commission of India"))))))));}}]);return Ourclients;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Ourclients);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Homefooter=function(_Component){_inherits(Homefooter,_Component);function Homefooter(){_classCallCheck(this,Homefooter);return _possibleConstructorReturn(this,(Homefooter.__proto__||Object.getPrototypeOf(Homefooter)).apply(this,arguments));}_createClass(Homefooter,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-btm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1st Floor, 10-Sathya Gardens, Kamarajar Nagar, 80-feet Road, Saligramam, Chennai \u2013 600093, Tamil Nadu, INDIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Mobile : +91 9176679710  -  Phone : +91 44-39361361  -  Email : info@361dm.com - Courses site : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]},' www.361online.com'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["e" /* onLineUrl */]+'network/'},'Partners')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'institutions/'},'Institutions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'corporates/'},'Corporates')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'asps/'},'ASPs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'governments/'},'Governments')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/get-app-code.php'},'361DM App')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php'},'Careers'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'about-us'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void();'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'About Us :'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/company-profile.php',target:'_blank',rel:'noopener noreferrer'},'Company profile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/tech-platform.php',target:'_blank',rel:'noopener noreferrer'},'Tech Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/media-center.php',target:'_blank',rel:'noopener noreferrer'},'Media Centre')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/alumni.php',target:'_blank',rel:'noopener noreferrer'},'Alumni')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/careers.php',target:'_blank',rel:'noopener noreferrer'},'Careers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/contact-us.php',target:'_blank',rel:'noopener noreferrer'},'Contact Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/privacy.php',target:'_blank',rel:'noopener noreferrer'},'Privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/terms.php',target:'_blank',rel:'noopener noreferrer'},'Terms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'about-us/legal.php',target:'_blank',rel:'noopener noreferrer'},'Legal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-social'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-social-ico'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/361dm',title:'Facebook',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/foo-fb-ico.png',alt:'Facebook',width:'32',height:'32'})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://plus.google.com/s/361DM/top',title:'Google+',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/foo-gplus-ico.png',alt:'Google+',width:'32',height:'32'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/361dm',title:'Twitter',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/foo-tw-ico.png',alt:'Twitter',width:'32',height:'32'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.linkedin.com/company/361-degree-minds?',title:'Linkedin',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/foo-in-ico.png',alt:'Linkedin',width:'32',height:'32'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'copyright'},'Copyright \xA9 2017 361Degree Minds Consulting Pvt Ltd'))));}}]);return Homefooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Homefooter);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_inboxAction__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_profileAction__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_DmWall__ = __webpack_require__(208);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Header=function(_React$Component){_inherits(Header,_React$Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={lr_pho:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/avathar.gif',className:'user-photo',width:'50'}),message:0,fnHideCorporateIDs:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('fnHideCorporateIDs',true)};_this.props.getInbox();_this.props.getProfile();return _this;}_createClass(Header,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.profile.corp!=undefined){this.setState({message:nextProps.message,lr_pho:nextProps.profile.corp.photo==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/avathar.gif',className:'user-photo',width:'50'}):nextProps.profile.corp.photo});}}},{key:'userLogin',value:function userLogin(e){var _this2=this;e.stopPropagation();var selname=e.target.value;var selectedIndex=e.target.options.selectedIndex;var password=e.target.options[selectedIndex].getAttribute('data-key');var expired=e.target.options[selectedIndex].getAttribute('expired');if(expired==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Note!',"Sorry You'r login has expired",'info');return false;}var authUser=selname;//var authPwd = "melanoleuca";
var authPwd="";if(password!==""){authPwd=password;}else{authPwd="Vaccinium55x23";}if(authUser.trim()===""||authPwd.trim()===""){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["g" /* handleFormErrors */])({'authpwd':"Please enter your username and password"});//Common.message("Validation error occurred.", "Please enter your username and password", "error");
}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["g" /* handleFormErrors */])({});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["k" /* isMatchesEmail */])(authUser)){fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/login",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({authuser:authUser,authpwd:authPwd})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status===0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{//Common.setUserData("user", JSON.stringify(responseJson.data));
try{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["x" /* setTokenData */]("token",responseJson.token);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["y" /* setUserData */]("isLoggedIn",true);var date=new Date();date.setSeconds(date.getSeconds()+__WEBPACK_IMPORTED_MODULE_1__config_Config__["j" /* sessExpire */]);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["y" /* setUserData */]("sessMax",date.getTime());var decodeJson=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["r" /* parseJwt */](responseJson.token);setTimeout(function(){if(decodeJson.beforeRoutes.length>0){window.location.reload();//this.props.router.push(decodeJson.beforeRoutes[0].url);
}else if(decodeJson.afterRoutes.length>0){_this2.props.router.push(decodeJson.afterRoutes[0].url);}else{//this.props.router.push(decodeJson.routePath);
window.location.reload();}},500);}catch(e){alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');_this2.props.router.goBack();}}});}else{fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"imeta/includes/metaajax_control.php?q=metalogin&name="+authUser+"&pword="+authPwd,{method:"GET"}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson==="Sucess"){window.location.href=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"home.php";}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("Validation error occurred.","Username (or) password incorrect.","error");}});}}}},{key:'userLogout',value:function userLogout(){var productid_forredirect=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('productID',true);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/logout",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status!=0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */])();//window.location.href = window.location + "/#/login";
if(productid_forredirect==429||productid_forredirect==430){window.location.assign("https://www.361dm.com/kluniversity.php");}else if(productid_forredirect===422){window.location.assign("https://www.361dm.com/gndu.php");}else{window.location=window.location.origin;}}});}},{key:'getLearnerWall',value:function getLearnerWall(){document.body.className='dm-wall-open';this.refs.dmwall.loadWallData();}},{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["j" /* headerLoad */])();$(".fancybox").fancybox({'href':'#poup-txt4',afterClose:function afterClose(){document.body.className=document.body.className.replace("dm-wall-open","");}});$(".popup").hide();},100);}},{key:'switchPanel',value:function switchPanel(){$(".leftposstatic").css('display','block');this.props.switchPanel();}},{key:'menuHandleChange',value:function menuHandleChange(type){this.props.menuClick(type);}},{key:'goToHome',value:function goToHome(){window.location.reload(true);}},{key:'render',value:function render(){var _this3=this;var messages=this.state.message;var productName=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('productName',true);var productid=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('productID',true);var corporateID=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('corporateID',true);var product_logo=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('product_logo',true);var tech_logo=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('tchnology_partnerlogo',true);var multiple_product=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('multiple_product',true);var checkif_loginexpired=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('chk_ifanyissuein_login',true);var multiple_usernames=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('multiple_usernames',true);var username=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('primaryEmail',true);var badge=messages!=0?"badge1":"";var d=new Date();var jDate=d.getDate();var jMonth=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["p" /* monthNames */][d.getMonth()];var jYear=d.getFullYear();var is_careerlauncher=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('is_careerlauncher',true);var styles={marginLeft:'208px'};var key="key";//console.log(multiple_usernames);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerwhite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'fixed-head'},username=='rkarthikhrm@361dm.com'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('marquee',{direction:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'lr-title'},'Please visit library for information regarding free courses')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this3.goToHome();},href:'javascript:void(0);'},tech_logo==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/upload_images/'+tech_logo,alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122'}))),product_logo==''?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/upload_images/'+product_logo,alt:'361\xB0minds\u2122',height:'60',style:styles,title:'IDIADA-HR'}),' ')),this.state.fnHideCorporateIDs===false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,!is_careerlauncher&&productid!=418&&productid!=419&&corporateID!=77&&corporateID!=93?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'wall',onClick:function onClick(){return _this3.getLearnerWall();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:'361dm wall',className:'fancybox show'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'361dm'),'wall')):'',corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'program'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/pgm-icon.png',alt:'Program',title:'Program',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hover-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pgm-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,productName))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,jDate),' ',jMonth),!is_careerlauncher&&productid!=418&&productid!=419&&corporateID!=77&&corporateID!=93?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:"message "+badge,'data-badge':this.state.message!=0?this.state.message:'',onClick:function onClick(e){return _this3.menuHandleChange('messages');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-message.png',alt:'Message',title:'Message',border:'0'}),' ')):'',corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.state.lr_pho}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hover-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'usr-name'},' ',Object(__WEBPACK_IMPORTED_MODULE_4__helpers_User__["b" /* Username */])())):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'others'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/other-lnks.png',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.goToHome();}},'Home')):'',!is_careerlauncher&&corporateID!=77&&corporateID!=93?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.menuHandleChange('my_profile');}},'My Profile')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.userLogout(e);}},'Logout')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'poup-txt4',className:'popup',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_DmWall__["a" /* default */],{ref:'dmwall',autoload:false})));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state,ownProps){return{message:state.inbox.unread,profile:state.profile};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({getInbox:__WEBPACK_IMPORTED_MODULE_7__actions_inboxAction__["a" /* getInbox */],getProfile:__WEBPACK_IMPORTED_MODULE_8__actions_profileAction__["a" /* getProfile */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Header));

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Tinyscroll__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Left=function(_React$Component){_inherits(Left,_React$Component);function Left(props){_classCallCheck(this,Left);var _this=_possibleConstructorReturn(this,(Left.__proto__||Object.getPrototypeOf(Left)).call(this,props));_this.state={learningroom:[],modular_path:[],modular_lrs:[],is_guided_path:'',is_modular_path:'',display_order:''};return _this;}_createClass(Left,[{key:'switchComponentPanel',value:function switchComponentPanel(type,lr_id,dlr_id,prerequisite_status){if(prerequisite_status=='1'){this.props.onClick(type,lr_id,dlr_id);}else{__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["o" /* message */]('Note!',prerequisite_status,'info');}}},{key:'getLearningRoom',value:function getLearningRoom(){if(!__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["l" /* isAccordionInit */]()){__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["A" /* showLargeLeftMenu */]();__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["F" /* winResize */]();__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["f" /* ddaccordionInIt */](this.props.leftMenuType);__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["C" /* showconleft */]();__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["E" /* updateScrollLeft */]();__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["v" /* reactLoaderk */]("hide");}}},{key:'modulefunction',value:function modulefunction(lr_id){var _this2=this;var strv=this.state.modular_lrs[lr_id].map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'strv_'+index,id:'md'+key.lr_id,className:'mlr_'+key.lr_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'amod'+key.lr_id,onClick:function onClick(e){return _this2.switchComponentPanel('componet_list',key.lr_id,key.dlr_id,key.prerequisite_status);},href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'},key.lr_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:key.lr_status}))));});return strv;}},{key:'modulefunctionres',value:function modulefunctionres(lr_id){var _this3=this;var strv=this.state.modular_lrs[lr_id].map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'mods_'+index,id:'mds'+key.lr_id,className:'mrlr_'+key.lr_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'amods'+key.lr_id,onClick:function onClick(e){return _this3.switchComponentPanel('componet_list',key.lr_id,key.dlr_id,key.prerequisite_status);},href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'})));});return strv;}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["v" /* reactLoaderk */]("show","please wait...");this.props.getLearningRoom();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this4=this;this.setState({learningroom:nextProps.learningRoom.lr_list,modular_path:nextProps.learningRoom.modular_path,modular_lrs:nextProps.learningRoom.modular_lrs,is_guided_path:nextProps.learningRoom.is_have_guided_path,is_modular_path:nextProps.learningRoom.is_have_modular_path,display_order:nextProps.learningRoom.guided_modular_display_order});setTimeout(function(){_this4.getLearningRoom();},100);}},{key:'render',value:function render(){var _this5=this;var lr_count=0,modul_lr_count=0;var lr_rooms=this.state.learningroom.map(function(key,index){var lid=key.lr_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'lr_rooms_'+index,id:"lr"+key.lr_id,className:"lr"+key.lr_id+" "+key.style_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this5.switchComponentPanel('componet_list',key.lr_id,key.dlr_id,key.prerequisite_status);},href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'},key.lr_name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:key.lr_status}))));});var lr_rooms_response=this.state.learningroom.map(function(key,index){var lid=key.lr_id;lr_count=index+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'lr_rooms_response_'+index,id:"lr"+key.lr_id,className:'lr'+key.lr_id+' '+key.style_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this5.switchComponentPanel('componet_list',key.lr_id,key.dlr_id,key.prerequisite_status);},href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},lr_count)));});var module_dlrooms=Object.keys(this.state.modular_path).map(function(mk,index){var modu=_this5.state.modular_path[mk],mid=modu.module_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'module_dlrooms_'+index,id:modu.module_name,className:'modularcs '+modu.style_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'},modu.module_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this5.modulefunction(mid)));});var module_dlrooms_response=Object.keys(this.state.modular_path).map(function(mk,index){var modu=_this5.state.modular_path[mk],mid=modu.module_id;modul_lr_count=index+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'module_dlrooms_response_'+index,id:modu.module_name,className:'modularcs '+modu.style_class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this5.modulefunctionres(mid)));});var smallGuidedMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:'Guided Path',alt:'Guided Path',className:'guide lr-small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'lr-wise-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-left',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport viewport2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview guided_path'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,lr_rooms_response))))));var smallModularMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:'Modular Path',alt:'Modular Path',className:'module module-small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'module-wise-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-left1',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise',className:'overview guided_path'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,module_dlrooms_response))))));var largeGuidedMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:'Guided Path',alt:'Guided Path',className:'guide lr-big'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Guided Path ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub'},'Recommended learning sequence')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'lr-wise-big'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview guided_path'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,lr_rooms)))));var largeModularMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:'Modular Path',alt:'Modular Path',className:'module module-big'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Learning Modules ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub'},'Topic-wise components')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'module-wise-big'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise',className:'overview guided_path'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,module_dlrooms)))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leftposstatic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'toggle-left',className:'toggle-left toggle-left-mbl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'leftmenuarrow',className:'showconleft openarrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applemenu menusmall',id:'menusmall',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'toggle-left',className:'toggle-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'leftmenuarrow',className:'showconleft closearrow'})),this.state.display_order===1&&this.state.is_guided_path===1&&smallGuidedMenu,this.state.is_modular_path===1&&smallModularMenu,this.state.display_order===2&&this.state.is_guided_path===1&&smallGuidedMenu),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'leftnavsec',className:'left-nav',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'toggle-left',className:'toggle-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'leftmenuarrow',className:'showconleft openarrow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applemenu',id:'menularge'},this.state.display_order===1&&this.state.is_guided_path===1&&largeGuidedMenu,this.state.is_modular_path===1&&largeModularMenu,this.state.display_order===2&&this.state.is_guided_path===1&&largeGuidedMenu)));}}]);return Left;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state,ownProps){return{learningRoom:state.learningRoom};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_4__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Left));

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var jQuery=window.jQuery;var Tinyscroll=function(_Component){_inherits(Tinyscroll,_Component);function Tinyscroll(){_classCallCheck(this,Tinyscroll);return _possibleConstructorReturn(this,(Tinyscroll.__proto__||Object.getPrototypeOf(Tinyscroll)).apply(this,arguments));}_createClass(Tinyscroll,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var timer_count=500;if(nextProps.count>0){timer_count=parseInt(nextProps.count)*10;}Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */])("show","Please wait...");setTimeout(function(){var $scrollbar=jQuery('#'+nextProps.selector).tinyscrollbar();var scrollbarUpdate=$scrollbar.data("plugin_tinyscrollbar");if(scrollbarUpdate){scrollbarUpdate.update('relative');}var self=nextProps;jQuery(document).on('click','#module-wise a',function(){var $scrollbar=jQuery('#'+self.selector).tinyscrollbar();var scrollbarUpdate=$scrollbar.data("plugin_tinyscrollbar");var $scrollbarContent=jQuery('#semana-scroll').tinyscrollbar();if(scrollbarUpdate){scrollbarUpdate.update('relative');}var scrollbarContent=$scrollbarContent.data("plugin_tinyscrollbar");if(scrollbarContent){scrollbarContent.update('relative');}});jQuery(document).on('click','#leftmenuarrow',function(){var $scrollbar=jQuery('#'+self.selector).tinyscrollbar();var scrollbarUpdate=$scrollbar.data("plugin_tinyscrollbar");if(scrollbarUpdate){scrollbarUpdate.update('relative');}});Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */])("hide");},timer_count);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:this.props.selector,className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),this.props.children);}}]);return Tinyscroll;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Tinyscroll);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lr_dlr_components_grid_partials_RecordPlayer__ = __webpack_require__(209);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var Rqulinks=function(_Component){_inherits(Rqulinks,_Component);function Rqulinks(props){_classCallCheck(this,Rqulinks);var _this=_possibleConstructorReturn(this,(Rqulinks.__proto__||Object.getPrototypeOf(Rqulinks)).call(this,props));_this.state={message:__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("No_msg",true)};return _this;}_createClass(Rqulinks,[{key:'fnqlinksSlide1',value:function fnqlinksSlide1(e){//console.log(e.target);
if($(e.target).parent().hasClass('opened')){$(e.target).parent().removeClass('opened');}else{$('aside').each(function(){$(this).removeClass('opened');});$(e.target).parent().addClass('opened');}}},{key:'switchPanel',value:function switchPanel(type){var corpCode=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('corpCode',true);if(corpCode=='Dem'){return false;}else{this.props.switchPanel(type);}}},{key:'getStatus',value:function getStatus(e){var status=e.target.value;var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);this.props.setStatusUpdate(status);fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'user/buddystatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,status:status})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["y" /* setUserData */]("statusBuddyChat",responseJson.bstatus,true);__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();}});}},{key:'updateMessage',value:function updateMessage(new_msg){if(new_msg!=''){this.setState({message:new_msg});}}},{key:'componentDidMount',value:function componentDidMount(){if(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('todayschuduledlr',true)!=false){setTimeout(function(){$(".slide6").addClass("opened");},2000);}}},{key:'render',value:function render(){var _this2=this;// let messages = this.state.message;
// let lib_count = Common.getUserData("count_lib", true);
// let opinion_polls_count = (Common.getUserData("opinion_polls_count", true)!=false)? Common.getUserData("opinion_polls_count", true):0;
var chat=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("chat",true);var mentor=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("mentor",true);var snappoll=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('snapPollReport',true);var memberChat=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('memberChat',true);var teleCall=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('teleCall',true);var library=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('library',true);var blog=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('blog',true);var collabrate=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('collabrate',true);var radio=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('radio',true);var poll=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('poll',true);var forum=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('forum',true);var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('productID',true);var recorder=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('recorder',true);var corporateID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('corporateID',true);var courseware_count=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('courseware_count',true);var corp_array=['33','36','44','45','51','52'];var completedStatus=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("completedStatus",true)!=false?__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("completedStatus",true):0;var corpCode=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('corpCode',true);var title_course='';var todayschuduledlr=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('todayschuduledlr',true)!=false?__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('todayschuduledlr',true):0;if(jQuery.inArray(corporateID,corp_array)>=0){title_course='Reference Material';}else{title_course='Courseware';}var productid=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('productID',true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'qlinks1'},radio!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'slide-out slide5',alt:'Radio',title:'Radio',onClick:function onClick(e){return _this2.switchPanel('radio');},href:'javascript:void(0)'},'.'):'',todayschuduledlr!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide6'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'recordicon',alt:'Today Schedule DLR',title:'Today Schedule DLR',onClick:function onClick(e){return _this2.fnqlinksSlide1(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Today Schedule DLR\'s'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recorder-slide vid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'vid-sch'},todayschuduledlr.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:i%2==0?'schduleone':'schduletwo',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:item.url},' DLR - ',item.dlrname,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));})))):'',recorder!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide4'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'recordicon',alt:'Record Audio and Replay',title:'Record Audio and Replay',onClick:function onClick(e){return _this2.fnqlinksSlide1(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Record'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recorder-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lr_dlr_components_grid_partials_RecordPlayer__["a" /* default */],null))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out support'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'support-ico  ',alt:'Learning Records',title:'Learning Records',onClick:function onClick(e){return _this2.fnqlinksSlide1(e);}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Learning Records'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'rightslide-img',src:"/rmeta"+'/images/learning-record-img.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'leftul'},productID!=359&&productID!=358&&productID!=230&&productID!=248?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can review your learning journey in the program as of current date. \nSorry, access to this link is restricted for this demo.');",onClick:radio!=false?function(e){return _this2.switchPanel('my_journey_demo');}:function(e){return _this2.switchPanel('my_journey');},title:'You can review your learning journey in the program as of current date.'},'My Journey')):'',productID!=230?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.\nSorry, access to this link is restricted for this demo.');",onClick:radio!=false?function(e){return _this2.switchPanel('my_performance_demo');}:function(e){return _this2.switchPanel('my_performance');},title:'You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.'},'My Performance')):'',productid!=418&&productid!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('This is your personal Diary that contains all your notes and all the work you have done inside Learning Room. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('my_diary');},title:'This is your personal Diary that contains all your notes and all the work you have done inside Learning Room.'},'My Diary')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'rightul'},productid!=418&&productid!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('When you log into the program after long gap, the system automatically takes you through the recap of work you had done till now. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('recap');},title:'When you log into the program after long gap, the system automatically takes you through the recap of work you had done till now.'},'Recap')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('login_history');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('View the number of times you logged in, at what times of the day, between any two dates… use it as a tool for “proactive planning”. \nSorry, access to this link is restricted for this demo.');",title:'View the number of times you logged in, at what times of the day, between any two dates? use it as a tool for ?proactive planning?.'},'Login History')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide1'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handle1 ',alt:'Personal Interactions',title:'Personal Interactions',onClick:function onClick(e){return _this2.fnqlinksSlide1(e);}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Personal Interactions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'rightslide-img',src:"/rmeta"+'/images/personal-tntraction-img.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'leftul'},mentor!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Observers');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('Observers are people known to you, who would observe you during the course of program, and give you feedback. \nSorry, access to this link is restricted for this demo.');",title:'Observers are people known to you, who would observe you during the course of program, and give you feedback.'},'My Observers')):'',completedStatus==0&&productid!=418&&productid!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('ecoach');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('Send questions to your E Coach, view the E Coach’s feedback on your work, rate the E Coach’s feedback, and dig into the FAQs pool. \nSorry, access to this link is restricted for this demo.');",title:'Send questions to your E Coach, view the E Coach?s feedback on your work, rate the E Coach?s feedback, and dig into the FAQs pool.'},'Ask E Coach')):'',productid!=418&&productid!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('messages');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('This is your personal Message box. You can send and receive messages from your Observers and E Coach. \nSorry, access to this link is restricted for this demo.');",title:'This is your personal Message box. You can send and receive messages from your Observers and E Coach.'},'Messages ')):'',completedStatus==0&&chat!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('chat_request');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can request for a chat with your E Coach. \nSorry, access to this link is restricted for this demo.');",title:'You can request for a chat with your E Coach.'},'E Coach Chat Request')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'rightul'},completedStatus==0&&memberChat!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'block',border:'1px solid #f3f8fe'}},corpCode=='Dem'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'buddyDemLinkdiv',style:{display:'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:alert(\'You can view currently logged in program batch mates, and chat with them. \\nSorry, access to this link is restricted for this demo.\');',style:{float:'left'},id:'buddychat',name:'buddychat'},'Buddy Chat')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'buddyLinkdiv',style:{display:'block'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/buddychat',target:'_blank',title:'You can view currently logged in program batch mates, and chat with them.',style:{float:'left'},id:'buddychat',name:'buddychat'},'Buddy Chat'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'statusforms',id:'statusforms'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'cmbStatus',id:'cmbStatus',style:{fontSize:'11px',width:'70px',padding:'0px',margin:'0 0 0 5px'},value:this.props.statusBuddyChat,onChange:function onChange(e){return _this2.getStatus(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Online'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Busy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'Invisible'))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Techsupport');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can send your technology related queries to our Technology Support Desk, and get your issues resolved. \nSorry, access to this link is restricted for this demo.');",title:'You can send your technology related queries to our Technology Support Desk, and get your issues resolved.',style:{display:'block'}},'Technology Support Desk')),completedStatus==0&&snappoll!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Seekfeedback');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('Any time during the program, you can create your own feedback forms, and send it to your peers and observers, for their feedback or opinion on an area of improvement in you. \nSorry, access to this link is restricted for this demo');",className:'snap_polls',title:'Any time during the program, you can create your own feedback forms, and send it to your peers and observers, for their feedback or opinion on an area of improvement in you.'},'I Seek Feedback '),' '):'',completedStatus==0&&teleCall!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Telecall');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can request for a tele call from your E Coach. \nSorry, access to this link is restricted for this demo.');",title:'You can request for a tele call from your E Coach.'},' Telecalls Request '),' '):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide2'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handle1 ',alt:'Learning Resources',title:'Learning Resources',onClick:function onClick(e){return _this2.fnqlinksSlide1(e);}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Learning Resources'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'rightslide-img',src:"/rmeta"+'/images/learning-resource-img.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'leftul'},library!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('library');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can Read through, Refer to, and Download relevant material, like articles, research papers in the library. \nSorry, access to this link is restricted for this demo.');",title:'You can Read through, Refer to, and Download relevant material, like articles, research papers in the library.'},'Library'),' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'rightul'},productID!=''&&courseware_count>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('courseware');},href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You can . \nSorry, access to this link is restricted for this demo.');",title:'Study material as per the curriculum'},title_course),' '):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',{className:'slide-out slide3'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'handle1 ',alt:'Group Interactions',title:'Group Interactions',onClick:function onClick(e){return _this2.fnqlinksSlide1(e);}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Group Interactions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/grop-intraction-img.jpg',align:'texttop',alt:'',border:'0',className:'rightslide-img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'leftul'},poll!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('opinion_poll');},title:'You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results.'},'Opinion Polls'),' '):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'rightul'},collabrate!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!='Dem'?"javascript:void(0);":"javascript:alert('Collabration.');",onClick:function onClick(e){return _this2.switchPanel('collaborate');},title:'Collabration.'},'Collaborate')):'')));}}]);return Rqulinks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Rqulinks);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__qlink_partials_NoticeBoard__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__qlink_partials_NewPost__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__qlink_partials_DoyouKnow__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__qlink_partials_SupportDesk__ = __webpack_require__(213);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Qlinks=function(_Component){_inherits(Qlinks,_Component);function Qlinks(props){_classCallCheck(this,Qlinks);var _this=_possibleConstructorReturn(this,(Qlinks.__proto__||Object.getPrototypeOf(Qlinks)).call(this,props));_this.redirect=_this.redirect.bind(_this);return _this;}_createClass(Qlinks,[{key:'redirect',value:function redirect(type){this.props.switchPanel(type);}},{key:'render',value:function render(){var is_careerlauncher=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */])('is_careerlauncher',true);var productid=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */])('productID',true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'qlinks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__qlink_partials_SupportDesk__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__qlink_partials_NoticeBoard__["a" /* default */],null),!is_careerlauncher&&productid!=418&&productid!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__qlink_partials_DoyouKnow__["a" /* default */],null)):'',!is_careerlauncher&&productid!=418&&productid!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__qlink_partials_NewPost__["a" /* default */],{redirectprops:this.redirect})):'');}}]);return Qlinks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Qlinks);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var jQuery=window.jQuery;var Contbtm=function(_Component){_inherits(Contbtm,_Component);function Contbtm(props){_classCallCheck(this,Contbtm);var _this=_possibleConstructorReturn(this,(Contbtm.__proto__||Object.getPrototypeOf(Contbtm)).call(this,props));_this.state={message:__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("No_msg",true),opinion_polls_count:__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("opinion_polls_count",true)!==false?__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("opinion_polls_count",true):0,fnHideCorporateIDs:__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('fnHideCorporateIDs',true)};return _this;}_createClass(Contbtm,[{key:'componentDidMount',value:function componentDidMount(){jQuery('.tab-close').click(function(e){jQuery(this).parent().slideUp();jQuery(this).parent().parent().find("a").removeClass('act-tab');});this.state.fnHideCorporateIDs?jQuery('.snap_polls').addClass('seek_class'):'';this.state.fnHideCorporateIDs?jQuery('.tele').addClass('telecall_class'):'';}},{key:'switchPanel',value:function switchPanel(type){var corpCode=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('corpCode',true);if(corpCode==='Dem'){return false;}else{this.props.switchPanel(type);}}},{key:'updateMessage',value:function updateMessage(new_msg){if(new_msg!==''){this.setState({message:new_msg});}}},{key:'getStatus',value:function getStatus(e){var status=e.target.value;var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);this.props.setStatusUpdate(status);fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'user/buddystatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,status:status})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!==0){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["y" /* setUserData */]("statusBuddyChat",responseJson.bstatus,true);__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();}});}},{key:'updateOpinion',value:function updateOpinion(count_poll){if(count_poll!==''){this.setState({opinion_polls_count:count_poll});}}},{key:'render',value:function render(){var _this2=this;// let messages = this.state.message;
// alert(Common.getUserData("statusBuddyChat", true));
// let lib_count = Common.getUserData("count_lib", true);
var chat=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("chat",true);var faculty_chat=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("faculty_chat",true);var mentor=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("mentor",true);var snappoll=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('snapPollReport',true);var memberChat=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('memberChat',true);var teleCall=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('teleCall',true);var library=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('library',true);var blog=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('blog',true);var poll=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('poll',true);var forum=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('forum',true);var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('productID',true);var corporateID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('corporateID',true);var courseware_count=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('courseware_count',true);var collabrate=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('collabrate',true);var radio=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('radio',true);var corp_array=['33','36','44','45','51','52'];var completedStatus=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("completedStatus",true)!==false?__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("completedStatus",true):0;var corpCode=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('corpCode',true);var title_course='';var enc_id=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('enc_learner_id',true);if(jQuery.inArray(corporateID,corp_array)>=0){title_course='Reference Material';}else{title_course='Courseware';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'contfoot',className:'cont-btm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'learning '},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cntbtm',alt:'Learning Records',title:'Learning Records'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),'Learning Records'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-popup',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Learning Records'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'popup-img',src:"/rmeta"+'/images/learning-record-img.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,productID!=359&&productID!=358&&productID!=230&&productID!=248?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can review your learning journey in the program as of current date. \nSorry, access to this link is restricted for this demo.');",onClick:radio!==false?function(e){return _this2.switchPanel('my_journey_demo');}:function(e){return _this2.switchPanel('my_journey');},title:'You can review your learning journey in the program as of current date.'},'My Journey')):'',productID!=230?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.\nSorry, access to this link is restricted for this demo.');",onClick:radio!==false?function(e){return _this2.switchPanel('my_performance_demo');}:function(e){return _this2.switchPanel('my_performance');},title:'You can view your performance and timeliness graphs. You can also look at where you currently stand against global benchmarks, in percentiles.'},'My Performance')):'',productID!==418&&productID!==419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('This is your personal Diary that contains all your notes and all the work you have done inside Learning Room. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('my_diary');},title:'This is your personal Diary that contains all your notes and all the work you have done inside Learning Room.'},'My Diary')):'',productID!==418&&productID!==419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('When you log into the program after long gap, the system automatically takes you through the recap of work you had done till now. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('recap');},title:'When you log into the program after long gap, the system automatically takes you through the recap of work you had done till now.'},'Recap')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('login_history');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('View the number of times you logged in, at what times of the day, between any two dates… use it as a tool for “proactive planning”. \nSorry, access to this link is restricted for this demo.');",title:'View the number of times you logged in, at what times of the day, between any two dates? use it as a tool for ?proactive planning?.'},'Login History'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'down-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-close'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'personal'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cntbtm',alt:'Personal Interactions',title:'Personal Interactions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),'Personal Interactions'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Personal Interactions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'popup-img',src:"/rmeta"+'/images/personal-tntraction-img.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,mentor!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Observers');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('Observers are people known to you, who would observe you during the course of program, and give you feedback. \nSorry, access to this link is restricted for this demo.');",title:'Observers are people known to you, who would observe you during the course of program, and give you feedback.'},'My Observers')):'',completedStatus===0&&productID!==418&&productID!==419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('Send questions to your E Coach, view the E Coach’s feedback on your work, rate the E Coach’s feedback, and dig into the FAQs pool. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('ecoach');},title:'Send questions to your E Coach, view the E Coach?s feedback on your work, rate the E Coach?s feedback, and dig into the FAQs pool.'},'Ask E Coach')):'',this.state.fnHideCorporateIDs===false&&productID!==418&&productID!==419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('messages');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('This is your personal Message box. You can send and receive messages from your Observers and E Coach. \nSorry, access to this link is restricted for this demo.');",title:'This is your personal Message box. You can send and receive messages from your Observers and E Coach.'},'Messages ')):'',completedStatus===0&&chat!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('chat_request');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can request for a chat with your E Coach. \nSorry, access to this link is restricted for this demo.');",title:'You can request for a chat with your E Coach.'},'E Coach Chat Request')):'',completedStatus===0&&memberChat!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,corpCode==='Dem'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'buddyDemLinkdiv',style:{display:'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:alert(\'You can view currently logged in program batch mates, and chat with them. \\nSorry, access to this link is restricted for this demo.\');void(0);',style:{float:'left',width:'43%'},id:'buddychat',name:'buddychat'},'Buddy Chat')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'buddyLinkdiv',style:{display:'block'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/buddychat',target:'_blank',title:'You can view currently logged in program batch mates, and chat with them.',style:{float:'left',width:'43%'},id:'buddychat',name:'buddychat'},'Buddy Chat'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'statusforms',id:'statusforms'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'cmbStatus',id:'cmbStatus',value:this.props.statusBuddyChat,style:{fontSize:'11px',width:'70px',padding:'0px',margin:'0 0 0 5px'},onChange:function onChange(e){return _this2.getStatus(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Online'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Busy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'Invisible'))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Techsupport');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can send your technology related queries to our Technology Support Desk, and get your issues resolved. \nSorry, access to this link is restricted for this demo.');",title:'You can send your technology related queries to our Technology Support Desk, and get your issues resolved.',style:{display:'block'}},'Technology Support Desk')),completedStatus===0&&snappoll!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'snap_polls'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Seekfeedback');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('Any time during the program, you can create your own feedback forms, and send it to your peers and observers, for their feedback or opinion on an area of improvement in you. \nSorry, access to this link is restricted for this demo');",title:'Any time during the program, you can create your own feedback forms, and send it to your peers and observers, for their feedback or opinion on an area of improvement in you.'},'I Seek Feedback '),' '):'',completedStatus===0&&teleCall!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'tele'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('Telecall');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can request for a tele call from your E Coach. \nSorry, access to this link is restricted for this demo.');",title:'You can request for a tele call from your E Coach.'},' Telecalls Request ')):'',faculty_chat!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'faculty_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://beta.361dm.com/group_chat/chat?id='+enc_id,target:'_blank'},'Faculty Chat')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'down-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-close'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'resources'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{alt:'Learning Resources',title:'Learning Resources',className:'cntbtm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),'Learning Resources'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shadow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Learning Resources'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/learning-resource-img.jpg',className:'popup-img',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,library!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{borderBottom:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('library');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can Read through, Refer to, and Download relevant material, like articles, research papers in the library. \nSorry, access to this link is restricted for this demo.');",title:'You can Read through, Refer to, and Download relevant material, like articles, research papers in the library.'},'Library')):'',productID!==''&&courseware_count>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchPanel('courseware');},href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You can . \nSorry, access to this link is restricted for this demo.');",title:'Study material as per the curriculum'},title_course)):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'down-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-close'}))),this.state.fnHideCorporateIDs===false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'group-intraction'},corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cntbtm',alt:'Group Interactions',title:'Group Interactions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),'Group Interactions'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Group Interactions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'popup-img',src:"/rmeta"+'/images/grop-intraction-img.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,poll!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{borderBottom:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results. \nSorry, access to this link is restricted for this demo.');",onClick:function onClick(e){return _this2.switchPanel('opinion_poll');},title:'You will participate in general opinion polls initiated by us on current issues, and will be able to view the overall opinion results.'},'Opinion Polls')):'',collabrate!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:corpCode!=='Dem'?"javascript:void(0);":"javascript:alert('Collabration.');",onClick:function onClick(e){return _this2.switchPanel('collaborate');},title:'Collabration.'},'Collaborate')):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'down-arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-close'})))));}}]);return Contbtm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Contbtm);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var win=window;var Highcharts=function(_Component){_inherits(Highcharts,_Component);function Highcharts(props){_classCallCheck(this,Highcharts);return _possibleConstructorReturn(this,(Highcharts.__proto__||Object.getPrototypeOf(Highcharts)).call(this,props));}_createClass(Highcharts,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var titleText=this.props.title;var types=this.props.charttype;// window.test();
setTimeout(function(){win.Highcharts.chart(_this2.refs.highcharts,{chart:{plotBackgroundColor:null,plotBorderWidth:null,plotShadow:false,type:types,options3d:{enabled:true,alpha:45,beta:0}},title:{text:titleText},tooltip:{pointFormat:'{series.name}: <b>{point.y}</b>'},plotOptions:{pie:{allowPointSelect:true,cursor:'pointer',depth:35,dataLabels:{enabled:false}}},series:[{name:_this2.props.name,colorByPoint:true,data:_this2.props.data}]});},200);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'highcharts',style:{width:'98%',float:'left',margin:'25px 0px'}});}}]);return Highcharts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Highcharts);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var MyJourneyLists=function(_Component){_inherits(MyJourneyLists,_Component);function MyJourneyLists(props){_classCallCheck(this,MyJourneyLists);var _this=_possibleConstructorReturn(this,(MyJourneyLists.__proto__||Object.getPrototypeOf(MyJourneyLists)).call(this,props));_this.state={};return _this;}_createClass(MyJourneyLists,[{key:'fnChange',value:function fnChange(e){var tabdiv=e;if($('.'+tabdiv+':visible').length==0){$("."+tabdiv).show();}else{$("."+tabdiv).hide();}}},{key:'switchComponentPanel',value:function switchComponentPanel(type,lr_id,dlr_id){var view_type=this.props.view_type;if(view_type=='webview'){return false;}else{this.props.getLrinfo(type,lr_id,dlr_id);}}},{key:'render',value:function render(){var _this2=this;var lrcomponents=null;if($.isArray(this.props.tabsdata)){lrcomponents=this.props.tabsdata.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrroom-head'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'main-lrroom-div'+index,className:'newtb tablehide',id:'para',onClick:function onClick(e){return _this2.fnChange('tablejourney'+index);}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+"/images/downarrow.png"}),key,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrroom-div'+index,className:'tablejourney'+index+' tabcls divv divhide tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrroom-colum'+index,className:'my-journey-table-content fivecolumns newtb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{key:'lrroom-table'+index,style:{width:'100%'},className:'myjourney-table mytb '},_this2.props.tabsdatalist[index].map(function(val,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'lrroom-tbody'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'lrroom-tr'+ind,className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.tabsdatalist[index].length==ind+1?"lreach10lasettr":"",key:'lrroom-lrroom-td1'+ind,style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'a-lrroom-lrroom-td1'+ind,onClick:function onClick(e){return _this2.switchComponentPanel('componet_list',val['lr_id'],0);},href:'javascript:void(0);',title:val['rooms']},val['rooms'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.tabsdatalist[index].length==ind+1?"lreach10lasettr":"",key:'lrroom-td2'+ind,style:{width:'34%'}},val['room_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.tabsdatalist[index].length==ind+1?"lreach10lasettr":"",key:'lrroom-td3'+ind,style:{width:'22.5%'}},val['module_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.tabsdatalist[index].length==ind+1?"lreach10lasettr":"",key:'lrroom-td5'+ind,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/"+val['status']+".png",width:'15',height:'15',alt:'',border:'0',className:'tick'}))));})))));});}/*
			let lrmodulewise=null;
			
			if($.isArray(this.props.lrmodule)){
				 lrmodulewise=this.props.lrmodule.map((key,index)=>{
	            return <div key={`lrmodule-head${index}`}>
							<div key={`main-lrmodule-div${index}`} className="tablehide" id="para" onClick={(e) =>this.fnChange('tablejourney1'+index)}> <img title="" alt="" src={process.env.PUBLIC_URL+"/images/downarrow.png"} />{key} </div>
							<div key={`lrmodule-div${index}`} className={`tablejourney1${index} tabcls divv divhide tableshow`} id="div1" style={{display:'none'}}>
								<div key={`lrmodule-colum${index}`} className="my-journey-table-content fivecolumns">
									<table key={`lrmodule-table${index}`}   style={{width:'100%'}} className="myjourney-table">
									<tbody>
										{this.props.lrmodulewiselist[index].map((val,ind)=>{
												return(<tr key={`lrmodule-tr${ind}`} className="oddbg">
															<td key={`lrmodule-td1${ind}`} style={{width:'11%'}}><a onClick={e=>this.switchComponentPanel('componet_list',val['lr_id'],0)} href="javascript:void(0);" title={val['lrmwid']}>{val['lrmwid']}</a></td>
															<td key={`lrmodule-td2${ind}`} style={{width:'34%'}}>{val['lrmwroomname']}</td>
															<td key={`lrmodule-td3${ind}`} style={{width:'20.5%'}}><p dangerouslySetInnerHTML={{ __html:val['lrmwpscore']?val['lrmwpscore']:''}} /></td>
															<td key={`lrmodule-td4${ind}`} style={{}}><img src={process.env.PUBLIC_URL+"/images/"+val['status']+".png"} width="15" height="15" alt="" border="0" className="tick" /></td>
														</tr>)
													})
										}
										</tbody>
								</table>
								</div>
							</div>
							</div>
	        });
				}
				*/var dlrroomwise=null;if($.isArray(this.props.dlrroomwiselist)){dlrroomwise=this.props.dlrroomwiselist.map(function(dlrroom,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',_defineProperty({className:_this2.props.dlrroomwiselist.length==key+1?"lreach10lasettr":"",key:'dlrroom-tr'+key},'className','oddbg'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.dlrroomwiselist.length==key+1?"lreach10lasettr":"",key:'dlrroom-td1'+key,style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.switchComponentPanel('componet_list',dlrroom['template_dlr_id'],dlrroom['dlr_dlr_id']);},href:'javascript:void(0);',title:'Go to DLR '+dlrroom['dlr_id']},'ID  ',dlrroom['dlr_id'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.dlrroomwiselist.length==key+1?"lreach10lasettr":"",key:'dlrroom-td2'+key,style:{width:'34.2%'}},dlrroom['dlr_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.dlrroomwiselist.length==key+1?"lreach10lasettr":"",key:'dlrroom-td3'+key,style:{width:'22.2%'}},dlrroom['module_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:_this2.props.dlrroomwiselist.length==key+1?"lreach10lasettr":"",key:'dlrroom-td5'+key,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/"+dlrroom['status']+".png",width:'15',height:'15',alt:'',border:'0',className:'tick'})));});}//const dlr_module_list='';
/*
			let dlr_module_list=null;
			if($.isArray(this.props.dlr_module_name_list)) {
				 dlr_module_list=this.props.dlr_module_name_list.map((key,index)=>{
	            return <div key={`dlrmodule-head${index}`}>
							<div key={`main-dlrmodule${index}`} className="tablehide" id="para" onClick={(e) =>this.fnChange('tablejourney2'+index)}> <img title="" alt="" src={process.env.PUBLIC_URL+"/images/downarrow.png"} />{key} </div>
							<div key={`dlrmodule-div${index}`} className={`tablejourney2${index} tabcls divv divhide tableshow`} id="div1" style={{display:'none'}}>
								<div key={`dlrmodule-colum${index}`} className="my-journey-table-content fivecolumns">
									<table key={`dlrmodule-table${index}`} style={{width:'100%'}} className="myjourney-table">

										{this.props.dlrroomwise_array_list[index].map((val,ind)=>{
											return <tbody key={`dlrmodule-tr${ind}`}>
														<tr key={`dlrmodule-tr${ind}`} className="oddbg">
											        <td key={`dlrmodule-td1${ind}`} style={{width:'13%'}}><a onClick={e=>this.switchComponentPanel('componet_list',val['template_dlr_id'],val['dlr_dlr_id'])} href="javascript:void(0);" title={"Go to DLR react1"+val['dlr_id']}>{val['dlr_id']}</a></td>
											        <td key={`dlrmodule-td2${ind}`} style={{width:'33.2%'}}>{val['dlr_name']}</td>

											        <td key={`dlrmodule-td3${ind}`} style={{width:'20.5%'}}><p dangerouslySetInnerHTML={{ __html:val['pscore']?val['pscore']:''}} /> </td>
											        <td key={`dlrmodule-td4${ind}`} style={{}}><img src={process.env.PUBLIC_URL+"/images/"+val['status']+".png"} width="15" height="15" alt="" border="0" className="tick" /></td>
											      </tr>
														</tbody>
									})
								}
									</table>
								</div>
							</div>
							</div>
	        });
				}
				*/return(//tab class removed resp-tabs-container hor_1
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content',id:'room1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-tabhead nhead fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headrow  newhead '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Room no'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'Room Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col3'},'Module Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col5'},'Status'))),lrcomponents),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content',id:'room3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-tabhead nhead fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headrow  newhead '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'DLR ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'Room Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col3'},'Module Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col5'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tableshow4 divv',id:'div1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns newtb '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{style:{width:'100%'},className:'myjourney-table mytb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,dlrroomwise))))))));}}]);return MyJourneyLists;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyJourneyLists);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Highcharts from './../components/Highcharts';
// import MyJourneyList from './MyJourneyLists';
var $=window.$;var MyJourneyDemo=function(_Component){_inherits(MyJourneyDemo,_Component);function MyJourneyDemo(props){_classCallCheck(this,MyJourneyDemo);var _this=_possibleConstructorReturn(this,(MyJourneyDemo.__proto__||Object.getPrototypeOf(MyJourneyDemo)).call(this,props));_this.state={};_this.getLrinfo=_this.getLrinfo.bind(_this);return _this;}_createClass(MyJourneyDemo,[{key:'getTabs',value:function getTabs(){window.$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});}},{key:'fnChangetabs',value:function fnChangetabs(divClass){$("."+divClass).slideToggle();}},{key:'componentDidMount',value:function componentDidMount(){this.getTabs();}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){// alert(type);
this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this2=this;var Webview=this.props.Webview;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea myjourneyDemo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-myjourney.jpg',align:'absmiddle',alt:'',border:'0'}),' '),' My Journey',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'A quick view of my progress in the program'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourneychart-left'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/my-jurney_1.jpg',alt:'',title:'',style:{'width':'auto','max-width':'100%','margin':'10px auto 0'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-myj gr-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Avg time spent by all per LR: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'org'},'00 hrs 38 min')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Average time I spent per LR: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'grn'},'00 hrs 45 min')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Total time spent in LRs: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'grn'},'04 hrs 30 min'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourneychart-right'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/my-jurney_2.jpg',alt:'',title:'',style:{'width':'auto','max-width':'100%','margin':'10px auto 0'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-myj gr-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Avg time spent by all per DLR: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'org'},'01 hrs 40 min')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Average time I spent per DLR: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'grn'},'01 hrs 45 min')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Total time spent in DLRs: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'grn'},'14 hrs 00 min')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myourney-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 hr-22'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'LRs Room-wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'LRs Module-wise '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'DLRs Room-wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'DLRs Module-wise')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'abbrevation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'PS'),' - Performance Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',title:''}),' - Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-notcompleted.png',alt:'',title:''}),' - In Progress'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',title:''}),' - Yet to start'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-tabhead sixcolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Rooms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'Room Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col3'},'Module Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col4'},'PS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col5'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para',onClick:function onClick(e){return _this2.fnChangetabs("tablejourney1");}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'LRs 1 to 10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney1  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.2%'}},'MBA Common'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'--'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.2%'}},'MBA Common'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),' (34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.2%'}},'MBA Common'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2%'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assessment on Principles of Management Ch 1 to 4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.2%'}},'Principles of Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'64.3%'),'(9/14)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'abbrevation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'PS'),' - Performance Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',title:''}),' - Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-notcompleted.png',alt:'',title:''}),' - In Progress'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',title:''}),' - Yet to start'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-tabhead sixcolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Rooms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'Room Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'PS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col4'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para',onClick:function onClick(e){return _this2.fnChangetabs("tablejourney3");}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'MBA Common'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney3  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2%'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Principles of Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney4  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Managerial Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney5  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'HR Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney6  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Marketing Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney7  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Financial Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney8  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Business Mathematics and Statistics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney9  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Production and Materials Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney10  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Advertising Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney11  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'LR1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Orientation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'LR2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Understanding Business'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'63%'),'(34/54)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'18.2'),'(2/11)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'LR20')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Making Distinctions in Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'LR37')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34.2%'}},'Assignment1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'abbrevation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'PS'),' - Performance Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',title:''}),' - Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-notcompleted.png',alt:'',title:''}),' - In Progress'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',title:''}),' - Yet to start'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-tabhead sixcolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'DLR ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'DLR Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col3'},'Module Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col4'},'PS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col5'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tableshow4 divv',id:'div1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table hr-t-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'PoM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.5%'}},'Principles of Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.1%'}},'82.4%(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'MC1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'Managerial Communication(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.5%'}},'Managerial Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.1%'}},'37.5%(6/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'MM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'Marketing Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.5%'}},'Marketing Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.1%'}},'42.9%(12/28)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'11%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'HRM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'34%'}},'HR Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'22.5%'}},'HR Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.1%'}},'34.8%(8/23)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'abbrevation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'PS'),' - Performance Score'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',title:''}),' - Completed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-notcompleted.png',alt:'',title:''}),' - In Progress'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',title:''}),' - Yet to start'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myjourney-tabhead fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Modules'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col2'},'DLR Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col4'},'PS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col5'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para',onClick:function onClick(e){return _this2.fnChangetabs("tablejourney21");}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Principles of Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney21  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'PoM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'PM1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Managerial Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney22  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'HR Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney23  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Marketing Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney24  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Financial Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney25  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Business Mathematics and Statistics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney26  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Production and Materials Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney27  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Advertising Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney28  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablehide',id:'para'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'',alt:'',src:"/rmeta"+'/images/downarrow.png'}),'Exam Preparation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablejourney29  tabcls divv tableshow',id:'div1',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-journey-table-content fivecolumns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',style:{width:'100%'},className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T5'},'poM1-4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-4)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'82.4%'),'(28/34)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T4'},'PoM512')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(5-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'oddbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T3'},'Po1324')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/start-small.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'evenbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'13%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',title:'Go to DLR QA-T2'},'Pm1-12')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'33%'}},'Principles of Management(1-12)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'20.4%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'25%'),'(4/16)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/status-completed.png',alt:'',className:'tick',width:'15',height:'15',border:'0'}))))))))))))))))));}}]);return MyJourneyDemo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyJourneyDemo);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var Bookaccordian=function(_Component){_inherits(Bookaccordian,_Component);function Bookaccordian(props){_classCallCheck(this,Bookaccordian);var _this=_possibleConstructorReturn(this,(Bookaccordian.__proto__||Object.getPrototypeOf(Bookaccordian)).call(this,props));_this.state={};_this.container="";_this.bookBlock="";_this.items="";_this.itemsCount=0;_this.current=0;_this.bb="";_this.navNext="";_this.navPrev="";_this.menuItems="";_this.tblcontents="";_this.transEndEventNames="";_this.transEndEventName="";_this.supportTransitions="";return _this;}_createClass(Bookaccordian,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;setTimeout(function(){var self=_this2;self.container=$('#'+_this2.refs.bookContainer.id);self.bookBlock=$('#'+_this2.refs.bookBlock.id);self.items=self.bookBlock.children();self.itemsCount=self.items.length;self.current=0;self.bb=$('#'+_this2.refs.bookBlock.id).bookblock({speed:800,perspective:2000,shadowSides:0.8,shadowFlip:0.4,onEndFlip:function onEndFlip(old,page,isLimit){self.current=page;// update TOC current
self.updateTOC();// updateNavigation
self.updateNavigation(isLimit);// initialize jScrollPane on the content div for the new item
self.setJSP('init');// destroy jScrollPane on the content div for the old item
self.setJSP('destroy',old);}});self.navNext=$('#bb-nav-next');self.navPrev=$('#bb-nav-prev').hide();self.menuItems=self.container.find('ul.menu-toc > li');self.tblcontents=$('#tblcontents');self.transEndEventNames={'WebkitTransition':'webkitTransitionEnd','MozTransition':'transitionend','OTransition':'oTransitionEnd','msTransition':'MSTransitionEnd','transition':'transitionend'};self.transEndEventName=self.transEndEventNames[win.Modernizr.prefixed('transition')];self.supportTransitions=win.Modernizr.csstransitions;self.setJSP('init');self.initEvents();},500);}},{key:"initEvents",value:function initEvents(){var self=this;// add navigation events
self.navNext.on('click',function(){self.bb.next();return false;});self.navPrev.on('click',function(){self.bb.prev();return false;});// add swipe events
self.items.on({'swipeleft':function swipeleft(event){if(self.container.data('opened')){return false;}self.bb.next();return false;},'swiperight':function swiperight(event){if(self.container.data('opened')){return false;}self.bb.prev();return false;}});// show table of contents
self.tblcontents.on('click',self.toggleTOC);// click a menu item
self.menuItems.on('click',function(){var $el=$(this),idx=$el.index(),jump=function jump(){self.bb.jump(idx+1);};this.current!==idx?self.closeTOC(jump):self.closeTOC();return false;});// reinit jScrollPane on window resize
$(win).on('debouncedresize',function(){// reinitialise jScrollPane on the content div
self.setJSP('reinit');});}},{key:"setJSP",value:function setJSP(action,idx){var self=this;var idx=idx===undefined?self.current:idx,$content=self.items.eq(idx).children('div.content'),apiJSP=$content.data('jsp');if(action==='init'&&apiJSP===undefined){$content.jScrollPane({verticalGutter:0,hideFocus:true});}else if(action==='reinit'&&apiJSP!==undefined){apiJSP.reinitialise();}else if(action==='destroy'&&apiJSP!==undefined){apiJSP.destroy();}}},{key:"updateTOC",value:function updateTOC(){this.menuItems.removeClass('menu-toc-current').eq(this.current).addClass('menu-toc-current');}},{key:"updateNavigation",value:function updateNavigation(isLastPage){if(this.current===0){this.navNext.show();this.navPrev.hide();}else if(isLastPage){this.navNext.hide();this.navPrev.show();}else{this.navNext.show();this.navPrev.show();}}},{key:"toggleTOC",value:function toggleTOC(){var opened=this.container.data('opened');opened?this.closeTOC():this.openTOC();}},{key:"openTOC",value:function openTOC(){this.navNext.hide();this.navPrev.hide();this.container.addClass('slideRight').data('opened',true);}},{key:"closeTOC",value:function closeTOC(callback){var self=this;self.updateNavigation(self.current===self.itemsCount-1);self.container.removeClass('slideRight').data('opened',false);if(callback){if(self.supportTransitions){self.container.on(self.transEndEventName,function(){$(this).off(self.transEndEventName);callback.call();});}else{callback.call();}}}},{key:"render",value:function render(){var shows=this.props.shows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"container",ref:"bookContainer",className:"container-dairy"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bb-custom-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bb-bookblock",id:"bb-bookblock",ref:"bookBlock"},shows.length>0&&shows.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:"s_wise"+index,className:"bb-item",id:"item"+index,style:{display:index==0?'block':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"scroller"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pagetitle"},key['pagetitle']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"pagetitle1",dangerouslySetInnerHTML:{__html:key['pagetitle1']?key['pagetitle1']:''}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pagedate"},key['pagedate']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"scroller_new",dangerouslySetInnerHTML:{__html:key['notes']?key['notes']:''}}))));}),shows.length==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bb-item",id:"item0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"scroller"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"timebox_new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"red-txt"},"No Notes")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{id:"bb-nav-prev",style:{display:'none'}},"<"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{id:"bb-nav-next"},">")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"menu-button",id:"tblleftcontents"},"Table of Contents")));}}]);return Bookaccordian;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Bookaccordian);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Linecharts__ = __webpack_require__(217);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var MyPerformanceDemo=function(_Component){_inherits(MyPerformanceDemo,_Component);function MyPerformanceDemo(props){_classCallCheck(this,MyPerformanceDemo);var _this=_possibleConstructorReturn(this,(MyPerformanceDemo.__proto__||Object.getPrototypeOf(MyPerformanceDemo)).call(this,props));_this.state={};return _this;}_createClass(MyPerformanceDemo,[{key:'getAssesStatus',value:function getAssesStatus(type){this.props.switchPanel(type);}},{key:'getTabs',value:function getTabs(){/*
	           window.$('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });

							window.$('#ChildVerticalTab_1').easyResponsiveTabs({
			            type: 'vertical',
			            width: 'auto',
			            fit: true,
			            tabidentify: 'ver_1', // The tab groups identifier
			            //resp-tab-active
			           /* activate: function (event) { // Callback function if tab is switched
			                alert('sdf');
			               $('[aria-controls="ver_1_tab_item-2"]').click();
			               alert('dd');
						} *//*
					});
					*/window.$('#performanceParentTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion           
width:'auto',//auto or any custom width
fit:true,// 100% fits in a container
tabidentify:'tab_identifier_parent'// The tab groups identifier *This should be a unique name for each tab group and should not be defined in any styling or css file.
});//child tab
window.$('#performanceChildTab').easyResponsiveTabs({type:'vertical',//Types: default, vertical, accordion           
width:'auto',//auto or any custom width
fit:true,// 100% fits in a container
tabidentify:'tab_identifier_child'// The tab groups identifier *This should be a unique name for each tab group and should not be defined in any styling or css file.
});}},{key:'componentDidMount',value:function componentDidMount(){this.getTabs();}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-myperformance.jpg',align:'absmiddle',alt:'',border:'0'}),' '),' '),' My Performance',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'My cumulative performance in completed Learning Rooms.'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'performance-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'performanceParentTab',id:'performanceParentTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list tab_identifier_parent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Performance Chart'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Percentile Report')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container tab_identifier_parent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'performanceChildTab',className:'performanceChildTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list tab_identifier_child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'LR Room-wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'LR Module-wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'DLR Room-wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'DLR Module-wise')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container tab_identifier_child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"images/my-performance/subtab1.jpg",alt:"images/my-performance/subtab1.jpg"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img',style:{margin:'30px 0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"images/my-performance/subtab2.jpg",alt:"images/my-performance/subtab1.jpg"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grySelectBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Select Module:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Item 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Item 2')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img',style:{margin:'30px 0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/my-performance/subtab3.jpg',alt:"images/my-performance/subtab1.jpg"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img',style:{margin:'30px 0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/my-performance/subtab4.jpg',alt:"images/my-performance/subtab1.jpg"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grySelectBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Select Module:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Select'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Item 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Item 2'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gryBoxText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'K/A'),' - Knowledge / Action Component   \xA0\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'AS'),' - Actual Score   \xA0\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'MS'),' - Maximum Score  \xA0\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' %'),' - Percentage Score \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'G %ile'),' - Group Percentile    \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'U %ile '),'- Universal Percentile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Export Report')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tblResponsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rooms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Module Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Component Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'K/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'AS/MS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'G %ile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'U %ile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'AM24N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Advertising ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Quiz 1- Advertising Management(13-24)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2/16'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'12.5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'HRM1-4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'HR Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Quiz 1 - HR Management Objectives and Challenges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4/12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'33.33'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4.32')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'HRM1-4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'HR Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Quiz 2 - HR Management 1 -4 -Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4/11'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'36.36'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'5.71')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'LR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'MBA Common'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Understanding Business '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'34/54'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'62.96'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'29.41'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'60.02')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'LR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'MBA Common'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Useful Business Terms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2/11'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'18.18'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'5.88'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2.04')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'LR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Principles of Management'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Assessment on Principles of Management Ch 1 to 4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'9/14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'64.29'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'70.59'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'73.14')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'LR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Managerial Communication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Assessment on Managerial Communication Ch 1 to 4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'KS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2/8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'25'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'6.25'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'5.18'))))))))));}}]);return MyPerformanceDemo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyPerformanceDemo);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssessementStatus__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssessementMail__ = __webpack_require__(436);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var AssessementComp=function(_Component){_inherits(AssessementComp,_Component);function AssessementComp(props){_classCallCheck(this,AssessementComp);var _this=_possibleConstructorReturn(this,(AssessementComp.__proto__||Object.getPrototypeOf(AssessementComp)).call(this,props));_this.state={comp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AssessementStatus__["a" /* default */],{sentData:_this.getData.bind(_this)})};return _this;}_createClass(AssessementComp,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({comp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AssessementStatus__["a" /* default */],{sentData:this.getData.bind(this)})});}},{key:'getData',value:function getData(mail,evals,comp){this.setState({comp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AssessementMail__["a" /* default */],{mail:mail,evals:evals,comp:comp})});}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-myperformance.jpg',align:'absmiddle',alt:'',border:'0'}),' '),' My Performance',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Assessment Status.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.comp))))));}}]);return AssessementComp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AssessementComp);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var AssessementStatus=function(_Component){_inherits(AssessementStatus,_Component);function AssessementStatus(props){_classCallCheck(this,AssessementStatus);var _this=_possibleConstructorReturn(this,(AssessementStatus.__proto__||Object.getPrototypeOf(AssessementStatus)).call(this,props));_this.state={ass_status:[]};_this.getSentMail=_this.getSentMail.bind(_this);return _this;}_createClass(AssessementStatus,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'getList',value:function getList(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);// let learnerID = '96715';
var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learning/performance-assess',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this2.setState({ass_status:responseJson.performance_asses});}});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}},{key:'getSentMail',value:function getSentMail(mail,evals,component){this.props.sentData(mail,evals,component);}},{key:'componentDidMount',value:function componentDidMount(){this.getList();}},{key:'render',value:function render(){var _this3=this;var ass_status=[];if(this.state.ass_status!=null||this.state.ass_status!=undefined){ass_status=this.state.ass_status.map(function(ass,l){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'ass_'+l,bgcolor:'#ffffff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.no),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.lr_no),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.component),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.evaluator_id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.sentdate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.assesseddate==""||ass.assesseddate==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.getSentMail(ass.mail_id,ass.evaluator_id,ass.component);}},'YTA'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,ass.assesseddate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,ass.score==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.getSentMail(ass.mail_id,ass.evaluator_id,ass.component);}},'YTA'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,ass.score)));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',width:'100%',id:'view',className:'myjourney-table border-blue',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'S.No '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'LR No ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Component Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observer Name',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sent date',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Assessed date',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Assessed Score',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!ass_status.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'7'},'No Recods Found')):ass_status)));}}]);return AssessementStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AssessementStatus);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var AssessementMail=function(_Component){_inherits(AssessementMail,_Component);function AssessementMail(props){_classCallCheck(this,AssessementMail);var _this=_possibleConstructorReturn(this,(AssessementMail.__proto__||Object.getPrototypeOf(AssessementMail)).call(this,props));_this.state={mails:props.mail,evals:props.evals,comp:props.comp};_this.sentMail=_this.sentMail.bind(_this);return _this;}_createClass(AssessementMail,[{key:'sentMail',value:function sentMail(){var mail=this.state.mails;var name=this.state.evals;var comp=this.state.comp;var sub=this.refs.subject.value;var message=this.refs.message.value;var lr_mail=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('primaryEmail',true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learning/performance-mail',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({mail:mail,name:name,comp:comp,sub:sub,msg:message,lr_mail:lr_mail})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",'Your mail to '+name+' has been sent successfully',"success");$('form#asssendmail')[0].reset();}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Send a message to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.evals),' regarding assessment of ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.comp),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-cont5 tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'asssendmail',id:'asssendmail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},this.state.mails)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Subject ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',ref:'subject',className:'txtbox'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Message ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{cols:'20',rows:'15',ref:'message'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'mail-icon',type:'button',name:'submit',value:'Send Mail',alt:'Send Mail',title:'Send Mail',onClick:function onClick(){return _this2.sentMail();}}))))))));}}]);return AssessementMail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AssessementMail);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__ = __webpack_require__(219);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Recap_list=function(_Component){_inherits(Recap_list,_Component);function Recap_list(props){_classCallCheck(this,Recap_list);var _this=_possibleConstructorReturn(this,(Recap_list.__proto__||Object.getPrototypeOf(Recap_list)).call(this,props));_this.state={};return _this;}_createClass(Recap_list,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this2=this;var lr_lists=null;if(this.props.lr_lists!=null||this.props.lr_lists!=undefined){lr_lists=this.props.lr_lists.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lr-key'+index,id:'Hire'+index,style:{display:''+(index==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-content',id:'LROOM'+key['lr'],style:{display:''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this2.props.lr_lists[index].divider.map(function(divide,divi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'divider_'+divi},_this2.props.lr_lists[index].componentslists[divide].map(function(val,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'componentslists_'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'lr-li'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:val['spanclass']})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'lr-li'+divi,className:'recapsep'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lrdivider-rc'},'\xA0')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,key['lr_name']),key['recap']!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:key['recap']?key['recap']:''}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Notes'),key['count_note']!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'count_note_'+index},key['noteslists'].map(function(note,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'count_note1_'+n},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtrecap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,note.notes_title),'\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orange_txt1'},note.modified_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:note.notes?note.notes:'No Notes available for this Learning room.'}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Notes available for this Learning room.')))));});}var lr_module_name_lists=null;if(this.props.lr_module_name_lists!=null||this.props.lr_module_name_lists!=undefined){lr_module_name_lists=this.props.lr_module_name_lists.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'option-key'+index,value:key['module_id']+"#"+key['learningroom_id']},key['module_name']);});}var module_name_list=null;var module_lr_lists=null;if(this.props.module_name_list!=null||this.props.module_name_list!=undefined){module_name_list=this.props.module_name_list.map(function(mod,list){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'main-key'+list,className:'allcss',id:'Mod1'+mod['module_id'],style:{display:''+(list==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'allcss',id:'Mod'+mod['module_id'],style:{display:''+(list==0?'':'none')}},mod['module_name'],'(',mod['lrnames'],')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'moduleLrIds'+list,id:'moduleLrIds'+list,value:mod['lrids']}),_this2.props.module_lr_lists[list].map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lr-key'+index,className:'allcss lrroomcss',id:'ModuleHier'+key['lr'],style:{display:''+(index==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-content',id:'LROOM'+key['lr']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,_this2.props.module_lr_lists[list][index].divider.map(function(divide,divi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'divider1_'+divi},_this2.props.module_lr_lists[list][index].componentslists[divide].map(function(val,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'lr-li'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:val['spanclass']}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'recapsep'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lrdivider-rc'},'\xA0')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,key['lr_name']),key['recap']!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:key['recap']?key['recap']:''}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Notes'),key['count_note']!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrcount_note_'+index},key['noteslists'].map(function(note,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrcount_note1_'+n},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtrecap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,note.notes_title),'\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orange_txt1'},note.modified_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:note.notes?note.notes:'No Notes available for this Learning room.'}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Notes available for this Learning room.')))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'allcss',id:'ButtonShow'+mod['module_id'],style:{float:'right',paddingRight:'40px',display:''+(list==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form1',name:'form1',method:'post',action:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'CurrentCount'+list,id:'CurrentCount'+list,value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'txtOverallCount'+list,id:'txtOverallCount'+list,value:mod['module_lr_count']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'txtCurLearningRoom'+list,id:'txtCurLearningRoom'+list,value:mod['lrids']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'txtOverallLearningRoom'+list,id:'txtOverallLearningRoom'+list,value:mod['lrids']}),mod['module_lr_count']>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrmodcount_note_'+list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prevNextBtn',style:{display:'none'},id:'PreviousButModule'+list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'PreviousBut'+list,value:'Previous',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["j" /* showRecapPreMod */](list);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prevNextBtn',id:'NextButModule'+list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'NextBut'+list,value:'Next',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["g" /* showRecapNextMod */](list);}})))):'')));});}var dlr_wise_list=null;if(this.props.dlr_wise_list!=null||this.props.dlr_wise_list!=undefined){dlr_wise_list=this.props.dlr_wise_list.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr-key'+index,id:'DLRHire'+index,style:{display:''+(index==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-content',id:'LROOM'+key['dlr_id'],style:{display:''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,key['divider'].map(function(divide,divi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'divider2_'+divi},key['componentslists'][divide].map(function(val,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'dlr-li'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:val['spanclass']}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'recapsep'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lrdivider-rc'},'\xA0')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,key['dlr_name']),key['recap']!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:key['recap']?key['recap']:''}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Notes'),key['dlr_note_count']!='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr_note_count_'+index},key['dlr_notes'].map(function(note,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr_note_count1_'+n},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtrecap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,note.notes_title),'\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orange_txt1'},note.modified_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:note.notes?note.notes:'No Notes available for this DLR.'}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Notes available for this DLR.')))));});}var dlr_module_name_lists=null;if(this.props.dlr_module_name_lists!=null||this.props.dlr_module_name_lists!=undefined){dlr_module_name_lists=this.props.dlr_module_name_lists.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'option-key1'+index,value:key['module_id']+"#"+key['learningroom_id']},key['module_name']);});}var dlr_module_wise=null;if(this.props.dlr_module_wise_list!=null||this.props.dlr_module_wise_list!=undefined){dlr_module_wise=this.props.dlr_module_wise_list.map(function(mod,list){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dmain-key'+list,className:'dlr_allcss',id:'DLRModuleMod1'+mod['module_id'],style:{display:''+(list==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'dlr_allcss',id:'DLRModuleMod'+mod['module_id'],style:{display:''+(list==0?'':'none')}},mod['module_name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'moduleLrIds'+list,id:'moduleLrIds'+list,value:mod['lrids']}),mod['dlr_module_wise_details'].map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr-key'+index,className:'dlr_allcss dlrroomcss',id:'DLRModuleModuleHier'+key['dlr_id'],style:{display:''+(index==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' recap-content',id:'LROOM'+key['dlr_id']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,mod['divider'].map(function(divide,divi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr_divider_'+divi},mod['componentslists'][divide].map(function(val,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'dlr-li'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:val['spanclass']}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'recapsep'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lrdivider-rc'},'\xA0')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,key['dlr_name']),key['recap']!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Recap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:key['recap']?key['recap']:''}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recap-right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Notes'),mod['dlr_note_count']!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr_note_count2_'+index},mod['dlr_notes'].map(function(note,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlr_note_count3_'+n},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtrecap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,note.notes_title),'\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orange_txt1'},note.modified_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:note.notes?note.notes:'No Notes available for this Learning room.'}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Notes available for this Learning room.')))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dlr_allcss',id:'DLRModuleButtonShow'+mod['module_id'],style:{float:'right',paddingRight:'40px',display:''+(list==0?'':'none')}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form1',name:'form1',method:'post',action:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRModuleCurrentCount'+list,id:'DLRModuleCurrentCount'+list,value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRModuletxtOverallCount'+list,id:'DLRModuletxtOverallCount'+list,value:mod['module_dlr_count']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRModuletxtCurLearningRoom'+list,id:'DLRModuletxtCurLearningRoom'+list,value:mod['dlr_id']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRModuletxtOverallLearningRoom'+list,id:'DLRModuletxtOverallLearningRoom'+list,value:mod['dlrids']}),mod['module_dlr_count']>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'module_dlr_count'+list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prevNextBtn',style:{display:'none'},id:'DLRModulePreviousButModule'+list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'DLRModulePreviousBut'+list,value:'Previous',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["c" /* DLRModuleshowRecapPreMod */](list);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prevNextBtn',id:'DLRModuleNextButModule'+list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'NextBut'+list,value:'Next',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["b" /* DLRModuleshowRecapNextMod */](list);}})))):'')));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content',id:'lr-wise'},this.props.lr_count!='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,lr_lists,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form1',name:'form1',method:'post',action:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'txthidden',id:'txthidden',value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'txttothid',id:'txttothid',value:this.props.lr_count}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prev-next-btn',style:{display:'none',margin:'0px'},id:'PreviousBut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'PreviousBut',value:'Previous',title:'Previous',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["h" /* showRecapPre */]();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prev-next-btn',style:{margin:'0px'},id:'NextBut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'NextBut',value:'Next',title:'Next',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["e" /* showRecapNext */]();}})))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new',style:{display:'block'}},'Please complete at least 1 learning room to view recaps')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content',id:'lr-module-wise'},this.props.lr_count!='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,module_name_list,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right',paddingRight:'40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Choose a Module'),' \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'lstModuleSelect',style:{width:'200px'},id:'lstModuleSelect',onChange:function onChange(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["d" /* showModule */]();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),lr_module_name_lists))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new',style:{display:'block'}},'Please complete at least 1 learning room to view recaps'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'TotalModuleValue',id:'TotalModuleValue',value:'1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content',id:'dlr-wise'},dlr_wise_list!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,dlr_wise_list,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form1',name:'form1',method:'post',action:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRtxthidden',id:'DLRtxthidden',value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRtxttothid',id:'DLRtxttothid',value:this.props.dlr_count}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prev-next-btn',style:{display:'none',margin:'0px'},id:'DLRPreviousBut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'DLRPreviousBut',value:'Previous',title:'Previous',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["i" /* showRecapPreDLR */]();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button prev-next-btn',style:{margin:'0px'},id:'DLRNextBut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'DLRNextBut',value:'Next',title:'Next',onClick:function onClick(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["f" /* showRecapNextDLR */]();}})))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new',style:{display:'block'}},'Please complete at least 1 Dynamic learning room to view recaps.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content',id:'dlr-module-wise'},dlr_module_wise!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,dlr_module_wise,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRModulehiddenModuleID',id:'DLRModulehiddenModuleID',value:this.props.dlr_lear_count['dlr_lear']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'DLRModuleTotalModuleValue',id:'DLRModuleTotalModuleValue',value:this.props.dlr_module_name_lists_count}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right',paddingRight:'40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Choose a Module'),' \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'DLRModulelstModuleSelect',style:{width:'200px'},id:'DLRModulelstModuleSelect',onChange:function onChange(e){return __WEBPACK_IMPORTED_MODULE_1__components_Prevnext__["a" /* DLRModuleshowModule */]();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),dlr_module_name_lists))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox_new',style:{display:'block'}},'Please complete at least 1 Dynamic learning room to view recaps.')));}}]);return Recap_list;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Recap_list);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layouts_Main__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Contracts__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Anouncement__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Courseworkcomp__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videocomponent__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Practiceassigment__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContextQuestionnaire__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeedbackForm__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Recordedvideo__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Webcastlive__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EvaluationForm__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Thanks__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Descriptivetask3__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Normaltest__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RepeatNormaltest__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Testonebyone__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RepeatTestonebyone__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Timevariabletest__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RepeatTimevariabletest__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Fixedtimetest__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RepeatFixedtimetest__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__GridComp__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__BetTest__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__partials_WritingNotePad__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Testresults__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Ctestonebyone__ = __webpack_require__(105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var jQuery=window.jQuery;var Componetlist=function(_Component){_inherits(Componetlist,_Component);function Componetlist(props){_classCallCheck(this,Componetlist);var _this=_possibleConstructorReturn(this,(Componetlist.__proto__||Object.getPrototypeOf(Componetlist)).call(this,props));_this.state={writingPadData:[],component_type:"",componentPanel:"",learning_room_name:"",lrcomponents:[],auto_visible:[],defaultLrID:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])('defaultLRID',true),allowshowthanks:false};_this.lr_id=props.lr_id==0?_this.state.defaultLrID:props.lr_id;_this.dlrid=props.dlr_id==0?0:props.dlr_id;_this.compolist=_this.compolist.bind(_this);_this.anncompolist=_this.anncompolist.bind(_this);_this.goToNotesList=_this.goToNotesList.bind(_this);_this.returntestresult=_this.returntestresult.bind(_this);_this.returnrepeatretest=_this.returnrepeatretest.bind(_this);return _this;}_createClass(Componetlist,[{key:'getLearningRoom',value:function getLearningRoom(id,dlr_id){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'guidedpath/components',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({learner_id:Object(__WEBPACK_IMPORTED_MODULE_1__helpers_User__["a" /* UserId */])(),room_id:id,dlr_id:dlr_id})}).then(function(response){if(response.ok){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");return response.json();}else{return response.json();}}).then(function(responseJson){_this2.setState({writingPadData:responseJson,lrcomponents:responseJson.lrcomponents,learning_room_name:responseJson.lr_name,auto_visible:responseJson.auto_visible});jQuery(".guided_path li").removeClass("active-accordion");jQuery('.lr'+_this2.lr_id).addClass("active-accordion");// jQuery('.modu_' + this.lr_id).addClass("active-accordion");
jQuery('.mlr_'+_this2.lr_id).parents('li').addClass("active-accordion");jQuery('li.mlr_'+_this2.lr_id).addClass("active-accordion");jQuery('.mrlr_'+_this2.lr_id).parents('li').addClass("active-accordion");jQuery('li.mrlr_'+_this2.lr_id).addClass("active-accordion");var responselrcomponent=_this2.state.lrcomponents;if(responselrcomponent!=undefined&&responselrcomponent!=null){Object.keys(responselrcomponent).map(function(item,i){//console.log(responselrcomponent);   
if(responselrcomponent[item].length>1){var responselrcomponentitem=responselrcomponent[item];responselrcomponentitem.map(function(itemof,k){if(itemof.status!="completed"){_this2.setState({allowshowthanks:true});}});}else if(responselrcomponent[item].length==0&&responselrcomponent[item].status!="completed"){_this2.setState({allowshowthanks:true});}});}_this2.openthecompoents(responseJson.lrcomponents);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["k" /* hideleftbar */])();},400);});}},{key:'predividernotcompleted',value:function predividernotcompleted(){//message('Note!', 'You will be able to open this component only after completing the current Active Components', 'info');
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])('Note!','Please complete the items listed above the Gray line first','info');}},{key:'goToNotesList',value:function goToNotesList(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'opencompoentscase',value:function opencompoentscase(data){var _this3=this;var panel=[];var isScroll=1;switch(data.compo_type){case"contract":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Contracts__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"anouncement":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Anouncement__["a" /* default */],{data:data,usableType:'webapp',switchback:this.anncompolist,returnthanks:this.returntestresult});isScroll=0;break;case"videocomponent":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Videocomponent__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"coursework":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Courseworkcomp__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"practice":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Practiceassigment__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"descriptivetask":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Descriptivetask3__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"context":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ContextQuestionnaire__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"feedbackform":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__FeedbackForm__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"recordedvideo":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Recordedvideo__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"webcastlive":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Webcastlive__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"evaluation":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EvaluationForm__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"normaltest":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Normaltest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"repeatnormaltest":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__RepeatNormaltest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"testonebyone":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Testonebyone__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"repeattestonebyone":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__RepeatTestonebyone__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"testgoback":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Testonebyone__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"timevariabletest":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Timevariabletest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"repeattimevariabletest":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__RepeatTimevariabletest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"fixedtimetest":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Fixedtimetest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"repeatfixedtimetest":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__RepeatFixedtimetest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"girdcomponent":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__GridComp__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,returnthanks:this.returntestresult});isScroll=0;break;case"bet_test":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__BetTest__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"testresults":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Testresults__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist,switchrepeatretest:this.returnrepeatretest,returnthanks:this.returntestresult});isScroll=0;break;case"ctestonebyone":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Ctestonebyone__["a" /* default */],{data:data,usableType:'webapp',switchback:this.returntestresult,returnthanks:this.returntestresult});isScroll=0;break;case"thanks":panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Thanks__["a" /* default */],{data:data,usableType:'webapp',switchback:this.compolist});isScroll=0;break;default:Object.keys(this.state.lrcomponents).map(function(did,index){if(_this3.state.auto_visible[index]!==undefined){panel=_this3.openthecompoents(_this3.state.auto_visible[index]);}else{var testtxt=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'lrcomponents_'+index,id:'lrcomponents_'+index,className:'box gc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'ui$index',className:index},_this3.getdividcomponents(did)));if(panel!=undefined){panel.push(testtxt);}}});}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();if(panel!==undefined){this.setState({componentPanel:panel,component_type:isScroll});}}},{key:'compolist',value:function compolist(type,lr_id,dlr_id){this.opencompoentscase({type:type,lr_id:lr_id,dlr_id:dlr_id});this.getLearningRoom(lr_id,dlr_id);}},{key:'anncompolist',value:function anncompolist(responseJson){this.opencompoentscase(responseJson);if(responseJson.look_before==undefined){this.getLearningRoom(responseJson.learning_room_id,responseJson.dlr_id);}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();}},{key:'returntestresult',value:function returntestresult(testresultData){// alert('ttt321');
// console.log(testresultData);
// if(testresultData.status=='completed')
// {
//     this.setState({allowshowthanks:true}); 
// }
//check allow thanks page
if(this.state.allowshowthanks==true||testresultData.status=='completed'||testresultData.is_betcomponent=='1'&&testresultData.betallowcomp!=undefined&&testresultData.betallowcomp=='1')this.opencompoentscase(testresultData);else this.compolist('component_list',testresultData.learning_room_id,testresultData.dlr_id);// console.log(""+testresultData.learning_room_id+","+testresultData.dlr_id);
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */])();}},{key:'returnrepeatretest',value:function returnrepeatretest(testresultData){this.opencompoentscase(testresultData);}},{key:'openthecompoents',value:function openthecompoents(data){var _this4=this;//console.log(data);
if(data.look_before!=undefined&&data.look_before=="Y"&&data.status!='completed'){/* window.swal({
			     title: 'Note',
			     text: 'Before continue this component, You need confirm the announcement details of the current component.',
			     type: 'warning',
			     showCancelButton: true,
			     confirmButtonColor: '#3085d6',
			     cancelButtonColor: '#d33',
			     confirmButtonText: 'Open'
			 }).then((result) => {
			     if (result) {
			         this.opencompoentscase(data);
			     }
			 });*/this.opencompoentscase(data);//message("Note", "Before continue this component, You need confirm the announcement details of the current component.");
}else if(data.compo_type=="feedbackform"&&data.status=="completed"){if(data.fb_reopen==1){//message("", "This component is already completed.");
window.swal({//title: 'View!',
text:'Do you want to view this again?',// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){_this4.opencompoentscase(data);}});}else if(data.fb_reopen==0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])("","This component is already completed.");/*window.swal({
                    //title: 'View!',
                    text: 'Do you want to view this again?',
                   // type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#14a430',
                    cancelButtonColor: '#0082c9',
                    animation: false,
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    if (result) {
                        this.opencompoentscase(data);
                    }
                });
                //this.opencompoentscase(data);*/}}else if(data.status=="completed"){if(data.compo_type!="anouncement"&&data.Isvisible){this.opencompoentscase(data);}else{window.swal({//title: 'View!',
text:'Do you want to view this again?',// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){_this4.opencompoentscase(data);}});}}else{this.opencompoentscase(data);}Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */])();}},{key:'componentDidMount',value:function componentDidMount(){var _this5=this;this.getLearningRoom(this.lr_id,this.dlrid);setTimeout(function(){jQuery(".guided_path li").removeClass("active-accordion");jQuery('.lr'+_this5.lr_id).addClass("active-accordion");jQuery('.mlr_'+_this5.lr_id).parents('li').addClass("active-accordion");jQuery('.mrlr_'+_this5.lr_id).parents('li').addClass("active-accordion");jQuery('#semana-scroll').tinyscrollbar();},500);// showLargeLeftMenu();
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this6=this;this.lr_id=nextProps.lr_id==0?this.state.defaultLrID:nextProps.lr_id;this.dlrid=nextProps.dlr_id==0?0:nextProps.dlr_id;setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");jQuery(".guided_path li").removeClass("active-accordion");jQuery('.lr'+_this6.lr_id).addClass("active-accordion");jQuery('.mlr_'+_this6.lr_id).parents('li').addClass("active-accordion");jQuery('.mrlr_'+_this6.lr_id).parents('li').addClass("active-accordion");_this6.getLearningRoom(_this6.lr_id,_this6.dlrid);},500);}},{key:'updateCourse',value:function updateCourse(course_id,learner_id,course_name){//alert(course_id);
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'guidedpath/course',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({learner_id:learner_id,course_id:course_id,course_name:course_name})});Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");}//console.log(this.state.lrcomponents);
},{key:'getdividcomponents',value:function getdividcomponents(did){var _this7=this;var strv1=this.state.lrcomponents[did].map(function(key,index){if(index==0){return key;}});var renderdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,strv1[0].lr_room_id=="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'class':'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px'}},strv1[0].firstname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px'}},strv1[0].primaryemail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px'}},strv1[0].mobile),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px'}},strv1[0].college),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px'}},' Your Total Score : ',strv1[0].total_val,' / 60')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null));var tabledata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,strv1[0].lr_room_id=="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{style:{border:'1px solid #c1c1c175',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{border:'1px solid #c1c1c175',width:'100%',backgroundColor:'#76b8e4',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Segment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No.of Questions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Answered Correctly'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'% Scored')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{border:'1px solid #c1c1c175',width:'100%',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175'}},'BFSI Marketing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},'12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].bfsi_marketing_val),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].bfsi_val,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{border:'1px solid #c1c1c175',width:'100%',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175'}},'Capital Markets'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},'20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].capital_markets_val),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].capital_val,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{border:'1px solid #c1c1c175',width:'100%',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175'}},'Banking'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},'16'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].banking_val),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].bank_val,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{border:'1px solid #c1c1c175',width:'100%',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175'}},'Insurance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},'12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].insurance_val),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{border:'1px solid #c1c1c175',textAlign:'center'}},strv1[0].insu_val,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{border:'1px solid #c1c1c175',width:'100%',backgroundColor:'#76b8e4',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'60'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,strv1[0].total_val),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,strv1[0].tot_val,' %'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null));var strv=this.state.lrcomponents[did].map(function(key,index){if(key.lr_room_id=="6651"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'class':'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{marginTop:'25px',padding:'0px 20px 0px 0px',height:'33px',fontWeight:'bold'}},'(',key.section,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'50px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginTop:'13px',padding:'2px',color:'#0659ea'}},key.id,'. ',key.question)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px',fontSize:'14px'}},'A. ',key.option_a,' ',key.correct_ans==key.option_a?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px',color:'green'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px',fontSize:'14px'}},'B. ',key.option_b,' ',key.correct_ans==key.option_b?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px',color:'green'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px',fontSize:'14px'}},'C. ',key.option_c,' ',key.correct_ans==key.option_c?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px',color:'green'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px',fontSize:'14px'}},'D. ',key.option_d,' ',key.correct_ans==key.option_d?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px',color:'green'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px',fontSize:'14px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginTop:'13px',padding:'2px'}},'Your Answer : ',key.id==1?key.ans_q1:key.id==2?key.ans_q2:key.id==3?key.ans_q3:key.id==4?key.ans_q4:key.id==5?key.ans_q5:key.id==6?key.ans_q6:key.id==7?key.ans_q7:key.id==8?key.ans_q8:key.id==9?key.ans_q9:key.id==10?key.ans_q10:key.id==11?key.ans_q11:key.id==12?key.ans_q12:key.id==13?key.ans_q13:key.id==14?key.ans_q14:key.id==15?key.ans_q15:key.id==16?key.ans_q16:key.id==17?key.ans_q17:key.id==18?key.ans_q18:key.id==19?key.ans_q19:key.id==20?key.ans_q20:key.id==21?key.ans_q21:key.id==22?key.ans_q22:key.id==23?key.ans_q23:key.id==24?key.ans_q24:key.id==25?key.ans_q25:key.id==26?key.ans_q26:key.id==27?key.ans_q27:key.id==28?key.ans_q28:key.id==29?key.ans_q29:key.id==30?key.ans_q30:key.id==31?key.ans_q31:key.id==32?key.ans_q32:key.id==33?key.ans_q33:key.id==34?key.ans_q34:key.id==35?key.ans_q35:key.id==36?key.ans_q36:key.id==37?key.ans_q37:key.id==38?key.ans_q38:key.id==39?key.ans_q39:key.id==40?key.ans_q40:key.id==41?key.ans_q41:key.id==42?key.ans_q42:key.id==43?key.ans_q43:key.id==44?key.ans_q44:key.id==45?key.ans_q45:key.id==46?key.ans_q46:key.id==47?key.ans_q47:key.id==48?key.ans_q48:key.id==49?key.ans_q49:key.id==50?key.ans_q50:key.id==51?key.ans_q51:key.id==52?key.ans_q52:key.id==53?key.ans_q53:key.id==54?key.ans_q54:key.id==55?key.ans_q55:key.id==56?key.ans_q56:key.id==57?key.ans_q57:key.id==58?key.ans_q58:key.id==59?key.ans_q59:key.id==60?key.ans_q60:"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 20px 0px 0px',height:'33px',fontSize:'14px'}},'Score :',key.id==1?key.correct_ans==key.ans_q1?"1":"0":key.id==2?key.correct_ans==key.ans_q2?"1":"0":key.id==3?key.correct_ans==key.ans_q3?"1":"0":key.id==4?key.correct_ans==key.ans_q4?"1":"0":key.id==5?key.correct_ans==key.ans_q5?"1":"0":key.id==6?key.correct_ans==key.ans_q6?"1":"0":key.id==7?key.correct_ans==key.ans_q7?"1":"0":key.id==8?key.correct_ans==key.ans_q8?"1":"0":key.id==9?key.correct_ans==key.ans_q9?"1":"0":key.id==10?key.correct_ans==key.ans_q10?"1":"0":key.id==11?key.correct_ans==key.ans_q11?"1":"0":key.id==12?key.correct_ans==key.ans_q12?"1":"0":key.id==13?key.correct_ans==key.ans_q13?"1":"0":key.id==14?key.correct_ans==key.ans_q14?"1":"0":key.id==15?key.correct_ans==key.ans_q15?"1":"0":key.id==16?key.correct_ans==key.ans_q16?"1":"0":key.id==17?key.correct_ans==key.ans_q17?"1":"0":key.id==18?key.correct_ans==key.ans_q18?"1":"0":key.id==19?key.correct_ans==key.ans_q19?"1":"0":key.id==20?key.correct_ans==key.ans_q20?"1":"0":key.id==21?key.correct_ans==key.ans_q21?"1":"0":key.id==22?key.correct_ans==key.ans_q22?"1":"0":key.id==23?key.correct_ans==key.ans_q23?"1":"0":key.id==24?key.correct_ans==key.ans_q24?"1":"0":key.id==25?key.correct_ans==key.ans_q25?"1":"0":key.id==26?key.correct_ans==key.ans_q26?"1":"0":key.id==27?key.correct_ans==key.ans_q27?"1":"0":key.id==28?key.correct_ans==key.ans_q28?"1":"0":key.id==29?key.correct_ans==key.ans_q29?"1":"0":key.id==30?key.correct_ans==key.ans_q30?"1":"0":key.id==31?key.correct_ans==key.ans_q31?"1":"0":key.id==32?key.correct_ans==key.ans_q32?"1":"0":key.id==33?key.correct_ans==key.ans_q33?"1":"0":key.id==34?key.correct_ans==key.ans_q34?"1":"0":key.id==35?key.correct_ans==key.ans_q35?"1":"0":key.id==36?key.correct_ans==key.ans_q36?"1":"0":key.id==37?key.correct_ans==key.ans_q37?"1":"0":key.id==38?key.correct_ans==key.ans_q38?"1":"0":key.id==39?key.correct_ans==key.ans_q39?"1":"0":key.id==40?key.correct_ans==key.ans_q40?"1":"0":key.id==41?key.correct_ans==key.ans_q41?"1":"0":key.id==42?key.correct_ans==key.ans_q42?"1":"0":key.id==43?key.correct_ans==key.ans_q43?"1":"0":key.id==44?key.correct_ans==key.ans_q44?"1":"0":key.id==45?key.correct_ans==key.ans_q45?"1":"0":key.id==46?key.correct_ans==key.ans_q46?"1":"0":key.id==47?key.correct_ans==key.ans_q47?"1":"0":key.id==48?key.correct_ans==key.ans_q48?"1":"0":key.id==49?key.correct_ans==key.ans_q49?"1":"0":key.id==50?key.correct_ans==key.ans_q50?"1":"0":key.id==51?key.correct_ans==key.ans_q51?"1":"0":key.id==52?key.correct_ans==key.ans_q52?"1":"0":key.id==53?key.correct_ans==key.ans_q53?"1":"0":key.id==54?key.correct_ans==key.ans_q54?"1":"0":key.id==55?key.correct_ans==key.ans_q55?"1":"0":key.id==56?key.correct_ans==key.ans_q56?"1":"0":key.id==57?key.correct_ans==key.ans_q57?"1":"0":key.id==58?key.correct_ans==key.ans_q58?"1":"0":key.id==59?key.correct_ans==key.ans_q59?"1":"0":key.id==60?key.correct_ans==key.ans_q60?"1":"0":"")));}if(key.lr_room_id!="6651"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'divid_comp_'+index},key.is_ag>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:'left',marginRight:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img_action_goal.gif',style:{height:'40px'},title:'Action Goal'})),key.compo_type=="learningmaterial"&&_this7.lr_id!="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:'left',marginRight:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/mn.PNG',style:{height:'40px'},title:'Go To Material'})):_this7.lr_id=="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:key.spanclass,title:key.name}),_this7.lr_id!="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:key.status}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),key.compo_type=="learningmaterial"&&_this7.lr_id!="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:key.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(e){return _this7.updateCourse(key.course_id,key.learner_id,key.name);},style:{marginLeft:'4px'}},'Go To Course')):_this7.lr_id=="6651"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:key.divider_status!=0?function(e){return _this7.openthecompoents(key);}:function(e){return _this7.predividernotcompleted();}},key.name));}});//return renderdata.prepend(strv);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',renderdata,' ',tabledata,' ',strv,' ');}},{key:'render',value:function render(){var _this8=this;var ecoach_exists=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("ecoach_exists",true);var corporateID=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])('corporateID',true);var _props=this.props,lr_id=_props.lr_id,dlr_id=_props.dlr_id;var componentBlock=null;if(this.state.component_type){componentBlock=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport viewport1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},this.state.componentPanel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/completed.png',alt:'',align:'absmiddle',border:'0'}),' Completed ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/incompleted.png',alt:'',border:'0'}),' Partially Completed'));}else{componentBlock=this.state.componentPanel;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__partials_WritingNotePad__["a" /* default */],{name:this.state.learning_room_name,lr_id:this.lr_id,dlr_id:this.dlrid,notesList:this.goToNotesList}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-lr.png',align:'absmiddle',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-room'},this.state.learning_room_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-buttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,ecoach_exists!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this8.goToNotesList('ec_profile');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/profile-icon.png',alt:'E-Coach Profile',title:'E-Coach Profile'}))):null,corporateID!=77?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);','data-modal-id':'popup2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/writting-pad-grn.png',alt:'Writing Pad',title:'Writing Pad'}))):'',!this.state.component_type&&corporateID!=77&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this8.compolist('component_list',_this8.lr_id,_this8.dlrid);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/back-icon.png',alt:'Back',title:'Back'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-home'},' ',componentBlock,' '));}}]);return Componetlist;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Componetlist);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_learningRoomAction__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Contentproceed=function(_Component){_inherits(Contentproceed,_Component);function Contentproceed(props){_classCallCheck(this,Contentproceed);var _this=_possibleConstructorReturn(this,(Contentproceed.__proto__||Object.getPrototypeOf(Contentproceed)).call(this,props));_this.state={LearningCompletedStatus:[],proceedStatus:0};return _this;}_createClass(Contentproceed,[{key:'getLearningCompletedStatus',value:function getLearningCompletedStatus(){var _this2=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */]({learner_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])(),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,dlr_id:data.dlr_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'learner-component-status/view'+query_data+'?expand=completed_date',{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){_this2.setState({LearningCompletedStatus:responseJson.data});}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'continueTocomponentList',value:function continueTocomponentList(){this.props.backToComponentList();}},{key:'proceed',value:function proceed(){var _this3=this;var data=this.props.data;var query_data={comp_id:data.id,learner_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])(),compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,dlrid:data.dlr_id,ag:data.is_ag!=""?data.ag_id:""};window.swal({// title: 'Attention!',
text:'Proceed?',//type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'contracts/proceed',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify(query_data)}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["w" /* scrollToTop */]();_this3.props.getLearningRoom();if(responseJson.isCompletedFully){_this3.props.goToThanksPage();}else{_this3.setState({proceedStatus:responseJson.status});_this3.getLearningCompletedStatus();}});}});}},{key:'PrintElem',value:function PrintElem(){if(this.props.usableType=="webapp"){var contract=this.props.contract;var content="<div>"+$('#contract_content').html()+"</div>";var contract_btm="<div>"+$('#signature_con').html()+"</div>";var mywindow=window.open('','PRINT','height=400,width=600');mywindow.document.write( true?contract.contract_name:''+'</title>');mywindow.document.write('</head><body >');mywindow.document.write(content+contract_btm);mywindow.document.write('</body></html>');mywindow.document.close();// necessary for IE >= 10
mywindow.focus();// necessary for IE >= 10*/
mywindow.print();mywindow.close();return true;}else{window.print();}}},{key:'declineBlock',value:function declineBlock(){this.props.declineBlock();}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;if(data.status=="completed"){this.getLearningCompletedStatus();this.setState({proceedStatus:2});}}},{key:'render',value:function render(){var _this4=this;var _props=this.props,data=_props.data,contract=_props.contract;var LearningCompletedStatus=this.state.LearningCompletedStatus;var buttonSection1=null;var buttonSection2=null;if(this.state.proceedStatus==2){data.status='completed';}if(data.status!="completed"||this.state.proceedStatus==0){buttonSection1=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button-accept',onClick:function onClick(e){return _this4.proceed();},value:contract.button_one?contract.button_one:'',title:contract.button_one?contract.button_one:'',id:'proceed',name:'proceed',style:{float:'right'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button-cancel',value:contract.button_two?contract.button_two:'',title:contract.button_two?contract.button_two:'',onClick:function onClick(e){return _this4.declineBlock();},id:'cancel',name:'cancel',style:{float:'right'}})));}if(data.status=="completed"||this.state.proceedStatus==2){buttonSection2=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'signature_con',className:'contract-btm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},contract.button_one?contract.button_one:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contract_print'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'orgtxt'},'- ',Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["b" /* Username */])()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\xA0 Signed on date ',LearningCompletedStatus.completed_date?LearningCompletedStatus.completed_date:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'Print',id:'Print',value:'Print this contract',onClick:function onClick(){return _this4.PrintElem();},className:'button-blue',alt:'Print this contract',title:'Print this contract',style:{float:'right'}}):"",this.props.usableType=="webapp"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.continueTocomponentList();},name:'btnsubmit',value:'Continue',alt:'Continue',title:'Continue',className:'button_org',style:{float:'right'}}):""))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scroll',id:'semana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules-regulations'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'contract_content',dangerouslySetInnerHTML:{__html:contract.contract_content?contract.contract_content:''}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divcontract'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thanksmsg'},buttonSection1,buttonSection2))))));}}]);return Contentproceed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_6__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Contentproceed));

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Decline=function(_Component){_inherits(Decline,_Component);function Decline(props){_classCallCheck(this,Decline);var _this=_possibleConstructorReturn(this,(Decline.__proto__||Object.getPrototypeOf(Decline)).call(this,props));_this.state={};return _this;}_createClass(Decline,[{key:"continueContract",value:function continueContract(){this.props.continueContract();}},{key:"declineContract",value:function declineContract(){this.props.declineContract();}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"scroll",id:"semana-scroll-inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"viewport"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"overview"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"rules-regulations"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"thanksmsg5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"contractrej"},"You have chosen to quit this Program!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This means your PIN will be deactivated immediately and any information you have entered during this Program will be lost.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"button",name:"btnsubmit",value:"Continue Learning",alt:"Continue Learning",title:"Continue Learning",className:"button-accept contrarejbtn",onClick:function onClick(e){return _this2.continueContract();},style:{float:'right'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"button",onClick:function onClick(e){return _this2.declineContract();},name:"btnsubmit",value:"Quit the Program",alt:"Quit the Program",title:"Quit the Program",className:"button-cancel mail-icon",style:{float:'right'}})))))));}}]);return Decline;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Decline);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSAlert = __webpack_require__(225);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _TableHeaderColumn = __webpack_require__(227);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _TableHeader = __webpack_require__(450);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableFooter = __webpack_require__(453);

var _TableFooter2 = _interopRequireDefault(_TableFooter);

var _TableBody = __webpack_require__(454);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _PaginationList = __webpack_require__(459);

var _PaginationList2 = _interopRequireDefault(_PaginationList);

var _ToolBar = __webpack_require__(461);

var _ToolBar2 = _interopRequireDefault(_ToolBar);

var _TableFilter = __webpack_require__(471);

var _TableFilter2 = _interopRequireDefault(_TableFilter);

var _TableDataStore = __webpack_require__(472);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

var _csv_export_util = __webpack_require__(473);

var _csv_export_util2 = _interopRequireDefault(_csv_export_util);

var _Filter = __webpack_require__(477);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-alert: 0 */
/* eslint max-len: 0 */


var BootstrapTable = function (_Component) {
  _inherits(BootstrapTable, _Component);

  function BootstrapTable(props) {
    _classCallCheck(this, BootstrapTable);

    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));

    _this.handleSort = function () {
      return _this.__handleSort__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExpandRow = function () {
      return _this.__handleExpandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handlePaginationData = function () {
      return _this.__handlePaginationData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseLeave = function () {
      return _this.__handleMouseLeave__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseEnter = function () {
      return _this.__handleMouseEnter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleNavigateCell = function () {
      return _this.__handleNavigateCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectAllRow = function () {
      return _this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlySelected = function () {
      return _this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleAddRow = function () {
      return _this.__handleAddRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getPageByRowKey = function () {
      return _this.__getPageByRowKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRow = function () {
      return _this.__handleDropRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilterData = function () {
      return _this.__handleFilterData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSearch = function () {
      return _this.__handleSearch__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollTop = function () {
      return _this.___scrollTop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollHeader = function () {
      return _this.___scrollHeader__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollFooter = function () {
      return _this.___scrollFooter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.isIE = false;
    if (_util2.default.canUseDOM()) {
      _this.isIE = document.documentMode;
    }
    _this.store = new _TableDataStore.TableDataStore(_this.props.data ? _this.props.data.slice() : []);
    _this.isVerticalScroll = false;
    _this.initTable(_this.props);

    if (_this.props.selectRow && _this.props.selectRow.selected) {
      var copy = _this.props.selectRow.selected.slice();
      _this.store.setSelectedRowKey(copy);
    }
    var currPage = _Const2.default.PAGE_START_INDEX;
    if (typeof _this.props.options.page !== 'undefined') {
      currPage = _this.props.options.page;
    } else if (typeof _this.props.options.pageStartIndex !== 'undefined') {
      currPage = _this.props.options.pageStartIndex;
    }

    _this._adjustHeaderWidth = _this._adjustHeaderWidth.bind(_this);
    _this._adjustHeight = _this._adjustHeight.bind(_this);
    _this._adjustTable = _this._adjustTable.bind(_this);
    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);

    var expandedKeys = [];
    if (_this.props.options.expandAllChilds !== null && _this.props.options.expandAllChilds !== undefined && _this.props.options.expandAllChilds) {
      expandedKeys = _this.store.getAllRowkey();
    } else if (_this.props.options.expanding !== undefined && _this.props.options.expanding !== null) {
      expandedKeys = _this.props.options.expanding;
    }

    _this.state = {
      data: _this.getTableData(),
      currPage: currPage,
      expanding: expandedKeys,
      sizePerPage: _this.props.options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0],
      selectedRowKeys: _this.store.getSelectedRowKeys(),
      reset: false,
      x: _this.props.keyBoardNav ? 0 : -1,
      y: _this.props.keyBoardNav ? 0 : -1
    };
    return _this;
  }

  _createClass(BootstrapTable, [{
    key: '___scrollFooter__REACT_HOT_LOADER__',
    value: function ___scrollFooter__REACT_HOT_LOADER__() {
      return this.___scrollFooter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__() {
      return this.___scrollHeader__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      return this.___scrollTop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__() {
      return this.__handleSearch__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__() {
      return this.__handleFilterData__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__() {
      return this.__handleDropRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__() {
      return this.__getPageByRowKey__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__() {
      return this.__handleAddRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__() {
      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__() {
      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      return this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__() {
      return this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__() {
      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__() {
      return this.__handleNavigateCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      return this.__handleMouseEnter__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      return this.__handleMouseLeave__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__() {
      return this.__handlePaginationData__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__() {
      return this.__handleExpandRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__() {
      return this.__handleSort__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'initTable',
    value: function initTable(props) {
      var _this2 = this;

      // If columns changed, clean removed columns that had filters
      if (props.children !== this.props.children && this.filter) {
        var nextDataFields = _react2.default.Children.map(props.children, function (column) {
          return column.props.dataField;
        });
        _react2.default.Children.forEach(this.props.children, function (column) {
          var _column$props = column.props,
              dataField = _column$props.dataField,
              filter = _column$props.filter;

          if (filter && !nextDataFields.includes(dataField)) {
            // Clear filter
            _this2.filter.handleFilter(dataField, '', filter.type, filter);
          }
        });
      }

      var keyField = props.keyField;


      var isKeyFieldDefined = typeof keyField === 'string' && keyField.length;
      _react2.default.Children.forEach(props.children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }
        if (column.props.isKey) {
          if (keyField) {
            throw new Error('Error. Multiple key column detected in TableHeaderColumn.');
          }
          keyField = column.props.dataField;
        }
        if (column.props.filter) {
          // a column contains a filter
          if (!_this2.filter) {
            // first time create the filter on the BootstrapTable
            _this2.filter = new _Filter.Filter();
          }
          // pass the filter to column with filter
          column.props.filter.emitter = _this2.filter;
        }
      });

      // if a column filter was created, add 'onFilterChange' listener
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
        this.filter.on('onFilterChange', function (currentFilter) {
          _this2.handleFilterData(currentFilter);
        });
      }

      this.colInfos = this.getColumnsDescription(props).reduce(function (prev, curr) {
        prev[curr.name] = curr;
        return prev;
      }, {});

      if (!isKeyFieldDefined && !keyField) {
        throw new Error('Error. No any key column defined in TableHeaderColumn.\n            Use \'isKey={true}\' to specify a unique column after version 0.5.4.');
      }

      this.store.setProps({
        isPagination: props.pagination,
        keyField: keyField,
        colInfos: this.colInfos,
        multiColumnSearch: props.multiColumnSearch,
        strictSearch: props.strictSearch,
        multiColumnSort: props.multiColumnSort,
        remote: this.props.remote
      });
    }
  }, {
    key: 'getTableData',
    value: function getTableData() {
      var result = [];
      var _props = this.props,
          options = _props.options,
          pagination = _props.pagination;

      var sortName = options.defaultSortName || options.sortName;
      var sortOrder = options.defaultSortOrder || options.sortOrder;
      var searchText = options.defaultSearch;

      if (sortName && sortOrder) {
        this.store.setSortInfo(sortOrder, sortName);
        if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
          this.store.sort();
        }
      }

      if (searchText) {
        this.store.search(searchText);
      }

      if (pagination) {
        var page = void 0;
        var sizePerPage = void 0;
        if (this.store.isChangedPage()) {
          sizePerPage = this.state.sizePerPage;
          page = this.state.currPage;
        } else {
          sizePerPage = options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0];
          page = options.page || 1;
        }
        result = this.store.page(page, sizePerPage).get();
      } else {
        result = this.store.get();
      }
      return result;
    }
  }, {
    key: 'getColumnsDescription',
    value: function getColumnsDescription(_ref) {
      var _this3 = this;

      var children = _ref.children;

      var rowCount = 0;
      _react2.default.Children.forEach(children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }

        if (Number(column.props.row) > rowCount) {
          rowCount = Number(column.props.row);
        }
      });
      return _react2.default.Children.map(children, function (column, i) {
        if (column === null || column === undefined) {
          // Return null for empty objects
          return null;
        }

        var rowIndex = column.props.row ? Number(column.props.row) : 0;
        var rowSpan = column.props.rowSpan ? Number(column.props.rowSpan) : 1;
        if (rowSpan + rowIndex === rowCount + 1) {
          var columnDescription = _this3.getColumnDescription(column);

          columnDescription.index = i;
          return columnDescription;
        }
      });
    }
  }, {
    key: 'getColumnDescription',
    value: function getColumnDescription(column) {
      var columnDescription = {
        name: column.props.dataField,
        align: column.props.dataAlign,
        sort: column.props.dataSort,
        format: column.props.dataFormat,
        formatExtraData: column.props.formatExtraData,
        filterFormatted: column.props.filterFormatted,
        filterValue: column.props.filterValue,
        editable: column.props.editable,
        customEditor: column.props.customEditor,
        hidden: column.props.hidden,
        hiddenOnInsert: column.props.hiddenOnInsert,
        searchable: column.props.searchable,
        className: column.props.columnClassName,
        editClassName: column.props.editColumnClassName,
        invalidEditColumnClassName: column.props.invalidEditColumnClassName,
        columnTitle: column.props.columnTitle,
        width: column.props.width,
        text: column.props.headerText || column.props.children,
        sortFunc: column.props.sortFunc,
        sortFuncExtraData: column.props.sortFuncExtraData,
        export: column.props.export,
        expandable: column.props.expandable,
        attrs: column.props.tdAttr,
        editAttrs: column.props.editTdAttr,
        style: column.props.tdStyle
      };

      if (column.type.name !== _TableHeaderColumn2.default.name && _react2.default.isValidElement(column.props.children)) {
        columnDescription = _extends({}, columnDescription, this.getColumnDescription(_react2.default.Children.only(column.props.children)));
      }

      return columnDescription;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      var pageStartIndex = this.props.options.pageStartIndex;

      this.store.clean();
      this.body.setState({ currEditCell: null });
      this.setState(function () {
        return {
          data: _this4.getTableData(),
          currPage: _util2.default.getFirstPage(pageStartIndex),
          expanding: [],
          sizePerPage: _Const2.default.SIZE_PER_PAGE_LIST[0],
          selectedRowKeys: [],
          reset: true
        };
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.initTable(nextProps);
      var options = nextProps.options,
          selectRow = nextProps.selectRow;
      var replace = nextProps.replace;

      replace = replace || this.props.replace;

      if (!nextProps.data) {
        return;
      }
      this.store.setData(nextProps.data.slice());

      if (!replace) {
        // from #481
        var page = this.state.currPage;
        if (this.props.options.page !== options.page) {
          page = options.page;
        }
        // from #481
        var sizePerPage = this.state.sizePerPage;
        if (this.props.options.sizePerPage !== options.sizePerPage) {
          sizePerPage = options.sizePerPage;
        }

        if (this.isRemoteDataSource()) {
          var newState = { sizePerPage: sizePerPage, reset: false, currPage: page };
          var data = nextProps.data.slice();
          if (nextProps.pagination && !this.allowRemote(_Const2.default.REMOTE_PAGE)) {
            data = this.store.page(page, sizePerPage).get();
          }

          if (this.store.isOnFilter) {
            if (this.store.searchText) this.handleSearch(this.store.searchText);
            if (this.store.filterObj) this.handleFilterData(this.store.filterObj);
            newState.currPage = _util2.default.getFirstPage(nextProps.options.pageStartIndex);
          } else {
            if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
              data = this.store.sort().get();
            } else {
              var currentOptions = this.props.options;

              var sortName = options.sortName;
              var sortOrder = options.sortOrder;
              if (currentOptions.sortName !== sortName || currentOptions.sortOrder !== sortOrder) {
                this.store.setSortInfo(sortOrder, options.sortName);
              }
            }
            newState.data = data;
          }
          this.setState(function () {
            return newState;
          });
        } else {
          // #125
          // remove !options.page for #709
          if (page > Math.ceil(nextProps.data.length / sizePerPage)) {
            page = 1;
          }
          var sortList = this.store.getSortInfo();
          var sortField = options.sortName;
          var _sortOrder = options.sortOrder;
          if (sortField && _sortOrder) {
            this.store.setSortInfo(_sortOrder, sortField);
            this.store.sort();
          } else if (sortList.length > 0) {
            this.store.sort();
          }
          var _data = this.store.page(page, sizePerPage).get();
          this.setState(function () {
            return {
              data: _data,
              currPage: page,
              sizePerPage: sizePerPage,
              reset: false
            };
          });

          if (this.store.isSearching && options.afterSearch) {
            options.afterSearch(this.store.searchText, this.store.getDataIgnoringPagination());
          }

          if (this.store.isFiltering && options.afterColumnFilter) {
            options.afterColumnFilter(this.store.filterObj, this.store.getDataIgnoringPagination());
          }
        }

        // If setting the expanded rows is being handled externally
        // then overwrite the current expanded rows.
        if (this.props.options.expanding !== options.expanding) {
          this.setState(function () {
            return {
              expanding: options.expanding || []
            };
          });
        }

        if (selectRow && selectRow.selected) {
          // set default select rows to store.
          var copy = selectRow.selected.slice();
          this.store.setSelectedRowKey(copy);
          this.setState(function () {
            return {
              selectedRowKeys: copy,
              reset: false
            };
          });
        }
      } else {
        this.reset();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._adjustTable();
      window.addEventListener('resize', this._adjustTable);
      this.body.container.addEventListener('scroll', this._scrollHeader);
      if (this.props.footer) {
        this.body.container.addEventListener('scroll', this._scrollFooter);
      }
      if (this.props.scrollTop) {
        this._scrollTop();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._adjustTable);
      if (this.body && this.body.container) {
        this.body.container.removeEventListener('scroll', this._scrollHeader);
        if (this.props.footer) {
          this.body.container.removeEventListener('scroll', this._scrollFooter);
        }
      }
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._adjustTable();
      if (this.props.options.afterTableComplete) {
        this.props.options.afterTableComplete();
      }
    }

    /**
     * Returns true if in the current configuration,
     * the datagrid should load its data remotely.
     *
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'isRemoteDataSource',
    value: function isRemoteDataSource(props) {
      var _ref2 = props || this.props,
          remote = _ref2.remote;

      return remote === true || _util2.default.isFunction(remote);
    }

    /**
     * Returns true if this action can be handled remote store
     * From #990, Sometimes, we need some actions as remote, some actions are handled by default
     * so function will tell you the target action is can be handled as remote or not.
     * @param  {String}  [action] Required.
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'allowRemote',
    value: function allowRemote(action, props) {
      var _ref3 = props || this.props,
          remote = _ref3.remote;

      if (typeof remote === 'function') {
        var remoteObj = remote(_Const2.default.REMOTE);
        return remoteObj[action];
      } else {
        return remote;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var style = {
        height: this.props.height,
        maxHeight: this.props.maxHeight
      };

      var columns = this.getColumnsDescription(this.props);
      var sortList = this.store.getSortInfo();
      var pagination = this.renderPagination();
      var toolBar = this.renderToolBar();
      var tableFilter = this.renderTableFilter(columns);
      var isSelectAll = this.isSelectAll();
      var expandColumnOptions = this.props.expandColumnOptions;
      if (typeof expandColumnOptions.expandColumnBeforeSelectColumn === 'undefined') {
        expandColumnOptions.expandColumnBeforeSelectColumn = true;
      }
      var colGroups = _util2.default.renderColGroup(columns, this.props.selectRow, expandColumnOptions, this.props.version);
      var tableFooter = this.renderTableFooter(this.props.footerData, this.state.data, columns, colGroups);
      var sortIndicator = this.props.options.sortIndicator;
      if (typeof this.props.options.sortIndicator === 'undefined') sortIndicator = true;

      var _props$options$pagina = this.props.options.paginationPosition,
          paginationPosition = _props$options$pagina === undefined ? _Const2.default.PAGINATION_POS_BOTTOM : _props$options$pagina;

      var showPaginationOnTop = paginationPosition !== _Const2.default.PAGINATION_POS_BOTTOM;
      var showPaginationOnBottom = paginationPosition !== _Const2.default.PAGINATION_POS_TOP;
      var selectRow = _extends({}, this.props.selectRow);
      if (this.props.cellEdit && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_NONE) {
        selectRow.clickToSelect = false;
      }

      var _props$options$toolba = this.props.options.toolbarPosition,
          toolbarPosition = _props$options$toolba === undefined ? _Const2.default.TOOLBAR_POS_TOP : _props$options$toolba;

      var showToolbarOnTop = toolbarPosition !== _Const2.default.TOOLBAR_POS_BOTTOM;
      var showToolbarOnBottom = toolbarPosition !== _Const2.default.TOOLBAR_POS_TOP;
      var _props$options$hideRo = this.props.options.hideRowOnExpand,
          hideRowOnExpand = _props$options$hideRo === undefined ? false : _props$options$hideRo;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('react-bs-table-container', this.props.className, this.props.containerClass),
          style: this.props.containerStyle },
        showToolbarOnTop ? toolBar : null,
        showPaginationOnTop ? pagination : null,
        _react2.default.createElement(
          'div',
          { ref: function ref(node) {
              return _this5.table = node;
            },
            className: (0, _classnames2.default)('react-bs-table', { 'react-bs-table-bordered': this.props.bordered }, this.props.tableContainerClass),
            style: _extends({}, style, this.props.tableStyle),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave },
          _react2.default.createElement(
            _TableHeader2.default,
            {
              ref: function ref(node) {
                return _this5.header = node;
              },
              version: this.props.version,
              colGroups: colGroups,
              headerContainerClass: this.props.headerContainerClass,
              tableHeaderClass: this.props.tableHeaderClass,
              style: this.props.headerStyle,
              rowSelectType: this.props.selectRow.mode,
              customComponent: this.props.selectRow.customComponent,
              hideSelectColumn: this.props.selectRow.hideSelectColumn,
              sortList: sortList,
              sortIndicator: sortIndicator,
              onSort: this.handleSort,
              onSelectAllRow: this.handleSelectAllRow,
              bordered: this.props.bordered,
              condensed: this.props.condensed,
              isFiltered: this.filter ? true : false,
              isSelectAll: isSelectAll,
              reset: this.state.reset,
              expandColumnVisible: expandColumnOptions.expandColumnVisible,
              expandColumnComponent: expandColumnOptions.expandColumnComponent,
              expandedColumnHeaderComponent: expandColumnOptions.expandedColumnHeaderComponent,
              noAnyExpand: this.state.expanding.length === 0,
              expandAll: this.props.options.expandAll,
              toggleExpandAllChilds: this.toggleExpandAllChilds,
              expandColumnBeforeSelectColumn: expandColumnOptions.expandColumnBeforeSelectColumn },
            this.props.children
          ),
          _react2.default.createElement(_TableBody2.default, {
            ref: function ref(node) {
              return _this5.body = node;
            },
            bodyContainerClass: this.props.bodyContainerClass,
            tableBodyClass: this.props.tableBodyClass,
            style: _extends({}, style, this.props.bodyStyle),
            data: this.state.data,
            version: this.props.version,
            expandComponent: this.props.expandComponent,
            expandableRow: this.props.expandableRow,
            expandRowBgColor: this.props.options.expandRowBgColor,
            expandBy: this.props.options.expandBy || _Const2.default.EXPAND_BY_ROW,
            expandBodyClass: this.props.options.expandBodyClass,
            expandParentClass: this.props.options.expandParentClass,
            columns: columns,
            trClassName: this.props.trClassName,
            trStyle: this.props.trStyle,
            striped: this.props.striped,
            bordered: this.props.bordered,
            hover: this.props.hover,
            keyField: this.store.getKeyField(),
            condensed: this.props.condensed,
            selectRow: selectRow,
            expandColumnOptions: this.props.expandColumnOptions,
            cellEdit: this.props.cellEdit,
            selectedRowKeys: this.state.selectedRowKeys,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            noDataText: this.props.options.noDataText,
            withoutNoDataText: this.props.options.withoutNoDataText,
            expanding: this.state.expanding,
            onExpand: this.handleExpandRow,
            onlyOneExpanding: this.props.options.onlyOneExpanding,
            beforeShowError: this.props.options.beforeShowError,
            keyBoardNav: this.props.keyBoardNav,
            onNavigateCell: this.handleNavigateCell,
            x: this.state.x,
            y: this.state.y,
            withoutTabIndex: this.props.withoutTabIndex,
            hideRowOnExpand: hideRowOnExpand,
            onEditCell: this.handleEditCell }),
          tableFooter
        ),
        tableFilter,
        showPaginationOnBottom ? pagination : null,
        showToolbarOnBottom ? toolBar : null,
        this.props.renderAlert ? _react2.default.createElement(_reactSAlert2.default, { stack: { limit: 3 } }) : null
      );
    }
  }, {
    key: 'isSelectAll',
    value: function isSelectAll() {
      if (this.store.isEmpty()) return false;
      var _props$selectRow = this.props.selectRow,
          unselectable = _props$selectRow.unselectable,
          onlyUnselectVisible = _props$selectRow.onlyUnselectVisible;

      var keyField = this.store.getKeyField();
      var allRowKeys = onlyUnselectVisible ? this.store.get().map(function (r) {
        return r[keyField];
      }) : this.store.getAllRowkey();
      var defaultSelectRowKeys = this.store.getSelectedRowKeys();

      if (onlyUnselectVisible) {
        defaultSelectRowKeys = defaultSelectRowKeys.filter(function (x) {
          return x !== allRowKeys;
        });
      }

      if (defaultSelectRowKeys.length === 0) return false;
      var match = 0;
      var noFound = 0;
      var unSelectableCnt = 0;
      defaultSelectRowKeys.forEach(function (selected) {
        if (allRowKeys.indexOf(selected) !== -1) match++;else noFound++;
        if (unselectable && unselectable.indexOf(selected) !== -1) unSelectableCnt++;
      });

      if (noFound === defaultSelectRowKeys.length) return false;
      if (match === allRowKeys.length) {
        return true;
      } else {
        if (unselectable && match <= unSelectableCnt && unSelectableCnt === unselectable.length) return false;else return 'indeterminate';
      }
      // return (match === allRowKeys.length) ? true : 'indeterminate';
    }
  }, {
    key: 'cleanSelected',
    value: function cleanSelected() {
      this.store.setSelectedRowKey([]);
      this.setState(function () {
        return {
          selectedRowKeys: [],
          reset: false
        };
      });
    }
  }, {
    key: 'cleanSort',
    value: function cleanSort() {
      this.store.cleanSortInfo();
      this.setState(function () {
        return {
          reset: false
        };
      });
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__(order, sortField) {
      var _props2 = this.props,
          sort = _props2.autoCollapse.sort,
          options = _props2.options;

      if (options.onSortChange) {
        options.onSortChange(sortField, order, this.props);
      }
      this.store.setSortInfo(order, sortField);
      if (this.allowRemote(_Const2.default.REMOTE_SORT)) {
        if (sort) {
          this.setState(function () {
            return {
              expanding: []
            };
          });
        }
        return;
      }

      var result = this.store.sort().get();
      this.setState(function () {
        var newState = {
          data: result,
          reset: false
        };
        if (sort) newState.expanding = [];
        return newState;
      });
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__(expanding, rowKey, isRowExpanding, event) {
      var _this6 = this;

      var onExpand = this.props.options.onExpand;

      if (onExpand) {
        onExpand(rowKey, !isRowExpanding, event);
      }
      this.setState(function () {
        return { expanding: expanding, reset: false };
      }, function () {
        _this6._adjustHeaderWidth();
      });
    }
  }, {
    key: 'toggleExpandAllChilds',
    value: function toggleExpandAllChilds() {
      var _this7 = this;

      var expanding = this.state.expanding;

      if (expanding.length > 0) {
        this.setState(function () {
          return {
            expanding: [],
            reset: false
          };
        });
      } else {
        this.setState(function () {
          return {
            expanding: _this7.store.getAllRowkey(),
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__(page, sizePerPage) {
      var _props$options = this.props.options,
          onPageChange = _props$options.onPageChange,
          pageStartIndex = _props$options.pageStartIndex;

      var emptyTable = this.store.isEmpty();
      if (onPageChange) {
        onPageChange(page, sizePerPage);
      }

      var state = {
        sizePerPage: sizePerPage,
        reset: false
      };
      if (!emptyTable) state.currPage = page;
      this.setState(function () {
        return state;
      });

      if (this.allowRemote(_Const2.default.REMOTE_PAGE) || emptyTable) {
        return;
      }

      var result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, page), sizePerPage).get();
      this.setState(function () {
        return { data: result, reset: false };
      });
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseLeave) {
        this.props.options.onMouseLeave();
      }
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseEnter) {
        this.props.options.onMouseEnter();
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOut) {
        this.props.options.onRowMouseOut(row, event);
      }
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOver) {
        this.props.options.onRowMouseOver(row, event);
      }
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__(_ref4) {
      var offSetX = _ref4.x,
          offSetY = _ref4.y,
          lastEditCell = _ref4.lastEditCell;
      var pagination = this.props.pagination;
      var _state = this.state,
          x = _state.x,
          y = _state.y,
          currPage = _state.currPage;

      x += offSetX;
      y += offSetY;

      var columns = this.store.getColInfos();
      var visibleRowSize = this.state.data.length;
      var visibleColumnSize = Object.keys(columns).filter(function (k) {
        return !columns[k].hidden;
      }).length;

      if (y >= visibleRowSize) {
        currPage++;
        var lastPage = pagination ? this.pagination.getLastPage() : -1;
        if (currPage <= lastPage) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = 0;
      } else if (y < 0) {
        currPage--;
        if (currPage > 0) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = visibleRowSize - 1;
      } else if (x >= visibleColumnSize) {
        if (y + 1 === visibleRowSize) {
          currPage++;
          var _lastPage = pagination ? this.pagination.getLastPage() : -1;
          if (currPage <= _lastPage) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = 0;
        } else {
          y++;
        }
        x = lastEditCell ? 1 : 0;
      } else if (x < 0) {
        x = visibleColumnSize - 1;
        if (y === 0) {
          currPage--;
          if (currPage > 0) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = this.state.sizePerPage - 1;
        } else {
          y--;
        }
      }
      this.setState(function () {
        return {
          x: x, y: y, currPage: currPage, reset: false
        };
      });
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(row, rowIndex, columnIndex, event) {
      var _props3 = this.props,
          options = _props3.options,
          keyBoardNav = _props3.keyBoardNav;

      if (options.onRowClick) {
        options.onRowClick(row, columnIndex, rowIndex, event);
      }
      if (keyBoardNav) {
        var _ref5 = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav : {},
            clickToNav = _ref5.clickToNav;

        clickToNav = clickToNav === false ? clickToNav : true;
        if (clickToNav) {
          this.setState(function () {
            return {
              x: columnIndex,
              y: rowIndex,
              reset: false
            };
          });
        }
      }
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowDoubleClick) {
        this.props.options.onRowDoubleClick(row, event);
      }
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__(e) {
      var isSelected = e.currentTarget.checked;
      var keyField = this.store.getKeyField();
      var _props$selectRow2 = this.props.selectRow,
          onSelectAll = _props$selectRow2.onSelectAll,
          unselectable = _props$selectRow2.unselectable,
          selected = _props$selectRow2.selected,
          onlyUnselectVisible = _props$selectRow2.onlyUnselectVisible;

      var selectedRowKeys = onlyUnselectVisible ? this.state.selectedRowKeys : [];
      var result = true;
      var rows = this.store.get();

      // onlyUnselectVisible default is false, #1276
      if (!isSelected && !onlyUnselectVisible) {
        rows = this.store.getRowByKey(this.state.selectedRowKeys);
      }

      if (unselectable && unselectable.length > 0) {
        if (isSelected) {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1 || selected && selected.indexOf(r[keyField]) !== -1;
          });
        } else {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1;
          });
        }
      }

      if (onSelectAll) {
        result = this.props.selectRow.onSelectAll(isSelected, rows);
      }

      if (typeof result == 'undefined' || result !== false) {
        if (isSelected) {
          if (Array.isArray(result)) {
            selectedRowKeys = result;
          } else {
            var currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            // onlyUnselectVisible default is false, #1276
            if (onlyUnselectVisible) {
              selectedRowKeys = selectedRowKeys.concat(currentRowKeys);
            } else {
              selectedRowKeys = currentRowKeys;
            }
          }
        } else {
          if (unselectable && selected) {
            selectedRowKeys = selected.filter(function (r) {
              return unselectable.indexOf(r) > -1;
            });
          } else if (onlyUnselectVisible) {
            var _currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            selectedRowKeys = selectedRowKeys.filter(function (k) {
              return _currentRowKeys.indexOf(k) === -1;
            });
          }
        }

        this.store.setSelectedRowKey(selectedRowKeys);
        this.setState(function () {
          return { selectedRowKeys: selectedRowKeys, reset: false };
        });
      }
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      this.store.ignoreNonSelected();
      var pageStartIndex = this.props.options.pageStartIndex;

      var result = void 0;
      if (this.props.pagination) {
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), this.state.sizePerPage).get();
      } else {
        result = this.store.get();
      }
      this.setState(function () {
        return {
          data: result,
          reset: false,
          currPage: _util2.default.getFirstPage(pageStartIndex)
        };
      });
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(row, isSelected, e, rowIndex) {
      var result = true;
      var currSelected = this.store.getSelectedRowKeys();
      var rowKey = row[this.store.getKeyField()];
      var selectRow = this.props.selectRow;

      if (selectRow.onSelect) {
        result = selectRow.onSelect(row, isSelected, e, rowIndex);
      }

      if (typeof result === 'undefined' || result !== false) {
        if (selectRow.mode === _Const2.default.ROW_SELECT_SINGLE) {
          currSelected = isSelected ? [rowKey] : [];
        } else {
          if (isSelected) {
            currSelected.push(rowKey);
          } else {
            currSelected = currSelected.filter(function (key) {
              return rowKey !== key;
            });
          }
        }

        this.store.setSelectedRowKey(currSelected);
        this.setState(function () {
          return {
            selectedRowKeys: currSelected,
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(newVal, rowIndex, colIndex) {
      var _this8 = this;

      var beforeSaveCell = this.props.cellEdit.beforeSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;

      var invalid = function invalid() {
        _this8.setState(function () {
          return {
            data: _this8.store.get(),
            reset: false
          };
        });
        return;
      };

      if (beforeSaveCell) {
        var beforeSaveCellCB = function beforeSaveCellCB(result) {
          _this8.body.cancelEditCell();
          if (result || result === undefined) {
            _this8.editCell(newVal, rowIndex, colIndex);
          } else {
            invalid();
          }
        };
        var props = { rowIndex: rowIndex, colIndex: colIndex };
        var isValid = beforeSaveCell(this.state.data[rowIndex], fieldName, newVal, beforeSaveCellCB, props);
        if (isValid === false && typeof isValid !== 'undefined') {
          return invalid();
        } else if (isValid === _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          /* eslint consistent-return: 0 */
          return isValid;
        }
      }
      this.editCell(newVal, rowIndex, colIndex);
    }
  }, {
    key: 'editCell',
    value: function editCell(newVal, rowIndex, colIndex) {
      var onCellEdit = this.props.options.onCellEdit;
      var afterSaveCell = this.props.cellEdit.afterSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;
      var props = { rowIndex: rowIndex, colIndex: colIndex };
      if (onCellEdit) {
        newVal = onCellEdit(this.state.data[rowIndex], fieldName, newVal);
      }

      if (this.allowRemote(_Const2.default.REMOTE_CELL_EDIT)) {
        if (afterSaveCell) {
          afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
        }
        return;
      }

      var result = this.store.edit(newVal, rowIndex, fieldName).get();
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });

      if (afterSaveCell) {
        afterSaveCell(this.state.data[rowIndex], fieldName, newVal, props);
      }
    }
  }, {
    key: 'handleAddRowAtBegin',
    value: function handleAddRowAtBegin(newObj) {
      try {
        this.store.addAtBegin(newObj);
      } catch (e) {
        return e;
      }
      this._handleAfterAddingRow(newObj, true);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__(newObj) {
      var _this9 = this;

      var isAsync = false;
      var onAddRow = this.props.options.onAddRow;


      var afterHandleAddRow = function afterHandleAddRow(errMsg) {
        if (isAsync) {
          _this9.toolbar.afterHandleSaveBtnClick(errMsg);
        } else {
          return errMsg;
        }
      };

      var afterAddRowCB = function afterAddRowCB(errMsg) {
        if (typeof errMsg !== 'undefined' && errMsg !== '') return afterHandleAddRow(errMsg);
        if (_this9.allowRemote(_Const2.default.REMOTE_INSERT_ROW)) {
          if (_this9.props.options.afterInsertRow) {
            _this9.props.options.afterInsertRow(newObj);
          }
          return afterHandleAddRow();
        }

        try {
          _this9.store.add(newObj);
        } catch (e) {
          return afterHandleAddRow(e.message);
        }
        _this9._handleAfterAddingRow(newObj, false);
        return afterHandleAddRow();
      };

      if (onAddRow) {
        var colInfos = this.store.getColInfos();
        var errMsg = onAddRow(newObj, colInfos, afterAddRowCB);

        if (errMsg !== '' && errMsg !== false) {
          return errMsg;
        } else if (typeof errMsg === 'undefined') {
          return afterAddRowCB();
        } else {
          isAsync = true;
          return !isAsync;
        }
      } else {
        return afterAddRowCB();
      }
    }
  }, {
    key: 'getSizePerPage',
    value: function getSizePerPage() {
      return this.state.sizePerPage;
    }
  }, {
    key: 'getCurrentPage',
    value: function getCurrentPage() {
      return this.state.currPage;
    }
  }, {
    key: 'getTableDataIgnorePaging',
    value: function getTableDataIgnorePaging() {
      return this.store.getCurrentDisplayData();
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__(rowKey) {
      var sizePerPage = this.state.sizePerPage;

      var currentData = this.store.getCurrentDisplayData();
      var keyField = this.store.getKeyField();
      var result = currentData.findIndex(function (x) {
        return x[keyField] === rowKey;
      });
      if (result > -1) {
        return parseInt(result / sizePerPage, 10) + 1;
      } else {
        return result;
      }
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__(rowKeys) {
      var _this10 = this;

      var dropRowKeys = rowKeys ? rowKeys : this.store.getSelectedRowKeys();
      // add confirm before the delete action if that option is set.
      if (dropRowKeys && dropRowKeys.length > 0) {
        if (this.props.options.handleConfirmDeleteRow) {
          this.props.options.handleConfirmDeleteRow(function () {
            _this10.deleteRow(dropRowKeys);
          }, dropRowKeys);
        } else if (confirm('Are you sure you want to delete?')) {
          this.deleteRow(dropRowKeys);
        }
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(dropRowKeys) {
      var _this11 = this;

      var dropRow = this.store.getRowByKey(dropRowKeys);
      var _props$options2 = this.props.options,
          onDeleteRow = _props$options2.onDeleteRow,
          afterDeleteRow = _props$options2.afterDeleteRow,
          pageStartIndex = _props$options2.pageStartIndex;


      if (onDeleteRow) {
        onDeleteRow(dropRowKeys, dropRow);
      }

      this.store.setSelectedRowKey([]); // clear selected row key

      if (this.allowRemote(_Const2.default.REMOTE_DROP_ROW)) {
        if (afterDeleteRow) {
          afterDeleteRow(dropRowKeys, dropRow);
        }
        return;
      }

      this.store.remove(dropRowKeys); // remove selected Row
      var result = void 0;
      if (this.props.pagination) {
        // debugger;
        var sizePerPage = this.state.sizePerPage;

        var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
        var currPage = this.state.currPage;

        if (currPage > currLastPage) currPage = currLastPage;
        // console.log(Util.getNormalizedPage(currPage));
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, currPage), sizePerPage).get();
        this.setState(function () {
          return {
            data: result,
            selectedRowKeys: _this11.store.getSelectedRowKeys(),
            currPage: currPage,
            reset: false
          };
        });
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false,
            selectedRowKeys: _this11.store.getSelectedRowKeys()
          };
        });
      }
      if (afterDeleteRow) {
        afterDeleteRow(dropRowKeys, dropRow);
      }
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__(filterObj) {
      var _props4 = this.props,
          filter = _props4.autoCollapse.filter,
          options = _props4.options;
      var onFilterChange = options.onFilterChange,
          pageStartIndex = options.pageStartIndex;

      if (onFilterChange) {
        var colInfos = this.store.getColInfos();
        onFilterChange(filterObj, colInfos);
      }

      this.setState(function () {
        var newState = {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
        if (filter) newState.expanding = [];
        return newState;
      });

      if (this.allowRemote(_Const2.default.REMOTE_FILTER)) {
        if (this.props.options.afterColumnFilter) {
          this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.filter(filterObj);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;

      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterColumnFilter) {
        this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      var result = {};

      var csvFileName = this.props.csvFileName;
      var _props$options3 = this.props.options,
          onExportToCSV = _props$options3.onExportToCSV,
          exportCSVSeparator = _props$options3.exportCSVSeparator,
          noAutoBOM = _props$options3.noAutoBOM,
          excludeCSVHeader = _props$options3.excludeCSVHeader;

      if (onExportToCSV) {
        result = onExportToCSV();
      } else {
        result = this.store.getDataIgnoringPagination();
      }
      var separator = exportCSVSeparator || _Const2.default.DEFAULT_CSV_SEPARATOR;
      var keys = [];
      this.props.children.filter(function (_) {
        return _ != null;
      }).map(function (column) {
        if (column.props.export === true || typeof column.props.export === 'undefined' && column.props.hidden === false) {
          keys.push({
            field: column.props.dataField,
            type: column.props.csvFieldType,
            format: column.props.csvFormat,
            extraData: column.props.csvFormatExtraData,
            header: column.props.csvHeader || column.props.dataField,
            row: Number(column.props.row) || 0,
            rowSpan: Number(column.props.rowSpan) || 1,
            colSpan: Number(column.props.colSpan) || 1
          });
        }
      });

      if (_util2.default.isFunction(csvFileName)) {
        csvFileName = csvFileName();
      }

      (0, _csv_export_util2.default)(result, keys, csvFileName, separator, noAutoBOM, excludeCSVHeader);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__(searchText) {
      // Set search field if this function being called outside
      // but it's not necessary if calling fron inside.
      if (this.toolbar) {
        this.toolbar.setSearchInput(searchText);
      }
      var search = this.props.autoCollapse.search;
      var _props$options4 = this.props.options,
          onSearchChange = _props$options4.onSearchChange,
          pageStartIndex = _props$options4.pageStartIndex;

      if (onSearchChange) {
        var colInfos = this.store.getColInfos();
        onSearchChange(searchText, colInfos, this.props.multiColumnSearch);
      }

      this.setState(function () {
        var newState = {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
        if (search) newState.expanding = [];
        return newState;
      });

      if (this.allowRemote(_Const2.default.REMOTE_SEARCH)) {
        if (this.props.options.afterSearch) {
          this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.search(searchText);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;
      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterSearch) {
        this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      var _this12 = this;

      if (this.props.pagination) {
        var dataSize = void 0;
        if (this.allowRemote(_Const2.default.REMOTE_PAGE)) {
          dataSize = this.props.fetchInfo.dataTotalSize;
        } else {
          dataSize = this.store.getDataNum();
        }
        var options = this.props.options;

        var withFirstAndLast = options.withFirstAndLast === undefined ? true : options.withFirstAndLast;
        if (Math.ceil(dataSize / this.state.sizePerPage) <= 1 && this.props.ignoreSinglePage) return null;
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-pagination' },
          _react2.default.createElement(_PaginationList2.default, {
            ref: function ref(node) {
              return _this12.pagination = node;
            },
            version: this.props.version,
            withFirstAndLast: withFirstAndLast,
            alwaysShowAllBtns: options.alwaysShowAllBtns,
            currPage: this.state.currPage,
            changePage: this.handlePaginationData,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: options.sizePerPageList || _Const2.default.SIZE_PER_PAGE_LIST,
            pageStartIndex: options.pageStartIndex,
            paginationShowsTotal: options.paginationShowsTotal,
            paginationSize: options.paginationSize || _Const2.default.PAGINATION_SIZE,
            dataSize: dataSize,
            onSizePerPageList: options.onSizePerPageList,
            prePage: options.prePage || _Const2.default.PRE_PAGE,
            nextPage: options.nextPage || _Const2.default.NEXT_PAGE,
            firstPage: options.firstPage || _Const2.default.FIRST_PAGE,
            lastPage: options.lastPage || _Const2.default.LAST_PAGE,
            prePageTitle: options.prePageTitle || _Const2.default.PRE_PAGE_TITLE,
            nextPageTitle: options.nextPageTitle || _Const2.default.NEXT_PAGE_TITLE,
            firstPageTitle: options.firstPageTitle || _Const2.default.FIRST_PAGE_TITLE,
            lastPageTitle: options.lastPageTitle || _Const2.default.LAST_PAGE_TITLE,
            hideSizePerPage: options.hideSizePerPage,
            sizePerPageDropDown: options.sizePerPageDropDown,
            hidePageListOnlyOnePage: options.hidePageListOnlyOnePage,
            paginationPanel: options.paginationPanel,
            keepSizePerPageState: options.keepSizePerPageState,
            open: false })
        );
      }
      return null;
    }
  }, {
    key: 'renderToolBar',
    value: function renderToolBar() {
      var _this13 = this;

      var _props5 = this.props,
          exportCSV = _props5.exportCSV,
          selectRow = _props5.selectRow,
          insertRow = _props5.insertRow,
          deleteRow = _props5.deleteRow,
          search = _props5.search,
          children = _props5.children,
          keyField = _props5.keyField;

      var enableShowOnlySelected = selectRow && selectRow.showOnlySelected;
      var print = typeof this.props.options.printToolBar === 'undefined' ? true : this.props.options.printToolBar;
      if (enableShowOnlySelected || insertRow || deleteRow || search || exportCSV || this.props.options.searchPanel || this.props.options.btnGroup || this.props.options.toolBar) {
        var columns = void 0;
        if (Array.isArray(children)) {
          columns = children.filter(function (_) {
            return _ != null;
          }).map(function (column, r) {
            if (!column) return;
            var props = column.props;

            var isKey = props.isKey || keyField === props.dataField;
            return {
              isKey: isKey,
              name: props.headerText || props.children,
              field: props.dataField,
              hiddenOnInsert: props.hiddenOnInsert,
              keyValidator: props.keyValidator,
              customInsertEditor: props.customInsertEditor,
              // when you want same auto generate value and not allow edit, example ID field
              autoValue: props.autoValue || false,
              // for create editor, no params for column.editable() indicate that editor for new row
              editable: props.editable && _util2.default.isFunction(props.editable === 'function') ? props.editable() : props.editable,
              format: props.dataFormat ? function (value) {
                return props.dataFormat(value, null, props.formatExtraData, r).replace(/<.*?>/g, '');
              } : false
            };
          });
        } else {
          columns = [{
            name: children.props.headerText || children.props.children,
            field: children.props.dataField,
            editable: children.props.editable,
            customInsertEditor: children.props.customInsertEditor,
            hiddenOnInsert: children.props.hiddenOnInsert,
            keyValidator: children.props.keyValidator
          }];
        }
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-tool-bar ' + (print ? '' : 'hidden-print') },
          _react2.default.createElement(_ToolBar2.default, {
            ref: function ref(node) {
              return _this13.toolbar = node;
            },
            version: this.props.version,
            defaultSearch: this.props.options.defaultSearch,
            clearSearch: this.props.options.clearSearch,
            searchPosition: this.props.options.searchPosition,
            searchDelayTime: this.props.options.searchDelayTime,
            enableInsert: insertRow,
            enableDelete: deleteRow,
            enableSearch: search,
            enableExportCSV: exportCSV,
            enableShowOnlySelected: enableShowOnlySelected,
            columns: columns,
            searchPlaceholder: this.props.searchPlaceholder,
            exportCSVText: this.props.options.exportCSVText,
            insertText: this.props.options.insertText,
            deleteText: this.props.options.deleteText,
            saveText: this.props.options.saveText,
            closeText: this.props.options.closeText,
            ignoreEditable: this.props.options.ignoreEditable,
            onAddRow: this.handleAddRow,
            onDropRow: this.handleDropRow,
            onSearch: this.handleSearch,
            onExportCSV: this.handleExportCSV,
            onShowOnlySelected: this.handleShowOnlySelected,
            insertModalHeader: this.props.options.insertModalHeader,
            insertModalFooter: this.props.options.insertModalFooter,
            insertModalBody: this.props.options.insertModalBody,
            insertModal: this.props.options.insertModal,
            insertBtn: this.props.options.insertBtn,
            deleteBtn: this.props.options.deleteBtn,
            showSelectedOnlyBtn: this.props.options.showSelectedOnlyBtn,
            exportCSVBtn: this.props.options.exportCSVBtn,
            clearSearchBtn: this.props.options.clearSearchBtn,
            searchField: this.props.options.searchField,
            searchPanel: this.props.options.searchPanel,
            btnGroup: this.props.options.btnGroup,
            toolBar: this.props.options.toolBar,
            reset: this.state.reset,
            isValidKey: this.store.isValidKey,
            insertFailIndicator: this.props.options.insertFailIndicator || _Const2.default.INSERT_FAIL_INDICATOR })
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFilter',
    value: function renderTableFilter(columns) {
      if (this.props.columnFilter) {
        return _react2.default.createElement(_TableFilter2.default, { columns: columns,
          rowSelectType: this.props.selectRow.mode,
          onFilter: this.handleFilterData });
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFooter',
    value: function renderTableFooter(footerData, footerFormatterReturnData, columns, colGroups) {
      var _this14 = this;

      if (this.props.footer) {
        var hideSelectColumn = true;
        var mode = this.props.selectRow.mode;

        var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
        if (isSelectRowDefined) {
          hideSelectColumn = this.props.selectRow.hideSelectColumn;
        }
        return _react2.default.createElement(
          _TableFooter2.default,
          {
            ref: function ref(node) {
              return _this14.footer = node;
            },
            columns: columns,
            colGroups: colGroups,
            footerFormatterReturnData: footerFormatterReturnData,
            tableFooterClass: this.props.tableFooterClass,
            style: this.props.headerStyle,
            hideSelectColumn: hideSelectColumn,
            expandColumnVisible: this.props.expandColumnOptions.expandColumnVisible,
            bordered: this.props.bordered,
            condensed: this.props.condensed,
            isFiltered: this.filter ? true : false,
            showStickyColumn: this.props.showStickyColumn },
          footerData
        );
      }
      return null;
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      var scrollTop = this.props.scrollTop;

      if (scrollTop === _Const2.default.SCROLL_TOP) {
        this.body.container.scrollTop = 0;
      } else if (scrollTop === _Const2.default.SCROLL_BOTTOM) {
        this.body.container.scrollTop = this.body.container.scrollHeight;
      } else if (typeof scrollTop === 'number' && !isNaN(scrollTop)) {
        this.body.container.scrollTop = scrollTop;
      }
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__(e) {
      this.header.container.scrollLeft = e.currentTarget.scrollLeft;
    }
  }, {
    key: '___scrollFooter__REACT_HOT_LOADER__',
    value: function ___scrollFooter__REACT_HOT_LOADER__(e) {
      if (this.props.footer) {
        this.footer.container.scrollLeft = e.currentTarget.scrollLeft;
      }
    }
  }, {
    key: '_adjustTable',
    value: function _adjustTable() {
      this._adjustHeight();
      if (!this.props.printable) {
        this._adjustHeaderWidth();
      }
    }
  }, {
    key: '_adjustHeaderWidth',
    value: function _adjustHeaderWidth() {
      var header = this.header.getHeaderColGrouop();
      var tbody = this.body.tbody;
      var bodyHeader = this.body.getHeaderColGrouop();
      var firstRow = tbody.childNodes[0];
      var isScroll = tbody.parentNode.getBoundingClientRect().height > tbody.parentNode.parentNode.getBoundingClientRect().height;

      var scrollBarWidth = isScroll ? _util2.default.getScrollBarWidth() : 0;
      if (firstRow && this.store.getDataNum()) {
        if (isScroll || this.isVerticalScroll !== isScroll) {
          var cells = firstRow.childNodes;
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var computedStyle = window.getComputedStyle(cell);
            var width = parseFloat(computedStyle.width.replace('px', ''));
            if (this.isIE) {
              var paddingLeftWidth = parseFloat(computedStyle.paddingLeft.replace('px', ''));
              var paddingRightWidth = parseFloat(computedStyle.paddingRight.replace('px', ''));
              var borderRightWidth = parseFloat(computedStyle.borderRightWidth.replace('px', ''));
              var borderLeftWidth = parseFloat(computedStyle.borderLeftWidth.replace('px', ''));
              width = width + paddingLeftWidth + paddingRightWidth + borderRightWidth + borderLeftWidth;
            }
            var lastPadding = cells.length - 1 === i ? scrollBarWidth : 0;
            if (width <= 0) {
              width = 120;
              cell.width = width + lastPadding + 'px';
            }
            var result = width + lastPadding + 'px';
            header[i].style.width = result;
            header[i].style.minWidth = result;
            if (cells.length - 1 === i) {
              bodyHeader[i].style.width = width + 'px';
              bodyHeader[i].style.minWidth = width + 'px';
            } else {
              bodyHeader[i].style.width = result;
              bodyHeader[i].style.minWidth = result;
            }
          }
        }
      } else {
        for (var _i in bodyHeader) {
          if (bodyHeader.hasOwnProperty(_i)) {
            var child = bodyHeader[_i];
            if (child.style) {
              if (child.style.width) {
                header[_i].style.width = child.style.width;
              }
              if (child.style.minWidth) {
                header[_i].style.minWidth = child.style.minWidth;
              }
            }
          }
        }
      }
      this.isVerticalScroll = isScroll;
    }
  }, {
    key: '_adjustHeight',
    value: function _adjustHeight() {
      var height = this.props.height;
      var maxHeight = this.props.maxHeight;

      if (typeof height === 'number' && !isNaN(height) || height.indexOf('%') === -1) {
        this.body.container.style.height = parseFloat(height, 10) - this.header.container.offsetHeight + 'px';
      }
      if (maxHeight) {
        maxHeight = typeof maxHeight === 'number' ? maxHeight : parseInt(maxHeight.replace('px', ''), 10);

        this.body.container.style.maxHeight = maxHeight - this.header.container.offsetHeight + 'px';
      }
    }
  }, {
    key: '_handleAfterAddingRow',
    value: function _handleAfterAddingRow(newObj, atTheBeginning) {
      var result = void 0;
      if (this.props.pagination) {
        // if pagination is enabled and inserting row at the end,
        // change page to the last page
        // otherwise, change it to the first page
        var sizePerPage = this.state.sizePerPage;


        if (atTheBeginning) {
          var pageStartIndex = this.props.options.pageStartIndex;

          result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: _util2.default.getFirstPage(pageStartIndex),
              reset: false
            };
          });
        } else {
          var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
          result = this.store.page(currLastPage, sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: currLastPage,
              reset: false
            };
          });
        }
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false
          };
        });
      }

      if (this.props.options.afterInsertRow) {
        this.props.options.afterInsertRow(newObj);
      }
    }
  }]);

  return BootstrapTable;
}(_react.Component);

BootstrapTable.propTypes = {
  keyField: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  version: _propTypes2.default.string, // bootstrap version
  remote: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]), // remote data, default is false
  replace: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  scrollTop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  pagination: _propTypes2.default.bool,
  printable: _propTypes2.default.bool,
  withoutTabIndex: _propTypes2.default.bool,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  searchPlaceholder: _propTypes2.default.string,
  selectRow: _propTypes2.default.shape({
    mode: _propTypes2.default.oneOf([_Const2.default.ROW_SELECT_NONE, _Const2.default.ROW_SELECT_SINGLE, _Const2.default.ROW_SELECT_MULTI]),
    customComponent: _propTypes2.default.func,
    bgColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    selected: _propTypes2.default.array,
    onSelect: _propTypes2.default.func,
    onSelectAll: _propTypes2.default.func,
    clickToSelect: _propTypes2.default.bool,
    hideSelectColumn: _propTypes2.default.bool,
    clickToSelectAndEditCell: _propTypes2.default.bool,
    clickToExpand: _propTypes2.default.bool,
    showOnlySelected: _propTypes2.default.bool,
    unselectable: _propTypes2.default.array,
    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    onlyUnselectVisible: _propTypes2.default.bool
  }),
  cellEdit: _propTypes2.default.shape({
    mode: _propTypes2.default.string,
    blurToSave: _propTypes2.default.bool,
    blurToEscape: _propTypes2.default.bool,
    beforeSaveCell: _propTypes2.default.func,
    afterSaveCell: _propTypes2.default.func,
    nonEditableRows: _propTypes2.default.func
  }),
  insertRow: _propTypes2.default.bool,
  deleteRow: _propTypes2.default.bool,
  search: _propTypes2.default.bool,
  multiColumnSearch: _propTypes2.default.bool,
  strictSearch: _propTypes2.default.bool,
  columnFilter: _propTypes2.default.bool,
  trClassName: _propTypes2.default.any,
  trStyle: _propTypes2.default.any,
  tableStyle: _propTypes2.default.object,
  containerStyle: _propTypes2.default.object,
  headerStyle: _propTypes2.default.object,
  bodyStyle: _propTypes2.default.object,
  containerClass: _propTypes2.default.string,
  tableContainerClass: _propTypes2.default.string,
  headerContainerClass: _propTypes2.default.string,
  bodyContainerClass: _propTypes2.default.string,
  tableHeaderClass: _propTypes2.default.string,
  tableBodyClass: _propTypes2.default.string,
  tableFooterClass: _propTypes2.default.string,
  options: _propTypes2.default.shape({
    clearSearch: _propTypes2.default.bool,
    sortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    sortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    defaultSortName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    defaultSortOrder: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    sortIndicator: _propTypes2.default.bool,
    afterTableComplete: _propTypes2.default.func,
    afterDeleteRow: _propTypes2.default.func,
    afterInsertRow: _propTypes2.default.func,
    afterSearch: _propTypes2.default.func,
    afterColumnFilter: _propTypes2.default.func,
    onRowClick: _propTypes2.default.func,
    onRowDoubleClick: _propTypes2.default.func,
    page: _propTypes2.default.number,
    pageStartIndex: _propTypes2.default.number,
    paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    sizePerPageList: _propTypes2.default.array,
    sizePerPage: _propTypes2.default.number,
    paginationSize: _propTypes2.default.number,
    paginationPosition: _propTypes2.default.oneOf([_Const2.default.PAGINATION_POS_TOP, _Const2.default.PAGINATION_POS_BOTTOM, _Const2.default.PAGINATION_POS_BOTH]),
    toolbarPosition: _propTypes2.default.oneOf([_Const2.default.TOOLBAR_POS_TOP, _Const2.default.TOOLBAR_POS_BOTTOM, _Const2.default.TOOLBAR_POS_BOTH]),
    hideSizePerPage: _propTypes2.default.bool,
    hidePageListOnlyOnePage: _propTypes2.default.bool,
    alwaysShowAllBtns: _propTypes2.default.bool,
    withFirstAndLast: _propTypes2.default.bool,
    keepSizePerPageState: _propTypes2.default.bool,
    onSortChange: _propTypes2.default.func,
    onPageChange: _propTypes2.default.func,
    onSizePerPageList: _propTypes2.default.func,
    onFilterChange: _propTypes2.default.func,
    onSearchChange: _propTypes2.default.func,
    onAddRow: _propTypes2.default.func,
    onExportToCSV: _propTypes2.default.func,
    onCellEdit: _propTypes2.default.func,
    noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    withoutNoDataText: _propTypes2.default.bool,
    handleConfirmDeleteRow: _propTypes2.default.func,
    prePage: _propTypes2.default.any,
    nextPage: _propTypes2.default.any,
    firstPage: _propTypes2.default.any,
    lastPage: _propTypes2.default.any,
    prePageTitle: _propTypes2.default.string,
    nextPageTitle: _propTypes2.default.string,
    firstPageTitle: _propTypes2.default.string,
    lastPageTitle: _propTypes2.default.string,
    searchDelayTime: _propTypes2.default.number,
    excludeCSVHeader: _propTypes2.default.bool,
    exportCSVText: _propTypes2.default.string,
    exportCSVSeparator: _propTypes2.default.string,
    insertText: _propTypes2.default.string,
    deleteText: _propTypes2.default.string,
    saveText: _propTypes2.default.string,
    closeText: _propTypes2.default.string,
    ignoreEditable: _propTypes2.default.bool,
    defaultSearch: _propTypes2.default.string,
    insertModalHeader: _propTypes2.default.func,
    insertModalBody: _propTypes2.default.func,
    insertModalFooter: _propTypes2.default.func,
    insertModal: _propTypes2.default.func,
    insertBtn: _propTypes2.default.func,
    deleteBtn: _propTypes2.default.func,
    showSelectedOnlyBtn: _propTypes2.default.func,
    exportCSVBtn: _propTypes2.default.func,
    clearSearchBtn: _propTypes2.default.func,
    searchField: _propTypes2.default.func,
    searchPanel: _propTypes2.default.func,
    btnGroup: _propTypes2.default.func,
    toolBar: _propTypes2.default.func,
    sizePerPageDropDown: _propTypes2.default.func,
    paginationPanel: _propTypes2.default.func,
    searchPosition: _propTypes2.default.string,
    expandRowBgColor: _propTypes2.default.string,
    expandBy: _propTypes2.default.string,
    expanding: _propTypes2.default.array,
    onExpand: _propTypes2.default.func,
    onlyOneExpanding: _propTypes2.default.bool,
    expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    beforeShowError: _propTypes2.default.func,
    printToolBar: _propTypes2.default.bool,
    insertFailIndicator: _propTypes2.default.string,
    noAutoBOM: _propTypes2.default.bool,
    expandAll: _propTypes2.default.bool,
    hideRowOnExpand: _propTypes2.default.bool
  }),
  fetchInfo: _propTypes2.default.shape({
    dataTotalSize: _propTypes2.default.number
  }),
  renderAlert: _propTypes2.default.bool,
  exportCSV: _propTypes2.default.bool,
  csvFileName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  ignoreSinglePage: _propTypes2.default.bool,
  expandableRow: _propTypes2.default.func,
  expandComponent: _propTypes2.default.func,
  autoCollapse: _propTypes2.default.shape({
    sort: _propTypes2.default.bool,
    filter: _propTypes2.default.bool,
    search: _propTypes2.default.bool
  }),
  expandColumnOptions: _propTypes2.default.shape({
    columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    expandColumnVisible: _propTypes2.default.bool,
    expandColumnComponent: _propTypes2.default.func,
    expandedColumnHeaderComponent: _propTypes2.default.func,
    expandColumnBeforeSelectColumn: _propTypes2.default.bool
  }),
  footer: _propTypes2.default.bool
};
BootstrapTable.defaultProps = {
  version: '3',
  replace: false,
  scrollTop: undefined,
  expandComponent: undefined,
  expandableRow: undefined,
  expandColumnOptions: {
    expandColumnVisible: false,
    expandColumnComponent: undefined,
    expandedColumnHeaderComponent: undefined,
    expandColumnBeforeSelectColumn: true
  },
  height: '100%',
  maxHeight: undefined,
  striped: false,
  bordered: true,
  hover: false,
  condensed: false,
  pagination: false,
  printable: false,
  withoutTabIndex: false,
  keyBoardNav: false,
  searchPlaceholder: undefined,
  selectRow: {
    mode: _Const2.default.ROW_SELECT_NONE,
    bgColor: _Const2.default.ROW_SELECT_BG_COLOR,
    selected: [],
    onSelect: undefined,
    onSelectAll: undefined,
    clickToSelect: false,
    hideSelectColumn: false,
    clickToSelectAndEditCell: false,
    clickToExpand: false,
    showOnlySelected: false,
    unselectable: [],
    customComponent: undefined,
    onlyUnselectVisible: false
  },
  cellEdit: {
    mode: _Const2.default.CELL_EDIT_NONE,
    blurToSave: false,
    blurToEscape: false,
    beforeSaveCell: undefined,
    afterSaveCell: undefined,
    nonEditableRows: undefined
  },
  insertRow: false,
  deleteRow: false,
  search: false,
  multiColumnSearch: false,
  strictSearch: undefined,
  multiColumnSort: 1,
  columnFilter: false,
  trClassName: '',
  trStyle: undefined,
  tableStyle: undefined,
  containerStyle: undefined,
  headerStyle: undefined,
  bodyStyle: undefined,
  containerClass: null,
  tableContainerClass: null,
  headerContainerClass: null,
  bodyContainerClass: null,
  tableHeaderClass: null,
  tableBodyClass: null,
  tableFooterClass: null,
  options: {
    clearSearch: false,
    sortName: undefined,
    sortOrder: undefined,
    defaultSortName: undefined,
    defaultSortOrder: undefined,
    sortIndicator: true,
    afterTableComplete: undefined,
    afterDeleteRow: undefined,
    afterInsertRow: undefined,
    afterSearch: undefined,
    afterColumnFilter: undefined,
    onRowClick: undefined,
    onRowDoubleClick: undefined,
    onMouseLeave: undefined,
    onMouseEnter: undefined,
    onRowMouseOut: undefined,
    onRowMouseOver: undefined,
    page: undefined,
    paginationShowsTotal: false,
    sizePerPageList: _Const2.default.SIZE_PER_PAGE_LIST,
    sizePerPage: undefined,
    paginationSize: _Const2.default.PAGINATION_SIZE,
    paginationPosition: _Const2.default.PAGINATION_POS_BOTTOM,
    toolbarPosition: _Const2.default.TOOLBAR_POS_TOP,
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    alwaysShowAllBtns: false,
    withFirstAndLast: true,
    keepSizePerPageState: false,
    onSizePerPageList: undefined,
    noDataText: undefined,
    withoutNoDataText: false,
    handleConfirmDeleteRow: undefined,
    prePage: _Const2.default.PRE_PAGE,
    nextPage: _Const2.default.NEXT_PAGE,
    firstPage: _Const2.default.FIRST_PAGE,
    lastPage: _Const2.default.LAST_PAGE,
    prePageTitle: _Const2.default.PRE_PAGE_TITLE,
    nextPageTitle: _Const2.default.NEXT_PAGE_TITLE,
    firstPageTitle: _Const2.default.FIRST_PAGE_TITLE,
    lastPageTitle: _Const2.default.LAST_PAGE_TITLE,
    pageStartIndex: 1,
    searchDelayTime: undefined,
    excludeCSVHeader: false,
    exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
    exportCSVSeparator: _Const2.default.DEFAULT_CSV_SEPARATOR,
    insertText: _Const2.default.INSERT_BTN_TEXT,
    deleteText: _Const2.default.DELETE_BTN_TEXT,
    saveText: _Const2.default.SAVE_BTN_TEXT,
    closeText: _Const2.default.CLOSE_BTN_TEXT,
    ignoreEditable: false,
    defaultSearch: '',
    insertModalHeader: undefined,
    insertModalBody: undefined,
    insertModalFooter: undefined,
    insertModal: undefined,
    insertBtn: undefined,
    deleteBtn: undefined,
    showSelectedOnlyBtn: undefined,
    exportCSVBtn: undefined,
    clearSearchBtn: undefined,
    searchField: undefined,
    searchPanel: undefined,
    btnGroup: undefined,
    toolBar: undefined,
    sizePerPageDropDown: undefined,
    paginationPanel: undefined,
    searchPosition: 'right',
    expandRowBgColor: undefined,
    expandBy: _Const2.default.EXPAND_BY_ROW,
    expanding: [],
    onExpand: undefined,
    onlyOneExpanding: false,
    expandBodyClass: null,
    expandParentClass: null,
    beforeShowError: undefined,
    printToolBar: true,
    insertFailIndicator: _Const2.default.INSERT_FAIL_INDICATOR,
    noAutoBOM: true,
    expandAll: false,
    hideRowOnExpand: false
  },
  fetchInfo: {
    dataTotalSize: 0
  },
  renderAlert: true,
  exportCSV: false,
  csvFileName: 'spreadsheet.csv',
  ignoreSinglePage: false,
  autoCollapse: {
    sort: _Const2.default.AUTO_COLLAPSE_WHEN_SORT,
    filter: _Const2.default.AUTO_COLLAPSE_WHEN_FILTER,
    search: _Const2.default.AUTO_COLLAPSE_WHEN_SEARCH
  },
  footer: false
};

var _default = BootstrapTable;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BootstrapTable, 'BootstrapTable', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');
}();

;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(226), __webpack_require__(3), __webpack_require__(127), __webpack_require__(126), __webpack_require__(444)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('./SAlertContent'), require('prop-types'), require('./s-alert-parts/s-alert-store'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-data-prep'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.SAlertContent, global.propTypes, global.sAlertStore, global.sAlertTools, global.sAlertDataPrep);
        global.SAlert = mod.exports;
    }
})(this, function (exports, _react, _SAlertContent, _propTypes, _sAlertStore, _sAlertTools, _sAlertDataPrep) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertDataPrep2 = _interopRequireDefault(_sAlertDataPrep);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var insertFunc = function insertFunc(msg, data, condition) {
        var id = _sAlertTools2.default.randomId();
        _sAlertStore2.default.dispatch({
            type: 'INSERT',
            data: _extends({}, data, {
                id: id,
                condition: condition,
                message: msg
            })
        });
        return id;
    };

    var SAlert = function (_React$Component) {
        _inherits(SAlert, _React$Component);

        function SAlert(props) {
            _classCallCheck(this, SAlert);

            var _this = _possibleConstructorReturn(this, (SAlert.__proto__ || Object.getPrototypeOf(SAlert)).call(this, props));

            _this.state = {
                dataRight: [],
                dataLeft: [],
                dataTop: [],
                dataBottom: []
            };
            return _this;
        }

        _createClass(SAlert, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                var storeStateLeft = void 0;
                var storeStateRight = void 0;
                var storeStateTop = void 0;
                var storeStateBottom = void 0;

                var addToStoreRight = function addToStoreRight() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
                            length = storeStateRight.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateRight[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
                            }
                            _this2.setState({ dataRight: storeStateRight });
                        });
                    });
                };
                this.unsubStoreRight = _sAlertStore2.default.subscribe(addToStoreRight);

                var addToStoreLeft = function addToStoreLeft() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
                            length = storeStateLeft.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateLeft[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
                            }
                            _this2.setState({ dataLeft: storeStateLeft });
                        });
                    });
                };
                this.unsubStoreLeft = _sAlertStore2.default.subscribe(addToStoreLeft);

                var addToStoreTop = function addToStoreTop() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
                            length = storeStateTop.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateTop[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
                            }
                            _this2.setState({ dataTop: storeStateTop });
                        });
                    });
                };
                this.unsubStoreTop = _sAlertStore2.default.subscribe(addToStoreTop);

                var addToStoreBottom = function addToStoreBottom() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
                            length = storeStateBottom.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateBottom[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
                            }
                            _this2.setState({ dataBottom: storeStateBottom });
                        });
                    });
                };
                this.unsubStoreBottom = _sAlertStore2.default.subscribe(addToStoreBottom);

                // set up global config from global SAlert props
                // only stuff needed for getAlertData
                var globalConfig = {
                    contentTemplate: this.props.contentTemplate,
                    offset: this.props.offset,
                    message: this.props.message,
                    stack: this.props.stack,
                    html: this.props.html,
                    customFields: this.props.customFields,
                    position: this.props.position || 'top-right',
                    preserveContext: this.props.preserveContext || false
                };
                _sAlertTools2.default.setGlobalConfig(globalConfig);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unsubStoreTop();
                this.unsubStoreBottom();
                this.unsubStoreLeft();
                this.unsubStoreRight();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this3 = this;

                var mapFunc = function mapFunc(alert, index) {
                    var customKey = 'alert-key-' + alert.id + '-' + alert.position;
                    var id = alert.id;
                    var condition = _sAlertTools2.default.returnFirstDefined(alert.condition, 'info');
                    var message = _sAlertTools2.default.returnFirstDefined(alert.message, _this3.props.message, '');
                    var position = _sAlertTools2.default.returnFirstDefined(alert.position, _this3.props.position, 'top-right');
                    var offset = _sAlertTools2.default.returnFirstDefined(alert.offset, _this3.props.offset, 0);
                    var effect = _sAlertTools2.default.returnFirstDefined(alert.effect, _this3.props.effect);
                    var boxPosition = alert.boxPosition;
                    var beep = _sAlertTools2.default.returnFirstDefined(alert.beep, _this3.props.beep, false);
                    var timeout = _sAlertTools2.default.returnFirstDefined(alert.timeout, _this3.props.timeout, 5000);
                    var html = _sAlertTools2.default.returnFirstDefined(alert.html, _this3.props.html);
                    var onClose = _sAlertTools2.default.returnFirstDefined(alert.onClose, _this3.props.onClose);
                    var onShow = _sAlertTools2.default.returnFirstDefined(alert.onShow, _this3.props.onShow);
                    var customFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, _this3.props.customFields);
                    var contentTemplate = _this3.props.contentTemplate;

                    return _react2.default.createElement(_SAlertContent2.default, {
                        key: customKey,
                        id: id,
                        customFields: customFields,
                        condition: condition,
                        message: message,
                        position: position,
                        effect: effect,
                        boxPosition: boxPosition,
                        beep: beep,
                        timeout: timeout,
                        html: html,
                        onClose: onClose,
                        onShow: onShow,
                        contentTemplate: contentTemplate });
                };
                var sAlertElemsRight = this.state.dataRight.map(mapFunc);
                var sAlertElemsLeft = this.state.dataLeft.map(mapFunc);
                var sAlertElemsTop = this.state.dataTop.map(mapFunc);
                var sAlertElemsBottom = this.state.dataBottom.map(mapFunc);
                return _react2.default.createElement(
                    'div',
                    { className: 's-alert-wrapper' },
                    sAlertElemsRight,
                    sAlertElemsLeft,
                    sAlertElemsTop,
                    sAlertElemsBottom
                );
            }
        }], [{
            key: 'info',
            value: function info(msg, data) {
                return insertFunc(msg, data, 'info');
            }
        }, {
            key: 'error',
            value: function error(msg, data) {
                return insertFunc(msg, data, 'error');
            }
        }, {
            key: 'warning',
            value: function warning(msg, data) {
                return insertFunc(msg, data, 'warning');
            }
        }, {
            key: 'success',
            value: function success(msg, data) {
                return insertFunc(msg, data, 'success');
            }
        }, {
            key: 'close',
            value: function close(id) {
                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
            }
        }, {
            key: 'closeAll',
            value: function closeAll() {
                _sAlertStore2.default.dispatch({ type: 'REMOVEALL' });
            }
        }]);

        return SAlert;
    }(_react2.default.Component);

    SAlert.propTypes = {
        message: _propTypes2.default.string,
        position: _propTypes2.default.string,
        offset: _propTypes2.default.number,
        stack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        preserveContext: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlert;
});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes);
        global.SAlertContentTmpl = mod.exports;
    }
})(this, function (exports, _react, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContentTmpl = function (_React$Component) {
        _inherits(SAlertContentTmpl, _React$Component);

        function SAlertContentTmpl(props) {
            _classCallCheck(this, SAlertContentTmpl);

            return _possibleConstructorReturn(this, (SAlertContentTmpl.__proto__ || Object.getPrototypeOf(SAlertContentTmpl)).call(this, props));
        }

        _createClass(SAlertContentTmpl, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    { className: this.props.classNames, id: this.props.id, style: this.props.styles },
                    _react2.default.createElement(
                        'div',
                        { className: 's-alert-box-inner' },
                        this.props.message
                    ),
                    _react2.default.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose })
                );
            }
        }]);

        return SAlertContentTmpl;
    }(_react2.default.Component);

    SAlertContentTmpl.propTypes = {
        id: _propTypes2.default.string.isRequired,
        classNames: _propTypes2.default.string.isRequired,
        condition: _propTypes2.default.string.isRequired,
        styles: _propTypes2.default.object.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
        handleClose: _propTypes2.default.func.isRequired,
        customFields: _propTypes2.default.object
    };

    exports.default = SAlertContentTmpl;
});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(7), __webpack_require__(226), __webpack_require__(127), __webpack_require__(126)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('../SAlertContent'), require('./s-alert-store'), require('./s-alert-tools'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.SAlertContent, global.sAlertStore, global.sAlertTools);
        global.sAlertDataPrep = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _SAlertContent, _sAlertStore, _sAlertTools) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var getAlertData = function getAlertData(sAlertPosition, parentComponent) {
        var positionTop = 0;
        var positionBottom = 0;
        var padding = 0;
        var alerts = {};
        var style = void 0;
        var docElement = void 0;
        var sAlertBoxHeight = void 0;
        var positionTypeTop = void 0;
        var positionTypeBottom = void 0;
        var checkFirst = function checkFirst(type, objId) {
            var collectionOfType = sAlertCollection.filter(function (obj) {
                return obj.position === type || sAlertGlobalConfig.position === type;
            });
            return collectionOfType && collectionOfType[0].id === objId;
        };
        var positionFunc = function positionFunc(position, positionType, alert, docElement, sAlertBoxHeight, reactComponent) {
            padding = aStack.spacing || parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))[positionType]);
            if (checkFirst(aPosition, alert.id) && aOffset) {
                position = 0;
                position = position + parseInt(aOffset);
            }
            if (checkFirst(aPosition, alert.id) && aStack.spacing) {
                position = position;
            } else {
                position = position + parseInt(padding);
            }
            style = positionType + ': ' + position + 'px;';
            position = position + sAlertBoxHeight;
            return position;
        };

        var sAlertGlobalConfig = _sAlertTools2.default.getGlobalConfig();
        var aStack = void 0;
        var aContentTemplate = void 0;
        var aOffset = void 0;
        var aMessage = void 0;
        var aHtml = void 0;
        var aCustomFields = void 0;
        var aPosition = void 0;
        var preserveContext = void 0;

        var query = {};
        if (sAlertPosition === 'left') {
            query = function query(item) {
                return item.position === 'top-left' || item.position === 'bottom-left' || !item.position && (sAlertGlobalConfig.position === 'top-left' || sAlertGlobalConfig.position === 'bottom-left');
            };
        }
        if (sAlertPosition === 'right') {
            query = function query(item) {
                return item.position === 'top-right' || item.position === 'bottom-right' || !item.position && (sAlertGlobalConfig.position === 'top-right' || sAlertGlobalConfig.position === 'bottom-right');
            };
        }
        if (sAlertPosition === 'full-top') {
            query = function query(item) {
                return item.position === 'top' || !item.position && sAlertGlobalConfig.position === 'top';
            };
        }
        if (sAlertPosition === 'full-bottom') {
            query = function query(item) {
                return item.position === 'bottom' || !item.position && sAlertGlobalConfig.position === 'bottom';
            };
        }

        var currentState = _sAlertStore2.default.getState();
        var sAlertCollection = currentState.slice().filter(query);

        return sAlertCollection.map(function (alert) {
            aStack = sAlertGlobalConfig.stack;
            aContentTemplate = sAlertGlobalConfig.contentTemplate;
            aOffset = _sAlertTools2.default.returnFirstDefined(alert.offset, sAlertGlobalConfig.offset);
            aMessage = _sAlertTools2.default.returnFirstDefined(alert.message, sAlertGlobalConfig.message);
            aHtml = _sAlertTools2.default.returnFirstDefined(alert.html, sAlertGlobalConfig.html);
            aCustomFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, sAlertGlobalConfig.customFields);
            aPosition = _sAlertTools2.default.returnFirstDefined(alert.position, sAlertGlobalConfig.position);
            preserveContext = _sAlertTools2.default.returnFirstDefined(alert.preserveContext, sAlertGlobalConfig.preserveContext);
            positionTypeTop = aPosition && /top/g.test(aPosition);
            positionTypeBottom = aPosition && /bottom/g.test(aPosition);

            if (aStack) {
                // checking alert box height - needed to calculate position
                docElement = document.createElement('div');
                docElement.classList.add('s-alert-box-height');

                // mock element, needed for positions calculations
                var reactElement = _react2.default.createElement(_SAlertContent2.default, {
                    key: _sAlertTools2.default.randomId(),
                    id: _sAlertTools2.default.randomId(),
                    condition: alert.condition,
                    message: aMessage,
                    position: aPosition,
                    effect: alert.effect,
                    boxPosition: alert.boxPosition,
                    beep: false,
                    timeout: 'none',
                    html: aHtml,
                    contentTemplate: aContentTemplate,
                    customFields: aCustomFields
                });

                var reactComponent = void 0;

                if (preserveContext) {
                    reactComponent = _reactDom2.default.unstable_renderSubtreeIntoContainer(parentComponent, reactElement, docElement);
                } else {
                    reactComponent = _reactDom2.default.render(reactElement, docElement);
                }

                document.body.appendChild(docElement);
                sAlertBoxHeight = parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))['height']);
                if (positionTypeTop) {
                    positionTop = positionFunc(positionTop, 'top', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                if (positionTypeBottom) {
                    positionBottom = positionFunc(positionBottom, 'bottom', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                var sAlertComputedStyle = getComputedStyle(_reactDom2.default.findDOMNode(reactComponent));
                if (sAlertPosition === 'left') {
                    style = style + 'left: ' + (aStack.spacing || parseInt(sAlertComputedStyle.left)) + 'px;';
                }
                if (sAlertPosition === 'right') {
                    style = style + 'right: ' + (aStack.spacing || parseInt(sAlertComputedStyle.right)) + 'px;';
                }
                alerts = _extends({}, alert, { boxPosition: style });
                _reactDom2.default.unmountComponentAtNode(docElement);
                docElement.parentNode.removeChild(docElement);
            } else if (aOffset && positionTypeTop) {
                alerts = _extends({}, alert, { boxPosition: 'top: ' + parseInt(aOffset) + 'px;' });
            } else if (aOffset && positionTypeBottom) {
                alerts = _extends({}, alert, { boxPosition: 'bottom: ' + parseInt(aOffset) + 'px;' });
            } else {
                alerts = alert;
            }
            return alerts;
        });
    };

    exports.default = getAlertData;
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint quotes: 0 */
/* eslint max-len: 0 */


var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

function dateParser(d) {
  return d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2);
}

var DateFilter = function (_Component) {
  _inherits(DateFilter, _Component);

  function DateFilter(props) {
    _classCallCheck(this, DateFilter);

    var _this = _possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));

    _this.dateComparators = _this.props.dateComparators || legalComparators;
    _this.filter = _this.filter.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(DateFilter, [{
    key: 'setDefaultDate',
    value: function setDefaultDate() {
      var defaultDate = '';
      var defaultValue = this.props.defaultValue;

      if (defaultValue && defaultValue.date) {
        // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
        defaultDate = dateParser(new Date(defaultValue.date));
      }
      return defaultDate;
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var date = this.inputDate.value;
      var comparator = event.target.value;
      if (date === '') {
        return;
      }
      date = new Date(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      for (var i = 0; i < this.dateComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.dateComparators[i] },
          this.dateComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var comparator = this.dateFilterComparator.value;
      var dateValue = event.target.value;
      if (dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      } else {
        this.props.filterHandler(null, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.setDefaultDate();
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.dateFilterComparator.value = comparator;
      this.inputDate.value = value;
      this.props.filterHandler({ date: new Date(value), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterDateObj) {
      var date = filterDateObj.date,
          comparator = filterDateObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: date === '' };
      });
      this.dateFilterComparator.value = comparator;
      this.inputDate.value = dateParser(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.dateFilterComparator.value;
      var dateValue = this.inputDate.value;
      if (comparator && dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          _props$style = _props.style,
          date = _props$style.date,
          comparator = _props$style.comparator;

      return _react2.default.createElement(
        'div',
        { className: 'filter date-filter' },
        _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this2.dateFilterComparator = n;
            },
            style: comparator,
            className: 'date-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: defaultValue ? defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        _react2.default.createElement('input', { ref: function ref(n) {
            return _this2.inputDate = n;
          },
          className: 'filter date-filter-input form-control',
          style: date,
          type: 'date',
          onChange: this.filter,
          defaultValue: this.setDefaultDate() })
      );
    }
  }]);

  return DateFilter;
}(_react.Component);

DateFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.shape({
    date: _propTypes2.default.object,
    comparator: _propTypes2.default.oneOf(legalComparators)
  }),
  style: _propTypes2.default.shape({
    date: _propTypes2.default.oneOfType([_propTypes2.default.object]),
    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
  }),
  /* eslint consistent-return: 0 */
  dateComparators: function dateComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Date comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  columnName: _propTypes2.default.any
};

DateFilter.defaultProps = {
  style: {
    date: null,
    comparator: null
  }
};

var _default = DateFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(dateParser, 'dateParser', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(DateFilter, 'DateFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
}();

;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFilter = function (_Component) {
  _inherits(TextFilter, _Component);

  function TextFilter(props) {
    _classCallCheck(this, TextFilter);

    var _this = _possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    _this.state = {
      value: _this.props.defaultValue || ''
    };
    return _this;
  }

  _createClass(TextFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.setState(function () {
        return { value: filterValue };
      });
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.TEXT);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.setState(function () {
        return { value: value };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterText) {
      this.setState(function () {
        return { value: filterText };
      });
      this.props.filterHandler(filterText, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var defaultValue = this.inputText.value;
      if (defaultValue) {
        this.props.filterHandler(defaultValue, _Const2.default.FILTER_TYPE.TEXT);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultValue !== this.props.defaultValue) {
        this.applyFilter(nextProps.defaultValue || '');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: function ref(n) {
          return _this3.inputText = n;
        },
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter ' + columnName + '...',
        value: this.state.value });
    }
  }]);

  return TextFilter;
}(_react.Component);

TextFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

TextFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = TextFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TextFilter, 'TextFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');
}();

;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegexFilter = function (_Component) {
  _inherits(RegexFilter, _Component);

  function RegexFilter(props) {
    _classCallCheck(this, RegexFilter);

    var _this = _possibleConstructorReturn(this, (RegexFilter.__proto__ || Object.getPrototypeOf(RegexFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    return _this;
  }

  _createClass(RegexFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.REGEX);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.inputText.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterRegx) {
      this.inputText.value = filterRegx;
      this.props.filterHandler(filterRegx, _Const2.default.FILTER_TYPE.REGEX);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.inputText.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.REGEX);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: function ref(n) {
          return _this3.inputText = n;
        },
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter Regex for ' + columnName + '...',
        defaultValue: defaultValue ? defaultValue : '' });
    }
  }]);

  return RegexFilter;
}(_react.Component);

RegexFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

RegexFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = RegexFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegexFilter, 'RegexFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');
}();

;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function optionsEquals(options1, options2) {
  var keys = Object.keys(options1);
  for (var k in keys) {
    if (options1[k] !== options2[k]) {
      return false;
    }
  }
  return Object.keys(options1).length === Object.keys(options2).length;
}

var SelectFilter = function (_Component) {
  _inherits(SelectFilter, _Component);

  function SelectFilter(props) {
    _classCallCheck(this, SelectFilter);

    var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || !_this.props.options.hasOwnProperty(_this.props.defaultValue)
    };
    return _this;
  }

  _createClass(SelectFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var currentSelectValue = this.selectInput.value;
      var isPlaceholderSelected = !currentSelectValue || currentSelectValue === '';
      this.setState(function () {
        return {
          isPlaceholderSelected: isPlaceholderSelected
        };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var needFilter = false;
      if (this.props.defaultValue !== prevProps.defaultValue) {
        needFilter = true;
      } else if (!optionsEquals(this.props.options, prevProps.options)) {
        needFilter = true;
      }
      if (needFilter) {
        var value = this.selectInput.value;
        if (value) {
          this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
        }
      }
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue !== undefined ? this.props.defaultValue : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.selectInput.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterOption) {
      filterOption = filterOption + '';
      this.setState(function () {
        return { isPlaceholderSelected: filterOption === '' };
      });
      this.selectInput.value = filterOption;
      this.props.filterHandler(filterOption, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          selectText = _props.selectText,
          withoutEmptyOption = _props.withoutEmptyOption;

      var selectTextValue = selectText !== undefined ? selectText : 'Select';
      if (!withoutEmptyOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          placeholder || selectTextValue + ' ' + columnName + '...'
        ));
      }
      Object.keys(options).map(function (key) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: key, value: key },
          options[key] + ''
        ));
      });
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.selectInput.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectClass = (0, _classnames2.default)('filter', 'select-filter', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'select',
        { ref: function ref(n) {
            return _this2.selectInput = n;
          },
          style: this.props.style,
          className: selectClass,
          onChange: this.filter,
          defaultValue: this.props.defaultValue !== undefined ? this.props.defaultValue : '' },
        this.getOptions()
      );
    }
  }]);

  return SelectFilter;
}(_react.Component);

SelectFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object])
};

var _default = SelectFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(optionsEquals, 'optionsEquals', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(SelectFilter, 'SelectFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
}();

;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

var NumberFilter = function (_Component) {
  _inherits(NumberFilter, _Component);

  function NumberFilter(props) {
    _classCallCheck(this, NumberFilter);

    var _this = _possibleConstructorReturn(this, (NumberFilter.__proto__ || Object.getPrototypeOf(NumberFilter)).call(this, props));

    _this.numberComparators = _this.props.numberComparators || legalComparators;
    _this.timeout = null;
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || _this.props.defaultValue.number === undefined || _this.props.options && _this.props.options.indexOf(_this.props.defaultValue.number) === -1
    };
    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
    _this.onChangeNumberSet = _this.onChangeNumberSet.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(NumberFilter, [{
    key: 'onChangeNumber',
    value: function onChangeNumber(event) {
      var _this2 = this;

      var comparator = this.numberFilterComparator.value;
      if (comparator === '') {
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler({ number: filterValue, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }, this.props.delay);
    }
  }, {
    key: 'onChangeNumberSet',
    value: function onChangeNumberSet(event) {
      var comparator = this.numberFilterComparator.value;
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      if (comparator === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var value = this.numberFilter.value;
      var comparator = event.target.value;
      if (value === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue.number : '';
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.numberFilterComparator.value = comparator;
      this.numberFilter.value = value;
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterObj) {
      var number = filterObj.number,
          comparator = filterObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: number === '' };
      });
      this.numberFilterComparator.value = comparator;
      this.numberFilter.value = number;
      this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;

      if (!withoutEmptyComparatorOption) {
        optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      }
      for (var i = 0; i < this.numberComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.numberComparators[i] },
          this.numberComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'getNumberOptions',
    value: function getNumberOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          withoutEmptyNumberOption = _props.withoutEmptyNumberOption;

      if (!withoutEmptyNumberOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          this.props.placeholder || 'Select ' + this.props.columnName + '...'
        ));
      }
      for (var i = 0; i < options.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: options[i] },
          options[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.numberFilterComparator.value;
      var number = this.numberFilter.value;
      if (comparator && number) {
        this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var selectClass = (0, _classnames2.default)('select-filter', 'number-filter-input', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'div',
        { className: 'filter number-filter' },
        _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this3.numberFilterComparator = n;
            },
            style: this.props.style.comparator,
            className: 'number-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        this.props.options ? _react2.default.createElement(
          'select',
          { ref: function ref(n) {
              return _this3.numberFilter = n;
            },
            className: selectClass,
            onChange: this.onChangeNumberSet,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' },
          this.getNumberOptions()
        ) : _react2.default.createElement('input', { ref: function ref(n) {
            return _this3.numberFilter = n;
          },
          type: 'number',
          style: this.props.style.number,
          className: 'number-filter-input form-control',
          placeholder: this.props.placeholder || 'Enter ' + this.props.columnName + '...',
          onChange: this.onChangeNumber,
          defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' })
      );
    }
  }]);

  return NumberFilter;
}(_react.Component);

NumberFilter.propTypes = {
  filterHandler: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.number),
  defaultValue: _propTypes2.default.shape({
    number: _propTypes2.default.number,
    comparator: _propTypes2.default.oneOf(legalComparators)
  }),
  style: _propTypes2.default.shape({
    number: _propTypes2.default.oneOfType([_propTypes2.default.object]),
    comparator: _propTypes2.default.oneOfType([_propTypes2.default.object])
  }),
  delay: _propTypes2.default.number,
  /* eslint consistent-return: 0 */
  numberComparators: function numberComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Number comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  placeholder: _propTypes2.default.string,
  columnName: _propTypes2.default.any,
  withoutEmptyComparatorOption: _propTypes2.default.bool,
  withoutEmptyNumberOption: _propTypes2.default.bool
};

NumberFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY,
  withoutEmptyComparatorOption: false,
  withoutEmptyNumberOption: false,
  style: {
    number: null,
    comparator: null
  }
};

var _default = NumberFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(NumberFilter, 'NumberFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
}();

;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _SelectRowHeaderColumn = __webpack_require__(451);

var _SelectRowHeaderColumn2 = _interopRequireDefault(_SelectRowHeaderColumn);

var _ExpandRowHeaderColumn = __webpack_require__(452);

var _ExpandRowHeaderColumn2 = _interopRequireDefault(_ExpandRowHeaderColumn);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update(this.props.checked);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.update(props.checked);
    }
  }, {
    key: 'update',
    value: function update(checked) {
      _reactDom2.default.findDOMNode(this).indeterminate = checked === 'indeterminate';
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', { className: 'react-bs-select-all',
        type: 'checkbox',
        checked: this.props.checked,
        onChange: this.props.onChange });
    }
  }]);

  return Checkbox;
}(_react.Component);

function getSortOrder(sortList, field, enableSort) {
  if (!enableSort) return undefined;
  var result = sortList.filter(function (sortObj) {
    return sortObj.sortField === field;
  });
  if (result.length > 0) {
    return result[0].order;
  } else {
    return undefined;
  }
}

var TableHeader = function (_Component2) {
  _inherits(TableHeader, _Component2);

  function TableHeader() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref, [this].concat(args))), _this2), _this2.getHeaderColGrouop = function () {
      var _this3;

      return (_this3 = _this2).__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(TableHeader, [{
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          sortIndicator = _props.sortIndicator,
          sortList = _props.sortList,
          onSort = _props.onSort,
          reset = _props.reset,
          version = _props.version,
          condensed = _props.condensed,
          bordered = _props.bordered,
          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
          noAnyExpand = _props.noAnyExpand,
          toggleExpandAllChilds = _props.toggleExpandAllChilds,
          expandAll = _props.expandAll;

      var containerClasses = (0, _classnames2.default)('react-bs-container-header', 'table-header-wrapper', this.props.headerContainerClass);
      var customTableClasses = {
        'table-bordered': bordered
      };
      if (condensed) {
        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
      }
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', customTableClasses, this.props.tableHeaderClass);

      var rowCount = Math.max.apply(Math, _toConsumableArray(_react2.default.Children.map(this.props.children, function (elm) {
        return elm && elm.props.row ? Number(elm.props.row) : 0;
      })));

      var rows = [];
      var rowKey = 0;

      rows[0] = [];
      rows[0].push([this.props.expandColumnVisible && this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
        noAnyExpand: noAnyExpand,
        expandAll: expandAll,
        toggleExpandAllChilds: toggleExpandAllChilds })], [this.renderSelectRowHeader(rowCount + 1, rowKey++)], [this.props.expandColumnVisible && !this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { key: 'expandCol', rowCount: rowCount + 1,
        expandedColumnHeaderComponent: expandedColumnHeaderComponent,
        noAnyExpand: noAnyExpand,
        expandAll: expandAll,
        toggleExpandAllChilds: toggleExpandAllChilds })]);

      _react2.default.Children.forEach(this.props.children, function (elm) {
        if (elm === null || elm === undefined) {
          // Skip null or undefined elements.
          return;
        }
        var _elm$props = elm.props,
            dataField = _elm$props.dataField,
            dataSort = _elm$props.dataSort;

        var sort = getSortOrder(sortList, dataField, dataSort);
        var rowIndex = elm.props.row ? Number(elm.props.row) : 0;
        var rowSpan = elm.props.rowSpan ? Number(elm.props.rowSpan) : 1;
        if (rows[rowIndex] === undefined) {
          rows[rowIndex] = [];
        }
        if (rowSpan + rowIndex === rowCount + 1) {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { reset: reset, key: rowKey++, onSort: onSort, sort: sort, sortIndicator: sortIndicator, isOnlyHead: false, version: version }));
        } else {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { key: rowKey++, isOnlyHead: true, version: version }));
        }
      });

      var trs = rows.map(function (row, indexRow) {
        return _react2.default.createElement(
          'tr',
          { key: indexRow },
          row
        );
      });

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this4.container = node;
          },
          className: containerClasses,
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(this.props.colGroups, { ref: function ref(node) {
              return _this4.headerGrp = node;
            } }),
          _react2.default.createElement(
            'thead',
            { ref: function ref(node) {
                return _this4.header = node;
              } },
            trs
          )
        )
      );
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.headerGrp.childNodes;
    }
  }, {
    key: 'renderSelectRowHeader',
    value: function renderSelectRowHeader(rowCount, rowKey) {
      if (this.props.hideSelectColumn) {
        return null;
      } else if (this.props.customComponent) {
        var CustomComponent = this.props.customComponent;
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(CustomComponent, { type: 'checkbox', checked: this.props.isSelectAll,
            indeterminate: this.props.isSelectAll === 'indeterminate', disabled: false,
            onChange: this.props.onSelectAllRow, rowIndex: 'Header' })
        );
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_SINGLE) {
        return _react2.default.createElement(_SelectRowHeaderColumn2.default, { key: rowKey, rowCount: rowCount });
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(Checkbox, {
            onChange: this.props.onSelectAllRow,
            checked: this.props.isSelectAll })
        );
      } else {
        return null;
      }
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.propTypes = {
  headerContainerClass: _propTypes2.default.string,
  tableHeaderClass: _propTypes2.default.string,
  style: _propTypes2.default.object,
  rowSelectType: _propTypes2.default.string,
  onSort: _propTypes2.default.func,
  onSelectAllRow: _propTypes2.default.func,
  sortList: _propTypes2.default.array,
  hideSelectColumn: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  isFiltered: _propTypes2.default.bool,
  isSelectAll: _propTypes2.default.oneOf([true, 'indeterminate', false]),
  sortIndicator: _propTypes2.default.bool,
  customComponent: _propTypes2.default.func,
  colGroups: _propTypes2.default.element,
  reset: _propTypes2.default.bool,
  expandColumnVisible: _propTypes2.default.bool,
  expandColumnComponent: _propTypes2.default.func,
  expandedColumnHeaderComponent: _propTypes2.default.func,
  expandColumnBeforeSelectColumn: _propTypes2.default.bool,
  version: _propTypes2.default.string,
  noAnyExpand: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool,
  toggleExpandAllChilds: _propTypes2.default.func
};

var _default = TableHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(getSortOrder, 'getSortOrder', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(TableHeader, 'TableHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
}();

;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectRowHeaderColumn = function (_Component) {
  _inherits(SelectRowHeaderColumn, _Component);

  function SelectRowHeaderColumn() {
    _classCallCheck(this, SelectRowHeaderColumn);

    return _possibleConstructorReturn(this, (SelectRowHeaderColumn.__proto__ || Object.getPrototypeOf(SelectRowHeaderColumn)).apply(this, arguments));
  }

  _createClass(SelectRowHeaderColumn, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          'data-is-only-head': false },
        this.props.children
      );
    }
  }]);

  return SelectRowHeaderColumn;
}(_react.Component);

SelectRowHeaderColumn.propTypes = {
  children: _propTypes2.default.node,
  rowCount: _propTypes2.default.number
};
var _default = SelectRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectRowHeaderColumn, 'SelectRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');
}();

;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandRowHeaderColumn = function (_Component) {
  _inherits(ExpandRowHeaderColumn, _Component);

  function ExpandRowHeaderColumn(props) {
    _classCallCheck(this, ExpandRowHeaderColumn);

    var _this = _possibleConstructorReturn(this, (ExpandRowHeaderColumn.__proto__ || Object.getPrototypeOf(ExpandRowHeaderColumn)).call(this, props));

    _this.toggleExpandAllChilds = _this.toggleExpandAllChilds.bind(_this);
    return _this;
  }

  _createClass(ExpandRowHeaderColumn, [{
    key: 'toggleExpandAllChilds',
    value: function toggleExpandAllChilds() {
      this.props.toggleExpandAllChilds();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandedColumnHeaderComponent = _props.expandedColumnHeaderComponent,
          noAnyExpand = _props.noAnyExpand,
          expandAll = _props.expandAll;

      var expandedHeaderComponent = noAnyExpand ? _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' }) : _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' });
      var ExpandedColumnHeaderComponent = expandedColumnHeaderComponent;

      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          className: 'react-bs-table-expand-cell',
          'data-is-only-head': false },
        expandAll ? _react2.default.createElement(
          'div',
          { onClick: this.toggleExpandAllChilds },
          expandedColumnHeaderComponent ? _react2.default.createElement(ExpandedColumnHeaderComponent, {
            anyExpand: !noAnyExpand }) : expandedHeaderComponent
        ) : null
      );
    }
  }]);

  return ExpandRowHeaderColumn;
}(_react.Component);

ExpandRowHeaderColumn.propTypes = {
  expandedColumnHeaderComponent: _propTypes2.default.func,
  rowCount: _propTypes2.default.number,
  noAnyExpand: _propTypes2.default.bool,
  expandAll: _propTypes2.default.bool,
  toggleExpandAllChilds: _propTypes2.default.func
};
var _default = ExpandRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandRowHeaderColumn, 'ExpandRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');
}();

;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFooter = function (_Component) {
  _inherits(TableFooter, _Component);

  function TableFooter() {
    _classCallCheck(this, TableFooter);

    return _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
  }

  _createClass(TableFooter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          hideSelectColumn = _props.hideSelectColumn,
          expandColumnVisible = _props.expandColumnVisible;

      var containerClasses = (0, _classnames2.default)('react-bs-container-footer', 'table-footer-wrapper');
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', {
        'table-bordered': this.props.bordered,
        'table-condensed': this.props.condensed
      }, this.props.tableFooterClass);
      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this2.container = node;
          },
          className: containerClasses,
          style: this.props.style },
        this.props.children.map(function (footerItem, footerItemIndex) {
          return _react2.default.createElement(
            'span',
            { key: footerItemIndex },
            _react2.default.createElement(
              'table',
              { className: tableClasses },
              _react2.default.cloneElement(_this2.props.colGroups),
              _react2.default.createElement(
                'tfoot',
                null,
                _react2.default.createElement(
                  'tr',
                  { ref: function ref(node) {
                      return _this2.footer = node;
                    } },
                  hideSelectColumn ? null : _this2.renderSelectionOrExpandCol(),
                  !expandColumnVisible ? null : _this2.renderSelectionOrExpandCol(),
                  _this2.props.columns.map(function (columnItem, colIndex) {
                    if (!columnItem.hidden) {
                      var footerObj = footerItem.filter(function (item) {
                        return item.columnIndex === colIndex;
                      });
                      var footerData = void 0;
                      var thAlignment = 'left';
                      if (footerObj.length) {
                        thAlignment = footerObj[0].align;
                        if (footerObj[0].formatter) {
                          footerData = footerObj[0].formatter(_this2.props.footerFormatterReturnData);
                        } else {
                          footerData = footerObj[0].label;
                        }
                      } else {
                        footerData = '';
                      }
                      return _react2.default.createElement(
                        'th',
                        {
                          key: colIndex,
                          style: {
                            minWidth: _this2.props.columns[colIndex].width + 'px',
                            textAlign: thAlignment
                          } },
                        footerData
                      );
                    }
                  })
                )
              )
            )
          );
        })
      );
    }
  }, {
    key: 'renderSelectionOrExpandCol',
    value: function renderSelectionOrExpandCol() {
      return _react2.default.createElement('th', null);
    }
  }]);

  return TableFooter;
}(_react.Component);

TableFooter.propTypes = {
  tableHeaderClass: _propTypes2.default.string,
  style: _propTypes2.default.object,
  hideSelectColumn: _propTypes2.default.bool,
  expandColumnVisible: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  isFiltered: _propTypes2.default.bool,
  sortIndicator: _propTypes2.default.bool
};

var _default = TableFooter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFooter, 'TableFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFooter.js');
}();

;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _TableRow = __webpack_require__(455);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableColumn = __webpack_require__(456);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _TableEditColumn = __webpack_require__(457);

var _TableEditColumn2 = _interopRequireDefault(_TableEditColumn);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpandComponent = __webpack_require__(458);

var _ExpandComponent2 = _interopRequireDefault(_ExpandComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_Component) {
  _inherits(TableBody, _Component);

  function TableBody(props) {
    _classCallCheck(this, TableBody);

    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

    _this.handleCellKeyDown = function () {
      return _this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRowColumChange = function () {
      return _this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickCell = function () {
      return _this.__handleClickCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.nextEditableCell = function () {
      return _this.__nextEditableCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCompleteEditCell = function () {
      return _this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.cancelEditCell = function () {
      return _this.__cancelEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickonSelectColumn = function () {
      return _this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHeaderColGrouop = function () {
      return _this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      currEditCell: null
    };
    return _this;
  }

  _createClass(TableBody, [{
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__() {
      return this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      return this.__cancelEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__() {
      return this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__() {
      return this.__nextEditableCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__() {
      return this.__handleEditCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__() {
      return this.__handleClickCell__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__() {
      return this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__() {
      return this.__handleSelectRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__() {
      return this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__() {
      return this.__handleRowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__() {
      return this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__() {
      return this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cellEdit = _props.cellEdit,
          beforeShowError = _props.beforeShowError,
          x = _props.x,
          y = _props.y,
          keyBoardNav = _props.keyBoardNav,
          trStyle = _props.trStyle,
          version = _props.version;

      var customTableClasses = {
        'table-striped': this.props.striped,
        'table-bordered': this.props.bordered,
        'table-hover': this.props.hover
      };
      if (this.props.condensed) {
        if (_util2.default.isBootstrap4(version)) customTableClasses['table-sm'] = true;else customTableClasses['table-condensed'] = true;
      }
      var tableClasses = (0, _classnames2.default)('table', customTableClasses, this.props.tableBodyClass);

      var noneditableRows = cellEdit.nonEditableRows && cellEdit.nonEditableRows() || [];
      var unselectable = this.props.selectRow.unselectable || [];
      var isSelectRowDefined = _util2.default.isSelectRowDefined(this.props.selectRow.mode);
      var tableHeader = _util2.default.renderColGroup(this.props.columns, this.props.selectRow, this.props.expandColumnOptions, version);
      var inputType = this.props.selectRow.mode === _Const2.default.ROW_SELECT_SINGLE ? 'radio' : 'checkbox';
      var CustomComponent = this.props.selectRow.customComponent;
      var enableKeyBoardNav = keyBoardNav === true || (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object';
      var customEditAndNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyleOnEditCell : null;
      var customNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyle : null;
      var ExpandColumnCustomComponent = this.props.expandColumnOptions.expandColumnComponent;
      var expandColSpan = this.props.columns.filter(function (col) {
        return col && !col.hidden;
      }).length;
      if (isSelectRowDefined && !this.props.selectRow.hideSelectColumn) {
        expandColSpan += 1;
      }
      var tabIndex = 1;
      if (this.props.expandColumnOptions.expandColumnVisible) {
        expandColSpan += 1;
      }

      var tableRows = this.props.data.map(function (data, r) {
        var tableColumns = this.props.columns.filter(function (_) {
          return _ != null;
        }).map(function (column, i) {
          var fieldValue = data[column.name];
          var isFocusCell = r === y && i === x;
          if (column.name !== this.props.keyField && // Key field can't be edit
          column.editable && // column is editable? default is true, user can set it false
          column.editable.readOnly !== true && this.state.currEditCell !== null && this.state.currEditCell.rid === r && this.state.currEditCell.cid === i && noneditableRows.indexOf(data[this.props.keyField]) === -1) {
            var editable = column.editable;
            var format = column.format ? function (value) {
              return column.format(value, data, column.formatExtraData, r).replace(/<.*?>/g, '');
            } : false;
            if (_util2.default.isFunction(column.editable)) {
              editable = column.editable(fieldValue, data, r, i);
            }

            return _react2.default.createElement(_TableEditColumn2.default, {
              completeEdit: this.handleCompleteEditCell
              // add by bluespring for column editor customize
              , editable: editable,
              attrs: column.editAttrs,
              customEditor: column.customEditor,
              format: column.format ? format : false,
              key: i,
              blurToSave: cellEdit.blurToSave,
              blurToEscape: cellEdit.blurToEscape,
              onTab: this.handleEditCell,
              rowIndex: r,
              colIndex: i,
              row: data,
              fieldValue: fieldValue,
              className: column.editClassName,
              invalidColumnClassName: column.invalidEditColumnClassName,
              beforeShowError: beforeShowError,
              isFocus: isFocusCell,
              customStyleWithNav: customEditAndNavStyle });
          } else {
            // add by bluespring for className customize
            var formattedValue = void 0;
            var columnChild = fieldValue && fieldValue.toString();
            var columnTitle = null;
            var tdClassName = column.className;
            var tdStyles = column.style;
            if (_util2.default.isFunction(column.className)) {
              tdClassName = column.className(fieldValue, data, r, i);
            }

            if (_util2.default.isFunction(column.style)) {
              tdStyles = column.style(fieldValue, data, r, i);
            }

            if (typeof column.format !== 'undefined') {
              formattedValue = column.format(fieldValue, data, column.formatExtraData, r);
              if (!_react2.default.isValidElement(formattedValue)) {
                columnChild = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: formattedValue } });
              } else {
                columnChild = formattedValue;
              }
            }
            if (_util2.default.isFunction(column.columnTitle)) {
              columnTitle = column.columnTitle(fieldValue, data, r, i);
            } else if (typeof column.columnTitle === 'string') {
              columnTitle = column.columnTitle;
            } else if (column.columnTitle) {
              if (formattedValue) columnTitle = formattedValue.toString();else if (fieldValue) columnTitle = fieldValue.toString();
            }
            return _react2.default.createElement(
              _TableColumn2.default,
              { key: i,
                cIndex: i,
                rIndex: r,
                dataAlign: column.align,
                className: tdClassName,
                columnTitle: columnTitle,
                cellEdit: cellEdit,
                hidden: column.hidden,
                onEdit: this.handleEditCell,
                width: column.width,
                onClick: this.handleClickCell,
                attrs: column.attrs,
                style: tdStyles,
                tabIndex: tabIndex++ + '',
                isFocus: isFocusCell,
                keyBoardNav: enableKeyBoardNav,
                onKeyDown: this.handleCellKeyDown,
                customNavStyle: customNavStyle,
                row: data,
                withoutTabIndex: this.props.withoutTabIndex },
              columnChild
            );
          }
        }, this);
        var key = data[this.props.keyField];
        var disable = unselectable.indexOf(key) !== -1;
        var selected = this.props.selectedRowKeys.indexOf(key) !== -1;
        var selectRowColumn = isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? this.renderSelectRowColumn(selected, inputType, disable, CustomComponent, r, data) : null;
        var expandedRowColumn = this.renderExpandRowColumn(this.props.expandableRow && this.props.expandableRow(data), this.props.expanding.indexOf(key) > -1, ExpandColumnCustomComponent, r);
        var haveExpandContent = this.props.expandableRow && this.props.expandableRow(data);
        var isExpanding = haveExpandContent && this.props.expanding.indexOf(key) > -1;
        var hideRowOnExpand = this.props.hideRowOnExpand;
        // add by bluespring for className customize

        var trClassName = this.props.trClassName;
        if (_util2.default.isFunction(this.props.trClassName)) {
          trClassName = this.props.trClassName(data, r);
        }
        if (isExpanding && this.props.expandParentClass) {
          trClassName += _util2.default.isFunction(this.props.expandParentClass) ? ' ' + this.props.expandParentClass(data, r) : ' ' + this.props.expandParentClass;
        }
        var result = [_react2.default.createElement(
          _TableRow2.default,
          { isSelected: selected, key: key, className: trClassName,
            index: r,
            row: data,
            selectRow: isSelectRowDefined ? this.props.selectRow : undefined,
            enableCellEdit: cellEdit.mode !== _Const2.default.CELL_EDIT_NONE,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            onExpandRow: this.handleClickCell,
            unselectableRow: disable,
            style: trStyle,
            hidden: isExpanding && hideRowOnExpand,
            dbClickToEdit: cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK },
          this.props.expandColumnOptions.expandColumnVisible && this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          selectRowColumn,
          this.props.expandColumnOptions.expandColumnVisible && !this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          tableColumns
        )];

        if (haveExpandContent) {
          var expandBodyClass = _util2.default.isFunction(this.props.expandBodyClass) ? this.props.expandBodyClass(data, r, isExpanding) : this.props.expandBodyClass;
          result.push(_react2.default.createElement(
            _ExpandComponent2.default,
            {
              key: key + '-expand',
              row: data,
              className: expandBodyClass,
              bgColor: this.props.expandRowBgColor || this.props.selectRow.bgColor || undefined,
              hidden: !isExpanding,
              colSpan: expandColSpan,
              width: "100%" },
            this.props.expandComponent(data)
          ));
        }
        return result;
      }, this);

      if (tableRows.length === 0 && !this.props.withoutNoDataText) {
        var colSpan = this.props.columns.filter(function (c) {
          return !c.hidden;
        }).length + (isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? 1 : 0) + (this.props.expandColumnOptions.expandColumnVisible ? 1 : 0);
        tableRows = [_react2.default.createElement(
          _TableRow2.default,
          { key: '##table-empty##', style: trStyle },
          _react2.default.createElement(
            'td',
            { 'data-toggle': 'collapse',
              colSpan: colSpan,
              className: 'react-bs-table-no-data' },
            this.props.noDataText || _Const2.default.NO_DATA_TEXT
          )
        )];
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(node) {
            return _this2.container = node;
          },
          className: (0, _classnames2.default)('react-bs-container-body', this.props.bodyContainerClass),
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(tableHeader, { ref: function ref(node) {
              return _this2.header = node;
            } }),
          _react2.default.createElement(
            'tbody',
            { ref: function ref(node) {
                return _this2.tbody = node;
              } },
            tableRows
          )
        )
      );
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__(e, lastEditCell) {
      e.preventDefault();
      var _props2 = this.props,
          keyBoardNav = _props2.keyBoardNav,
          onNavigateCell = _props2.onNavigateCell,
          cellEdit = _props2.cellEdit,
          selectedRowKeys = _props2.selectedRowKeys;

      var offset = void 0;
      if (e.keyCode === 37) {
        offset = { x: -1, y: 0 };
      } else if (e.keyCode === 38) {
        offset = { x: 0, y: -1 };
      } else if (e.keyCode === 39 || e.keyCode === 9) {
        offset = { x: 1, y: 0 };
        if (e.keyCode === 9 && lastEditCell) {
          offset = _extends({}, offset, {
            lastEditCell: lastEditCell
          });
        }
      } else if (e.keyCode === 40) {
        offset = { x: 0, y: 1 };
      } else if (e.keyCode === 13) {
        var rowIndex = e.target.parentElement.rowIndex + 1;
        var enterToEdit = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToEdit : false;
        var enterToExpand = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToExpand : false;
        var enterToSelect = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToSelect : false;

        if (cellEdit && enterToEdit) {
          this.handleEditCell(rowIndex, e.currentTarget.cellIndex, '', e);
        }

        if (enterToExpand) {
          this.handleClickCell(e, this.props.y + 1, this.props.x);
        }

        if (enterToSelect) {
          var isSelected = selectedRowKeys.indexOf(this.props.data[rowIndex - 1][this.props.keyField]) !== -1;
          this.handleSelectRow(rowIndex, !isSelected, e);
        }
      }
      if (offset && keyBoardNav) {
        onNavigateCell(offset);
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOut(targetRow, event);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOver(targetRow, event);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(rowIndex, cellIndex, event) {
      var _props3 = this.props,
          onRowClick = _props3.onRowClick,
          selectRow = _props3.selectRow;

      if (_util2.default.isSelectRowDefined(selectRow.mode)) cellIndex--;
      if (this._isExpandColumnVisible()) cellIndex--;
      onRowClick(this.props.data[rowIndex - 1], rowIndex - 1, cellIndex, event);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(rowIndex, event) {
      var onRowDoubleClick = this.props.onRowDoubleClick;

      var targetRow = this.props.data[rowIndex];
      onRowDoubleClick(targetRow, event);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(rowIndex, isSelected, e) {
      var selectedRow = void 0;
      var _props4 = this.props,
          data = _props4.data,
          onSelectRow = _props4.onSelectRow;

      data.forEach(function (row, i) {
        if (i === rowIndex - 1) {
          selectedRow = row;
          return false;
        }
      });
      onSelectRow(selectedRow, isSelected, e, rowIndex - 1);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__(e, rowIndex) {
      if (!this.props.selectRow.clickToSelect || !this.props.selectRow.clickToSelectAndEditCell) {
        this.handleSelectRow(rowIndex + 1, e.currentTarget.checked, e);
      }
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__(event, rowIndex) {
      var columnIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var _props5 = this.props,
          columns = _props5.columns,
          keyField = _props5.keyField,
          expandBy = _props5.expandBy,
          expandableRow = _props5.expandableRow,
          _props5$selectRow = _props5.selectRow,
          mode = _props5$selectRow.mode,
          clickToExpand = _props5$selectRow.clickToExpand,
          hideSelectColumn = _props5$selectRow.hideSelectColumn,
          onlyOneExpanding = _props5.onlyOneExpanding;

      var isSelectRowDefined = _util2.default.isSelectRowDefined(mode);
      var selectRowAndExpand = isSelectRowDefined && !clickToExpand ? false : true;
      columnIndex = isSelectRowDefined && !hideSelectColumn ? columnIndex - 1 : columnIndex;
      columnIndex = this._isExpandColumnVisible() ? columnIndex - 1 : columnIndex;
      if (expandableRow && selectRowAndExpand && (expandBy === _Const2.default.EXPAND_BY_ROW ||
      /* Below will allow expanding trigger by clicking on selection column
      if configure as expanding by column */
      expandBy === _Const2.default.EXPAND_BY_COL && columnIndex < 0 || expandBy === _Const2.default.EXPAND_BY_COL && columns[columnIndex].expandable)) {
        var expanding = this.props.expanding;
        var rowKey = this.props.data[rowIndex - 1][keyField];
        var isRowExpanding = expanding.indexOf(rowKey) > -1;

        if (isRowExpanding) {
          // collapse
          expanding = expanding.filter(function (k) {
            return k !== rowKey;
          });
        } else {
          // expand
          if (onlyOneExpanding) expanding = [rowKey];else expanding.push(rowKey);
        }
        this.props.onExpand(expanding, rowKey, isRowExpanding, event);
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(rowIndex, columnIndex, action, e) {
      var selectRow = this.props.selectRow;

      var defineSelectRow = _util2.default.isSelectRowDefined(selectRow.mode);
      var expandColumnVisible = this._isExpandColumnVisible();
      if (defineSelectRow) {
        columnIndex--;
        if (selectRow.hideSelectColumn) columnIndex++;
      }
      if (expandColumnVisible) {
        columnIndex--;
      }
      rowIndex--;

      if (action === 'tab') {
        if (defineSelectRow && !selectRow.hideSelectColumn) columnIndex++;
        if (expandColumnVisible) columnIndex++;
        this.handleCompleteEditCell(e.target.value, rowIndex, columnIndex - 1);
        if (columnIndex >= this.props.columns.length) {
          this.handleCellKeyDown(e, true);
        } else {
          this.handleCellKeyDown(e);
        }

        var _nextEditableCell = this.nextEditableCell(rowIndex, columnIndex),
            nextRIndex = _nextEditableCell.nextRIndex,
            nextCIndex = _nextEditableCell.nextCIndex;

        rowIndex = nextRIndex;
        columnIndex = nextCIndex;
      }

      var stateObj = {
        currEditCell: {
          rid: rowIndex,
          cid: columnIndex
        }
      };

      if (this.props.selectRow.clickToSelectAndEditCell && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        var selected = this.props.selectedRowKeys.indexOf(this.props.data[rowIndex][this.props.keyField]) !== -1;
        this.handleSelectRow(rowIndex + 1, !selected, e);
      }
      this.setState(function () {
        return stateObj;
      });
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__(rIndex, cIndex) {
      var keyField = this.props.keyField;

      var nextRIndex = rIndex;
      var nextCIndex = cIndex;
      var row = void 0;
      var column = void 0;
      do {
        if (nextCIndex >= this.props.columns.length) {
          nextRIndex++;
          nextCIndex = 0;
        }
        row = this.props.data[nextRIndex];
        column = this.props.columns[nextCIndex];
        if (!row) break;
        var editable = column.editable;
        if (_util2.default.isFunction(column.editable)) {
          editable = column.editable(column, row, nextRIndex, nextCIndex);
        }
        if (editable && editable.readOnly !== true && !column.hidden && keyField !== column.name) {
          break;
        } else {
          nextCIndex++;
        }
      } while (row);
      return { nextRIndex: nextRIndex, nextCIndex: nextCIndex };
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__(newVal, rowIndex, columnIndex) {
      if (newVal !== null) {
        var result = this.props.onEditCell(newVal, rowIndex, columnIndex);
        if (result !== _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          this.setState(function () {
            return { currEditCell: null };
          });
        }
      } else {
        this.setState(function () {
          return { currEditCell: null };
        });
      }
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { currEditCell: null };
      });
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__(e, isSelect, rowIndex, row) {
      e.stopPropagation();
      if (e.target.tagName === 'TD' && (this.props.selectRow.clickToSelect || this.props.selectRow.clickToSelectAndEditCell)) {
        var unselectable = this.props.selectRow.unselectable || [];
        if (unselectable.indexOf(row[this.props.keyField]) === -1) {
          this.handleSelectRow(rowIndex + 1, isSelect, e);
          this.handleClickCell(e, rowIndex + 1);
        }
      }
    }
  }, {
    key: 'renderSelectRowColumn',
    value: function renderSelectRowColumn(selected, inputType, disabled) {
      var CustomComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var _this3 = this;

      var rowIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var row = arguments[5];

      return _react2.default.createElement(
        'td',
        { onClick: function onClick(e) {
            _this3.handleClickonSelectColumn(e, !selected, rowIndex, row);
          }, style: { textAlign: 'center' } },
        CustomComponent ? _react2.default.createElement(CustomComponent, { type: inputType, checked: selected, disabled: disabled,
          rowIndex: rowIndex,
          onChange: function onChange(e) {
            return _this3.handleSelectRowColumChange(e, rowIndex);
          } }) : _react2.default.createElement('input', { type: inputType, checked: selected, disabled: disabled,
          onChange: function onChange(e) {
            return _this3.handleSelectRowColumChange(e, rowIndex);
          } })
      );
    }
  }, {
    key: 'renderExpandRowColumn',
    value: function renderExpandRowColumn(isExpandableRow, isExpanded, CustomComponent) {
      var _this4 = this;

      var rowIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var content = null;
      if (CustomComponent) {
        content = _react2.default.createElement(CustomComponent, { isExpandableRow: isExpandableRow, isExpanded: isExpanded });
      } else if (isExpandableRow) {
        content = isExpanded ? _react2.default.createElement('span', { className: 'fa fa-minus glyphicon glyphicon-minus' }) : _react2.default.createElement('span', { className: 'fa fa-plus glyphicon glyphicon-plus' });
      } else {
        content = ' ';
      }

      return _react2.default.createElement(
        'td',
        {
          className: 'react-bs-table-expand-cell',
          onClick: function onClick(e) {
            return _this4.handleClickCell(e, rowIndex + 1);
          } },
        content
      );
    }
  }, {
    key: '_isExpandColumnVisible',
    value: function _isExpandColumnVisible() {
      return this.props.expandColumnOptions.expandColumnVisible;
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.header.childNodes;
    }
  }]);

  return TableBody;
}(_react.Component);

TableBody.propTypes = {
  version: _propTypes2.default.string,
  data: _propTypes2.default.array,
  columns: _propTypes2.default.array,
  striped: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  hover: _propTypes2.default.bool,
  condensed: _propTypes2.default.bool,
  keyField: _propTypes2.default.string,
  selectedRowKeys: _propTypes2.default.array,
  onRowClick: _propTypes2.default.func,
  onRowDoubleClick: _propTypes2.default.func,
  onSelectRow: _propTypes2.default.func,
  noDataText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  withoutNoDataText: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  tableBodyClass: _propTypes2.default.string,
  bodyContainerClass: _propTypes2.default.string,
  expandableRow: _propTypes2.default.func,
  expandComponent: _propTypes2.default.func,
  expandRowBgColor: _propTypes2.default.string,
  expandBy: _propTypes2.default.string,
  expanding: _propTypes2.default.array,
  onExpand: _propTypes2.default.func,
  expandBodyClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  expandParentClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  onlyOneExpanding: _propTypes2.default.bool,
  beforeShowError: _propTypes2.default.func,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  x: _propTypes2.default.number,
  y: _propTypes2.default.number,
  onNavigateCell: _propTypes2.default.func,
  withoutTabIndex: _propTypes2.default.bool,
  hideRowOnExpand: _propTypes2.default.bool
};
var _default = TableBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableBody, 'TableBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');
}();

;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var TableRow = function (_Component) {
  _inherits(TableRow, _Component);

  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.rowClick = function () {
      return _this.__rowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.expandRow = function () {
      return _this.__expandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowDoubleClick = function () {
      return _this.__rowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOut = function () {
      return _this.__rowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOver = function () {
      return _this.__rowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.clickNum = 0;
    return _this;
  }

  _createClass(TableRow, [{
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__() {
      return this.__rowMouseOver__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__() {
      return this.__rowMouseOut__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__() {
      return this.__rowDoubleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__() {
      return this.__expandRow__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__() {
      return this.__rowClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__(e) {
      var _this2 = this;

      var rowIndex = this.props.index + 1;
      var cellIndex = e.target.cellIndex;
      if (this.props.onRowClick) this.props.onRowClick(rowIndex, cellIndex, e);
      var _props = this.props,
          selectRow = _props.selectRow,
          unselectableRow = _props.unselectableRow,
          isSelected = _props.isSelected,
          onSelectRow = _props.onSelectRow,
          onExpandRow = _props.onExpandRow,
          dbClickToEdit = _props.dbClickToEdit;

      if (selectRow) {
        if (selectRow.clickToSelect && !unselectableRow) {
          onSelectRow(rowIndex, !isSelected, e);
        } else if (selectRow.clickToSelectAndEditCell && !unselectableRow) {
          this.clickNum++;
          /** if clickToSelectAndEditCell is enabled,
           *  there should be a delay to prevent a selection changed when
           *  user dblick to edit cell on same row but different cell
          **/
          setTimeout(function () {
            if (_this2.clickNum === 1) {
              onSelectRow(rowIndex, !isSelected, e);
              onExpandRow(e, rowIndex, cellIndex);
            }
            _this2.clickNum = 0;
          }, 200);
        } else {
          if (dbClickToEdit) {
            this.expandRow(e, rowIndex, cellIndex);
          }
        }
      }
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__(event, rowIndex, cellIndex) {
      var _this3 = this;

      this.clickNum++;
      setTimeout(function () {
        if (_this3.clickNum === 1) {
          _this3.props.onExpandRow(event, rowIndex, cellIndex);
        }
        _this3.clickNum = 0;
      }, 200);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'SELECT' && e.target.tagName !== 'TEXTAREA') {
        if (this.props.onRowDoubleClick) {
          this.props.onRowDoubleClick(this.props.index, e);
        }
      }
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOut) {
        this.props.onRowMouseOut(rowIndex, e);
      }
    }
  }, {
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOver) {
        this.props.onRowMouseOver(rowIndex, e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      this.clickNum = 0;
      var _props2 = this.props,
          selectRow = _props2.selectRow,
          row = _props2.row,
          isSelected = _props2.isSelected,
          className = _props2.className,
          index = _props2.index,
          hidden = _props2.hidden;
      var style = this.props.style;

      var backgroundColor = null;
      var selectRowClass = null;

      if (selectRow) {
        backgroundColor = _util2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(row, isSelected) : isSelected ? selectRow.bgColor : null;

        selectRowClass = _util2.default.isFunction(selectRow.className) ? selectRow.className(row, isSelected) : isSelected ? selectRow.className : null;
      }

      if (_util2.default.isFunction(style)) {
        style = style(row, index);
      } else {
        style = _extends({}, style) || {};
      }
      // the bgcolor of row selection always overwrite the bgcolor defined by global.
      if (style && backgroundColor && isSelected) {
        style.backgroundColor = backgroundColor;
      }
      var trCss = {
        style: _extends({}, style),
        className: (0, _classnames2.default)(selectRowClass, className)
      };

      return _react2.default.createElement(
        'tr',
        _extends({}, trCss, {
          onMouseOver: this.rowMouseOver,
          onMouseOut: this.rowMouseOut,
          onClick: this.rowClick,
          hidden: hidden,
          onDoubleClick: this.rowDoubleClick }),
        this.props.children
      );
    }
  }]);

  return TableRow;
}(_react.Component);

TableRow.propTypes = {
  index: _propTypes2.default.number,
  row: _propTypes2.default.any,
  style: _propTypes2.default.any,
  isSelected: _propTypes2.default.bool,
  enableCellEdit: _propTypes2.default.bool,
  onRowClick: _propTypes2.default.func,
  onRowDoubleClick: _propTypes2.default.func,
  onSelectRow: _propTypes2.default.func,
  onExpandRow: _propTypes2.default.func,
  onRowMouseOut: _propTypes2.default.func,
  onRowMouseOver: _propTypes2.default.func,
  unselectableRow: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool
};
TableRow.defaultProps = {
  onRowClick: undefined,
  onRowDoubleClick: undefined,
  hidden: false
};
var _default = TableRow;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableRow, 'TableRow', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');
}();

;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumn = function (_Component) {
  _inherits(TableColumn, _Component);

  function TableColumn(props) {
    _classCallCheck(this, TableColumn);

    var _this = _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call(this, props));

    _this.handleCellEdit = function () {
      return _this.__handleCellEdit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCellClick = function () {
      return _this.__handleCellClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyDown = function () {
      return _this.__handleKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }
  /* eslint no-unused-vars: [0, { "args": "after-used" }] */


  _createClass(TableColumn, [{
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__() {
      return this.__handleKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__() {
      return this.__handleCellClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__() {
      return this.__handleCellEdit__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var children = this.props.children;

      var shouldUpdated = this.props.width !== nextProps.width || this.props.className !== nextProps.className || this.props.hidden !== nextProps.hidden || this.props.dataAlign !== nextProps.dataAlign || this.props.isFocus !== nextProps.isFocus || (typeof children === 'undefined' ? 'undefined' : _typeof(children)) !== _typeof(nextProps.children) || ('' + this.props.onEdit).toString() !== ('' + nextProps.onEdit).toString();

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if ((typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object' && children !== null && children.props !== null) {
        if (children.props.type === 'checkbox' || children.props.type === 'radio') {
          shouldUpdated = shouldUpdated || children.props.type !== nextProps.children.props.type || children.props.checked !== nextProps.children.props.checked || children.props.disabled !== nextProps.children.props.disabled;
        } else {
          shouldUpdated = true;
        }
      } else {
        shouldUpdated = shouldUpdated || children !== nextProps.children;
      }

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if (!(this.props.cellEdit && nextProps.cellEdit)) {
        return false;
      } else {
        return shouldUpdated || this.props.cellEdit.mode !== nextProps.cellEdit.mode;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__(e) {
      try {
        if (this.props.cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          if (document.selection && document.selection.empty) {
            document.selection.empty();
          } else if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
          }
        }
      } catch (err) {} /* eslint no-empty: 0 */
      this.props.onEdit(this.props.rIndex + 1, e.currentTarget.cellIndex, e);
      if (this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        this.props.onClick(e, this.props.rIndex + 1, e.currentTarget.cellIndex);
      }
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onClick = _props.onClick,
          rIndex = _props.rIndex;

      if (onClick) {
        onClick(e, rIndex + 1, e.currentTarget.cellIndex);
      }
    }
  }, {
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__(e) {
      if (this.props.keyBoardNav) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnTitle = _props2.columnTitle,
          dataAlign = _props2.dataAlign,
          hidden = _props2.hidden,
          cellEdit = _props2.cellEdit,
          attrs = _props2.attrs,
          style = _props2.style,
          isFocus = _props2.isFocus,
          keyBoardNav = _props2.keyBoardNav,
          tabIndex = _props2.tabIndex,
          customNavStyle = _props2.customNavStyle,
          withoutTabIndex = _props2.withoutTabIndex,
          row = _props2.row;
      var className = this.props.className;


      var tdStyle = _extends({
        textAlign: dataAlign,
        display: hidden ? 'none' : null
      }, style);

      var opts = {};

      if (cellEdit) {
        if (cellEdit.mode === _Const2.default.CELL_EDIT_CLICK) {
          opts.onClick = this.handleCellEdit;
        } else if (cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          opts.onDoubleClick = this.handleCellEdit;
        } else {
          opts.onClick = this.handleCellClick;
        }
      }

      if (keyBoardNav && isFocus) {
        opts.onKeyDown = this.handleKeyDown;
      }

      if (isFocus) {
        if (customNavStyle) {
          var cusmtStyle = _util2.default.isFunction(customNavStyle) ? customNavStyle(children, row) : customNavStyle;
          tdStyle = _extends({}, tdStyle, cusmtStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      var attr = {};
      if (!withoutTabIndex) attr.tabIndex = tabIndex;
      return _react2.default.createElement(
        'td',
        _extends({}, attr, { style: tdStyle,
          title: columnTitle,
          className: className
        }, opts, attrs),
        typeof children === 'boolean' ? children.toString() : children
      );
    }
  }]);

  return TableColumn;
}(_react.Component);

TableColumn.propTypes = {
  rIndex: _propTypes2.default.number,
  dataAlign: _propTypes2.default.string,
  hidden: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  columnTitle: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  attrs: _propTypes2.default.object,
  style: _propTypes2.default.object,
  isFocus: _propTypes2.default.bool,
  onKeyDown: _propTypes2.default.func,
  tabIndex: _propTypes2.default.string,
  withoutTabIndex: _propTypes2.default.bool,
  keyBoardNav: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  customNavStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
  row: _propTypes2.default.any /* only used on custom styling for navigation */
};

TableColumn.defaultProps = {
  dataAlign: 'left',
  withoutTabIndex: false,
  hidden: false,
  className: '',
  isFocus: false,
  keyBoardNav: false
};
var _default = TableColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableColumn, 'TableColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');
}();

;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Editor = __webpack_require__(228);

var _Editor2 = _interopRequireDefault(_Editor);

var _Notification = __webpack_require__(229);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableEditColumn = function (_Component) {
  _inherits(TableEditColumn, _Component);

  function TableEditColumn(props) {
    _classCallCheck(this, TableEditColumn);

    var _this = _possibleConstructorReturn(this, (TableEditColumn.__proto__ || Object.getPrototypeOf(TableEditColumn)).call(this, props));

    _this.handleKeyPress = function () {
      return _this.__handleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleBlur = function () {
      return _this.__handleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCustomUpdate = function () {
      return _this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.notifyToastr = function () {
      return _this.__notifyToastr__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClick = function () {
      return _this.__handleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getInputRef = function () {
      return _this.__getInputRef__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHandleKeyPress = function () {
      return _this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHandleBlur = function () {
      return _this.__getHandleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    var _this$props = _this.props,
        fieldValue = _this$props.fieldValue,
        row = _this$props.row,
        className = _this$props.className;

    _this.focusInEditor = _this.focusInEditor.bind(_this);
    _this.state = {
      shakeEditor: false,
      className: _util2.default.isFunction(className) ? className(fieldValue, row) : className
    };
    return _this;
  }

  _createClass(TableEditColumn, [{
    key: '__getHandleBlur__REACT_HOT_LOADER__',
    value: function __getHandleBlur__REACT_HOT_LOADER__() {
      return this.__getHandleBlur__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
    value: function __getHandleKeyPress__REACT_HOT_LOADER__() {
      return this.__getHandleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__getInputRef__REACT_HOT_LOADER__',
    value: function __getInputRef__REACT_HOT_LOADER__() {
      return this.__getInputRef__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__() {
      return this.__handleClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__() {
      return this.__notifyToastr__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',
    value: function __handleCustomUpdate__REACT_HOT_LOADER__() {
      return this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__() {
      return this.__handleBlur__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__() {
      return this.__handleKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'valueShortCircuit',
    value: function valueShortCircuit(value) {
      return value === null || typeof value === 'undefined' ? '' : value;
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__(e) {
      if (e.keyCode === 13 || e.keyCode === 9) {
        // Pressed ENTER or TAB
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;

        if (e.keyCode === 9 && this.props.blurToSave || !this.validator(value)) {
          return;
        }

        if (e.keyCode === 13) {
          this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
        } else {
          this.props.onTab(this.props.rowIndex + 1, this.props.colIndex + 1, 'tab', e);
          e.preventDefault();
        }
      } else if (e.keyCode === 27) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      } else if (e.type === 'click' && !this.props.blurToSave) {
        // textarea click save button
        var _value = e.target.parentElement.firstChild.value;
        if (!this.validator(_value)) {
          return;
        }
        this.props.completeEdit(_value, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__(e) {
      e.stopPropagation();
      if (this.props.blurToSave) {
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;
        if (!this.validator(value)) {
          return false;
        }
        this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
      } else if (this.props.blurToEscape) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',


    // modified by iuculanop
    // BEGIN
    value: function __handleCustomUpdate__REACT_HOT_LOADER__(value) {
      if (!this.validator(value)) {
        return;
      }
      this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
    }
  }, {
    key: 'validator',
    value: function validator(value) {
      var ts = this;
      var valid = true;
      if (ts.props.editable.validator) {
        var checkVal = ts.props.editable.validator(value, this.props.row);
        var responseType = typeof checkVal === 'undefined' ? 'undefined' : _typeof(checkVal);
        if (responseType !== 'object' && checkVal !== true) {
          valid = false;
          this.notifyToastr('error', checkVal, '');
        } else if (responseType === 'object' && checkVal.isValid !== true) {
          valid = false;
          this.notifyToastr(checkVal.notification.type, checkVal.notification.msg, checkVal.notification.title);
        }
        if (!valid) {
          // animate input
          ts.clearTimeout();
          var _props = this.props,
              invalidColumnClassName = _props.invalidColumnClassName,
              row = _props.row;

          var className = _util2.default.isFunction(invalidColumnClassName) ? invalidColumnClassName(value, row) : invalidColumnClassName;
          ts.setState({ shakeEditor: true, className: className });
          ts.timeouteClear = setTimeout(function () {
            ts.setState({ shakeEditor: false });
          }, 300);
          this.focusInEditor();
          return valid;
        }
      }
      return valid;
    }
    // END

  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__(type, message, title) {
      var toastr = true;
      var beforeShowError = this.props.beforeShowError;

      if (beforeShowError) {
        toastr = beforeShowError(type, message, title);
      }
      if (toastr) {
        (0, _Notification.notice)(type, message, title);
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear !== 0) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInEditor();
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'focusInEditor',
    value: function focusInEditor() {
      if (this.inputRef && _util2.default.isFunction(this.inputRef.focus)) {
        this.inputRef.focus();
      }
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'TD') {
        e.stopPropagation();
      }
    }
  }, {
    key: '__getInputRef__REACT_HOT_LOADER__',
    value: function __getInputRef__REACT_HOT_LOADER__(userRef) {
      var _this2 = this;

      return function (ref) {
        _this2.inputRef = ref;
        if (_util2.default.isFunction(userRef)) {
          userRef(ref);
        } else if (typeof userRef === 'string') {
          throw new Error('Ref must be a function');
        }
      };
    }
  }, {
    key: '__getHandleKeyPress__REACT_HOT_LOADER__',
    value: function __getHandleKeyPress__REACT_HOT_LOADER__(customHandler) {
      var _this3 = this;

      return function (e) {
        _this3.handleKeyPress(e);
        if (_util2.default.isFunction(customHandler)) {
          customHandler(e);
        }
      };
    }
  }, {
    key: '__getHandleBlur__REACT_HOT_LOADER__',
    value: function __getHandleBlur__REACT_HOT_LOADER__(customHandler) {
      var _this4 = this;

      return function (e) {
        _this4.handleBlur(e);
        if (_util2.default.isFunction(customHandler)) {
          customHandler(e);
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          editable = _props2.editable,
          format = _props2.format,
          customEditor = _props2.customEditor,
          isFocus = _props2.isFocus,
          customStyleWithNav = _props2.customStyleWithNav,
          row = _props2.row,
          attrs = _props2.attrs;
      var shakeEditor = this.state.shakeEditor;

      var attr = _extends({}, editable.attrs, {
        ref: this.getInputRef(editable.attrs && editable.attrs.ref),
        onKeyDown: this.getHandleKeyPress(editable.attrs && editable.attrs.onKeyDown),
        onBlur: this.getHandleBlur(editable.attrs && editable.attrs.onBlur)
      });
      var style = { position: 'relative' };
      var fieldValue = this.props.fieldValue;
      var className = this.state.className;


      if (editable.placeholder) {
        attr.placeholder = editable.placeholder;
        /* eslint-disable no-console */
        console.warn('Setting editable.placeholder is deprecated. Use editable.attrs to set input attributes');
        /* eslint-enable no-console */
      }

      var editorClass = (0, _classnames2.default)({ 'animated': shakeEditor, 'shake': shakeEditor });
      fieldValue = fieldValue === 0 ? '0' : fieldValue;
      var cellEditor = void 0;
      if (customEditor) {
        var customEditorProps = _extends({
          row: row
        }, attr, {
          defaultValue: this.valueShortCircuit(fieldValue)
        }, customEditor.customEditorParameters);
        cellEditor = customEditor.getElement(this.handleCustomUpdate, customEditorProps);
      } else {
        cellEditor = (0, _Editor2.default)(editable, attr, format, editorClass, this.valueShortCircuit(fieldValue), null, row);
      }

      if (isFocus) {
        if (customStyleWithNav) {
          var customStyle = _util2.default.isFunction(customStyleWithNav) ? customStyleWithNav(fieldValue, row) : customStyleWithNav;
          style = _extends({}, style, customStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      return _react2.default.createElement(
        'td',
        _extends({}, attrs, {
          style: style,
          className: className,
          onClick: this.handleClick }),
        cellEditor
      );
    }
  }, {
    key: '_getCheckBoxValue',
    value: function _getCheckBoxValue(e) {
      var value = '';
      var values = e.currentTarget.value.split(':');
      value = e.currentTarget.checked ? values[0] : values[1];
      return value;
    }
  }]);

  return TableEditColumn;
}(_react.Component);

TableEditColumn.propTypes = {
  completeEdit: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number,
  colIndex: _propTypes2.default.number,
  blurToSave: _propTypes2.default.bool,
  blurToEscape: _propTypes2.default.bool,
  editable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  format: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  row: _propTypes2.default.any,
  fieldValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.any,
  beforeShowError: _propTypes2.default.func,
  isFocus: _propTypes2.default.bool,
  attrs: _propTypes2.default.object,
  customStyleWithNav: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
};

var _default = TableEditColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableEditColumn, 'TableEditColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');
}();

;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */
/* eslint no-nested-ternary: 0 */


var ExpandComponent = function (_Component) {
  _inherits(ExpandComponent, _Component);

  function ExpandComponent() {
    _classCallCheck(this, ExpandComponent);

    return _possibleConstructorReturn(this, (ExpandComponent.__proto__ || Object.getPrototypeOf(ExpandComponent)).apply(this, arguments));
  }

  _createClass(ExpandComponent, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var trCss = {
        style: {
          backgroundColor: this.props.bgColor
        },
        className: (0, _classnames2.default)(className)
      };
      return _react2.default.createElement(
        'tr',
        _extends({ hidden: this.props.hidden, width: this.props.width }, trCss),
        _react2.default.createElement(
          'td',
          { colSpan: this.props.colSpan },
          this.props.children
        )
      );
    }
  }]);

  return ExpandComponent;
}(_react.Component);

var _default = ExpandComponent;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandComponent, 'ExpandComponent', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');
}();

;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _PageButton = __webpack_require__(460);

var _PageButton2 = _interopRequireDefault(_PageButton);

var _SizePerPageDropDown = __webpack_require__(230);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationList = function (_Component) {
  _inherits(PaginationList, _Component);

  function PaginationList(props) {
    _classCallCheck(this, PaginationList);

    var _this = _possibleConstructorReturn(this, (PaginationList.__proto__ || Object.getPrototypeOf(PaginationList)).call(this, props));

    _this.changePage = function () {
      return _this.__changePage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.changeSizePerPage = function () {
      return _this.__changeSizePerPage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.toggleDropDown = function () {
      return _this.__toggleDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.closeDropDown = function () {
      return _this.__closeDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      open: _this.props.open
    };
    return _this;
  }

  _createClass(PaginationList, [{
    key: '__closeDropDown__REACT_HOT_LOADER__',
    value: function __closeDropDown__REACT_HOT_LOADER__() {
      return this.__closeDropDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      return this.__toggleDropDown__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__() {
      return this.__changeSizePerPage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__() {
      return this.__changePage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var keepSizePerPageState = this.props.keepSizePerPageState;

      if (!keepSizePerPageState) {
        this.closeDropDown();
      }
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__(page) {
      var _props = this.props,
          pageStartIndex = _props.pageStartIndex,
          prePage = _props.prePage,
          currPage = _props.currPage,
          nextPage = _props.nextPage,
          lastPage = _props.lastPage,
          firstPage = _props.firstPage,
          sizePerPage = _props.sizePerPage,
          keepSizePerPageState = _props.keepSizePerPageState;


      if (page === prePage) {
        page = currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
      } else if (page === nextPage) {
        page = currPage + 1 > this.lastPage ? this.lastPage : currPage + 1;
      } else if (page === lastPage) {
        page = this.lastPage;
      } else if (page === firstPage) {
        page = pageStartIndex;
      } else {
        page = parseInt(page, 10);
      }

      if (keepSizePerPageState) {
        this.closeDropDown();
      }

      if (page !== currPage) {
        this.props.changePage(page, sizePerPage);
      }
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__(pageNum) {
      var selectSize = typeof pageNum === 'string' ? parseInt(pageNum, 10) : pageNum;
      var currPage = this.props.currPage;

      if (selectSize !== this.props.sizePerPage) {
        this.totalPages = Math.ceil(this.props.dataSize / selectSize);
        this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
        if (currPage > this.lastPage) currPage = this.lastPage;
        this.props.changePage(currPage, selectSize);
        if (this.props.onSizePerPageList) {
          this.props.onSizePerPageList(selectSize);
        }
      }

      this.closeDropDown();
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      var _this2 = this;

      this.setState(function () {
        return {
          open: !_this2.state.open
        };
      });
    }
  }, {
    key: '__closeDropDown__REACT_HOT_LOADER__',
    value: function __closeDropDown__REACT_HOT_LOADER__() {
      this.setState(function () {
        return {
          open: false
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currPage = _props2.currPage,
          dataSize = _props2.dataSize,
          sizePerPage = _props2.sizePerPage,
          sizePerPageList = _props2.sizePerPageList,
          paginationShowsTotal = _props2.paginationShowsTotal,
          pageStartIndex = _props2.pageStartIndex,
          paginationPanel = _props2.paginationPanel,
          hidePageListOnlyOnePage = _props2.hidePageListOnlyOnePage;

      this.totalPages = Math.ceil(dataSize / sizePerPage);
      this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
      var pageBtns = this.makePage(_util2.default.isFunction(paginationPanel));
      var dropdown = this.makeDropDown();

      var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
      var start = (currPage - pageStartIndex) * sizePerPage;
      start = dataSize === 0 ? 0 : start + 1;
      var to = Math.min(sizePerPage * (currPage + offset) - 1, dataSize);
      if (to >= dataSize) to--;
      var total = paginationShowsTotal ? _react2.default.createElement(
        'span',
        null,
        'Showing rows ',
        start,
        ' to\xA0',
        to + 1,
        ' of\xA0',
        dataSize
      ) : null;

      if (_util2.default.isFunction(paginationShowsTotal)) {
        total = paginationShowsTotal(start, to + 1, dataSize);
      }

      var content = paginationPanel && paginationPanel({
        currPage: currPage,
        sizePerPage: sizePerPage,
        sizePerPageList: sizePerPageList,
        pageStartIndex: pageStartIndex,
        totalPages: this.totalPages,
        changePage: this.changePage,
        toggleDropDown: this.toggleDropDown,
        changeSizePerPage: this.changeSizePerPage,
        components: {
          totalText: total,
          sizePerPageDropdown: dropdown,
          pageList: pageBtns
        }
      });

      var hidePageList = hidePageListOnlyOnePage && this.totalPages === 1 ? 'none' : 'block';
      return _react2.default.createElement(
        'div',
        { className: 'row', style: { marginTop: 15 } },
        content || [_react2.default.createElement(
          'div',
          { key: 'paging-left', className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          total,
          sizePerPageList.length > 1 ? dropdown : null
        ), _react2.default.createElement(
          'div',
          { key: 'paging-right', style: { display: hidePageList },
            className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          pageBtns
        )]
      );
    }
  }, {
    key: 'makeDropDown',
    value: function makeDropDown() {
      var _this3 = this;

      var dropdown = void 0;
      var dropdownProps = void 0;
      var sizePerPageText = '';
      var _props3 = this.props,
          sizePerPageDropDown = _props3.sizePerPageDropDown,
          hideSizePerPage = _props3.hideSizePerPage,
          sizePerPage = _props3.sizePerPage,
          sizePerPageList = _props3.sizePerPageList;

      if (sizePerPageDropDown) {
        dropdown = sizePerPageDropDown({
          open: this.state.open,
          hideSizePerPage: hideSizePerPage,
          currSizePerPage: String(sizePerPage),
          sizePerPageList: sizePerPageList,
          toggleDropDown: this.toggleDropDown,
          changeSizePerPage: this.changeSizePerPage,
          onBlur: this.closeDropDown
        });
        if (dropdown.type.name === _SizePerPageDropDown2.default.name) {
          dropdownProps = dropdown.props;
        } else {
          return dropdown;
        }
      }

      if (dropdownProps || !dropdown) {
        var isBootstrap4 = _util2.default.isBootstrap4(this.props.version);
        var sizePerPageOptions = sizePerPageList.map(function (_sizePerPage) {
          var pageText = _sizePerPage.text || _sizePerPage;
          var pageNum = _sizePerPage.value || _sizePerPage;
          if (sizePerPage === pageNum) sizePerPageText = pageText;
          if (isBootstrap4) {
            return _react2.default.createElement(
              'a',
              {
                href: '#',
                tabIndex: '-1',
                key: pageText,
                className: 'dropdown-item',
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  _this3.changeSizePerPage(pageNum);
                } },
              pageText
            );
          } else {
            return _react2.default.createElement(
              'li',
              { key: pageText, role: 'presentation', className: 'dropdown-item' },
              _react2.default.createElement(
                'a',
                { role: 'menuitem',
                  tabIndex: '-1', href: '#',
                  'data-page': pageNum,
                  onMouseDown: function onMouseDown(e) {
                    e.preventDefault();
                    _this3.changeSizePerPage(pageNum);
                  } },
                pageText
              )
            );
          }
        });
        dropdown = _react2.default.createElement(_SizePerPageDropDown2.default, _extends({
          open: this.state.open,
          hidden: hideSizePerPage,
          currSizePerPage: String(sizePerPageText),
          options: sizePerPageOptions,
          onClick: this.toggleDropDown,
          onBlur: this.closeDropDown,
          isBootstrap4: isBootstrap4
        }, dropdownProps));
      }
      return dropdown;
    }
  }, {
    key: 'makePage',
    value: function makePage() {
      var _this4 = this;

      var isCustomPagingPanel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var pages = this.getPages();
      var isStart = function isStart(page, _ref) {
        var currPage = _ref.currPage,
            pageStartIndex = _ref.pageStartIndex,
            firstPage = _ref.firstPage,
            prePage = _ref.prePage;
        return currPage === pageStartIndex && (page === firstPage || page === prePage);
      };
      var isEnd = function isEnd(page, _ref2) {
        var currPage = _ref2.currPage,
            nextPage = _ref2.nextPage,
            lastPage = _ref2.lastPage;
        return currPage === _this4.lastPage && (page === nextPage || page === lastPage);
      };
      var pageBtns = pages.filter(function (page) {
        if (this.props.alwaysShowAllBtns) {
          return true;
        }
        return isStart(page, this.props) || isEnd(page, this.props) ? false : true;
      }, this).map(function (page, index) {
        var isActive = page === this.props.currPage;
        var isDisabled = isStart(page, this.props) || isEnd(page, this.props) ? true : false;
        var title = page + '';
        var pageNumber = page;

        if (page === this.props.nextPage) {
          title = this.props.nextPageTitle;
          pageNumber = this.props.currPage + 1;
        } else if (page === this.props.prePage) {
          title = this.props.prePageTitle;
          pageNumber = this.props.currPage - 1;
        } else if (page === this.props.firstPage) {
          title = this.props.firstPageTitle;
          pageNumber = this.props.pageStartIndex;
        } else if (page === this.props.lastPage) {
          title = this.props.lastPageTitle;
          pageNumber = this.getLastPage();
        }

        return _react2.default.createElement(
          _PageButton2.default,
          { key: index,
            title: title,
            changePage: this.changePage,
            active: isActive,
            disable: isDisabled,
            pageNumber: pageNumber },
          page
        );
      }, this);
      var classname = (0, _classnames2.default)(isCustomPagingPanel ? null : 'react-bootstrap-table-page-btns-ul', 'pagination');
      return _react2.default.createElement(
        'ul',
        { className: classname },
        pageBtns
      );
    }
  }, {
    key: 'getLastPage',
    value: function getLastPage() {
      return this.lastPage;
    }
  }, {
    key: 'getPages',
    value: function getPages() {
      var pages = void 0;
      var endPage = this.totalPages;
      if (endPage <= 0) return [];
      var startPage = Math.max(this.props.currPage - Math.floor(this.props.paginationSize / 2), this.props.pageStartIndex);
      endPage = startPage + this.props.paginationSize - 1;

      if (endPage > this.lastPage) {
        endPage = this.lastPage;
        startPage = endPage - this.props.paginationSize + 1;
      }

      if (startPage !== this.props.pageStartIndex && this.totalPages > this.props.paginationSize && this.props.withFirstAndLast) {
        pages = [this.props.firstPage, this.props.prePage];
      } else if (this.totalPages > 1 || this.props.alwaysShowAllBtns) {
        pages = [this.props.prePage];
      } else {
        pages = [];
      }

      for (var i = startPage; i <= endPage; i++) {
        if (i >= this.props.pageStartIndex) pages.push(i);
      }

      if (endPage <= this.lastPage && pages.length > 1) {
        pages.push(this.props.nextPage);
      }
      if (endPage !== this.lastPage && this.props.withFirstAndLast) {
        pages.push(this.props.lastPage);
      }

      return pages;
    }
  }]);

  return PaginationList;
}(_react.Component);

PaginationList.propTypes = {
  currPage: _propTypes2.default.number,
  sizePerPage: _propTypes2.default.number,
  dataSize: _propTypes2.default.number,
  changePage: _propTypes2.default.func,
  sizePerPageList: _propTypes2.default.array,
  paginationShowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  paginationSize: _propTypes2.default.number,
  onSizePerPageList: _propTypes2.default.func,
  prePage: _propTypes2.default.any,
  nextPage: _propTypes2.default.any,
  firstPage: _propTypes2.default.any,
  lastPage: _propTypes2.default.any,
  pageStartIndex: _propTypes2.default.number,
  hideSizePerPage: _propTypes2.default.bool,
  alwaysShowAllBtns: _propTypes2.default.bool,
  withFirstAndLast: _propTypes2.default.bool,
  sizePerPageDropDown: _propTypes2.default.func,
  paginationPanel: _propTypes2.default.func,
  prePageTitle: _propTypes2.default.string,
  nextPageTitle: _propTypes2.default.string,
  firstPageTitle: _propTypes2.default.string,
  lastPageTitle: _propTypes2.default.string,
  hidePageListOnlyOnePage: _propTypes2.default.bool,
  keepSizePerPageState: _propTypes2.default.bool
};

PaginationList.defaultProps = {
  sizePerPage: _Const2.default.SIZE_PER_PAGE,
  pageStartIndex: _Const2.default.PAGE_START_INDEX
};

var _default = PaginationList;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaginationList, 'PaginationList', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');
}();

;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageButton = function (_Component) {
  _inherits(PageButton, _Component);

  function PageButton(props) {
    _classCallCheck(this, PageButton);

    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));

    _this.pageBtnClick = function () {
      return _this.__pageBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }

  _createClass(PageButton, [{
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__() {
      return this.__pageBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__(e) {
      e.preventDefault();
      this.props.changePage(this.props.pageNumber);
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)({
        'active': this.props.active,
        'disabled': this.props.disable,
        'hidden': this.props.hidden,
        'page-item': true
      });
      return _react2.default.createElement(
        'li',
        { className: classes, title: this.props.title },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.pageBtnClick, className: 'page-link' },
          this.props.children
        )
      );
    }
  }]);

  return PageButton;
}(_react.Component);

PageButton.propTypes = {
  title: _propTypes2.default.string,
  changePage: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  disable: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  pageNumber: _propTypes2.default.number
};

var _default = PageButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PageButton, 'PageButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');
}();

;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(462);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _Notification = __webpack_require__(229);

var _InsertModal = __webpack_require__(470);

var _InsertModal2 = _interopRequireDefault(_InsertModal);

var _InsertButton = __webpack_require__(237);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(238);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(239);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(240);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _SearchField = __webpack_require__(241);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ClearSearchButton = __webpack_require__(242);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

// import classSet from 'classnames';

// import editor from '../Editor';


var ToolBar = function (_Component) {
  _inherits(ToolBar, _Component);

  function ToolBar(props) {
    _classCallCheck(this, ToolBar);

    var _this = _possibleConstructorReturn(this, (ToolBar.__proto__ || Object.getPrototypeOf(ToolBar)).call(this, props));

    _this.displayCommonMessage = function () {
      return _this.__displayCommonMessage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSaveBtnClick = function () {
      return _this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.afterHandleSaveBtnClick = function () {
      return _this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalClose = function () {
      return _this.__handleModalClose__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalOpen = function () {
      return _this.__handleModalOpen__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlyToggle = function () {
      return _this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRowBtnClick = function () {
      return _this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDebounce = function () {
      return _this.__handleDebounce__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClearBtnClick = function () {
      return _this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    _this.modalClassName;
    _this.state = {
      isInsertModalOpen: false,
      validateState: null,
      shakeEditor: false,
      showSelected: false
    };
    return _this;
  }

  _createClass(ToolBar, [{
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      return this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      return this.__handleExportCSV__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__() {
      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleDebounce__REACT_HOT_LOADER__',
    value: function __handleDebounce__REACT_HOT_LOADER__(func, wait, immediate) {
      var _this2 = this,
          _arguments = arguments;

      var timeout = void 0;

      return function () {
        var later = function later() {
          timeout = null;

          if (!immediate) {
            func.apply(_this2, _arguments);
          }
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait || 0);

        if (callNow) {
          func.appy(_this2, _arguments);
        }
      };
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      return this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      return this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      return this.__handleModalOpen__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      return this.__handleModalClose__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__() {
      return this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      return this.__displayCommonMessage__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var delay = this.props.searchDelayTime ? this.props.searchDelayTime : 0;
      this.debounceCallback = this.handleDebounce(function () {
        _this3.seachInput && _this3.props.onSearch(_this3.seachInput.getValue());
      }, delay);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.setSearchInput('');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'setSearchInput',
    value: function setSearchInput(text) {
      if (this.seachInput && this.seachInput.value !== text) {
        this.seachInput.value = text;
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      (0, _Notification.notice)('error', this.props.insertFailIndicator, '');
    }
  }, {
    key: 'validateNewRow',
    value: function validateNewRow(newRow) {
      var _this4 = this;

      var validateState = {};
      var isValid = true;
      var tempMsg = void 0;
      var responseType = void 0;

      this.props.columns.forEach(function (column) {
        if (column.isKey && column.keyValidator) {
          // key validator for checking exist key
          tempMsg = _this4.props.isValidKey(newRow[column.field]);
          if (tempMsg) {
            _this4.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          }
        } else if (column.editable && column.editable.validator) {
          // process validate
          tempMsg = column.editable.validator(newRow[column.field], newRow);
          responseType = typeof tempMsg === 'undefined' ? 'undefined' : _typeof(tempMsg);
          if (responseType !== 'object' && tempMsg !== true) {
            _this4.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          } else if (responseType === 'object' && tempMsg.isValid !== true) {
            (0, _Notification.notice)(tempMsg.notification.type, tempMsg.notification.msg, tempMsg.notification.title);
            isValid = false;
            validateState[column.field] = tempMsg.notification.msg;
          }
        }
      });

      if (isValid) {
        return true;
      } else {
        this.clearTimeout();
        // show error in form and shake it
        this.setState(function () {
          return { validateState: validateState, shakeEditor: true };
        });
        this.timeouteClear = setTimeout(function () {
          _this4.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
        return null;
      }
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(newRow) {
      if (!this.validateNewRow(newRow)) {
        // validation fail
        return;
      }
      var msg = this.props.onAddRow(newRow);
      if (msg !== false) {
        this.afterHandleSaveBtnClick(msg);
      }
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__(msg) {
      var _this5 = this;

      if (msg) {
        (0, _Notification.notice)('error', msg, '');
        this.clearTimeout();
        // shake form and hack prevent modal hide
        this.setState(function () {
          return {
            shakeEditor: true,
            validateState: 'this is hack for prevent bootstrap modal hide'
          };
        });
        // clear animate class
        this.timeouteClear = setTimeout(function () {
          _this5.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
      } else {
        // reset state and hide modal hide
        this.setState(function () {
          return {
            validateState: null,
            shakeEditor: false,
            isInsertModalOpen: false
          };
        });
      }
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: false };
      });
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: true };
      });
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      var _this6 = this;

      this.setState(function () {
        return {
          showSelected: !_this6.state.showSelected
        };
      });
      this.props.onShowOnlySelected();
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      this.props.onDropRow();
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(event) {
      event.persist();
      this.debounceCallback(event);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      this.props.onExportCSV();
    }
  }, {
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      this.seachInput && this.seachInput.setValue('');
      this.props.onSearch('');
    }
  }, {
    key: 'render',
    value: function render() {
      this.modalClassName = 'bs-table-modal-sm' + ToolBar.modalSeq++;
      var toolbar = null;
      var btnGroup = null;
      var insertBtn = null;
      var deleteBtn = null;
      var exportCSVBtn = null;
      var showSelectedOnlyBtn = null;

      if (this.props.enableInsert) {
        if (this.props.insertBtn) {
          insertBtn = this.renderCustomBtn(this.props.insertBtn, [this.handleModalOpen], _InsertButton2.default.name, 'onClick', this.handleModalOpen);
        } else {
          insertBtn = _react2.default.createElement(_InsertButton2.default, { btnText: this.props.insertText,
            onClick: this.handleModalOpen });
        }
      }

      if (this.props.enableDelete) {
        if (this.props.deleteBtn) {
          deleteBtn = this.renderCustomBtn(this.props.deleteBtn, [this.handleDropRowBtnClick], _DeleteButton2.default.name, 'onClick', this.handleDropRowBtnClick);
        } else {
          deleteBtn = _react2.default.createElement(_DeleteButton2.default, { btnText: this.props.deleteText,
            onClick: this.handleDropRowBtnClick });
        }
      }

      if (this.props.enableShowOnlySelected) {
        if (this.props.showSelectedOnlyBtn) {
          showSelectedOnlyBtn = this.renderCustomBtn(this.props.showSelectedOnlyBtn, [this.handleShowOnlyToggle, this.state.showSelected], _ShowSelectedOnlyButton2.default.name, 'onClick', this.handleShowOnlyToggle);
        } else {
          showSelectedOnlyBtn = _react2.default.createElement(_ShowSelectedOnlyButton2.default, { toggle: this.state.showSelected,
            onClick: this.handleShowOnlyToggle });
        }
      }

      if (this.props.enableExportCSV) {
        if (this.props.exportCSVBtn) {
          exportCSVBtn = this.renderCustomBtn(this.props.exportCSVBtn, [this.handleExportCSV], _ExportCSVButton2.default.name, 'onClick', this.handleExportCSV);
        } else {
          exportCSVBtn = _react2.default.createElement(_ExportCSVButton2.default, { btnText: this.props.exportCSVText,
            onClick: this.handleExportCSV });
        }
      }

      if (this.props.btnGroup) {
        btnGroup = this.props.btnGroup({
          exportCSVBtn: exportCSVBtn,
          insertBtn: insertBtn,
          deleteBtn: deleteBtn,
          showSelectedOnlyBtn: showSelectedOnlyBtn
        });
      } else {
        btnGroup = _react2.default.createElement(
          'div',
          { className: 'btn-group btn-group-sm', role: 'group' },
          exportCSVBtn,
          insertBtn,
          deleteBtn,
          showSelectedOnlyBtn
        );
      }

      var _renderSearchPanel = this.renderSearchPanel(),
          _renderSearchPanel2 = _slicedToArray(_renderSearchPanel, 3),
          searchPanel = _renderSearchPanel2[0],
          searchField = _renderSearchPanel2[1],
          clearBtn = _renderSearchPanel2[2];

      var modal = this.props.enableInsert ? this.renderInsertRowModal() : null;

      if (this.props.toolBar) {
        toolbar = this.props.toolBar({
          components: {
            exportCSVBtn: exportCSVBtn,
            insertBtn: insertBtn,
            deleteBtn: deleteBtn,
            showSelectedOnlyBtn: showSelectedOnlyBtn,
            searchPanel: searchPanel,
            btnGroup: btnGroup,
            searchField: searchField,
            clearBtn: clearBtn
          },
          event: {
            openInsertModal: this.handleModalOpen,
            closeInsertModal: this.handleModalClose,
            dropRow: this.handleDropRowBtnClick,
            showOnlyToogle: this.handleShowOnlyToggle,
            exportCSV: this.handleExportCSV,
            search: this.props.onSearch
          }
        });
      } else {
        toolbar = [_react2.default.createElement(
          'div',
          { key: 'toolbar-left', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-8' },
          this.props.searchPosition === 'left' ? searchPanel : btnGroup
        ), _react2.default.createElement(
          'div',
          { key: 'toolbar-right', className: 'col-xs-6 col-sm-6 col-md-6 col-lg-4' },
          this.props.searchPosition === 'left' ? btnGroup : searchPanel
        )];
      }

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        toolbar,
        modal
      );
    }
  }, {
    key: 'renderSearchPanel',
    value: function renderSearchPanel() {
      var _this7 = this;

      if (this.props.enableSearch) {
        var classNames = 'form-group form-group-sm react-bs-table-search-form';
        var clearBtn = null;
        var searchField = null;
        var searchPanel = null;
        if (this.props.clearSearch) {
          if (this.props.clearSearchBtn) {
            clearBtn = this.renderCustomBtn(this.props.clearSearchBtn, [this.handleClearBtnClick], _ClearSearchButton2.default.name, 'onClick', this.handleClearBtnClick); /* eslint max-len: 0*/
          } else {
            clearBtn = _react2.default.createElement(_ClearSearchButton2.default, { onClick: this.handleClearBtnClick });
          }
          classNames += ' input-group input-group-sm';
        }

        if (this.props.searchField) {
          searchField = this.props.searchField({
            search: this.handleKeyUp,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder
          });
          if (searchField.type.name === _SearchField2.default.name) {
            searchField = _react2.default.cloneElement(searchField, {
              ref: function ref(node) {
                return _this7.seachInput = node;
              },
              onKeyUp: this.handleKeyUp
            });
          } else {
            searchField = _react2.default.cloneElement(searchField, {
              ref: function ref(node) {
                return _this7.seachInput = node;
              }
            });
          }
        } else {
          searchField = _react2.default.createElement(_SearchField2.default, { ref: function ref(node) {
              return _this7.seachInput = node;
            },
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            onKeyUp: this.handleKeyUp });
        }
        if (this.props.searchPanel) {
          searchPanel = this.props.searchPanel({
            searchField: searchField, clearBtn: clearBtn,
            search: this.props.onSearch,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            clearBtnClick: this.handleClearBtnClick
          });
        } else {
          searchPanel = _react2.default.createElement(
            'div',
            { className: classNames },
            searchField,
            _react2.default.createElement(
              'span',
              { className: 'input-group-btn' },
              clearBtn
            )
          );
        }
        return [searchPanel, searchField, clearBtn];
      } else {
        return [];
      }
    }
  }, {
    key: 'renderInsertRowModal',
    value: function renderInsertRowModal() {
      var validateState = this.state.validateState || {};
      var _props = this.props,
          version = _props.version,
          columns = _props.columns,
          ignoreEditable = _props.ignoreEditable,
          insertModalHeader = _props.insertModalHeader,
          insertModalBody = _props.insertModalBody,
          insertModalFooter = _props.insertModalFooter,
          insertModal = _props.insertModal;


      var modal = void 0;
      modal = insertModal && insertModal(this.handleModalClose, this.handleSaveBtnClick, columns, validateState, ignoreEditable);

      if (!modal) {
        modal = _react2.default.createElement(_InsertModal2.default, {
          version: version,
          columns: columns,
          validateState: validateState,
          ignoreEditable: ignoreEditable,
          onModalClose: this.handleModalClose,
          onSave: this.handleSaveBtnClick,
          headerComponent: insertModalHeader,
          bodyComponent: insertModalBody,
          footerComponent: insertModalFooter });
      }

      return _react2.default.createElement(
        _reactModal2.default,
        { className: 'react-bs-insert-modal modal-dialog',
          isOpen: this.state.isInsertModalOpen,
          ariaHideApp: false,
          onRequestClose: this.handleModalClose,
          contentLabel: 'Modal' },
        modal
      );
    }
  }, {
    key: 'renderCustomBtn',
    value: function renderCustomBtn(cb, params, componentName, eventName, event) {
      var element = cb.apply(null, params);
      if (element.type.name === componentName && !element.props[eventName]) {
        var props = {};
        props[eventName] = event;
        element = _react2.default.cloneElement(element, props);
      }
      return element;
    }
  }]);

  return ToolBar;
}(_react.Component);

ToolBar.modalSeq = 0;


ToolBar.propTypes = {
  version: _propTypes2.default.string,
  onAddRow: _propTypes2.default.func,
  onDropRow: _propTypes2.default.func,
  onShowOnlySelected: _propTypes2.default.func,
  enableInsert: _propTypes2.default.bool,
  enableDelete: _propTypes2.default.bool,
  enableSearch: _propTypes2.default.bool,
  enableShowOnlySelected: _propTypes2.default.bool,
  columns: _propTypes2.default.array,
  searchPlaceholder: _propTypes2.default.string,
  exportCSVText: _propTypes2.default.string,
  insertText: _propTypes2.default.string,
  deleteText: _propTypes2.default.string,
  saveText: _propTypes2.default.string,
  closeText: _propTypes2.default.string,
  clearSearch: _propTypes2.default.bool,
  ignoreEditable: _propTypes2.default.bool,
  defaultSearch: _propTypes2.default.string,
  insertModalHeader: _propTypes2.default.func,
  insertModalBody: _propTypes2.default.func,
  insertModalFooter: _propTypes2.default.func,
  insertModal: _propTypes2.default.func,
  insertBtn: _propTypes2.default.func,
  deleteBtn: _propTypes2.default.func,
  showSelectedOnlyBtn: _propTypes2.default.func,
  exportCSVBtn: _propTypes2.default.func,
  clearSearchBtn: _propTypes2.default.func,
  searchField: _propTypes2.default.func,
  searchPanel: _propTypes2.default.func,
  btnGroup: _propTypes2.default.func,
  toolBar: _propTypes2.default.func,
  searchPosition: _propTypes2.default.string,
  reset: _propTypes2.default.bool,
  isValidKey: _propTypes2.default.func,
  insertFailIndicator: _propTypes2.default.string
};

ToolBar.defaultProps = {
  reset: false,
  enableInsert: false,
  enableDelete: false,
  enableSearch: false,
  enableShowOnlySelected: false,
  clearSearch: false,
  ignoreEditable: false,
  exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
  insertText: _Const2.default.INSERT_BTN_TEXT,
  deleteText: _Const2.default.DELETE_BTN_TEXT,
  saveText: _Const2.default.SAVE_BTN_TEXT,
  closeText: _Const2.default.CLOSE_BTN_TEXT
};

var _default = ToolBar;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ToolBar, 'ToolBar', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');
}();

;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(463);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(464);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(232);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(128);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(233);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(465);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(466);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(232);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(469);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(128);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(231);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(231);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof tabbable[x] === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InsertModalHeader = __webpack_require__(234);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalFooter = __webpack_require__(235);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertModalBody = __webpack_require__(236);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

var defaultModalClassName = 'react-bs-table-insert-modal';

var InsertModal = function (_Component) {
  _inherits(InsertModal, _Component);

  function InsertModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModal.__proto__ || Object.getPrototypeOf(InsertModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function () {
      var _this2;

      return (_this2 = _this).__handleSave__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModal, [{
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      return this.__handleSave__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      if (this.body.getFieldValue) {
        this.props.onSave(this.body.getFieldValue());
      } else {
        console.error('Custom InsertModalBody should implement getFieldValue function\n        and should return an object presented as the new row that user input.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          headerComponent = _props.headerComponent,
          footerComponent = _props.footerComponent,
          bodyComponent = _props.bodyComponent;
      var _props2 = this.props,
          columns = _props2.columns,
          validateState = _props2.validateState,
          ignoreEditable = _props2.ignoreEditable,
          onModalClose = _props2.onModalClose;

      var bodyAttr = { columns: columns, validateState: validateState, ignoreEditable: ignoreEditable };

      bodyComponent = bodyComponent && bodyComponent(columns, validateState, ignoreEditable);

      headerComponent = headerComponent && headerComponent(onModalClose, this.handleSave);

      footerComponent = footerComponent && footerComponent(onModalClose, this.handleSave);

      if (bodyComponent) {
        bodyComponent = _react2.default.cloneElement(bodyComponent, { ref: function ref(node) {
            return _this3.body = node;
          } });
      }

      if (headerComponent && headerComponent.type.name === _InsertModalHeader2.default.name) {
        var eventProps = {};
        if (!headerComponent.props.onModalClose) eventProps.onModalClose = onModalClose;
        if (!headerComponent.props.onSave) eventProps.onSave = this.handleSave;
        if (Object.keys(eventProps).length > 0) {
          headerComponent = _react2.default.cloneElement(headerComponent, eventProps);
        }
      } else if (headerComponent && headerComponent.type.name !== _InsertModalHeader2.default.name) {
        var className = headerComponent.props.className;

        if (typeof className === 'undefined' || className.indexOf('modal-header') === -1) {
          headerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            headerComponent
          );
        }
      }

      if (footerComponent && footerComponent.type.name === _InsertModalFooter2.default.name) {
        var _eventProps = {};
        if (!footerComponent.props.onModalClose) _eventProps.onModalClose = onModalClose;
        if (!footerComponent.props.onSave) _eventProps.onSave = this.handleSave;
        if (Object.keys(_eventProps).length > 0) {
          footerComponent = _react2.default.cloneElement(footerComponent, _eventProps);
        }
      } else if (footerComponent && footerComponent.type.name !== _InsertModalFooter2.default.name) {
        var _className = footerComponent.props.className;

        if (typeof _className === 'undefined' || _className.indexOf('modal-footer') === -1) {
          footerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            footerComponent
          );
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'modal-content ' + defaultModalClassName },
        headerComponent || _react2.default.createElement(_InsertModalHeader2.default, {
          version: this.props.version,
          className: 'react-bs-table-inser-modal-header',
          onModalClose: onModalClose }),
        bodyComponent || _react2.default.createElement(_InsertModalBody2.default, _extends({ ref: function ref(node) {
            return _this3.body = node;
          } }, bodyAttr)),
        footerComponent || _react2.default.createElement(_InsertModalFooter2.default, {
          className: 'react-bs-table-inser-modal-footer',
          onModalClose: onModalClose,
          onSave: this.handleSave })
      );
    }
  }]);

  return InsertModal;
}(_react.Component);

var _default = InsertModal;
exports.default = _default;

InsertModal.propTypes = {
  version: _propTypes2.default.string.isRequired,
  columns: _propTypes2.default.array.isRequired,
  validateState: _propTypes2.default.object.isRequired,
  ignoreEditable: _propTypes2.default.bool,
  headerComponent: _propTypes2.default.func,
  bodyComponent: _propTypes2.default.func,
  footerComponent: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func,
  onSave: _propTypes2.default.func
};

InsertModal.defaultProps = {};
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultModalClassName, 'defaultModalClassName', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(InsertModal, 'InsertModal', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
}();

;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFilter = function (_Component) {
  _inherits(TableFilter, _Component);

  function TableFilter(props) {
    _classCallCheck(this, TableFilter);

    var _this = _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).call(this, props));

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.filterObj = {};
    return _this;
  }

  _createClass(TableFilter, [{
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__() {
      return this.__handleKeyUp__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(e) {
      var _e$currentTarget = e.currentTarget,
          value = _e$currentTarget.value,
          name = _e$currentTarget.name;

      if (value.trim() === '') {
        delete this.filterObj[name];
      } else {
        this.filterObj[name] = value;
      }
      this.props.onFilter(this.filterObj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          striped = _props.striped,
          condensed = _props.condensed,
          rowSelectType = _props.rowSelectType,
          columns = _props.columns;

      var tableClasses = (0, _classnames2.default)('table', {
        'table-striped': striped,
        'table-condensed': condensed
      });
      var selectRowHeader = null;

      if (rowSelectType === _Const2.default.ROW_SELECT_SINGLE || rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        var style = {
          width: 35,
          paddingLeft: 0,
          paddingRight: 0
        };
        selectRowHeader = _react2.default.createElement(
          'th',
          { style: style, key: -1 },
          'Filter'
        );
      }

      var filterField = columns.map(function (column) {
        var hidden = column.hidden,
            width = column.width,
            name = column.name;

        var thStyle = {
          display: hidden ? 'none' : null,
          width: width
        };
        return _react2.default.createElement(
          'th',
          { key: name, style: thStyle },
          _react2.default.createElement(
            'div',
            { className: 'th-inner table-header-column' },
            _react2.default.createElement('input', { size: '10', type: 'text',
              placeholder: name, name: name, onKeyUp: this.handleKeyUp })
          )
        );
      }, this);

      return _react2.default.createElement(
        'table',
        { className: tableClasses, style: { marginTop: 5 } },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { style: { borderBottomStyle: 'hidden' } },
            selectRowHeader,
            filterField
          )
        )
      );
    }
  }]);

  return TableFilter;
}(_react.Component);

TableFilter.propTypes = {
  columns: _propTypes2.default.array,
  rowSelectType: _propTypes2.default.string,
  onFilter: _propTypes2.default.func
};
var _default = TableFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFilter, 'TableFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');
}();

;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableDataStore = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-nested-ternary: 0 */
/* eslint guard-for-in: 0 */
/* eslint no-console: 0 */
/* eslint eqeqeq: 0 */
/* eslint one-var: 0 */


var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableDataStore = function () {
  function TableDataStore(data) {
    var _this = this;

    _classCallCheck(this, TableDataStore);

    this.isValidKey = function () {
      return _this.__isValidKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    this.data = data;
    this.filteredData = null;
    this.isOnFilter = false;
    this.filterObj = null;
    this.searchText = null;
    this.sortList = [];
    this.pageObj = {};
    this.selected = [];
    this.showOnlySelected = false;
  }

  _createClass(TableDataStore, [{
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__() {
      return this.__isValidKey__REACT_HOT_LOADER__.apply(this, arguments);
    }
  }, {
    key: 'setProps',
    value: function setProps(props) {
      this.keyField = props.keyField;
      this.enablePagination = props.isPagination;
      this.colInfos = props.colInfos;
      this.remote = props.remote;
      this.multiColumnSearch = props.multiColumnSearch;
      // default behaviour if strictSearch prop is not provided: !multiColumnSearch
      this.strictSearch = typeof props.strictSearch === 'undefined' ? !props.multiColumnSearch : props.strictSearch;
      this.multiColumnSort = props.multiColumnSort;
    }
  }, {
    key: 'clean',
    value: function clean() {
      this.filteredData = null;
      this.isOnFilter = false;
      this.filterObj = null;
      this.searchText = null;
      this.sortList = [];
      this.pageObj = {};
      this.selected = [];
    }
  }, {
    key: 'isSearching',
    value: function isSearching() {
      return this.searchText !== null;
    }
  }, {
    key: 'isFiltering',
    value: function isFiltering() {
      return this.filterObj !== null;
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.data = data;
      if (this.remote) {
        return;
      }

      this._refresh(true);
    }
  }, {
    key: 'getColInfos',
    value: function getColInfos() {
      return this.colInfos;
    }
  }, {
    key: 'getSortInfo',
    value: function getSortInfo() {
      return this.sortList;
    }
  }, {
    key: 'setSortInfo',
    value: function setSortInfo(order, sortField) {
      if ((typeof order === 'undefined' ? 'undefined' : _typeof(order)) !== (typeof sortField === 'undefined' ? 'undefined' : _typeof(sortField))) {
        throw new Error('The type of sort field and order should be both with String or Array');
      }
      if (Array.isArray(order) && Array.isArray(sortField)) {
        if (order.length !== sortField.length) {
          throw new Error('The length of sort fields and orders should be equivalent');
        }
        order = order.slice().reverse();
        this.sortList = sortField.slice().reverse().map(function (field, i) {
          return {
            order: order[i],
            sortField: field
          };
        });
        this.sortList = this.sortList.slice(0, this.multiColumnSort);
      } else {
        var sortObj = {
          order: order,
          sortField: sortField
        };

        if (this.multiColumnSort > 1) {
          var i = this.sortList.length - 1;
          var sortFieldInHistory = false;

          for (; i >= 0; i--) {
            if (this.sortList[i].sortField === sortField) {
              sortFieldInHistory = true;
              break;
            }
          }

          if (sortFieldInHistory) {
            if (i > 0) {
              this.sortList = this.sortList.slice(0, i);
            } else {
              this.sortList = this.sortList.slice(1);
            }
          }

          this.sortList.unshift(sortObj);
          this.sortList = this.sortList.slice(0, this.multiColumnSort);
        } else {
          this.sortList = [sortObj];
        }
      }
    }
  }, {
    key: 'cleanSortInfo',
    value: function cleanSortInfo() {
      this.sortList = [];
    }
  }, {
    key: 'setSelectedRowKey',
    value: function setSelectedRowKey(selectedRowKeys) {
      this.selected = selectedRowKeys;
    }
  }, {
    key: 'getRowByKey',
    value: function getRowByKey(keys) {
      var _this2 = this;

      // Bad Performance #1164
      // return keys.map(key => {
      //   const result = this.data.filter(d => d[this.keyField] === key);
      //   if (result.length !== 0) return result[0];
      // });
      var result = [];
      if (!keys || keys.length === 0) {
        return result;
      }

      var _loop = function _loop(i) {
        var d = _this2.data[i];
        if (keys.indexOf(d[_this2.keyField]) > -1) {
          keys = keys.filter(function (k) {
            return k !== d[_this2.keyField];
          });
          result.push(d);
        }
      };

      for (var i = 0; i < this.data.length; i++) {
        _loop(i);
      }
      return result;
    }
  }, {
    key: 'getSelectedRowKeys',
    value: function getSelectedRowKeys() {
      return this.selected;
    }
  }, {
    key: 'getCurrentDisplayData',
    value: function getCurrentDisplayData() {
      if (this.isOnFilter) return this.filteredData;else return this.data;
    }
  }, {
    key: '_refresh',
    value: function _refresh(skipSorting) {
      if (this.isOnFilter) {
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      if (!skipSorting && this.sortList.length > 0) {
        this.sort();
      }
    }
  }, {
    key: 'ignoreNonSelected',
    value: function ignoreNonSelected() {
      var _this3 = this;

      this.showOnlySelected = !this.showOnlySelected;
      if (this.showOnlySelected) {
        this.isOnFilter = true;
        this.filteredData = this.data.filter(function (row) {
          var result = _this3.selected.find(function (x) {
            return row[_this3.keyField] === x;
          });
          return typeof result !== 'undefined' ? true : false;
        });
      } else {
        this.isOnFilter = false;
      }
    }
  }, {
    key: 'sort',
    value: function sort() {
      var currentDisplayData = this.getCurrentDisplayData();

      currentDisplayData = this._sort(currentDisplayData);

      return this;
    }
  }, {
    key: 'page',
    value: function page(_page, sizePerPage) {
      this.pageObj.end = _page * sizePerPage - 1;
      this.pageObj.start = this.pageObj.end - (sizePerPage - 1);
      return this;
    }
  }, {
    key: 'edit',
    value: function edit(newVal, rowIndex, fieldName) {
      var currentDisplayData = this.getCurrentDisplayData();
      var rowKeyCache = void 0;
      if (!this.enablePagination) {
        currentDisplayData[rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[rowIndex][this.keyField];
      } else {
        currentDisplayData[this.pageObj.start + rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[this.pageObj.start + rowIndex][this.keyField];
      }
      if (this.isOnFilter) {
        this.data.forEach(function (row) {
          if (row[this.keyField] === rowKeyCache) {
            row[fieldName] = newVal;
          }
        }, this);
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      return this;
    }
  }, {
    key: 'addAtBegin',
    value: function addAtBegin(newObj) {
      if (!newObj[this.keyField] || newObj[this.keyField].toString() === '') {
        throw new Error(this.keyField + ' can\'t be empty value.');
      }
      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.forEach(function (row) {
        if (row[this.keyField].toString() === newObj[this.keyField].toString()) {
          throw new Error(this.keyField + ' ' + newObj[this.keyField] + ' already exists');
        }
      }, this);
      currentDisplayData.unshift(newObj);
      if (this.isOnFilter) {
        this.data.unshift(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: 'add',
    value: function add(newObj) {
      var e = this.isValidKey(newObj[this.keyField]);
      if (e) throw new Error(e);

      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.push(newObj);
      if (this.isOnFilter) {
        this.data.push(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__(key) {
      var _this4 = this;

      if (key === null || key === undefined || key.toString() === '') {
        return this.keyField + ' can\'t be empty value.';
      }
      var currentDisplayData = this.getCurrentDisplayData();
      var exist = currentDisplayData.find(function (row) {
        return row[_this4.keyField].toString() === key.toString();
      });
      if (exist) return this.keyField + ' ' + key + ' already exists';
    }
  }, {
    key: 'remove',
    value: function remove(rowKey) {
      var _this5 = this;

      var currentDisplayData = this.getCurrentDisplayData();
      var result = currentDisplayData.filter(function (row) {
        return rowKey.indexOf(row[_this5.keyField]) === -1;
      });

      if (this.isOnFilter) {
        this.data = this.data.filter(function (row) {
          return rowKey.indexOf(row[_this5.keyField]) === -1;
        });
        this.filteredData = result;
      } else {
        this.data = result;
      }
    }
  }, {
    key: 'filter',
    value: function filter(filterObj) {
      if (Object.keys(filterObj).length === 0) {
        this.filteredData = null;
        this.isOnFilter = false;
        this.filterObj = null;
        if (this.searchText) this._search(this.data);
      } else {
        var source = this.data;
        this.filterObj = filterObj;
        if (this.searchText) {
          this._search(source);
          source = this.filteredData;
        }
        this._filter(source);
      }
    }
  }, {
    key: 'filterNumber',
    value: function filterNumber(targetVal, filterVal, comparator) {
      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (targetVal != filterVal) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetVal < filterVal) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetVal > filterVal) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (targetVal == filterVal) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Number comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterDate',
    value: function filterDate(targetVal, filterVal, comparator) {
      if (!targetVal) return false;

      var filterDate = filterVal.getDate();
      var filterMonth = filterVal.getMonth();
      var filterYear = filterVal.getFullYear();

      if ((typeof targetVal === 'undefined' ? 'undefined' : _typeof(targetVal)) !== 'object') {
        targetVal = new Date(targetVal);
      }

      var targetDate = targetVal.getDate();
      var targetMonth = targetVal.getMonth();
      var targetYear = targetVal.getFullYear();

      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (filterDate !== targetDate || filterMonth !== targetMonth || filterYear !== targetYear) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetYear < filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth < filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate < filterDate) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetYear > filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth > filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate > filterDate) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (filterDate === targetDate && filterMonth === targetMonth && filterYear === targetYear) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Date comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterRegex',
    value: function filterRegex(targetVal, filterVal) {
      try {
        return new RegExp(filterVal, 'i').test(targetVal);
      } catch (e) {
        return true;
      }
    }
  }, {
    key: 'filterCustom',
    value: function filterCustom(targetVal, filterVal, callbackInfo, cond) {
      if (callbackInfo !== null && (typeof callbackInfo === 'undefined' ? 'undefined' : _typeof(callbackInfo)) === 'object') {
        return callbackInfo.callback(targetVal, callbackInfo.callbackParameters);
      }

      return this.filterText(targetVal, filterVal, cond);
    }
  }, {
    key: 'filterText',
    value: function filterText() {
      var targetVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var filterVal = arguments[1];
      var cond = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Const2.default.FILTER_COND_LIKE;

      targetVal = targetVal === null ? '' : targetVal.toString();
      filterVal = filterVal.toString();
      if (cond === _Const2.default.FILTER_COND_EQ) {
        return targetVal === filterVal;
      } else {
        targetVal = targetVal.toLowerCase();
        filterVal = filterVal.toLowerCase();
        return !(targetVal.indexOf(filterVal) === -1);
      }
    }

    /**
     * Filter if targetVal is contained in filterVal.
     */

  }, {
    key: 'filterArray',
    value: function filterArray(targetVal, filterVal) {
      // case insensitive
      return filterVal.indexOf(targetVal) > -1;
    }

    /* General search function
     * It will search for the text if the input includes that text;
     */

  }, {
    key: 'search',
    value: function search(searchText) {
      if (searchText.trim() === '') {
        this.filteredData = null;
        this.isOnFilter = false;
        this.searchText = null;
        if (this.filterObj) this._filter(this.data);
      } else {
        var source = this.data;
        this.searchText = searchText;
        if (this.filterObj) {
          this._filter(source);
          source = this.filteredData;
        }
        this._search(source);
      }
    }
  }, {
    key: '_filter',
    value: function _filter(source) {
      var _this6 = this;

      var filterObj = this.filterObj;
      this.filteredData = source.filter(function (row, r) {
        var valid = true;
        var filterVal = void 0;
        for (var key in filterObj) {
          var targetVal = row[key];
          if (targetVal === null || targetVal === undefined) {
            targetVal = '';
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                filterVal = filterObj[key].value.number;
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                filterVal = _typeof(filterObj[key].value) === 'object' ? undefined : typeof filterObj[key].value === 'string' ? filterObj[key].value.toLowerCase() : filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                filterVal = filterObj[key].value.date;
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                filterVal = filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.ARRAY:
              {
                filterVal = filterObj[key].value;
                if (!Array.isArray(filterVal)) {
                  throw new Error('Value must be an Array');
                }
                break;
              }
            default:
              {
                filterVal = filterObj[key].value;
                if (filterVal === undefined) {
                  // Support old filter
                  filterVal = filterObj[key];
                }
                break;
              }
          }
          var format = void 0,
              filterFormatted = void 0,
              formatExtraData = void 0,
              filterValue = void 0;
          if (_this6.colInfos[key]) {
            format = _this6.colInfos[key].format;
            filterFormatted = _this6.colInfos[key].filterFormatted;
            formatExtraData = _this6.colInfos[key].formatExtraData;
            filterValue = _this6.colInfos[key].filterValue;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            }
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                valid = _this6.filterNumber(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                valid = _this6.filterDate(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                valid = _this6.filterRegex(targetVal, filterVal);
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                var cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterCustom(targetVal, filterVal, filterObj[key].value, cond);
                break;
              }
            case _Const2.default.FILTER_TYPE.ARRAY:
              {
                valid = _this6.filterArray(targetVal, filterVal);
                break;
              }
            default:
              {
                if (filterObj[key].type === _Const2.default.FILTER_TYPE.SELECT && filterFormatted && filterFormatted && format) {
                  filterVal = format(filterVal, row, formatExtraData, r);
                }
                var _cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterText(targetVal, filterVal, _cond);
                break;
              }
          }
          if (!valid) {
            break;
          }
        }
        return valid;
      });
      this.isOnFilter = true;
    }

    /*
     * Four different sort modes, all case insensitive:
     * (1) strictSearch && !multiColumnSearch
     *     search text must be contained as provided in a single column
     * (2) strictSearch && multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms over multiple columns
     * (3) !strictSearch && !multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms in a single column
     * (4) !strictSearch && multiColumnSearch
     *     any of the whitespace separated terms must be contained in any column
     */

  }, {
    key: '_search',
    value: function _search(source) {
      var _this7 = this;

      var searchTextArray = void 0;
      if (this.multiColumnSearch || !this.strictSearch) {
        // ignore leading and trailing whitespaces
        searchTextArray = this.searchText.trim().toLowerCase().split(/\s+/);
      } else {
        searchTextArray = [this.searchText.toLowerCase()];
      }
      var searchTermCount = searchTextArray.length;
      var multipleTerms = searchTermCount > 1;
      var nonStrictMultiCol = multipleTerms && !this.strictSearch && this.multiColumnSearch;
      var nonStrictSingleCol = multipleTerms && !this.strictSearch && !this.multiColumnSearch;
      this.filteredData = source.filter(function (row, r) {
        var keys = Object.keys(row);
        // only clone array if necessary
        var searchTerms = multipleTerms ? searchTextArray.slice() : searchTextArray;
        // for loops are ugly, but performance matters here.
        // And you cant break from a forEach.
        // http://jsperf.com/for-vs-foreach/66
        for (var i = 0, keysLength = keys.length; i < keysLength; i++) {
          var key = keys[i];
          var colInfo = _this7.colInfos[key];
          if (colInfo && colInfo.searchable) {
            var format = colInfo.format,
                filterFormatted = colInfo.filterFormatted,
                filterValue = colInfo.filterValue,
                formatExtraData = colInfo.formatExtraData;

            var targetVal = void 0;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            } else {
              targetVal = row[key];
            }
            if (targetVal !== null && typeof targetVal !== 'undefined') {
              targetVal = targetVal.toString().toLowerCase();
              if (nonStrictSingleCol && searchTermCount > searchTerms.length) {
                // reset search terms for single column search
                searchTerms = searchTextArray.slice();
              }
              for (var j = searchTerms.length - 1; j > -1; j--) {
                if (targetVal.indexOf(searchTerms[j]) !== -1) {
                  if (nonStrictMultiCol || searchTerms.length === 1) {
                    // match found: the last or only one
                    return true;
                  }
                  // match found: but there are more search terms to check for
                  searchTerms.splice(j, 1);
                } else if (!_this7.multiColumnSearch) {
                  // one of the search terms was not found in this column
                  break;
                }
              }
            }
          }
        }
        return false;
      });
      this.isOnFilter = true;
    }
  }, {
    key: '_sort',
    value: function _sort(arr) {
      var _this8 = this;

      if (this.sortList.length === 0 || typeof this.sortList[0] === 'undefined') {
        return arr;
      }

      arr.sort(function (a, b) {
        var result = 0;

        for (var i = 0; i < _this8.sortList.length; i++) {
          var sortDetails = _this8.sortList[i];
          var isDesc = sortDetails.order.toLowerCase() === _Const2.default.SORT_DESC;

          var _colInfos$sortDetails = _this8.colInfos[sortDetails.sortField],
              sortFunc = _colInfos$sortDetails.sortFunc,
              sortFuncExtraData = _colInfos$sortDetails.sortFuncExtraData;


          if (sortFunc) {
            result = sortFunc(a, b, sortDetails.order, sortDetails.sortField, sortFuncExtraData);
          } else {
            var valueA = a[sortDetails.sortField] == null ? '' : a[sortDetails.sortField];
            var valueB = b[sortDetails.sortField] == null ? '' : b[sortDetails.sortField];

            if (isDesc) {
              if (typeof valueB === 'string') {
                result = valueB.localeCompare(valueA);
              } else {
                result = valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
              }
            } else {
              if (typeof valueA === 'string') {
                result = valueA.localeCompare(valueB);
              } else {
                result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              }
            }
          }

          if (result !== 0) {
            return result;
          }
        }

        return result;
      });

      return arr;
    }
  }, {
    key: 'getDataIgnoringPagination',
    value: function getDataIgnoringPagination() {
      return this.getCurrentDisplayData();
    }
  }, {
    key: 'get',
    value: function get() {
      var _data = this.getCurrentDisplayData();

      if (_data.length === 0) return _data;

      var remote = typeof this.remote === 'function' ? this.remote(_Const2.default.REMOTE)[_Const2.default.REMOTE_PAGE] : this.remote;

      if (remote || !this.enablePagination) {
        return _data;
      } else {
        var result = [];
        for (var i = this.pageObj.start; i <= this.pageObj.end; i++) {
          result.push(_data[i]);
          if (i + 1 === _data.length) break;
        }
        return result;
      }
    }
  }, {
    key: 'getKeyField',
    value: function getKeyField() {
      return this.keyField;
    }
  }, {
    key: 'getDataNum',
    value: function getDataNum() {
      return this.getCurrentDisplayData().length;
    }
  }, {
    key: 'isChangedPage',
    value: function isChangedPage() {
      return this.pageObj.start && this.pageObj.end ? true : false;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.data.length === 0 || this.data === null || this.data === undefined;
    }
  }, {
    key: 'getAllRowkey',
    value: function getAllRowkey() {
      var _this9 = this;

      return this.data.map(function (row) {
        return row[_this9.keyField];
      });
    }
  }]);

  return TableDataStore;
}();

exports.TableDataStore = TableDataStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableDataStore, 'TableDataStore', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/store/TableDataStore.js');
}();

;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(22);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint block-scoped-var: 0 */
/* eslint vars-on-top: 0 */
/* eslint no-var: 0 */
/* eslint no-unused-vars: 0 */
if (_util2.default.canUseDOM()) {
  var filesaver = __webpack_require__(474);
  var saveAs = filesaver.saveAs;
}

function toString(data, keys, separator, excludeCSVHeader) {
  var dataString = '';
  if (data.length === 0) return dataString;

  var headCells = [];
  var rowCount = 0;
  keys.forEach(function (key) {
    if (key.row > rowCount) {
      rowCount = key.row;
    }
    // rowCount += (key.rowSpan + key.colSpan - 1);
    for (var index = 0; index < key.colSpan; index++) {
      headCells.push(key);
    }
  });

  var firstRow = excludeCSVHeader ? 1 : 0;

  var _loop = function _loop(i) {
    dataString += headCells.map(function (x) {
      if (x.row + (x.rowSpan - 1) === i) {
        return '"' + x.header + '"';
      }
      if (x.row === i && x.rowSpan > 1) {
        return '';
      }
    }).filter(function (key) {
      return typeof key !== 'undefined';
    }).join(separator) + '\n';
  };

  for (var i = firstRow; i <= rowCount; i++) {
    _loop(i);
  }

  keys = keys.filter(function (key) {
    return key.field !== undefined;
  });

  data.map(function (row) {
    keys.map(function (col, i) {
      var field = col.field,
          format = col.format,
          extraData = col.extraData,
          type = col.type;

      var value = typeof format !== 'undefined' ? format(row[field], row, extraData) : row[field];
      value = type === _Const2.default.CSV_NUMBER_TYPE ? Number(value) : '"' + value + '"';
      var cell = typeof value !== 'undefined' ? value : '';
      dataString += cell;
      if (i + 1 < keys.length) dataString += separator;
    });

    dataString += '\n';
  });

  return dataString;
}

var exportCSV = function exportCSV(data, keys, filename, separator, noAutoBOM, excludeCSVHeader) {
  var dataString = toString(data, keys, separator, excludeCSVHeader);
  if (typeof window !== 'undefined') {
    noAutoBOM = noAutoBOM === undefined ? true : noAutoBOM;
    saveAs(new Blob(['\uFEFF', dataString], { type: 'text/plain;charset=utf-8' }), filename, noAutoBOM);
  }
};

var _default = exportCSV;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saveAs, 'saveAs', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(toString, 'toString', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(exportCSV, 'exportCSV', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
}();

;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || function (view) {
	"use strict";
	// IE <10 is explicitly unsupported

	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var doc = view.document
	// only get URL when necessary in case Blob.js hasn't overridden it yet
	,
	    get_URL = function get_URL() {
		return view.URL || view.webkitURL || view;
	},
	    save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"),
	    can_use_save_link = "download" in save_link,
	    click = function click(node) {
		var event = new MouseEvent("click");
		node.dispatchEvent(event);
	},
	    is_safari = /constructor/i.test(view.HTMLElement) || view.safari,
	    is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent),
	    throw_outside = function throw_outside(ex) {
		(view.setImmediate || view.setTimeout)(function () {
			throw ex;
		}, 0);
	},
	    force_saveable_type = "application/octet-stream"
	// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
	,
	    arbitrary_revoke_timeout = 1000 * 40 // in ms
	,
	    revoke = function revoke(file) {
		var revoker = function revoker() {
			if (typeof file === "string") {
				// file is an object URL
				get_URL().revokeObjectURL(file);
			} else {
				// file is a File
				file.remove();
			}
		};
		setTimeout(revoker, arbitrary_revoke_timeout);
	},
	    dispatch = function dispatch(filesaver, event_types, event) {
		event_types = [].concat(event_types);
		var i = event_types.length;
		while (i--) {
			var listener = filesaver["on" + event_types[i]];
			if (typeof listener === "function") {
				try {
					listener.call(filesaver, event || filesaver);
				} catch (ex) {
					throw_outside(ex);
				}
			}
		}
	},
	    auto_bom = function auto_bom(blob) {
		// prepend BOM for UTF-8 XML and text/* types (including HTML)
		// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
		if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
			return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
		}
		return blob;
	},
	    FileSaver = function FileSaver(blob, name, no_auto_bom) {
		if (!no_auto_bom) {
			blob = auto_bom(blob);
		}
		// First try a.download, then web filesystem, then object URLs
		var filesaver = this,
		    type = blob.type,
		    force = type === force_saveable_type,
		    object_url,
		    dispatch_all = function dispatch_all() {
			dispatch(filesaver, "writestart progress write writeend".split(" "));
		}
		// on any filesys errors revert to saving with object URLs
		,
		    fs_error = function fs_error() {
			if ((is_chrome_ios || force && is_safari) && view.FileReader) {
				// Safari doesn't allow downloading of blob urls
				var reader = new FileReader();
				reader.onloadend = function () {
					var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
					var popup = view.open(url, '_blank');
					if (!popup) view.location.href = url;
					url = undefined; // release reference before dispatching
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
				};
				reader.readAsDataURL(blob);
				filesaver.readyState = filesaver.INIT;
				return;
			}
			// don't create more object URLs than needed
			if (!object_url) {
				object_url = get_URL().createObjectURL(blob);
			}
			if (force) {
				view.location.href = object_url;
			} else {
				var opened = view.open(object_url, "_blank");
				if (!opened) {
					// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
					view.location.href = object_url;
				}
			}
			filesaver.readyState = filesaver.DONE;
			dispatch_all();
			revoke(object_url);
		};
		filesaver.readyState = filesaver.INIT;

		if (can_use_save_link) {
			object_url = get_URL().createObjectURL(blob);
			setTimeout(function () {
				save_link.href = object_url;
				save_link.download = name;
				click(save_link);
				dispatch_all();
				revoke(object_url);
				filesaver.readyState = filesaver.DONE;
			});
			return;
		}

		fs_error();
	},
	    FS_proto = FileSaver.prototype,
	    saveAs = function saveAs(blob, name, no_auto_bom) {
		return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
	};
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function (blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function () {};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;

	return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
	module.exports.saveAs = saveAs;
} else if ("function" !== "undefined" && __webpack_require__(475) !== null && __webpack_require__(476) !== null) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
		return saveAs;
	}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(saveAs, "saveAs", "/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filesaver.js");
}();

;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 476 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Const = __webpack_require__(12);

var _Const2 = _interopRequireDefault(_Const);

var _events = __webpack_require__(478);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = exports.Filter = function (_EventEmitter) {
  _inherits(Filter, _EventEmitter);

  function Filter(data) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, data));

    _this.currentFilter = {};
    return _this;
  }

  _createClass(Filter, [{
    key: 'handleFilter',
    value: function handleFilter(dataField, value, type, filterObj) {
      var filterType = type || _Const2.default.FILTER_TYPE.CUSTOM;

      var props = {
        cond: filterObj.condition // Only for select and text filter
      };

      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        // value of the filter is an object
        var hasValue = true;
        for (var prop in value) {
          if (!value[prop] || value[prop] === '') {
            hasValue = false;
            break;
          }
        }
        // if one of the object properties is undefined or empty, we remove the filter
        if (hasValue) {
          this.currentFilter[dataField] = { value: value, type: filterType, props: props };
        } else {
          delete this.currentFilter[dataField];
        }
      } else if (!value || value.trim() === '') {
        delete this.currentFilter[dataField];
      } else {
        this.currentFilter[dataField] = { value: value.trim(), type: filterType, props: props };
      }
      this.emit('onFilterChange', this.currentFilter);
    }
  }]);

  return Filter;
}(_events.EventEmitter);

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Filter, 'Filter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Filter.js');
}();

;

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          sizeClass = _props.sizeClass,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['className', 'sizeClass', 'children']);

      return _react2.default.createElement(
        'div',
        _extends({ className: 'btn-group ' + sizeClass + ' ' + className, role: 'group' }, rest),
        children
      );
    }
  }]);

  return ButtonGroup;
}(_react.Component);

ButtonGroup.propTypes = {
  sizeClass: _propTypes2.default.string,
  className: _propTypes2.default.string
};
ButtonGroup.defaultProps = {
  sizeClass: 'btn-group-sm',
  className: ''
};

var _default = ButtonGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ButtonGroup, 'ButtonGroup', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');
}();

;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],e):"object"==typeof exports?exports.ReactCountdownClock=e(require("react")):t.ReactCountdownClock=e(t.React)}(window,function(t){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/Users/hugh/repos/react-countdown-clock/build",n(n.s=1)}([function(e,n){e.exports=t},function(t,e,n){"use strict";var i,r,o;r=n(0),i=n(2),(o=n(5)({_seconds:0,_radius:null,_fraction:null,_content:null,_canvas:null,_timeoutIds:[],_scale:window.devicePixelRatio||1,displayName:"ReactCountdownClock",componentDidUpdate:function(t){if(t.seconds!==this.props.seconds&&(this._seconds=this._startSeconds(),this._stopTimer(),this._setupTimer()),t.color!==this.props.color&&(this._drawBackground(),this._updateCanvas()),t.paused!==this.props.paused&&(this.props.paused||this._startTimer(),this.props.paused))return this._pauseTimer()},componentDidMount:function(){return this._seconds=this._startSeconds(),this._setupTimer()},componentWillUnmount:function(){return this._cancelTimer()},_startSeconds:function(){return this.props.paused?this.props.seconds:this.props.seconds-.01},_setupTimer:function(){if(this._setScale(),this._setupCanvases(),this._drawBackground(),this._drawTimer(),!this.props.paused)return this._startTimer()},_updateCanvas:function(){return this._clearTimer(),this._drawTimer()},_setScale:function(){return this._radius=this.props.size/2,this._fraction=2/this._seconds,this._tickPeriod=this._calculateTick(),this._innerRadius=this.props.weight?this._radius-this.props.weight:this._radius/1.8},_calculateTick:function(){var t;return 1.8,(t=1.8*this._seconds)>1e3?1e3:t},_setupCanvases:function(){if(!this._background||!this._timer)return this._background=this.refs.background.getContext("2d"),this._background.scale(this._scale,this._scale),this._timer=this.refs.timer.getContext("2d"),this._timer.textAlign="center",this._timer.textBaseline="middle",this._timer.scale(this._scale,this._scale),null!=this.props.onClick?this.refs.component.addEventListener("click",this.props.onClick):void 0},_startTimer:function(){var t=this;return this._timeoutIds.push(setTimeout(function(){return t._tick()}),200)},_pauseTimer:function(){return this._stopTimer(),this._updateCanvas()},_stopTimer:function(){var t,e,n,i,r;for(i=[],t=0,e=(n=this._timeoutIds).length;t<e;t++)r=n[t],i.push(clearTimeout(r));return i},_cancelTimer:function(){if(this._stopTimer(),null!=this.props.onClick)return this.refs.component.removeEventListener("click",this.props.onClick)},_tick:function(){var t,e=this;return t=Date.now(),this._timeoutIds.push(setTimeout(function(){var n;return n=(Date.now()-t)/1e3,e._seconds-=n,e._seconds<=0?(e._seconds=0,e._handleComplete(),e._clearTimer()):(e._updateCanvas(),e._tick())},this._tickPeriod))},_handleComplete:function(){if(this.props.onComplete)return this.props.onComplete()},_clearBackground:function(){return this._background.clearRect(0,0,this.refs.timer.width,this.refs.timer.height)},_clearTimer:function(){if(null!=this.refs.timer)return this._timer.clearRect(0,0,this.refs.timer.width,this.refs.timer.height)},_drawBackground:function(){return this._clearBackground(),this._background.beginPath(),this._background.globalAlpha=this.props.alpha/3,this._background.fillStyle=this.props.color,this._background.arc(this._radius,this._radius,this._radius,0,2*Math.PI,!1),this._background.arc(this._radius,this._radius,this._innerRadius,2*Math.PI,0,!0),this._background.closePath(),this._background.fill()},_formattedTime:function(){var t,e,n,i,r,o,s,a,c;return t=null!=(o=this._seconds<10&&this.props.showMilliseconds)?o:{1:0},"hms"===this.props.timeFormat?(n=""+(e=parseInt(this._seconds/3600)%24),r=""+(i=parseInt(this._seconds/60)%60),a=""+(s=t?(Math.floor(10*this._seconds)/10).toFixed(t):Math.floor(this._seconds%60)),e<10&&(n="0"+e),i<10&&e>=1&&(r="0"+i),s<10&&(i>=1||e>=1)&&(a="0"+s),c=[],e>0&&c.push(n),(i>0||e>0)&&c.push(r),c.push(a),c.join(":")):(Math.floor(10*this._seconds)/10).toFixed(t)},_fontSize:function(t){var e;return"auto"===this.props.fontSize?(e=function(){switch(t.length){case 8:return 4;case 5:return 3;default:return 2}}(),this._radius/e+"px"):this.props.fontSize},_drawTimer:function(){var t,e,n;return e=this._fraction*this._seconds+1.5,t=this._formattedTime(),n=this.props.paused&&null!=this.props.pausedText?this.props.pausedText:t,this._timer.globalAlpha=this.props.alpha,this._timer.fillStyle=this.props.color,this._timer.font="bold "+this._fontSize(t)+" "+this.props.font,this._timer.fillText(n,this._radius,this._radius),this._timer.beginPath(),this._timer.arc(this._radius,this._radius,this._radius,1.5*Math.PI,Math.PI*e,!1),this._timer.arc(this._radius,this._radius,this._innerRadius,Math.PI*e,1.5*Math.PI,!0),this._timer.closePath(),this._timer.fill()},render:function(){var t;return t={style:{position:"absolute",width:this.props.size,height:this.props.size},height:this.props.size*this._scale,width:this.props.size*this._scale},r.createElement("div",{ref:"component",className:"react-countdown-clock",style:{width:this.props.size,height:this.props.size}},r.createElement("canvas",Object.assign({ref:"background"},t)),r.createElement("canvas",Object.assign({ref:"timer"},t)))}})).propTypes={seconds:i.number,size:i.number,weight:i.number,color:i.string,fontSize:i.string,font:i.string,alpha:i.number,timeFormat:i.string,onComplete:i.func,onClick:i.func,showMilliseconds:i.bool,paused:i.bool,pausedText:i.string},o.defaultProps={seconds:60,size:300,color:"#000",alpha:1,timeFormat:"hms",fontSize:"auto",font:"Arial",showMilliseconds:!0,paused:!1},t.exports=o},function(t,e,n){t.exports=n(3)()},function(t,e,n){"use strict";var i=n(4);function r(){}t.exports=function(){function t(t,e,n,r,o,s){if(s!==i){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e};return n.checkPropTypes=r,n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){"use strict";var i=n(0),r=n(6);if(void 0===i)throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");var o=(new i.Component).updater;t.exports=r(i.Component,i.isValidElement,o)},function(t,e,n){"use strict";var i=n(7),r=n(8),o=n(9),s="mixins";t.exports=function(t,e,n){var a=[],c={mixins:"DEFINE_MANY",statics:"DEFINE_MANY",propTypes:"DEFINE_MANY",contextTypes:"DEFINE_MANY",childContextTypes:"DEFINE_MANY",getDefaultProps:"DEFINE_MANY_MERGED",getInitialState:"DEFINE_MANY_MERGED",getChildContext:"DEFINE_MANY_MERGED",render:"DEFINE_ONCE",componentWillMount:"DEFINE_MANY",componentDidMount:"DEFINE_MANY",componentWillReceiveProps:"DEFINE_MANY",shouldComponentUpdate:"DEFINE_ONCE",componentWillUpdate:"DEFINE_MANY",componentDidUpdate:"DEFINE_MANY",componentWillUnmount:"DEFINE_MANY",UNSAFE_componentWillMount:"DEFINE_MANY",UNSAFE_componentWillReceiveProps:"DEFINE_MANY",UNSAFE_componentWillUpdate:"DEFINE_MANY",updateComponent:"OVERRIDE_BASE"},u={getDerivedStateFromProps:"DEFINE_MANY_MERGED"},p={displayName:function(t,e){t.displayName=e},mixins:function(t,e){if(e)for(var n=0;n<e.length;n++)h(t,e[n])},childContextTypes:function(t,e){t.childContextTypes=i({},t.childContextTypes,e)},contextTypes:function(t,e){t.contextTypes=i({},t.contextTypes,e)},getDefaultProps:function(t,e){t.getDefaultProps?t.getDefaultProps=d(t.getDefaultProps,e):t.getDefaultProps=e},propTypes:function(t,e){t.propTypes=i({},t.propTypes,e)},statics:function(t,e){!function(t,e){if(e)for(var n in e){var i=e[n];if(e.hasOwnProperty(n)){var r=n in p;o(!r,'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',n);var s=n in t;if(s){var a=u.hasOwnProperty(n)?u[n]:null;return o("DEFINE_MANY_MERGED"===a,"ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",n),void(t[n]=d(t[n],i))}t[n]=i}}}(t,e)},autobind:function(){}};function l(t,e){var n=c.hasOwnProperty(e)?c[e]:null;E.hasOwnProperty(e)&&o("OVERRIDE_BASE"===n,"ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",e),t&&o("DEFINE_MANY"===n||"DEFINE_MANY_MERGED"===n,"ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",e)}function h(t,n){if(n){o("function"!=typeof n,"ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."),o(!e(n),"ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");var i=t.prototype,r=i.__reactAutoBindPairs;for(var a in n.hasOwnProperty(s)&&p.mixins(t,n.mixins),n)if(n.hasOwnProperty(a)&&a!==s){var u=n[a],h=i.hasOwnProperty(a);if(l(h,a),p.hasOwnProperty(a))p[a](t,u);else{var f=c.hasOwnProperty(a);if("function"!=typeof u||f||h||!1===n.autobind)if(h){var m=c[a];o(f&&("DEFINE_MANY_MERGED"===m||"DEFINE_MANY"===m),"ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",m,a),"DEFINE_MANY_MERGED"===m?i[a]=d(i[a],u):"DEFINE_MANY"===m&&(i[a]=_(i[a],u))}else i[a]=u;else r.push(a,u),i[a]=u}}}}function f(t,e){for(var n in o(t&&e&&"object"==typeof t&&"object"==typeof e,"mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."),e)e.hasOwnProperty(n)&&(o(void 0===t[n],"mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",n),t[n]=e[n]);return t}function d(t,e){return function(){var n=t.apply(this,arguments),i=e.apply(this,arguments);if(null==n)return i;if(null==i)return n;var r={};return f(r,n),f(r,i),r}}function _(t,e){return function(){t.apply(this,arguments),e.apply(this,arguments)}}function m(t,e){return e.bind(t)}var y={componentDidMount:function(){this.__isMounted=!0}},g={componentWillUnmount:function(){this.__isMounted=!1}},E={replaceState:function(t,e){this.updater.enqueueReplaceState(this,t,e)},isMounted:function(){return!!this.__isMounted}},b=function(){};return i(b.prototype,t.prototype,E),function(t){var e=function(t){return t}(function(t,i,s){this.__reactAutoBindPairs.length&&function(t){for(var e=t.__reactAutoBindPairs,n=0;n<e.length;n+=2){var i=e[n],r=e[n+1];t[i]=m(t,r)}}(this),this.props=t,this.context=i,this.refs=r,this.updater=s||n,this.state=null;var a=this.getInitialState?this.getInitialState():null;o("object"==typeof a&&!Array.isArray(a),"%s.getInitialState(): must return an object or null",e.displayName||"ReactCompositeComponent"),this.state=a});for(var i in e.prototype=new b,e.prototype.constructor=e,e.prototype.__reactAutoBindPairs=[],a.forEach(h.bind(null,e)),h(e,y),h(e,t),h(e,g),e.getDefaultProps&&(e.defaultProps=e.getDefaultProps()),o(e.prototype.render,"createClass(...): Class specification must implement a `render` method."),c)e.prototype[i]||(e.prototype[i]=null);return e}}},function(t,e,n){"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/var i=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;t.exports=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var i={};return"abcdefghijklmnopqrst".split("").forEach(function(t){i[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},i)).join("")}catch(t){return!1}}()?Object.assign:function(t,e){for(var n,s,a=function(t){if(null===t||void 0===t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}(t),c=1;c<arguments.length;c++){for(var u in n=Object(arguments[c]))r.call(n,u)&&(a[u]=n[u]);if(i){s=i(n);for(var p=0;p<s.length;p++)o.call(n,s[p])&&(a[s[p]]=n[s[p]])}}return a}},function(t,e,n){"use strict";t.exports={}},function(t,e,n){"use strict";var i=function(t){};t.exports=function(t,e,n,r,o,s,a,c){if(i(e),!t){var u;if(void 0===e)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var p=[n,r,o,s,a,c],l=0;(u=new Error(e.replace(/%s/g,function(){return p[l++]}))).name="Invariant Violation"}throw u.framesToPop=1,u}}}])});
//# sourceMappingURL=react-countdown-clock.js.map

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(130);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(145);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CKEditor = function (_Component) {
  (0, _inherits3["default"])(CKEditor, _Component);

  function CKEditor(props) {
    (0, _classCallCheck3["default"])(this, CKEditor);

    var _this = (0, _possibleConstructorReturn3["default"])(this, _Component.call(this, props));

    _this.changeListener = _this.changeListener.bind(_this);

    _this.state = {
      value: props.value,
      config: props.config || {},
      onChange: props.onChange
    };
    return _this;
  }

  CKEditor.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!window.CKEDITOR) {
      console.error("CKEditor not found");
      return;
    }

    this.instance = window.CKEDITOR.appendTo(this.divRef, this.state.config, this.state.value);

    this.instance.on('instanceReady', function (e) {
      //Set content and read only flag again. Can have changed since init.
      e.editor.setData(_this2.state.value);
      if ("readOnly" in _this2.state.config) _this2.instance.setReadOnly(_this2.state.config.readOnly);
    });
    this.instance.on('change', this.changeListener);
  };

  CKEditor.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (!this.instance) {
      return;
    }

    //Only manipulate the editor when it's ready. The data will be set when it's
    //ready otherwise.
    if (this.instance.status === "ready") {

      if (this.state.value !== props.value) {
        // setData will move the cursor to the begining of the input
        this.instance.setData(props.value);
      }

      if (props.config && this.state.config !== props.config) {
        if ("readOnly" in props.config) this.instance.setReadOnly(props.config.readOnly);
      }
    }

    this.setState({
      value: props.value,
      config: props.config || {},
      onChange: props.onChange
    });
  };

  CKEditor.prototype.componentWillUnmount = function componentWillUnmount() {
    this.instance.removeListener("change", this.changeListener);
    this.instance.destroy();
  };

  CKEditor.prototype.changeListener = function changeListener() {
    this.state.value = this.instance.getData();
    this.handleChange();
  };

  CKEditor.prototype.handleChange = function handleChange() {
    this.state.onChange(this.state.value);
  };

  CKEditor.prototype.render = function render() {
    var _this3 = this;

    return _react2["default"].createElement("div", { ref: function ref(input) {
        return _this3.divRef = input;
      } });
  };

  return CKEditor;
}(_react.Component);

exports["default"] = CKEditor;
module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(483), __esModule: true };

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(484);
__webpack_require__(494);
module.exports = __webpack_require__(142).f('iterator');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(485)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(243)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(133);
var defined = __webpack_require__(134);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(137);
var descriptor = __webpack_require__(86);
var setToStringTag = __webpack_require__(141);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(53)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(41);
var anObject = __webpack_require__(66);
var getKeys = __webpack_require__(87);

module.exports = __webpack_require__(42) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(55);
var toLength = __webpack_require__(490);
var toAbsoluteIndex = __webpack_require__(491);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(133);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(133);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(36).document;
module.exports = document && document.documentElement;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(43);
var toObject = __webpack_require__(251);
var IE_PROTO = __webpack_require__(138)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(495);
var global = __webpack_require__(36);
var hide = __webpack_require__(53);
var Iterators = __webpack_require__(136);
var TO_STRING_TAG = __webpack_require__(56)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(496);
var step = __webpack_require__(497);
var Iterators = __webpack_require__(136);
var toIObject = __webpack_require__(55);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(243)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(499), __esModule: true };

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(500);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
module.exports = __webpack_require__(37).Symbol;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(36);
var has = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(42);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(247);
var META = __webpack_require__(501).KEY;
var $fails = __webpack_require__(67);
var shared = __webpack_require__(139);
var setToStringTag = __webpack_require__(141);
var uid = __webpack_require__(88);
var wks = __webpack_require__(56);
var wksExt = __webpack_require__(142);
var wksDefine = __webpack_require__(143);
var enumKeys = __webpack_require__(502);
var isArray = __webpack_require__(503);
var anObject = __webpack_require__(66);
var isObject = __webpack_require__(54);
var toIObject = __webpack_require__(55);
var toPrimitive = __webpack_require__(135);
var createDesc = __webpack_require__(86);
var _create = __webpack_require__(137);
var gOPNExt = __webpack_require__(504);
var $GOPD = __webpack_require__(253);
var $DP = __webpack_require__(41);
var $keys = __webpack_require__(87);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(252).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(89).f = $propertyIsEnumerable;
  __webpack_require__(144).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(85)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(53)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(88)('meta');
var isObject = __webpack_require__(54);
var has = __webpack_require__(43);
var setDesc = __webpack_require__(41).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(67)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(87);
var gOPS = __webpack_require__(144);
var pIE = __webpack_require__(89);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(250);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(55);
var gOPN = __webpack_require__(252).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 505 */
/***/ (function(module, exports) {



/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143)('asyncIterator');


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143)('observable');


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(509), __esModule: true };

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(510);
module.exports = __webpack_require__(37).Object.setPrototypeOf;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(52);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(511).set });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(54);
var anObject = __webpack_require__(66);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(244)(Function.call, __webpack_require__(253).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(513), __esModule: true };

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(514);
var $Object = __webpack_require__(37).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(137) });


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_learningRoomAction__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Videocomponent=function(_Component){_inherits(Videocomponent,_Component);function Videocomponent(props){_classCallCheck(this,Videocomponent);var _this=_possibleConstructorReturn(this,(Videocomponent.__proto__||Object.getPrototypeOf(Videocomponent)).call(this,props));_this.compeletestatus="";_this.state={vediocnt:[],isAdimage:null,images:[],playersem:null};return _this;}_createClass(Videocomponent,[{key:'getVideocomponents',value:function getVideocomponents(data){var _this2=this;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'videocomponent/getvideocomponent',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */]()})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({playersem:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{playlist:responseJson.videotracks,trackData:trackData,vcdata:data}),vediocnt:responseJson.data,isAdimage:responseJson.isAdimage});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//$("html,body").animate({scrollTop : $(".videoscroll").position().top + ($(".videoscroll").outerHeight(true)/2)},300);
if($(".videoscroll").length>0){$("html,body").animate({scrollTop:$(".videoscroll").position().top},300);}},200);});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var data=this.props.data;this.compeletestatus=data.status;this.getVideocomponents(data);var imageArr=[];imageArr[0]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/Bennett.jpg';imageArr[1]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/IFIM.jpg';imageArr[2]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/Manav.jpg';imageArr[3]=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/RMS.jpg';this.setState({images:imageArr});setTimeout(function(){_this3.changeImage(1);},10000);}},{key:'changeImage',value:function changeImage(x){var _this4=this;if(this.state.isAdimage==='1'){$('.videoadd').show();var img=document.getElementById("img");if(img!==null){img.src=this.state.images[x];x++;}if(x>=this.state.images.length){x=0;}setTimeout(function(){_this4.changeImage(x);},5000);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;this.getVideocomponents(data);}},{key:'adimaes',value:function adimaes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'videoadd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'img',src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/361_includes/images/Ads/IFIM.jpg',alt:''}));}},{key:'onsubmit',value:function onsubmit(){var _this5=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'videocomponent/saveall',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),dlr_id:data.dlr_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");_this5.props.getLearningRoom();if(responseJson.isCompletedFully){_this5.goToThanksPage();}else{_this5.props.switchback(responseJson.type,responseJson.lr_id,responseJson.dlr_id);}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["d" /* composcroll */]();});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true};this.props.returnthanks(sdd);}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'submitbuttons',value:function submitbuttons(){var _this6=this;if(this.compeletestatus==='completed'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'cancel',id:'cancel',value:'Continue',className:'button_org_inactive',alt:'Continue',title:'Continue',type:'button',onClick:function onClick(e){return _this6.backToComponentList();}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'cancel',id:'cancel',value:'Will watch later',className:'button-cancel',alt:'Will watch later',title:'Will watch later',type:'button',onClick:function onClick(e){return _this6.backToComponentList();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'pqqroceed',id:'pqqroceed',value:'Next',className:'button-accept',alt:'Next',title:'Next',type:'submit',onClick:function onClick(e){return _this6.onsubmit();}}));}}},{key:'render',value:function render(){var vdata=this.state.vediocnt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:vdata.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'vc_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,vdata.videocomponent_name?vdata.videocomponent_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,vdata.base_line?vdata.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box videogray videoscroll'},this.state.playersem,this.state.isAdimage==='1'?this.adimaes():'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txtLP rgbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},this.submitbuttons())))))))));}}]);return Videocomponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_7__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Videocomponent));

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_learningRoomAction__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Recordedvideo=function(_Component){_inherits(Recordedvideo,_Component);function Recordedvideo(props){_classCallCheck(this,Recordedvideo);var _this=_possibleConstructorReturn(this,(Recordedvideo.__proto__||Object.getPrototypeOf(Recordedvideo)).call(this,props));_this.compeletestatus="";_this.state={vediocnt:[],playersem:null};return _this;}_createClass(Recordedvideo,[{key:'getRecordedvideos',value:function getRecordedvideos(data){var _this2=this;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'recordedvideo/getvideocomponent',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({data:data,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */]()})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({playersem:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Flowplayer__["a" /* default */],{playlist:responseJson.videotracks,trackData:trackData}),vediocnt:responseJson.data,errmsg:responseJson.errmsg});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["B" /* showSmallLeftMenu */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["e" /* contentResizeLoad */]();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//$("html,body").animate({scrollTop : $(".videoscroll").position().top + ($(".videoscroll").outerHeight(true)/2)},300);
if($(".videoscroll").length>0)$("html,body").animate({scrollTop:$(".videoscroll").position().top},300);},200);});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getRecordedvideos(data);$(".various").fancybox({closeBtn:true,maxWidth:900,maxHeight:600,fitToView:true,width:'90%',height:'90%',autoSize:true,closeClick:true,openEffect:'none',closeEffect:'none'});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this3=this;var data=nextProps.data;this.compeletestatus=data.status;setTimeout(function(){_this3.getRecordedvideos(data);},300);}},{key:'loading',value:function loading(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","");setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},200);}},{key:'extvideo',value:function extvideo(externalvideo_link){var _this4=this;if(externalvideo_link!==undefined&&externalvideo_link.length>0){var strv=externalvideo_link.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{key:'ms_'+index,onClick:_this4.loading()},'Video ',index+1,': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'various fancybox fancybox.iframe',href:key},key));});return strv;}}},{key:'onsubmit',value:function onsubmit(){var _this5=this;var data=this.props.data;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'recordedvideo/saveall',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),dlr_id:data.dlr_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");_this5.props.getLearningRoom();if(responseJson.isCompletedFully){_this5.goToThanksPage();}else{_this5.props.switchback(responseJson.type,responseJson.lr_id,responseJson.dlr_id);}});}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'submitbuttons',value:function submitbuttons(){var _this6=this;if(this.compeletestatus!=='completed'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'cancel',id:'cancel',value:'Cancel',className:'button-cancel',alt:'Cancel',title:'Cancel',type:'button',onClick:function onClick(e){return _this6.backToComponentList();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'proceed',id:'proceed',value:'Finish',className:'button-accept',alt:'Finish',title:'Finish',type:'button',onClick:function onClick(e){return _this6.onsubmit();}}));}else{return"";}}},{key:'render',value:function render(){var vdata=this.state.vediocnt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:vdata.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Recorded Session',className:'vc_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,vdata.videocomponent_name?vdata.videocomponent_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,vdata.base_line?vdata.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},vdata.isvideoavail===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtedf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box videogray videoscroll'},this.state.playersem,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txtLP rgbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},this.submitbuttons()))),this.state.errmsg===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box videogray videohd'},' Note: Please click on "HD" on the RHS of your video player and select your best video quality to view.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box videogray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'whitebg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},'DISCLAIMER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'The following videos are not a property of 361DM, and have been suggested to you only to enhance your learning. It is possible that any time later, the owner of the video withdraws it, or the link may get broken, which we cannot fix. In that case, the particular video will not be available for watching any more, and we will not be able to provide a substitute video.')),vdata.externalvideo_link!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'whitebg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},'Click on the links below to watch the Videos shown in this DLR session'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.extvideo(vdata.externalvideo_link))):"")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,vdata.warning_msg),this.state.errmsg!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' '},this.state.errmsg)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'dsdpoup-txt4',className:'popup'}));}}]);return Recordedvideo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_7__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Recordedvideo));

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export

var ReactLiveClock = __webpack_require__(518).default;

module.exports = ReactLiveClock;
//# sourceMappingURL=index.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(519);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(523);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDate = function getDate(date) {
  return date ? new Date(date).getTime() : new Date().getTime();
};

var ReactLiveClock = function (_React$Component) {
  _inherits(ReactLiveClock, _React$Component);

  function ReactLiveClock() {
    _classCallCheck(this, ReactLiveClock);

    return _possibleConstructorReturn(this, (ReactLiveClock.__proto__ || Object.getPrototypeOf(ReactLiveClock)).apply(this, arguments));
  }

  _createClass(ReactLiveClock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.ticking) {
        this.tickTimer = setInterval(function () {
          _this2.forceUpdate();
        }, this.props.interval);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.tickTimer) {
        clearInterval(this.tickTimer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          date = _props.date,
          format = _props.format,
          timezone = _props.timezone;

      var dateValue = getDate(date || children);
      var localizedTime = (0, _momentTimezone2.default)(dateValue);

      if (timezone) {
        localizedTime.tz(timezone);
      }

      var formattedTime = localizedTime.format(format);

      return _react2.default.createElement(
        'time',
        { className: className },
        formattedTime
      );
    }
  }]);

  return ReactLiveClock;
}(_react2.default.Component);

exports.default = ReactLiveClock;


ReactLiveClock.propTypes = {
  children: _propTypes2.default.string,
  className: _propTypes2.default.string,
  date: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  format: _propTypes2.default.string,
  interval: _propTypes2.default.number,
  ticking: _propTypes2.default.bool,
  timezone: _propTypes2.default.string
};

ReactLiveClock.defaultProps = {
  className: null,
  date: null,
  format: 'HH:mm',
  interval: 1000,
  ticking: false,
  timezone: null
};
//# sourceMappingURL=Component.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(520)();
}


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(521);
var invariant = __webpack_require__(189);
var ReactPropTypesSecret = __webpack_require__(522);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(524);
moment.tz.load(__webpack_require__(525));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.13
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(146)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.13",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = {"version":"2017b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _theming = __webpack_require__(259);

Object.defineProperty(exports, 'ThemeProvider', {
  enumerable: true,
  get: function get() {
    return _theming.ThemeProvider;
  }
});
Object.defineProperty(exports, 'withTheme', {
  enumerable: true,
  get: function get() {
    return _theming.withTheme;
  }
});
Object.defineProperty(exports, 'createTheming', {
  enumerable: true,
  get: function get() {
    return _theming.createTheming;
  }
});

var _JssProvider = __webpack_require__(533);

Object.defineProperty(exports, 'JssProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_JssProvider)['default'];
  }
});

var _jss = __webpack_require__(147);

Object.defineProperty(exports, 'jss', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jss)['default'];
  }
});
Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _jss.SheetsRegistry;
  }
});
Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _jss.createGenerateClassNameDefault;
  }
});

var _injectSheet = __webpack_require__(574);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_injectSheet)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createThemeProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_function__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_function___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_function__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_plain_object__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__channel__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_brcast__ = __webpack_require__(531);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * Provide a theme to an entire react component tree via context
 * and event listeners (have to do both context
 * and event emitter as pure components block context updates)
 */

function createThemeProvider() {
  var _class, _temp2;

  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__channel__["a" /* default */];

  return _temp2 = _class = function (_React$Component) {
    _inherits(ThemeProvider, _React$Component);

    function ThemeProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ThemeProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = Object(__WEBPACK_IMPORTED_MODULE_5_brcast__["a" /* default */])(_this.getTheme()), _this.setOuterTheme = function (theme) {
        _this.outerTheme = theme;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ThemeProvider, [{
      key: 'getTheme',


      // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
      value: function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if (__WEBPACK_IMPORTED_MODULE_2_is_function___default()(theme)) {
          var mergedTheme = theme(this.outerTheme);
          if (!__WEBPACK_IMPORTED_MODULE_3_is_plain_object___default()(mergedTheme)) {
            throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
          }
          return mergedTheme;
        }
        if (!__WEBPACK_IMPORTED_MODULE_3_is_plain_object___default()(theme)) {
          throw new Error('[ThemeProvider] Please make your theme prop a plain object');
        }

        if (!this.outerTheme) {
          return theme;
        }

        return _extends({}, this.outerTheme, theme);
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return _defineProperty({}, CHANNEL, this.broadcast);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        // create a new subscription for keeping track of outer theme, if present
        if (this.context[CHANNEL]) {
          this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
        }
      }

      // set broadcast state by merging outer theme with own

    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (this.context[CHANNEL]) {
          this.setOuterTheme(this.context[CHANNEL].getState());
          this.broadcast.setState(this.getTheme());
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) {
          this.broadcast.setState(this.getTheme(nextProps.theme));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.subscriptionId !== undefined) {
          this.context[CHANNEL].unsubscribe(this.subscriptionId);
          delete this.subscriptionId;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (!this.props.children) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
      }
    }]);

    return ThemeProvider;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
    theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired
  }, _class.childContextTypes = _defineProperty({}, CHANNEL, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired), _class.contextTypes = _defineProperty({}, CHANNEL, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object), _temp2;
}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(530);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["a"] = (createBroadcast);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWithTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_theme_listener__ = __webpack_require__(260);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

function createWithTheme() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__channel__["a" /* default */];

  var themeListener = Object(__WEBPACK_IMPORTED_MODULE_2__create_theme_listener__["a" /* default */])(CHANNEL);
  return function (Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      _inherits(WithTheme, _React$Component);

      function WithTheme(props, context) {
        _classCallCheck(this, WithTheme);

        var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));

        _this.state = { theme: themeListener.initial(context) };
        _this.setTheme = function (theme) {
          return _this.setState({ theme: theme });
        };
        return _this;
      }

      _createClass(WithTheme, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var theme = this.state.theme;


          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({ theme: theme }, this.props));
        }
      }]);

      return WithTheme;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'WithTheme(' + getDisplayName(Component) + ')', _class.contextTypes = themeListener.contextTypes, _temp;
  };
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(3);

var _jss = __webpack_require__(147);

var _ns = __webpack_require__(151);

var ns = _interopRequireWildcard(_ns);

var _contextTypes = __webpack_require__(267);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _propTypes2 = __webpack_require__(268);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JssProvider = function (_Component) {
  _inherits(JssProvider, _Component);

  function JssProvider() {
    _classCallCheck(this, JssProvider);

    return _possibleConstructorReturn(this, (JssProvider.__proto__ || Object.getPrototypeOf(JssProvider)).apply(this, arguments));
  }

  _createClass(JssProvider, [{
    key: 'getChildContext',


    // JssProvider can be nested. We allow to overwrite any context prop at any level.
    // 1. Check if there is a value passed over props.
    // 2. If value was passed, we set it on the child context.
    // 3. If value was not passed, we proxy parent context (default context behaviour).
    value: function getChildContext() {
      var _props = this.props,
          registry = _props.registry,
          classNamePrefix = _props.classNamePrefix,
          localJss = _props.jss,
          generateClassName = _props.generateClassName,
          disableStylesGeneration = _props.disableStylesGeneration;

      var sheetOptions = this.context[ns.sheetOptions] || {};
      var context = _defineProperty({}, ns.sheetOptions, sheetOptions);

      if (registry) {
        context[ns.sheetsRegistry] = registry;
        // This way we identify a new request on the server, because user will create
        // a new Registry instance for each.
        if (registry !== this.registry) {
          // We reset managers because we have to regenerate all sheets for the new request.
          this.managers = {};
          this.registry = registry;
        }
      }

      // Make sure we don't loose managers when JssProvider is used inside of a stateful
      // component which decides to rerender.
      context[ns.managers] = this.managers;

      if (generateClassName) {
        sheetOptions.generateClassName = generateClassName;
      } else if (!sheetOptions.generateClassName) {
        if (!this.generateClassName) {
          var createGenerateClassName = _jss.createGenerateClassNameDefault;
          if (localJss && localJss.options.createGenerateClassName) {
            createGenerateClassName = localJss.options.createGenerateClassName;
          }
          // Make sure we don't loose the generator when JssProvider is used inside of a stateful
          // component which decides to rerender.
          this.generateClassName = createGenerateClassName();
        }

        sheetOptions.generateClassName = this.generateClassName;
      }

      if (classNamePrefix) sheetOptions.classNamePrefix = classNamePrefix;
      if (localJss) context[ns.jss] = localJss;
      if (disableStylesGeneration !== undefined) {
        sheetOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return context;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return JssProvider;
}(_react.Component);

JssProvider.propTypes = _extends({}, _propTypes3['default'], {
  generateClassName: _propTypes.func,
  classNamePrefix: _propTypes.string,
  disableStylesGeneration: _propTypes.bool,
  children: _propTypes.node.isRequired
});
JssProvider.childContextTypes = _contextTypes2['default'];
JssProvider.contextTypes = _contextTypes2['default'];
exports['default'] = JssProvider;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(263);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(95);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(266);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(540);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(541);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(547);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(548);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(149);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(58);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(265);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(94);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(549);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(550);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(542);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(543);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(544);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(545);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(546);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(68);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(68);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(148);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(148);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(58);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(94);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(263);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(68);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(58);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(94);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(149);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(58);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(93);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssTemplate = __webpack_require__(552);

var _jssTemplate2 = _interopRequireDefault(_jssTemplate);

var _jssGlobal = __webpack_require__(555);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

var _jssExtend = __webpack_require__(556);

var _jssExtend2 = _interopRequireDefault(_jssExtend);

var _jssNested = __webpack_require__(558);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCompose = __webpack_require__(560);

var _jssCompose2 = _interopRequireDefault(_jssCompose);

var _jssCamelCase = __webpack_require__(562);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(564);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssExpand = __webpack_require__(566);

var _jssExpand2 = _interopRequireDefault(_jssExpand);

var _jssVendorPrefixer = __webpack_require__(568);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(573);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
  };
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parse = __webpack_require__(553);

var _parse2 = _interopRequireDefault(_parse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var onProcessRule = function onProcessRule(rule) {
  if (typeof rule.style === 'string') {
    rule.style = (0, _parse2['default'])(rule.style);
  }
};

exports['default'] = function () {
  return { onProcessRule: onProcessRule };
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(554);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var semiWithNl = /;\n/;

/**
 * Naive CSS parser.
 * - Supports only rule body (no selectors)
 * - Requires semicolon and new line after the value (except of last line)
 * - No nested rules support
 */

exports['default'] = function (cssText) {
  var style = {};
  var split = cssText.split(semiWithNl);
  for (var i = 0; i < split.length; i++) {
    var decl = (split[i] || '').trim();

    if (!decl) continue;
    var colonIndex = decl.indexOf(':');
    if (colonIndex === -1) {
      (0, _warning2['default'])(false, 'Malformed CSS string "%s"', decl);
      continue;
    }
    var prop = decl.substr(0, colonIndex).trim();
    var value = decl.substr(colonIndex + 1).trim();
    style[prop] = value;
  }
  return style;
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(261);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = jssExtend;

var _warning = __webpack_require__(557);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isObject = function isObject(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
};
var valueNs = 'extendCurrValue' + Date.now();

function mergeExtend(style, rule, sheet, newStyle) {
  var extendType = _typeof(style.extend);
  // Extend using a rule name.
  if (extendType === 'string') {
    if (!sheet) return;
    var refRule = sheet.getRule(style.extend);
    if (!refRule) return;
    if (refRule === rule) {
      (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);
      return;
    }
    var parent = refRule.options.parent;

    if (parent) {
      var originalStyle = parent.rules.raw[style.extend];
      extend(originalStyle, rule, sheet, newStyle);
    }
    return;
  }

  // Extend using an array of objects.
  if (Array.isArray(style.extend)) {
    for (var index = 0; index < style.extend.length; index++) {
      extend(style.extend[index], rule, sheet, newStyle);
    }
    return;
  }

  // Extend is a style object.
  for (var prop in style.extend) {
    if (prop === 'extend') {
      extend(style.extend.extend, rule, sheet, newStyle);
      continue;
    }
    if (isObject(style.extend[prop])) {
      if (!(prop in newStyle)) newStyle[prop] = {};
      extend(style.extend[prop], rule, sheet, newStyle[prop]);
      continue;
    }
    newStyle[prop] = style.extend[prop];
  }
}

function mergeRest(style, rule, sheet, newStyle) {
  // Copy base style.
  for (var prop in style) {
    if (prop === 'extend') continue;
    if (isObject(newStyle[prop]) && isObject(style[prop])) {
      extend(style[prop], rule, sheet, newStyle[prop]);
      continue;
    }

    if (isObject(style[prop])) {
      newStyle[prop] = extend(style[prop], rule, sheet);
      continue;
    }

    newStyle[prop] = style[prop];
  }
}

/**
 * Recursively extend styles.
 */
function extend(style, rule, sheet) {
  var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  mergeExtend(style, rule, sheet, newStyle);
  mergeRest(style, rule, sheet, newStyle);
  return newStyle;
}

/**
 * Handle `extend` property.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExtend() {
  function onProcessStyle(style, rule, sheet) {
    if ('extend' in style) return extend(style, rule, sheet);
    return style;
  }

  function onChangeValue(value, prop, rule) {
    if (prop !== 'extend') return value;

    // Value is empty, remove properties set previously.
    if (value == null || value === false) {
      for (var key in rule[valueNs]) {
        rule.prop(key, null);
      }
      rule[valueNs] = null;
      return null;
    }

    for (var _key in value) {
      rule.prop(_key, value[_key]);
    }
    rule[valueNs] = value;

    // Make sure we don't set the value in the core.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(559);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jssCompose;

var _warning = __webpack_require__(561);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set selector.
 *
 * @param {Object} original rule
 * @param {String} className class string
 * @return {Boolean} flag, indicating function was successfull or not
 */
function registerClass(rule, className) {
  // Skip falsy values
  if (!className) return true;

  // Support array of class names `{composes: ['foo', 'bar']}`
  if (Array.isArray(className)) {
    for (var index = 0; index < className.length; index++) {
      var isSetted = registerClass(rule, className[index]);
      if (!isSetted) return false;
    }

    return true;
  }

  // Support space separated class names `{composes: 'foo bar'}`
  if (className.indexOf(' ') > -1) {
    return registerClass(rule, className.split(' '));
  }

  var parent = rule.options.parent;

  // It is a ref to a local rule.

  if (className[0] === '$') {
    var refRule = parent.getRule(className.substr(1));

    if (!refRule) {
      (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
      return false;
    }

    if (refRule === rule) {
      (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
      return false;
    }

    parent.classes[rule.key] += ' ' + parent.classes[refRule.key];

    return true;
  }

  rule.options.parent.classes[rule.key] += ' ' + className;

  return true;
}

/**
 * Convert compose property to additional class, remove property from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssCompose() {
  function onProcessStyle(style, rule) {
    if (!style.composes) return style;
    registerClass(rule, style.composes);
    // Remove composes property to prevent infinite loop.
    delete style.composes;
    return style;
  }
  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(563);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(565);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = jssExpand;

var _props = __webpack_require__(567);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Map values by given prop.
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {String} original rule
 * @return {String} mapped values
 */
function mapValuesByProp(value, prop, rule) {
  return value.map(function (item) {
    return objectToArray(item, prop, rule, false, true);
  });
}

/**
 * Convert array to nested array, if needed
 *
 * @param {Array} array of values
 * @param {String} original property
 * @param {Object} sheme, for converting arrays in strings
 * @param {Object} original rule
 * @return {String} converted string
 */
function processArray(value, prop, scheme, rule) {
  if (scheme[prop] == null) return value;
  if (value.length === 0) return [];
  if (Array.isArray(value[0])) return processArray(value[0], prop, scheme);
  if (_typeof(value[0]) === 'object') {
    return mapValuesByProp(value, prop, rule);
  }

  return [value];
}

/**
 * Convert object to array.
 *
 * @param {Object} object of values
 * @param {String} original property
 * @param {Object} original rule
 * @param {Boolean} is fallback prop
 * @param {Boolean} object is inside array
 * @return {String} converted string
 */
function objectToArray(value, prop, rule, isFallback, isInArray) {
  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return [];

  var result = [];

  // Check if exists any non-standart property
  if (_props.customPropObj[prop]) {
    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
  }

  // Pass throught all standart props
  if (Object.keys(value).length) {
    for (var baseProp in _props.propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result.push(_props.propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
        } else result.push(value[baseProp]);
        continue;
      }

      // Add default value from props config.
      if (_props.propObj[prop][baseProp] != null) {
        result.push(_props.propObj[prop][baseProp]);
      }
    }
  }

  if (!result.length || isInArray) return result;
  return [result];
}

/**
 * Convert custom properties values to styles adding them to rule directly
 *
 * @param {Object} object of values
 * @param {Object} original rule
 * @param {String} property, that contain partial custom properties
 * @param {Boolean} is fallback prop
 * @return {Object} value without custom properties, that was already added to rule
 */
function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop];

    // If current property doesn't exist already in rule - add new one
    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
      var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName];

      // Add style directly in rule
      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
    }
    // Delete converted property to avoid double converting
    delete value[prop];
  }

  return value;
}

/**
 * Detect if a style needs to be converted.
 *
 * @param {Object} style
 * @param {Object} rule
 * @param {Boolean} is fallback prop
 * @return {Object} convertedStyle
 */
function styleDetector(style, rule, isFallback) {
  for (var prop in style) {
    var value = style[prop];

    if (Array.isArray(value)) {
      // Check double arrays to avoid recursion.
      if (!Array.isArray(value[0])) {
        if (prop === 'fallbacks') {
          for (var index = 0; index < style.fallbacks.length; index++) {
            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
          }
          continue;
        }

        style[prop] = processArray(value, prop, _props.propArray);
        // Avoid creating properties with empty values
        if (!style[prop].length) delete style[prop];
      }
    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      if (prop === 'fallbacks') {
        style.fallbacks = styleDetector(style.fallbacks, rule, true);
        continue;
      }

      style[prop] = objectToArray(value, prop, rule, isFallback);
      // Avoid creating properties with empty values
      if (!style[prop].length) delete style[prop];
    }

    // Maybe a computed value resulting in an empty string
    else if (style[prop] === '') delete style[prop];
  }

  return style;
}

/**
 * Adds possibility to write expanded styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssExpand() {
  function onProcessStyle(style, rule) {
    if (!style || rule.type !== 'style') return style;

    if (Array.isArray(style)) {
      // Pass rules one by one and reformat them
      for (var index = 0; index < style.length; index++) {
        style[index] = styleDetector(style[index], rule);
      }
      return style;
    }

    return styleDetector(style, rule);
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A scheme for converting properties from array to regular style.
 * All properties listed below will be transformed to a string separated by space.
 */
var propArray = exports.propArray = {
  'background-size': true,
  'background-position': true,
  border: true,
  'border-bottom': true,
  'border-left': true,
  'border-top': true,
  'border-right': true,
  'border-radius': true,
  'border-image': true,
  'border-width': true,
  'border-style': true,
  'border-color': true,
  'box-shadow': true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  'transform-origin': true,
  transform: true,
  transition: true

  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */
};var propArrayInObj = exports.propArrayInObj = {
  position: true, // background-position
  size: true // background-size


  /**
   * A scheme for parsing and building correct styles from passed objects.
   */
};var propObj = exports.propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  'border-top': {
    width: null,
    style: null,
    color: null
  },
  'border-right': {
    width: null,
    style: null,
    color: null
  },
  'border-bottom': {
    width: null,
    style: null,
    color: null
  },
  'border-left': {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  'list-style': {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed for avoiding comilation issues with jss-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    'timing-function': null,
    timingFunction: null, // Needed to avoid compilation issues with jss-camel-case
    delay: null,
    'iteration-count': null,
    iterationCount: null, // Needed to avoid compilation issues with jss-camel-case
    direction: null,
    'fill-mode': null,
    fillMode: null, // Needed to avoid compilation issues with jss-camel-case
    'play-state': null,
    playState: null // Needed to avoid compilation issues with jss-camel-case
  },
  'box-shadow': {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  'text-shadow': {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }

  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */
};var customPropObj = exports.customPropObj = {
  border: {
    radius: 'border-radius',
    image: 'border-image',
    width: 'border-width',
    style: 'border-style',
    color: 'border-color'
  },
  background: {
    size: 'background-size',
    image: 'background-image'
  },
  font: {
    style: 'font-style',
    variant: 'font-variant',
    weight: 'font-weight',
    stretch: 'font-stretch',
    size: 'font-size',
    family: 'font-family',
    lineHeight: 'line-height', // Needed to avoid compilation issues with jss-camel-case
    'line-height': 'line-height'
  },
  flex: {
    grow: 'flex-grow',
    basis: 'flex-basis',
    direction: 'flex-direction',
    wrap: 'flex-wrap',
    flow: 'flex-flow',
    shrink: 'flex-shrink'
  },
  align: {
    self: 'align-self',
    items: 'align-items',
    content: 'align-content'
  },
  grid: {
    'template-columns': 'grid-template-columns',
    templateColumns: 'grid-template-columns',

    'template-rows': 'grid-template-rows',
    templateRows: 'grid-template-rows',

    'template-areas': 'grid-template-areas',
    templateAreas: 'grid-template-areas',

    template: 'grid-template',

    'auto-columns': 'grid-auto-columns',
    autoColumns: 'grid-auto-columns',

    'auto-rows': 'grid-auto-rows',
    autoRows: 'grid-auto-rows',

    'auto-flow': 'grid-auto-flow',
    autoFlow: 'grid-auto-flow',

    row: 'grid-row',
    column: 'grid-column',

    'row-start': 'grid-row-start',
    rowStart: 'grid-row-start',
    'row-end': 'grid-row-end',
    rowEnd: 'grid-row-end',

    'column-start': 'grid-column-start',
    columnStart: 'grid-column-start',
    'column-end': 'grid-column-end',
    columnEnd: 'grid-column-end',

    area: 'grid-area',
    gap: 'grid-gap',

    'row-gap': 'grid-row-gap',
    rowGap: 'grid-row-gap',

    'column-gap': 'grid-column-gap',
    columnGap: 'grid-column-gap'
  }
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(569);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(150);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(570);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(572);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(95);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(150);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(571);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(95);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(150);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = injectSheet;

var _hoistNonReactStatics = __webpack_require__(575);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _createHoc = __webpack_require__(576);

var _createHoc2 = _interopRequireDefault(_createHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * @type {Number}
 */
var indexCounter = -100000;

var NoRenderer = function NoRenderer(_ref) {
  var children = _ref.children;
  return children || null;
};

/**
 * HOC creator function that wrapps the user component.
 *
 * `injectSheet(styles, [options])(Component)`
 *
 * @api public
 */
function injectSheet(stylesOrSheet) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options.index === undefined) {
    options.index = indexCounter++;
  }
  return function () {
    var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;

    var Jss = (0, _createHoc2['default'])(stylesOrSheet, InnerComponent, options);
    return (0, _hoistNonReactStatics2['default'])(Jss, InnerComponent, { inner: true });
  };
}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theming = __webpack_require__(259);

var _theming2 = _interopRequireDefault(_theming);

var _jss = __webpack_require__(147);

var _jss2 = _interopRequireDefault(_jss);

var _compose = __webpack_require__(577);

var _compose2 = _interopRequireDefault(_compose);

var _getDisplayName = __webpack_require__(578);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _ns = __webpack_require__(151);

var ns = _interopRequireWildcard(_ns);

var _contextTypes = __webpack_require__(267);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var env = "production";

// Like a Symbol
var dynamicStylesNs = Math.random();

/*
 * # Use cases
 *
 * - Unthemed component accepts styles object
 * - Themed component accepts styles creator function which takes theme as a single argument
 * - Multiple instances will re-use the same static sheet via sheets manager
 * - Sheet manager identifies static sheets by theme as a key
 * - For unthemed components theme is an empty object
 * - The very first instance will add static sheet to sheets manager
 * - Every further instances will get that static sheet from sheet manager
 * - Every mount of every instance will call method `sheetsManager.manage`,
 * thus incrementing reference counter.
 * - Every unmount of every instance will call method `sheetsManager.unmanage`,
 * thus decrementing reference counter.
 * - `sheetsManager.unmanage` under the hood will detach static sheet once reference
 * counter is zero.
 * - Dynamic styles are not shared between instances
 *
 */

var getStyles = function getStyles(stylesOrCreator, theme) {
  if (typeof stylesOrCreator !== 'function') {
    return stylesOrCreator;
  }
  return stylesOrCreator(theme);
};

// Returns an object with array property as a key and true as a value.
var toMap = function toMap(arr) {
  return arr.reduce(function (map, prop) {
    map[prop] = true;
    return map;
  }, {});
};

var defaultInjectProps = {
  sheet: false,
  classes: true,
  theme: true
};

var managersCounter = 0;

/**
 * Wrap a Component into a JSS Container Component.
 *
 * @param {Object|Function} stylesOrCreator
 * @param {Component} InnerComponent
 * @param {Object} [options]
 * @return {Component}
 */

exports['default'] = function (stylesOrCreator, InnerComponent) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var isThemingEnabled = typeof stylesOrCreator === 'function';

  var _options$theming = options.theming,
      theming = _options$theming === undefined ? _theming2['default'] : _options$theming,
      inject = options.inject,
      optionsJss = options.jss,
      sheetOptions = _objectWithoutProperties(options, ['theming', 'inject', 'jss']);

  var injectMap = inject ? toMap(inject) : defaultInjectProps;
  var themeListener = theming.themeListener;

  var displayName = (0, _getDisplayName2['default'])(InnerComponent);
  var defaultClassNamePrefix = env === 'production' ? undefined : displayName + '-';
  var noTheme = {};
  var managerId = managersCounter++;
  var manager = new _jss.SheetsManager();
  var defaultProps = _extends({}, InnerComponent.defaultProps);
  delete defaultProps.classes;

  var Jss = function (_Component) {
    _inherits(Jss, _Component);

    function Jss(props, context) {
      _classCallCheck(this, Jss);

      var _this = _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).call(this, props, context));

      _initialiseProps.call(_this);

      var theme = isThemingEnabled ? themeListener.initial(context) : noTheme;

      _this.state = _this.createState({ theme: theme }, props);
      return _this;
    }

    _createClass(Jss, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.manage(this.state);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (isThemingEnabled) {
          this.unsubscribeId = themeListener.subscribe(this.context, this.setTheme);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        this.context = nextContext;
        var dynamicSheet = this.state.dynamicSheet;

        if (dynamicSheet) dynamicSheet.update(nextProps);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (isThemingEnabled && this.state.theme !== nextState.theme) {
          var newState = this.createState(nextState, nextProps);
          this.manage(newState);
          this.manager.unmanage(this.state.theme);
          this.setState(newState);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        // We remove previous dynamicSheet only after new one was created to avoid FOUC.
        if (prevState.dynamicSheet !== this.state.dynamicSheet) {
          this.jss.removeStyleSheet(prevState.dynamicSheet);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.unsubscribeId) {
          themeListener.unsubscribe(this.context, this.unsubscribeId);
        }

        this.manager.unmanage(this.state.theme);
        if (this.state.dynamicSheet) {
          this.state.dynamicSheet.detach();
        }
      }
    }, {
      key: 'createState',
      value: function createState(_ref, _ref2) {
        var theme = _ref.theme,
            dynamicSheet = _ref.dynamicSheet;
        var userClasses = _ref2.classes;

        var contextSheetOptions = this.context[ns.sheetOptions];
        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
          return { theme: theme, dynamicSheet: dynamicSheet, classes: {} };
        }

        var classNamePrefix = defaultClassNamePrefix;
        var staticSheet = this.manager.get(theme);

        if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
          classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
        }

        if (!staticSheet) {
          var styles = getStyles(stylesOrCreator, theme);
          staticSheet = this.jss.createStyleSheet(styles, _extends({}, sheetOptions, contextSheetOptions, {
            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Static',
            classNamePrefix: classNamePrefix
          }));
          this.manager.add(theme, staticSheet);
          staticSheet[dynamicStylesNs] = (0, _jss.getDynamicStyles)(styles);
        }

        var dynamicStyles = staticSheet[dynamicStylesNs];

        if (dynamicStyles) {
          dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends({}, sheetOptions, contextSheetOptions, {
            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Dynamic',
            classNamePrefix: classNamePrefix,
            link: true
          }));
        }

        var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : {};
        var jssClasses = dynamicSheet ? (0, _compose2['default'])(staticSheet.classes, dynamicSheet.classes) : staticSheet.classes;
        var classes = _extends({}, defaultClasses, jssClasses, userClasses);

        return { theme: theme, dynamicSheet: dynamicSheet, classes: classes };
      }
    }, {
      key: 'manage',
      value: function manage(_ref3) {
        var theme = _ref3.theme,
            dynamicSheet = _ref3.dynamicSheet;

        var contextSheetOptions = this.context[ns.sheetOptions];
        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
          return;
        }
        var registry = this.context[ns.sheetsRegistry];

        var staticSheet = this.manager.manage(theme);
        if (registry) registry.add(staticSheet);

        if (dynamicSheet) {
          dynamicSheet.update(this.props).attach();
          if (registry) registry.add(dynamicSheet);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            theme = _state.theme,
            dynamicSheet = _state.dynamicSheet,
            classes = _state.classes;

        var _props = this.props,
            innerRef = _props.innerRef,
            props = _objectWithoutProperties(_props, ['innerRef']);

        var sheet = dynamicSheet || this.manager.get(theme);

        if (injectMap.sheet && !props.sheet) props.sheet = sheet;
        if (isThemingEnabled && injectMap.theme && !props.theme) props.theme = theme;

        // We have merged classes already.
        if (injectMap.classes) props.classes = classes;

        return _react2['default'].createElement(InnerComponent, _extends({ ref: innerRef }, props));
      }
    }, {
      key: 'jss',
      get: function get() {
        return this.context[ns.jss] || optionsJss || _jss2['default'];
      }
    }, {
      key: 'manager',
      get: function get() {
        var managers = this.context[ns.managers];

        // If `managers` map is present in the context, we use it in order to
        // let JssProvider reset them when new response has to render server-side.
        if (managers) {
          if (!managers[managerId]) {
            managers[managerId] = new _jss.SheetsManager();
          }
          return managers[managerId];
        }

        return manager;
      }
    }]);

    return Jss;
  }(_react.Component);

  Jss.displayName = 'Jss(' + displayName + ')';
  Jss.InnerComponent = InnerComponent;
  Jss.contextTypes = _extends({}, _contextTypes2['default'], isThemingEnabled && themeListener.contextTypes);
  Jss.propTypes = {
    innerRef: _propTypes2['default'].func
  };
  Jss.defaultProps = defaultProps;

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.setTheme = function (theme) {
      return _this2.setState({ theme: theme });
    };
  };

  return Jss;
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Adds `composes` property to each top level rule
 * in order to have a composed class name for dynamic style sheets.
 *
 * It relies on jss-compose and jss-extend plugins.
 *
 * Example:
 * classes:  {left: 'a', button: 'b'}
 * styles:   {button: {height: () => { ... }}}
 * composed: {
 *   button: {
 *     composes: 'b',
 *     height: () => { ... }
 *   },
 *   left: {
 *     composes: 'a'
 *   }
 * }
 *
 * @param {Object} classes static classes map
 * @param {Object} styles dynamic styles object without static properties
 * @return {Object|null}
 */
exports["default"] = function (staticClasses, dynamicClasses) {
  var combinedClasses = _extends({}, staticClasses);

  for (var name in dynamicClasses) {
    combinedClasses[name] = staticClasses[name] ? staticClasses[name] + " " + dynamicClasses[name] : dynamicClasses[name];
  }

  return combinedClasses;
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (Component) {
  return Component.displayName || Component.name || 'Component';
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMinimalistPortal = __webpack_require__(580);

var _reactMinimalistPortal2 = _interopRequireDefault(_reactMinimalistPortal);

var _CSSTransition = __webpack_require__(581);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _noScroll = __webpack_require__(583);

var _noScroll2 = _interopRequireDefault(_noScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.onClickOverlay = function (e) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          closeOnOverlayClick = _this$props.closeOnOverlayClick;

      if (!closeOnOverlayClick || typeof e.target.className !== 'string') {
        return;
      }
      var className = e.target.className.split(' ');
      if (className.indexOf(classes.overlay) !== -1 && !_this.isScrollBarClick(e)) {
        e.stopPropagation();
        _this.props.onClose();
      }
    };

    _this.onClickCloseIcon = function (e) {
      e.stopPropagation();
      _this.props.onClose();
    };

    _this.isScrollBarClick = function (e) {
      return e.clientX >= document.documentElement.offsetWidth;
    };

    _this.handleKeydown = function (e) {
      if (e.keyCode === 27 && _this.props.open) {
        _this.props.onClose();
      }
    };

    _this.handleExited = function () {
      if (_this.props.onExited) {
        _this.props.onExited();
      }

      _this.setState({ showPortal: false });
      _this.unblockScroll();
    };

    _this.unblockScroll = function () {
      var openedModals = document.getElementsByClassName(_this.props.classes.modal);
      if (openedModals.length === 1) {
        _noScroll2.default.off();
      }
    };

    _this.state = {
      showPortal: props.open
    };
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      // Block scroll when initial prop is open
      if (this.props.open) {
        this.blockScroll();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!this.props.open && nextProps.open) {
        this.setState({
          showPortal: true
        }, function () {
          _this2.blockScroll();
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      this.unblockScroll();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'blockScroll',


    // eslint-disable-next-line class-methods-use-this
    value: function blockScroll() {
      _noScroll2.default.on();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          little = _props.little,
          classes = _props.classes,
          classNames = _props.classNames,
          styles = _props.styles,
          showCloseIcon = _props.showCloseIcon,
          closeIconSize = _props.closeIconSize,
          closeIconSvgPath = _props.closeIconSvgPath,
          animationDuration = _props.animationDuration;
      var showPortal = this.state.showPortal;

      if (!showPortal) return null;
      return _react2.default.createElement(
        _reactMinimalistPortal2.default,
        null,
        _react2.default.createElement(
          _CSSTransition2.default,
          {
            'in': open,
            appear: true,
            classNames: {
              appear: classNames.transitionEnter || classes.transitionEnter,
              appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
              enter: classNames.transitionEnter || classes.transitionEnter,
              enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
              exit: classNames.transitionExit || classes.transitionExit,
              exitActive: classNames.transitionExitActive || classes.transitionExitActive
            },
            timeout: animationDuration,
            onExited: this.handleExited
          },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)(classes.overlay, little ? classes.overlayLittle : null, classNames.overlay),
              onMouseDown: this.onClickOverlay,
              style: styles.overlay
            },
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)(classes.modal, classNames.modal),
                style: styles.modal
              },
              showCloseIcon ? _react2.default.createElement(
                'svg',
                {
                  className: (0, _classnames2.default)(classes.closeIcon, classNames.closeIcon),
                  style: styles.closeIcon,
                  onClick: this.onClickCloseIcon,
                  xmlns: 'http://www.w3.org/2000/svg',
                  width: closeIconSize,
                  height: closeIconSize,
                  viewBox: '0 0 36 36'
                },
                closeIconSvgPath
              ) : null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  closeOnEsc: _propTypes2.default.bool,
  closeOnOverlayClick: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool.isRequired,
  classNames: _propTypes2.default.object,
  styles: _propTypes2.default.object,
  children: _propTypes2.default.node,
  classes: _propTypes2.default.object.isRequired,
  little: _propTypes2.default.bool,
  onExited: _propTypes2.default.func,
  showCloseIcon: _propTypes2.default.bool,
  closeIconSize: _propTypes2.default.number,
  closeIconSvgPath: _propTypes2.default.node,
  animationDuration: _propTypes2.default.number
};

Modal.defaultProps = {
  closeOnEsc: true,
  closeOnOverlayClick: true,
  showCloseIcon: true,
  closeIconSize: 28,
  closeIconSvgPath: _react2.default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' }),
  classNames: {},
  styles: {},
  children: null,
  little: false,
  onExited: null,
  animationDuration: 500
};

exports.default = Modal;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
var isBrowser = typeof window !== 'undefined';

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isBrowser) {
        if (!this.props.container) {
          this.container = document.createElement('div');
          document.body.appendChild(this.container);
        } else {
          this.container = this.props.container;
        }
        this.renderLayer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom2.default.unmountComponentAtNode(this.container);
      }
      if (!this.props.container) {
        document.body.removeChild(this.container);
      }
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (useCreatePortal) {
        return _reactDom2.default.createPortal(this.props.children, this.container);
      }
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node, // eslint-disable-line
  container: _propTypes2.default.object // eslint-disable-line
};

exports.default = Portal;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _addClass = _interopRequireDefault(__webpack_require__(269));

var _removeClass = _interopRequireDefault(__webpack_require__(271));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(582));

var _PropTypes = __webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};

var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};;
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(7));

var _reactLifecyclesCompat = __webpack_require__(233);

var _PropTypes = __webpack_require__(272);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: 1000,
    padding: '1.2rem'
  },
  overlayLittle: {
    alignItems: 'center'
  },
  modal: {
    maxWidth: 800,
    position: 'relative',
    padding: '1.2rem',
    background: '#ffffff',
    backgroundClip: 'padding-box',
    boxShadow: '0 12px 15px 0 rgba(0,0,0,0.25)'
  },
  closeIcon: {
    position: 'absolute',
    top: '14px',
    right: '14px',
    cursor: 'pointer'
  },
  transitionEnter: {
    opacity: '0.01'
  },
  transitionEnterActive: {
    opacity: 1,
    transition: 'opacity 500ms cubic-bezier(0.23, 1, 0.32, 1)'
  },
  transitionExit: {
    opacity: 1
  },
  transitionExitActive: {
    opacity: '0.01',
    transition: 'opacity 500ms cubic-bezier(0.23, 1, 0.32, 1)'
  }
};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Virtualkeyboard__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Normaltest=function(_Component){_inherits(Normaltest,_Component);function Normaltest(props){_classCallCheck(this,Normaltest);var _this=_possibleConstructorReturn(this,(Normaltest.__proto__||Object.getPrototypeOf(Normaltest)).call(this,props));_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.state={componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",isrepeatcomp:'N',confidence_meter:'',confidence_answer:[],score_disable:false};return _this;}_createClass(Normaltest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettestdetails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({isrepeatcomp:responseJson.isrepeatcomp,testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,observerEvaluation:responseJson.Mcq_details.observerEvaluation,confidence_meter:responseJson.Mcq_details.confidence_meter,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.Mcq_details.evaluationMentor,evaluation_ecoach:responseJson.Mcq_details.evaluationEcoach,mentor_perform:responseJson.Mcq_details.mentorPerform,ecoach_perform:responseJson.Mcq_details.ecoachPerform,mentor_view:responseJson.Mcq_details.mentorView,ecoach_view:responseJson.Mcq_details.ecoachView})});_this2.state.testquestions.map(function(mk,index){if(mk.question_type==9||mk.question_type==10){_this2.setState({score_disable:true});}});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getTestdetails(data);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true,"score_disable":this.state.score_disable};this.props.switchback(sdd);}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',//type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){switch(ans_opt.options){case'image':return imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':return this.video_frame(ans_opt.add_on_answer_video,'');break;default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}}},{key:'submittest',value:function submittest(){var _this3=this;var confidence=this.state.confidence_meter;var isValid=true;if(confidence==1){this.state.testquestions.map(function(mk,index){if(document.getElementById('notsure_'+mk.question_id).checked===true||document.getElementById('somewhatsure_'+mk.question_id).checked===true||document.getElementById('verysure_'+mk.question_id).checked===true){isValid=true;$('#errorconfident_'+mk.question_id).css('display','none');if(document.getElementById('somewhatsure_'+mk.question_id).checked==true){//alert('2');
_this3.state.confidence_answer.push({'confidence_ans':document.getElementById('somewhatsure_'+mk.question_id).value});//console.log(this.state.testquestions);
}if(document.getElementById('notsure_'+mk.question_id).checked==true){//alert('1');
_this3.state.confidence_answer.push({'confidence_ans':document.getElementById('notsure_'+mk.question_id).value});}if(document.getElementById('verysure_'+mk.question_id).checked==true){//salert('3');
_this3.state.confidence_answer.push({'confidence_ans':document.getElementById('verysure_'+mk.question_id).value});}}else{isValid=false;$('#errorconfident_'+mk.question_id).css('display','block');}});}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;//this.state.testquestions.confidence_ans=2;
var testForm=$("#frm_mcq").serializeArray(),formData=new FormData();testForm.map(function(val,index){formData.append(val.name,val.value);});formData.append("questions",JSON.stringify(this.state.testquestions));formData.append("data",JSON.stringify(data));formData.append("confidence_test",JSON.stringify(this.state.confidence_answer));Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/saveall",{method:"POST",headers:{"Accept":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this3.props.getLearningRoom();if(responseJson.componentStatus=='completed'){_this3.gotoresult();}else{var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this3.setState({componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel});}}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this4=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.testcont,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this4.props.getLearningRoom();// if (responseJson.isCompletedFully) {
//     this.goToThanksPage();
// } else {
_this4.gotoresult();// this.setState({
//     componentStatus: "completed"
// });
//}
}});}},{key:'submitbuttons',value:function submitbuttons(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Submit',className:'button_org_inactive',type:'button',onClick:function onClick(e){return _this5.submittest();}}));}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 9:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'0.5em'}},ans_opt.options),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:quest_det.question_id,maxLength:'1',required:true,onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["m" /* validateTxtbox */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["j" /* handleTextbox */])(e);}}));break;case 10:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'0.5em'}},ans_opt.options),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:'1.5em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{float:'right',marginRight:'480px'},type:'radio','data-id':quest_det.question_id,required:true,value:ans_opt.mcq_answer_id_pk,name:quest_det.question_id+'_most',onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["f" /* handleDoubleRadio */])(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{float:'right',marginRight:'-87px'},type:'radio','data-id':quest_det.question_id,required:true,value:ans_opt.mcq_answer_id_pk,name:quest_det.question_id+'_least',onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["f" /* handleDoubleRadio */])(e);}})));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this6=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this6.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this6.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:''})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{key:video_files,playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip===0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},mk.is_virtualkeyboard===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Virtualkeyboard__["a" /* default */],{qus_id:mk.question_id,validate:validationClass,chkonkeyup:function chkonkeyup(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},data_maxword:mk.openended_maxwords}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,id:'keyboard'+mk.question_id,className:validationClass,rows:'3',style:{height:"inherit",resize:"none"},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'render',value:function render(){var _this7=this;var data=this.state.testcont,seq_op=[];var confidence_meter=this.state.confidence_meter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.componentStatus==="incompleted"&&this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.isrepeatcomp=='Y'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Message:'),' You can repeat this test after completion. However, the score achieved in your first attempt will be your final score.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq'},this.state.testquestions.map(function(mk,index){var optionText=[],vcla=mk.is_hint_viewed>0?'block':'none';var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},mk.hint_for_learner!=''&&mk.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+index,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this7.hintopen(mk.question_id,mk.hint_reduce_per,mk.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+mk.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+mk.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_type==10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'441px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Most'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'32px'}},'Least'))),mk.question_images.map(function(val,iex){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izkey:'img_'+iex,izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:mk.img_width,izheight:mk.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+iex,src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width,height:mk.img_height}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this7.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}else if(mk.question_type==2){if(i==0){seq_op=[];seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'span_'+i,className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+mk.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}else{seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'span_'+i,className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+mk.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}//unique_option
// seq_op.push(<span key={`span_${i}`} className="seq-container"><input type="text" name={`${mk.question_id}`} className="seq_txtbox auto-focus" maxLength="2" onKeyPress={e=>allowOnlyNumberInput(e)} onKeyUp={(e)=>autoFocusNext(e, '.seq-container')} onBlur={(e)=>handleSequence(e)}/> -</span>);
}return _this7.getquestion(mk,qas,i+1,data.imagezoom);}),mk.question_type==6&&_this7.openendquestions(mk),mk.question_type==7&&_this7.matchfillfun(mk,data.imagezoom)),$.inArray(mk.question_type,[1,3,5,9,10])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':mk.max_multiple,defaultValue:''})),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:mk}),mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:sequenceClass,'data-max-seq':mk.question_option_answers.length,defaultValue:''}))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:optionClass,'data-options':optionText.join(',')})))))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Confidencemeter__["a" /* default */],{dynamic_confidence:mk.question_id}):'');}),this.submitbuttons())),this.state.componentStatus==="incompleted"&&!this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox'},'You have already answered this component.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This component will get completed only when you choose Observer(s) to rate your answers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this7.continueToComplete();}})))))))));}}]);return Normaltest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_13__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Normaltest));

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var RepeatNormaltest=function(_Component){_inherits(RepeatNormaltest,_Component);function RepeatNormaltest(props){_classCallCheck(this,RepeatNormaltest);var _this=_possibleConstructorReturn(this,(RepeatNormaltest.__proto__||Object.getPrototypeOf(RepeatNormaltest)).call(this,props));_this.state={componentStatus:_this.props.data.status,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",resultpage:false,totalscore:0,outofscore:0,is_performance:false,percentage:''//confidence_answer: [],
};return _this;}_createClass(RepeatNormaltest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettestdetails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getTestdetails(data);}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){switch(ans_opt.options){case'image':return imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':return this.video_frame(ans_opt.add_on_answer_video,'');break;default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}}},{key:'submittest',value:function submittest(){var _this3=this;var confidence=this.state.testcont.confidence_meter;var isValid=true;if(confidence==1){this.state.testquestions.map(function(mk,index){if(document.getElementById('notsure_'+mk.question_id).checked===true||document.getElementById('somewhatsure_'+mk.question_id).checked===true||document.getElementById('verysure_'+mk.question_id).checked===true){isValid=true;$('#errorconfident_'+mk.question_id).css('display','none');/*if(document.getElementById('somewhatsure_'+mk.question_id).checked ==true)
            {
              //alert('2');
              this.state.confidence_answer.push({'confidence_ans': document.getElementById('somewhatsure_'+mk.question_id).value})
              //console.log(this.state.testquestions);
            }
            if(document.getElementById('notsure_'+mk.question_id).checked ==true )
            {
              //alert('1');
              this.state.confidence_answer.push({'confidence_ans':document.getElementById('notsure_'+mk.question_id).value})
            }
            if(document.getElementById('verysure_'+mk.question_id).checked ==true)
            {
              //salert('3');
              this.state.confidence_answer.push({'confidence_ans':document.getElementById('verysure_'+mk.question_id).value})
            }*/}else{isValid=false;$('#errorconfident_'+mk.question_id).css('display','block');}});}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;var testForm=$("#frm_mcq").serializeArray(),formData=new FormData();testForm.map(function(val,index){formData.append(val.name,val.value);});formData.append("questions",JSON.stringify(this.state.testquestions));formData.append("data",JSON.stringify(data));Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show");//console.log(testForm);
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/repeattestsaveall",{method:"POST",headers:{"Accept":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this3.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage});}});}}},{key:'submitbuttons',value:function submitbuttons(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Submit',className:'button_org_inactive',type:'button',onClick:function onClick(e){return _this4.submittest();}}));}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:''})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{key:video_files,playlist:playlist,trackData:trackData});}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;// console.log(data);
this.props.switchback("component_list",data.learning_room_id,data.dlr_id);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["k" /* hideleftbar */])();},400);}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont,seq_op=[];var resultpagecontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg'},'Successfully completed the Session.'),this.state.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box lr-yellow-box-repeat'},' You have scored ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.state.percentage!=''?this.state.percentage+'%':'0%',' (',(this.state.totalscore!=undefined?this.state.totalscore:'')+'/'+(this.state.outofscore!=undefined?this.state.outofscore:''),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this6.backToComponentList();}})))))))));var confidence_meter=this.state.testcont.confidence_meter;return this.state.resultpage?resultpagecontent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),data.learner_msg!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.componentStatus!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq'},this.state.testquestions.map(function(mk,index){var optionText=[],vcla=mk.is_hint_viewed>0?'block':'none';var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},mk.hint_for_learner!=''&&mk.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+index,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+mk.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_images.map(function(val,iex){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izkey:'img_'+iex,izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:mk.img_width,izheight:mk.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+iex,src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width,height:mk.img_height}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}else if(mk.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'span_'+i,className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+mk.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}return _this6.getquestion(mk,qas,i+1,data.imagezoom);}),mk.question_type==7&&_this6.matchfillfun(mk,data.imagezoom),$.inArray(mk.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':mk.max_multiple,defaultValue:''}))),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:mk}),mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:sequenceClass,'data-max-seq':mk.question_option_answers.length,defaultValue:''}))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:optionClass,'data-options':optionText.join(',')}))))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Confidencemeter__["a" /* default */],{dynamic_confidence:mk.question_id}):''));}),this.submitbuttons())))))));}}]);return RepeatNormaltest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_9__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null,mapDispatchToProps)(RepeatNormaltest));

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Virtualkeyboard__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Testonebyone=function(_Component){_inherits(Testonebyone,_Component);function Testonebyone(props){_classCallCheck(this,Testonebyone);var _this=_possibleConstructorReturn(this,(Testonebyone.__proto__||Object.getPrototypeOf(Testonebyone)).call(this,props));_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.compeletestatus="";_this.state={testseqfields:[],componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",is_answered_all:0,resultthank:'',isrepeatcomp:'N',confidence_meter:''//confidence_answer:'',
};return _this;}_createClass(Testonebyone,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getonebyonedet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({isrepeatcomp:responseJson.isrepeatcomp,testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,observerEvaluation:responseJson.Mcq_details.observerEvaluation,is_answered_all:responseJson.Mcq_details.is_answered_all,confidence_meter:responseJson.Mcq_details.confidence_meter,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.Mcq_details.evaluationMentor,evaluation_ecoach:responseJson.Mcq_details.evaluationEcoach,mentor_perform:responseJson.Mcq_details.mentorPerform,ecoach_perform:responseJson.Mcq_details.ecoachPerform,mentor_view:responseJson.Mcq_details.mentorView,ecoach_view:responseJson.Mcq_details.ecoachView})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true//alert('gott');
};this.props.switchback(sdd);}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',//type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',animation:false,cancelButtonColor:'#0082c9',confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,observerEvaluation:responseJson.Mcq_details.observerEvaluation,confidence_meter:responseJson.Mcq_details.confidence_meter,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.Mcq_details.evaluationMentor,evaluation_ecoach:responseJson.Mcq_details.evaluationEcoach,mentor_perform:responseJson.Mcq_details.mentorPerform,ecoach_perform:responseJson.Mcq_details.ecoachPerform,mentor_view:responseJson.Mcq_details.mentorView,ecoach_view:responseJson.Mcq_details.ecoachView})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this4=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.testcont,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{_this4.setState({componentStatus:"completed"});_this4.gotoresult();}});}},{key:'submittest',value:function submittest(cur_question_id){var _this5=this;var data=this.props.data;var isValid=true;if(this.state.confidence_meter==1&&this.state.testcont.allowskip==0){if(document.getElementById('notsure_'+cur_question_id).checked===true||document.getElementById('somewhatsure_'+cur_question_id).checked===true||document.getElementById('verysure_'+cur_question_id).checked===true){isValid=true;}else{isValid=false;$('#errorconfident_'+cur_question_id).css('display','block');}}/*else if(this.state.confidence_meter==1 && this.state.testcont.allowskip==1)
        {
            //let isValid = true;
            if(document.getElementById('notsure_'+cur_question_id).checked == true)
            {
                this.state.confidence_answer=document.getElementById('notsure_'+cur_question_id).value;
            }
            else if(document.getElementById('somewhatsure_'+cur_question_id).checked == true)
            {
                this.state.confidence_answer=document.getElementById('somewhatsure_'+cur_question_id).value;
            }
            else if(document.getElementById('verysure_'+cur_question_id).checked === true)
            {
                this.state.confidence_answer=document.getElementById('verysure_'+cur_question_id).value;
            }
            else
            {
                this.state.confidence_answer='';
            }
        }*/if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var frmaddobserver=$('#frm_mcq').serializeArray(),formData=new FormData();var productid_forrefresh=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('productID',true);var pinid_forrefresh=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('pinID',true);frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){//alert('1');
Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this5.backToComponentList();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{//alert('2');
_this5.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();if(responseJson.componentStatus=='completed'){//alert('3');
_this5.gotoresult();}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this5.setState({componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,is_answered_all:responseJson.is_answered_all});}else{setTimeout(function(){_this5.goback(responseJson.next_id);},200);}Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");//dhana
if(productid_forrefresh==372||pinid_forrefresh==1112||productid_forrefresh==481||pinid_forrefresh==1327||productid_forrefresh==365||pinid_forrefresh==1111){window.location.reload();}}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:''}))),this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this6=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this6.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg',defaultValue:mk.answered[r]})),mc.match_ans_type==4&&_this6.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:mk.fullanswer})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},mk.is_virtualkeyboard==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Virtualkeyboard__["a" /* default */],{qus_id:mk.question_id,validate:validationClass,chkonkeyup:function chkonkeyup(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},data_maxword:mk.openended_maxwords}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,id:'keyboard'+mk.question_id,className:validationClass,rows:'3',style:{height:"inherit",resize:"none"},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'render',value:function render(){var _this7=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed!=undefined&&testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';var confidence_meter=this.state.confidence_meter;checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.componentStatus==="incompleted"&&this.state.is_answered_all=='1'&&this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.isrepeatcomp=='Y'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Message:'),' You can repeat this test after completion. However, the score achieved in your first attempt will be your final score.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this7.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+testquestions.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt fleft qus-no'},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn fleft qus-txt',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:testquestions.img_width,izheight:testquestions.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this7.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlaopt'+index,className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'flaopt'+index,className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'ulaopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:qas.inserted_answer!=undefined?qas.inserted_answer:''}),' -'));}return _this7.getquestion(testquestions,qas,i+1,data.imagezoom);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions,data.imagezoom),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple,defaultValue:testquestions.fullanswer})),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length,defaultValue:testquestions.fullanswer}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(','),defaultValue:testquestions.answered}))))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Confidencemeter__["a" /* default */],{dynamic_confidence:testquestions.question_id,goback_confanswer:testquestions.confidence_gobk_ansers}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this7.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this7.goback(pre_question_id);}}))))),this.state.componentStatus==="incompleted"&&this.state.is_answered_all=='1'&&!this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox'},'You have already answered this component.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This component will get completed only when you choose Observer(s) to rate your answers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this7.continueToComplete();}})))))))));}}]);return Testonebyone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_13__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Testonebyone));

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var RepeatTestonebyone=function(_Component){_inherits(RepeatTestonebyone,_Component);function RepeatTestonebyone(props){_classCallCheck(this,RepeatTestonebyone);var _this=_possibleConstructorReturn(this,(RepeatTestonebyone.__proto__||Object.getPrototypeOf(RepeatTestonebyone)).call(this,props));_this.compeletestatus="";_this.state={testseqfields:[],componentStatus:_this.props.data.status,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",is_answered_all:0,resultthank:'',resultpage:false,totalscore:0,outofscore:0,is_performance:false,percentage:'',confidence_meter:''};return _this;}_createClass(RepeatTestonebyone,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getonebyonedet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,confidence_meter:responseJson.Mcq_details.confidence_meter,is_answered_all:responseJson.Mcq_details.is_answered_all});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;data.takerepeatable=1;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["k" /* hideleftbar */])();},400);}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/repeatgetprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submittest',value:function submittest(cur_question_id){var _this4=this;var data=this.props.data;var isValid=true;if(this.state.confidence_meter==1&&this.state.testcont.allowskip==0){if(document.getElementById('notsure_'+cur_question_id).checked===true||document.getElementById('somewhatsure_'+cur_question_id).checked===true||document.getElementById('verysure_'+cur_question_id).checked===true){isValid=true;}else{isValid=false;$('#errorconfident_'+cur_question_id).css('display','block');}}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var frmaddobserver=$('#frm_mcq').serializeArray(),formData=new FormData();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/repeatsavenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this4.backToComponentList();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this4.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();if(responseJson.componentStatus=='completed'){_this4.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage});}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this4.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage,componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,is_answered_all:responseJson.is_answered_all});}else{setTimeout(function(){_this4.goback(responseJson.next_id);},200);}Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}});}}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var seq_op=[];var optionText=[];var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';var resultpagecontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg'},'Successfully completed the Session.'),this.state.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box lr-yellow-box-repeat'},' You have scored ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.state.percentage!=''?this.state.percentage+'%':'0%',' (',(this.state.totalscore!=undefined?this.state.totalscore:'')+'/'+(this.state.outofscore!=undefined?this.state.outofscore:''),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this6.backToComponentList();}})))))))));var confidence_meter=this.state.confidence_meter;return this.state.resultpage?resultpagecontent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt fleft'},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn fleft',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:testquestions.img_width,izheight:testquestions.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'dlaopt'+index,className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'flaopt'+index,className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'ulaopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}return _this6.getquestion(testquestions,qas,i+1,data.imagezoom);}),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions,data.imagezoom),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple})),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(',')})))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Confidencemeter__["a" /* default */],{dynamic_confidence:testquestions.question_id}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.goback(pre_question_id);}}))))))))));}}]);return RepeatTestonebyone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_9__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null,mapDispatchToProps)(RepeatTestonebyone));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Timercount__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Virtualkeyboard__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Timevariabletest=function(_Component){_inherits(Timevariabletest,_Component);function Timevariabletest(props){_classCallCheck(this,Timevariabletest);var _this=_possibleConstructorReturn(this,(Timevariabletest.__proto__||Object.getPrototypeOf(Timevariabletest)).call(this,props));_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.compeletestatus="";_this.state={componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",testseqfields:[],time_left:'',time_state:0,is_answered_all:0,isrepeatcomp:'N',confidence_meter:''};return _this;}_createClass(Timevariabletest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettimevariable',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({isrepeatcomp:responseJson.isrepeatcomp,time_left:'',testseqfields:{'seconds':responseJson.time_left_seconds,'question_number':responseJson.Mcq_details.question_number},testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,is_answered_all:responseJson.Mcq_details.is_answered_all,confidence_meter:responseJson.Mcq_details.confidence_meter,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.Mcq_details.evaluationMentor,evaluation_ecoach:responseJson.Mcq_details.evaluationEcoach,mentor_perform:responseJson.Mcq_details.mentorPerform,ecoach_perform:responseJson.Mcq_details.ecoachPerform,mentor_view:responseJson.Mcq_details.mentorView,ecoach_view:responseJson.Mcq_details.ecoachView})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',// type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this4=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.testcont,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this4.props.getLearningRoom();// if (responseJson.isCompletedFully) {
//     this.goToThanksPage();
// } else {
// this.setState({
//     componentStatus: "completed"
// });
// alert(1);
_this4.gotoresult();//}
}});}},{key:'submittest',value:function submittest(cur_question_id){var _this5=this;var isValid=true;if(this.state.confidence_meter==1){if(document.getElementById('notsure_'+cur_question_id).checked===true||document.getElementById('somewhatsure_'+cur_question_id).checked===true||document.getElementById('verysure_'+cur_question_id).checked===true){isValid=true;}else{isValid=false;$('#errorconfident_'+cur_question_id).css('display','block');}}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this5.backToComponentList();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this5.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();if(responseJson.componentStatus=='completed'){_this5.gotoresult();}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this5.setState({componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:responseJson.is_answered_all});}else{setTimeout(function(){_this5.goback(responseJson.next_id);},200);}Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:'',controlsList:'nodownload'}))),this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this6=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tatement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this6.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tatement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg',defaultValue:mk.answered[r]})),mc.match_ans_type==4&&_this6.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:mk.fullanswer})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},mk.is_virtualkeyboard==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Virtualkeyboard__["a" /* default */],{qus_id:mk.question_id,validate:validationClass,chkonkeyup:function chkonkeyup(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},data_maxword:mk.openended_maxwords}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,id:'keyboard'+mk.question_id,className:validationClass,rows:'3',style:{height:"inherit",resize:"none"},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'opentest',value:function opentest(){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");this.setState({time_state:1});var vdf=this.state.testseqfields;this.setState({time_left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Timercount__["a" /* default */],{seconds:vdf.seconds,details:data,question_number:vdf.question_number,state:this.state.time_state})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},1000);}//   submitObserverandProceed(obj) {
//     const {data} = this.props;
//     reactLoader("show", "Please wait...");
//     fetch(domainUrl +"normal-test/observer-proceed", {
//       method: "POST",
//       headers: {
//         "Accept": "application/json",
//         "Content-Type": "application/json",
//         'Authorization':'Bearer ' +getTokenData()
//       },
//       body: JSON.stringify({
//         form_data: this.state.testcont,
//         observers: obj,
//         data: data
//       })
//     }).then((response) => response.json()).then((responseJson) => {
//       reactLoader("hide");
//       if (responseJson.status == 0) {
//         message("OOPS!", "Something went wrong. Please try again later.", "error");
//       }else {
//         this.setState({
//           componentStatus: "completed"
//         })
//       }
//     });
//   }
},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'render',value:function render(){var _this7=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';var confidence_meter=this.state.confidence_meter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.componentStatus==="incompleted"&&this.state.is_answered_all=='1'&&this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.isrepeatcomp=='Y'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Message:'),' You can repeat this test after completion. However, the score achieved in your first attempt will be your final score.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimedeg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-allot-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/timer.gif',width:'74',border:'0',height:'74'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tk-txt '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qc-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',null,'Questions completed: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.question_completed))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},'Time taken: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.time_left_hours_string!='00'?data.time_left_hours_string+' hrs':'',' ',data.time_left_mintues_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' mins'),' ',data.time_left_seconds_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' secs'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnroom',title:'Continue',type:'button',className:'Btgoback',value:'Continue',onClick:function onClick(e){return _this7.opentest();}})))),this.state.time_state!=0&&this.state.is_answered_all!=1&&this.state.time_left,this.state.time_state!=0&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this7.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+testquestions.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:testquestions.img_width,izheight:testquestions.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this7.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:qas.inserted_answer!=undefined?qas.inserted_answer:''}),' -'));}return _this7.getquestion(testquestions,qas,i+1,data.imagezoom);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions,data.imagezoom),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple,defaultValue:testquestions.fullanswer})),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length,defaultValue:testquestions.fullanswer}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(','),defaultValue:testquestions.answered}))))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Confidencemeter__["a" /* default */],{dynamic_confidence:testquestions.question_id}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this7.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this7.goback(pre_question_id);}})))),this.state.componentStatus==="incompleted"&&this.state.is_answered_all==1&&!this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox'},'You have already answered this component.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This component will get completed only when you choose Observer(s) to rate your answers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this7.continueToComplete();}})))))))));}}]);return Timevariabletest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_14__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Timevariabletest));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Timercount__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var RepeatTimevariabletest=function(_Component){_inherits(RepeatTimevariabletest,_Component);function RepeatTimevariabletest(props){_classCallCheck(this,RepeatTimevariabletest);var _this=_possibleConstructorReturn(this,(RepeatTimevariabletest.__proto__||Object.getPrototypeOf(RepeatTimevariabletest)).call(this,props));_this.compeletestatus="";_this.state={componentStatus:_this.props.data.status,evaluationPanel:false,testquestions:[],testcont:[],statusMessage:"",testseqfields:[],time_left:'',time_state:0,is_answered_all:0,resultthank:'',resultpage:false,totalscore:0,outofscore:0,is_performance:false,percentage:'',completetime:'',confidence_meter:''};return _this;}_createClass(RepeatTimevariabletest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettimevariable',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({time_left:'',testseqfields:{'seconds':0,'question_number':1},testcont:responseJson.Mcq_details,confidence_meter:responseJson.Mcq_details.confidence_meter,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/repeatgetprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submittest',value:function submittest(cur_question_id){var _this4=this;var isValid=true;//if(this.state.confidence_meter==1 && this.state.testcont.allowskip==0)
if(this.state.confidence_meter==1){if(document.getElementById('notsure_'+cur_question_id).checked===true||document.getElementById('somewhatsure_'+cur_question_id).checked===true||document.getElementById('verysure_'+cur_question_id).checked===true){isValid=true;}else{isValid=false;$('#errorconfident_'+cur_question_id).css('display','block');}}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});var timetakendata=$("#timer").html();formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/repeatsavenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this4.backToComponentList();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this4.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();if(responseJson.componentStatus=='completed'){// this.gotoresult();
_this4.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage,completetime:timetakendata});}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this4.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage,componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:responseJson.is_answered_all,completetime:timetakendata});}else{setTimeout(function(){_this4.goback(responseJson.next_id);},200);}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["k" /* hideleftbar */])();},400);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}});}}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:'',controlsList:'nodownload'}))),this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tatement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tatement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,className:validationClass,cols:'70',rows:'7',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords},mk.fullanswer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'opentest',value:function opentest(){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");this.setState({time_state:1});var vdf=this.state.testseqfields;this.setState({time_left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Timercount__["a" /* default */],{seconds:vdf.seconds,details:data,question_number:vdf.question_number,state:this.state.time_state,allowaddtimer:0})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},1000);}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';var resultpagecontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg'},'Successfully completed the Session.'),this.state.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box lr-yellow-box-repeat'},' You have scored ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.state.percentage!=''?this.state.percentage+'%':'0%',' (',(this.state.totalscore!=undefined?this.state.totalscore:'')+'/'+(this.state.outofscore!=undefined?this.state.outofscore:''),')'),this.state.completetime!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{style:{float:'right',background:'#2b93d8',color:'#fff',padding:'0px 20px',borderRadius:'5px'}},'Time taken : ',this.state.completetime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this6.backToComponentList();}})))))))));var confidence_meter=this.state.confidence_meter;return this.state.resultpage?resultpagecontent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimedeg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-allot-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/timer.gif',width:'74',border:'0',height:'74'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'0 auto'}},'Time Alloted:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},' 00',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' mins'),' 00',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' secs')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnroom',title:'Continue',type:'button',className:'Btgoback',value:'Continue',onClick:function onClick(e){return _this6.opentest();}}))),this.state.time_state!=0&&this.state.is_answered_all!=1&&this.state.time_left,this.state.time_state!=0&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:testquestions.img_width,izheight:testquestions.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}return _this6.getquestion(testquestions,qas,i+1,data.imagezoom);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions,data.imagezoom),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple})),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(',')})))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Confidencemeter__["a" /* default */],{dynamic_confidence:testquestions.question_id}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.goback(pre_question_id);}})))),this.state.componentStatus==="incompleted"&&this.state.is_answered_all==1&&!this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox'},'You have already answered this component.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This component will get completed only when you choose Observer(s) to rate your answers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this6.continueToComplete();}})))))))));}}]);return RepeatTimevariabletest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_10__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null,mapDispatchToProps)(RepeatTimevariabletest));

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Timecountdown__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Virtualkeyboard__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partials_AssessementViewList__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Fixedtimetest=function(_Component){_inherits(Fixedtimetest,_Component);function Fixedtimetest(props){_classCallCheck(this,Fixedtimetest);var _this=_possibleConstructorReturn(this,(Fixedtimetest.__proto__||Object.getPrototypeOf(Fixedtimetest)).call(this,props));_this.goToThanksPage=_this.goToThanksPage.bind(_this);_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.sback=_this.sback.bind(_this);_this.compeletestatus="";_this.state={componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,testquestions:[],testcont:[],statusMessages:"",testseqfields:[],time_left:'',time_state:0,is_answered_all:0,resultthank:'',isrepeatcomp:'N',confidence_meter:''};return _this;}_createClass(Fixedtimetest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettimevariable',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({isrepeatcomp:responseJson.isrepeatcomp,time_left:'',testseqfields:{'seconds':responseJson.time_left_seconds,'question_number':responseJson.Mcq_details.question_number},testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,is_answered_all:responseJson.Mcq_details.is_answered_all,confidence_meter:responseJson.Mcq_details.confidence_meter,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.Mcq_details.evaluationMentor,evaluation_ecoach:responseJson.Mcq_details.evaluationEcoach,mentor_perform:responseJson.Mcq_details.mentorPerform,ecoach_perform:responseJson.Mcq_details.ecoachPerform,mentor_view:responseJson.Mcq_details.mentorView,ecoach_view:responseJson.Mcq_details.ecoachView})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({//title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',//type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',animation:false,cancelButtonColor:'#0082c9',confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/getprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this4=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.testcont,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{_this4.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();// if (responseJson.isCompletedFully) {
//     this.goToThanksPage();
// } else {
// this.setState({
//     componentStatus: "completed"
// });
_this4.gotoresult();//}
}});}},{key:'submittest',value:function submittest(cur_question_id){var _this5=this;var isValid=true;if(this.state.confidence_meter==1&&this.state.testcont.allowskip==0){if(document.getElementById('notsure_'+cur_question_id).checked===true||document.getElementById('somewhatsure_'+cur_question_id).checked===true||document.getElementById('verysure_'+cur_question_id).checked===true){isValid=true;}else{isValid=false;$('#errorconfident_'+cur_question_id).css('display','block');}}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/savenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this5.backToComponentList();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this5.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();if(responseJson.componentStatus=='completed'){_this5.gotoresult();}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this5.setState({componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:responseJson.is_answered_all});}else{setTimeout(function(){_this5.goback(responseJson.next_id);},200);}Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}});}}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',defaultChecked:$.inArray(ans_opt.mcq_answer_id_pk,quest_det.answered)>=0,name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:''}))),this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this6=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this6.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:mk.answered[r]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this6.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:mk.fullanswer})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},mk.is_virtualkeyboard==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Virtualkeyboard__["a" /* default */],{qus_id:mk.question_id,validate:validationClass,chkonkeyup:function chkonkeyup(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},data_maxword:mk.openended_maxwords}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,id:'keyboard'+mk.question_id,className:validationClass,rows:'3',style:{height:"inherit",resize:"none"},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'sback',value:function sback(sdata){if(sdata.componentStatus=='completed'){this.gotoresult();}else{var evaluationPanel=sdata.componentStatus=="incompleted"?true:false;this.setState({componentStatus:sdata.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:sdata.is_answered_all});}//const {data}=this.props;
//this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'opentest',value:function opentest(){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");this.setState({time_state:1});var vdf=this.state.testseqfields;this.setState({time_left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Timecountdown__["a" /* default */],{seconds:vdf.seconds,details:data,question_number:vdf.question_number,state:this.state.time_state,tfs:this.sback,goToThanksPage:this.goToThanksPage})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},1000);}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this7=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"normal-test/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.testcont,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{_this7.setState({componentStatus:"completed"});_this7.gotoresult();}});}},{key:'render',value:function render(){var _this8=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';var confidence_meter=this.state.confidence_meter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.componentStatus==="incompleted"&&this.state.is_answered_all=='1'&&this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.isrepeatcomp=='Y'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxtbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Message:'),' You can repeat this test after completion. However, the score achieved in your first attempt will be your final score.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimedeg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ftime_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-allot-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/timer.gif",width:'74',border:'0',height:'74'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-cont-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-cont-box'},'Questions completed: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.question_completed),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Time taken: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-green'},data.time_left_mintues_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' mins'),' ',data.time_left_seconds_string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'normaltxt'},' secs'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-align'},'Time Alloted:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-red'},data.time_duration,' mins')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-divider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/divider.gif',width:'1',height:'54',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnroom',title:'Continue',type:'button',className:'Btgoback',value:'Continue',onClick:function onClick(e){return _this8.opentest();}})))),this.state.is_answered_all!=1&&this.state.time_left,this.state.time_state!=0&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+testquestions.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:testquestions.img_width,izheight:testquestions.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this8.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);},defaultValue:qas.inserted_answer!=undefined?qas.inserted_answer:''}),' -'));}return _this8.getquestion(testquestions,qas,i+1,data.imagezoom);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions,data.imagezoom),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple,defaultValue:testquestions.fullanswer})),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length,defaultValue:testquestions.fullanswer}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(','),defaultValue:testquestions.answered}))))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Confidencemeter__["a" /* default */],{dynamic_confidence:testquestions.question_id}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this8.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this8.goback(pre_question_id);}})))),this.state.componentStatus==="incompleted"&&this.state.is_answered_all=='1'&&!this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox'},'You have already answered this component.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This component will get completed only when you choose Observer(s) to rate your answers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this8.continueToComplete();}})))))))));}}]);return Fixedtimetest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_14__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Fixedtimetest));

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Timecountdown__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var RepeatFixedtimetest=function(_Component){_inherits(RepeatFixedtimetest,_Component);function RepeatFixedtimetest(props){_classCallCheck(this,RepeatFixedtimetest);var _this=_possibleConstructorReturn(this,(RepeatFixedtimetest.__proto__||Object.getPrototypeOf(RepeatFixedtimetest)).call(this,props));_this.goToThanksPage=_this.goToThanksPage.bind(_this);_this.sback=_this.sback.bind(_this);_this.compeletestatus="";_this.state={componentStatus:_this.props.data.status,evaluationPanel:false,testquestions:[],testcont:[],statusMessages:"",testseqfields:[],time_left:'',time_state:0,is_answered_all:0,resultthank:'',resultpage:false,totalscore:0,outofscore:0,is_performance:false,percentage:'',completetime:'',confidence_meter:''};return _this;}_createClass(RepeatFixedtimetest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/gettimevariable',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({time_left:'',testseqfields:{'seconds':responseJson.time_left_seconds,'question_number':1},testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions,confidence_meter:responseJson.Mcq_details.confidence_meter//is_answered_all: responseJson.Mcq_details.is_answered_all,
});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.compeletestatus=data.status;data.takerepeatable=1;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.compeletestatus=data.status;}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;var sdd={"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true};this.props.switchback(sdd);}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){var op_val='';switch(ans_opt.options){case'image':op_val=imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;break;case'audio':op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':op_val=this.video_frame(ans_opt.add_on_answer_video,'');break;default:op_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}return op_val;}},{key:'goback',value:function goback(pre_question_id){var _this3=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/repeatgetprevnxtdet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'pre_question_id':pre_question_id})}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({testcont:responseJson.Mcq_details,testquestions:responseJson.McqQuestions});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}},{key:'submittest',value:function submittest(cur_question_id){var _this4=this;var isValid=true;if(this.state.confidence_meter==1&&this.state.testcont.allowskip==0){if(document.getElementById('notsure_'+cur_question_id).checked===true||document.getElementById('somewhatsure_'+cur_question_id).checked===true||document.getElementById('verysure_'+cur_question_id).checked===true){isValid=true;}else{isValid=false;$('#errorconfident_'+cur_question_id).css('display','block');}}if(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;var formData=new FormData();var frmaddobserver=$('#frm_mcq').serializeArray();frmaddobserver.map(function(key,index){formData.append(key.name,key.value);});var timetakendata=$("#timer").html();formData.append('compseq_id',data.compseq_id);formData.append('learning_room_id',data.learning_room_id);formData.append('learner_id',data.learner_id);formData.append('dlr_id',data.dlr_id);formData.append('is_ag',data.is_ag);formData.append('divider_id',data.divider_id);formData.append('mcq_questionary_id',data.id);formData.append('question_id',cur_question_id);formData.append('question_number',this.state.testcont.question_number);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'normal-test/repeatsavenxt',{method:'POST',headers:{'Accept':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this4.backToComponentList();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this4.props.getLearningRoom();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();if(responseJson.componentStatus=='completed'){//this.gotoresult();
_this4.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage,completetime:timetakendata});}else if(responseJson.is_answered_all=='1'){var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this4.setState({resultpage:true,totalscore:responseJson.resultdata.total_score,outofscore:responseJson.resultdata.out_of_score,is_performance:responseJson.resultdata.performance,percentage:responseJson.resultdata.percentage,componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel,time_state:0,is_answered_all:responseJson.is_answered_all,completetime:timetakendata});}else{setTimeout(function(){_this4.goback(responseJson.next_id);},200);}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["k" /* hideleftbar */])();},400);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");}});}}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sfleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 8:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'mp3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'btn-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'record',className:'button recordButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-microphone'}),'Record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'stop',className:'button ply-btn'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}),' Complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',className:'uniquefilecls',name:'uniquefile',id:'uniquefile'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'widht-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio-btm',id:'audio',controls:''}))),this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this5=this;var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this5.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"40px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this5.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allowskip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,className:validationClass,cols:'70',rows:'7',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords},mk.fullanswer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'sback',value:function sback(sdata){if(sdata.componentStatus=='completed'){this.gotoresult();}else{var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["d" /* composcroll */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["k" /* hideleftbar */])();},400);}//const {data}=this.props;
//this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'opentest',value:function opentest(){var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");this.setState({time_state:1});var vdf=this.state.testseqfields;this.setState({time_left:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Timecountdown__["a" /* default */],{seconds:vdf.seconds,details:data,question_number:vdf.question_number,state:this.state.time_state,tfs:this.sback,goToThanksPage:this.goToThanksPage,allowaddtimer:0})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},1000);}},{key:'goToThanksPage',value:function goToThanksPage(){var data=this.props.data;this.props.returnthanks({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"thanks","look_before":data.compseq_id,"flowresult":true});}},{key:'render',value:function render(){var _this6=this;var data=this.state.testcont;var testquestions=this.state.testquestions;var index=1;var control_style={width:'50%'};var seq_op=[];var optionText=[],vcla=testquestions.is_hint_viewed>0?'block':'none';var cur_question_id=testquestions.question_id;var pre_question_id=data.pre_question_id;var answered=testquestions.answered;var checkboxRadioClass=data.allowskip==0?'required ':'',sequenceClass=data.allowskip==0?'required ':'',optionClass=data.allowskip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';var resultpagecontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.base_line?data.base_line:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg'},'Successfully completed the Session.'),this.state.is_performance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-yellow-box lr-yellow-box-repeat'},' You have scored ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.state.percentage!=''?this.state.percentage+'%':'0%',' (',(this.state.totalscore!=undefined?this.state.totalscore:'')+'/'+(this.state.outofscore!=undefined?this.state.outofscore:''),')'),this.state.completetime!=''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{style:{float:'right',background:'#2b93d8',color:'#fff',padding:'0px 20px',borderRadius:'5px'}},'Time taken : ',this.state.completetime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Continue',title:'Continue',className:'button_org',onClick:function onClick(){return _this6.backToComponentList();}})))))))));var confidence_meter=this.state.confidence_meter;return this.state.resultpage?resultpagecontent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:data.base_line?"title-box":"title-box tit-new"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Videocomponents',className:'ts_active_button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,data.mcq_name?data.mcq_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},data.base_line?data.base_line:'')),data.learner_msg!==""&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:data.learner_msg?data.learner_msg:''}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrol',id:'smana-scroll-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.is_answered_all!=1&&this.state.time_state==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testtimedeg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ftime_contbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-allot-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/timer.gif",width:'74',border:'0',height:'74'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'time-cont-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'0 auto'}},'Time Alloted:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'txt-red'},data.time_duration,'  mins')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'btnroom',title:'Continue',type:'button',className:'Btgoback',value:'Continue',onClick:function onClick(e){return _this6.opentest();}}))),this.state.is_answered_all!=1&&this.state.time_left,this.state.time_state!=0&&this.state.is_answered_all!=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq',key:'FTa'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'aT'+cur_question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'Ta'+cur_question_id,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border',key:'gTa'+cur_question_id},testquestions.hint_for_learner!=''&&testquestions.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+cur_question_id,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+testquestions.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',data.question_number,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:testquestions.mcq_question_name}}),testquestions.question_images!=undefined&&testquestions.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},data.imagezoom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:testquestions.img_width,izheight:testquestions.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:testquestions.img_width,height:testquestions.img_height}));}}),testquestions.question_audio!=undefined&&testquestions.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),testquestions.question_video!=undefined&&testquestions.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this6.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'your options are: ')),testquestions.question_option_answers!=undefined&&testquestions.question_option_answers.map(function(qas,i){if(testquestions.question_type==4){optionText.push(qas.options);}else if(testquestions.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+testquestions.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}return _this6.getquestion(testquestions,qas,i+1,data.imagezoom);}),testquestions.question_type==6&&this.openendquestions(testquestions),testquestions.question_type==7&&testquestions.mcq_match_filling!=undefined&&this.matchfillfun(testquestions,data.imagezoom),$.inArray(testquestions.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':testquestions.max_multiple})),testquestions.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_VoiceRecorder__["a" /* default */],{questionData:testquestions}),testquestions.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:testquestions.question_id+'_hidden',className:sequenceClass,'data-max-seq':testquestions.question_option_answers.length}))),testquestions.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:testquestions.question_id,className:optionClass,'data-options':optionText.join(',')})))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Confidencemeter__["a" /* default */],{dynamic_confidence:testquestions.question_id}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button bkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Next',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.submittest(cur_question_id);}}),data.question_number>1&&data.allowgoback>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'Btgoback',value:'Go Back',className:'Btgoback',type:'button',onClick:function onClick(e){return _this6.goback(pre_question_id);}}))))))))));}}]);return RepeatFixedtimetest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_10__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null,mapDispatchToProps)(RepeatFixedtimetest));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImageAudioTile__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecordPlayer__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var GridTile=function(_Component){_inherits(GridTile,_Component);function GridTile(props){_classCallCheck(this,GridTile);var _this=_possibleConstructorReturn(this,(GridTile.__proto__||Object.getPrototypeOf(GridTile)).call(this,props));_this.gridresponserange_fn=function(e,divorder){var restype=e.target.value;//1,2,3,4,5
//let applyrespclass = 'minor-img ' + ((restype === '1') ? 'five-row' : ((restype === '2') ? 'four-row' : ((restype === '3') ? 'three-row' : ((restype === '4') ? 'two-row' : 'one-row'))))
//changed as 5 to 3 point
// /alert(restype);
var applyrespclass='minor-img '+(restype==='1'?'five-row':restype==='2'?'three-row':'one-row');$('#maindiv'+divorder+' #grid_tile').attr('class',applyrespclass);};_this.state={subMitButton:"hide"};return _this;}// show grid responsively using range field (#gridresponserange)
_createClass(GridTile,[{key:'change_comp',value:function change_comp(id,comptype,grid_id,gridType){var _this2=this;var _props=this.props,data=_props.data,compData=_props.compData;$.each($('audio'),function(i,audio){audio.pause();audio.currentTime=0;});__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var request_data={comp_id:compData.id,learner_id:__WEBPACK_IMPORTED_MODULE_5__helpers_User__["a" /* UserId */](),compseq_id:compData.compseq_id,lroom_id:compData.learning_room_id,divider_id:compData.divider_id,dlrid:compData.dlr_id,comptype:comptype,grid_id:grid_id};fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"girdcomponent/next-component",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");var total_panels=$('div[id^="maindiv"]').length;var self=_this2;if(total_panels>0){if(total_panels-1==id){self.setState({subMitButton:"show"});}if(total_panels==1){self.setState({subMitButton:"show"});if($("#"+_this2.id).find(".button-accept").length>0){$("#"+_this2.id).find(".button-accept").show();}}if(total_panels!=id){$('div[id^="maindiv"]').each(function(){$(this).hide();if($("#"+this.id).find(".click-button").length>0){if($("#"+this.id).find(".click-button").hasClass("pin_up")){$("#"+this.id).find(".click-button").show();}else{$("#"+this.id).find(".click-button").hide();}}if($("#"+this.id).find(".button-accept").length>0){if($("#"+this.id).find(".button-accept").hasClass("pin_up")){$("#"+this.id).find(".button-accept").show();}else{$("#"+this.id).find(".button-accept").hide();}}});}$("div#maindiv"+id).show();}});}},{key:'submit',value:function submit(comptype,grid_id,gridType){var _this3=this;var _props2=this.props,data=_props2.data,compData=_props2.compData;var request_data={comp_id:compData.id,learner_id:__WEBPACK_IMPORTED_MODULE_5__helpers_User__["a" /* UserId */](),compseq_id:compData.compseq_id,lroom_id:compData.learning_room_id,divider_id:compData.divider_id,dlrid:compData.dlr_id,comptype:comptype,grid_id:grid_id};__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"girdcomponent/submit",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==2){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["w" /* scrollToTop */]();if(responseJson.isCompletedFully){_this3.props.goToThanksPage();}else{__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */]('Good Job!','You have successfully finished this component.','success');if(_this3.props.usableType=="webapp"){_this3.props.switchbackList();}}}else{// Common.message('','You already finished this component.','error');
_this3.props.switchbackList();}});}},{key:'componentDidMount',value:function componentDidMount(){var _this4=this;$(document).mouseup(function(e){if(!$('.detail-popup').is(e.target)&&$('.detail-popup').has(e.target).length===0&&!$('.dots-popup').is(e.target)&&$('.dots-popup').has(e.target).length===0){$('.detail-popup').slideUp('slow');}});setTimeout(function(){var total_panels=$('div[id^="maindiv"]').length;if(total_panels==1){_this4.setState({subMitButton:"show"});}},900);//click left menu grid change to full view
$(document).on('click','#leftmenuarrow',function(){$('#gridresponserange').val('1');$('#grid_tile').attr('class','minor-img five-row');});//audio player option div (slow/normal)
/* $(document).on('click', '.dotsof', function () {
             console.log($(this));
             $(this).next('.detail-popup').slideToggle('slow');
            
             
         })
         
         
        *///    $(window).click(function(event) {
//        console.log($(event.target).closest(".dots").length);
//            if($(event.target).closest(".dots").length == 0)
//            {
//             alert("dd");   
//            }
//        });
}},{key:'render',value:function render(){var _this5=this;var _props3=this.props,data=_props3.data,compData=_props3.compData,learningCompletedStatus=_props3.learningCompletedStatus;//const grmin = ($(window).width() <= 500) ? 4 : (($(window).width() <= 550) ? 3 : (($(window).width() <= 960) ? 2 : 1));
var grmin='';if($(window).width()==320){grmin=2;}else if($(window).width()<500){grmin=2;}else if($(window).width()==500){grmin=2;}else if($(window).width()<=960){grmin=2;}else{grmin=1;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grd-tails'},data.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,data.map(function(key,ind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:ind,id:'maindiv'+ind,style:{display:ind==0?'block':'none'}},key.type=='grid'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,key.gridData.major_desc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slidecontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'range',min:grmin,max:'3',defaultValue:'1',className:'slider',id:'gridresponserange',onChange:function onChange(e){return _this5.gridresponserange_fn(e,''+ind);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid-box'},key.gridData.minor_desc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid-img gridTile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'minor-img '+'five-row',id:'grid_tile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:5>key.tiles.length?'ajus_min_5tile':''},key.tiles.map(function(val,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'Li_'+i,id:'image'+val.data.tile_id_pk+'_'+ind},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ImageAudioTile__["a" /* default */],{key:'ImageAudioTile_'+i,index:ind,data:key,tileData:val,compData:compData,learningCompletedStatus:learningCompletedStatus}));})))),key.gridType=="Voice Practice"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RecordPlayer__["a" /* default */],{key:'record'+ind}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:"100%",textAlign:"center",marginTop:"30px",float:'left'}},_this5.state.subMitButton=="show"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Next',alt:'Go to next page',className:'button-accept custom-button-adj',onClick:function onClick(e){return _this5.submit(key.type,key.gridData.grid_id_pk,key.gridType);},style:{display:'none'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{display:ind==0&&key.type=='pin_up'?'':'none'},href:'javascript:void(0)',className:'click-button',onClick:function onClick(e){return _this5.change_comp(ind+1,key.type,key.gridData.grid_id_pk,key.gridType);}},'next'))),key.type=='pin_up'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-content'},key.comp_obj!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-bgs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btm-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'project-content-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,key.comp_obj.msg_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'align-cus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,key.comp_obj.msg_textarea))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:"100%",textAlign:"center",float:'left'}},_this5.state.subMitButton=="show"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Next',alt:'Go to next page',className:key.type=='pin_up'?'button-accept custom-button-adj pin_up':'button-accept custom-button-adj',onClick:function onClick(e){return _this5.submit(key.type,key.comp_obj.msg_id_pk,key.gridType);},style:{display:'none'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{display:key.type=='pin_up'?'':'none'},href:'javascript:void(0)',className:key.type=='pin_up'?'click-button pin_up':'click-button',onClick:function onClick(e){return _this5.change_comp(ind+1,key.type,key.comp_obj.msg_id_pk,key.gridType);}},'next')))));})));}}]);return GridTile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GridTile);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TilePlayer__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ImageAudioTile=function(_Component){_inherits(ImageAudioTile,_Component);function ImageAudioTile(props){_classCallCheck(this,ImageAudioTile);var _this=_possibleConstructorReturn(this,(ImageAudioTile.__proto__||Object.getPrototypeOf(ImageAudioTile)).call(this,props));_this.replayoption=function(id,aud1,aud2,type,grid_id,tile_id,tile_count,counter){_this.close_popup(id);_this.playaudio(id,aud1,aud2,type,grid_id,tile_id,tile_count,counter);};_this.state={answerBlock:"",gridAudio:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/girdtileaudio_files/'+props.tileData.gridAudio1,audio2:false,palayingrate:'1.0'};_this.DoSomething=_this.DoSomething.bind(_this);_this.handleUpdate=_this.handleUpdate.bind(_this);return _this;}//replay option
_createClass(ImageAudioTile,[{key:'playaudio',value:function playaudio(id,aud1,aud2,type,grid_id,tile_id,tile_count,counter){var _props=this.props,data=_props.data,tileData=_props.tileData,compData=_props.compData;$('input[type="button"]').addClass("button-accept");$('input[type="button"]').removeAttr('disabled');//change all border as default style
$('#grid_tile ul li').each(function(){$(this).css('border','3px solid #cccccc');});//change active li border color as blue
$('#image'+id).css('border','3px solid #1e7bc0');var comp_id=compData.id;var seqid=compData.compseq_id;var count=counter;$('span[id^="audios"]').show();$.each($('audio'),function(i,audio){audio.pause();audio.currentTime=0;});$('div[id^="wrap"]').hide();// $('div[id^="audio"]').hide();
$("div").not("#wrap"+id).removeClass('playing-part');var audio=document.getElementById('audios'+id);var wrap=document.getElementById('wrap'+id);$("#wrap"+id).show();$("#wrap"+id).addClass("playing-part");if(audio.style.display==='none'||audio.style.display==' '){audio.style.display='block';}else{audio.style.display='none';wrap.style.display='block';var freshaudio=document.getElementById('myaudio'+id);if(freshaudio!=null){//alert(freshaudio.duration);
//if (!isNaN(freshaudio.duration)) {
if(typeof freshaudio.duration=='number'){freshaudio.currentTime=0;var opt_value=document.getElementById("speed"+id);var selected_val=opt_value.options[opt_value.selectedIndex].value;freshaudio.playbackRate=this.state.palayingrate;freshaudio.play();if(type==1){var _compData=this.props.compData;var request_data={grid_id:grid_id,tile_id:tile_id,comp_id:_compData.id,learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */](),compseq_id:_compData.compseq_id,lroom_id:_compData.learning_room_id,divider_id:_compData.divider_id,dlrid:_compData.dlr_id,tile_count:tile_count};__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"girdcomponent/audio-insert",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");if($("a.click-button").length>0){$("a.click-button").show();}if($("input.button-accept").length>0){$("input.button-accept").show();}});}if(type==3){if($("a.click-button").length>0){$("a.click-button").show();}if($("input.button-accept").length>0){$("input.button-accept").show();}}}else{__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */]("Attention!","Audio file is missing.",'warning');}}}}},{key:'close_popup',value:function close_popup(id){$("#showDiv"+id).hide();$("#audios"+id).show();}},{key:'handleUpdate',value:function handleUpdate(rate){this.setState({palayingrate:rate});}},{key:'DoSomething',value:function DoSomething(id){var div=document.getElementById('showDiv'+id);$("#wrap"+id).hide();div.style.display='block';}},{key:'audio_two',value:function audio_two(id,aud1,aud2,value,grid_id,tile_id,row){var _props2=this.props,data=_props2.data,tileData=_props2.tileData,compData=_props2.compData,index=_props2.index,learningCompletedStatus=_props2.learningCompletedStatus;this.setState({gridAudio:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/girdtileaudio_files/'+aud2,audio2:true});setTimeout(function(){var Audio=document.getElementById('myaudio'+id);if(Audio!=null){if(!isNaN(Audio.duration)){Audio.src=__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/girdtileaudio_files/'+aud2;Audio.play();}}},100);__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var request_data={comp_id:compData.id,learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */](),compseq_id:compData.compseq_id,lroom_id:compData.learning_room_id,divider_id:compData.divider_id,dlrid:compData.dlr_id,grid_id:grid_id,value:value,tileData:tileData,tile_id:tile_id};fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"girdcomponent/mark-validations",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify(request_data)}).then(function(response){return response.json();}).then(function(responseJson){var response=responseJson;__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");// if(learningCompletedStatus!=null){
//
// }
if(response.data.score!=0){$("li#image"+id).addClass("pending");$("#showDiv"+id+" > p ").hide();$("#showDiv"+id+" > .btn-center ").hide();}else{$("li#image"+id).addClass("viewed");$("#showDiv"+id+" > p ").hide();$("#showDiv"+id+" > .btn-center ").hide();}if($("a.click-button").length>0){$("a.click-button").show();}if($("input.button-accept").length>0){$("input.button-accept").show();}});}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,data=_props3.data,tileData=_props3.tileData,compData=_props3.compData,index=_props3.index;var mainid=tileData.data.tile_id_pk+'_'+index;var id=''+compData.id+tileData.image_tile_count;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'grid_img',src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+'admin/girdtileimages/'+tileData.gridImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'grid-dummy-image',src:'images/dummy-img-of.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'audios'+tileData.data.tile_id_pk+'_'+index,className:'audio',onClick:function onClick(e){return _this2.playaudio(mainid,''+tileData.gridAudio1,''+tileData.gridAudio2,''+data.gridType_no,''+data.gridData.grid_id_pk,''+tileData.data.tile_id_pk,''+data.Tcount,''+data.counter);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TilePlayer__["a" /* default */],{wrapper_id:'wrap'+tileData.data.tile_id_pk+'_'+index,gridType:data.gridType,aud_file:this.state.gridAudio,audio2:this.state.audio2,mainid:mainid,onEnd:this.DoSomething,palayingrate:this.props.palayingrate,onUpdate:this.handleUpdate}),data.gridType=='Practice'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'play-part',id:'showDiv'+tileData.data.tile_id_pk+'_'+index,style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Is this correct? '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'click-yes',id:'click',onClick:function onClick(e){return _this2.audio_two(mainid,''+tileData.gridAudio1,''+tileData.gridAudio2,1,''+data.gridData.grid_id_pk,''+tileData.data.tile_id_pk,''+data.Tcount);}},'Yes'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'click-no',id:'click',onClick:function onClick(e){return _this2.audio_two(mainid,''+tileData.gridAudio1,''+tileData.gridAudio2,0,''+data.gridData.grid_id_pk,''+tileData.data.tile_id_pk,''+data.Tcount);}},'No')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reply-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Replay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'reply-btn-click',id:'click',onClick:this.replayoption.bind(this,mainid,''+tileData.gridAudio1,''+tileData.gridAudio2,''+data.gridType_no,''+data.gridData.grid_id_pk,''+tileData.data.tile_id_pk,''+data.Tcount,''+data.counter)}))));}}]);return ImageAudioTile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ImageAudioTile);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var TilePlayer=function(_Component){_inherits(TilePlayer,_Component);function TilePlayer(props){_classCallCheck(this,TilePlayer);var _this=_possibleConstructorReturn(this,(TilePlayer.__proto__||Object.getPrototypeOf(TilePlayer)).call(this,props));_this.state={palayingrate:'1.0'};return _this;}//customize audio speed normal and  slow 
_createClass(TilePlayer,[{key:'slow_normal_audio_fn',value:function slow_normal_audio_fn(id,rate){var Audio=document.getElementById("myaudio"+id);Audio.pause();Audio.currentTime=0;if(Audio!=null){if(!isNaN(Audio.duration)){Audio.playbackRate=rate;}}this.setState({palayingrate:rate});this.props.onUpdate(rate);if(rate==='1.0'){setTimeout(function(){$('#normal_'+id).hide();$('#slow_'+id).show();},500);}else{setTimeout(function(){$('#slow_'+id).hide();$('#normal_'+id).show();},500);}Audio.play();$('#detail-popup'+id).slideToggle('slow');}},{key:'audio_play',value:function audio_play(id,palyingrate){$('div[id^="pause_btn"]').removeClass("pause-icon-hover");$('div[id^="stop_btn"]').removeClass("stop-icon-hover");var Audio=document.getElementById('myaudio'+id);Audio.currentTime=0;if(Audio!=null){if(!isNaN(Audio.duration)){// let opt_value = document.getElementById("speed" + id);
// let selected_val = opt_value.options[opt_value.selectedIndex].value;
Audio.playbackRate=palyingrate;Audio.play();}}$("#play_btn"+id).addClass("play-icon-hover");}},{key:'pause_audio',value:function pause_audio(id){$('div[id^="play_btn"]').addClass("play-icon");$('div[id^="play_btn"]').removeClass("play-icon-hover");$('div[id^="stop_btn"]').removeClass("stop-icon-hover");var Audio=document.getElementById('myaudio'+id);if(Audio!=null){if(!isNaN(Audio.duration)){Audio.pause();}}$("#pause_btn"+id).addClass("pause-icon-hover");}},{key:'stop_audio',value:function stop_audio(aud_file,id){$('div[id^="play_btn"]').addClass("play-icon");$('div[id^="play_btn"]').removeClass("play-icon-hover");$('div[id^="pause_btn"]').removeClass("pause-icon-hover");var Audio=document.getElementById("myaudio"+id);if(Audio!=null){if(!isNaN(Audio.duration)){Audio.src=aud_file;Audio.pause();Audio.currentTime=0;}}$("#stop_btn"+id).addClass("stop-icon-hover");}},{key:'slow_audio',value:function slow_audio(id){var Audio=document.getElementById("myaudio"+id);if(Audio!=null){if(!isNaN(Audio.duration)){var opt_value=document.getElementById("speed"+id);var selected_val=opt_value.options[opt_value.selectedIndex].value;Audio.playbackRate=selected_val;}}}},{key:'onComplete',value:function onComplete(id){this.props.onEnd(id);}},{key:'doIdle',value:function doIdle(id){// $('#audios'+id).show();
// $('#wrap'+id).hide();
}},{key:'slownormalaudio',value:function slownormalaudio(id){$('#detail-popup'+id).slideToggle('slow');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,aud_file=_props.aud_file,mainid=_props.mainid,gridType=_props.gridType,audio2=_props.audio2,wrapper_id=_props.wrapper_id;var audio_mine="audio/mpeg";var ext=aud_file.split(".").pop();if(ext=="m4a"){audio_mine="audio/mp4";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:wrapper_id,className:'playing-part',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'detail-popup'+mainid,className:'detail-popup',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.slow_normal_audio_fn(mainid,'1.0');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'normal',id:'normal_'+mainid,style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Normal'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'no-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/play-button.png'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.slow_normal_audio_fn(mainid,'0.5');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slow',id:'slow_'+mainid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Slow'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'no-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/play-button.png'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dots-popup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dotsof',onClick:function onClick(e){return _this2.slownormalaudio(mainid);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dots'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'audio'+mainid,className:'audio_player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'play-icon-hover',id:'play_btn'+mainid,onClick:function onClick(e){return _this2.audio_play(mainid,_this2.state.palayingrate);},title:'play'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pause-icon',id:'pause_btn'+mainid,onClick:function onClick(e){return _this2.pause_audio(mainid);},title:'pause/play',style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{type:'button',id:'stop_btn'+mainid,onClick:function onClick(e){return _this2.stop_audio(aud_file,mainid);},className:'stop-icon',title:'stop',style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'speed'+mainid,id:'speed'+mainid,className:'speed',style:{width:"20px"},onChange:function onChange(e){return _this2.slow_audio(mainid);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1.0'},'Normal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0.5'},'Slowly'))),audio2==true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{id:'myaudio'+mainid,controls:true,controlsList:'nodownload',onEnded:function onEnded(e){return _this2.onComplete(mainid);},style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:aud_file,type:audio_mine})),audio2==false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{id:'myaudio'+mainid,onEnded:function onEnded(e){return gridType=='Practice'?_this2.onComplete(mainid):_this2.doIdle(mainid);},controls:true,controlsList:'nodownload',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:aud_file,type:audio_mine})));}}]);return TilePlayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TilePlayer);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Virtualkeyboard__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_SelectLearnerObserver__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_learningRoomAction__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_actiongoalAction__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Confidencemeter__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var BetTest=function(_Component){_inherits(BetTest,_Component);function BetTest(props){_classCallCheck(this,BetTest);var _this=_possibleConstructorReturn(this,(BetTest.__proto__||Object.getPrototypeOf(BetTest)).call(this,props));_this.submitObserverandProceed=_this.submitObserverandProceed.bind(_this);_this.state={videoTracks:[],componentStatus:_this.props.data.status,observerEvaluation:false,evaluationPanel:false,showChallengeSelect:false,showComponentVideo:false,testquestions:[],testcont:[],statusMessage:"",altText:"",mcqName:"",noOfQuestions:"",confidence_meter:"",learnerMsg:"",showBetQuestions:false,amountInHand:0,betType:'1',betTheme:'1',percentageList:[{text:"I can score 90% <br /> or more",value:970},{text:"75% or more, <br /> but less than 90%",value:663},{text:"65% or more, <br /> but less than 75%",value:335},{text:"55% or more, <br /> but less than 65%",value:150}]};return _this;}_createClass(BetTest,[{key:'getTestdetails',value:function getTestdetails(data){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'bet-test/gettestdetails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({data:data})}).then(function(response){return response.json();}).then(function(responseJson){var showChallengeSelect=responseJson.challengeAdded?false:true;_this2.setState({testquestions:responseJson.McqQuestions,testcont:responseJson.Mcq_details,betType:responseJson.Mcq_details.bet_type,betTheme:responseJson.Mcq_details.bet_theme,confidence_meter:responseJson.Mcq_details.confidence_meter,altText:responseJson.Mcq_details.alt_text,mcqName:responseJson.Mcq_details.mcq_name,noOfQuestions:responseJson.Mcq_details.no_of_questions,learnerMsg:responseJson.Mcq_details.learner_msg,amountInHand:responseJson.amountInHand,videoTracks:responseJson.videoTracks,observerEvaluation:responseJson.Mcq_details.observerEvaluation,showChallengeSelect:showChallengeSelect,showBetQuestions:responseJson.challengeAdded,statusMessage:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["b" /* ObserverEcoachMessage */])({evaluation_mentor:responseJson.Mcq_details.evaluationMentor,evaluation_ecoach:responseJson.Mcq_details.evaluationEcoach,mentor_perform:responseJson.Mcq_details.mentorPerform,ecoach_perform:responseJson.Mcq_details.ecoachPerform,mentor_view:responseJson.Mcq_details.mentorView,ecoach_view:responseJson.Mcq_details.ecoachView})});setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["B" /* showSmallLeftMenu */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);if(_this2.state.testcont.imagezoom){$(function(){$('[data-chittizoom]').chittizoom();});}});}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;this.getTestdetails(data);setTimeout(function(){$('audio').on("play",function(me){$('audio').each(function(i,e){if(e!==me.currentTarget){this.pause();}});});},500);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var data=nextProps.data;this.getTestdetails(data);}},{key:'backToComponentList',value:function backToComponentList(){var data=this.props.data;this.props.switchback('component_list',data.learning_room_id,data.dlr_id);}},{key:'gotoresult',value:function gotoresult(){var data=this.props.data;this.props.switchback({"status":"completed","learning_room_id":data.learning_room_id,"compseq_id":data.compseq_id,"divider_id":data.divider_id,"dlr_id":data.dlr_id,"learner_id":data.learner_id,"is_ag":data.is_ag,"id":data.id,"compo_type":"testresults","look_before":data.compseq_id,"flowresult":true,"is_betcomponent":data.is_betcomponent,"betallowcomp":'1'//confidence_answer:[], for post confident answer to api.
});}},{key:'continueToComplete',value:function continueToComplete(){this.setState({evaluationPanel:true});}},{key:'chooseScorePlan',value:function chooseScorePlan(e){$("#winingAmountTxt, #loseAmountTxt").text(0);$(".toggle").removeClass("active-color");$(e.currentTarget).addClass("active-color");this.refs.percentageIndex.value=e.currentTarget.dataset.id;this.refs.investAmount.value="";}},{key:'chooseScorePlanold',value:function chooseScorePlanold(e){if(e.target.checked){$("#winingAmountTxt, #loseAmountTxt").text(0);// $(".toggle").removeClass("active-color");
// $(e.currentTarget).addClass("active-color");
this.refs.percentageIndex.value=e.target.dataset.id;this.refs.investAmount.value="";}}},{key:'calculateAmount',value:function calculateAmount(evt){$("#winingAmountTxt, #loseAmountTxt").text(0);var investAmount=this.refs.investAmount.value.substring(0,6),amountInHand=this.refs.amountInHand.value*.25,percentageIndex=parseInt(this.refs.percentageIndex.value);if(isNaN(percentageIndex)){alert("Please choose above score plan and continue.");this.refs.investAmount.value="";}else if(investAmount>amountInHand){alert("Bet amount should not exceed 25% of cash in hand.");this.refs.investAmount.value="";}else if(this.refs.investAmount.value!==""){var percentageValue=this.state.percentageList[percentageIndex].value,winAmount=percentageValue*investAmount/100;$("#winingAmountTxt").text(winAmount);$("#loseAmountTxt").text(investAmount);this.refs.winAmount.value=winAmount;this.refs.loseAmount.value=investAmount;// We can't access refs on unrendered part. So set in state
this.setState({percentage_index:percentageIndex+1,invest_amount:investAmount,amount_in_hand:this.refs.amountInHand.value,win_amount:winAmount,lose_amount:investAmount});}}/* hide feb-4 2019
    showBetTestVideo() {
        if (runValidation()) {
            this.setState({
                showChallengeSelect: false,
                showComponentVideo: true
            })
        }
    }
    */},{key:'showBetTestVideo',value:function showBetTestVideo(){// console.log(runValidation());return false;
if(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Validation__["a" /* runValidation */])()){var betType=this.state.betType;this.setState({showChallengeSelect:false,showComponentVideo:betType===1?true:false//showComponentVideo:  true,
});if(betType===2)this.continueBetTest();}}},{key:'continueBetTest',value:function continueBetTest(){var _this3=this;var data=this.props.data;var ajaxData=JSON.stringify({data:data,percentage_index:this.state.percentage_index,invest_amount:this.state.invest_amount,amount_in_hand:this.state.amount_in_hand,win_amount:this.state.win_amount,lose_amount:this.state.lose_amount});Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'bet-test/add-bet',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:ajaxData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this3.setState({showComponentVideo:false,showBetQuestions:true});});}},{key:'hintopen',value:function hintopen(question_id,hint_reduce_per,hint_message){var data=this.props.data;window.swal({// title: 'Note',
text:'​Viewing the hint will reduce your score for this question by '+hint_reduce_per+'%',//type: 'warning',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'normal-test/addhintstatus',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({'data':data,'question_id':question_id,'hint_reduce_per':hint_reduce_per})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.result){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])('Hint!',hint_message,'info');$('.'+question_id).css('display','block');}setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["e" /* contentResizeLoad */])();Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");},200);});}});}},{key:'submittest',value:function submittest(){var _this4=this;var confidence=this.state.confidence_meter;var isValid=true;if(confidence==1){this.state.testquestions.map(function(mk,index){if(document.getElementById('notsure_'+mk.question_id).checked===true||document.getElementById('somewhatsure_'+mk.question_id).checked===true||document.getElementById('verysure_'+mk.question_id).checked===true){isValid=true;$('#errorconfident_'+mk.question_id).css('display','none');if(document.getElementById('somewhatsure_'+mk.question_id).checked==true){//alert('2');
//this.state.confidence_answer.push({'confidence_ans': document.getElementById('somewhatsure_'+mk.question_id).value})
//console.log(this.state.testquestions);
}if(document.getElementById('notsure_'+mk.question_id).checked==true){//alert('1');
//this.state.confidence_answer.push({'confidence_ans':document.getElementById('notsure_'+mk.question_id).value})
}if(document.getElementById('verysure_'+mk.question_id).checked==true){//alert('3');
//this.state.confidence_answer.push({'confidence_ans':document.getElementById('verysure_'+mk.question_id).value})
}}else{isValid=false;$('#errorconfident_'+mk.question_id).css('display','block');}});}if(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Validation__["a" /* runValidation */])()&&isValid){var data=this.props.data;var testForm=$("#frm_mcq").serializeArray(),formData=new FormData();testForm.map(function(val,index){formData.append(val.name,val.value);});console.log(data);formData.append("questions",JSON.stringify(this.state.testquestions));formData.append("data",JSON.stringify(data));Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+"bet-test/saveall",{method:"POST",headers:{"Accept":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this4.props.getLearningRoom();if(responseJson.componentStatus=='completed'){_this4.gotoresult();}else{var evaluationPanel=responseJson.componentStatus=="incompleted"?true:false;_this4.setState({componentStatus:responseJson.componentStatus,evaluationPanel:evaluationPanel});}}});}}},{key:'submitObserverandProceed',value:function submitObserverandProceed(obj){var _this5=this;var data=this.props.data;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+"normal-test/observer-proceed",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json",'Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({form_data:this.state.testcont,observers:obj,data:data})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])("OOPS!","Something went wrong. Please try again later.","error");}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["w" /* scrollToTop */])();_this5.props.getLearningRoom();_this5.gotoresult();}});}},{key:'getoptions',value:function getoptions(ans_opt,imagezoomopt){switch(ans_opt.options){case'image':return imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,izalt:'',izwidth:'150',izheight:'150'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+ans_opt.add_on_answer_image,alt:'',width:'150',height:'150'});break;case'audio':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+ans_opt.add_on_answer_audio,type:'audio/mpeg'}));break;case'video':return this.video_frame(ans_opt.add_on_answer_video,'');break;default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:ans_opt.options}});break;}}},{key:'submitbuttons',value:function submitbuttons(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'InActive',className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Submit',className:'button_org_inactive',type:'button',onClick:function onClick(e){return _this6.submittest();}}));}},{key:'getquestion',value:function getquestion(quest_det,ans_opt,i,imagezoomopt){var qty_val=[];var question_type=quest_det.question_type;var classnam=ans_opt.options=='video'?"vleft":'fleft';switch(question_type){case 1:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id+'_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 2:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id+'_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fleft'},i,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 3:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id+'_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["e" /* handleCheckbox */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;case 4:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id+'_'+i,className:'qleft testopt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'sleft'},this.getoptions(ans_opt,imagezoomopt)));break;case 5:qty_val=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+quest_det.question_id+'_'+i,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'flefts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:quest_det.question_id,onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["h" /* handleRadio */])(e);},value:ans_opt.mcq_answer_id_pk})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classnam},this.getoptions(ans_opt,imagezoomopt)));break;default:qty_val='';break;}return qty_val;}},{key:'matchfillfun',value:function matchfillfun(mk,imagezoomopt){var _this7=this;var validationClass=this.state.testcont.allow_skip==0?'required ':'';validationClass=validationClass+'sequence';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Match Set A with correct item in Set B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Key in the corresponding no. (1,2,3...) in the box provided'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-match-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'tbl-match'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'tbl-match-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Correct match from Set B')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SET B')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,mk.mcq_match_filling.map(function(mc,r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'matches_tr_'+r,className:'tbl-match-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ques_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ques_src),mc.match_ques_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ques_src,alt:'',width:'200',height:'200'})),mc.match_ques_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ques_src,type:'audio/mpeg'})),mc.match_ques_type==4&&_this7.video_frame(mc.match_ques_src,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:'txtbox matchtxt auto-focus',style:{width:"90px"},title:'Enter numeric input',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["b" /* autoFocusNext */])(e,'tr');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["i" /* handleSequence */])(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},r+1,'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'statement'},mc.match_ans_type==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,mc.match_ans_src),mc.match_ans_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,imagezoomopt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izsrc:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,izalt:'',izwidth:'200',izheight:'200'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+'/admin/test_image_files/'+mc.match_ans_src,alt:'',width:'200',height:'200'})),mc.match_ans_type==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+mc.match_ans_src,type:'audio/mpeg'})),mc.match_ans_type==4&&_this7.video_frame(mc.match_ans_src,'')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:validationClass,'data-max-seq':mk.mcq_match_filling.length,defaultValue:''})));}},{key:'video_frame',value:function video_frame(video_files,text){var data=this.props.data;var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,divider_id:data.divider_id,learner_id:data.learner_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/mp4",src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+'admin/test_video_files/'+video_files}]}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{key:video_files,playlist:playlist,trackData:trackData});}},{key:'openendquestions',value:function openendquestions(mk){var validationClass=this.state.testcont.allow_skip==0?'required ':'';validationClass=validationClass+'textbox_big word-count-check';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_'+mk.question_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'textbox_align1'},mk.is_virtualkeyboard==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Virtualkeyboard__["a" /* default */],{qus_id:mk.question_id,validate:validationClass,chkonkeyup:function chkonkeyup(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["c" /* countWords */])(e);},data_maxword:mk.openended_maxwords}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:mk.question_id,id:'keyboard'+mk.question_id,className:validationClass,rows:'3',style:{height:"inherit",resize:"none"},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':mk.openended_maxwords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: ',mk.openended_maxwords)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words'}))));}},{key:'render',value:function render(){var _this8=this;var seq_op=[],control_style={width:'50%'};var data=this.props.data;var imagezoomof=this.state.testcont.imagezoom;var percentageListHtml=this.state.betTheme==1?this.state.percentageList.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'percentList'+key,className:'serv-list'+(key+1)+' toggle','data-id':key,onClick:function onClick(e){return _this8.chooseScorePlan(e);},style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:val.text}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),' ',val.value));}):this.state.percentageList.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'percentList'+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cha-radio-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',id:'cah-radio'+(key+1),name:'radio-challenge','data-id':key,onChange:function onChange(e){return _this8.chooseScorePlanold(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'cah-radio'+(key+1)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:val.text}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},val.value));});var trackData={compseq_id:data.compseq_id,lroom_id:data.learning_room_id,learner_id:data.learner_id,divider_id:data.divider_id,dlr_id:data.dlr_id,compo_type:data.compo_type};var betVideoHtml=null;var confidence_meter=this.state.confidence_meter;//if (this.state.videoTracks.playlist != undefined) {
if(this.state.videoTracks.length!=0){betVideoHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lr-gray-box videogray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Flowplayer__["a" /* default */],{playlist:this.state.videoTracks,vcdata:data,trackData:trackData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));}var challengeHtml=this.state.betTheme==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'challenge-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/simp-log.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Challenge Setter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),'My Challenge for Quiz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-char'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'spec-head'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'serv-list'},percentageListHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'percentageIndex',className:'required'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'char-spec'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'new'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-pad'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/money-bag1.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.state.amountInHand),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'My Points')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-pad'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Enter the points which your are investing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'required invest digit',type:'text',placeholder:'I am investing',ref:'investAmount',maxLength:'6','data-maxvalue':this.state.amountInHand>0?this.state.amountInHand:'1000','data-minvalue':'1',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return _this8.calculateAmount(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'If I meet my challenge the points I will win is '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/ctick.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'winingAmountTxt'},'0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'If I don\'t meet my challenge, the points I will lose is '),' \xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/cwrong.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'loseAmountTxt'},'0')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'OK',className:'submit',onClick:function onClick(){return _this8.showBetTestVideo();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'amountInHand',value:this.state.amountInHand}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'winAmount'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'loseAmount'}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'challenge-blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'challenge-blue-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'You are now going to SET A CHALLENGE for yourself for next 10 quiz(zes). Follow the steps:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'setp1-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'head-step'},'STEP 01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Choose a challenge from below.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{'width':'52%'}},'My Challenge for 10 Quiz (zes)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Winning amount for every 50 points invested ')),percentageListHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'percentageIndex',className:'required'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/cha-money-ico.png'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Money at hand: ',this.state.amountInHand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step2-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step2-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step2-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'head-step'},'STEP 02'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Enter the amont you are ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'investing on the challenge.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'red-bg form-investing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Enter the investing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'required invest digit',type:'text',placeholder:'I am investing',ref:'investAmount',maxLength:'6','data-maxvalue':this.state.amountInHand>0?this.state.amountInHand:'1000','data-minvalue':'1',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return _this8.calculateAmount(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'nxt-redbg'},'If I meet my challenge, the amount I will win is'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'winingAmountTxt',className:'red-bg info'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'nxt-redbg'},'If I don\'t meet my challenge, the amount I will lose is'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loseAmountTxt',className:'red-bg info'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'OK',className:'submit',onClick:function onClick(){return _this8.showBetTestVideo();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'amountInHand',value:this.state.amountInHand}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'winAmount'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',ref:'loseAmount'})));var questionHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},this.state.componentStatus==="incompleted"&&this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__partials_ThanksMessage__["a" /* default */],{message:this.state.statusMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__partials_SelectLearnerObserver__["a" /* default */],{submitObserverandProceed:this.submitObserverandProceed})),this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_mcq',id:'frm_mcq'},this.state.testquestions.map(function(mk,index){var optionText=[],vcla=mk.is_hint_viewed>0?'block':'none';var checkboxRadioClass=mk.allow_skip==0?'required ':'',sequenceClass=mk.allow_skip==0?'required ':'',optionClass=mk.allow_skip==0?'required ':'';checkboxRadioClass=checkboxRadioClass+'max-select-check';sequenceClass=sequenceClass+'sequence';optionClass=optionClass+'with-in-options txtbox fillupstxt';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'a'+index,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox_border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},mk.hint_for_learner!=''&&mk.hint_for_learner!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'hint'+index,className:'test-hint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.hintopen(mk.question_id,mk.hint_reduce_per,mk.hint_for_learner);},title:'\u200BViewing the hint will reduce your score for this question by '+mk.hint_reduce_per+'%'},'Hint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:vcla},key:'hv'+index,className:'hint-viewed '+mk.question_id,title:'You have already viewed hint for this question'},'Viewed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blwetxt',style:{float:"left"}},'Q',index+1,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:mk.mcq_question_name}}),mk.question_images.map(function(val,index){if(val!=''&&val!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'imageq'+index,className:'qleft'},imagezoomof?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Imagezoom__["a" /* default */],{izkey:'img_'+index,izsrc:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,izalt:'',izwidth:mk.img_width,izheight:mk.img_height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'img_'+index,src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_image_files/"+val,alt:'',width:mk.img_width,height:mk.img_height}));}}),mk.question_audio.map(function(aval,aindex){if(aval!=''&&aval!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'auq'+index,className:'qleft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{key:'audio_'+aindex,controls:true,controlsList:'nodownload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+"admin/test_audio_files/"+aval,type:'audio/mpeg'})));}}),mk.question_video.map(function(vval,vindex){if(vval!=''&&vval!=undefined){return _this8.video_frame(vval,'');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'aopt'+index},mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Your options are: ')),mk.question_option_answers.map(function(qas,i){if(mk.question_type==4){optionText.push(qas.options);}else if(mk.question_type==2){seq_op.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'span_'+i+'_'+index,className:'seq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:''+mk.question_id,className:'seq_txtbox auto-focus',maxLength:'2',onKeyPress:function onKeyPress(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["a" /* allowOnlyNumberInput */])(e);},onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["b" /* autoFocusNext */])(e,'.seq-container');},onBlur:function onBlur(e){return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["i" /* handleSequence */])(e);}}),' -'));}return _this8.getquestion(mk,qas,i+1,imagezoomof);}),mk.question_type==6&&_this8.openendquestions(mk),mk.question_type==7&&_this8.matchfillfun(mk,imagezoomof),$.inArray(mk.question_type,[1,3,5])>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:checkboxRadioClass,'data-max-option':mk.max_multiple,defaultValue:''}))),mk.question_type==8&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_VoiceRecorder__["a" /* default */],{questionData:mk}),mk.question_type==2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,seq_op,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'(Eg: 4 - 3 - 1 - 2.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:mk.question_id+'_hidden',className:sequenceClass,'data-max-seq':mk.question_option_answers.length,defaultValue:''}))),mk.question_type==4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'integratestsmalltxt'},'Ans:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:mk.question_id,className:optionClass,'data-options':optionText.join(',')}))))),confidence_meter==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Confidencemeter__["a" /* default */],{dynamic_confidence:mk.question_id}):''));}),this.submitbuttons()),this.state.componentStatus==="incompleted"&&!this.state.evaluationPanel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratebox'},'You have already answered this component.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'This component will get completed only when you choose Observer(s) to rate your answers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this8.continueToComplete();}}))),this.state.componentStatus==="completed"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button_org',value:'Continue',title:'Continue',onClick:function onClick(){return _this8.backToComponentList();}}))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon-box ts_complete_button',title:this.state.altText}),this.state.mcqName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},'Number of Questions : ',this.state.noOfQuestions)),this.state.componentStatus===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",padding:"10px 0px 10px 0px",marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editortxt',dangerouslySetInnerHTML:{__html:this.state.learnerMsg}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.showChallengeSelect&&challengeHtml,this.state.showComponentVideo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,betVideoHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-react-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Continue',onClick:function onClick(){return _this8.continueBetTest();}}))),this.state.showBetQuestions&&questionHtml))))));}}]);return BetTest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({getLearningRoom:__WEBPACK_IMPORTED_MODULE_12__actions_learningRoomAction__["a" /* getLearningRoom */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(null,mapDispatchToProps)(BetTest));

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tinymce__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_collapsible__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_collapsible__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var jQuery=window.jQuery;var WritingNotePad=function(_Component){_inherits(WritingNotePad,_Component);function WritingNotePad(props){_classCallCheck(this,WritingNotePad);var _this=_possibleConstructorReturn(this,(WritingNotePad.__proto__||Object.getPrototypeOf(WritingNotePad)).call(this,props));var type="LR";if(props.dlr_id>0){type="DLR";}_this.state={dlr_count:0,title:"",notes_id:0,editorcontent:"",lr_mynotes:[],dlr_mynotes:[],heading_name:"",lr_id:props.lr_id,dlr_id:props.dlr_id,lr_type:type,actionType:"ADD"};_this.handleEditorChange=_this.handleEditorChange.bind(_this);_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(WritingNotePad,[{key:'updateScrollinner5',value:function updateScrollinner5(){var $scrollbarin5=jQuery('#semana-scroll-inner5');$scrollbarin5.tinyscrollbar();var scrollbarin5=$scrollbarin5.data("plugin_tinyscrollbar");if(scrollbarin5){scrollbarin5.update("relative");}}},{key:'updateScrollinner6',value:function updateScrollinner6(){var $scrollbarin6=jQuery('#semana-scroll-inner6');$scrollbarin6.tinyscrollbar();var scrollbarin6=$scrollbarin6.data("plugin_tinyscrollbar");if(scrollbarin6){scrollbarin6.update("relative");}}},{key:'popup_close',value:function popup_close(){win.swal({//title: "Have you saved your notes?",
text:"Have you saved your notes?",// text: "You will not be able to recover this imaginary file!",
//type: "warning",
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',confirmButtonText:"OK",// cancelButtonText: "Skip",
closeOnConfirm:true,animation:false,closeOnCancel:true}).then(function(result){if(result){// sa-icon sa-warning pulseWarning
jQuery('.sa-icon').css("display","none");jQuery('#popup2').css("display","none");jQuery('.modal-overlay').css("display","none");return true;}else{jQuery('.sa-icon').css("display","none");return false;}});}},{key:'minimize',value:function minimize(){jQuery('#popup2').css({height:'30px',width:'300px',overflow:'hidden',transform:'rotate(360deg)','-webkit-transform':'rotate(360deg)','-moz-transform':'rotate(360deg)','-o-transform':'rotate(360deg)',position:'fixed',transition:' all ease .4s','-webkit-transition':'all ease .4s','-moz-transition':'all ease .4s','-o-transition':'all ease .4s'});}},{key:'maximize',value:function maximize(){jQuery('#popup2').css({top:'20px',display:'block',left:'25%',height:'auto',width:'56%',overflow:'unset',transform:'unset','-webkit-transform':'unset','-moz-transform':'unset','-o-transform':'unset',position:'absolute'});// jQuery('#popup2').show();
}},{key:'editInfo',value:function editInfo(data,heading_name){//console.log(data);
//data.notes
this.setState({notes_id:data.notes_id_pk,heading_name:heading_name,editorcontent:data.notes,title:data.notes_title,lr_id:this.state.lr_id,dlr_id:this.state.dlr_id,lr_type:this.state.lr_type,actionType:"EDIT"});if(win.tinymce.get(this.refs.noteseditor.id)){win.tinymce.get(this.refs.noteseditor.id).setContent(data.notes);}}},{key:'getLeftInfo',value:function getLeftInfo(){var _this2=this;var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var _props=this.props,name=_props.name,lr_id=_props.lr_id,dlr_id=_props.dlr_id;this.setState({heading_name:"",title:"",editorcontent:"",actionType:"ADD",lr_id:lr_id,dlr_id:dlr_id});var learnerID=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */]("id",true);var pinID=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */]("pinID",true);var productID=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */]("productID",true);var pinNo=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */]("pinNo",true);var corporateID=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */]("corporateID",true);fetch(__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+'writing-pad/get-info',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,pinID:pinID,productID:productID,pinNo:pinNo,corporateID:corporateID})}).then(function(response){return response.json();}).then(function(responseJson){var data=responseJson.data;_this2.setState({dlr_count:data.dlr_count,lr_mynotes:data.lr_mynotes,dlr_mynotes:data.dlr_mynotes,heading_name:name});if(window.tinymce.get(_this2.refs.noteseditor.id)){window.tinymce.get(_this2.refs.noteseditor.id).setContent("");}if(action==""){//jQuery(".accordion_coach1").smk_Accordion().init();
$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});}});}},{key:'handleEditorChange',value:function handleEditorChange(e){this.setState({editorcontent:e.target.getContent()});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'saveNotes',value:function saveNotes(){var _this3=this;var url=__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+'writing-pad/save-notes';var learnerID=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["i" /* getUserData */]("id",true);__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(url,{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,title:this.state.title,editorcontent:this.state.editorcontent,lr_id:this.state.lr_id,dlr_id:this.state.dlr_id,lr_type:this.state.lr_type,actionType:this.state.actionType,room_id:this.state.lr_type=="LR"?this.state.lr_id:this.state.dlr_id,notes_id:this.state.notes_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["o" /* message */](responseJson.message,'Notes saved successfully.','success');_this3.getLeftInfo("Edit");}});}},{key:'create_notes',value:function create_notes(){var _props2=this.props,name=_props2.name,lr_id=_props2.lr_id,dlr_id=_props2.dlr_id;this.setState({heading_name:name,title:"",editorcontent:"",actionType:"ADD",lr_id:lr_id,dlr_id:dlr_id});if(window.tinymce.get(this.refs.noteseditor.id)){window.tinymce.get(this.refs.noteseditor.id).setContent("");}}},{key:'componentDidMount',value:function componentDidMount(){var self=this;var appendthis="<div class='modal-overlay js-modal-close'></div>";jQuery('a[data-modal-id]').click(function(e){e.preventDefault();jQuery("body").append(appendthis);jQuery(".modal-overlay").fadeTo(500,0.7);//$(".js-modalbox").fadeIn(500);
var modalBox=jQuery(this).attr('data-modal-id');jQuery('#'+modalBox).fadeIn(jQuery(this).data());self.getLeftInfo();});jQuery(".js-modal-close, .modal-overlay").click(function(){jQuery(".modal-box, .modal-overlay").fadeOut(500,function(){jQuery(".modal-overlay").remove();});});jQuery(window).resize(function(){jQuery(".modal-box").css({top:20,//(jQuery(window).height() - jQuery(".modal-box").outerHeight()) / 2,
left:(jQuery(window).width()-jQuery(".modal-box").outerWidth())/2});});jQuery(window).resize();var $scrollbarin5=jQuery('#semana-scroll-inner5');$scrollbarin5.tinyscrollbar();var $scrollbarin6=jQuery('#semana-scroll-inner6');$scrollbarin6.tinyscrollbar();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var type="LR";if(nextProps.dlr_id>0){type="DLR";}this.setState({lr_id:nextProps.lr_id,dlr_id:nextProps.dlr_id,lr_type:type});}},{key:'goTonotes',value:function goTonotes(type){var _props3=this.props,name=_props3.name,lr_id=_props3.lr_id,dlr_id=_props3.dlr_id;this.props.notesList(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this4=this;var _props4=this.props,name=_props4.name,lr_id=_props4.lr_id,dlr_id=_props4.dlr_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'popup2',style:{top:'20px',left:'297px',display:'none'},className:'modal-box popup-ecoach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.popup_close();},title:'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/cloze.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.minimize();},title:'Minimize',className:'',style:{marginRight:"35px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/min.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.maximize();},title:'Maximize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/max.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'write-pad-tiltle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/wiriting-pad-icon.png',border:'0'}),' Writing Pad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body popup-grey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'writing-pad-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'writing-pad-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pad-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'LR'),this.state.dlr_count>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'DLR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_coach1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner5',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},this.state.lr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},this.state.lr_mynotes.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_collapsible___default.a,{key:'notes_lr_main_'+i,trigger:'LR-'+key.lr_name},key.notes!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,key.notes.map(function(value,inc){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'notes_lr_title_'+inc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.editInfo(value,'LR-'+key.lr_name);}},value.notes_title));}))));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_coach1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner6',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},this.state.dlr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},this.state.dlr_mynotes.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_collapsible___default.a,{key:'notes_dlr_main_'+i,trigger:'DLR-'+key.lr_name},key.notes!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,key.notes.map(function(value,inc){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'notes_dlr_title_'+inc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.editInfo(value,'DLR-'+key.lr_name);}},value.notes_title));}))));}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pad-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pad-right-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'cat_head_rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'learning_room_title'},this.state.heading_name!=""?this.state.heading_name:name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'padtag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'title',id:'notes_title',onChange:this.handleChange,value:this.state.title,placeholder:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'div_notes_title',className:'error'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tinymce___default.a,{ref:'noteseditor',content:this.state.editorcontent,config:{menubar:false,plugins:'autolink link image lists print preview',toolbar:'bold italic | alignleft aligncenter alignright',branding:false},onChange:this.handleEditorChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'div_writing_txtarea',className:'error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',style:{padding:"0px 10px",fontSize:"15px",backgroundColor:"#d24d57",border:"medium none",width:"auto"},onClick:function onClick(e){return _this4.saveNotes();},value:'SAVE NOTES'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'writing-pad-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.create_notes();},value:'Create New Notes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.goTonotes('seek_notes');},value:'Seek Notes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.goTonotes('sharek_notes');},value:'Share Notes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.goTonotes('share_requests');},value:'Share Requests'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.goTonotes('all_notes');},value:'All Notes'})));}}]);return WritingNotePad;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WritingNotePad);

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(24);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _lodashIsEqual = __webpack_require__(599);

var _lodashIsEqual2 = _interopRequireDefault(_lodashIsEqual);

var _lodashClone = __webpack_require__(649);

var _lodashClone2 = _interopRequireDefault(_lodashClone);

var _helpersUuid = __webpack_require__(669);

var _helpersUuid2 = _interopRequireDefault(_helpersUuid);

var _helpersUcFirst = __webpack_require__(670);

var _helpersUcFirst2 = _interopRequireDefault(_helpersUcFirst);

// Include all of the Native DOM and custom events from:
// https://github.com/tinymce/tinymce/blob/master/tools/docs/tinymce.Editor.js#L5-L12
var EVENTS = ['focusin', 'focusout', 'click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'beforepaste', 'paste', 'cut', 'copy', 'selectionchange', 'mouseout', 'mouseenter', 'mouseleave', 'keydown', 'keypress', 'keyup', 'contextmenu', 'dragend', 'dragover', 'draggesture', 'dragdrop', 'drop', 'drag', 'BeforeRenderUI', 'SetAttrib', 'PreInit', 'PostRender', 'init', 'deactivate', 'activate', 'NodeChange', 'BeforeExecCommand', 'ExecCommand', 'show', 'hide', 'ProgressState', 'LoadContent', 'SaveContent', 'BeforeSetContent', 'SetContent', 'BeforeGetContent', 'GetContent', 'VisualAid', 'remove', 'submit', 'reset', 'BeforeAddUndo', 'AddUndo', 'change', 'undo', 'redo', 'ClearUndos', 'ObjectSelected', 'ObjectResizeStart', 'ObjectResized', 'PreProcess', 'PostProcess', 'focus', 'blur', 'dirty'];

// Note: because the capitalization of the events is weird, we're going to get
// some inconsistently-named handlers, for example compare:
// 'onMouseleave' and 'onNodeChange'
var HANDLER_NAMES = EVENTS.map(function (event) {
  return 'on' + (0, _helpersUcFirst2['default'])(event);
});

var TinyMCE = (0, _createReactClass2['default'])({
  displayName: 'TinyMCE',

  propTypes: {
    config: _propTypes2['default'].object,
    content: _propTypes2['default'].string,
    id: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    name: _propTypes2['default'].string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      config: {},
      content: ''
    };
  },

  componentWillMount: function componentWillMount() {
    this.id = this.id || this.props.id || (0, _helpersUuid2['default'])();
  },

  componentDidMount: function componentDidMount() {
    var config = (0, _lodashClone2['default'])(this.props.config);
    this._init(config, this.props.content);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (!(0, _lodashIsEqual2['default'])(this.props.config, nextProps.config) || !(0, _lodashIsEqual2['default'])(this.props.id, nextProps.id)) {
      this.id = nextProps.id;
      this._init((0, _lodashClone2['default'])(nextProps.config), nextProps.content);
      return;
    }

    // TODO: This will fix problems with keeping internal state, but causes problems with cursor placement
    // if (!isEqual(this.props.content, nextProps.content)) {
    //   const editor = tinymce.EditorManager.get(this.id);
    //   editor.setContent(nextProps.content);
    //
    //   editor.selection.select(editor.getBody(), true);
    //   editor.selection.collapse(false);
    // }
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    return !(0, _lodashIsEqual2['default'])(this.props.config, nextProps.config);
  },

  componentWillUnmount: function componentWillUnmount() {
    this._remove();
  },

  render: function render() {
    return this.props.config.inline ? _react2['default'].createElement('div', {
      id: this.id,
      className: this.props.className,
      dangerouslySetInnerHTML: { __html: this.props.content }
    }) : _react2['default'].createElement('textarea', {
      id: this.id,
      className: this.props.className,
      name: this.props.name,
      defaultValue: this.props.content
    });
  },

  _init: function _init(config, content) {
    var _this = this;

    if (this._isInit) {
      this._remove();
    }

    // hide the textarea that is me so that no one sees it
    (0, _reactDom.findDOMNode)(this).style.hidden = 'hidden';

    var setupCallback = config.setup;
    var hasSetupCallback = typeof setupCallback === 'function';

    config.selector = '#' + this.id;
    config.setup = function (editor) {
      EVENTS.forEach(function (eventType, index) {
        editor.on(eventType, function (e) {
          var handler = _this.props[HANDLER_NAMES[index]];
          if (typeof handler === 'function') {
            // native DOM events don't have access to the editor so we pass it here
            handler(e, editor);
          }
        });
      });
      // need to set content here because the textarea will still have the
      // old `this.props.content`
      if (typeof content !== 'undefined') {
        editor.on('init', function () {
          editor.setContent(content);
        });
      }
      if (hasSetupCallback) {
        setupCallback(editor);
      }
    };

    tinymce.init(config);

    (0, _reactDom.findDOMNode)(this).style.hidden = '';

    this._isInit = true;
  },

  _remove: function _remove() {
    tinymce.EditorManager.execCommand('mceRemoveEditor', true, this.id);
    this._isInit = false;
  }
});

// add handler propTypes
HANDLER_NAMES.forEach(function (name) {
  TinyMCE.propTypes[name] = _propTypes2['default'].func;
});

module.exports = TinyMCE;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(156);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(157),
    equalArrays = __webpack_require__(277),
    equalByTag = __webpack_require__(634),
    equalObjects = __webpack_require__(637),
    getTag = __webpack_require__(103),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(101),
    isTypedArray = __webpack_require__(165);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(97);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 607 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 608 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 609 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(97),
    Map = __webpack_require__(158),
    MapCache = __webpack_require__(160);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(159),
    isMasked = __webpack_require__(614),
    isObject = __webpack_require__(31),
    toSource = __webpack_require__(276);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(60);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 613 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(615);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(28);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 616 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(618),
    ListCache = __webpack_require__(97),
    Map = __webpack_require__(158);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(619),
    hashDelete = __webpack_require__(620),
    hashGet = __webpack_require__(621),
    hashHas = __webpack_require__(622),
    hashSet = __webpack_require__(623);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(100);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(160),
    setCacheAdd = __webpack_require__(630),
    setCacheHas = __webpack_require__(631);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(60),
    Uint8Array = __webpack_require__(278),
    eq = __webpack_require__(70),
    equalArrays = __webpack_require__(277),
    mapToArray = __webpack_require__(635),
    setToArray = __webpack_require__(636);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 635 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 636 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(279);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    isLength = __webpack_require__(166),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(168),
    nativeKeys = __webpack_require__(644);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(283);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(284);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(73),
    keys = __webpack_require__(71);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(73),
    keysIn = __webpack_require__(170);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31),
    isPrototype = __webpack_require__(168),
    nativeKeysIn = __webpack_require__(653);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(28);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)(module)))

/***/ }),
/* 655 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(73),
    getSymbols = __webpack_require__(162);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(73),
    getSymbolsIn = __webpack_require__(288);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(171),
    cloneDataView = __webpack_require__(660),
    cloneRegExp = __webpack_require__(661),
    cloneSymbol = __webpack_require__(662),
    cloneTypedArray = __webpack_require__(663);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(171);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(60);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(171);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(290),
    getPrototype = __webpack_require__(104),
    isPrototype = __webpack_require__(168);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(666),
    baseUnary = __webpack_require__(102),
    nodeUtil = __webpack_require__(167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(103),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(668),
    baseUnary = __webpack_require__(102),
    nodeUtil = __webpack_require__(167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(103),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var count = 0;
module.exports = function uuid() {
  return 'react-tinymce-' + count++;
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ucFirst;

function ucFirst(str) {
  return str[0].toUpperCase() + str.substring(1);
}

module.exports = exports["default"];

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChangePassword__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChangeProfile__ = __webpack_require__(673);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import * as Config from '../config/Config';
// import * as User from '../helpers/User';
var $=window.$;var MyProfile=function(_Component){_inherits(MyProfile,_Component);function MyProfile(props){_classCallCheck(this,MyProfile);return _possibleConstructorReturn(this,(MyProfile.__proto__||Object.getPrototypeOf(MyProfile)).call(this,props));// this.state={
// };        
}_createClass(MyProfile,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(next){$("#changeprofile").click();}},{key:'componentDidMount',value:function componentDidMount(){//alert('im in first');
$('#parentHorizontalTab').easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
var $tab=$(this);var $info=$('#nested-tabInfo');var $name=$('span',$info);$name.text($tab.text());$info.show();}});// Common.showSmallLeftMenu();
}// onChangedPro(val){
// 	this.props.ChangeProf(val);
// }
},{key:'render',value:function render(){var is_careerlauncher=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]('is_careerlauncher',true);var mcxclas=is_careerlauncher&&"iscar";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea cl'+mcxclas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img-my-account.jpg",alt:'',border:'0',align:'absmiddle'})),'My Account',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Manage the profile'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance myobservers profilepage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'changeprofile'},'View / Edit profile',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'viewfeed'},'Change Password',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",alt:'',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 tapmargntop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ChangeProfile__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ChangePassword__["a" /* default */],null))))))))));}}]);return MyProfile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyProfile);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ChangePassword=function(_Component){_inherits(ChangePassword,_Component);function ChangePassword(props){_classCallCheck(this,ChangePassword);var _this=_possibleConstructorReturn(this,(ChangePassword.__proto__||Object.getPrototypeOf(ChangePassword)).call(this,props));_this.state={txtOldPassword:'',txtNewPassword:'',txtConfirmPassword:''};_this.onSubmit=_this.onSubmit.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.clearForm=_this.clearForm.bind(_this);return _this;}_createClass(ChangePassword,[{key:'clearForm',value:function clearForm(){var old_pwd=$("#txtOldPassword").val("");var new_pwd=$("#txtNewPassword").val("");var confirm_pwd=$("#txtConfirmPassword").val("");this.setState({txtOldPassword:'',txtNewPassword:'',txtConfirmPassword:''});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'onSubmit',value:function onSubmit(e){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var lr_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var username=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('primaryEmail',true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/change-password",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({old_pwd:this.state.txtOldPassword,new_pwd:this.state.txtNewPassword,confirm_pwd:this.state.txtConfirmPassword,learner_id:lr_id,username:username})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this2.clearForm();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");}});}},{key:'maskunmask',value:function maskunmask(id){if($('#'+id).attr('type')=='password'){$("#"+id).attr('type','text');$("."+id+".eye_icon").removeClass('unmask');}else{$("#"+id).attr('type','password');$("."+id+".eye_icon").addClass('unmask');}}},{key:'componentDidMount',value:function componentDidMount(){// Common.showSmallLeftMenu();
}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-observer'},'Password can contain English alphabet and numerals, but not special characters. Please note that the password is CaSE-sensitive.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-observer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'newobserver-left change-password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'change_password_form',name:'change_password_form',method:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'chkoldpass',id:'chkoldpass',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Old Password ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{position:'relative',width:'23%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',id:'txtOldPassword',name:'txtOldPassword',maxLength:'30',className:'txtbox',onChange:function onChange(e){return _this3.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{top:'6px'},className:'txtOldPassword eye_icon unmask',onClick:function onClick(){return _this3.maskunmask('txtOldPassword');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'New Password ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{position:'relative',width:'23%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',id:'txtNewPassword',name:'txtNewPassword',maxLength:'30',className:'txtbox',onChange:function onChange(e){return _this3.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{top:'6px'},className:'txtNewPassword eye_icon unmask',onClick:function onClick(){return _this3.maskunmask('txtNewPassword');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'min-char',style:{color:'#f3523e'}},'Minimum of 6 characters in length.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'min-char',style:{color:'#f3523e'}},'Password must be alpha numeric.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'min-char',style:{color:'#f3523e'}},'It should not case sensitive.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Confirm New Password  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{position:'relative',width:'23%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',id:'txtConfirmPassword',name:'txtConfirmPassword',maxLength:'30',className:'txtbox',onChange:function onChange(e){return _this3.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{top:'6px'},className:'txtConfirmPassword eye_icon unmask',onClick:function onClick(){return _this3.maskunmask('txtConfirmPassword');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'min-char',style:{color:'#f3523e'}},'Minimum of 6 characters in length.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'min-char',style:{color:'#f3523e'}},'Password must be alpha numeric.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'min-char',style:{color:'#f3523e'}},'It should not case sensitive.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label-required'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Required fields ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Change Password',name:'submit',className:'password',alt:'Change Password',title:'Change Password',onClick:function onClick(e){return _this3.onSubmit(e);}})))))))));}}]);return ChangePassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChangePassword);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileEdit__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_profileAction__ = __webpack_require__(125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ChangeProfile=function(_Component){_inherits(ChangeProfile,_Component);function ChangeProfile(props){_classCallCheck(this,ChangeProfile);var _this=_possibleConstructorReturn(this,(ChangeProfile.__proto__||Object.getPrototypeOf(ChangeProfile)).call(this,props));_this.state={details:[],corp:[],sentdetails:[],display:'none',show:'block'};_this.remove=_this.remove.bind(_this);_this.getEditform=_this.getEditform.bind(_this);_this.regenarateCode=_this.regenarateCode.bind(_this);// this.getactive = this.getactive.bind(this);
_this.props.getProfile();return _this;}_createClass(ChangeProfile,[{key:'remove',value:function remove(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var lr_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/remove-photo",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:lr_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{//     	setTimeout(() => {
// 	this.getDetails();
// }, 100);
// let pho = '';
// Common.setUserData('photo_lr',pho,true);
// this.props.ChangedPro(pho);
_this2.props.getProfile();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");}});}// getactive(val){
// 	if(val){
// 		setTimeout(() => {
// 			this.getDetails();
// 		}, 500);
// 	}
// 	this.props.ChangedPro(val);
// }
},{key:'regenarateCode',value:function regenarateCode(){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var lr_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/regenerate-appcode",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:lr_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// setTimeout(() => {
// 	this.getDetails();
// }, 500);
this.setState({details:nextProps.profile.learner,corp:nextProps.profile.corp,sentdetails:nextProps.profile,show:'block',display:'none'});}},{key:'getEditform',value:function getEditform(){this.setState({show:'none',display:'block'});$('.edit_form').css('display','block');}},{key:'componentDidMount',value:function componentDidMount(){// this.getDetails();
// Common.showSmallLeftMenu();
}},{key:'render',value:function render(){var _this3=this;var app=this.state.corp!=undefined||this.state.corp!=null?this.state.corp.appcode:0;app==1?app=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'button-blue',onClick:function onClick(e){return _this3.regenarateCode(e);},value:'Generate New Appcode',alt:'Generate New Appcode',title:'Generate New Appcode'}):app="";var edit=this.state.corp!=undefined||this.state.corp!=null?this.state.corp.but_show:0;edit!=2?edit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Remove',name:'img_remove',className:'remove',alt:'Remove',title:'Remove',onClick:function onClick(e){return _this3.remove(e);}})):edit='';var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('productID',true);var occupation=this.state.details!=undefined||this.state.details!=null?this.state.details.occupation:0;occupation==1?occupation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-inner-left view_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,productID!=418&&productID!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date of Birth '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.corp.dob?this.state.corp.dob:'-----')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Dept of study'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.studying?this.state.details.studying:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Year of study'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.yearofstudy?this.state.details.yearofstudy:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'College Location '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.location?this.state.details.location:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'College Name '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.college?this.state.details.college:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-txt'},'Additional info about Me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.aboutyourself?this.state.details.aboutyourself:'-----')))):occupation==2?occupation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-inner-left view_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,productID!=418&&productID!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date of Birth '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.corp.dob?this.state.corp.dob:'-----')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Designation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.designation?this.state.details.designation:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Experience'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.corp.experience?this.state.corp.experience:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Education'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.education?this.state.details.education:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Office Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.location?this.state.details.location:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-txt'},'Additional info about Me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.aboutyourself?this.state.details.aboutyourself:'-----')))):occupation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-inner-left view_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,productID!=418&&productID!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date of Birth '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.corp.dob?this.state.corp.dob:'-----')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Occupation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.others?this.state.details.others:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.location?this.state.details.location:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-txt'},'Additional info about Me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.aboutyourself?this.state.details.aboutyourself:'-----'))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey viewobservers my-account'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-inner',id:'profile-inner',style:{display:this.state.show}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-lft view_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pphoto',dangerouslySetInnerHTML:{__html:this.state.corp!=undefined||this.state.corp!=null?this.state.corp.photo:''}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-rht'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pro-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Profile image should have minimum width 200px and minimum height of 200px'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Make sure to save changes after changing the image.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{method:'post'},edit)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pro-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'box-name'},this.state.corp!=undefined||this.state.corp!=null?this.state.corp.corporate:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{'border-style':'solid','border-color':'#817a77'}},' Please note : You can ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'modify'),' your ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'First Name'),' and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Last Name'),' only once ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Modify Now',className:'edit',alt:'Modify Now',title:'Modify Now',onClick:function onClick(e){return _this3.getEditform(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.firstname?this.state.details.firstname:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.lastname?this.state.details.lastname:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email Id'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.email?this.state.details.email:'-----'))))),occupation,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-inner-left acc-inner-rht view_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gender'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.corp.gender?this.state.corp.gender:'--------')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Mobile No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.mobile?this.state.details.country_code+'-'+this.state.details.mobile:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'City / Town '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.citytown?this.state.details.citytown:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Region / State '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.regionstate?this.state.details.regionstate:'-----')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Country '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.corp.country_name?this.state.corp.country_name:'-----')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-btn view_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Edit Details',className:'edit',alt:'Edit Details',title:'Edit Details',onClick:function onClick(e){return _this3.getEditform(e);}}),app)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-inner',id:'profile-inner1',style:{display:this.state.display}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProfileEdit__["a" /* default */],{sentdetails:this.state.sentdetails})));}}]);return ChangeProfile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{profile:state.profile};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({getProfile:__WEBPACK_IMPORTED_MODULE_7__actions_profileAction__["a" /* getProfile */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ChangeProfile));

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_profileAction__ = __webpack_require__(125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var ProfileEdit=function(_Component){_inherits(ProfileEdit,_Component);function ProfileEdit(props){_classCallCheck(this,ProfileEdit);var _this=_possibleConstructorReturn(this,(ProfileEdit.__proto__||Object.getPrototypeOf(ProfileEdit)).call(this,props));_this.state={txtStudying:'',cmbYearofstudy:'',txtdob:'',firstname:'',lastname:'',txtCollege:'',txtcoll_name:'',oth_others:'',oth_rLocation:'',txtaboutyourself:'',cmbcountrycode:'',txtmob:'',txtCityTown:'',txtRegionstate:'',com_cmbCountry:'',checkedGenderOption:'',lstexpmonths:'',lstexpyrs:'',occupation:'',photo:'',wor_designation:'',wor_Education:'',wor_office_Location:'',details:[],corp:[],getcountrycodes:[],locations:[],cities:[],tr_student:'',tr_Working:'none',othershow:'none',hidOccupation:'',but_show:''};_this.remove=_this.remove.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.props.getProfile();return _this;}_createClass(ProfileEdit,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.sentdetails!=undefined){//alert(JSON.stringify(nextProps.sentdetails.learner));
var details=nextProps.sentdetails;this.setState({details:details.learner,corp:details.corp,txtStudying:details.learner.studying!=undefined?details.learner.studying:'',cmbYearofstudy:details.learner.yearofstudy?details.learner.yearofstudy:'',txtdob:details.corp.dob?details.corp.dob:'',txtCollege:details.learner.location?details.learner.location:'',txtcoll_name:details.learner.college?details.learner.college:'',wor_designation:details.learner.designation?details.learner.designation:'',wor_Education:details.learner.education?details.learner.education:'',wor_office_Location:details.learner.location?details.learner.location:'',oth_others:details.learner.others?details.learner.others:'',oth_rLocation:details.learner.location?details.learner.location:'',txtaboutyourself:details.learner.aboutyourself?details.learner.aboutyourself:'',cmbcountrycode:details.learner.country_code?details.learner.country_code:'',txtmob:details.learner.mobile?details.learner.mobile:'',firstname:details.learner.firstname?details.learner.firstname:'',lastname:details.learner.lastname?details.learner.lastname:'',txtCityTown:details.learner.citytown?details.learner.citytown:'',txtRegionstate:details.learner.regionstate?details.learner.regionstate:'',com_cmbCountry:details.learner.country?details.learner.country:'',checkedGenderOption:details.learner.gender?details.learner.gender:'',lstexpmonths:details.corp.month?details.corp.month:'',lstexpyrs:details.corp.year?details.corp.year:'',occupation:details.learner.occupation?details.learner.occupation:'',photo:details.corp.photo?details.corp.photo:'',but_show:details.corp.but_show?details.corp.but_show:''});}}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'gender',value:function gender(value){//alert(value);
this.setState({checkedGenderOption:value});}},{key:'onSubmit',value:function onSubmit(){var _this2=this;var formData=new FormData();var frm_myaccount=$('#frm_myaccount').serializeArray();var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var domain=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */];formData.append('learner_id',learnerID);formData.append('domain',domain);var details=[];frm_myaccount.map(function(key,index){if(key.name=='hidfilename'){return false;}details.push(_defineProperty({},key.name,key.value));formData.append(key.name,key.value);});if($('#txtfile')[0].files.length>0){// alert('here');
formData.append('txtfile',$('#txtfile')[0].files[0]);}else{// alert('here ony');
formData.append('txtfile','');}// alert(JSON.stringify(details));
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/update-registerdetails",{method:"POST",// data: formData,
headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{$('#txtfile').val('');// let pho =responseJson.lr_photo;				  
// Common.setUserData('photo_lr',pho,true);
//    this.props.active(pho);
_this2.props.getProfile();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Success',responseJson.message,'success');}});}},{key:'getcountrycodes',value:function getcountrycodes(){var _this3=this;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"getcountrycodes",{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson));
_this3.setState({getcountrycodes:responseJson.country_data});});}},{key:'getlocations_cities',value:function getlocations_cities(){var _this4=this;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"getlocationscities",{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson));
_this4.setState({locations:responseJson.location,cities:responseJson.city});});}},{key:'componentDidMount',value:function componentDidMount(){$('.edit_form').css('display','block');this.getcountrycodes();this.getlocations_cities();// setTimeout(function(){
$("#txtdob").datepicker({dateFormat:'yy-mm-dd',changeMonth:true,changeYear:true,yearRange:"-70:-15",maxDate:'15Y',onSelect:function(selected,evnt){this.setState({txtdob:selected});}.bind(this)});// },100);
}},{key:'remove',value:function remove(){var _this5=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var lr_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var domain=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */];fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/remove-photo",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:lr_id,domain:domain})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this5.setState({photo:responseJson.datas,but_show:responseJson.btn_show});//     	let pho = "";
// Common.setUserData('photo_lr',pho,true);
// this.props.active('');
_this5.props.getProfile();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");}});}},{key:'render',value:function render(){var _this6=this;//const {sentdetails} = this.props;
//alert(JSON.stringify(this.state.getcountrycodes));
var edit=this.state.but_show;// let ph = this.state.but_show;
edit!=2?edit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'remove-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Remove',name:'img_remove',className:'remove',alt:'Remove',title:'Remove',onClick:function onClick(e){return _this6.remove(e);}})):edit='';var occupation=this.state.details.occupation;occupation==1?$("#tr_student").css('display','block'):occupation==2?$("#tr_Working").css('display','block'):occupation==3?$("#othershow").css('display','block'):'';var contryCodeoptions=null;if(this.state.getcountrycodes!=undefined||this.state.getcountrycodes!=null){contryCodeoptions=this.state.getcountrycodes.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.id},key.name_code);});}var contryoptions=null;if(this.state.getcountrycodes!=undefined||this.state.getcountrycodes!=null){contryoptions=this.state.getcountrycodes.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.id},key.name);});}var locations=null;if(this.state.locations!=undefined||this.state.locations!=null){locations=this.state.locations.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.name},key.name);});}var cities=null;if(this.state.cities!=undefined||this.state.cities!=null){cities=this.state.cities.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.name},key.name);});}var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('productID',true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('corporateID',true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frm_myaccount',id:'frm_myaccount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-lft edit_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pphoto',dangerouslySetInnerHTML:{__html:this.state.photo}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-rht'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pro-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Profile image should have minimum width 200px and minimum height of 200px'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Make sure to save changes after changing the image.')),edit),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pro-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'box-name'},this.state.corp.corporate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'First Name'),this.state.details.firstname_lastname_only_once!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.firstname):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profilevalidiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'textbox',style:{background:'#fff'},name:'firstname',id:'firstname',value:this.state.firstname=='-'?'':this.state.firstname,onChange:function onChange(e){return _this6.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Last Name'),this.state.details.firstname_lastname_only_once!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.lastname):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profilevalidiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'lastname',style:{background:'#fff'},className:'textbox',id:'lastname',value:this.state.lastname=='-'?'':this.state.lastname,onChange:function onChange(e){return _this6.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email Id'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.details.email))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-inner-left edit_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Upload Photo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'txtfile',accept:'image/*',name:'txtfile',className:'uploadfile'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'hidfilename',type:'hidden',id:'hidfilename',value:''})),productID!=418&&productID!=419?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date of Birth ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profilevalidiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'txtdob',className:'txtdob active-textbox',id:'txtdob',value:this.state.txtdob}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tr_student',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Dept of study',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'txtStudying',id:'txtStudying',type:'text',value:this.state.txtStudying=='-'?'':this.state.txtStudying,onChange:function onChange(e){return _this6.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'hidOccupation',type:'hidden',id:'hidOccupation',value:this.state.occupation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Year of study ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'cmbYearofstudy',id:'cmbYearofstudy',value:this.state.cmbYearofstudy,onChange:function onChange(e){return _this6.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Select --'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'I'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'II'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'III'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'IV'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'College Location',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'textbox',name:'txtCollege',id:'txtCollege',value:this.state.txtCollege=='-'?'':this.state.txtCollege,onChange:function onChange(e){return _this6.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'College Name',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'textbox',name:'txtcoll_name',id:'txtcoll_name',value:this.state.txtcoll_name=='-'?'':this.state.txtcoll_name,onChange:function onChange(e){return _this6.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tr_Working',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Designation ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'wor_designation',id:'wor_designation',type:'text',value:this.state.wor_designation,onChange:function onChange(e){return _this6.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Experience ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'lstexpyrs',id:'lstexpyrs',value:this.state.lstexpyrs,onChange:function onChange(e){return _this6.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'11'},'11'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'12'},'12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'13'},'13'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'14'},'14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15'},'15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'16'},'16'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'17'},'17'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'18'},'18'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'19'},'19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'20'},'20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'21'},'21'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'22'},'22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'23'},'23'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'24'},'24'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'25'},'25')),'Yrs  \xA0  \xA0  \xA0  \xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'lstexpmonths',id:'lstexpmonths',value:this.state.lstexpmonths,onChange:function onChange(e){return _this6.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'11'},'11')),'Months ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Education ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'wor_Education',id:'wor_Education',value:this.state.wor_Education=='-'?'':this.state.wor_Education,onChange:function onChange(e){return _this6.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Office Location ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'wor_office_Location',id:'wor_office_Location',value:this.state.wor_office_Location=='-'?'':this.state.wor_office_Location,type:'text',onChange:function onChange(e){return _this6.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'othershow',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Occupation',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'oth_others',id:'oth_others',type:'text',value:this.state.oth_others=='-'?'':this.state.oth_others,onChange:function onChange(e){return _this6.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Location',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'oth_rLocation',id:'oth_rLocation',type:'text',value:this.state.oth_rLocation=='-'?'':this.state.oth_rLocation,onChange:function onChange(e){return _this6.handleChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-txt'},'Additional info about Me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'txtaboutyourself',id:'txtaboutyourself',value:this.state.txtaboutyourself=='-'?'':this.state.txtaboutyourself,className:'active-textbox',onChange:function onChange(e){return _this6.handleChange(e);}},this.state.txtaboutyourself=='-'?'':this.state.txtaboutyourself)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-inner-left acc-inner-rht edit_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gender'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profilevalidiv genderborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'optgender',type:'radio',value:'1',checked:this.state.checkedGenderOption==1,onChange:function onChange(e){return _this6.gender(1);}}),'Male \xA0  \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'optgender',type:'radio',value:'2',checked:this.state.checkedGenderOption==2,onChange:function onChange(e){return _this6.gender(2);}}),'Female')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'limobno'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Mobile No',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mobile-no'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'cmbcountrycode',id:'cmbcountrycode',value:this.state.cmbcountrycode,onChange:function onChange(e){return _this6.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),contryCodeoptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Country code'))),corporateID!=93?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mobile-no'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'txtmob',id:'txtmob',className:'txtbox',maxLength:'10',value:this.state.txtmob,onChange:function onChange(e){return _this6.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Mobile Number'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mobile-no'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'txtmob',id:'txtmob',readonly:true,className:'txtbox',maxLength:'10',value:this.state.txtmob}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Mobile Number'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'City / Town ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profilevalidiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'textbox',name:'txtCityTown',id:'txtCityTown',value:this.state.txtCityTown=='-'?'':this.state.txtCityTown,onChange:function onChange(e){return _this6.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Region / State ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profilevalidiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'textbox',name:'txtRegionstate',id:'regionstate',value:this.state.txtRegionstate=='-'?'':this.state.txtRegionstate,onChange:function onChange(e){return _this6.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Country ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'com_cmbCountry',id:'country_options',value:this.state.com_cmbCountry,onChange:function onChange(e){return _this6.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),contryoptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc-btn edit_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Save',id:'edit',name:'',className:'edit',alt:'Save',title:'Save',onClick:function onClick(e){return _this6.onSubmit(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'* '),'Required fields')));}}]);return ProfileEdit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{profile:state.profile};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({getProfile:__WEBPACK_IMPORTED_MODULE_6__actions_profileAction__["a" /* getProfile */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ProfileEdit));

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cwsubdetails__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MyBookmarks__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MySearch__ = __webpack_require__(681);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Cwsubject=function(_Component){_inherits(Cwsubject,_Component);function Cwsubject(props){_classCallCheck(this,Cwsubject);var _this=_possibleConstructorReturn(this,(Cwsubject.__proto__||Object.getPrototypeOf(Cwsubject)).call(this,props));_this.state={subject:'',component:'',sub_id:'',mats:[]};_this.setComponentPanel=_this.setComponentPanel.bind(_this);return _this;}_createClass(Cwsubject,[{key:'setComponentPanel',value:function setComponentPanel(type,datas){var pan='';var datas_detail=datas;var panel='';switch(type){case'bookmark':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MyBookmarks__["a" /* default */],{handler:this.setComponentPanel});break;case'search':panel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MySearch__["a" /* default */],{searchkey:datas_detail,handler:this.setComponentPanel});break;case'getback':if(datas_detail!=undefined){pan=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Cwsubdetails__["a" /* default */],{chap_sub:datas_detail,materials:this.state.mats,handler:this.setComponentPanel});}else{pan=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Cwsubdetails__["a" /* default */],{subject_id:this.state.sub_id,materials:this.state.mats,handler:this.setComponentPanel});}panel=pan;break;}this.setState({component:panel});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.subject_id!=undefined){//alert(nextProps.subject_id);
this.setState({component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Cwsubdetails__["a" /* default */],{subject_id:nextProps.subject_id,materials:nextProps.materials,handler:this.setComponentPanel}),sub_id:nextProps.subject_id,mats:nextProps.materials});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img-courseware.jpg",align:'absmiddle',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Courseware'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'- subjects and chapters for your study'))),this.state.component);}}]);return Cwsubject;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Cwsubject);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Myquiz__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Flowplayer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_newPostAction__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Cwsubdetails=function(_Component){_inherits(Cwsubdetails,_Component);function Cwsubdetails(props){_classCallCheck(this,Cwsubdetails);var _this=_possibleConstructorReturn(this,(Cwsubdetails.__proto__||Object.getPrototypeOf(Cwsubdetails)).call(this,props));_this.state={formattedContent:"",content_sub:'',templatebg:'Template1',subject:'',subjects:[],chapters:[],chapter_name:'',chapter_id_pk:'',bookmark_img:'star-box-ovr',bookmark_title:'',txtSearch:'',dis_quiz:'inline-block',dis_chap:'none',subject_id:'',dis_cont:'block',dis_ques:'none',assessment_id:'',ids_media:[]};_this.getChaptersid=_this.getChaptersid.bind(_this);_this.getChaptersCon=_this.getChaptersCon.bind(_this);_this.setBookmark=_this.setBookmark.bind(_this);_this.handleChange=_this.handleChange.bind(_this);// this.markText = this.markText.bind(this);
return _this;}_createClass(Cwsubdetails,[{key:'_handleKeyPress',value:function _handleKeyPress(e){if(e.key==="Enter"){this.handler('search',this.state.txtSearch);}}},{key:'markText',value:function markText(content_text){var con_ket=content_text;var control_style={position:'relative'};var content=[];con_ket=con_ket.split("##");// const { data } = this.props;
// let trackData={
// 	compseq_id: data.compseq_id,
// 	lroom_id: data.learning_room_id,
// 	divider_id: data.divider_id,
// 	learner_id: data.learner_id,
// 	dlr_id: data.dlr_id,
// 	compo_type:data.compo_type
// };
var trackData={compseq_id:'',lroom_id:'',divider_id:'',learner_id:__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */](),dlr_id:'',compo_type:'courseware'};//console.log(con_ket);
if(con_ket.length>0){con_ket.map(function(val,i){if(val.match(/audio_player/g)){var audio_file_name=val.split("audio_player_");var audioplayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'audio_player_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:control_style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:''+(__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+audio_file_name[1]),type:'audio/mpeg',width:'400',height:'50'})));content.push(audioplayer);}else if(val.match(/video_player/g)){var video_file_name=val.split("video_player_");//let video_file_type = video_file_name[1].substr(-3);
var video_file_type=video_file_name[1].split('.').pop();//alert(video_file_type);														
var video_playlist={share:false,ratio:9/16,clip:{sources:[{type:"video/"+video_file_type,src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+video_file_name[1]}]}};content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'video_player_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Flowplayer__["a" /* default */],{playlist:video_playlist,trackData:trackData})));}else if(val.match(/image_viewer/g)){// alert(val);
var image_file_name=val.split("image_viewer_");content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:'image_viewer_'+i,alt:'image',src:__WEBPACK_IMPORTED_MODULE_4__config_Config__["g" /* rootDomainUrl */]+image_file_name[1],style:{width:'680px'}}));}else{content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'content_'+i,dangerouslySetInnerHTML:{__html:val}}));}});}return content;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.subject_id!=undefined){var id=nextProps.subject_id;this.getSubject(id);}if(nextProps.materials!=undefined){this.setState({subjects:nextProps.materials,chapters:[]});}}},{key:'setBookmark',value:function setBookmark(chap_id){var _this2=this;// alert(chap_id);
var chap_id=chap_id;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'resources/bookmark',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({chap_id:chap_id,learnerID:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Success',responseJson.message,'success');_this2.setState({bookmark_img:responseJson.bookmark_img,bookmark_title:responseJson.bookmark_title});}});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'getChaptersCon',value:function getChaptersCon(chap_id,sub_id){var _this3=this;var chapter_id=chap_id;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'resources/chapters-content',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({chapter_id:chapter_id,learnerID:learnerID,sub_id:sub_id})}).then(function(response){return response.json();}).then(function(responseJson){//alert(responseJson);
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this3.setState({formattedContent:_this3.markText(responseJson.content),content_sub:responseJson.content,chapter_name:responseJson.chapter_name,chapter_id_pk:chapter_id,bookmark_img:responseJson.bookmark.img,bookmark_title:responseJson.bookmark.title,assessment_id:responseJson.bookmark.ass_id});setTimeout(function(){_this3.props.getNewPost();},5000);}});}},{key:'getChaptersid',value:function getChaptersid(){if($('#chapter_menu').css('display')=='none'){$("#chapter_menu").css('display','block');}else{$("#chapter_menu").css('display','none');}}},{key:'getSubject',value:function getSubject(){var _this4=this;var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var sub_i=$("select#cmbSubject").val();var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);if(sub_i!=""&&id==""){var subject=sub_i;}else{var subject=id;}// alert(subject);
// console.log(sub_i);
if(subject!=''){var sub_id=subject.split('_');var subject_id=sub_id[0];var tmp_id=sub_id[1];var sub=sub_id[2];__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'resources/subject-content',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({subject_id:subject_id,tmp_id:tmp_id,subject:sub,learnerID:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
_this4.setState({formattedContent:_this4.markText(responseJson.content),subject_id:subject_id,content_sub:responseJson.content,templatebg:responseJson.templatebg,subject:responseJson.subject,chapters:responseJson.chapters,chapter_name:responseJson.chapter_name,chapter_id_pk:responseJson.chapter_id_pk,bookmark_img:responseJson.bookmark.img,bookmark_title:responseJson.bookmark.title,assessment_id:responseJson.bookmark.ass_id});setTimeout(function(){_this4.props.getNewPost();},5000);});}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["F" /* winResize */]();}},{key:'componentDidMount',value:function componentDidMount(){var _this5=this;var subject_id=this.props.subject_id;var materials=this.props.materials;this.setState({subjects:materials,chapters:[]});if(subject_id!=""||subject_id!=undefined){this.getSubject(subject_id);}var chap_sub=this.props.chap_sub;if(chap_sub!=""&&subject_id==undefined){var chasub=chap_sub;if(chasub!=undefined){var chsub=chasub.split('__');var sub=chsub[0];var chap=chsub[1];if(sub!=""){this.getSubject(sub);}setTimeout(function(){if(chap){_this5.getChaptersCon(chap,sub);}},1500);}}}},{key:'changeType',value:function changeType(type){if(type=='quiz'){if(this.state.dis_quiz=="inline-block"){this.setState({dis_quiz:'none',dis_chap:'inline-block',dis_ques:'block',dis_cont:'none'});}else{this.setState({dis_quiz:'inline-block',dis_chap:'none',dis_ques:'none',dis_cont:'block'});}}}},{key:'handler',value:function handler(type,data_sent){this.props.handler(type,data_sent);}},{key:'render',value:function render(){var _this6=this;var chap_con=this.state.chapters.map(function(chap,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'chapters_'+chap.chapter_id_pk+'_'+i,className:'chap_title2',onClick:function onClick(e){return _this6.getChaptersCon(chap.chapter_id_pk,chap.subject_ids,e);},id:chap.chapter_id_pk},chap.chapter_name);});var subject_select=this.state.subjects.map(function(subject,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'subjects_'+subject.subject_id_pk+'_'+i,value:subject.subject_id_pk+'_'+subject.template_id_fk+'_'+subject.subject},subject.subject);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'yellow-course'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'txtSearch',name:'txtSearch',type:'text',onChange:function onChange(e){return _this6.handleChange(e);},onKeyPress:function onKeyPress(e){return _this6._handleKeyPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:'Search',border:'0',type:'button',id:'sebut',onClick:function onClick(e){return _this6.handler('search',_this6.state.txtSearch);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'bookmark_div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this6.setBookmark(_this6.state.chapter_id_pk);},title:this.state.bookmark_title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/"+this.state.bookmark_img+".jpg",align:'texttop',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',style:{display:this.state.dis_chap},title:'View Chapters',id:'view-chap',className:'self-chk',onClick:function onClick(e){return _this6.changeType('quiz');}},'View Chapters'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',style:{display:this.state.dis_quiz},title:'Self-check Quiz',id:'self-chk',className:'self-chk',onClick:function onClick(e){return _this6.changeType('quiz');}},'Self-check Quiz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',title:'My Bookmarks',className:'my-book',onClick:function onClick(e){return _this6.handler('bookmark');}},'My Bookmarks')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box-gray title-box-blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'SubjectFrm',id:'SubjectFrm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'sub_cmbbox',id:'cmbSubject',onChange:function onChange(e){return _this6.getSubject();},style:{width:'210px'},name:'cmbSubject'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Choose another subject'),subject_select))),this.state.subject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'chapter_menu',className:'chap_main menu',style:{display:'none'}},chap_con),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chap_main',id:'chapter_latest',top:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slt_chp',align:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this6.getChaptersid(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/change_chapter.jpg",width:'185',height:'38',border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.state.chapter_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"courseware_contentbg"+this.state.templatebg,style:{display:this.state.dis_cont}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top_img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/courseware_templates/"+this.state.templatebg+"/top-img.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.formattedContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"courseware_footer"+this.state.templatebg})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.dis_ques},className:'courseware_template'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Myquiz__["a" /* default */],{chaptersub:this.state.assessment_id+'_'+this.state.subject_id+'_'+this.state.chapter_id_pk,handler:this.setComponentPanel}))))))))));}}]);return Cwsubdetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({getNewPost:__WEBPACK_IMPORTED_MODULE_9__actions_newPostAction__["a" /* getNewPost */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Cwsubdetails));

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(678);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(47),q=__webpack_require__(0);function aa(a,b,e,c,g,d,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var B=[e,c,g,d,h,f],A=0;a=Error(b.replace(/%s/g,function(){return B[A++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function u(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var w="function"===typeof Symbol&&Symbol.for,y=w?Symbol.for("react.portal"):60106,z=w?Symbol.for("react.fragment"):60107,C=w?Symbol.for("react.strict_mode"):60108,D=w?Symbol.for("react.profiler"):60114,E=w?Symbol.for("react.provider"):60109,F=w?Symbol.for("react.context"):60110,G=w?Symbol.for("react.concurrent_mode"):60111,H=w?Symbol.for("react.forward_ref"):60112,I=w?Symbol.for("react.suspense"):60113,J=w?Symbol.for("react.memo"):60115,L=w?Symbol.for("react.lazy"):60116;
function M(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case G:return"ConcurrentMode";case z:return"Fragment";case y:return"Portal";case D:return"Profiler";case C:return"StrictMode";case I:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case F:return"Context.Consumer";case E:return"Context.Provider";case H:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case J:return M(a.type);case L:if(a=1===a._status?a._result:null)return M(a)}return null}var ba=q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,ca={};function N(a,b){for(var e=a._threadCount|0;e<=b;e++)a[e]=a._currentValue2,a._threadCount=e+1}function da(a,b,e){var c=a.contextType;if("object"===typeof c&&null!==c)return N(c,e),c[e];if(a=a.contextTypes){e={};for(var g in a)e[g]=b[g];b=e}else b=ca;return b}for(var O=new Uint16Array(16),P=0;15>P;P++)O[P]=P+1;O[15]=0;
var ea=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,fa=Object.prototype.hasOwnProperty,ha={},ia={};
function ja(a){if(fa.call(ia,a))return!0;if(fa.call(ha,a))return!1;if(ea.test(a))return ia[a]=!0;ha[a]=!0;return!1}function ka(a,b,e,c){if(null!==e&&0===e.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==e)return!e.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function la(a,b,e,c){if(null===b||"undefined"===typeof b||ka(a,b,e,c))return!0;if(c)return!1;if(null!==e)switch(e.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function Q(a,b,e,c,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=g;this.mustUseProperty=e;this.propertyName=a;this.type=b}var R={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){R[a]=new Q(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];R[b]=new Q(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){R[a]=new Q(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){R[a]=new Q(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){R[a]=new Q(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){R[a]=new Q(a,3,!0,a,null)});
["capture","download"].forEach(function(a){R[a]=new Q(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){R[a]=new Q(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){R[a]=new Q(a,5,!1,a.toLowerCase(),null)});var S=/[\-:]([a-z])/g;function T(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(S,
T);R[b]=new Q(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(S,T);R[b]=new Q(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(S,T);R[b]=new Q(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});R.tabIndex=new Q("tabIndex",1,!1,"tabindex",null);var ma=/["'&<>]/;
function U(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ma.exec(a);if(b){var e="",c,g=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}g!==c&&(e+=a.substring(g,c));g=c+1;e+=b}a=g!==c?e+a.substring(g,c):e}return a}var na=!1;function oa(a,b,e,c){for(;na;)na=!1,e=a(b,c);return e}
var V=0,pa={readContext:function(a){var b=V;N(a,b);return a[b]}},qa={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function ra(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var sa={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},ta=p({menuitem:!0},sa),W={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ua=["Webkit","ms","Moz","O"];Object.keys(W).forEach(function(a){ua.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);W[b]=W[a]})});
var va=/([A-Z])/g,wa=/^ms-/,X=q.Children.toArray,Y=ba.ReactCurrentOwner,xa={listing:!0,pre:!0,textarea:!0},ya=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,za={},Z={};function Aa(a){if(void 0===a||null===a)return a;var b="";q.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Ba=Object.prototype.hasOwnProperty,Ca={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Da(a,b){void 0===a&&u("152",M(b)||"Component")}
function Ea(a,b,e){function c(g,c){var d=da(c,b,e),f=[],h=!1,l={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},k=void 0;if(c.prototype&&c.prototype.isReactComponent){if(k=new c(g.props,d,l),"function"===typeof c.getDerivedStateFromProps){var r=c.getDerivedStateFromProps.call(null,g.props,k.state);null!=r&&(k.state=p({},k.state,r))}}else if(k=c(g.props,
d,l),k=oa(c,g.props,k,d),null==k||null==k.render){a=k;Da(a,c);return}k.props=g.props;k.context=d;k.updater=l;l=k.state;void 0===l&&(k.state=l=null);if("function"===typeof k.UNSAFE_componentWillMount||"function"===typeof k.componentWillMount)if("function"===typeof k.componentWillMount&&"function"!==typeof c.getDerivedStateFromProps&&k.componentWillMount(),"function"===typeof k.UNSAFE_componentWillMount&&"function"!==typeof c.getDerivedStateFromProps&&k.UNSAFE_componentWillMount(),f.length){l=f;var m=
h;f=null;h=!1;if(m&&1===l.length)k.state=l[0];else{r=m?l[0]:k.state;var t=!0;for(m=m?1:0;m<l.length;m++){var v=l[m];v="function"===typeof v?v.call(k,r,g.props,d):v;null!=v&&(t?(t=!1,r=p({},r,v)):p(r,v))}k.state=r}}else f=null;a=k.render();Da(a,c);g=void 0;if("function"===typeof k.getChildContext&&(d=c.childContextTypes,"object"===typeof d)){g=k.getChildContext();for(var K in g)K in d?void 0:u("108",M(c)||"Unknown",K)}g&&(b=p({},b,g))}for(;q.isValidElement(a);){var g=a,d=g.type;if("function"!==typeof d)break;
c(g,d)}return{child:a,context:b}}
var Fa=function(){function a(b,e){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");q.isValidElement(b)?b.type!==z?b=[b]:(b=b.props.children,b=q.isValidElement(b)?[b]:X(b)):b=X(b);b={type:null,domNamespace:qa.html,children:b,childIndex:0,context:ca,footer:""};var c=O[0];if(0===c){var g=O;c=g.length;var d=2*c;65536>=d?void 0:u("304");var h=new Uint16Array(d);h.set(g);O=h;O[0]=c+1;for(g=c;g<d-1;g++)O[g]=g+1;O[d-1]=0}else O[0]=O[c];this.threadID=c;this.stack=[b];this.exhausted=
!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=e;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.destroy=function(){if(!this.exhausted){this.exhausted=!0;var a=this.threadID;O[a]=O[0];O[0]=a}};a.prototype.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,g=this.threadID;N(c,g);var d=c[g];this.contextStack[b]=c;this.contextValueStack[b]=d;c[g]=a.props.value};a.prototype.popProvider=function(){var a=
this.contextIndex,e=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;e[this.threadID]=c};a.prototype.read=function(a){if(this.exhausted)return null;var b=V;V=this.threadID;var c=Y.currentDispatcher;Y.currentDispatcher=pa;try{for(var g=[""],d=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;O[h]=O[0];O[0]=h;break}var f=this.stack[this.stack.length-1];if(d||f.childIndex>=f.children.length){var B=
f.footer;""!==B&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===f.type)this.currentSelectValue=null;else if(null!=f.type&&null!=f.type.type&&f.type.type.$$typeof===E)this.popProvider(f.type);else if(f.type===I){this.suspenseDepth--;var A=g.pop();if(d){d=!1;var n=f.fallbackFrame;n?void 0:u("303");this.stack.push(n);continue}else g[this.suspenseDepth]+=A}g[this.suspenseDepth]+=B}else{var l=f.children[f.childIndex++],k="";try{k+=this.render(l,f.context,f.domNamespace)}catch(r){throw r;
}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=k}}return g[0]}finally{Y.currentDispatcher=c,V=b}};a.prototype.render=function(a,e,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return U(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+U(c);this.previousWasTextNode=!0;return U(c)}e=Ea(a,e,this.threadID);a=e.child;e=e.context;if(null===a||!1===a)return"";if(!q.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;
b===y?u("257"):void 0;u("258",b.toString())}a=X(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:e,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,e,c);switch(b){case C:case G:case D:case z:return a=X(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:e,footer:""}),"";case I:u("294")}if("object"===typeof b&&null!==b)switch(b.$$typeof){case H:var d=b.render(a.props,a.ref);d=oa(b.render,a.props,d,a.ref);
d=X(d);this.stack.push({type:null,domNamespace:c,children:d,childIndex:0,context:e,footer:""});return"";case J:return a=[q.createElement(b.type,p({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:e,footer:""}),"";case E:return b=X(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:e,footer:""},this.pushProvider(a),this.stack.push(c),"";case F:b=a.type;d=a.props;var h=this.threadID;N(b,h);b=X(d.children(b[h]));this.stack.push({type:a,
domNamespace:c,children:b,childIndex:0,context:e,footer:""});return"";case L:u("295")}u("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,e,c){var b=a.type.toLowerCase();c===qa.html&&ra(b);za.hasOwnProperty(b)||(ya.test(b)?void 0:u("65",b),za[b]=!0);var d=a.props;if("input"===b)d=p({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===b){var h=d.value;if(null==h){h=
d.defaultValue;var f=d.children;null!=f&&(null!=h?u("92"):void 0,Array.isArray(f)&&(1>=f.length?void 0:u("93"),f=f[0]),h=""+f);null==h&&(h="")}d=p({},d,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=p({},d,{value:void 0});else if("option"===b){f=this.currentSelectValue;var B=Aa(d.children);if(null!=f){var A=null!=d.value?d.value+"":B;h=!1;if(Array.isArray(f))for(var n=0;n<f.length;n++){if(""+f[n]===A){h=!0;break}}else h=""+f===A;d=
p({selected:void 0,children:void 0},d,{selected:h,children:B})}}if(h=d)ta[b]&&(null!=h.children||null!=h.dangerouslySetInnerHTML?u("137",b,""):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?u("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:u("61")),null!=h.style&&"object"!==typeof h.style?u("62",""):void 0;h=d;f=this.makeStaticMarkup;B=1===this.stack.length;A="<"+a.type;for(x in h)if(Ba.call(h,x)){var l=h[x];if(null!=l){if("style"===
x){n=void 0;var k="",r="";for(n in l)if(l.hasOwnProperty(n)){var m=0===n.indexOf("--"),t=l[n];if(null!=t){var v=n;if(Z.hasOwnProperty(v))v=Z[v];else{var K=v.replace(va,"-$1").toLowerCase().replace(wa,"-ms-");v=Z[v]=K}k+=r+v+":";r=n;m=null==t||"boolean"===typeof t||""===t?"":m||"number"!==typeof t||0===t||W.hasOwnProperty(r)&&W[r]?(""+t).trim():t+"px";k+=m;r=";"}}l=k||null}n=null;b:if(m=b,t=h,-1===m.indexOf("-"))m="string"===typeof t.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=
!1;break b;default:m=!0}if(m)Ca.hasOwnProperty(x)||(n=x,n=ja(n)&&null!=l?n+"="+('"'+U(l)+'"'):"");else{m=x;n=l;l=R.hasOwnProperty(m)?R[m]:null;if(t="style"!==m)t=null!==l?0===l.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;t||la(m,n,l,!1)?n="":null!==l?(m=l.attributeName,l=l.type,n=3===l||4===l&&!0===n?m+'=""':m+"="+('"'+U(n)+'"')):n=ja(m)?m+"="+('"'+U(n)+'"'):""}n&&(A+=" "+n)}}f||B&&(A+=' data-reactroot=""');var x=A;h="";sa.hasOwnProperty(b)?x+="/>":(x+=">",h="</"+a.type+
">");a:{f=d.dangerouslySetInnerHTML;if(null!=f){if(null!=f.__html){f=f.__html;break a}}else if(f=d.children,"string"===typeof f||"number"===typeof f){f=U(f);break a}f=null}null!=f?(d=[],xa[b]&&"\n"===f.charAt(0)&&(x+="\n"),x+=f):d=X(d.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?ra(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:d,childIndex:0,context:e,footer:h});this.previousWasTextNode=
!1;return x};return a}(),Ga={renderToString:function(a){a=new Fa(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Fa(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){u("207")},renderToStaticNodeStream:function(){u("208")},version:"16.7.0"},Ha={default:Ga},Ia=Ha&&Ga||Ha;module.exports=Ia.default||Ia;


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Validation__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Myquiz=function(_Component){_inherits(Myquiz,_Component);function Myquiz(props){_classCallCheck(this,Myquiz);var _this=_possibleConstructorReturn(this,(Myquiz.__proto__||Object.getPrototypeOf(Myquiz)).call(this,props));_this.state={chaptersub:'',top:'',ques_ans:[],ques:[],percentage:''};return _this;}_createClass(Myquiz,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){//alert(nextProps.chaptersub);
//alert('im here first');
// setTimeout(()=>{
var chaptersub=nextProps.chaptersub;if(chaptersub!='__'){//this.getquiz(chaptersub);
this.reset(chaptersub);}// },1600);
}},{key:'reset',value:function reset(chaptersub){$('form#test_form')[0].reset();this.setState({percentage:''});this.getquiz(chaptersub);}},{key:'getquiz',value:function getquiz(chaptersub){var _this2=this;//alert(chaptersub);
$(".error").remove();var chaptesub=chaptersub;var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("productID",true);fetch(__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+'resources/get-quiz',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,product:productID,chapsub:chaptesub})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson)) ;
if(responseJson.status!=0){_this2.setState({ques:responseJson.ques_ans,ques_ans:responseJson.ques_ans.questions,top:responseJson.top,chaptersub:chaptersub});//          if($('#chapter_menu').css('display') == 'none'){
// 	$("#chapter_menu").css('display','block');
// }
// else{
$("#chapter_menu").css('display','none');// }
}});}},{key:'componentDidMount',value:function componentDidMount(){//alert('im in first');
var chaptersub=this.props.chaptersub;//alert(chaptersub);
if(chaptersub!='__'){this.getquiz(chaptersub);}}},{key:'submitFeedback',value:function submitFeedback(){var _this3=this;if(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_Validation__["a" /* runValidation */])()){var jsonFormData=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Fields__["d" /* getFormValues */])(this.state.ques);var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("productID",true);__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+'resources/ans-quiz',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,product:productID,json_form_data:jsonFormData})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson)) ;
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{_this3.setState({ques:responseJson.ques_ans,ques_ans:responseJson.ques_ans.questions,percentage:responseJson.total});}});//alert(JSON.stringify(jsonFormData));
}}},{key:'render',value:function render(){var _this4=this;//alert(this.state.top);
var ques_ans="";var button="";if(this.state.ques_ans!=undefined){ques_ans=this.state.ques_ans.map(function(val,key){var value=key+1;//alert(val.questionAnswerscore);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'ques_div_'+key,className:'lr-gray-box test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margbtm para'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt'},'Q'+value,'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'quetn',dangerouslySetInnerHTML:{__html:val.questionLabel}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'test-ques'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{name:'bookmark'+value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__["a" /* default */],{key:'ques_inputgenerator_'+key,qDetails:val})),val.questionAnswerscore!=null||val.questionAnswerscore==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dottedline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt score'},'Your Score -'+val.questionAnswerscore)):"")));});}this.state.percentage?button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txt'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',id:'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnsubmit',value:'Re-do Assessment',onClick:function onClick(){return _this4.reset(_this4.state.chaptersub);}}))):button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txt'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',id:'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnsubmit',value:'Submit',onClick:function onClick(){return _this4.submitFeedback();}})));this.state.ques_ans?ques_ans=ques_ans:ques_ans='The chapter has no Assessment.';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'test_form',id:'test_form',method:'post',action:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.state.top}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.state.percentage}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),ques_ans,button));}}]);return Myquiz;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Myquiz);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var MyBookmarks=function(_Component){_inherits(MyBookmarks,_Component);function MyBookmarks(props){_classCallCheck(this,MyBookmarks);var _this=_possibleConstructorReturn(this,(MyBookmarks.__proto__||Object.getPrototypeOf(MyBookmarks)).call(this,props));_this.state={bookmarks:[]};_this.getBookmarkDetails=_this.getBookmarkDetails.bind(_this);_this.removeBookmark=_this.removeBookmark.bind(_this);return _this;}_createClass(MyBookmarks,[{key:'getBookmarkDetails',value:function getBookmarkDetails(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'resources/bookmark-details',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson)) ;
__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");_this2.setState({bookmarks:responseJson.bookmark_details});});}},{key:'handler',value:function handler(type,data_sent){this.props.handler(type,data_sent);}},{key:'removeBookmark',value:function removeBookmark(chap_id){var _this3=this;window.swal({//title: 'Remove!',
text:'Remove this bookmark?',// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'resources/bookmark',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({chap_id:chap_id,learnerID:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringisy(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]('Success',responseJson.message,'success');_this3.getBookmarkDetails();}});}});}},{key:'componentDidMount',value:function componentDidMount(){this.getBookmarkDetails();}},{key:'render',value:function render(){var _this4=this;// let bookmarks = "";
var bookmarks=this.state.bookmarks.map(function(books,i){var chap=books.chapters.map(function(chapt,k){var chap_sub=books.sent_id+'__'+chapt.chapter_id_pk;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:chapt.chapter_id_pk,id:'bmark_link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sub'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){_this4.removeBookmark(chapt.chapter_id_pk);},title:'Un-Bookmark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/remove_cwr.jpg",width:'17',height:'17',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.handler('getback',chap_sub);}},chapt.chapter_name))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'subject_div_'+books.subject_id,id:"subject_div_"+books.subject_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mybook-blue'},books.subject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"chapter_id_"+books.bookmark_id},chap));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box-gray'},'My Bookmarks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chap_main1',id:'chapter_latest'},!bookmarks.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No Bookmarks'):bookmarks),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button cwbookmarkbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.handler('getback');},name:'btnsubmit',value:'Continue',className:'button_org',alt:'Continue',title:'Continue'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{clear:'both'}})))))));}}]);return MyBookmarks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyBookmarks);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var MySearch=function(_Component){_inherits(MySearch,_Component);function MySearch(props){_classCallCheck(this,MySearch);var _this=_possibleConstructorReturn(this,(MySearch.__proto__||Object.getPrototypeOf(MySearch)).call(this,props));_this.state={search_results:[],total:0,txtSearch:''};return _this;}_createClass(MySearch,[{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'handler',value:function handler(type,data_sent){this.props.handler(type,data_sent);}},{key:'getSearchResult',value:function getSearchResult(key){var _this2=this;var search_key=key;if(search_key==""){$("#err_course").show();return false;}else{$("#err_course").hide();var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var productID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("productID",true);var pinID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("pinID",true);__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'resources/search-results',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,search_key:search_key,product:productID,pinid:pinID})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringify(responseJson)) ;
__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this2.setState({search_results:responseJson.search_results,txtSearch:search_key,total:responseJson.total});}});}}},{key:'componentDidMount',value:function componentDidMount(){$("#err_course").hide();var searchkey=this.props.searchkey;this.getSearchResult(searchkey);}},{key:'_handleKeyPress',value:function _handleKeyPress(e){if(e.key==="Enter"){this.getSearchResult(this.state.txtSearch);}}},{key:'render',value:function render(){var _this3=this;//let results = "";
var results=this.state.search_results.map(function(result,k){if(result.subject_id!=null&&result.content!=""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:result.subject_id,className:'sub'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.handler('getback',result.sent_id);},className:'txt-slnk'},result.subject,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.handler('getback',result.sent_id);}},result.chapter_name,'  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:result.content}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}});this.state.total>0?results=results:results='No results found.';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-box-gray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'txtSearch',name:'txtSearch',value:this.state.txtSearch,onChange:function onChange(e){return _this3.handleChange(e);},onKeyPress:function onKeyPress(e){return _this3._handleKeyPress(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Search',id:'sebut',onClick:function onClick(e){return _this3.getSearchResult(_this3.state.txtSearch);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'error',id:'err_course'},'Search key cannot be empty')),'Search results'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'rul-title'},'About ',this.state.total,' results'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',top:'10px',right:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.handler('getback');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/back-icon.png",align:'absmiddle',alt:'Courseware Home',title:'Courseware Home'}),' Courseware')),results))))));}}]);return MySearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MySearch);

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 683 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 684 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Addmore__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IseekCreateform__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Titleinput__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Pagination__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekView=function(_Component){_inherits(IseekView,_Component);function IseekView(props){_classCallCheck(this,IseekView);//alert(JSON.stringify(this.props.feedbacks));
var _this=_possibleConstructorReturn(this,(IseekView.__proto__||Object.getPrototypeOf(IseekView)).call(this,props));_this.state={pageOfItems:[],mailsents:'',poll_title:[],poll_answers:[],snap_poll_title:'',pollQuestions:[],feedbacks:[],show:'block',hide:'none',length:''};_this.fnGetSaveAsPage=_this.fnGetSaveAsPage.bind(_this);_this.fnGetmails=_this.fnGetmails.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.titleChange=_this.titleChange.bind(_this);_this.getForm=_this.getForm.bind(_this);return _this;}_createClass(IseekView,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.feedbacks!=undefined){//alert(JSON.stringify(nextProps.feedbacksResults));
this.setState({show:'block',hide:'none',feedbacks:nextProps.feedbacks,pageOfItems:nextProps.feedbacks});//this.forceUpdate();
//  alert(JSON.stringify(nextProps.feedbacks));
}}},{key:'titleChange',value:function titleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'getForm',value:function getForm(){//alert('im in');
$("#formfeed").click();}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});}},{key:'fnGetmails',value:function fnGetmails(snapid){var _this2=this;var snapid=snapid;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/iseek-showmails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({snapid:snapid})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){//alert(JSON.stringify(responseJson));
if(responseJson.mails!=''){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Mails',responseJson.mails);_this2.setState({mailsents:responseJson.mails});}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('','No Results');}}});}},{key:'fnGetSaveAsPage',value:function fnGetSaveAsPage(snapid){var _this3=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var snapid=snapid;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/iseek-saveas',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({snapid:snapid,lr_id:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");// alert(JSON.stringify(responseJson));
// alert(responseJson.poll_answers.length-1);
if(responseJson.poll_answers.length>0){// let more_fields = '';
//let more_fields=[];
var length=responseJson.poll_answers.length-1;//  alert(getdata);
// length.map(()=>{
//  more_fields.push({deleteoption: true});
// });
//alert(JSON.stringify(more_fields));
_this3.setState({show:'none',hide:'block',// pollQuestions : more_fields,
length:length,poll_title:responseJson.poll_title,poll_answers:responseJson.poll_answers,snap_poll_title:responseJson.poll_title.snap_poll_title});// alert(JSON.stringify(this.state.pollQuestions));
}});}},{key:'renameInput',value:function renameInput(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";setTimeout(function(){$('div[id^="Questionsedit"]').each(function(){var mainid=$(this).attr('id').split("_");if($('#Questionsedit_'+mainid[1]).find(".dummy_text_select")){$('#Questionsedit_'+mainid[1]).find(".dummy_text_select").attr("name",'snap_poll_type['+mainid[1]+']').removeClass('dummy_text_select');}if($('#Questionsedit_'+mainid[1]).find(".dummy_text_parent")){$('#Questionsedit_'+mainid[1]).find(".dummy_text_parent").attr("name",'snap_poll_question['+mainid[1]+']').removeClass('dummy_text_parent');}if($('#Questionsedit_'+mainid[1]).find(".dummy_text")){$('#Questionsedit_'+mainid[1]).find(".dummy_text").attr("name",'snap_poll_answer['+mainid[1]+'][]').removeClass('dummy_text');// $('#Questionsedit_'+mainid[1]).find('.answers_input').append('<input type="text" name="snap_poll_answer['+mainid[1]+'][]" class="txtbox"  />');
}if($('#Questionsedit_'+mainid[1]).find(".addanswers")){$('#Questionsedit_'+mainid[1]).find(".addanswers").attr("id",mainid[1]).removeClass('addanswers');}});},200);}},{key:'submit',value:function submit(e){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");//let learnerID = Common.getUserData("id", true);
var formData=new FormData();var snap_poll_add_new_edit_form=$('#snap_poll_add_new_edit_form').serializeArray();var details=[];snap_poll_add_new_edit_form.map(function(key,index){details.push(_defineProperty({},key.name,key.value));formData.append(key.name,key.value);});//alert(JSON.stringify(details));
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"personal",{method:"POST",//data: formData,
headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()//'Content-Type': 'application/json'
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("","Poll saved successfully. Assign this poll to your assessor(s).","success");$("#formfeed").click();$("#savedform").click();}});}},{key:'getQuestype',value:function getQuestype(e){//alert(JSON.stringify(e));
// var div = this.refs.node.parentNode.parentNode.id;
// //alert("#"+div+" #cmbPollQuestionType");
// let id = div.split('_');
// id= id[1];
// id="cmbPollQuestionType"+id;
var qtype=document.querySelectorAll('.qtype');var ansdiv=document.querySelectorAll('.ansdiv');// Set their ids
for(var i=0;i<qtype.length;i++){qtype[i].id='cmbPollQuestionType_'+i;}for(var i=0;i<ansdiv.length;i++){ansdiv[i].id='PollAnswertr_'+i;}var id=e.target.id;var ansid=id.split('_');ansid=ansid[1];if($("#"+id).val()==2){$("#PollAnswertr_"+ansid).hide();// $("#PollAnswertr_"+ansid +' :input').attr('disabled',true);
}else{$("#PollAnswertr_"+ansid).show();$("#PollAnswertr_"+ansid+' :input').removeAttr('disabled');}}},{key:'render',value:function render(){var _this4=this;//alert(this.state.mailsents);
// alert(JSON.stringify(this.state.pollQuestions));
var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var date=new Date();var display_ansdiv='';var dis='';var polls=this.state.poll_answers.map(function(poll,k){var ans_length=poll.answer.length-1;if(poll.type=='2'){display_ansdiv='none';dis='';}else{display_ansdiv='block';dis="disabled";}var answ='';if(poll.answer!=undefined){answ=poll.answer.map(function(ans,index){if(ans.snap_poll_answer!=''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'chc_'+index,id:'answersedit_'+index,className:'child_inputs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'snap_poll_answer['+k+'][]',className:'txtbox dummy_text',type:'text',defaultValue:ans.snap_poll_answer}));}});}if(poll.question!=""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'pac_'+k,id:'Questionsedit_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox',id:'question1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdback-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Question type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'snap_poll_type['+k+']',className:'qtype dummy_text_select',defaultValue:poll.type,onChange:function onChange(e){return _this4.getQuestype(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Multiple choice question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Open ended question')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',defaultValue:poll.question,name:'snap_poll_question['+k+']',id:'txtPollQuestion',className:'snap_textbox dummy_text_parent'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-right ansdiv',style:{display:display_ansdiv}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'Main_answer_div1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'answer_div11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Answer Choices'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl addanswers',id:k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Addmore__["a" /* default */],{polls_sent:answ,selector:'answersedit',limit:4,AddLabel:'+ Add Choices',DeleteLabel:'X',compType:'child',editType:'edit',startId:ans_length,refreshScroll:function refreshScroll(e){return _this4.renameInput(e);},parent:'Questionsedit',subType:'subtype'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'snap_poll_answer['+k+'][]',className:'txtbox dummy_text',type:'text',disabled:dis}))))))));}});//const {feedbacks} = this.props;
var rows=this.state.pageOfItems.map(function(feedback,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'feedback_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedback.sno),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedback.poll_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedback.createddate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this4.fnGetmails(feedback.snap_poll_id);},href:'javascript:void(0)'},feedback.no_of_time_sent)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/saveicon.png",onClick:function onClick(){return _this4.fnGetSaveAsPage(feedback.snap_poll_id);}})));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},'Currently you do not have any feedback form. You can create feedback forms by clicking',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'',href:'javascript:void(0);',onClick:function onClick(e){return _this4.getForm(e);}},' here'))):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'viewfdbktble'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pageContent',style:{display:this.state.show}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',border:'0',className:'myjourney-table tablesorter',cellPadding:'0',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'SNo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Form Title',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created date',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No of time sent',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Save as'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_Pagination__["a" /* default */],{items:this.state.feedbacks,onChangePage:function onChangePage(e){return _this4.onChangePage(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pagecontent1',style:{display:this.state.hide}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content_poll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'snap_poll_add_new_edit_form',name:'snap_poll_add_new_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gradientbg gradientbg1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Form Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'created_date',value:date,format:'Y-m-d'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'lr_id',value:learnerID}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Titleinput__["a" /* default */],{title:this.state.snap_poll_title})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-content',id:'Main_Question_div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Addmore__["a" /* default */],{polls_sent:polls,selector:'Questionsedit',limit:6,AddLabel:'+ Add Questions',DeleteLabel:'X',compType:'parent',editType:'edit',startId:this.state.length,refreshScroll:function refreshScroll(e){return _this4.renameInput(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'graybox',id:'question1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdback-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Question type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'snap_poll_type[0]',className:'qtype dummy_text_select',onChange:function onChange(e){return _this4.getQuestype(e);},disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Multiple choice question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Open ended question')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'snap_poll_question[0]',id:'txtPollQuestion',className:'snap_textbox dummy_text_parent',disabled:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-right ansdiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'Main_answer_div1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'answer_div11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Answer Choices'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-cntrl addanswers',id:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Addmore__["a" /* default */],{selector:'answersedit',limit:4,AddLabel:'+ Add Choices',DeleteLabel:'X',compType:'child',startId:'0',editType:'edit',refreshScroll:function refreshScroll(e){return _this4.renameInput(e);},parent:'Questionsedit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'snap_poll_answer[]',className:'txtbox dummy_text',type:'text'})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSubmit',id:'',value:'Save & Send',alt:'Save',title:'Save',className:'button-accept',onClick:function onClick(e){return _this4.submit(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSubmit',id:'',value:'Save',alt:'Save',title:'Save',className:'button-accept',onClick:function onClick(e){return _this4.submit(e);}})))))));}}]);return IseekView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekView);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Titleinput=function(_Component){_inherits(Titleinput,_Component);function Titleinput(props){_classCallCheck(this,Titleinput);var _this=_possibleConstructorReturn(this,(Titleinput.__proto__||Object.getPrototypeOf(Titleinput)).call(this,props));_this.state={snap_poll_title:''};return _this;}_createClass(Titleinput,[{key:'titleChange',value:function titleChange(e){this.setState({snap_poll_title:e.target.value});}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.title!=undefined){this.setState({snap_poll_title:nextProps.title});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'255',name:'snap_poll_title',id:'txtPollTitle',className:'snap_textbox',value:this.state.snap_poll_title,onChange:function onChange(e){return _this2.titleChange(e);}});}}]);return Titleinput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Titleinput);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Pagination__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekResults=function(_Component){_inherits(IseekResults,_Component);function IseekResults(props){_classCallCheck(this,IseekResults);var _this=_possibleConstructorReturn(this,(IseekResults.__proto__||Object.getPrototypeOf(IseekResults)).call(this,props));_this.state={results:[],pageOfItems:[],title:'',sent_date:'',sent_to:'',received_from:'',snap_assigned_id:'',feedbacks:[],show:'block',hide:'none'};_this.fnGetResults=_this.fnGetResults.bind(_this);_this.getExcel=_this.getExcel.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);return _this;}_createClass(IseekResults,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.feedbacksResults!=undefined){//alert(JSON.stringify(nextProps.feedbacksResults));
this.setState({feedbacks:nextProps.feedbacksResults,pageOfItems:nextProps.feedbacksResults,show:'block',hide:'none'});}}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});}},{key:'getExcel',value:function getExcel(){//alert('im in');
var assigned_id=this.state.snap_assigned_id;var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var domain=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */];//alert(assigned_id);
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/generate-excel',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({assignid:assigned_id,learnerID:learnerID,domainUrl:domain})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson));
var path=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/admin/'+responseJson.data;window.open(path,'_blank');});}},{key:'fnGetResults',value:function fnGetResults(assignedid){var _this2=this;//alert(assignedid);
var assignid=assignedid;var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/iseek-getresults',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({assignid:assignid,learnerID:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson));
if(responseJson.status!=0){_this2.setState({results:responseJson.results,title:responseJson.snaps.title,sent_date:responseJson.snaps.sent_date,sent_to:responseJson.snaps.sent_to,received_from:responseJson.snaps.received_from,snap_assigned_id:responseJson.snaps.snap_assigned_id,show:'none',hide:'block'});}});// $("#pageContent_fb").hide();
// $("#Content").show();
}},{key:'render',value:function render(){var _this3=this;//alert(this.state.feedbacks);
var res=this.state.results.map(function(result,ke){var ans="";if(result.type==1){ans=result.answers.map(function(answ,ki){if(answ.answer!=''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'feedresult_'+ki},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pollres'},answ.answer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pollprogress'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:"100%"},dangerouslySetInnerHTML:{__html:answ.bar}})))));}});}var div_vote=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'orgtxt',style:{border:'#FF0000 0px solid'}},'(Total Votes : ',result.total_vote,')');result.answers.length<=0||result.type==2?div_vote=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'view-ans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:function onClick(e){return _this3.getExcel(e);},className:'orange1'},'Click here to view answers')):div_vote=div_vote;if(result.question!=''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fresult_'+ke,className:'fbres-whitebg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluetxt bluetxt-ans'},result.question),div_vote,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line-fb-page'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inspiration'},ans));}});//const {feedbacksResults} = this.props;
var rows=this.state.pageOfItems.map(function(feedbackresult,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'feedbackresult_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedbackresult.sno),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedbackresult.poll_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,feedbackresult.assigneddate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/viewicon.png",alt:'',onClick:function onClick(){return _this3.fnGetResults(feedbackresult.assigned_id);}}),feedbackresult.new_snap!=0?feedbackresult.new_snap:''));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},'You have not sought any feedback from your contacts yet. Please send your feedback questionnaire to your contacts and get their feedback.')):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ResultpageContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fbresulttbl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pageContent_fb',style:{display:this.state.show}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',border:'0',className:'myjourney-table tablesorter',cellPadding:'0',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'S.No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Form Title',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sent date',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View results'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helpers_Pagination__["a" /* default */],{items:this.state.feedbacks,onChangePage:function onChangePage(e){return _this3.onChangePage(e);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Content',style:{display:this.state.hide}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',width:'100%',border:'1',className:'myjourney-table',style:{borderCollapse:'collapse',border:'solid 1px #e7e7e7'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'bluetxt'},this.state.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'tr_polls1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{border:'0',cellPadding:'0',width:'100%',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fbresultpage-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fbresulttitbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fb-result-date'},'Sent Date: ',this.state.sent_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fb-result-mail'},'Sent to:\xA0',this.state.sent_to,'\xA0people',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Received from:\xA0 ',this.state.received_from,'\xA0people')),res,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontWeight:'bold',clear:'both',padding:'15px 0 15px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:function onClick(e){return _this3.getExcel(e);},className:'orange1'},'Click here to view all answers')))))))))))));}}]);return IseekResults;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekResults);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IseekObservers__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IseekAssessors__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IseekOthers__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IseekCreateform__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IseekSavedform__ = __webpack_require__(692);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekForm=function(_Component){_inherits(IseekForm,_Component);function IseekForm(props){_classCallCheck(this,IseekForm);var _this=_possibleConstructorReturn(this,(IseekForm.__proto__||Object.getPrototypeOf(IseekForm)).call(this,props));_this.state={Observers:[],Assessors:[],Others:[],savedForms:[],polldata:'',mails:"",ids:[],idsarray:[],editsele:''};_this.getData=_this.getData.bind(_this);_this.getEmails=_this.getEmails.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.clearForm=_this.clearForm.bind(_this);return _this;}_createClass(IseekForm,[{key:'clearForm',value:function clearForm(){this.setState({polldata:'',mails:''});}},{key:'onSubmit',value:function onSubmit(e){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var pollid=this.state.polldata;pollid=pollid.split('_');pollid=pollid[0];var domain=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */];//alert(JSON.stringify(this.state.ids));
// var  date = new Date();
// alert(pollid);
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'iseek/assign-assessor',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,roles:this.state.idsarray,snap_poll_id_fk:pollid,snap_assessor_id_fk:this.state.ids,domain:domain})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//alert(responseJson.status);
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this2.clearForm();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("",responseJson.message,"success");if($('input[type="checkbox"]').is(':checked')){$('input[type="checkbox"]').prop('checked',false);}$("#seekfeedback-right").css('display','none');//$("#viewfeed").click();
}});}},{key:'getData',value:function getData(data){// alert(data);
this.setState({polldata:data});}},{key:'getEmails',value:function getEmails(ids){var _this3=this;//alert(emails);
__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/getmails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,role_id:ids})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status!=0){_this3.setState({mails:responseJson.mails,ids:responseJson.ids,idsarray:responseJson.idsarray});}});}// show(){
// }
// showmail(){
// }
},{key:'getSeekTables',value:function getSeekTables(){var _this4=this;var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);var mentor=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('mentor',true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/iseek-tables',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,mentor:mentor})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){_this4.setState({Observers:responseJson.Observers,Assessors:responseJson.Assessors,Others:responseJson.Others,savedForms:responseJson.savedForms});}});}},{key:'componentDidMount',value:function componentDidMount(){this.getSeekTables();setTimeout(function(){$(".accordion_coach1").smk_Accordion();},500);}},{key:'render',value:function render(){var _this5=this;// alert(this.state.polldata);
if(this.state.polldata!=""&&this.state.polldata!="undefined"){// this.show();
$("#seekfeedback-right").css('display','block');}var polltitle=this.state.polldata;polltitle=polltitle.split('_');polltitle=polltitle[1];if(this.state.mails!=""&&this.state.mails!="undefined"){$("#divToaddress").css('display','none');// this.showmail();
}else if(this.state.mails==''){$("#divToaddress").css('display','block');}//alert(JSON.stringify(this.state.editsele));
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbk-tab1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Collect responses to your feedback!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),'Send your Feedback Form to your Observers, Assessors, or anybody else you\'d like to. Choose the people from the groups, or type in a valid email ID below, and send.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seekfeedback-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_coach1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head rgtDiv'},'Create a new form'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IseekCreateform__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head rgtDiv',id:'savedform',onClick:function onClick(e){return _this5.getSeekTables(e);}},'Use a saved form'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IseekSavedform__["a" /* default */],{savedForms:this.state.savedForms,sendData:this.getData}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head rgtDivShw color'},'My Observers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IseekObservers__["a" /* default */],{Observers:this.state.Observers,sendEmails:this.getEmails}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head rgtDivShw color'},'My Assessors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__IseekAssessors__["a" /* default */],{Assessors:this.state.Assessors,sendEmails:this.getEmails}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head rgtDivShw color'},'My other contacts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:'none'},id:'others'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__IseekOthers__["a" /* default */],{Others:this.state.Others,getSeekTables:function getSeekTables(e){return _this5.getSeekTables();},sendEmails:this.getEmails}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seekfeedback-right',id:'seekfeedback-right',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Form Title:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'blue-bg'},polltitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'To:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'grey-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.state.mails}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divToaddress',style:{display:'block'}},'Please select the people from your Observers, Assessors, or Others to send this feedback form to'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',value:this.state.mails}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSend',id:'',value:'Send',className:'button-accept',alt:'Send',title:'Send',onClick:function onClick(e){return _this5.onSubmit(e);}}))));}}]);return IseekForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekForm);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekObservers=function(_Component){_inherits(IseekObservers,_Component);function IseekObservers(props){_classCallCheck(this,IseekObservers);var _this=_possibleConstructorReturn(this,(IseekObservers.__proto__||Object.getPrototypeOf(IseekObservers)).call(this,props));_this.getCheck=_this.getCheck.bind(_this);return _this;}_createClass(IseekObservers,[{key:'getCheck',value:function getCheck(){var checkedValues=$('.chk_slct:checked').map(function(){return this.value;}).get();//alert(checkedValues);
// var values = checkedValues.split('_');
// values = (values[1])+values[2];
this.props.sendEmails(checkedValues);//    this.setState({
// 	checkedValues: checkedValues
// });
// this.getData();
}},{key:'render',value:function render(){var _this2=this;var Observers=this.props.Observers;//alert(JSON.stringify({Observers}));
var rows=Observers.map(function(observer,i){var value=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:"chkAssessor_id"+value,id:"chkAssessor_id"+value,value:'OB_'+observer.assessor_id+'_'+observer.assessor_name+'_'+observer.email,className:'chk_slct',onClick:function onClick(e){return _this2.getCheck(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,observer.assessor_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,observer.email));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3'},'No Observer(s) found.')):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',border:'1',style:{border:'solid 1px #e7e7e7'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows));}}]);return IseekObservers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekObservers);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekAssessors=function(_Component){_inherits(IseekAssessors,_Component);function IseekAssessors(props){_classCallCheck(this,IseekAssessors);var _this=_possibleConstructorReturn(this,(IseekAssessors.__proto__||Object.getPrototypeOf(IseekAssessors)).call(this,props));_this.getCheck=_this.getCheck.bind(_this);return _this;}_createClass(IseekAssessors,[{key:'getCheck',value:function getCheck(){var checkedValues=$('.chk_slct:checked').map(function(){return this.value;}).get();//alert(checkedValues);
// var values = checkedValues.split('_');
// values = (values[1])+values[2];
this.props.sendEmails(checkedValues);//    this.setState({
// 	checkedValues: checkedValues
// });
// this.getData();
}},{key:'render',value:function render(){var _this2=this;var Assessors=this.props.Assessors;var rows=[];if(Assessors!=undefined||Assessors!=null){rows=Assessors.map(function(assessor,i){var value=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:"chkAssessor_id"+value,id:"chkAssessor_id"+value,value:'AS_'+assessor.assessor_id+'_'+assessor.assessor_name+'_'+assessor.email,className:'chk_slct',onClick:function onClick(e){return _this2.getCheck(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,assessor.assessor_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,assessor.email));});}rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3'},'No Assessor(s) found.')):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',border:'1',style:{border:'solid 1px #e7e7e7'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows));}}]);return IseekAssessors;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekAssessors);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var IseekOthers=function(_Component){_inherits(IseekOthers,_Component);function IseekOthers(props){_classCallCheck(this,IseekOthers);var _this=_possibleConstructorReturn(this,(IseekOthers.__proto__||Object.getPrototypeOf(IseekOthers)).call(this,props));_this.state={isOpen:false};_this.close_popup=_this.close_popup.bind(_this);_this.getCheck=_this.getCheck.bind(_this);_this.toggleModal=_this.toggleModal.bind(_this);return _this;}_createClass(IseekOthers,[{key:'getCheck',value:function getCheck(){var checkedValues=$('.chk_slct:checked').map(function(){return this.value;}).get();//alert(checkedValues);
// var values = checkedValues.split('_');
// values = (values[1])+values[2];
this.props.sendEmails(checkedValues);//    this.setState({
// 	checkedValues: checkedValues
// });
// this.getData();
}// getData(){
// 	var emails = this.state.checkedValues;
// 	//alert(emails);
// }
},{key:'close_popup',value:function close_popup(e){//$('#close_modal').click();
$("#window_trans1").css('display','none');$("#popup_window").css('display','none');}},{key:'toggleModal',value:function toggleModal(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);window.swal({//title: 'Add new contact',
showCancelButton:true,confirmButtonText:'Submit',animation:false,showLoaderOnConfirm:true,html:'<form id="assessor_add_form" name="assessor_add_form"  class="assessor_add_form">'+'<input type="hidden"  name="others_learner_id" id="others_learner_id"  className="swal2-input txtbox" value="" />'+'<input type="text"  name="others_name" placeholder="Name"  class="swal2-input txtbox" autofocus />'+'<input type="text"  name="others_email" placeholder="Email"   class="swal2-input txtbox"  />'+'</form>',preConfirm:function preConfirm(){// const values = [];
//alert(learnerID);	
$("#others_learner_id").val(learnerID);var formData=new FormData();//let details = [];
$.each($('#assessor_add_form').serializeArray(),function(i,field){return(//details.push({[field.name]:field.value})
formData.append(field.name,field.value));});return Promise.resolve(formData);},allowOutsideClick:true}).then(function(result){if(result){fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"iseek-others",{method:"POST",//data: formData,
headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()//'Content-Type': 'application/json'
},body:result}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.props.getSeekTables();}});}});}},{key:'render',value:function render(){var _this3=this;// alert(JSON.stringify(this.state.checkedValues));
var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var Others=this.props.Others;var rows=[];if(Others!=undefined||Others!=null){rows=Others.map(function(other,i){var value=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:"chkAssessor_id"+value,id:"chkAssessor_id"+value,value:'OT_'+other.snap_others_id_pk+'_'+other.others_name+'_'+other.others_email,className:'chk_slct',onClick:function onClick(e){return _this3.getCheck(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,other.others_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,other.others_email));});}rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3'},'No contacts found.')):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',border:'1',style:{border:'solid 1px #e7e7e7'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',align:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Add new contacts')))))));}}]);return IseekOthers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekOthers);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var IseekSavedform=function(_Component){_inherits(IseekSavedform,_Component);function IseekSavedform(props){_classCallCheck(this,IseekSavedform);var _this=_possibleConstructorReturn(this,(IseekSavedform.__proto__||Object.getPrototypeOf(IseekSavedform)).call(this,props));_this.state={pollid:'',senteditf:''};_this.getPollId=_this.getPollId.bind(_this);_this.buttonClick=_this.buttonClick.bind(_this);return _this;}_createClass(IseekSavedform,[{key:'getPollId',value:function getPollId(e){this.setState({pollid:e.target.value});}},{key:'buttonClick',value:function buttonClick(){// alert(this.state.pollid);
var polldata=this.state.pollid;this.props.sendData(polldata);}// componentWillReceiveProps(nextProps) {
//         if(nextProps.sentedits!=undefined){
//         	//alert(nextProps.sentedits);
//         	if(nextProps.sentedits == 'selected'){
// 	       	$("#cmbPollQuestion option:last").attr("selected", "selected");
// 	       	$("#btnsubpoll").click();
//           	}
//         }
//    }
},{key:'render',value:function render(){var _this2=this;var savedForms=this.props.savedForms;// const {sentedits} = this.props;
// alert(sentedits);
//alert(JSON.stringify(savedForms));
var rows=null;if(savedForms!=undefined||savedForms!=null){rows=savedForms.map(function(savedform,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:savedform.snap_poll_id_pk+'_'+savedform.snap_poll_title},savedform.snap_poll_title);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-content existing-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'cmbPollQuestion',id:'cmbPollQuestion',className:'cmbbox_form',onChange:function onChange(e){return _this2.getPollId(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),rows),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fdbk-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',value:this.state.pollid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSubmit',id:'btnsubpoll',value:'Select',className:'button-accept',title:'Select',alt:'Select',onClick:this.buttonClick}))));}}]);return IseekSavedform;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IseekSavedform);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActiveObservers__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__YetactiveObservers__ = __webpack_require__(695);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ObserverView=function(_Component){_inherits(ObserverView,_Component);function ObserverView(props){_classCallCheck(this,ObserverView);var _this=_possibleConstructorReturn(this,(ObserverView.__proto__||Object.getPrototypeOf(ObserverView)).call(this,props));_this.state={};return _this;}_createClass(ObserverView,[{key:'otherFunc',value:function otherFunc(){this.props.callFun();}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var actyetact=this.props.actyetact;var activeob='';var yetactiveob='';if(actyetact!=undefined||actyetact!=null){activeob=actyetact.map(function(active,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ActiveObservers__["a" /* default */],{key:'active_'+i,activeob:active.activeob});});}if(actyetact!=undefined||actyetact!=null){yetactiveob=actyetact.map(function(yetob,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__YetactiveObservers__["a" /* default */],{key:'yetob_'+i,yetactiveob:yetob.yetactiveob});});}//alert(JSON.stringify({actyetact}));
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey viewobservers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ChildVerticalTab_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list ver_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',id:'actob',onClick:this.otherFunc.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Active Observers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',id:'yetob',onClick:this.otherFunc.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Yet to be Observers '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container ver_1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content activeobs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activeobs-tbl'},activeob)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticaltab-content inactiveobs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inactiveobs-tbl'},yetactiveob),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'testforms'})))));}}]);return ObserverView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ObserverView);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Pagination__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ActiveObservers=function(_Component){_inherits(ActiveObservers,_Component);function ActiveObservers(props){_classCallCheck(this,ActiveObservers);var _this=_possibleConstructorReturn(this,(ActiveObservers.__proto__||Object.getPrototypeOf(ActiveObservers)).call(this,props));_this.state={pageOfItems:[],activeob:props.activeob};_this.onChangePage=_this.onChangePage.bind(_this);return _this;}_createClass(ActiveObservers,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// alert('im in');
if(nextProps.activeob!=undefined){this.setState({activeob:nextProps.activeob,pageOfItems:nextProps.activeob});}}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});}},{key:'render',value:function render(){var _this2=this;//const {activeob} = this.props;
//alert(JSON.stringify(activeob));
var rows=this.state.pageOfItems.map(function(active,i){var value=active.sno;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'actobserver_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,active.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,active.relationship),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,active.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,active.phno));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},'You have no active Observers.')):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{border:'0',width:'100%',className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sno'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Observer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Relationship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Contact No'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__helpers_Pagination__["a" /* default */],{items:this.state.activeob,onChangePage:function onChangePage(e){return _this2.onChangePage(e);}})));}}]);return ActiveObservers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActiveObservers);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Pagination__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var YetactiveObservers=function(_Component){_inherits(YetactiveObservers,_Component);function YetactiveObservers(props){_classCallCheck(this,YetactiveObservers);var _this=_possibleConstructorReturn(this,(YetactiveObservers.__proto__||Object.getPrototypeOf(YetactiveObservers)).call(this,props));_this.state={checkedValues:[],txtSubject:'',mailtxtcontractcont:'',pageOfItems:[],yetactiveob:props.yetactiveob,counter:'1',checkedmails:[]};//alert(JSON.stringify(props.yetactiveob));
_this.handleChange=_this.handleChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);// this.getSelectedRowKeys = this.getSelectedRowKeys.bind(this);
_this.onSelectAll=_this.onSelectAll.bind(_this);_this.onRowSelect=_this.onRowSelect.bind(_this);_this.clearForm=_this.clearForm.bind(_this);return _this;}_createClass(YetactiveObservers,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){//alert('im in');
//	$('input:checkbox').removeAttr('checked');
if(nextProps.yetactiveob!=undefined){this.setState({yetactiveob:nextProps.yetactiveob,pageOfItems:nextProps.yetactiveob});}}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'clearForm',value:function clearForm(){this.refs.table.setState({selectedRowKeys:[]});this.refs.table.cleanSelected();$('form#mentorhistory')[0].reset();//$('input:checkbox').removeAttr('checked');
this.setState({checkedmails:[]});}},{key:'onChangePage',value:function onChangePage(pageOfItems){//alert(pageOfItems);
// update state with new page of items
this.setState({pageOfItems:pageOfItems});}},{key:'onSubmit',value:function onSubmit(e){var _this2=this;// e.preventDefault();
var learnerID=__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["i" /* getUserData */]("id",true);__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'add-observer/resentmail',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({subject:this.state.txtSubject,message:this.state.mailtxtcontractcont,mailids:this.state.checkedmails,learner_id:learnerID})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson));
__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this2.clearForm();$('#observermail').hide();__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["o" /* message */]("",responseJson.message,"success");//     if($('input[type="checkbox"]').is(':checked')){
// 	$('input[type="checkbox"]').prop('checked',false);
// }
}});}// getSelectedRowKeys(email) {
//   // I think this answers your questions
//   // alert('here');
// 	 alert(email);
//     // this.setState({checkedmails: this.state.checkedmails.concat([email])});
//     // alert(this.state.checkedmails);
//   //    var newState = React.addons.update(this.state, {
//   //     list : {
//   //       $push : [newObject]
//   //     }
//   // });
//   // this.setState(newState);
//    alert(this.refs.table.state.selectedRowKeys);
//    // let formData = new FormData();
//    //  let getdata=$('#getdata').serializeArray();
//    //  let details = [];
//    //     getdata.map((key,index)=>{
//    //         details.push({[key.name]:key.value});
//    //         formData.append(key.name,key.value);
//    //     });
//    //     alert(JSON.stringify(details));
//  }
},{key:'onRowSelect',value:function onRowSelect(row,isSelected){var rowStr="";// alert(isSelected);
var email=row['email'];//this.getSelectedRowKeys(email);
if(isSelected==true){//this.setState({checkedmails: this.state.checkedmails.concat([email])});
var joined=this.state.checkedmails.concat(email);this.setState({checkedmails:joined});}else if(isSelected==false){//  	this.setState({
//   data: update(this.state.data, {$splice: [[index, 1]]})
// })
var array=this.state.checkedmails;var index=array.indexOf(email);array.splice(index,1);this.setState({checkedmails:array});// var joined = this.state.checkedmails.filter(function(email) { return user.id != member.id });
// this.setState({ users: users });
//alert(this.state.checkedmails);
}}},{key:'onSelectAll',value:function onSelectAll(isSelected,currentDisplayAndSelectedData){// alert("is select all: " + isSelected);
// alert("Current display and selected data: ");
if(isSelected==true){var mails=this.state.checkedmails;for(var i=0;i<currentDisplayAndSelectedData.length;i++){//alert(currentDisplayAndSelectedData[i]['email']);
var email=currentDisplayAndSelectedData[i]['email'];//alert(email);
var mail=mails.push(email);//alert(mail);
//let mail = mail.join(',');
}this.setState({mails:mails});//alert(this.state.checkedmails);
}else if(isSelected==false){//  	this.setState({
//   data: update(this.state.data, {$splice: [[index, 1]]})
// })
var array=this.state.checkedmails;for(var _i=0;_i<currentDisplayAndSelectedData.length;_i++){//alert(currentDisplayAndSelectedData[i]['email']);
var _email=currentDisplayAndSelectedData[_i]['email'];//alert(email);
var index=array.indexOf(_email);array.splice(index,1);//alert(mail);
//let mail = mail.join(',');
}this.setState({checkedmails:array});// var joined = this.state.checkedmails.filter(function(email) { return user.id != member.id });
// this.setState({ users: users });
//alert(this.state.checkedmails);
}}},{key:'componentDidMount',value:function componentDidMount(){$('#observermail').hide();this.refs.table.cleanSelected();this.refs.table.setState({selectedRowKeys:[]});//    $( "#checkall" ).on('click',function(){
//   if ($("#checkall").is(':checked')) {
//     $('.chk_slct').prop("checked", true);
//   }
//   else
//   {
//     $('.chk_slct').prop("checked", false);
//   }
// });
jQuery("#btnSubmit").on('click',function(){var clickedonce=$('input[type="checkbox"]:checked').length;if(clickedonce<=0){__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["o" /* message */]('Validation error','Please select an Observer to send mail.',"error");//jQuery('#msgEmailChk').show();
$('#observermail').hide();}else{// var checkedValues = $('.chk_slct:checked').map(function() {
//     return this.value;
// }).get();
//          this.setState({
//        checkedValues: checkedValues
//      });
//jQuery('#msgEmailChk').hide();
$('#observermail').show();}}.bind(this));}},{key:'render',value:function render(){var _React$createElement,_this3=this;if(this.state.checkedmails.length<=0){$("#observermail").css('display','none');}// const {yetactiveob} = this.props;
// alert(JSON.stringify(this.state.pageOfItems));
// let mailids = this.state.checkedValues.map((mailid)=>{
// 	return(
// 		<span>{mailid},</span>
// 		)
// });
var mailids=this.state.checkedmails.join(',');// let rows = this.state.pageOfItems.map((yetactive,i) => {
// 	 var status = yetactive.approved;
// 	 var name = yetactive.name;
// 	 var gender = yetactive.gender;
// 	 var contact = yetactive.contact;
// 	 var status = yetactive.status;
// 	 var value = yetactive.sno;
//          return (
//                  <tr key={`observer_${yetactive.assessor_id}`} id={yetactive.assessor_id}>
//                  		<td><input name={"MentorName"+ name} value={(gender==1) ? gender =  'Mr.'+ name : gender =  'Ms.'+ name} type="hidden" /><input type="checkbox" value={yetactive.email} name={`observer[${value}]`} id={'Chk'+ value} className="chk_slct" /></td>
//                   	<td>{value}</td>
//                 <td>{yetactive.name}</td>
//                 <td>{yetactive.relationship}</td>
//                 <td>{yetactive.email}</td>
//                 <td>{yetactive.isd_code +'-'+yetactive.std_code+ '-'+yetactive.phno}</td>
//                 <td>{(status==2) ? status =  'declined' : status =  'Awaiting'}</td>
//                  </tr>
//               )
//      });
var selectRowProp={mode:'checkbox',clickToSelect:true,onSelect:this.onRowSelect,onSelectAll:this.onSelectAll};var options={noDataText:'You have no pending Observers.'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'getdata'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["BootstrapTable"],(_React$createElement={ref:'table',data:this.state.yetactiveob,containerClass:'myjourney-table'},_defineProperty(_React$createElement,'ref','table'),_defineProperty(_React$createElement,'selectRow',selectRowProp),_defineProperty(_React$createElement,'options',options),_defineProperty(_React$createElement,'pagination',true),_React$createElement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'sno',isKey:true},'Sno'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'name'},'Observer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'relationship'},'Relationship'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'email'},'Email ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'contact'},'Contact No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_table__["TableHeaderColumn"],{dataField:'status'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'observer-btn',id:'mailbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',name:'btnSubmit',id:'btnSubmit',value:'Email Request',className:'button-accept mail-icon',alt:'Email Request',title:'Email Request'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'mentorhistory',id:'mentorhistory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'viewobservers',id:'observermail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-cont5 tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'To '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},mailids)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'Subject ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'txtSubject',name:'txtSubject',className:'textbox',onChange:function onChange(e){return _this3.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{valign:'top',className:'mentermaillft'},'Message ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,' To review my request to become my observer, click here'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'mailtxtcontractcont',cols:'20',rows:'15',id:'mailtxtcontractcont',onChange:function onChange(e){return _this3.handleChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidchkToaddress',id:'hidchkToaddress',value:this.state.checkedValues}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidName',id:'hidName',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'Names',id:'Names',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'Emails',id:'Emails',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pwdpagespan',style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'),' Required fields'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermaillft'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mentermailrgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button mailbtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Send mail',className:'mail-icon',alt:'Send mail',title:'Send mail',onClick:function onClick(e){return _this3.onSubmit(e);}}))))))));}}]);return YetactiveObservers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YetactiveObservers);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Mentorhistory=function(_Component){_inherits(Mentorhistory,_Component);function Mentorhistory(props){_classCallCheck(this,Mentorhistory);return _possibleConstructorReturn(this,(Mentorhistory.__proto__||Object.getPrototypeOf(Mentorhistory)).call(this,props));}_createClass(Mentorhistory,[{key:"render",value:function render(){var mentorhistory=this.props.mentorhistory;var rows=mentorhistory.map(function(mentor,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,mentor.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,mentor.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,mentor.visits),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,mentor.tendays));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{align:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"5"},"No Observers Found.")):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mentor_table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{border:"0",width:"100%",className:"myjourney-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"SNo"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Observer Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Email ID"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Total visits"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Visits in last 10 days"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,rows)));}}]);return Mentorhistory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Mentorhistory);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ObserverForm=function(_Component){_inherits(ObserverForm,_Component);function ObserverForm(props){_classCallCheck(this,ObserverForm);var _this=_possibleConstructorReturn(this,(ObserverForm.__proto__||Object.getPrototypeOf(ObserverForm)).call(this,props));_this.state={txtname:'',txtemail:'',lstrelation:'',OptGender:'1',txtphoneISD1:'',txtphoneSTD:'',txtphone:''};_this.handleChange=_this.handleChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.clearForm=_this.clearForm.bind(_this);return _this;}_createClass(ObserverForm,[{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'clearForm',value:function clearForm(){var txtname=$("#txtname").val("");var txtemail=$("#txtemail").val("");var lstrelation=$("#lstrelation").val("");var OptGender=$("#OptGender").val("");var txtphoneISD1=$("#txtphoneISD1").val("");var txtphoneSTD=$("#txtphoneSTD").val("");var txtphone=$("#txtphone").val("");this.setState({txtname:'',txtemail:'',lstrelation:'',OptGender:'1',txtphoneISD1:'',txtphoneSTD:'',txtphone:''});}},{key:'onSubmit',value:function onSubmit(e){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var email=this.state.txtemail;var product_name=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("productName",true);var learnerID=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("id",true);//alert(product_name);
//var product_name = 'MBA Common';
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'add-observer',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({assessor_name:this.state.txtname,email:this.state.txtemail,uname:this.state.txtemail,relationship:this.state.lstrelation,gender:this.state.OptGender,isd_code:this.state.txtphoneISD1,//std_code: this.state.txtphoneSTD,
phone:this.state.txtphone,is_mentor:1,is_approved:0,is_approved_mentor:0,awaiting_deleted:0,learner_id:learnerID,product_name:product_name})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status==0){if(responseJson.errors=='<ul><li class=\"error\">custom</li></ul>'){_this2.clearForm();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("",'Your request has been sent successfully.  When the person accepts your request, he/she will become your Observer.',"success");}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}}else{_this2.clearForm();__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("",'Your request has been sent successfully.  When the person accepts your request, he/she will become your Observer.',"success");}});}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this3=this;var formtodata=this.props.formtodata;//alert(JSON.stringify(formtodata));
var rows=null;if(formtodata!=undefined||formtodata!=null){rows=formtodata.map(function(formdata,i){var row='';if(formdata.relations!=undefined){row=formdata.relations.map(function(rela,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'observerkeys_'+k,value:rela},rela);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'lstrelation',key:'selectformobserver_'+i,id:'lstrelation',onChange:function onChange(e){return _this3.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--Select--'),row);});}var country='';if(formtodata!=undefined||formtodata!=null){country=formtodata.map(function(formdata,index){var row='';var value=index+1;if(formdata.country!=undefined){row=formdata.country.map(function(country){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'selectform'+country.printableName,value:country.numCode},country.printableName+' - '+country.numCode);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'txtphoneISD1',key:'formkey_'+value,id:'txtphoneISD1',onChange:function onChange(e){return _this3.handleChange(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--Select--'),row);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'observer-msg',style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'add-observer',style:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'customerid',id:'customerid',type:'hidden'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'new-observer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'newobserver-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Name ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'txtname',type:'text',id:'txtname',onChange:function onChange(e){return _this3.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divName',className:'error'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email ID ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'txtemail',type:'text',id:'txtemail',className:'textbox_gray',onChange:function onChange(e){return _this3.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'msgemail',className:'error'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Relationship ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,rows,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divDesignation',className:'error'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'newobserver-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gender ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ratiobg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'OptGender',className:'rdbtn',type:'radio',value:'1',checked:this.state.OptGender==='1',onChange:function onChange(e){return _this3.handleChange(e);}}),'Male',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'OptGender',className:'rdbtn',type:'radio',value:'0',checked:this.state.OptGender==='0',onChange:function onChange(e){return _this3.handleChange(e);}}),'Female'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Contact No ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redstar'},'*'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,country,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'msgphoneISD1',className:'error'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-code'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'txtphone',type:'text',className:'textbox_gray',id:'txtphone',maxLength:'10',onChange:function onChange(e){return _this3.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10 digit Mobile Number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'msgphoneSTD',className:'error'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'msgphone',className:'error'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'label'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',name:'btnmentors',value:'Add Observer',onClick:function onClick(e){return _this3.onSubmit(e);},alt:'Add Observer',title:'Add Observer'}))))));}}]);return ObserverForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ObserverForm);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var TelecallBook=function(_Component){_inherits(TelecallBook,_Component);function TelecallBook(props){_classCallCheck(this,TelecallBook);var _this=_possibleConstructorReturn(this,(TelecallBook.__proto__||Object.getPrototypeOf(TelecallBook)).call(this,props));_this.state={booked:[],books:[],call_avail:0};_this.getCalender=_this.getCalender.bind(_this);_this.setRate=_this.setRate.bind(_this);return _this;}_createClass(TelecallBook,[{key:'setRate',value:function setRate(time_slot_id,date,time,id){var _this2=this;var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var lr_name=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("fullName",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var corp_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);var rating=$('#'+id).val();fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'telecall/rate-call',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,rating:rating,time_slot_id:time_slot_id,date:date,time:time,lr_name:lr_name,pinid:pinid,pinno:pinno,corp_id:corp_id,role:role})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.props.updateComp('change');}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getList();}},{key:'getCalender',value:function getCalender(call_id,tele_id){this.props.setCalender(call_id,tele_id);}},{key:'getList',value:function getList(){var _this3=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'telecall/booked-details',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,pinid:pinid,pinno:pinno})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){_this3.setState({booked:responseJson.booked,books:responseJson.books,call_avail:responseJson.call_avail});}});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}},{key:'componentDidMount',value:function componentDidMount(){this.getList();}},{key:'render',value:function render(){var _this4=this;var books=void 0,booked=void 0;if(this.state.books!=undefined||this.state.books!=null){books=this.state.books.map(function(calls,i){if(calls!=""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box telecall-status',key:'calls_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You are now eligible for a one-on-one telecall with your E Coach. Please click on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'"Book Now"'),' and pick a slot available with the E Coach and convenient to you. Please do this before.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'bold'}},calls.end_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button-accept',href:'javascript:void(0);',onClick:function onClick(){return _this4.getCalender(calls.call_id,calls.tele_id);}},'Book Now'));}});}if(this.state.booked!=undefined||this.state.booked!=null){booked=this.state.booked.map(function(called,k){var id="cmbRating"+k;var rat_div='';if(called.completed_state==1){if(called.rating==0||called.rating==null){rat_div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orng-box'},'Please rate the E Coach on this telecall from 1 to 10, where ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1 means "I am not satisfied at all"'),' and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10 means "I am extremely happy with it"'),'.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rating'},'I rate this call as',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:"cmbRating"+k,id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Select ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',name:'btnRate',value:'Rate',onClick:function onClick(){return _this4.setRate(called.time_slot_id,called.date,called.time,id);}})));}else{rat_div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'blue-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'I rate this call as  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-txt'},called.rating+'/10'));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'light-graybox',key:'called_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date:'),called.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Time:'),called.time),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Request Status:'),called.status)),rat_div);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{top:"0px"},className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.call_avail==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,books,!booked.length?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'recap-blue-title'},'Telecalls booked by me'),booked):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox light-graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You are not yet eligible for a telecall. Please check this page once you are eligible and book a telecall with your E Coach.')))))));}}]);return TelecallBook;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TelecallBook);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookCall__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_big_calendar__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_big_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_big_calendar__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// a localizer for BigCalendar
__WEBPACK_IMPORTED_MODULE_7_react_big_calendar___default.a.momentLocalizer(__WEBPACK_IMPORTED_MODULE_6_moment___default.a);var $=window.$;var TeleCalender=function(_Component){_inherits(TeleCalender,_Component);function TeleCalender(props){_classCallCheck(this,TeleCalender);var _this=_possibleConstructorReturn(this,(TeleCalender.__proto__||Object.getPrototypeOf(TeleCalender)).call(this,props));_this.state={call_id:props.call_id,tele_id:props.tele_id,events:[],open:false};_this.getPopup=_this.getPopup.bind(_this);_this.onCloseModal=_this.onCloseModal.bind(_this);return _this;}_createClass(TeleCalender,[{key:'onChangeComp',value:function onChangeComp(value){this.props.ChangedComp(value);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'getPopup',value:function getPopup(event){this.setState({open:true,BookComp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BookCall__["a" /* default */],{events:event,closeModal:this.onCloseModal,ChangeComp:this.onChangeComp.bind(this)})});}},{key:'onCloseModal',value:function onCloseModal(){this.setState({open:false});}},{key:'getEvents',value:function getEvents(){var _this2=this;var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var call_id=this.state.call_id;var tele_id=this.state.tele_id;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'telecall/get-events',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,pinid:pinid,pinno:pinno,call_id:call_id,tele_id:tele_id})}).then(function(response){return response.json();}).then(function(responseJson){// alert(JSON.stringify(responseJson));
if(responseJson.status!=0){_this2.setState({events:responseJson.events});}});}},{key:'componentDidMount',value:function componentDidMount(){this.getEvents();}},{key:'render',value:function render(){var _this3=this;var open=this.state.open;var monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];var d=new Date(),jDate=d.getDate(),jMonth=monthNames[d.getMonth()],jYear=d.getFullYear();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{top:"0px"},className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'telecal-reqcalendar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'recap-blue-title'},'E Coach\'s available slots for telecalls'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),' - Dates with this color background denotes availability of E Coach'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'center'}},jMonth+' '+jYear)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_big_calendar___default.a,{popup:true,selectable:true,style:{height:'520px',width:'100%'},views:['month'],defaultView:'month',toolbar:false,events:this.state.events,onSelectEvent:function onSelectEvent(event){return _this3.getPopup(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal___default.a,{open:open,onClose:this.onCloseModal},this.state.BookComp)))));}}]);return TeleCalender;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TeleCalender);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var BookCall=function(_Component){_inherits(BookCall,_Component);function BookCall(props){_classCallCheck(this,BookCall);var _this=_possibleConstructorReturn(this,(BookCall.__proto__||Object.getPrototypeOf(BookCall)).call(this,props));_this.state={call_date:props.events.call_date,chat_time_id:props.events.chat_time_id_pk,id:props.events.id,start:props.events.start,end:props.events.end,call_id:props.events.call_id,tele_id:props.events.tele_id,title:props.events.title1,slots:props.events.slots,cur_time:props.events.curr_time,cur_date:props.events.curr_date,date_call:props.events.date_call,but_hide:'none',show:'block',hide:'none',preferred_time:'',old_img:'',preferred_id:''};_this.showTimeslots=_this.showTimeslots.bind(_this);_this.BookSlot=_this.BookSlot.bind(_this);_this.Slot=_this.Slot.bind(_this);return _this;}_createClass(BookCall,[{key:'showTimeslots',value:function showTimeslots(id){}},{key:'Slot',value:function Slot(time_chat_id,call_id,tele_id){var _this2=this;// alert(time_chat_id);
var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'telecall/book-slot',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,pinid:pinid,pinno:pinno,call_id:call_id,tele_id:tele_id,chat_time_id:time_chat_id})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.props.closeModal();_this2.props.ChangeComp('change');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}});}},{key:'BookSlot',value:function BookSlot(time_id_chat,slot_time,id_img){var loc="/rmeta"+"images/call.gif";var old_loc="/rmeta"+"images/call_dull.gif";$('#'+id_img+' img').attr("src",loc);if(this.state.old_img!=''){$('#'+this.state.old_img+' img').attr("src",old_loc);}this.setState({but_hide:'block',show:'none',hide:'block',preferred_time:slot_time,old_img:id_img,preferred_id:time_id_chat});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'componentDidMount',value:function componentDidMount(){$(".accordion_coach").smk_Accordion();}},{key:'render',value:function render(){var _this3=this;var slot_times="";if(this.state.slots.length>0||this.state.slots!=undefined){var d=1;slot_times=this.state.slots.map(function(slot,i){var slots_seg='';if(slot.length>0){slots_seg=slot.map(function(sl,k){var id_img='img'+d;d++;var style='';var img='';var slot_time=sl.start_slot+' to '+sl.end_slot;if(sl.slot_time_from<_this3.state.cur_time&&_this3.state.date_call<=_this3.state.cur_date){img='';style='line-through';}else if(sl.telecall_booking_status==1||sl.chat_booking_status==1){img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/call_dull_tick.gif",border:'0'});}else if(_this3.state.chat_time_id_pk==sl.chat_time_slot_id_pk){img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/call.gif",border:'0'});}else{img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/call_dull.gif",onClick:function onClick(){return _this3.BookSlot(sl.chat_time_slot_id_pk,slot_time,id_img);},border:'0'});}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'sl_'+k,className:'chat-img',id:id_img},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'15px'}},img)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'sltd_'+k,style:{textDecoration:style,fontSize:'14px'}},sl.start_slot+' - '+sl.end_slot)];});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'slots_'+i},slots_seg);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-ecoach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'colorstyle'},'Schedule a one-on-one Telecall with your E Coach')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'colorstyle'},'E Coach\'s available slots for telecall on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{nohref:'true',name:'ptime'},this.state.call_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Preferred Time:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'before_booking',style:{display:this.state.show}},'Click on the slots to choose your convenient time to have telecall with your E Coach.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'booked_time_div',style:{display:this.state.hide}},this.state.preferred_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'btndiv',className:'button-cancel',style:{display:this.state.but_hide}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'white',href:'javascript:void(0);',onClick:function onClick(){return _this3.Slot(_this3.state.preferred_id,_this3.state.call_id,_this3.state.tele_id);}},'Book Slot'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'telecal-popup accordion_coach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablescroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in acc_active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head',onClick:this.showTimeslots(this.state.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_icon_expand'}),this.state.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{id:"trid_"+this.state.id,style:{display:'block',borderCollapse:'collapse',border:'1px solid rgb(231, 231, 231)',width:'100%',marginBottom:'10px'},cellSpacing:'1',cellPadding:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,slot_times)))))));}}]);return BookCall;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BookCall);

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _uncontrollable = __webpack_require__(702);

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes3 = __webpack_require__(20);

var _helpers = __webpack_require__(74);

var _constants = __webpack_require__(29);

var _formats = __webpack_require__(107);

var _formats2 = _interopRequireDefault(_formats);

var _messages = __webpack_require__(108);

var _messages2 = _interopRequireDefault(_messages);

var _move = __webpack_require__(302);

var _move2 = _interopRequireDefault(_move);

var _Views = __webpack_require__(303);

var _Views2 = _interopRequireDefault(_Views);

var _Toolbar = __webpack_require__(783);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _EventWrapper = __webpack_require__(329);

var _EventWrapper2 = _interopRequireDefault(_EventWrapper);

var _BackgroundWrapper = __webpack_require__(186);

var _BackgroundWrapper2 = _interopRequireDefault(_BackgroundWrapper);

var _omit = __webpack_require__(784);

var _omit2 = _interopRequireDefault(_omit);

var _defaults = __webpack_require__(792);

var _defaults2 = _interopRequireDefault(_defaults);

var _transform = __webpack_require__(793);

var _transform2 = _interopRequireDefault(_transform);

var _mapValues = __webpack_require__(794);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function viewNames(_views) {
  return !Array.isArray(_views) ? Object.keys(_views) : _views;
}

function isValidView(view, _ref) {
  var _views = _ref.views;

  var names = viewNames(_views);
  return names.indexOf(view) !== -1;
}

/**
 * react-big-calendar is a full featured Calendar component for managing events and dates. It uses
 * modern `flexbox` for layout, making it super responsive and performant. Leaving most of the layout heavy lifting
 * to the browser. __note:__ The default styles use `height: 100%` which means your container must set an explicit
 * height (feel free to adjust the styles to suit your specific needs).
 *
 * Big Calendar is unopiniated about editing and moving events, preferring to let you implement it in a way that makes
 * the most sense to your app. It also tries not to be prescriptive about your event data structures, just tell it
 * how to find the start and end datetimes and you can pass it whatever you want.
 *
 * One thing to note is that, `react-big-calendar` treats event start/end dates as an _exclusive_ range.
 * which means that the event spans up to, but not including, the end date. In the case
 * of displaying events on whole days, end dates are rounded _up_ to the next day. So an
 * event ending on `Apr 8th 12:00:00 am` will not appear on the 8th, whereas one ending
 * on `Apr 8th 12:01:00 am` will. If you want _inclusive_ ranges consider providing a
 * function `endAccessor` that returns the end date + 1 day for those events that end at midnight.
 */
/**
 *
 *
 * @static
 * @memberof Calendar
 */

var Calendar = function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Calendar.prototype.render = function render() {
    var _props = this.props,
        view = _props.view,
        toolbar = _props.toolbar,
        events = _props.events,
        culture = _props.culture,
        _props$components = _props.components,
        components = _props$components === undefined ? {} : _props$components,
        _props$formats = _props.formats,
        formats = _props$formats === undefined ? {} : _props$formats,
        _props$messages = _props.messages,
        messages = _props$messages === undefined ? {} : _props$messages,
        style = _props.style,
        className = _props.className,
        elementProps = _props.elementProps,
        current = _props.date,
        getNow = _props.getNow,
        length = _props.length,
        props = _objectWithoutProperties(_props, ['view', 'toolbar', 'events', 'culture', 'components', 'formats', 'messages', 'style', 'className', 'elementProps', 'date', 'getNow', 'length']);

    current = current || getNow();

    formats = (0, _formats2.default)(formats);
    messages = (0, _messages2.default)(messages);

    var View = this.getView();
    var names = viewNames(this.props.views);

    var viewComponents = (0, _defaults2.default)(components[view] || {}, (0, _omit2.default)(components, names), {
      eventWrapper: _EventWrapper2.default,
      dayWrapper: _BackgroundWrapper2.default,
      dateCellWrapper: _BackgroundWrapper2.default
    });

    var CalToolbar = components.toolbar || _Toolbar2.default;
    var label = View.title(current, { formats: formats, culture: culture, length: length });

    return _react2.default.createElement(
      'div',
      _extends({}, elementProps, {
        className: (0, _classnames2.default)('rbc-calendar', className, {
          'rbc-rtl': props.rtl
        }),
        style: style
      }),
      toolbar && _react2.default.createElement(CalToolbar, {
        date: current,
        view: view,
        views: names,
        label: label,
        onViewChange: this.handleViewChange,
        onNavigate: this.handleNavigate,
        messages: messages
      }),
      _react2.default.createElement(View, _extends({
        ref: 'view'
      }, props, formats, {
        messages: messages,
        culture: culture,
        formats: undefined,
        events: events,
        date: current,
        getNow: getNow,
        length: length,
        components: viewComponents,
        getDrilldownView: this.getDrilldownView,
        onNavigate: this.handleNavigate,
        onDrillDown: this.handleDrillDown,
        onSelectEvent: this.handleSelectEvent,
        onDoubleClickEvent: this.handleDoubleClickEvent,
        onSelectSlot: this.handleSelectSlot,
        onShowMore: this._showMore
      }))
    );
  };

  return Calendar;
}(_react2.default.Component);

Calendar.propTypes = {
  /**
   * Props passed to main calendar `<div>`.
   *
   */
  elementProps: _propTypes2.default.object,

  /**
   * The current date value of the calendar. Determines the visible view range.
   * If `date` is omitted then the result of `getNow` is used; otherwise the
   * current date is used.
   *
   * @controllable onNavigate
   */
  date: _propTypes2.default.instanceOf(Date),

  /**
   * The current view of the calendar.
   *
   * @default 'month'
   * @controllable onView
   */
  view: _propTypes2.default.string,

  /**
   * The initial view set for the Calendar.
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @default 'month'
   */
  defaultView: _propTypes2.default.string,

  /**
   * An array of event objects to display on the calendar. Events objects
   * can be any shape, as long as the Calendar knows how to retrieve the
   * following details of the event:
   *
   *  - start time
   *  - end time
   *  - title
   *  - whether its an "all day" event or not
   *  - any resource the event may be a related too
   *
   * Each of these properties can be customized or generated dynamically by
   * setting the various "accessor" props. Without any configuration the default
   * event should look like:
   *
   * ```js
   * Event {
   *   title: string,
   *   start: Date,
   *   end: Date,
   *   allDay?: boolean
   *   resource?: any,
   * }
   * ```
   */
  events: _propTypes2.default.arrayOf(_propTypes2.default.object),

  /**
   * Accessor for the event title, used to display event information. Should
   * resolve to a `renderable` value.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  titleAccessor: _propTypes3.accessor,

  /**
   * Accessor for the event tooltip. Should
   * resolve to a `renderable` value. Removes the tooltip if null.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  tooltipAccessor: _propTypes3.accessor,

  /**
   * Determines whether the event should be considered an "all day" event and ignore time.
   * Must resolve to a `boolean` value.
   *
   * ```js
   * string | (event: Object) => boolean
   * ```
   *
   * @type {(func|string)}
   */
  allDayAccessor: _propTypes3.accessor,

  /**
   * The start date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  startAccessor: _propTypes3.accessor,

  /**
   * The end date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  endAccessor: _propTypes3.accessor,

  /**
   * Returns the id of the `resource` that the event is a member of. This
   * id should match at least one resource in the `resources` array.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  resourceAccessor: _propTypes3.accessor,

  /**
   * An array of resource objects that map events to a specific resource.
   * Resource objects, like events, can be any shape or have any properties,
   * but should be uniquly identifiable via the `resourceIdAccessor`, as
   * well as a "title" or name as provided by the `resourceTitleAccessor` prop.
   */
  resources: _propTypes2.default.arrayOf(_propTypes2.default.object),

  /**
   * Provides a unique identifier for each resource in the `resources` array
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceIdAccessor: _propTypes3.accessor,

  /**
   * Provides a human readable name for the resource object, used in headers.
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceTitleAccessor: _propTypes3.accessor,

  /**
   * Determines the current date/time which is highlighted in the views.
   *
   * The value affects which day is shaded and which time is shown as
   * the current time. It also affects the date used by the Today button in
   * the toolbar.
   *
   * Providing a value here can be useful when you are implementing time zones
   * using the `startAccessor` and `endAccessor` properties.
   *
   * @type {func}
   * @default () => new Date()
   */
  getNow: _propTypes2.default.func,

  /**
   * Callback fired when the `date` value changes.
   *
   * @controllable date
   */
  onNavigate: _propTypes2.default.func,

  /**
   * Callback fired when the `view` value changes.
   *
   * @controllable view
   */
  onView: _propTypes2.default.func,

  /**
   * Callback fired when date header, or the truncated events links are clicked
   *
   */
  onDrillDown: _propTypes2.default.func,

  /**
   * A callback fired when a date selection is made. Only fires when `selectable` is `true`.
   *
   * ```js
   * (
   *   slotInfo: {
   *     start: Date,
   *     end: Date,
   *     slots: Array<Date>,
   *     action: "select" | "click" | "doubleClick"
   *   }
   * ) => any
   * ```
   */
  onSelectSlot: _propTypes2.default.func,

  /**
   * Callback fired when a calendar event is selected.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => any
   * ```
   *
   * @controllable selected
   */
  onSelectEvent: _propTypes2.default.func,

  /**
   * Callback fired when a calendar event is clicked twice.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => void
   * ```
   */
  onDoubleClickEvent: _propTypes2.default.func,

  /**
   * Callback fired when dragging a selection in the Time views.
   *
   * Returning `false` from the handler will prevent a selection.
   *
   * ```js
   * (range: { start: Date, end: Date }) => ?boolean
   * ```
   */
  onSelecting: _propTypes2.default.func,

  /**
   * The selected event, if any.
   */
  selected: _propTypes2.default.object,

  /**
   * An array of built-in view names to allow the calendar to display.
   * accepts either an array of builtin view names,
   *
   * ```jsx
   * views={['month', 'day', 'agenda']}
   * ```
   * or an object hash of the view name and the component (or boolean for builtin).
   *
   * ```jsx
   * views={{
   *   month: true,
   *   week: false,
   *   myweek: WorkWeekViewComponent,
   * }}
   * ```
   *
   * Custom views can be any React component, that implements the following
   * interface:
   *
   * ```js
   * interface View {
   *   static title(date: Date, { formats: DateFormat[], culture: string?, ...props }): string
   *   static navigate(date: Date, action: 'PREV' | 'NEXT' | 'DATE'): Date
   * }
   * ```
   *
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @View
   ['month', 'week', 'day', 'agenda']
   */
  views: _propTypes3.views,

  /**
   * The string name of the destination view for drill-down actions, such
   * as clicking a date header, or the truncated events links. If
   * `getDrilldownView` is also specified it will be used instead.
   *
   * Set to `null` to disable drill-down actions.
   *
   * ```js
   * <BigCalendar
   *   drilldownView="agenda"
   * />
   * ```
   */
  drilldownView: _propTypes2.default.string,

  /**
   * Functionally equivalent to `drilldownView`, but accepts a function
   * that can return a view name. It's useful for customizing the drill-down
   * actions depending on the target date and triggering view.
   *
   * Return `null` to disable drill-down actions.
   *
   * ```js
   * <BigCalendar
   *   getDrilldownView={(targetDate, currentViewName, configuredViewNames) =>
   *     if (currentViewName === 'month' && configuredViewNames.includes('week'))
   *       return 'week'
   *
   *     return null;
   *   }}
   * />
   * ```
   */
  getDrilldownView: _propTypes2.default.func,

  /**
   * Determines the end date from date prop in the agenda view
   * date prop + length (in number of days) = end date
   */
  length: _propTypes2.default.number,

  /**
   * Determines whether the toolbar is displayed
   */
  toolbar: _propTypes2.default.bool,

  /**
   * Show truncated events in an overlay when you click the "+_x_ more" link.
   */
  popup: _propTypes2.default.bool,

  /**
   * Distance in pixels, from the edges of the viewport, the "show more" overlay should be positioned.
   *
   * ```jsx
   * <BigCalendar popupOffset={30}/>
   * <BigCalendar popupOffset={{x: 30, y: 20}}/>
   * ```
   */
  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ x: _propTypes2.default.number, y: _propTypes2.default.number })]),

  /**
   * Allows mouse selection of ranges of dates/times.
   *
   * The 'ignoreEvents' option prevents selection code from running when a
   * drag begins over an event. Useful when you want custom event click or drag
   * logic
   */
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),

  /** Determines whether you want events to be resizable */
  resizable: _propTypes2.default.bool,

  /**
   * Specifies the number of miliseconds the user must press and hold on the screen for a touch
   * to be considered a "long press." Long presses are used for time slot selection on touch
   * devices.
   *
   * @type {number}
   * @default 250
   */
  longPressThreshold: _propTypes2.default.number,

  /**
   * Determines the selectable time increments in week and day views
   */
  step: _propTypes2.default.number,

  /**
   * The number of slots per "section" in the time grid views. Adjust with `step`
   * to change the default of 1 hour long groups, with 30 minute slots.
   */
  timeslots: _propTypes2.default.number,

  /**
   *Switch the calendar to a `right-to-left` read direction.
   */
  rtl: _propTypes2.default.bool,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the event node.
   *
   * ```js
   * (
   * 	event: Object,
   * 	start: Date,
   * 	end: Date,
   * 	isSelected: boolean
   * ) => { className?: string, style?: Object }
   * ```
   */
  eventPropGetter: _propTypes2.default.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the time-slot node. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  slotPropGetter: _propTypes2.default.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the day background. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  dayPropGetter: _propTypes2.default.func,

  /**
   * Support to show multi-day events with specific start and end times in the
   * main time grid (rather than in the all day header).
   *
   * **Note: This may cause calendars with several events to look very busy in
   * the week and day views.**
   */
  showMultiDayTimes: _propTypes2.default.bool,

  /**
   * Constrains the minimum _time_ of the Day and Week views.
   */
  min: _propTypes2.default.instanceOf(Date),

  /**
   * Constrains the maximum _time_ of the Day and Week views.
   */
  max: _propTypes2.default.instanceOf(Date),

  /**
   * Determines how far down the scroll pane is initially scrolled down.
   */
  scrollToTime: _propTypes2.default.instanceOf(Date),

  /**
   * Specify a specific culture code for the Calendar.
   *
   * **Note: it's generally better to handle this globally via your i18n library.**
   */
  culture: _propTypes2.default.string,

  /**
   * Localizer specific formats, tell the Calendar how to format and display dates.
   *
   * `format` types are dependent on the configured localizer; both Moment and Globalize
   * accept strings of tokens according to their own specification, such as: `'DD mm yyyy'`.
   *
   * ```jsx
   * let formats = {
   *   dateFormat: 'dd',
   *
   *   dayFormat: (date, culture, localizer) =>
   *     localizer.format(date, 'DDD', culture),
   *
   *   dayRangeHeaderFormat: ({ start, end }, culture, local) =>
   *     local.format(start, { date: 'short' }, culture) + ' — ' +
   *     local.format(end, { date: 'short' }, culture)
   * }
   *
   * <Calendar formats={formats} />
   * ```
   *
   * All localizers accept a function of
   * the form `(date: Date, culture: ?string, localizer: Localizer) -> string`
   */
  formats: _propTypes2.default.shape({
    /**
     * Format for the day of the month heading in the Month view.
     * e.g. "01", "02", "03", etc
     */
    dateFormat: _propTypes3.dateFormat,

    /**
     * A day of the week format for Week and Day headings,
     * e.g. "Wed 01/04"
     *
     */
    dayFormat: _propTypes3.dateFormat,

    /**
     * Week day name format for the Month week day headings,
     * e.g: "Sun", "Mon", "Tue", etc
     *
     */
    weekdayFormat: _propTypes3.dateFormat,

    /**
     * The timestamp cell formats in Week and Time views, e.g. "4:00 AM"
     */
    timeGutterFormat: _propTypes3.dateFormat,

    /**
     * Toolbar header format for the Month view, e.g "2015 April"
     *
     */
    monthHeaderFormat: _propTypes3.dateFormat,

    /**
     * Toolbar header format for the Week views, e.g. "Mar 29 - Apr 04"
     */
    dayRangeHeaderFormat: _propTypes3.dateRangeFormat,

    /**
     * Toolbar header format for the Day view, e.g. "Wednesday Apr 01"
     */
    dayHeaderFormat: _propTypes3.dateFormat,

    /**
     * Toolbar header format for the Agenda view, e.g. "4/1/2015 — 5/1/2015"
     */
    agendaHeaderFormat: _propTypes3.dateRangeFormat,

    /**
     * A time range format for selecting time slots, e.g "8:00am — 2:00pm"
     */
    selectRangeFormat: _propTypes3.dateRangeFormat,

    agendaDateFormat: _propTypes3.dateFormat,
    agendaTimeFormat: _propTypes3.dateFormat,
    agendaTimeRangeFormat: _propTypes3.dateRangeFormat,

    /**
     * Time range displayed on events.
     */
    eventTimeRangeFormat: _propTypes3.dateRangeFormat,

    /**
     * An optional event time range for events that continue onto another day
     */
    eventTimeRangeStartFormat: _propTypes3.dateFormat,

    /**
     * An optional event time range for events that continue from another day
     */
    eventTimeRangeEndFormat: _propTypes3.dateFormat
  }),

  /**
   * Customize how different sections of the calendar render by providing custom Components.
   * In particular the `Event` component can be specified for the entire calendar, or you can
   * provide an individual component for each view type.
   *
   * ```jsx
   * let components = {
   *   event: MyEvent, // used by each view (Month, Day, Week)
   *   toolbar: MyToolbar,
   *   agenda: {
   *   	 event: MyAgendaEvent // with the agenda view use a different component to render events
   *   }
   * }
   * <Calendar components={components} />
   * ```
   */
  components: _propTypes2.default.shape({
    event: _propTypes3.elementType,
    eventWrapper: _propTypes3.elementType,
    dayWrapper: _propTypes3.elementType,
    dateCellWrapper: _propTypes3.elementType,

    toolbar: _propTypes3.elementType,

    agenda: _propTypes2.default.shape({
      date: _propTypes3.elementType,
      time: _propTypes3.elementType,
      event: _propTypes3.elementType
    }),

    day: _propTypes2.default.shape({
      header: _propTypes3.elementType,
      event: _propTypes3.elementType
    }),
    week: _propTypes2.default.shape({
      header: _propTypes3.elementType,
      event: _propTypes3.elementType
    }),
    month: _propTypes2.default.shape({
      header: _propTypes3.elementType,
      dateHeader: _propTypes3.elementType,
      event: _propTypes3.elementType
    })
  }),

  /**
   * String messages used throughout the component, override to provide localizations
   */
  messages: _propTypes2.default.shape({
    allDay: _propTypes2.default.node,
    previous: _propTypes2.default.node,
    next: _propTypes2.default.node,
    today: _propTypes2.default.node,
    month: _propTypes2.default.node,
    week: _propTypes2.default.node,
    day: _propTypes2.default.node,
    agenda: _propTypes2.default.node,
    date: _propTypes2.default.node,
    time: _propTypes2.default.node,
    event: _propTypes2.default.node,
    showMore: _propTypes2.default.func
  })
};
Calendar.defaultProps = {
  elementProps: {},
  popup: false,
  toolbar: true,
  view: _constants.views.MONTH,
  views: [_constants.views.MONTH, _constants.views.WEEK, _constants.views.DAY, _constants.views.AGENDA],
  step: 30,
  length: 30,

  drilldownView: _constants.views.DAY,

  titleAccessor: 'title',
  tooltipAccessor: 'title',
  allDayAccessor: 'allDay',
  startAccessor: 'start',
  endAccessor: 'end',
  resourceAccessor: 'resourceId',

  resourceIdAccessor: 'id',
  resourceTitleAccessor: 'title',

  longPressThreshold: 250,
  getNow: function getNow() {
    return new Date();
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getViews = function () {
    var views = _this2.props.views;

    if (Array.isArray(views)) {
      return (0, _transform2.default)(views, function (obj, name) {
        return obj[name] = _Views2.default[name];
      }, {});
    }

    if ((typeof views === 'undefined' ? 'undefined' : _typeof(views)) === 'object') {
      return (0, _mapValues2.default)(views, function (value, key) {
        if (value === true) {
          return _Views2.default[key];
        }

        return value;
      });
    }

    return _Views2.default;
  };

  this.getView = function () {
    var views = _this2.getViews();

    return views[_this2.props.view];
  };

  this.getDrilldownView = function (date) {
    var _props2 = _this2.props,
        view = _props2.view,
        drilldownView = _props2.drilldownView,
        getDrilldownView = _props2.getDrilldownView;


    if (!getDrilldownView) return drilldownView;

    return getDrilldownView(date, view, Object.keys(_this2.getViews()));
  };

  this.handleNavigate = function (action, newDate) {
    var _props3 = _this2.props,
        view = _props3.view,
        date = _props3.date,
        getNow = _props3.getNow,
        onNavigate = _props3.onNavigate,
        props = _objectWithoutProperties(_props3, ['view', 'date', 'getNow', 'onNavigate']);

    var ViewComponent = _this2.getView();

    date = (0, _move2.default)(ViewComponent, _extends({}, props, {
      action: action,
      date: newDate || date,
      today: getNow()
    }));

    onNavigate(date, view, action);
  };

  this.handleViewChange = function (view) {
    if (view !== _this2.props.view && isValidView(view, _this2.props)) {
      _this2.props.onView(view);
    }
  };

  this.handleSelectEvent = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (0, _helpers.notify)(_this2.props.onSelectEvent, args);
  };

  this.handleDoubleClickEvent = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    (0, _helpers.notify)(_this2.props.onDoubleClickEvent, args);
  };

  this.handleSelectSlot = function (slotInfo) {
    (0, _helpers.notify)(_this2.props.onSelectSlot, slotInfo);
  };

  this.handleDrillDown = function (date, view) {
    var onDrillDown = _this2.props.onDrillDown;

    if (onDrillDown) {
      onDrillDown(date, view, _this2.drilldownView);
      return;
    }
    if (view) _this2.handleViewChange(view);

    _this2.handleNavigate(_constants.navigate.DATE, date);
  };
};

exports.default = (0, _uncontrollable2.default)(Calendar, {
  view: 'onView',
  date: 'onNavigate',
  selected: 'onSelectEvent'
});
module.exports = exports['default'];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(703);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(704);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(13);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(173);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(173);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

var MILI    = 'milliseconds'
  , SECONDS = 'seconds'
  , MINUTES = 'minutes'
  , HOURS   = 'hours'
  , DAY     = 'day'
  , WEEK    = 'week'
  , MONTH   = 'month'
  , YEAR    = 'year'
  , DECADE  = 'decade'
  , CENTURY = 'century';

var dates = module.exports = {

  add: function(date, num, unit) {
    date = new Date(date)

    switch (unit){
      case MILI:
      case SECONDS:
      case MINUTES:
      case HOURS:
      case YEAR:
        return dates[unit](date, dates[unit](date) + num)
      case DAY:
        return dates.date(date, dates.date(date) + num)
      case WEEK:
        return dates.date(date, dates.date(date) + (7 * num)) 
      case MONTH:
        return monthMath(date, num)
      case DECADE:
        return dates.year(date, dates.year(date) + (num * 10))
      case CENTURY:
        return dates.year(date, dates.year(date) + (num * 100))
    }

    throw new TypeError('Invalid units: "' + unit + '"')
  },

  subtract: function(date, num, unit) {
    return dates.add(date, -num, unit)
  },

  startOf: function(date, unit, firstOfWeek) {
    date = new Date(date)

    switch (unit) {
      case 'century':
      case 'decade':
      case 'year':
          date = dates.month(date, 0);
      case 'month':
          date = dates.date(date, 1);
      case 'week':
      case 'day':
          date = dates.hours(date, 0);
      case 'hours':
          date = dates.minutes(date, 0);
      case 'minutes':
          date = dates.seconds(date, 0);
      case 'seconds':
          date = dates.milliseconds(date, 0);
    }

    if (unit === DECADE) 
      date = dates.subtract(date, dates.year(date) % 10, 'year')
    
    if (unit === CENTURY) 
      date = dates.subtract(date, dates.year(date) % 100, 'year')

    if (unit === WEEK) 
      date = dates.weekday(date, 0, firstOfWeek);

    return date
  },


  endOf: function(date, unit, firstOfWeek){
    date = new Date(date)
    date = dates.startOf(date, unit, firstOfWeek)
    date = dates.add(date, 1, unit)
    date = dates.subtract(date, 1, MILI)
    return date
  },

  eq:  createComparer(function(a, b){ return a === b }),
  neq: createComparer(function(a, b){ return a !== b }),
  gt:  createComparer(function(a, b){ return a > b }),
  gte: createComparer(function(a, b){ return a >= b }),
  lt:  createComparer(function(a, b){ return a < b }),
  lte: createComparer(function(a, b){ return a <= b }),

  min: function(){
    return new Date(Math.min.apply(Math, arguments))
  },

  max: function(){
    return new Date(Math.max.apply(Math, arguments))
  },
  
  inRange: function(day, min, max, unit){
    unit = unit || 'day'

    return (!min || dates.gte(day, min, unit))
        && (!max || dates.lte(day, max, unit))
  },

  milliseconds:   createAccessor('Milliseconds'),
  seconds:        createAccessor('Seconds'),
  minutes:        createAccessor('Minutes'),
  hours:          createAccessor('Hours'),
  day:            createAccessor('Day'),
  date:           createAccessor('Date'),
  month:          createAccessor('Month'),
  year:           createAccessor('FullYear'),

  decade: function (date, val) {
    return val === undefined 
      ? dates.year(dates.startOf(date, DECADE))
      : dates.add(date, val + 10, YEAR);
  },

  century: function (date, val) {
    return val === undefined 
      ? dates.year(dates.startOf(date, CENTURY))
      : dates.add(date, val + 100, YEAR);
  },

  weekday: function (date, val, firstDay) {
      var weekday = (dates.day(date) + 7 - (firstDay || 0) ) % 7;

      return val === undefined 
        ? weekday 
        : dates.add(date, val - weekday, DAY);
  },

  diff: function (date1, date2, unit, asFloat) {
    var dividend, divisor, result;

    switch (unit) {
      case MILI:
      case SECONDS:
      case MINUTES:
      case HOURS:
      case DAY:
      case WEEK:
        dividend = date2.getTime() - date1.getTime(); break;
      case MONTH:
      case YEAR:
      case DECADE:
      case CENTURY:
        dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1); break;
      default:
        throw new TypeError('Invalid units: "' + unit + '"');
    }

    switch (unit) {
      case MILI:
          divisor = 1; break;
      case SECONDS:
          divisor = 1000; break;
      case MINUTES:
          divisor = 1000 * 60; break;
      case HOURS:
          divisor = 1000 * 60 * 60; break;
      case DAY:
          divisor = 1000 * 60 * 60 * 24; break;
      case WEEK:
          divisor = 1000 * 60 * 60 * 24 * 7; break;
      case MONTH:
          divisor = 1; break;
      case YEAR:
          divisor = 12; break;
      case DECADE:
          divisor = 120; break;
      case CENTURY:
          divisor = 1200; break;
      default:
        throw new TypeError('Invalid units: "' + unit + '"');
    }

    result = dividend / divisor;

    return asFloat ? result : absoluteFloor(result);
  }
};

function absoluteFloor(number) {
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function monthMath(date, val){
  var current = dates.month(date)
    , newMonth  = (current + val);

    date = dates.month(date, newMonth)

    while (newMonth < 0 ) newMonth = 12 + newMonth
      
    //month rollover
    if ( dates.month(date) !== ( newMonth % 12))
      date = dates.date(date, 0) //move to last of month

    return date
}

function createAccessor(method){
  return function(date, val){
    if (val === undefined)
      return date['get' + method]()

    date = new Date(date)
    date['set' + method](val)
    return date
  }
}

function createComparer(operator) {
  return function (a, b, unit) {
    return operator(+dates.startOf(a, unit), +dates.startOf(b, unit))
  };
}


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _chunk = __webpack_require__(709);

var _chunk2 = _interopRequireDefault(_chunk);

var _constants = __webpack_require__(29);

var _helpers = __webpack_require__(74);

var _position = __webpack_require__(307);

var _position2 = _interopRequireDefault(_position);

var _requestAnimationFrame = __webpack_require__(311);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _Popup = __webpack_require__(720);

var _Popup2 = _interopRequireDefault(_Popup);

var _Overlay = __webpack_require__(721);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _DateContentRow = __webpack_require__(314);

var _DateContentRow2 = _interopRequireDefault(_DateContentRow);

var _Header = __webpack_require__(320);

var _Header2 = _interopRequireDefault(_Header);

var _DateHeader = __webpack_require__(758);

var _DateHeader2 = _interopRequireDefault(_DateHeader);

var _propTypes3 = __webpack_require__(20);

var _eventLevels = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var eventsForWeek = function eventsForWeek(evts, start, end, props) {
  return evts.filter(function (e) {
    return (0, _eventLevels.inRange)(e, start, end, props);
  });
};

var propTypes = {
  events: _propTypes2.default.array.isRequired,
  date: _propTypes2.default.instanceOf(Date),

  min: _propTypes2.default.instanceOf(Date),
  max: _propTypes2.default.instanceOf(Date),

  step: _propTypes2.default.number,
  getNow: _propTypes2.default.func.isRequired,

  scrollToTime: _propTypes2.default.instanceOf(Date),
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,

  culture: _propTypes2.default.string,
  dayFormat: _propTypes3.dateFormat,

  rtl: _propTypes2.default.bool,
  width: _propTypes2.default.number,

  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onNavigate: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func,
  onSelectEvent: _propTypes2.default.func,
  onDoubleClickEvent: _propTypes2.default.func,
  onShowMore: _propTypes2.default.func,
  onDrillDown: _propTypes2.default.func,
  getDrilldownView: _propTypes2.default.func.isRequired,

  dateFormat: _propTypes3.dateFormat,

  weekdayFormat: _propTypes3.dateFormat,
  popup: _propTypes2.default.bool,

  messages: _propTypes2.default.object,
  components: _propTypes2.default.object.isRequired,
  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  })])
};

var MonthView = function (_React$Component) {
  _inherits(MonthView, _React$Component);

  function MonthView() {
    _classCallCheck(this, MonthView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _initialiseProps.call(_this);

    _this._bgRows = [];
    _this._pendingSelection = [];
    _this.state = {
      rowLimit: 5,
      needLimitMeasure: true
    };
    return _this;
  }

  MonthView.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var date = _ref.date;

    this.setState({
      needLimitMeasure: !_dates2.default.eq(date, this.props.date)
    });
  };

  MonthView.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var running = void 0;

    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);

    window.addEventListener('resize', this._resizeListener = function () {
      if (!running) {
        (0, _requestAnimationFrame2.default)(function () {
          running = false;
          _this2.setState({ needLimitMeasure: true }); //eslint-disable-line
        });
      }
    }, false);
  };

  MonthView.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
  };

  MonthView.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener, false);
  };

  MonthView.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        culture = _props.culture,
        weekdayFormat = _props.weekdayFormat,
        className = _props.className,
        month = _dates2.default.visibleDays(date, culture),
        weeks = (0, _chunk2.default)(month, 7);

    this._weekCount = weeks.length;

    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('rbc-month-view', className) },
      _react2.default.createElement(
        'div',
        { className: 'rbc-row rbc-month-header' },
        this.renderHeaders(weeks[0], weekdayFormat, culture)
      ),
      weeks.map(this.renderWeek),
      this.props.popup && this.renderOverlay()
    );
  };

  MonthView.prototype.renderHeaders = function renderHeaders(row, format, culture) {
    var first = row[0];
    var last = row[row.length - 1];
    var HeaderComponent = this.props.components.header || _Header2.default;

    return _dates2.default.range(first, last, 'day').map(function (day, idx) {
      return _react2.default.createElement(
        'div',
        { key: 'header_' + idx, className: 'rbc-header', style: (0, _eventLevels.segStyle)(1, 7) },
        _react2.default.createElement(HeaderComponent, {
          date: day,
          label: _localizer2.default.format(day, format, culture),
          localizer: _localizer2.default,
          format: format,
          culture: culture
        })
      );
    });
  };

  MonthView.prototype.renderOverlay = function renderOverlay() {
    var _this3 = this;

    var overlay = this.state && this.state.overlay || {};
    var components = this.props.components;


    return _react2.default.createElement(
      _Overlay2.default,
      {
        rootClose: true,
        placement: 'bottom',
        container: this,
        show: !!overlay.position,
        onHide: function onHide() {
          return _this3.setState({ overlay: null });
        }
      },
      _react2.default.createElement(_Popup2.default, _extends({}, this.props, {
        eventComponent: components.event,
        eventWrapperComponent: components.eventWrapper,
        position: overlay.position,
        events: overlay.events,
        slotStart: overlay.date,
        slotEnd: overlay.end,
        onSelect: this.handleSelectEvent,
        onDoubleClick: this.handleDoubleClickEvent
      }))
    );
  };

  MonthView.prototype.measureRowLimit = function measureRowLimit() {
    this.setState({
      needLimitMeasure: false,
      rowLimit: this.refs.slotRow.getRowLimit()
    });
  };

  MonthView.prototype.selectDates = function selectDates(slotInfo) {
    var slots = this._pendingSelection.slice();

    this._pendingSelection = [];

    slots.sort(function (a, b) {
      return +a - +b;
    });

    (0, _helpers.notify)(this.props.onSelectSlot, {
      slots: slots,
      start: slots[0],
      end: slots[slots.length - 1],
      action: slotInfo.action
    });
  };

  MonthView.prototype.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  return MonthView;
}(_react2.default.Component);

MonthView.displayName = 'MonthView';
MonthView.propTypes = propTypes;

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getContainer = function () {
    return (0, _reactDom.findDOMNode)(_this4);
  };

  this.renderWeek = function (week, weekIdx) {
    var _props2 = _this4.props,
        events = _props2.events,
        components = _props2.components,
        selectable = _props2.selectable,
        titleAccessor = _props2.titleAccessor,
        tooltipAccessor = _props2.tooltipAccessor,
        startAccessor = _props2.startAccessor,
        endAccessor = _props2.endAccessor,
        allDayAccessor = _props2.allDayAccessor,
        getNow = _props2.getNow,
        eventPropGetter = _props2.eventPropGetter,
        dayPropGetter = _props2.dayPropGetter,
        messages = _props2.messages,
        selected = _props2.selected,
        date = _props2.date,
        longPressThreshold = _props2.longPressThreshold;
    var _state = _this4.state,
        needLimitMeasure = _state.needLimitMeasure,
        rowLimit = _state.rowLimit;


    events = eventsForWeek(events, week[0], week[week.length - 1], _this4.props);
    events.sort(function (a, b) {
      return (0, _eventLevels.sortEvents)(a, b, _this4.props);
    });

    return _react2.default.createElement(_DateContentRow2.default, {
      key: weekIdx,
      ref: weekIdx === 0 ? 'slotRow' : undefined,
      container: _this4.getContainer,
      className: 'rbc-month-row',
      getNow: getNow,
      date: date,
      range: week,
      events: events,
      maxRows: rowLimit,
      selected: selected,
      selectable: selectable,
      messages: messages,
      titleAccessor: titleAccessor,
      tooltipAccessor: tooltipAccessor,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      allDayAccessor: allDayAccessor,
      eventPropGetter: eventPropGetter,
      dayPropGetter: dayPropGetter,
      renderHeader: _this4.readerDateHeading,
      renderForMeasure: needLimitMeasure,
      onShowMore: _this4.handleShowMore,
      onSelect: _this4.handleSelectEvent,
      onDoubleClick: _this4.handleDoubleClickEvent,
      onSelectSlot: _this4.handleSelectSlot,
      eventComponent: components.event,
      eventWrapperComponent: components.eventWrapper,
      dateCellWrapper: components.dateCellWrapper,
      longPressThreshold: longPressThreshold
    });
  };

  this.readerDateHeading = function (_ref3) {
    var date = _ref3.date,
        className = _ref3.className,
        props = _objectWithoutProperties(_ref3, ['date', 'className']);

    var _props3 = _this4.props,
        currentDate = _props3.date,
        getDrilldownView = _props3.getDrilldownView,
        dateFormat = _props3.dateFormat,
        culture = _props3.culture;


    var isOffRange = _dates2.default.month(date) !== _dates2.default.month(currentDate);
    var isCurrent = _dates2.default.eq(date, currentDate, 'day');
    var drilldownView = getDrilldownView(date);
    var label = _localizer2.default.format(date, dateFormat, culture);
    var DateHeaderComponent = _this4.props.components.dateHeader || _DateHeader2.default;

    return _react2.default.createElement(
      'div',
      _extends({}, props, {
        className: (0, _classnames2.default)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current')
      }),
      _react2.default.createElement(DateHeaderComponent, {
        label: label,
        date: date,
        drilldownView: drilldownView,
        isOffRange: isOffRange,
        onDrillDown: function onDrillDown(e) {
          return _this4.handleHeadingClick(date, drilldownView, e);
        }
      })
    );
  };

  this.handleSelectSlot = function (range, slotInfo) {
    _this4._pendingSelection = _this4._pendingSelection.concat(range);

    clearTimeout(_this4._selectTimer);
    _this4._selectTimer = setTimeout(function () {
      return _this4.selectDates(slotInfo);
    });
  };

  this.handleHeadingClick = function (date, view, e) {
    e.preventDefault();
    _this4.clearSelection();
    (0, _helpers.notify)(_this4.props.onDrillDown, [date, view]);
  };

  this.handleSelectEvent = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4.clearSelection();
    (0, _helpers.notify)(_this4.props.onSelectEvent, args);
  };

  this.handleDoubleClickEvent = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4.clearSelection();
    (0, _helpers.notify)(_this4.props.onDoubleClickEvent, args);
  };

  this.handleShowMore = function (events, date, cell, slot) {
    var _props4 = _this4.props,
        popup = _props4.popup,
        onDrillDown = _props4.onDrillDown,
        onShowMore = _props4.onShowMore,
        getDrilldownView = _props4.getDrilldownView;
    //cancel any pending selections so only the event click goes through.

    _this4.clearSelection();

    if (popup) {
      var position = (0, _position2.default)(cell, (0, _reactDom.findDOMNode)(_this4));

      _this4.setState({
        overlay: { date: date, events: events, position: position }
      });
    } else {
      (0, _helpers.notify)(onDrillDown, [date, getDrilldownView(date) || _constants.views.DAY]);
    }

    (0, _helpers.notify)(onShowMore, [events, date, slot]);
  };
};

MonthView.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -1, 'month');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, 1, 'month');

    default:
      return date;
  }
};

MonthView.title = function (date, _ref2) {
  var formats = _ref2.formats,
      culture = _ref2.culture;
  return _localizer2.default.format(date, formats.monthHeaderFormat, culture);
};

exports.default = MonthView;
module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(304),
    isIterateeCall = __webpack_require__(109),
    toInteger = __webpack_require__(305);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31),
    isSymbol = __webpack_require__(75);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(174));

var _style = _interopRequireDefault(__webpack_require__(308));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(715));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(309));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _offset = __webpack_require__(76);

var _offset2 = _interopRequireDefault(_offset);

var _scrollTop = __webpack_require__(175);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(310);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _EventCell = __webpack_require__(312);

var _EventCell2 = _interopRequireDefault(_EventCell);

var _selection = __webpack_require__(78);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _propTypes3 = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  position: _propTypes2.default.object,
  popupOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  })]),
  events: _propTypes2.default.array,
  selected: _propTypes2.default.object,
  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType,
  dayHeaderFormat: _propTypes3.dateFormat
};

var Popup = function (_React$Component) {
  _inherits(Popup, _React$Component);

  function Popup() {
    _classCallCheck(this, Popup);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    var _props$popupOffset = this.props.popupOffset,
        popupOffset = _props$popupOffset === undefined ? 5 : _props$popupOffset,
        _getOffset = (0, _offset2.default)(this.refs.root),
        top = _getOffset.top,
        left = _getOffset.left,
        width = _getOffset.width,
        height = _getOffset.height,
        viewBottom = window.innerHeight + (0, _scrollTop2.default)(window),
        viewRight = window.innerWidth + (0, _scrollLeft2.default)(window),
        bottom = top + height,
        right = left + width;

    if (bottom > viewBottom || right > viewRight) {
      var topOffset = void 0,
          leftOffset = void 0;

      if (bottom > viewBottom) topOffset = bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
      if (right > viewRight) leftOffset = right - viewRight + (popupOffset.x || +popupOffset || 0);

      this.setState({ topOffset: topOffset, leftOffset: leftOffset }); //eslint-disable-line
    }
  };

  Popup.prototype.render = function render() {
    var _props = this.props,
        events = _props.events,
        selected = _props.selected,
        eventComponent = _props.eventComponent,
        eventWrapperComponent = _props.eventWrapperComponent,
        props = _objectWithoutProperties(_props, ['events', 'selected', 'eventComponent', 'eventWrapperComponent']);

    var _props$position = this.props.position,
        left = _props$position.left,
        width = _props$position.width,
        top = _props$position.top,
        topOffset = (this.state || {}).topOffset || 0,
        leftOffset = (this.state || {}).leftOffset || 0;


    var style = {
      top: Math.max(0, top - topOffset),
      left: left - leftOffset,
      minWidth: width + width / 2
    };

    return _react2.default.createElement(
      'div',
      { ref: 'root', style: style, className: 'rbc-overlay' },
      _react2.default.createElement(
        'div',
        { className: 'rbc-overlay-header' },
        _localizer2.default.format(props.slotStart, props.dayHeaderFormat, props.culture)
      ),
      events.map(function (event, idx) {
        return _react2.default.createElement(_EventCell2.default, _extends({
          key: idx
        }, props, {
          event: event,
          eventComponent: eventComponent,
          eventWrapperComponent: eventWrapperComponent,
          selected: (0, _selection.isSelected)(event, selected)
        }));
      })
    );
  };

  return Popup;
}(_react2.default.Component);

Popup.propTypes = propTypes;

exports.default = Popup;
module.exports = exports['default'];

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(722);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(723);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(725);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(727);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          transitionAppear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(83);

var _createChainableTypeChecker = __webpack_require__(313);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(176);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(177);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(79);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(724);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(176);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(177);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(79);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(176);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(726);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(177);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(79);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(76);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(307);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(175);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(79);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(110);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(728);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(79);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(178);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(179);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(730),
    baseIteratee = __webpack_require__(111),
    toInteger = __webpack_require__(305);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(732),
    getMatchData = __webpack_require__(733),
    matchesStrictComparable = __webpack_require__(317);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(157),
    baseIsEqual = __webpack_require__(156);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(316),
    keys = __webpack_require__(71);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(156),
    get = __webpack_require__(735),
    hasIn = __webpack_require__(741),
    isKey = __webpack_require__(182),
    isStrictComparable = __webpack_require__(316),
    matchesStrictComparable = __webpack_require__(317),
    toKey = __webpack_require__(80);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(181);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(737);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(738);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(160);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(740);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(60),
    arrayMap = __webpack_require__(183),
    isArray = __webpack_require__(23),
    isSymbol = __webpack_require__(75);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(742),
    hasPath = __webpack_require__(743);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(112),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(23),
    isIndex = __webpack_require__(164),
    isLength = __webpack_require__(166),
    toKey = __webpack_require__(80);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(745),
    basePropertyDeep = __webpack_require__(746),
    isKey = __webpack_require__(182),
    toKey = __webpack_require__(80);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(181);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _eventLevels = __webpack_require__(46);

var _helpers = __webpack_require__(74);

var _propTypes3 = __webpack_require__(20);

var _selection = __webpack_require__(78);

var _Selection = __webpack_require__(318);

var _Selection2 = _interopRequireDefault(_Selection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundCells = function (_React$Component) {
  _inherits(BackgroundCells, _React$Component);

  function BackgroundCells(props, context) {
    _classCallCheck(this, BackgroundCells);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      selecting: false
    };
    return _this;
  }

  BackgroundCells.prototype.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();
  };

  BackgroundCells.prototype.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();
  };

  BackgroundCells.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();

    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
  };

  BackgroundCells.prototype.render = function render() {
    var _props = this.props,
        range = _props.range,
        Wrapper = _props.cellWrapperComponent,
        dayPropGetter = _props.dayPropGetter,
        currentDate = _props.date,
        getNow = _props.getNow;
    var _state = this.state,
        selecting = _state.selecting,
        startIdx = _state.startIdx,
        endIdx = _state.endIdx;

    var current = getNow();

    return _react2.default.createElement(
      'div',
      { className: 'rbc-row-bg' },
      range.map(function (date, index) {
        var selected = selecting && index >= startIdx && index <= endIdx;

        var _ref = dayPropGetter && dayPropGetter(date) || {},
            className = _ref.className,
            dayStyles = _ref.style;

        var segmStyles = (0, _eventLevels.segStyle)(1, range.length);
        var styles = _extends({}, dayStyles, segmStyles);

        return _react2.default.createElement(
          Wrapper,
          { key: index, value: date, range: range },
          _react2.default.createElement('div', {
            style: styles,
            className: (0, _classnames2.default)('rbc-day-bg', className, selected && 'rbc-selected-cell', _dates2.default.eq(date, current, 'day') && 'rbc-today', currentDate && _dates2.default.month(currentDate) !== _dates2.default.month(date) && 'rbc-off-range-bg')
          })
        );
      })
    );
  };

  BackgroundCells.prototype._selectable = function _selectable() {
    var _this2 = this;

    var node = (0, _reactDom.findDOMNode)(this);
    var selector = this._selector = new _Selection2.default(this.props.container, {
      longPressThreshold: this.props.longPressThreshold
    });

    var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), point)) {
        var rowBox = (0, _Selection.getBoundsForNode)(node);
        var _props2 = _this2.props,
            range = _props2.range,
            rtl = _props2.rtl;


        if ((0, _selection.pointInBox)(rowBox, point)) {
          var width = (0, _selection.slotWidth)((0, _Selection.getBoundsForNode)(node), range.length);
          var currentCell = (0, _selection.getCellAtX)(rowBox, point.x, width, rtl, range.length);

          _this2._selectSlot({
            startIdx: currentCell,
            endIdx: currentCell,
            action: actionType
          });
        }
      }

      _this2._initial = {};
      _this2.setState({ selecting: false });
    };

    selector.on('selecting', function (box) {
      var _props3 = _this2.props,
          range = _props3.range,
          rtl = _props3.rtl;


      var startIdx = -1;
      var endIdx = -1;

      if (!_this2.state.selecting) {
        (0, _helpers.notify)(_this2.props.onSelectStart, [box]);
        _this2._initial = { x: box.x, y: box.y };
      }
      if (selector.isSelected(node)) {
        var nodeBox = (0, _Selection.getBoundsForNode)(node);
        var _dateCellSelection = (0, _selection.dateCellSelection)(_this2._initial, nodeBox, box, range.length, rtl);

        startIdx = _dateCellSelection.startIdx;
        endIdx = _dateCellSelection.endIdx;
      }

      _this2.setState({
        selecting: true,
        startIdx: startIdx,
        endIdx: endIdx
      });
    });

    selector.on('beforeSelect', function (box) {
      if (_this2.props.selectable !== 'ignoreEvents') return;

      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
    });

    selector.on('click', function (point) {
      return selectorClicksHandler(point, 'click');
    });

    selector.on('doubleClick', function (point) {
      return selectorClicksHandler(point, 'doubleClick');
    });

    selector.on('select', function () {
      _this2._selectSlot(_extends({}, _this2.state, { action: 'select' }));
      _this2._initial = {};
      _this2.setState({ selecting: false });
      (0, _helpers.notify)(_this2.props.onSelectEnd, [_this2.state]);
    });
  };

  BackgroundCells.prototype._teardownSelectable = function _teardownSelectable() {
    if (!this._selector) return;
    this._selector.teardown();
    this._selector = null;
  };

  BackgroundCells.prototype._selectSlot = function _selectSlot(_ref2) {
    var endIdx = _ref2.endIdx,
        startIdx = _ref2.startIdx,
        action = _ref2.action;

    if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
      start: startIdx,
      end: endIdx,
      action: action
    });
  };

  return BackgroundCells;
}(_react2.default.Component);

BackgroundCells.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  getNow: _propTypes2.default.func.isRequired,
  cellWrapperComponent: _propTypes3.elementType,
  container: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes2.default.number,

  onSelectSlot: _propTypes2.default.func.isRequired,
  onSelectEnd: _propTypes2.default.func,
  onSelectStart: _propTypes2.default.func,

  range: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
  rtl: _propTypes2.default.bool,
  type: _propTypes2.default.string
};
exports.default = BackgroundCells;
module.exports = exports['default'];

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = closest;

var _matches = _interopRequireDefault(__webpack_require__(749));

var isDoc = function isDoc(obj) {
  return obj != null && obj.nodeType === obj.DOCUMENT_NODE;
};

function closest(node, selector, context) {
  while (node && (isDoc(node) || !(0, _matches.default)(node, selector))) {
    node = node !== context && !isDoc(node) ? node.parentNode : undefined;
  }

  return node;
}

module.exports = exports["default"];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = matches;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(180));

var matchesCache;

function matches(node, selector) {
  if (!matchesCache && _inDOM.default) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
    matchesCache = nativeMatch ? function (node, selector) {
      return nativeMatch.call(node, selector);
    } : ie8MatchesSelector;
  }

  return matchesCache ? matchesCache(node, selector) : null;
}

function ie8MatchesSelector(node, selector) {
  var matches = (0, _querySelectorAll.default)(node.document || node.ownerDocument, selector),
      i = 0;

  while (matches[i] && matches[i] !== node) {
    i++;
  }

  return !!matches[i];
}

module.exports = exports["default"];

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(178));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(179));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(751));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(752));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(110));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(180));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(39));

var _on = _interopRequireDefault(__webpack_require__(178));

var _off = _interopRequireDefault(__webpack_require__(179));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EventRowMixin = __webpack_require__(319);

var _EventRowMixin2 = _interopRequireDefault(_EventRowMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventRow = function (_React$Component) {
  _inherits(EventRow, _React$Component);

  function EventRow() {
    _classCallCheck(this, EventRow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventRow.prototype.render = function render() {
    var _this2 = this;

    var segments = this.props.segments;


    var lastEnd = 1;

    return _react2.default.createElement(
      'div',
      { className: 'rbc-row' },
      segments.reduce(function (row, _ref, li) {
        var event = _ref.event,
            left = _ref.left,
            right = _ref.right,
            span = _ref.span;

        var key = '_lvl_' + li;
        var gap = left - lastEnd;

        var content = _EventRowMixin2.default.renderEvent(_this2.props, event);

        if (gap) row.push(_EventRowMixin2.default.renderSpan(_this2.props, gap, key + '_gap'));

        row.push(_EventRowMixin2.default.renderSpan(_this2.props, span, key, content));

        lastEnd = right + 1;

        return row;
      }, [])
    );
  };

  return EventRow;
}(_react2.default.Component);

EventRow.propTypes = _extends({
  segments: _propTypes2.default.array
}, _EventRowMixin2.default.propTypes);
EventRow.defaultProps = _extends({}, _EventRowMixin2.default.defaultProps);
exports.default = EventRow;
module.exports = exports['default'];

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EventRowMixin = __webpack_require__(319);

var _EventRowMixin2 = _interopRequireDefault(_EventRowMixin);

var _eventLevels = __webpack_require__(46);

var _messages = __webpack_require__(108);

var _messages2 = _interopRequireDefault(_messages);

var _range = __webpack_require__(755);

var _range2 = _interopRequireDefault(_range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};
var eventsInSlot = function eventsInSlot(segments, slot) {
  return segments.filter(function (seg) {
    return isSegmentInSlot(seg, slot);
  }).length;
};

var EventEndingRow = function (_React$Component) {
  _inherits(EventEndingRow, _React$Component);

  function EventEndingRow() {
    _classCallCheck(this, EventEndingRow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  EventEndingRow.prototype.render = function render() {
    var _props = this.props,
        segments = _props.segments,
        slotCount = _props.slots;

    var rowSegments = (0, _eventLevels.eventLevels)(segments).levels[0];

    var current = 1,
        lastEnd = 1,
        row = [];

    while (current <= slotCount) {
      var key = '_lvl_' + current;

      var _ref = rowSegments.filter(function (seg) {
        return isSegmentInSlot(seg, current);
      })[0] || {},
          event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span; //eslint-disable-line

      if (!event) {
        current++;
        continue;
      }

      var gap = Math.max(0, left - lastEnd);

      if (this.canRenderSlotEvent(left, span)) {
        var content = _EventRowMixin2.default.renderEvent(this.props, event);

        if (gap) {
          row.push(_EventRowMixin2.default.renderSpan(this.props, gap, key + '_gap'));
        }

        row.push(_EventRowMixin2.default.renderSpan(this.props, span, key, content));

        lastEnd = current = right + 1;
      } else {
        if (gap) {
          row.push(_EventRowMixin2.default.renderSpan(this.props, gap, key + '_gap'));
        }

        row.push(_EventRowMixin2.default.renderSpan(this.props, 1, key, this.renderShowMore(segments, current)));
        lastEnd = current = current + 1;
      }
    }

    return _react2.default.createElement(
      'div',
      { className: 'rbc-row' },
      row
    );
  };

  EventEndingRow.prototype.canRenderSlotEvent = function canRenderSlotEvent(slot, span) {
    var segments = this.props.segments;


    return (0, _range2.default)(slot, slot + span).every(function (s) {
      var count = eventsInSlot(segments, s);

      return count === 1;
    });
  };

  EventEndingRow.prototype.renderShowMore = function renderShowMore(segments, slot) {
    var _this2 = this;

    var messages = (0, _messages2.default)(this.props.messages);
    var count = eventsInSlot(segments, slot);

    return count ? _react2.default.createElement(
      'a',
      {
        key: 'sm_' + slot,
        href: '#',
        className: 'rbc-show-more',
        onClick: function onClick(e) {
          return _this2.showMore(slot, e);
        }
      },
      messages.showMore(count)
    ) : false;
  };

  EventEndingRow.prototype.showMore = function showMore(slot, e) {
    e.preventDefault();
    this.props.onShowMore(slot);
  };

  return EventEndingRow;
}(_react2.default.Component);

EventEndingRow.propTypes = _extends({
  segments: _propTypes2.default.array,
  slots: _propTypes2.default.number,
  messages: _propTypes2.default.object,
  onShowMore: _propTypes2.default.func
}, _EventRowMixin2.default.propTypes);
EventEndingRow.defaultProps = _extends({}, _EventRowMixin2.default.defaultProps);
exports.default = EventEndingRow;
module.exports = exports['default'];

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(756);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(757),
    isIterateeCall = __webpack_require__(109),
    toFinite = __webpack_require__(306);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateHeader = function DateHeader(_ref) {
  var label = _ref.label,
      drilldownView = _ref.drilldownView,
      onDrillDown = _ref.onDrillDown;

  if (!drilldownView) {
    return _react2.default.createElement(
      'span',
      null,
      label
    );
  }

  return _react2.default.createElement(
    'a',
    { href: '#', onClick: onDrillDown },
    label
  );
};

DateHeader.propTypes = {
  label: _propTypes2.default.node,
  date: _propTypes2.default.instanceOf(Date),
  drilldownView: _propTypes2.default.string,
  onDrillDown: _propTypes2.default.func,
  isOffRange: _propTypes2.default.bool
};

exports.default = DateHeader;
module.exports = exports['default'];

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _constants = __webpack_require__(29);

var _TimeGrid = __webpack_require__(184);

var _TimeGrid2 = _interopRequireDefault(_TimeGrid);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Day = function (_React$Component) {
  _inherits(Day, _React$Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Day.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        props = _objectWithoutProperties(_props, ['date']);

    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, {
      range: [_dates2.default.startOf(date, 'day')],
      eventOffset: 10
    }));
  };

  return Day;
}(_react2.default.Component);

Day.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired
};


Day.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -1, 'day');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, 1, 'day');

    default:
      return date;
  }
};

Day.title = function (date, _ref) {
  var formats = _ref.formats,
      culture = _ref.culture;
  return _localizer2.default.format(date, formats.dayHeaderFormat, culture);
};

exports.default = Day;
module.exports = exports['default'];

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(7);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _Selection = __webpack_require__(318);

var _Selection2 = _interopRequireDefault(_Selection);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _selection = __webpack_require__(78);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _helpers = __webpack_require__(74);

var _propTypes3 = __webpack_require__(20);

var _accessors = __webpack_require__(61);

var _dayViewLayout = __webpack_require__(761);

var _dayViewLayout2 = _interopRequireDefault(_dayViewLayout);

var _TimeColumn = __webpack_require__(325);

var _TimeColumn2 = _interopRequireDefault(_TimeColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function snapToSlot(date, step) {
  var roundTo = 1000 * 60 * step;
  return new Date(Math.floor(date.getTime() / roundTo) * roundTo);
}

function startsAfter(date, max) {
  return _dates2.default.gt(_dates2.default.merge(max, date), max, 'minutes');
}

var DayColumn = function (_React$Component) {
  _inherits(DayColumn, _React$Component);

  function DayColumn() {
    var _temp, _this, _ret;

    _classCallCheck(this, DayColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  DayColumn.prototype.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();
  };

  DayColumn.prototype.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();
  };

  DayColumn.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();
    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
  };

  DayColumn.prototype.render = function render() {
    var _props = this.props,
        min = _props.min,
        max = _props.max,
        step = _props.step,
        getNow = _props.getNow,
        selectRangeFormat = _props.selectRangeFormat,
        culture = _props.culture,
        dayPropGetter = _props.dayPropGetter,
        props = _objectWithoutProperties(_props, ['min', 'max', 'step', 'getNow', 'selectRangeFormat', 'culture', 'dayPropGetter']);

    this._totalMin = _dates2.default.diff(min, max, 'minutes');
    var _state = this.state,
        selecting = _state.selecting,
        startSlot = _state.startSlot,
        endSlot = _state.endSlot;

    var slotStyle = this._slotStyle(startSlot, endSlot);

    var selectDates = {
      start: this.state.startDate,
      end: this.state.endDate
    };

    var _ref = dayPropGetter && dayPropGetter(max) || {},
        className = _ref.className,
        style = _ref.style;

    var current = getNow();

    return _react2.default.createElement(
      _TimeColumn2.default,
      _extends({}, props, {
        className: (0, _classnames2.default)('rbc-day-slot', className, _dates2.default.eq(max, current, 'day') && 'rbc-today'),
        style: style,
        getNow: getNow,
        min: min,
        max: max,
        step: step
      }),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('rbc-events-container', { rtl: this.props.rtl }) },
        this.renderEvents()
      ),
      selecting && _react2.default.createElement(
        'div',
        { className: 'rbc-slot-selection', style: slotStyle },
        _react2.default.createElement(
          'span',
          null,
          _localizer2.default.format(selectDates, selectRangeFormat, culture)
        )
      )
    );
  };

  return DayColumn;
}(_react2.default.Component);

DayColumn.propTypes = {
  events: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object,
  step: _propTypes2.default.number.isRequired,
  min: _propTypes2.default.instanceOf(Date).isRequired,
  max: _propTypes2.default.instanceOf(Date).isRequired,
  getNow: _propTypes2.default.func.isRequired,

  rtl: _propTypes2.default.bool,
  titleAccessor: _propTypes3.accessor,
  tooltipAccessor: _propTypes3.accessor,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,

  selectRangeFormat: _propTypes3.dateFormat,
  eventTimeRangeFormat: _propTypes3.dateFormat,
  eventTimeRangeStartFormat: _propTypes3.dateFormat,
  eventTimeRangeEndFormat: _propTypes3.dateFormat,
  showMultiDayTimes: _propTypes2.default.bool,
  culture: _propTypes2.default.string,
  timeslots: _propTypes2.default.number,
  messages: _propTypes2.default.object,

  selected: _propTypes2.default.object,
  selectable: _propTypes2.default.oneOf([true, false, 'ignoreEvents']),
  eventOffset: _propTypes2.default.number,
  longPressThreshold: _propTypes2.default.number,

  onSelecting: _propTypes2.default.func,
  onSelectSlot: _propTypes2.default.func.isRequired,
  onSelectEvent: _propTypes2.default.func.isRequired,
  onDoubleClickEvent: _propTypes2.default.func.isRequired,

  className: _propTypes2.default.string,
  dragThroughEvents: _propTypes2.default.bool,
  eventPropGetter: _propTypes2.default.func,
  dayPropGetter: _propTypes2.default.func,
  dayWrapperComponent: _propTypes3.elementType,
  eventComponent: _propTypes3.elementType,
  eventWrapperComponent: _propTypes3.elementType.isRequired,
  resource: _propTypes2.default.string
};
DayColumn.defaultProps = {
  dragThroughEvents: true,
  timeslots: 2
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { selecting: false };

  this.renderEvents = function () {
    var _props2 = _this2.props,
        EventComponent = _props2.components.event,
        culture = _props2.culture,
        endAccessor = _props2.endAccessor,
        eventPropGetter = _props2.eventPropGetter,
        eventTimeRangeEndFormat = _props2.eventTimeRangeEndFormat,
        eventTimeRangeFormat = _props2.eventTimeRangeFormat,
        eventTimeRangeStartFormat = _props2.eventTimeRangeStartFormat,
        EventWrapper = _props2.eventWrapperComponent,
        events = _props2.events,
        max = _props2.max,
        messages = _props2.messages,
        min = _props2.min,
        isRtl = _props2.rtl,
        selected = _props2.selected,
        showMultiDayTimes = _props2.showMultiDayTimes,
        startAccessor = _props2.startAccessor,
        step = _props2.step,
        timeslots = _props2.timeslots,
        titleAccessor = _props2.titleAccessor,
        tooltipAccessor = _props2.tooltipAccessor;


    var styledEvents = (0, _dayViewLayout2.default)({
      events: events,
      startAccessor: startAccessor,
      endAccessor: endAccessor,
      min: min,
      showMultiDayTimes: showMultiDayTimes,
      totalMin: _this2._totalMin,
      step: step,
      timeslots: timeslots
    });

    return styledEvents.map(function (_ref2, idx) {
      var _extends2;

      var event = _ref2.event,
          style = _ref2.style;

      var _eventTimeRangeFormat = eventTimeRangeFormat;
      var _continuesPrior = false;
      var _continuesAfter = false;
      var start = (0, _accessors.accessor)(event, startAccessor);
      var end = (0, _accessors.accessor)(event, endAccessor);

      if (start < min) {
        start = min;
        _continuesPrior = true;
        _eventTimeRangeFormat = eventTimeRangeEndFormat;
      }

      if (end > max) {
        end = max;
        _continuesAfter = true;
        _eventTimeRangeFormat = eventTimeRangeStartFormat;
      }

      var continuesPrior = (0, _dayViewLayout.startsBefore)(start, min);
      var continuesAfter = startsAfter(end, max);

      var title = (0, _accessors.accessor)(event, titleAccessor);
      var tooltip = (0, _accessors.accessor)(event, tooltipAccessor);
      var label = void 0;
      if (_continuesPrior && _continuesAfter) {
        label = messages.allDay;
      } else {
        label = _localizer2.default.format({ start: start, end: end }, _eventTimeRangeFormat, culture);
      }

      var _isSelected = (0, _selection.isSelected)(event, selected);

      if (eventPropGetter) var _eventPropGetter = eventPropGetter(event, start, end, _isSelected),
            xStyle = _eventPropGetter.style,
            className = _eventPropGetter.className;

      var height = style.height,
          top = style.top,
          width = style.width,
          xOffset = style.xOffset;


      return _react2.default.createElement(
        EventWrapper,
        { event: event, key: 'evt_' + idx },
        _react2.default.createElement(
          'div',
          {
            style: _extends({}, xStyle, (_extends2 = {
              top: top + '%',
              height: height + '%'
            }, _extends2[isRtl ? 'right' : 'left'] = Math.max(0, xOffset) + '%', _extends2.width = width + '%', _extends2)),
            title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
            onClick: function onClick(e) {
              return _this2._select(event, e);
            },
            onDoubleClick: function onDoubleClick(e) {
              return _this2._doubleClick(event, e);
            },
            className: (0, _classnames2.default)('rbc-event', className, {
              'rbc-selected': _isSelected,
              'rbc-event-continues-earlier': continuesPrior,
              'rbc-event-continues-later': continuesAfter,
              'rbc-event-continues-day-prior': _continuesPrior,
              'rbc-event-continues-day-after': _continuesAfter
            })
          },
          _react2.default.createElement(
            'div',
            { className: 'rbc-event-label' },
            label
          ),
          _react2.default.createElement(
            'div',
            { className: 'rbc-event-content' },
            EventComponent ? _react2.default.createElement(EventComponent, { event: event, title: title }) : title
          )
        )
      );
    });
  };

  this._slotStyle = function (startSlot, endSlot) {
    var top = startSlot / _this2._totalMin * 100;
    var bottom = endSlot / _this2._totalMin * 100;

    return {
      top: top + '%',
      height: bottom - top + '%'
    };
  };

  this._selectable = function () {
    var node = (0, _reactDom.findDOMNode)(_this2);
    var selector = _this2._selector = new _Selection2.default(function () {
      return (0, _reactDom.findDOMNode)(_this2);
    }, {
      longPressThreshold: _this2.props.longPressThreshold
    });

    var maybeSelect = function maybeSelect(box) {
      var onSelecting = _this2.props.onSelecting;
      var current = _this2.state || {};
      var state = selectionState(box);
      var start = state.startDate,
          end = state.endDate;


      if (onSelecting) {
        if (_dates2.default.eq(current.startDate, start, 'minutes') && _dates2.default.eq(current.endDate, end, 'minutes') || onSelecting({ start: start, end: end }) === false) return;
      }

      _this2.setState(state);
    };

    var selectionState = function selectionState(_ref3) {
      var y = _ref3.y;
      var _props3 = _this2.props,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;

      var _getBoundsForNode = (0, _Selection.getBoundsForNode)(node),
          top = _getBoundsForNode.top,
          bottom = _getBoundsForNode.bottom;

      var mins = _this2._totalMin;

      var range = Math.abs(top - bottom);

      var current = (y - top) / range;

      current = snapToSlot(minToDate(mins * current, min), step);

      if (!_this2.state.selecting) _this2._initialDateSlot = current;

      var initial = _this2._initialDateSlot;

      if (_dates2.default.eq(initial, current, 'minutes')) current = _dates2.default.add(current, step, 'minutes');

      var start = _dates2.default.max(min, _dates2.default.min(initial, current));
      var end = _dates2.default.min(max, _dates2.default.max(initial, current));

      return {
        selecting: true,
        startDate: start,
        endDate: end,
        startSlot: (0, _dayViewLayout.positionFromDate)(start, min, _this2._totalMin),
        endSlot: (0, _dayViewLayout.positionFromDate)(end, min, _this2._totalMin)
      };
    };

    var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box)) _this2._selectSlot(_extends({}, selectionState(box), { action: actionType }));

      _this2.setState({ selecting: false });
    };

    selector.on('selecting', maybeSelect);
    selector.on('selectStart', maybeSelect);

    selector.on('beforeSelect', function (box) {
      if (_this2.props.selectable !== 'ignoreEvents') return;

      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
    });

    selector.on('click', function (box) {
      return selectorClicksHandler(box, 'click');
    });

    selector.on('doubleClick', function (box) {
      return selectorClicksHandler(box, 'doubleClick');
    });

    selector.on('select', function () {
      if (_this2.state.selecting) {
        _this2._selectSlot(_extends({}, _this2.state, { action: 'select' }));
        _this2.setState({ selecting: false });
      }
    });
  };

  this._teardownSelectable = function () {
    if (!_this2._selector) return;
    _this2._selector.teardown();
    _this2._selector = null;
  };

  this._selectSlot = function (_ref4) {
    var startDate = _ref4.startDate,
        endDate = _ref4.endDate,
        action = _ref4.action;

    var current = startDate,
        slots = [];

    while (_dates2.default.lte(current, endDate)) {
      slots.push(current);
      current = _dates2.default.add(current, _this2.props.step, 'minutes');
    }

    (0, _helpers.notify)(_this2.props.onSelectSlot, {
      slots: slots,
      start: startDate,
      end: endDate,
      resourceId: _this2.props.resource,
      action: action
    });
  };

  this._select = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (0, _helpers.notify)(_this2.props.onSelectEvent, args);
  };

  this._doubleClick = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    (0, _helpers.notify)(_this2.props.onDoubleClickEvent, args);
  };
};

function minToDate(min, date) {
  var dt = new Date(date),
      totalMins = _dates2.default.diff(_dates2.default.startOf(date, 'day'), date, 'minutes');

  dt = _dates2.default.hours(dt, 0);
  dt = _dates2.default.minutes(dt, totalMins + min);
  dt = _dates2.default.seconds(dt, 0);
  return _dates2.default.milliseconds(dt, 0);
}

exports.default = DayColumn;
module.exports = exports['default'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.positionFromDate = exports.startsBefore = undefined;

var _event2 = __webpack_require__(762);

Object.defineProperty(exports, 'startsBefore', {
  enumerable: true,
  get: function get() {
    return _event2.startsBefore;
  }
});
Object.defineProperty(exports, 'positionFromDate', {
  enumerable: true,
  get: function get() {
    return _event2.positionFromDate;
  }
});

var _sortBy = __webpack_require__(763);

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Return true if event a and b is considered to be on the same row.
 */
function onSameRow(a, b) {
  return (
    // Occupies the same start slot.
    Math.abs(b.startSlot - a.startSlot) <= 30 ||
    // A's start slot overlaps with b's end slot.
    a.startSlot > b.startSlot && a.startSlot < b.endSlot
  );
}

function sortByRender(events) {
  var sortedByTime = (0, _sortBy2.default)(events, ['start', function (e) {
    return -e.end;
  }]);

  var sorted = [];
  while (sortedByTime.length > 0) {
    var event = sortedByTime.shift();
    sorted.push(event);

    for (var i = 0; i < sortedByTime.length; i++) {
      var test = sortedByTime[i];

      // Still inside this event, look for next.
      if (event.end > test.start) {
        continue;
      }

      // We've found the first event of the next event group.
      // If that event is not right next to our current event, we have to
      // move it here.
      if (i > 0) {
        var _sortedByTime$splice = sortedByTime.splice(i, 1),
            _event = _sortedByTime$splice[0];

        sorted.push(_event);
      }

      // We've already found the next event group, so stop looking.
      break;
    }
  }

  return sorted;
}

function getStyledEvents(_ref) {
  var events = _ref.events,
      props = _objectWithoutProperties(_ref, ['events']);

  // Create proxy events and order them so that we don't have
  // to fiddle with z-indexes.
  var proxies = events.map(function (event) {
    return new _event2.Event(event, props);
  });
  var eventsInRenderOrder = sortByRender(proxies);

  // Group overlapping events, while keeping order.
  // Every event is always one of: container, row or leaf.
  // Containers can contain rows, and rows can contain leaves.
  var containerEvents = [];

  var _loop = function _loop(i) {
    var event = eventsInRenderOrder[i];

    // Check if this event can go into a container event.
    var container = containerEvents.find(function (c) {
      return c.endSlot > event.startSlot;
    });

    // Couldn't find a container — that means this event is a container.
    if (!container) {
      event.rows = [];
      containerEvents.push(event);
      return 'continue';
    }

    // Found a container for the event.
    event.container = container;

    // Check if the event can be placed in an existing row.
    // Start looking from behind.
    var row = null;
    for (var j = container.rows.length - 1; !row && j >= 0; j--) {
      if (onSameRow(container.rows[j], event)) {
        row = container.rows[j];
      }
    }

    if (row) {
      // Found a row, so add it.
      row.leaves.push(event);
      event.row = row;
    } else {
      // Couldn't find a row – that means this event is a row.
      event.leaves = [];
      container.rows.push(event);
    }
  };

  for (var i = 0; i < eventsInRenderOrder.length; i++) {
    var _ret = _loop(i);

    if (_ret === 'continue') continue;
  }

  // Return the original events, along with their styles.
  return eventsInRenderOrder.map(function (event) {
    return {
      event: event.data,
      style: {
        top: event.top,
        height: event.height,
        width: event.width,
        xOffset: event.xOffset
      }
    };
  });
}

exports.default = getStyledEvents;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Event = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.startsBefore = startsBefore;
exports.positionFromDate = positionFromDate;

var _accessors = __webpack_require__(61);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function startsBefore(date, min) {
  return _dates2.default.lt(_dates2.default.merge(min, date), min, 'minutes');
}

function positionFromDate(date, min, total) {
  if (startsBefore(date, min)) {
    return 0;
  }

  var diff = _dates2.default.diff(min, _dates2.default.merge(min, date), 'minutes');
  return Math.min(diff, total);
}

var Event = exports.Event = function () {
  function Event(data, props) {
    _classCallCheck(this, Event);

    var startAccessor = props.startAccessor,
        endAccessor = props.endAccessor,
        min = props.min,
        totalMin = props.totalMin;

    var _normalizeDates = normalizeDates((0, _accessors.accessor)(data, startAccessor), (0, _accessors.accessor)(data, endAccessor), props),
        startDate = _normalizeDates[0],
        endDate = _normalizeDates[1];

    this.startSlot = positionFromDate(startDate, min, totalMin);
    this.endSlot = positionFromDate(endDate, min, totalMin);
    this.start = +startDate;
    this.end = +endDate;
    this.top = this.startSlot / totalMin * 100;
    this.height = this.endSlot / totalMin * 100 - this.top;
    this.data = data;
  }

  /**
   * The event's width without any overlap.
   */


  _createClass(Event, [{
    key: '_width',
    get: function get() {
      // The container event's width is determined by the maximum number of
      // events in any of its rows.
      if (this.rows) {
        var columns = this.rows.reduce(function (max, row) {
          return Math.max(max, row.leaves.length + 1); // add itself
        }, 0) + 1; // add the container

        return 100 / columns;
      }

      var availableWidth = 100 - this.container._width;

      // The row event's width is the space left by the container, divided
      // among itself and its leaves.
      if (this.leaves) {
        return availableWidth / (this.leaves.length + 1);
      }

      // The leaf event's width is determined by its row's width
      return this.row._width;
    }

    /**
     * The event's calculated width, possibly with extra width added for
     * overlapping effect.
     */

  }, {
    key: 'width',
    get: function get() {
      var noOverlap = this._width;
      var overlap = Math.min(100, this._width * 1.7);

      // Containers can always grow.
      if (this.rows) {
        return overlap;
      }

      // Rows can grow if they have leaves.
      if (this.leaves) {
        return this.leaves.length > 0 ? overlap : noOverlap;
      }

      // Leaves can grow unless they're the last item in a row.
      var leaves = this.row.leaves;

      var index = leaves.indexOf(this);
      return index === leaves.length - 1 ? noOverlap : overlap;
    }
  }, {
    key: 'xOffset',
    get: function get() {
      // Containers have no offset.
      if (this.rows) {
        return 0;
      }

      // Rows always start where their container ends.
      if (this.leaves) {
        return this.container._width;
      }

      // Leaves are spread out evenly on the space left by its row.
      var _row = this.row,
          leaves = _row.leaves,
          xOffset = _row.xOffset,
          _width = _row._width;

      var index = leaves.indexOf(this) + 1;
      return xOffset + index * _width;
    }
  }]);

  return Event;
}();

/**
 * Return start and end dates with respect to timeslot positions.
 */


function normalizeDates(startDate, endDate, _ref) {
  var min = _ref.min,
      showMultiDayTimes = _ref.showMultiDayTimes;

  if (!showMultiDayTimes) {
    return [startDate, endDate];
  }

  var current = new Date(min); // today at midnight
  var c = new Date(current);
  var s = new Date(startDate);
  var e = new Date(endDate);

  // Use noon to compare dates to avoid DST issues.
  s.setHours(12, 0, 0, 0);
  e.setHours(12, 0, 0, 0);
  c.setHours(12, 0, 0, 0);

  // Current day is at the start, but it spans multiple days,
  // so we correct the end.
  if (+c === +s && c < e) {
    return [startDate, _dates2.default.endOf(startDate, 'day')];
  }

  // Current day is in between start and end dates,
  // so we make it span all day.
  if (c > s && c < e) {
    return [current, _dates2.default.endOf(current, 'day')];
  }

  // Current day is at the end of a multi day event,
  // so we make it start at midnight, and end normally.
  if (c > s && +c === +e) {
    return [current, endDate];
  }

  return [startDate, endDate];
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(321),
    baseOrderBy = __webpack_require__(765),
    baseRest = __webpack_require__(322),
    isIterateeCall = __webpack_require__(109);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(60),
    isArguments = __webpack_require__(163),
    isArray = __webpack_require__(23);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(183),
    baseIteratee = __webpack_require__(111),
    baseMap = __webpack_require__(766),
    baseSortBy = __webpack_require__(771),
    baseUnary = __webpack_require__(102),
    compareMultiple = __webpack_require__(772),
    identity = __webpack_require__(113);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(767),
    isArrayLike = __webpack_require__(72);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(185),
    createBaseEach = __webpack_require__(770);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(769);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(72);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(773);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(75);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(776),
    defineProperty = __webpack_require__(287),
    identity = __webpack_require__(113);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 776 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TimeSlot = __webpack_require__(779);

var _TimeSlot2 = _interopRequireDefault(_TimeSlot);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _propTypes3 = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeSlotGroup = function (_Component) {
  _inherits(TimeSlotGroup, _Component);

  function TimeSlotGroup() {
    _classCallCheck(this, TimeSlotGroup);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TimeSlotGroup.prototype.renderSlice = function renderSlice(slotNumber, content, value) {
    var _props = this.props,
        dayWrapperComponent = _props.dayWrapperComponent,
        showLabels = _props.showLabels,
        isNow = _props.isNow,
        culture = _props.culture,
        resource = _props.resource,
        slotPropGetter = _props.slotPropGetter;

    return _react2.default.createElement(_TimeSlot2.default, {
      key: slotNumber,
      slotPropGetter: slotPropGetter,
      dayWrapperComponent: dayWrapperComponent,
      showLabel: showLabels && !slotNumber,
      content: content,
      culture: culture,
      isNow: isNow,
      resource: resource,
      value: value
    });
  };

  TimeSlotGroup.prototype.renderSlices = function renderSlices() {
    var ret = [];
    var sliceLength = this.props.step;
    var sliceValue = this.props.value;
    for (var i = 0; i < this.props.timeslots; i++) {
      var content = _localizer2.default.format(sliceValue, this.props.timeGutterFormat, this.props.culture);
      ret.push(this.renderSlice(i, content, sliceValue));
      sliceValue = _dates2.default.add(sliceValue, sliceLength, 'minutes');
    }
    return ret;
  };

  TimeSlotGroup.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: 'rbc-timeslot-group' },
      this.renderSlices()
    );
  };

  return TimeSlotGroup;
}(_react.Component);

TimeSlotGroup.propTypes = {
  dayWrapperComponent: _propTypes3.elementType,
  timeslots: _propTypes2.default.number.isRequired,
  step: _propTypes2.default.number.isRequired,
  value: _propTypes2.default.instanceOf(Date).isRequired,
  showLabels: _propTypes2.default.bool,
  isNow: _propTypes2.default.bool,
  slotPropGetter: _propTypes2.default.func,
  timeGutterFormat: _propTypes3.dateFormat,
  culture: _propTypes2.default.string,
  resource: _propTypes2.default.string
};
TimeSlotGroup.defaultProps = {
  timeslots: 2,
  step: 30,
  isNow: false,
  showLabels: false
};
exports.default = TimeSlotGroup;
module.exports = exports['default'];

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes3 = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeSlot = function (_Component) {
  _inherits(TimeSlot, _Component);

  function TimeSlot() {
    _classCallCheck(this, TimeSlot);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TimeSlot.prototype.render = function render() {
    var _props = this.props,
        value = _props.value,
        slotPropGetter = _props.slotPropGetter,
        resource = _props.resource;

    var Wrapper = this.props.dayWrapperComponent;

    var _ref = slotPropGetter && slotPropGetter(value) || {},
        className = _ref.className,
        style = _ref.style;

    return _react2.default.createElement(
      Wrapper,
      { value: value, resource: resource },
      _react2.default.createElement(
        'div',
        {
          style: style,
          className: (0, _classnames2.default)('rbc-time-slot', className, this.props.showLabel && 'rbc-label', this.props.isNow && 'rbc-now')
        },
        this.props.showLabel && _react2.default.createElement(
          'span',
          null,
          this.props.content
        )
      )
    );
  };

  return TimeSlot;
}(_react.Component);

TimeSlot.propTypes = {
  dayWrapperComponent: _propTypes3.elementType,
  value: _propTypes2.default.instanceOf(Date).isRequired,
  isNow: _propTypes2.default.bool,
  showLabel: _propTypes2.default.bool,
  content: _propTypes2.default.string,
  culture: _propTypes2.default.string,
  slotPropGetter: _propTypes2.default.func,
  resource: _propTypes2.default.string
};
TimeSlot.defaultProps = {
  isNow: false,
  showLabel: false,
  content: ''
};
exports.default = TimeSlot;
module.exports = exports['default'];

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Week = __webpack_require__(328);

var _Week2 = _interopRequireDefault(_Week);

var _TimeGrid = __webpack_require__(184);

var _TimeGrid2 = _interopRequireDefault(_TimeGrid);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function workWeekRange(date, options) {
  return _Week2.default.range(date, options).filter(function (d) {
    return [6, 0].indexOf(d.getDay()) === -1;
  });
}

var WorkWeek = function (_React$Component) {
  _inherits(WorkWeek, _React$Component);

  function WorkWeek() {
    _classCallCheck(this, WorkWeek);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  WorkWeek.prototype.render = function render() {
    var _props = this.props,
        date = _props.date,
        props = _objectWithoutProperties(_props, ['date']);

    var range = workWeekRange(date, this.props);

    return _react2.default.createElement(_TimeGrid2.default, _extends({}, props, { range: range, eventOffset: 15 }));
  };

  return WorkWeek;
}(_react2.default.Component);

WorkWeek.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired
};
WorkWeek.defaultProps = _TimeGrid2.default.defaultProps;


WorkWeek.navigate = _Week2.default.navigate;

WorkWeek.title = function (date, _ref) {
  var formats = _ref.formats,
      culture = _ref.culture;

  var _workWeekRange = workWeekRange(date, { culture: culture }),
      start = _workWeekRange[0],
      rest = _workWeekRange.slice(1);

  return _localizer2.default.format({ start: start, end: rest.pop() }, formats.dayRangeHeaderFormat, culture);
};

exports.default = WorkWeek;
module.exports = exports['default'];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _class = __webpack_require__(782);

var _class2 = _interopRequireDefault(_class);

var _width = __webpack_require__(326);

var _width2 = _interopRequireDefault(_width);

var _scrollbarSize = __webpack_require__(327);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _localizer = __webpack_require__(17);

var _localizer2 = _interopRequireDefault(_localizer);

var _messages = __webpack_require__(108);

var _messages2 = _interopRequireDefault(_messages);

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _constants = __webpack_require__(29);

var _accessors = __webpack_require__(61);

var _propTypes3 = __webpack_require__(20);

var _eventLevels = __webpack_require__(46);

var _selection = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Agenda = function (_React$Component) {
  _inherits(Agenda, _React$Component);

  function Agenda() {
    var _temp, _this, _ret;

    _classCallCheck(this, Agenda);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderDay = function (day, events, dayKey) {
      var _this$props = _this.props,
          culture = _this$props.culture,
          components = _this$props.components,
          titleAccessor = _this$props.titleAccessor,
          agendaDateFormat = _this$props.agendaDateFormat,
          eventPropGetter = _this$props.eventPropGetter,
          startAccessor = _this$props.startAccessor,
          endAccessor = _this$props.endAccessor,
          selected = _this$props.selected;


      var EventComponent = components.event;
      var DateComponent = components.date;

      events = events.filter(function (e) {
        return (0, _eventLevels.inRange)(e, day, day, _this.props);
      });

      return events.map(function (event, idx) {
        var _ref = eventPropGetter ? eventPropGetter(event, (0, _accessors.accessor)(event, startAccessor), (0, _accessors.accessor)(event, endAccessor), (0, _selection.isSelected)(event, selected)) : {},
            className = _ref.className,
            style = _ref.style;

        var dateLabel = idx === 0 && _localizer2.default.format(day, agendaDateFormat, culture);
        var first = idx === 0 ? _react2.default.createElement(
          'td',
          { rowSpan: events.length, className: 'rbc-agenda-date-cell' },
          DateComponent ? _react2.default.createElement(DateComponent, { day: day, label: dateLabel }) : dateLabel
        ) : false;

        var title = (0, _accessors.accessor)(event, titleAccessor);

        return _react2.default.createElement(
          'tr',
          { key: dayKey + '_' + idx, className: className, style: style },
          first,
          _react2.default.createElement(
            'td',
            { className: 'rbc-agenda-time-cell' },
            _this.timeRangeLabel(day, event)
          ),
          _react2.default.createElement(
            'td',
            { className: 'rbc-agenda-event-cell' },
            EventComponent ? _react2.default.createElement(EventComponent, { event: event, title: title }) : title
          )
        );
      }, []);
    }, _this.timeRangeLabel = function (day, event) {
      var _this$props2 = _this.props,
          endAccessor = _this$props2.endAccessor,
          startAccessor = _this$props2.startAccessor,
          allDayAccessor = _this$props2.allDayAccessor,
          culture = _this$props2.culture,
          messages = _this$props2.messages,
          components = _this$props2.components;


      var labelClass = '',
          TimeComponent = components.time,
          label = (0, _messages2.default)(messages).allDay;

      var start = (0, _accessors.accessor)(event, startAccessor);
      var end = (0, _accessors.accessor)(event, endAccessor);

      if (!(0, _accessors.accessor)(event, allDayAccessor)) {
        if (_dates2.default.eq(start, end, 'day')) {
          label = _localizer2.default.format({ start: start, end: end }, _this.props.agendaTimeRangeFormat, culture);
        } else if (_dates2.default.eq(day, start, 'day')) {
          label = _localizer2.default.format(start, _this.props.agendaTimeFormat, culture);
        } else if (_dates2.default.eq(day, end, 'day')) {
          label = _localizer2.default.format(end, _this.props.agendaTimeFormat, culture);
        }
      }

      if (_dates2.default.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
      if (_dates2.default.lt(day, end, 'day')) labelClass += ' rbc-continues-after';

      return _react2.default.createElement(
        'span',
        { className: labelClass.trim() },
        TimeComponent ? _react2.default.createElement(TimeComponent, { event: event, day: day, label: label }) : label
      );
    }, _this._adjustHeader = function () {
      var header = _this.refs.header;
      var firstRow = _this.refs.tbody.firstChild;

      if (!firstRow) return;

      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;
      var widths = _this._widths || [];

      _this._widths = [(0, _width2.default)(firstRow.children[0]), (0, _width2.default)(firstRow.children[1])];

      if (widths[0] !== _this._widths[0] || widths[1] !== _this._widths[1]) {
        _this.refs.dateCol.style.width = _this._widths[0] + 'px';
        _this.refs.timeCol.style.width = _this._widths[1] + 'px';
      }

      if (isOverflowing) {
        _class2.default.addClass(header, 'rbc-header-overflowing');
        header.style.marginRight = (0, _scrollbarSize2.default)() + 'px';
      } else {
        _class2.default.removeClass(header, 'rbc-header-overflowing');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Agenda.prototype.componentDidMount = function componentDidMount() {
    this._adjustHeader();
  };

  Agenda.prototype.componentDidUpdate = function componentDidUpdate() {
    this._adjustHeader();
  };

  Agenda.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        length = _props.length,
        date = _props.date,
        events = _props.events,
        startAccessor = _props.startAccessor;

    var messages = (0, _messages2.default)(this.props.messages);
    var end = _dates2.default.add(date, length, 'day');

    var range = _dates2.default.range(date, end, 'day');

    events = events.filter(function (event) {
      return (0, _eventLevels.inRange)(event, date, end, _this2.props);
    });

    events.sort(function (a, b) {
      return +(0, _accessors.accessor)(a, startAccessor) - +(0, _accessors.accessor)(b, startAccessor);
    });

    return _react2.default.createElement(
      'div',
      { className: 'rbc-agenda-view' },
      _react2.default.createElement(
        'table',
        { ref: 'header' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              { className: 'rbc-header', ref: 'dateCol' },
              messages.date
            ),
            _react2.default.createElement(
              'th',
              { className: 'rbc-header', ref: 'timeCol' },
              messages.time
            ),
            _react2.default.createElement(
              'th',
              { className: 'rbc-header' },
              messages.event
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'rbc-agenda-content', ref: 'content' },
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            { ref: 'tbody' },
            range.map(function (day, idx) {
              return _this2.renderDay(day, events, idx);
            })
          )
        )
      )
    );
  };

  return Agenda;
}(_react2.default.Component);

Agenda.propTypes = {
  events: _propTypes2.default.array,
  date: _propTypes2.default.instanceOf(Date),
  length: _propTypes2.default.number.isRequired,
  titleAccessor: _propTypes3.accessor.isRequired,
  tooltipAccessor: _propTypes3.accessor.isRequired,
  allDayAccessor: _propTypes3.accessor.isRequired,
  startAccessor: _propTypes3.accessor.isRequired,
  endAccessor: _propTypes3.accessor.isRequired,
  eventPropGetter: _propTypes2.default.func,
  selected: _propTypes2.default.object,

  agendaDateFormat: _propTypes3.dateFormat,
  agendaTimeFormat: _propTypes3.dateFormat,
  agendaTimeRangeFormat: _propTypes3.dateRangeFormat,
  culture: _propTypes2.default.string,

  components: _propTypes2.default.object.isRequired,
  messages: _propTypes2.default.shape({
    date: _propTypes2.default.string,
    time: _propTypes2.default.string
  })
};
Agenda.defaultProps = {
  length: 30
};


Agenda.navigate = function (date, action, _ref2) {
  var _ref2$length = _ref2.length,
      length = _ref2$length === undefined ? Agenda.defaultProps.length : _ref2$length;

  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates2.default.add(date, -length, 'day');

    case _constants.navigate.NEXT:
      return _dates2.default.add(date, length, 'day');

    default:
      return date;
  }
};

Agenda.title = function (start, _ref3) {
  var _ref3$length = _ref3.length,
      length = _ref3$length === undefined ? Agenda.defaultProps.length : _ref3$length,
      formats = _ref3.formats,
      culture = _ref3.culture;

  var end = _dates2.default.add(start, length, 'day');
  return _localizer2.default.format({ start: start, end: end }, formats.agendaHeaderFormat, culture);
};

Agenda.title = function (start, _ref4) {
  var _ref4$length = _ref4.length,
      length = _ref4$length === undefined ? length = Agenda.defaultProps.length : _ref4$length,
      formats = _ref4.formats,
      culture = _ref4.culture;

  var end = _dates2.default.add(start, length, 'day');
  return _localizer2.default.format({ start: start, end: end }, formats.agendaHeaderFormat, culture);
};

exports.default = Agenda;
module.exports = exports['default'];

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(269));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(271));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(270));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toolbar = function (_React$Component) {
  _inherits(Toolbar, _React$Component);

  function Toolbar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Toolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.navigate = function (action) {
      _this.props.onNavigate(action);
    }, _this.view = function (view) {
      _this.props.onViewChange(view);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Toolbar.prototype.render = function render() {
    var _props = this.props,
        messages = _props.messages,
        label = _props.label;


    return _react2.default.createElement(
      'div',
      { className: 'rbc-toolbar' },
      _react2.default.createElement(
        'span',
        { className: 'rbc-btn-group' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            onClick: this.navigate.bind(null, _constants.navigate.TODAY)
          },
          messages.today
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            onClick: this.navigate.bind(null, _constants.navigate.PREVIOUS)
          },
          messages.previous
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            onClick: this.navigate.bind(null, _constants.navigate.NEXT)
          },
          messages.next
        )
      ),
      _react2.default.createElement(
        'span',
        { className: 'rbc-toolbar-label' },
        label
      ),
      _react2.default.createElement(
        'span',
        { className: 'rbc-btn-group' },
        this.viewNamesGroup(messages)
      )
    );
  };

  Toolbar.prototype.viewNamesGroup = function viewNamesGroup(messages) {
    var _this2 = this;

    var viewNames = this.props.views;
    var view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map(function (name) {
        return _react2.default.createElement(
          'button',
          {
            type: 'button',
            key: name,
            className: (0, _classnames2.default)({ 'rbc-active': view === name }),
            onClick: _this2.view.bind(null, name)
          },
          messages[name]
        );
      });
    }
  };

  return Toolbar;
}(_react2.default.Component);

Toolbar.propTypes = {
  view: _propTypes2.default.string.isRequired,
  views: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  label: _propTypes2.default.node.isRequired,
  messages: _propTypes2.default.object,
  onNavigate: _propTypes2.default.func.isRequired,
  onViewChange: _propTypes2.default.func.isRequired
};
exports.default = Toolbar;
module.exports = exports['default'];

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(183),
    baseClone = __webpack_require__(284),
    baseUnset = __webpack_require__(785),
    castPath = __webpack_require__(112),
    copyObject = __webpack_require__(73),
    customOmitClone = __webpack_require__(788),
    flatRest = __webpack_require__(790),
    getAllKeysIn = __webpack_require__(289);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(112),
    last = __webpack_require__(786),
    parent = __webpack_require__(787),
    toKey = __webpack_require__(80);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(181),
    baseSlice = __webpack_require__(304);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(789);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(59),
    getPrototype = __webpack_require__(104),
    isObjectLike = __webpack_require__(38);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(791),
    overRest = __webpack_require__(323),
    setToString = __webpack_require__(324);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(321);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(322),
    eq = __webpack_require__(70),
    isIterateeCall = __webpack_require__(109),
    keysIn = __webpack_require__(170);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(285),
    baseCreate = __webpack_require__(290),
    baseForOwn = __webpack_require__(185),
    baseIteratee = __webpack_require__(111),
    getPrototype = __webpack_require__(104),
    isArray = __webpack_require__(23),
    isBuffer = __webpack_require__(101),
    isFunction = __webpack_require__(159),
    isObject = __webpack_require__(31),
    isTypedArray = __webpack_require__(165);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(169),
    baseForOwn = __webpack_require__(185),
    baseIteratee = __webpack_require__(111);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.formats = undefined;

exports.default = function (moment) {
  var locale = function locale(m, c) {
    return c ? m.locale(c) : m;
  };

  (0, _formats.set)(formats);

  return (0, _localizer.set)({
    firstOfWeek: function firstOfWeek(culture) {
      var data = culture ? moment.localeData(culture) : moment.localeData();
      return data ? data.firstDayOfWeek() : 0;
    },
    parse: function parse(value, format, culture) {
      return locale(moment(value, format), culture).toDate();
    },
    format: function format(value, _format, culture) {
      return locale(moment(value), culture).format(_format);
    }
  });
};

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _formats = __webpack_require__(107);

var _localizer = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'L', culture) + ' — ' + local.format(end, 'L', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 'LT', culture) + ' — ' + local.format(end, 'LT', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start,
      end = _ref3.end;
  return local.format(start, 'h:mma', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var start = _ref4.start,
      end = _ref4.end;
  return ' — ' + local.format(end, 'h:mma', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM DD', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'DD' : 'MMM DD', culture);
};

var formats = exports.formats = {
  dateFormat: 'DD',
  dayFormat: 'ddd DD/MM',
  weekdayFormat: 'ddd',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: 'LT',

  monthHeaderFormat: 'MMMM YYYY',
  dayHeaderFormat: 'dddd MMM DD',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'ddd MMM DD',
  agendaTimeFormat: 'LT',
  agendaTimeRangeFormat: timeRangeFormat
};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.formats = undefined;

exports.default = function (globalize) {
  var locale = function locale(culture) {
    return culture ? globalize(culture) : globalize;
  };

  // return the first day of the week from the locale data. Defaults to 'world'
  // territory if no territory is derivable from CLDR.
  // Failing to use CLDR supplemental (not loaded?), revert to the original
  // method of getting first day of week.
  function firstOfWeek(culture) {
    try {
      var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var cldr = locale(culture).cldr;
      var territory = cldr.attributes.territory;
      var weekData = cldr.get('supplemental').weekData;
      var firstDay = weekData.firstDay[territory || '001'];
      return days.indexOf(firstDay);
    } catch (e) {
       false ? (0, _warning2.default)(true, 'Failed to accurately determine first day of the week.\n            Is supplemental data loaded into CLDR?') : void 0;
      // maybe cldr supplemental is not loaded? revert to original method
      var date = new Date();
      //cldr-data doesn't seem to be zero based
      var localeDay = Math.max(parseInt(locale(culture).formatDate(date, { raw: 'e' }), 10) - 1, 0);

      return Math.abs(date.getDay() - localeDay);
    }
  }

  if (!globalize.load) return (0, _oldGlobalize2.default)(globalize);

  (0, _formats.set)(formats);

  return (0, _localizer.set)({
    firstOfWeek: firstOfWeek,

    parse: function parse(value, format, culture) {
      format = typeof format === 'string' ? { raw: format } : format;
      return locale(culture).parseDate(value, format);
    },
    format: function format(value, _format, culture) {
      _format = typeof _format === 'string' ? { raw: _format } : _format;
      return locale(culture).formatDate(value, _format);
    }
  });
};

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _oldGlobalize = __webpack_require__(797);

var _oldGlobalize2 = _interopRequireDefault(_oldGlobalize);

var _warning = __webpack_require__(798);

var _warning2 = _interopRequireDefault(_warning);

var _formats = __webpack_require__(107);

var _localizer = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, { date: 'short' }, culture) + ' — ' + local.format(end, { date: 'short' }, culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, { time: 'short' }, culture) + ' — ' + local.format(end, { time: 'short' }, culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start;
  return local.format(start, { time: 'short' }, culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var end = _ref4.end;
  return ' — ' + local.format(end, { time: 'short' }, culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' — ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = exports.formats = {
  dateFormat: 'dd',
  dayFormat: 'eee dd/MM',
  weekdayFormat: 'eee',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: { time: 'short' },

  monthHeaderFormat: 'MMMM yyyy',
  dayHeaderFormat: 'eeee MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'eee MMM dd',
  agendaTimeFormat: { time: 'short' },
  agendaTimeRangeFormat: timeRangeFormat
};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.formats = undefined;

exports.default = function (globalize) {
  function getCulture(culture) {
    return culture ? globalize.findClosestCulture(culture) : globalize.culture();
  }

  function firstOfWeek(culture) {
    culture = getCulture(culture);
    return culture && culture.calendar.firstDay || 0;
  }

  (0, _formats.set)(formats);

  return (0, _localizer.set)({
    firstOfWeek: firstOfWeek,

    parse: function parse(value, format, culture) {
      return globalize.parseDate(value, format, culture);
    },
    format: function format(value, _format, culture) {
      return globalize.format(value, _format, culture);
    }
  });
};

var _dates = __webpack_require__(16);

var _dates2 = _interopRequireDefault(_dates);

var _formats = __webpack_require__(107);

var _localizer = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 't', culture) + ' — ' + local.format(end, 't', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start,
      end = _ref3.end;
  return local.format(start, 't', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var start = _ref4.start,
      end = _ref4.end;
  return ' — ' + local.format(end, 't', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates2.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = exports.formats = {
  dateFormat: 'dd',
  dayFormat: 'ddd dd/MM',
  weekdayFormat: 'ddd',

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: 't',

  monthHeaderFormat: 'Y',
  dayHeaderFormat: 'dddd MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: 'ddd MMM dd',
  agendaTimeFormat: 't',
  agendaTimeRangeFormat: timeRangeFormat
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reply__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Inbox__ = __webpack_require__(800);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Getinbox=function(_Component){_inherits(Getinbox,_Component);function Getinbox(props){_classCallCheck(this,Getinbox);var _this=_possibleConstructorReturn(this,(Getinbox.__proto__||Object.getPrototypeOf(Getinbox)).call(this,props));_this.state={reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Inbox__["a" /* default */],{Replydata:_this.getReplydata.bind(_this)})};return _this;}_createClass(Getinbox,[{key:'getUnread',value:function getUnread(new_in){this.props.Newunread(new_in);}},{key:'getReplydata',value:function getReplydata(msg_id,from,subject,content,alldata){this.setState({reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Reply__["a" /* default */],{msgid:msg_id,to_address:from,to_subject:subject,to_content:content,to_datas:alldata,Rerender:this.getRerender.bind(this)})});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Inbox__["a" /* default */],{Replydata:this.getReplydata.bind(this)})});}},{key:'getRerender',value:function getRerender(){this.setState({reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Inbox__["a" /* default */],{Replydata:this.getReplydata.bind(this)})});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.reply_component);}}]);return Getinbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Getinbox);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Pagination__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_newPostAction__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_inboxAction__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Inbox=function(_Component){_inherits(Inbox,_Component);function Inbox(props){_classCallCheck(this,Inbox);var _this=_possibleConstructorReturn(this,(Inbox.__proto__||Object.getPrototypeOf(Inbox)).call(this,props));_this.state={inbox_mail:[],count:0,pageOfItems:[],idd:'',searchtext:'',datas:[],checkedValues:[],inbox_data:[],msg_ids:[]};_this.props.getInbox();_this.onChangePage=_this.onChangePage.bind(_this);_this.viewItem=_this.viewItem.bind(_this);_this.getCheck=_this.getCheck.bind(_this);_this.selectAll=_this.selectAll.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.getSearch=_this.getSearch.bind(_this);_this.Reply=_this.Reply.bind(_this);_this.onSort=_this.onSort.bind(_this);_this.changeStatus=_this.changeStatus.bind(_this);return _this;}_createClass(Inbox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// alert(JSON.stringify(nextProps.inbox_data));
var searchtext='';this.setState({inbox_data:nextProps.inbox,datas:nextProps.inbox_data.inbox_mail,inbox_mail:nextProps.inbox_data.inbox_mail,count:nextProps.inbox_data.inbox_mail?nextProps.inbox_data.inbox_mail.length:0,pageOfItems:nextProps.inbox_data.inbox_mail,searchtext:searchtext});}},{key:'viewItem',value:function viewItem(edit_id,msg_id){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var admin_role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);var old_id=this.state.idd;if(edit_id==old_id){// alert('same');
if($("#"+edit_id).css('display')=='none'){$("#"+edit_id).show();}else{$("#"+edit_id).hide();}}else{$("#"+old_id).hide();$("#"+edit_id).show();}$("#msgid"+msg_id).removeAttr("class");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'messages-site/mark-as',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({tobe_markedas:[msg_id],learner_id:learnerID,selected:'read',role:admin_role})}).then(function(response){return response.json();}).then(function(responseJson){// alert(JSON.stringisy(responseJson));
if(responseJson.status!=0){// this.props.getInbox();
//  setTimeout(() => {
// 	this.props.getNewPost();
//   }, 5000);
}});var msg_ids=[].concat(_toConsumableArray(this.state.msg_ids),[{msg_id:msg_id}]);this.setState({idd:edit_id,msg_ids:msg_ids});}},{key:'changeStatus',value:function changeStatus(e){var _this2=this;var selected=e.target.value;if(selected!=""){var values=this.state.checkedValues;if(values.length==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('','Please select the message(s) to mark as '+selected);}else{window.swal({//title: 'Mark As!',
text:'Are you sure, you want to '+selected+' the selected message(s)?',// type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'messages-site/mark-as',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({tobe_markedas:values,learner_id:learnerID,selected:selected})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringisy(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Success',responseJson.message,'success');$('.chkslct_inbox').prop('checked',false);$('#checkAll').removeAttr('checked');_this2.props.getInbox();//   setTimeout(() => {
// 	this.props.getNewPost();
//   }, 5000);
}});}});}}$('#inbox_cmbMark').val('');}},{key:'getCheck',value:function getCheck(){var checkedValues=$('.chkslct_inbox:checked').map(function(){return this.value;}).get();this.setState({checkedValues:checkedValues});}},{key:'onSort',value:function onSort(event,sortKey){// alert('im in');
var pageOfItems=this.state.pageOfItems;pageOfItems.sort(function(a,b){return a[sortKey].localeCompare(b[sortKey]);});this.setState({pageOfItems:pageOfItems});}},{key:'Reply',value:function Reply(msg_id,from,subject,content,alldata){// this.setState({
// 	reply_component : <Reply msgid={msg_id} to_address={from} to_subject={subject} to_content={content} to_datas={alldata}/>
// })
this.props.Replydata(msg_id,from,subject,content,alldata);}},{key:'selectAll',value:function selectAll(){if($('#checkAll').is(':checked')){$('.chkslct_inbox').prop('checked',true);}else{$('.chkslct_inbox').prop('checked',false);}var checkedValues=$('.chkslct_inbox:checked').map(function(){return this.value;}).get();this.setState({checkedValues:checkedValues});}},{key:'_handleKeyPress',value:function _handleKeyPress(e){if(e.key==="Enter"){this.getSearch('search');}}},{key:'getSearch',value:function getSearch(){// alert(this.state.searchtext);
var queryText=this.state.searchtext;var queryResult=[];this.state.datas.forEach(function(person){if(person.from_address.toString().toLowerCase().indexOf(queryText)!=-1){queryResult.push(person);}else if(person.subject.toString().toLowerCase().indexOf(queryText)!=-1){queryResult.push(person);}var total=queryResult.length;this.setState({inbox_mail:queryResult,count:total});}.bind(this));}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});$('#'+this.state.idd).hide();}},{key:'render',value:function render(){var _this3=this;if(this.state.pageOfItems===undefined){return null;}var rows=this.state.pageOfItems.map(function(mail,i){//alert(mail.from_address);
var msg_id=mail.msg_user_id_pk;var class_in="";if(mail.inbox==2){class_in="yellowbg yellowbg-txt";}else{class_in="";}var value=i+1;_this3.state.msg_ids.map(function(ids){// $('#msgid'+ids.msg_id).removeAttr('class');
if(msg_id==ids.msg_id){class_in='';}});//alert(value);
var edit='view_edit'+msg_id;var attach=mail.attached_files.map(function(att,k){var file_sent=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+att.fullpath;var new_file=new Buffer(file_sent).toString("base64");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'att_'+k,className:'msg-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/admin/'+new_file},att.filename));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'mailin_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'msgid'+msg_id,className:class_in},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:"chkInbox"+mail.msg_user_id_pk,id:"chkInbox"+mail.msg_user_id_pk,value:mail.msg_user_id_pk,className:'chkslct_inbox',onClick:function onClick(e){return _this3.getCheck(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:mail.attachment}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.viewItem(edit,msg_id);}},mail.from_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.viewItem(edit,msg_id);}},mail.subject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mail.created_date+' IST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'view_edit'+msg_id,style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5',className:'view-msg1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"view_send_item"+msg_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-deatil-cont ',id:'Detailview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-deatil-cont-head ',id:'viewline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.from_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.created_date+' IST')),mail.cc_address==''?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Cc'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.cc_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.subject)),!mail.attached_files.length?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Attachment'),attach)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-detail-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:mail.content}}),mail.completed_status==0&&mail.role!="SYS"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Reply',value:'Reply',onClick:function onClick(){return _this3.Reply(mail.message_id_pk,mail.reply_email,mail.reply_subject,mail.reply_content,mail.allDatas);}})):'')))))));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},'No Inbox Mails.'))):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Messages - Inbox'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-box1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'inbox_cmbMark',name:'cmbMark',className:'action_cmbbox',onChange:this.changeStatus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Actions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'read'},'Mark as Read'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'unread'},'Mark as Unread'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'archive'},'Mark as Archive'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchmsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'searchtext',value:this.state.searchtext,onChange:function onChange(e){return _this3.handleChange(e);},onKeyPress:function onKeyPress(e){return _this3._handleKeyPress(e);}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Search',title:'Search',onClick:function onClick(){return _this3.getSearch('search');}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.props.getInbox();},className:'button-cancel'},'Reset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-box2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,"Total "+this.state.count+" messages"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content table-cont6',style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'0',className:'myjourney-table message-table search-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'checkAll',onClick:function onClick(e){return _this3.selectAll(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'Attachment',src:"/rmeta"+"/images/attachment-white.png"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{onClick:function onClick(e){return _this3.onSort(e,'from_address');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mailsort',href:'javascript:void(0);'},'From \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0',align:'absmiddle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{onClick:function onClick(e){return _this3.onSort(e,'created_date');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mailsort',href:'javascript:void(0);'},'Received on \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0',align:'absmiddle'}))))),rows),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Pagination__["a" /* default */],{items:this.state.inbox_mail,onChangePage:function onChangePage(e){return _this3.onChangePage(e);}})))));}}]);return Inbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,ownProps){return{inbox_data:state.inbox};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({getInbox:__WEBPACK_IMPORTED_MODULE_7__actions_inboxAction__["a" /* getInbox */],getNewPost:__WEBPACK_IMPORTED_MODULE_6__actions_newPostAction__["a" /* getNewPost */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Inbox));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106).Buffer))

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reply__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Archieve__ = __webpack_require__(802);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Getarchive=function(_Component){_inherits(Getarchive,_Component);function Getarchive(props){_classCallCheck(this,Getarchive);var _this=_possibleConstructorReturn(this,(Getarchive.__proto__||Object.getPrototypeOf(Getarchive)).call(this,props));_this.state={archive_reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Archieve__["a" /* default */],{Replydatas:_this.getReplydatas.bind(_this)})};return _this;}_createClass(Getarchive,[{key:'getReplydatas',value:function getReplydatas(msg_id,from,subject,content,alldata){this.setState({archive_reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Reply__["a" /* default */],{msgid:msg_id,to_address:from,to_subject:subject,to_content:content,to_datas:alldata,Rerender:this.getRerender.bind(this)})});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({archive_reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Archieve__["a" /* default */],{Replydatas:this.getReplydatas.bind(this)})});}},{key:'getRerender',value:function getRerender(){this.setState({archive_reply_component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Archieve__["a" /* default */],{Replydatas:this.getReplydatas.bind(this)})});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.archive_reply_component);}}]);return Getarchive;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Getarchive);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Pagination__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_inboxAction__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Archieve=function(_Component){_inherits(Archieve,_Component);function Archieve(props){_classCallCheck(this,Archieve);var _this=_possibleConstructorReturn(this,(Archieve.__proto__||Object.getPrototypeOf(Archieve)).call(this,props));_this.state={archieve_mail:[],count:0,pageOfItems:[],idd:'',searchtext:'',datas:[],checkedValues:[],msg_ids:[]};_this.onChangePage=_this.onChangePage.bind(_this);_this.viewItem=_this.viewItem.bind(_this);_this.getCheck=_this.getCheck.bind(_this);_this.selectAll=_this.selectAll.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.getSearch=_this.getSearch.bind(_this);_this.Replydata=_this.Replydata.bind(_this);_this.onSort=_this.onSort.bind(_this);_this.changeStatus=_this.changeStatus.bind(_this);return _this;}_createClass(Archieve,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getArchieve();}},{key:'viewItem',value:function viewItem(edit_id,msg_id){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var old_id=this.state.idd;if(edit_id==old_id){// alert('same');
if($("#"+edit_id).css('display')=='none'){$("#"+edit_id).show();}else{$("#"+edit_id).hide();}}else{$("#"+old_id).hide();$("#"+edit_id).show();}$("#msgidsent"+msg_id).removeAttr("class");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'messages-site/mark-as',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({tobe_markedas:[msg_id],learner_id:learnerID,selected:'read'})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringisy(responseJson));
if(responseJson.status!=0){//this.getArchieve();
}});var msg_ids=[].concat(_toConsumableArray(this.state.msg_ids),[{msg_id:msg_id}]);this.setState({idd:edit_id,msg_ids:msg_ids});}},{key:'Replydata',value:function Replydata(msg_id,from,subject,content,alldata){this.props.Replydatas(msg_id,from,subject,content,alldata);}},{key:'onSort',value:function onSort(event,sortKey){// alert('im in');
var pageOfItems=this.state.pageOfItems;pageOfItems.sort(function(a,b){return a[sortKey].localeCompare(b[sortKey]);});this.setState({pageOfItems:pageOfItems});}},{key:'changeStatus',value:function changeStatus(e){var _this2=this;var selected=e.target.value;if(selected!=""){var values=this.state.checkedValues;if(values.length==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('','Please select the message(s) to mark as '+selected);}else{window.swal({//title: 'Mark As!',
text:'Are you sure, you want to '+selected+' the selected message(s)?',//type: 'question',
showCancelButton:true,confirmButtonColor:'#14a430',cancelButtonColor:'#0082c9',animation:false,confirmButtonText:'Ok'}).then(function(result){if(result){var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'messages-site/mark-as',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({tobe_markedas:values,learner_id:learnerID,selected:selected})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringisy(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]('Success',responseJson.message,'success');$('.chkslctt_inbox').prop('checked',false);_this2.getArchieve();_this2.props.getInbox();}});}});}}$('#archieve_cmbMark').val('');$('#checkAll_arch').removeAttr('checked');}},{key:'getCheck',value:function getCheck(){var checkedValues=$('.chkslctt_inbox:checked').map(function(){return this.value;}).get();this.setState({checkedValues:checkedValues});}},{key:'selectAll',value:function selectAll(){if($('#checkAll_arch').is(':checked')){$('.chkslctt_inbox').prop('checked',true);}else{$('.chkslctt_inbox').prop('checked',false);}var checkedValues=$('.chkslctt_inbox:checked').map(function(){return this.value;}).get();this.setState({checkedValues:checkedValues});}},{key:'_handleKeyPress',value:function _handleKeyPress(e){if(e.key==="Enter"){this.getSearch('search');}}},{key:'getSearch',value:function getSearch(){var queryText=this.state.searchtext;var queryResult=[];this.state.datas.forEach(function(person){if(person.from_address.toString().toLowerCase().indexOf(queryText)!=-1){queryResult.push(person);}else if(person.subject.toString().toLowerCase().indexOf(queryText)!=-1){queryResult.push(person);}var total=queryResult.length;this.setState({archieve_mail:queryResult,count:total});}.bind(this));}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'getArchieve',value:function getArchieve(){var _this3=this;var searchtext='';var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);// 	let corporateID = Common.getUserData("corporateID", true);
// let productID = Common.getUserData("productID", true);
var admin_role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'messages-site/get-archieve',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,admin_role:admin_role})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson.archieve_mail));
if(responseJson.status!=0){var total_message=responseJson.archieve_mail.length;_this3.setState({datas:responseJson.archieve_mail,archieve_mail:responseJson.archieve_mail,count:total_message,pageOfItems:responseJson.archieve_mail,searchtext:searchtext});}});}},{key:'componentDidMount',value:function componentDidMount(){var _this4=this;// alert('here');
//   	$('table.search-table').tableSearch({
// 	searchText:'Search',
// 	searchPlaceHolder:'Search Here'
// });
setTimeout(function(){_this4.getArchieve();},100);}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});$('#'+this.state.idd).hide();}},{key:'render',value:function render(){var _this5=this;//alert(JSON.stringify(this.state.checkedValues));
var rows=this.state.pageOfItems.map(function(mail,i){var msg_id=mail.msg_user_id_pk;var class_in="";if(mail.inbox==2){class_in="yellowbg yellowbg-txt";}else{class_in="";}var value=i+1;_this5.state.msg_ids.map(function(ids){// $('#msgid'+ids.msg_id).removeAttr('class');
if(msg_id==ids.msg_id){class_in='';}});var edit='view_edit_archieve'+msg_id;var attach=mail.attached_files.map(function(att,k){var file_sent=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+att.fullpath;var new_file=new Buffer(file_sent).toString("base64");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'att_'+k,className:'msg-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/admin/'+new_file},att.filename));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'mail_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'msgidsent'+msg_id,className:class_in},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:"chkInbox"+value,id:"chkInbox"+value,value:mail.msg_user_id_pk,className:'chkslctt_inbox',onClick:function onClick(e){return _this5.getCheck(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:mail.attachment}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this5.viewItem(edit,msg_id);}},mail.from_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this5.viewItem(edit,msg_id);}},mail.subject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mail.created_date+' IST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'view_edit_archieve'+msg_id,style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5',className:'view-msg1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"view_send_item"+msg_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-deatil-cont ',id:'Detailview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-deatil-cont-head ',id:'viewline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.from_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.created_date+' IST')),mail.cc_address==''?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Cc'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.cc_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.subject)),!mail.attached_files.length?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Attachment'),attach)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-detail-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:mail.content}}),mail.completed_status==0&&mail.role!="SYS"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',title:'Reply',value:'Reply',onClick:function onClick(){return _this5.Replydata(mail.message_id_pk,mail.reply_email,mail.reply_subject,mail.reply_content,mail.allDatas);}})):'')))))));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},'No Archieve Mails.'))):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Messages - Archieve'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-box1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'archieve_cmbMark',name:'cmbMark',className:'action_cmbbox',onChange:this.changeStatus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Actions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'inbox'},'Move to Inbox'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchmsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'searchtext',value:this.state.searchtext,onChange:function onChange(e){return _this5.handleChange(e);},onKeyPress:function onKeyPress(e){return _this5._handleKeyPress(e);}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Search',title:'Search',onClick:function onClick(){return _this5.getSearch('search');}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this5.getArchieve();},className:'button-cancel'},'Reset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-box2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,"Total "+this.state.count+" messages"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content table-cont6',style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'0',className:'myjourney-table message-table search-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'checkAll_arch',onClick:function onClick(e){return _this5.selectAll(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'Attachment',src:"/rmeta"+"/images/attachment-white.png"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{onClick:function onClick(e){return _this5.onSort(e,'from_address');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mailsort',href:'javascript:void(0);'},'From \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0',align:'absmiddle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{onClick:function onClick(e){return _this5.onSort(e,'created_date');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mailsort',href:'javascript:void(0);'},'Received on \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0',align:'absmiddle'}))))),rows),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Pagination__["a" /* default */],{items:this.state.archieve_mail,onChangePage:function onChangePage(e){return _this5.onChangePage(e);}})))));}}]);return Archieve;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({getInbox:__WEBPACK_IMPORTED_MODULE_6__actions_inboxAction__["a" /* getInbox */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Archieve));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106).Buffer))

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tinymce__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Contacts__ = __webpack_require__(804);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var jQuery=window.jQuery;var $=window.$;var Compose=function(_Component){_inherits(Compose,_Component);function Compose(props){_classCallCheck(this,Compose);var _this=_possibleConstructorReturn(this,(Compose.__proto__||Object.getPrototypeOf(Compose)).call(this,props));_this.state={contactForm:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Contacts__["a" /* default */],{sentData:_this.getData}),mailids:'',AllDatas:[],editorcontent:''};_this.slide=_this.slide.bind(_this);_this.getData=_this.getData.bind(_this);_this.Submit=_this.Submit.bind(_this);_this.handleEditorChange=_this.handleEditorChange.bind(_this);return _this;}_createClass(Compose,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'handleEditorChange',value:function handleEditorChange(e){this.setState({editorcontent:e.target.getContent()});}},{key:'slide',value:function slide(){$(".insert-mail").slideToggle();this.setState({contactForm:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Contacts__["a" /* default */],{sentData:this.getData})});}},{key:'Submit',value:function Submit(){var _this2=this;var formData=new FormData();var compose=$('form#compose_data').serializeArray();var role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);var details=[];formData.append("lr_id",__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true));formData.append("message",this.state.editorcontent);formData.append("lr_name",__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("fullName",true));formData.append("allData",this.state.AllDatas);compose.map(function(key,index){details.push(_defineProperty({},key.name,key.value));formData.append(key.name,key.value);});var val=0;$.each($('form#compose_data').find('input[type="file"]'),function(i,tag){$.each($(tag)[0].files,function(i,file){formData.append(tag.name+val,file);val++;});});formData.append("count",val);formData.append("admin_role",role);//console.log(details);
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"messages-site/compose",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");$('.MultiFile-remove').click();$('form#compose_data')[0].reset();_this2.setState({mailids:'',AllDatas:''});}});}},{key:'getData',value:function getData(mailid,AllDatas){this.setState({mailids:mailid,AllDatas:AllDatas});}},{key:'componentDidMount',value:function componentDidMount(){$("input[type=file].multi").MultiFile();}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Messages - Compose'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'compose',id:'compose_data',encType:'multipart/form-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-form-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'To :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divToaddress',className:'toaddress',style:{width:"574px"}},this.state.mailids),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'orange',onClick:function onClick(e){return _this3.slide(e);}},'Insert addresses'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-mail',style:{display:'none'}},this.state.contactForm)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Subject :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'subject',id:'txtSubject',className:'txtbox'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Message :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tinymce___default.a,{ref:'messgeseditor',config:{menubar:true,plugins:'autolink link image lists print preview',toolbar:'bold italic | alignleft aligncenter alignright',branding:false},onChange:this.handleEditorChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'div_writing_txtarea',className:'error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'last-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Attachment :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'attachment',name:'attachment',size:'80',className:'multi',accept:'xls|pdf|doc|ppt|pps|jpg|gif|txt',maxLength:'6'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-text'},'( Only XLS,Doc,PDF,PPT,PPS,JPG,GIF,TXT Format )')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnsend',value:'Send',alt:'Send',title:'Send',onClick:function onClick(e){return _this3.Submit(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'toaddress',id:'toaddress',value:this.state.mailids})))));}}]);return Compose;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Compose);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Contacts=function(_Component){_inherits(Contacts,_Component);function Contacts(props){_classCallCheck(this,Contacts);var _this=_possibleConstructorReturn(this,(Contacts.__proto__||Object.getPrototypeOf(Contacts)).call(this,props));_this.state={contacts:[],mails:[],checkedValues:[]};return _this;}_createClass(Contacts,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getToAddress();}},{key:'getCheck',value:function getCheck(){var checkedValues=$('.chk_slct:checked').map(function(){return this.value;}).get();var mailid=[];checkedValues.map(function(val,i){var get=val.split('*#');var admin_id=get[0];var name=get[1];var email=get[2];var role=get[3];mailid[i]=name+'('+email+')';});this.setState({mails:mailid,checkedValues:checkedValues});}},{key:'slideTog',value:function slideTog(){$(".insert-mail").slideToggle();}},{key:'showmail',value:function showmail(){$(".insert-mail").slideToggle();var joined=this.state.mails;var AllDatas=this.state.checkedValues;if(joined!=undefined){joined=joined.join(',');}this.props.sentData(joined,AllDatas);}},{key:'getToAddress',value:function getToAddress(){var _this2=this;var query_data=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["q" /* objToSlashString */]({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true),product_id:__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true),pin_id:__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('pinID',true),pin_no:__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]('pinNo',true)});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'message-contacts/view'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()}}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson));
if(responseJson.status==1){_this2.setState({contacts:responseJson.data});}//Common.reactLoader("hide");
});}},{key:'componentDidMount',value:function componentDidMount(){this.getToAddress();}},{key:'render',value:function render(){var _this3=this;//alert(JSON.stringify(this.state.mails))
//let contact = '';
var contact_add=null;if(this.state.contacts!=undefined){contact_add=this.state.contacts.map(function(lists,i){if(lists.contact!=undefined){var list=lists.contact.map(function(con,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:'li_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:"cn_"+k,id:"cn_"+k,value:con.id+'*#'+con.name+'*#'+con.email+'*#'+lists.role,className:'chk_slct',onClick:function onClick(e){return _this3.getCheck(e);}})),con.name));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'con_'+i,className:lists.class},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:lists.title}}),list?list:'No '+lists.notitle+' found');}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'contact_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Contacts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-mail-cont'},contact_add,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert-cont-lft insert-cont-lft-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'button-accept',type:'button',name:'btnInsert',id:'btnInsert',value:'Insert address',alt:'Insert address',title:'Insert address',onClick:function onClick(e){return _this3.showmail(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'button-cancel',type:'button',name:'btnInsert',id:'btnInsert',value:'Cancel',alt:'Cancel',title:'Cancel',onClick:function onClick(e){return _this3.slideTog(e);}}))));}}]);return Contacts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Contacts);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Pagination__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Sent=function(_Component){_inherits(Sent,_Component);function Sent(props){_classCallCheck(this,Sent);var _this=_possibleConstructorReturn(this,(Sent.__proto__||Object.getPrototypeOf(Sent)).call(this,props));_this.state={sent_mail:[],count:0,pageOfItems:[],idd:'',searchtext:'',datas:[]};_this.onChangePage=_this.onChangePage.bind(_this);_this.viewItem=_this.viewItem.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.getSearch=_this.getSearch.bind(_this);_this.onSort=_this.onSort.bind(_this);return _this;}_createClass(Sent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getSent();}},{key:'viewItem',value:function viewItem(edit_id){var old_id=this.state.idd;if(edit_id==old_id){// alert('same');
if($("#"+edit_id).css('display')=='none'){$("#"+edit_id).show();}else{$("#"+edit_id).hide();}this.setState({idd:edit_id});}else{$("#"+old_id).hide();$("#"+edit_id).show();this.setState({idd:edit_id});}}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'_handleKeyPress',value:function _handleKeyPress(e){if(e.key==="Enter"){this.getSearch('search');}}},{key:'getSearch',value:function getSearch(){var queryText=this.state.searchtext;var queryResult=[];this.state.datas.forEach(function(person){if(person.to_address.toString().toLowerCase().indexOf(queryText)!=-1){queryResult.push(person);}else if(person.subject.toString().toLowerCase().indexOf(queryText)!=-1){queryResult.push(person);}var total=queryResult.length;this.setState({sent_mail:queryResult,count:total});}.bind(this));}},{key:'onSort',value:function onSort(event,sortKey){// alert('im in');
var pageOfItems=this.state.pageOfItems;pageOfItems.sort(function(a,b){return a[sortKey].localeCompare(b[sortKey]);});this.setState({pageOfItems:pageOfItems});}},{key:'getSent',value:function getSent(){var _this2=this;var searchtext='';var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);// if(type == "search"){
// 	 searchtext = this.state.searchtext;
// }
// else if(type == "reset"){
// 	searchtext = '';
// }
// 	let corporateID = Common.getUserData("corporateID", true);
// let productID = Common.getUserData("productID", true);
var admin_role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'messages-site/get-sent',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,admin_role:admin_role})}).then(function(response){return response.json();}).then(function(responseJson){//alert(JSON.stringify(responseJson.sent_mail));
if(responseJson.status!=0){var total_message=responseJson.sent_mail.length;_this2.setState({datas:responseJson.sent_mail,sent_mail:responseJson.sent_mail,count:total_message,pageOfItems:responseJson.sent_mail,searchtext:searchtext});}});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;setTimeout(function(){_this3.getSent();},100);}},{key:'onChangePage',value:function onChangePage(pageOfItems){// update state with new page of items
this.setState({pageOfItems:pageOfItems});$('#'+this.state.idd).hide();}},{key:'render',value:function render(){var _this4=this;var rows=this.state.pageOfItems.map(function(mail,i){var msg_id=mail.msg_user_id_pk;var edit='view_edit_sent'+msg_id;var attach=mail.attached_files.map(function(att,k){var file_sent=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+att.fullpath;var new_file=new Buffer(file_sent).toString("base64");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'att_'+k,className:'msg-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/admin/'+new_file},att.filename));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:'mailsent_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'msgid'+msg_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:mail.attachment}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.viewItem(edit);}},mail.to_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.viewItem(edit);}},mail.subject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,mail.created_date+' IST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'view_edit_sent'+msg_id,style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'view-msg1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"view_send_item"+msg_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-deatil-cont ',id:'Detailview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-deatil-cont-head ',id:'viewline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.to_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.created_date+' IST')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.to_address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-cont'},mail.subject)),!mail.attached_files.length?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-label'},'Attachment'),attach)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg-detail-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:mail.content}}))))))));});rows.length==0?rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5'},'No Sent Mails.'))):rows=rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Messages - Sent'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'message-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchmsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'searchtext',value:this.state.searchtext,onChange:function onChange(e){return _this4.handleChange(e);},onKeyPress:function onKeyPress(e){return _this4._handleKeyPress(e);}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Search',title:'Search',onClick:function onClick(){return _this4.getSearch('search');}}),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this4.getSent();},className:'button-cancel'},'Reset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-box2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,"Total "+this.state.count+" messages"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content table-cont6',style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'0',className:'myjourney-table message-table search-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{title:'Attachment',src:"/rmeta"+"/images/attachment-white.png"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{onClick:function onClick(e){return _this4.onSort(e,'to_address');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mailsort',href:'javascript:void(0);'},'To \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0',align:'absmiddle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{onClick:function onClick(e){return _this4.onSort(e,'created_date');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'mailsort',href:'javascript:void(0);'},'Sent Date \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/sort-arrow.png",border:'0',align:'absmiddle'}))))),rows),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_Pagination__["a" /* default */],{items:this.state.sent_mail,onChangePage:function onChangePage(e){return _this4.onChangePage(e);}})))));}}]);return Sent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Sent);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(106).Buffer))

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookChat__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal_lib_react_responsive_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_big_calendar__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_big_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_big_calendar__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// a localizer for BigCalendar
__WEBPACK_IMPORTED_MODULE_7_react_big_calendar___default.a.momentLocalizer(__WEBPACK_IMPORTED_MODULE_6_moment___default.a);var $=window.$;var ChatBook=function(_Component){_inherits(ChatBook,_Component);function ChatBook(props){_classCallCheck(this,ChatBook);var _this=_possibleConstructorReturn(this,(ChatBook.__proto__||Object.getPrototypeOf(ChatBook)).call(this,props));_this.state={events:[],open:false,no_ecoach:'',chat_existance:'',no_ecoach_show:'block',show:'none',hide:'none'};_this.getPopup=_this.getPopup.bind(_this);_this.onCloseModal=_this.onCloseModal.bind(_this);return _this;}_createClass(ChatBook,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getEvents();}},{key:'getPopup',value:function getPopup(event){this.setState({open:true,BookComp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BookChat__["a" /* default */],{events:event,closeModal:this.onCloseModal})});}},{key:'onCloseModal',value:function onCloseModal(){this.setState({open:false});}},{key:'getEvents',value:function getEvents(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach-chat/get-events',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,pinid:pinid,pinno:pinno})}).then(function(response){return response.json();}).then(function(responseJson){// alert(JSON.stringify(responseJson));
__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!=0){if(responseJson.no_ecoach!=""){_this2.setState({no_ecoach_show:'block',show:'none',hide:'none'});}else if(responseJson.chat_existance){_this2.setState({no_ecoach_show:'none',show:'block',hide:'none'});}else{_this2.setState({no_ecoach_show:'none',show:'none',hide:'block',events:responseJson.events,no_ecoach:responseJson.no_ecoach,chat_existance:responseJson.chat_existance});}}});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}},{key:'componentDidMount',value:function componentDidMount(){this.getEvents();}},{key:'render',value:function render(){var _this3=this;var open=this.state.open;var monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];var d=new Date(),jDate=d.getDate(),jMonth=monthNames[d.getMonth()],jYear=d.getFullYear();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'light-graybox',style:{display:this.state.no_ecoach_show}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'No E Coach has been assigned to you. This feature will be active only if an E Coach is assigned.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'success-msg',style:{display:this.state.show}},'You may request for a chat after completing the current chat request.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat',style:{display:this.state.hide}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'telecal-reqcalendar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'recap-blue-title'},'E Coach\'s available slots for telecalls'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bluebgspan'}),' - Dates with this color background denotes availability of E Coach'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'center'}},jMonth+' '+jYear)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_big_calendar___default.a,{popup:true,selectable:true,style:{height:'520px',width:'100%'},views:['month'],defaultView:'month',toolbar:false,events:this.state.events,onSelectEvent:function onSelectEvent(event){return _this3.getPopup(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal___default.a,{open:open,onClose:this.onCloseModal},this.state.BookComp)));}}]);return ChatBook;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatBook);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var BookChat=function(_Component){_inherits(BookChat,_Component);function BookChat(props){_classCallCheck(this,BookChat);var _this=_possibleConstructorReturn(this,(BookChat.__proto__||Object.getPrototypeOf(BookChat)).call(this,props));_this.state={call_date:props.events.call_date,chat_time_id:props.events.chat_time_id_pk,id:props.events.id,start:props.events.start,end:props.events.end,title:props.events.title1,slots:props.events.slots,cur_time:props.events.curr_time,cur_date:props.events.curr_date,date_call:props.events.date_call,but_hide:'none',show:'block',hide:'none',preferred_time:'',old_img:'',preferred_id:''};_this.showTimeslots=_this.showTimeslots.bind(_this);_this.BookSlot=_this.BookSlot.bind(_this);_this.Slot=_this.Slot.bind(_this);return _this;}_createClass(BookChat,[{key:'showTimeslots',value:function showTimeslots(id){}},{key:'Slot',value:function Slot(time_chat_id){var _this2=this;// alert(time_chat_id);
var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach-chat/book-slot',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,pinid:pinid,pinno:pinno,chat_time_id:time_chat_id})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.props.closeModal();$("#sum").click();}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}});}},{key:'BookSlot',value:function BookSlot(time_id_chat,slot_time,id_img){var loc="/rmeta"+"images/chat.gif";var old_loc="/rmeta"+"images/chat_dull.gif";$('#'+id_img+' img').attr("src",loc);if(this.state.old_img!=''){$('#'+this.state.old_img+' img').attr("src",old_loc);}this.setState({but_hide:'block',show:'none',hide:'block',preferred_time:slot_time,old_img:id_img,preferred_id:time_id_chat});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'componentDidMount',value:function componentDidMount(){$(".accordion_coach").smk_Accordion();}},{key:'render',value:function render(){var _this3=this;var slot_times="";if(this.state.slots.length>0){var d=1;slot_times=this.state.slots.map(function(slot,i){var slots_seg='';if(slot.length>0){slots_seg=slot.map(function(sl,k){var id_img='img'+d;d++;var style='';var img='';var slot_time=sl.start_slot+' to '+sl.end_slot;if(sl.slot_time_from<_this3.state.cur_time&&_this3.state.date_call<=_this3.state.cur_date){img='';style='line-through';}else if(sl.telecall_booking_status==1||sl.chat_booking_status==1){img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/chat_dull_tick.gif",border:'0'});}else if(_this3.state.chat_time_id_pk==sl.chat_time_slot_id_pk){img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/chat.gif",border:'0'});}else{img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/chat_dull.gif",onClick:function onClick(){return _this3.BookSlot(sl.chat_time_slot_id_pk,slot_time,id_img);},border:'0'});}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'sl_'+k,className:'chat-img',id:id_img},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'15px'}},img)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'sltd_'+k,style:{textDecoration:style,fontSize:'14px'}},sl.start_slot+' - '+sl.end_slot)];});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'slots_'+i},slots_seg);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-ecoach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'colorstyle'},'Schedule a one-on-one chat with your E Coach')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'colorstyle'},'E Coach\'s available slots for chat on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{nohref:'true',name:'ptime'},this.state.call_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Preferred Time:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'before_booking',style:{display:this.state.show}},'Click on the slots to choose your convenient time to have chat with your E Coach.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'booked_time_div',style:{display:this.state.hide}},this.state.preferred_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'btndiv',className:'button-cancel',style:{display:this.state.but_hide}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'white',href:'javascript:void(0);',onClick:function onClick(){return _this3.Slot(_this3.state.preferred_id);}},'Book Slot'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'telecal-popup accordion_coach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tablescroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion_in acc_active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_head',onClick:this.showTimeslots(this.state.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_icon_expand'}),this.state.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'acc_content',style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{id:"trid_"+this.state.id,style:{display:'block',borderCollapse:'collapse',border:'1px solid rgb(231, 231, 231)',width:'100%',marginBottom:'10px'},cellSpacing:'1',cellPadding:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,slot_times)))))));}}]);return BookChat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BookChat);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var ChatSummary=function(_Component){_inherits(ChatSummary,_Component);function ChatSummary(props){_classCallCheck(this,ChatSummary);var _this=_possibleConstructorReturn(this,(ChatSummary.__proto__||Object.getPrototypeOf(ChatSummary)).call(this,props));_this.state={booked:[],books:[],call_avail:0,front:''};_this.getCalender=_this.getCalender.bind(_this);_this.setRate=_this.setRate.bind(_this);_this.chatLogs=_this.chatLogs.bind(_this);_this.getChat=_this.getChat.bind(_this);return _this;}_createClass(ChatSummary,[{key:'chatLogs',value:function chatLogs(slot_id,chatstart,chatends,date){var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var lr_name=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("fullName",true);var domain=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */];fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach-chat/generate-excel',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,time_slot_id:slot_id,lr_name:lr_name,chat_start:chatstart,chat_ends:chatends,slot_date:date,domain:domain})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var path=__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'download/admin/'+responseJson.data;window.open(path,'_blank');}});}},{key:'getChat',value:function getChat(ec_id,slot_id){// alert(this.props.location.pathname);
var path=this.state.front+'chat/'+ec_id+'/'+slot_id;// alert(path);
window.open(path,'_blank');}},{key:'setRate',value:function setRate(time_slot_id,date,time,id){var _this2=this;var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var lr_name=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("fullName",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var corp_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var role=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("role",true);var rating=$('#'+id).val();fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach-chat/rate-call',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,rating:rating,time_slot_id:time_slot_id,date:date,time:time,lr_name:lr_name,pinid:pinid,pinno:pinno,corp_id:corp_id,role:role})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.getList();}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getList();}},{key:'getCalender',value:function getCalender(call_id,tele_id){this.props.setCalender(call_id,tele_id);}},{key:'getList',value:function getList(){var _this3=this;//Common.reactLoader("show", "Please wait...");
var learner_id=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'ecoach-chat/booked-details',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learner_id,pinid:pinid,pinno:pinno})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){_this3.setState({booked:responseJson.booked,call_avail:responseJson.call_avail,front:responseJson.front_url});}});}},{key:'componentDidMount',value:function componentDidMount(){this.getList();}},{key:'render',value:function render(){var _this4=this;var booked=this.state.booked.map(function(called,k){var id="cmbRating"+k;var rat_div='';var chat_button='';var chat_log='';if(called.completed_state==1){if(called.rating==0||called.rating==null){rat_div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orng-box'},'Please rate the E Coach on this telecall from 1 to 10, where ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1 means "I am not satisfied at all"'),' and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10 means "I am extremely happy with it"'),'.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rating'},'I rate this call as',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:"cmbRating"+k,id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Select ---'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',name:'btnRate',value:'Rate',onClick:function onClick(){return _this4.setRate(called.time_slot_id,called.date,called.time,id);}})));}else{rat_div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'blue-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'I rate this call as  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-txt'},called.rating+'/10'));}}if(called.completed_state==1){chat_log=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button-accept',title:'View chat log',href:'javascript:void(0)',onClick:function onClick(){return _this4.chatLogs(called.time_slot_id,called.chatstart,called.chatend,called.date);}},'View chat log');}if(called.chat_button=='true'){chat_button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',style:{padding:'7px 25px'},className:'button-blue',onClick:function onClick(){return _this4.getChat(called.sent_ec,called.sent_slot_id);},alt:'Chat with E-Coach',title:'Chat with E-Coach'},'Chat with E-Coach');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'light-graybox',key:'called_'+k},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date:'),called.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Time:'),called.time),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Request Status:'),called.status)),chat_button,rat_div,chat_log);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{top:"0px"},className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},this.state.call_avail==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'recap-blue-title'},'Chats booked by me'),booked):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'timebox light-graybox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please get back later to visit your Chat Summary after your Chat with your E-Coach')))))));}}]);return ChatSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatSummary);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Fields__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Collaborate=function(_Component){_inherits(Collaborate,_Component);function Collaborate(props){_classCallCheck(this,Collaborate);var _this=_possibleConstructorReturn(this,(Collaborate.__proto__||Object.getPrototypeOf(Collaborate)).call(this,props));_this.state={};_this.getLrinfo=_this.getLrinfo.bind(_this);return _this;}_createClass(Collaborate,[{key:'componentDidMount',value:function componentDidMount(){var text_max=500;$('#balancedwords').html(text_max+'  '+'characters left');$('#txtcontes').keyup(function(){var text_length=$('#txtcontes').val().length;var text_remaining=text_max-text_length;if(text_remaining<0){$('#txtcontes').val('');}$('#balancedwords').html(text_remaining+'  '+'characters left');});$('#collaborate-search').keyup(function(){var search_length=$('#collaborate-search').val().length;if(0<search_length){//$('#sugglist').css("display", "block");
$('#sugglist').fadeIn(500);}});$("#erasetxt").click(function(){$('#txtcontes').val('');//$('#balancedwords').hide();
$('#balancedwords').html(text_max+'  '+'characters left');});$("#drop-btn").click(function(){$('#txtcontes').val('');$('#max-char').html('500'+'  '+'characters left');});//Show Suggestion
$('#suggetion-input').focusin(function(){$('.collaborate-active-cnt').fadeOut(500);$('.suggestion-box').fadeIn(500);});$('#srh-btn').click(function(){$('.suggestion-box').fadeIn(500);});$('.clear-btn').click(function(){$('.suggestion-box').fadeOut(500);});$('.hun-btn').focusin(function(){$('.suggestion-box').fadeOut(500);$('.collaborate-active-cnt').fadeIn(500);});$('#hub-close').click(function(){$('.collaborate-active-cnt').fadeOut(500);});$('#sug-close').click(function(){$('#sugglist').fadeOut(500);});//arechive tab
// $('.archives li').click(function(){
// 	$(this).find('.fa').toggleClass('fa-plus fa-minus');
// 	$(this).find('div').toggleClass('a-display');
// });
// $('.archives li').children('div').click(function(e){ e.stopPropagation();})
$(document).ready(function($){$('.collaborate-active-cnt').css('display','none');var curr_lr="1328";$("#"+curr_lr).addClass('active-accordion');});$('.year li h4').click(function(){$(this).parent('li').siblings().removeClass('active');$(this).parent('li').siblings().find('.slide-cnt').slideUp();$(this).parent('li').toggleClass('active');$(this).parent('li').find('.slide-cnt').slideToggle();});if($(window).width()>767){$('#collaborate-ul .cnt').slimscroll({height:'250px',width:'110px'});}}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea radio-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-title collaborate-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Collaborate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Interact with your peers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaborate-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',id:'collaborate-search',className:'collaborate-search',placeholder:'Search...'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-search'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaborate-search-cnt',id:'sugglist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'suggestion-text'},'Search results for "testing", "digital marketing":'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'suggestion-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Question by Ramon Prakash on March 15, 2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'How can we ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'test'),' if ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'digital marketing'),' is effective?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Question by Sonia Popat on November 11, 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'Why is it that my ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'digital marketing'),' strategy works for some  products, but not so well for some other kind of products? ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Comment by Martina Baker on October 5, 2015'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'But my first ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'digital marketing'),'  attempt was a disaster. I got underconfident about my skill of understanding the digital sp. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'btn-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-clear',id:'sug-close',href:'javascript:void(0);'},'Clear')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activity-hub'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'hun-btn'},'Activity Hub'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2'),' new questions, ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'0'),' new comments')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaborate-active-cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'suggestion-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Question by Ramon Prakash, 07:06:22 hrs, Mar 15, 2018',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-new'},'New')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'How can we test if digital marketing is effective?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Question by Sonia Popat on November 11, 2017',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-new'},'New')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'Can anybody explain the meaning of "white labelling"? Some examples would be great.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Comment by Arya Chaturvedi, 22:00:06 hrs, Jan 25, 2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'Democracy is followed in India. It has many flaws, but it is the best available form of governance. It may be...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'que'},'Question by Gopinathan C P, 11:25:00 hrs, May 3, 2016'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ans'},'Look at this image. It shows data on the scores of a group of students in 5 tests.  How to calculate the mode and median?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'year',id:'collaborate-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-cnt',style:{display:'block',marginTop:"-16px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Dec'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Nov'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Oct'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Sept'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Aug'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jul'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jun'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'May'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Apr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Mar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Feb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jan')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Dec'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Nov'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Oct'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Sept'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Aug'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jul'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jun'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'May'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Apr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Mar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Feb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jan')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'2016'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Dec'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Nov'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Oct'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Sept'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Aug'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jul'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jun'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'May'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Apr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Mar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Feb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Jan')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-clear',id:'hub-close',href:'javascript:void(0);'},'Close'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'have-questions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Have a question?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emd'},'Embed a jpeg, mp4, mp3 file'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:'txtcontes','data-total-words':'500',defaultValue:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left',style:{marginleft:"-95px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words',id:'balancedwords',style:{float:'left',color:"#1aa747"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words',style:{visibility:'hidden'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn btn-loud',id:'erasetxt'},'Drop it'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn btn-ask'},'Ask now'))))))// <section id="contentsection" className="contentarea">
//   <div className="inner-title-bg journey-tit-bg">
//     <h1> <span> <img src={process.env.PUBLIC_URL+'/images/collb-img.jpg'} align="absmiddle" alt="Collaboration feature in i-meta" border="0" /> </span>Collaborate<br />
//       <span className="subtitle">Interact with your peers</span></h1>
//   </div>
//   <div className="my-collabrate">
// 				<section className="search">
// 					<div className="">
// 						<div className="input-container">
// 							<form action="" method="">
// 								<input type="text" name="search" id="suggetion-input" className="srh-txt" />
// 								<button type="button" name="src-btn" className="srh-btn" id="srh-btn"><i className="fa fa-search"></i></button>
// 							</form>
// 						</div>
// 						<div className="suggestion-box">
// 							<p className="result">Search results for “testing”, “digital marketing”:</p>
// 							<ul>
// 								<li><span className="qus">Question by Ramon Prakash on March 15, 2018</span> How can we <strong>test</strong>  if <strong>digital marketing</strong> is effective?</li>
// 								<li><span className="qus">Question by Sonia Popat on November 11, 2017</span> Why is it that my <strong>digital marketing</strong> strategy works for some<br/> products, but not so well for some other kind of products? </li>
// 								<li><span className="qus">Comment by Martina Baker on October 5, 2015</span> ...but my <strong>first digital marketing </strong>attempt was a disaster. I got <br/>underconfident about my skill of understanding the digital sp...</li>
// 							</ul>
// 							<button className="clear-btn"> Clear</button>
// 							<div className="clear"></div>
// 						</div>
// 						<div className="comment-area">
// 							<a href="javascript:void(0);" className="hun-btn">Activity Hub</a> <span className="overview"><span style={{color: "#0070c0"}}>2</span> new questions, <span style={{color: "#0070c0"}}>0</span> new comments</span>
// 							<div className="hub-container"> 
// 								<div className="left">
// 									<ul className="activity-detail">
// 										<li><span className="qus">Question by Ramon Prakash, 07:06:22 hrs, Mar 15, 2018 <sup>New</sup></span> How can we test if digital marketing is effective?</li>
// 										<li><span className="qus">Question by Ben Steven,18:15:06 hrs, Nov 11, 2017<sup>New</sup></span> Can anybody explain the meaning of “white labelling”? <br />Some examples would be great. </li>
// 										<li><span className="qus">Comment by Arya Chaturvedi, 22:00:06 hrs, Jan 25, 2017</span> Democracy is followed in India. It has many flaws, but <br/>it is the best available form of governance. It may <br /> be…</li>
// 										<li><span className="qus">Question by Gopinathan C P, 11:25:00 hrs, May 3, 2016</span>Look at this image. It shows data on the scores of a <br />group of students in 5 tests. How to calculate the <br />mode and median?</li>
// 									</ul>
// 								</div>
// 								<div className="right">
// 									<ul className="archives">
// 										<li>2018
// 											<div className="a-display">
// 												<ul>
// 													<li><a href="javascript:void(0);">Apr</a></li>
// 													<li><a href="javascript:void(0);">Mar</a></li>
// 													<li><a href="javascript:void(0);">Feb</a></li>
// 													<li><a href="javascript:void(0);">Jan</a></li>
// 												</ul>
// 											</div>
// 											{/* <span className="ctrl"><i className="fa fa-minus"></i></span> */}
// 										</li>
// 										<li>2017
// 											<div>
// 												<ul>
// 													<li><a href="javascript:void(0);">Dec</a></li>
// 													<li><a href="javascript:void(0);">Nov</a></li>
// 													<li><a href="javascript:void(0);">Oct</a></li>
// 													<li><a href="javascript:void(0);">Sep</a></li>
// 													<li><a href="javascript:void(0);">Aug</a></li>
// 													<li><a href="javascript:void(0);">Jul</a></li>
// 													<li><a href="javascript:void(0);">Jun</a></li>
// 													<li><a href="javascript:void(0);">May</a></li>
// 													<li><a href="javascript:void(0);">Apr</a></li>
// 													<li><a href="javascript:void(0);">Mar</a></li>
// 													<li><a href="javascript:void(0);">Feb</a></li>
// 													<li><a href="javascript:void(0);">Jan</a></li>
// 												</ul>
// 											</div>
// 											{/* <span className="ctrl"><i className="fa fa-plus"></i></span> */}
// 										</li>
// 										<li>2016
// 											<div>
// 												<ul>
// 													<li><a href="javascript:void(0);">Dec</a></li>
// 													<li><a href="javascript:void(0);">Nov</a></li>
// 													<li><a href="javascript:void(0);">Oct</a></li>
// 													<li><a href="javascript:void(0);">Sep</a></li>
// 													<li><a href="javascript:void(0);">Aug</a></li>
// 												</ul>
// 											</div>
// 											{/* <span className="ctrl"><i className="fa fa-plus"></i></span> */}
// 										</li>
// 									</ul>
// 								</div>
// 								<div className="clear"></div>
// 								<button className="clear-btn" id="hub-close"> Close</button>
// 								<div className="clear"></div>
// 							</div>
// 							<div className="comment-box">
// 								<div className="left">Have a question?</div>
// 								<div className="right">Embed a jpeg, mp4, mp3 file</div>
// 								<div className="clear"></div>
// 								<form action="" method="">
// 									<textarea className="que-box" id="que-box" maxLength="500"  placeholder="Enter your Question"></textarea>
// 									<div className="max-char" id="max-char"></div>
// 									<div className="comment-action">
// 										<button type="button" className="drop" id="drop-btn">Drop it</button>
// 										<button type="button" className="ask-btn"> Ask now</button>
// 									</div>
// 								</form>
// 							</div>
// 						</div>
// 					</div>
// 				</section>						
// 				</div>         
// </section>
;}}]);return Collaborate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Collaborate);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;//const $=window.$;
// const win=window;
var Challenge=function(_Component){_inherits(Challenge,_Component);function Challenge(props){_classCallCheck(this,Challenge);var _this=_possibleConstructorReturn(this,(Challenge.__proto__||Object.getPrototypeOf(Challenge)).call(this,props));_this.state={historys:[],odd_arr:[],acc:[],rank:[]};_this.getLrinfo=_this.getLrinfo.bind(_this);return _this;}_createClass(Challenge,[{key:'hideShow',value:function hideShow(e){$('.silverheader').removeClass('selected');$('.'+e).addClass('selected');$('.submenu').css('display','none');$('#'+e).css('display','block');//normal-accordion
}},{key:'getChallenge',value:function getChallenge(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var specialExpiryDate=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("specialExpiryDate",true);__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'challenge-score/challenge',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,pinNo:pinNo,pinID:pinID,corporateID:corporateID,productID:productID})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var historys=responseJson.challenge_result.historys!=undefined?responseJson.challenge_result.historys:'';var acc=responseJson.challenge_result.acc!=undefined?responseJson.challenge_result.acc:'';var odd_arr=responseJson.challenge_result.odd_arr!=undefined?responseJson.challenge_result.odd_arr:'';var rank=responseJson.challenge_result.rank!=undefined?responseJson.challenge_result.rank:'';_this2.setState({challenge_result:responseJson.challenge_result,historys:historys,odd_arr:odd_arr,acc:acc,rank:rank});__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["g" /* downTabClose */]();}});}},{key:'componentDidMount',value:function componentDidMount(){this.getChallenge();}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){var _this3=this;var historys=null;if(this.state.historys!=null||this.state.historys!=undefined){historys=this.state.historys.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'lr-key'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['sno']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},'LR ',key['learning_room_cnt'],' Challenge ',key['sno']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},_this3.state.odd_arr[key['odd_id_fk']]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['invested_amount']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['status']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['money_in_hand']));});}var acc=null;if(this.state.acc!=null||this.state.acc!=undefined){acc=this.state.acc.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'acc-key'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['sno']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['challenged_date']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},'LR ',key['learning_room_cnt'],' Challenge ',_this3.state.odd_arr[key['odd_id_fk']]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['losing_amount']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['winning_amount']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['money_in_hand']));});}var rank=null;if(this.state.rank!=null||this.state.rank!=undefined){rank=this.state.rank.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'rank-key'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['firstname']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['money_in_hand']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},index+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},key['no_of_bets']));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'',className:'contentarea main-inner practicescore scoreround'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-lr1.png',align:'absmiddle',alt:'',border:'0'}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Challenge Score Card - Total Challenge report.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Go back',title:'Go back',style:{float:'right'},className:'button_org',onClick:function onClick(){return window.location.reload(true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applemenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader history'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',style:{backgroundColor:'#327277'},onClick:function onClick(e){return _this3.hideShow('history');},className:'guide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Challenge History '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'history',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartstatus',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'1',style:{borderCollapse:'collapse',border:'solid 1px #e5e5e5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{backgroundColor:'#000066',color:'#ffffff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'S.No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Challenges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Original Challenge'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Bet Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Challenge Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Amount Loss/Won')),historys!=''?historys:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6'},'No Records Found')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader account'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.hideShow('account');},style:{backgroundColor:'#327277'},className:'guide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Statement of Account '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'account',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartstatus',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'1',style:{borderCollapse:'collapse',border:'solid 1px #e5e5e5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{backgroundColor:'#000066',color:'#ffffff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'S.No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Narration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Debit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'credit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Balance')),acc!=''?acc:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6'},'No Records Found')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'silverheader ranking'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.hideShow('ranking');},style:{backgroundColor:'#327277'},className:'guide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Ranking '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu',id:'ranking',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'module-wise'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartstatus',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellSpacing:'0',cellPadding:'0',border:'1',style:{borderCollapse:'collapse',border:'solid 1px #e5e5e5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{style:{backgroundColor:'#000066',color:'#ffffff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Learner Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Money at Hand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Rank'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{align:'center'},'Number of Bets')),rank!=''?rank:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},'No Records Found'))))))))))))))));}}]);return Challenge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Challenge);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notepad_partials_Seeknotes__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notepad_partials_Sharenotes__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notepad_partials_Allnotes__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notepad_partials_ShareRequests__ = __webpack_require__(817);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var jQuery=window.jQuery;var Notes=function(_Component){_inherits(Notes,_Component);function Notes(props){_classCallCheck(this,Notes);var _this=_possibleConstructorReturn(this,(Notes.__proto__||Object.getPrototypeOf(Notes)).call(this,props));_this.state={buddies:[],allnotes:[],share_request:[],seeknotes:[],sharenotes:[]};return _this;}_createClass(Notes,[{key:'onchangedStatus',value:function onchangedStatus(status){if(status=='changed'){this.getNotesListInfo();}}},{key:'getNotesListInfo',value:function getNotesListInfo(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);var pinID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var productID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true);var pinNo=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var corporateID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'writing-pad/get-notes-list',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,pinID:pinID,productID:productID,pinNo:pinNo,corporateID:corporateID})}).then(function(response){return response.json();}).then(function(responseJson){var data=responseJson.data;if(responseJson.status==1){_this2.setState({buddies:data.buddies,allnotes:data.mynotes,seeknotes:data.seek_notes,sharenotes:data.share_notes,share_request:data.share_request});}});}},{key:'componentDidMount',value:function componentDidMount(){var type=this.props.type;var selector="#parentHorizontalTab";$('.modal-overlay').hide();$(selector).easyResponsiveTabs({type:'default',//Types: default, vertical, accordion
width:'auto',//auto or any width like 600px
fit:true,// 100% fit in a container
//closed: 'accordion', // Start closed if in accordion view
tabidentify:'hor_1',// The tab groups identifier
activate:function activate(event){// Callback function if tab is switched
// var $tab = $(this);
// var $info = $('#nested-tabInfo');
// var $name = $('span', $info);
// $name.text($tab.text());
// $info.show();
}});var activateTab=0;switch(type){case'seek_notes':activateTab=1;break;case'sharek_notes':activateTab=2;break;case'share_requests':activateTab=3;break;case'all_notes':activateTab=4;break;}setTimeout("$('"+selector+" ul.resp-tabs-list li:nth-child("+activateTab+")').trigger('click');",200);this.getNotesListInfo();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img-myobserver.jpg",align:'absmiddle',alt:'',border:'0'})),'Notes',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'Share & seek collection of notes prepared by you an your friends.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myperformance myobservers seeknotestab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'parentHorizontalTab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'resp-tabs-list hor_1 horizontaltabbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Seek Notes',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Share Notes',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Share Requests',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' All Notes',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'activearrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/activetab.png",border:'0'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resp-tabs-container hor_1 tapmargntop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__notepad_partials_Seeknotes__["a" /* default */],{data:this.state.seeknotes,changedStatus:this.onchangedStatus.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__notepad_partials_Sharenotes__["a" /* default */],{data:this.state.sharenotes,changedStatus:this.onchangedStatus.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__notepad_partials_ShareRequests__["a" /* default */],{shareData:this.state.share_request,changedStatus:this.onchangedStatus.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__notepad_partials_Allnotes__["a" /* default */],{data:this.state.allnotes,buddies:this.state.buddies}))))))))));}}]);return Notes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Notes);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Seeknotes=function(_Component){_inherits(Seeknotes,_Component);function Seeknotes(props){_classCallCheck(this,Seeknotes);return _possibleConstructorReturn(this,(Seeknotes.__proto__||Object.getPrototypeOf(Seeknotes)).call(this,props));}_createClass(Seeknotes,[{key:'fnIsSeeknotesSelected',value:function fnIsSeeknotesSelected(){var _this2=this;var chkLrID=$('input[type="checkbox"]:checked').length;if(chkLrID>0){$('#divSeeknotes').css('display','none');var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var ids=$('#seeknotes_form').serializeArray();__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'writing-pad/seeknotes-insert',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,ids:ids})}).then(function(response){return response.json();}).then(function(responseJson){_this2.props.changedStatus('changed');__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();});return true;}else{$('#divSeeknotes').css('display','block');return false;}}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this3=this;var nochk=0;var seek_notes_list='';if(this.props.data!=undefined||this.props.data!=null){seek_notes_list=this.props.data.map(function(key,index){{key.status==false?nochk=nochk+1:'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'main'+index,className:'seeknotes_list'},key.status!=false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'\xA0',key.learner_name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{align:'right',className:'date_red'},'Requesting status:',key.status)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'chkLrID[]',id:'chkLrID',value:key.learner_id_pk}),key.learner_name));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'seeknotes_form',id:'seeknotes_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'seeknotes_view'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'bluetxt seek-head'},'Buddies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divSeeknotes',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{color:'#FF0000'},'Please select the buddies')),seek_notes_list!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',seek_notes_list,nochk!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seek-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidnotes',id:'hidnotes',value:nochk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSave',value:'Seek',alt:'Seek',onClick:function onClick(e){return _this3.fnIsSeeknotesSelected();},title:'Seek'})))):''):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No buddies found'))));}}]);return Seeknotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Seeknotes);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Sharenotes=function(_Component){_inherits(Sharenotes,_Component);function Sharenotes(props){_classCallCheck(this,Sharenotes);return _possibleConstructorReturn(this,(Sharenotes.__proto__||Object.getPrototypeOf(Sharenotes)).call(this,props));}_createClass(Sharenotes,[{key:'fnIsSeeknotesSelected',value:function fnIsSeeknotesSelected(){var _this2=this;var chkLrID=$('input[type="checkbox"]:checked').length;if(chkLrID>0){$('#divSharenotes').css('display','none');var learnerID=__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["i" /* getUserData */]("id",true);var ids=$('#sharenotes_form').serializeArray();__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'writing-pad/sharenotes-insert',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learnerID:learnerID,ids:ids})}).then(function(response){return response.json();}).then(function(responseJson){_this2.props.changedStatus('changed');__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */]("hide");__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["g" /* downTabClose */]();});return true;}else{$('#divSharenotes').css('display','block');return false;}}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this3=this;var nochk=0;var share_notes_list='';if(this.props.data!=undefined||this.props.data!=null){share_notes_list=this.props.data.map(function(key,index){{key.status==false?nochk=nochk+1:'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'main'+index,className:'seeknotes_list'},key.status!=false?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'chkLrID[]',id:'chkLrID',value:key.learner_id_pk}),key.learner_name),key.status==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'( Notes already shared )'):'',key.status==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'( Notes share request awaiting)'):'');});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabgrey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'sharenotes_form',id:'sharenotes_form',method:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'sharenotes_view'},share_notes_list!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation'},' Choose any buddy to share your notes with and click on "Share" button. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'bluetxt seek-head'},'Buddies ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/buddychat',target:'_blank',className:'mang-buddy',title:'Manage Buddies'},'Manage Buddies')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divSharenotes',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{color:'#FF0000'},'Please select')),share_notes_list,nochk!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seek-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidnotes',id:'hidnotes',value:nochk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSave',value:'Share',alt:'Share',onClick:function onClick(e){return _this3.fnIsSeeknotesSelected();},title:'Share'})))):''):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Either you have shared notes with all your buddies or there are no buddies for you. Please click on "Manage Buddies" to add new buddies. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#/buddychat',target:'_blank',style:{float:'right'},title:'Manage Buddies',className:'button-accept'},'Manage Buddies')))));}}]);return Sharenotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Sharenotes);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotepadPopup__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Buddiesnotes__ = __webpack_require__(816);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var jQuery=window.jQuery;var Allnotes=function(_Component){_inherits(Allnotes,_Component);function Allnotes(props){_classCallCheck(this,Allnotes);var _this=_possibleConstructorReturn(this,(Allnotes.__proto__||Object.getPrototypeOf(Allnotes)).call(this,props));_this.state={popupBlock:null};return _this;}_createClass(Allnotes,[{key:"time",value:function time(){return Math.floor(new Date().getTime()/1000);}},{key:"showData",value:function showData(index,data,room_name,name,learner){this.setState({popupBlock:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NotepadPopup__["a" /* default */],{key:"notes_"+index,data:data,room_name:room_name,name:name,learner:learner})});}},{key:"openlrBlock",value:function openlrBlock(index){var block=$("div[id^=tr_lr_dlr_]");$(block).each(function(){$(this).hide();});$("#tr_lr_dlr_"+index).show();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,data=_props.data,buddies=_props.buddies;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tabgrey"},this.state.popupBlock,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"sharedlr_view"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"bluetxt seek-head"},"My Notes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,data.lr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object.keys(data.lr_mynotes).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buddies-lr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"roomtit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"LR's")),data.lr_mynotes.map(function(val,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"roomno"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"lr_linkd",onClick:function onClick(e){return _this2.showData(_this2.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name);},href:"javascript:void(0);"},val.name));}))),data.dLr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object.keys(data.dLr_mynotes).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buddies-lr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"roomtit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DLR's")),data.dLr_mynotes.map(function(val,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"roomno"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"dlr_linkd",onClick:function onClick(e){return _this2.showData(_this2.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name);},href:"javascript:void(0);"},val.name));}))),data.dLr_mynotes!=undefined&&data.lr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object.keys(data.dLr_mynotes).length>0&&Object.keys(data.lr_mynotes).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{align:"center"},"No notes found.")),buddies!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buddies-lr1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"bluetxt seek-head"},"Buddies"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"divSharedlr"}),Object.keys(buddies).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,buddies.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"buddieslist"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void(0);",onClick:function onClick(e){return _this2.openlrBlock(index);},className:"title_orange"},key.learner_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"tr_lr_dlr_"+index,style:{display:"none"}},key.lr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,key.lr_mynotes!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buddies-lr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"roomtit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"LR's")),key.lr_mynotes.map(function(val,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"roomno"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"lr_linkd",onClick:function onClick(e){return _this2.showData(_this2.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name);},href:"javascript:void(0);"},val.name));}))),key.dLr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,key.dLr_mynotes!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buddies-lr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"roomtit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"DLR's")),key.dLr_mynotes.map(function(val,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"roomno"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"dlr_linkd",onClick:function onClick(e){return _this2.showData(_this2.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name);},href:"javascript:void(0);"},val.name));}))),key.dLr_mynotes!=undefined&&key.lr_mynotes!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,key.dLr_mynotes==null&&key.lr_mynotes==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{align:"center"},"No notes found."))));}))))));}}]);return Allnotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Allnotes);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_collapsible__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_collapsible__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var win=window;var jQuery=window.jQuery;var NotepadPopup=function(_Component){_inherits(NotepadPopup,_Component);function NotepadPopup(props){_classCallCheck(this,NotepadPopup);var _this=_possibleConstructorReturn(this,(NotepadPopup.__proto__||Object.getPrototypeOf(NotepadPopup)).call(this,props));_this.selector="notespopup";_this.state={room_name:"",name:"",learner:[],notes:[]};return _this;}_createClass(NotepadPopup,[{key:'popup_close',value:function popup_close(){jQuery('.sa-icon').css("display","none");jQuery('#'+this.selector).css("display","none");jQuery('.modal-overlay').css("display","none");}},{key:'minimize',value:function minimize(){jQuery('#'+this.selector).css({height:'30px',width:'300px',overflow:'hidden',transform:'rotate(360deg)','-webkit-transform':'rotate(360deg)','-moz-transform':'rotate(360deg)','-o-transform':'rotate(360deg)',position:'fixed',transition:' all ease .4s','-webkit-transition':'all ease .4s','-moz-transition':'all ease .4s','-o-transition':'all ease .4s'});}},{key:'maximize',value:function maximize(){jQuery('#'+this.selector).css({top:'20px',display:'block',left:'25%',height:'auto',width:'56%',overflow:'unset',transform:'unset','-webkit-transform':'unset','-moz-transform':'unset','-o-transform':'unset',position:'absolute'});// jQuery('#notespopup').show();
}},{key:'openPopup',value:function openPopup(data,room_name,name,learner){var self=this;}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,data=_props.data,room_name=_props.room_name,name=_props.name,learner=_props.learner;var appendthis="<div class='modal-overlay js-modal-close'></div>";jQuery("body").append(appendthis);jQuery(".modal-overlay").fadeTo(500,0.7);//$(".js-modalbox").fadeIn(500);
var modalBox=jQuery('#'+this.selector).attr('data-modal-id');jQuery('#'+this.selector).fadeIn(jQuery('#'+this.selector).data());jQuery(".js-modal-close, .modal-overlay").click(function(){jQuery(".modal-box, .modal-overlay").fadeOut(500,function(){jQuery(".modal-overlay").remove();});});jQuery(window).resize(function(){jQuery(".modal-box").css({top:20,//(jQuery(window).height() - jQuery(".modal-box").outerHeight()) / 2,
left:(jQuery(window).width()-jQuery(".modal-box").outerWidth())/2});});jQuery(window).resize();setTimeout(function(){_this2.setState({room_name:room_name,name:name,learner:learner,notes:data});},150);}},{key:'render',value:function render(){var _this3=this;var learner=this.state.learner;var notesdata=this.state.notes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:this.selector,style:{top:'20px',left:'297px',display:'none'},className:'modal-box popup-ecoach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.popup_close();},title:'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/cloze.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.minimize();},title:'Minimize',className:'',style:{marginRight:"35px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/min.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this3.maximize();},title:'Maximize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/max.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'write-pad-tiltle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/wiriting-pad-icon.png',border:'0'}),' All Notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body popup-grey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'writing-pad-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'writing-pad-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pad-left',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'cat_head_rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'learning_room_title'},learner)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'cat_head_rgt',style:{fontSize:'12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'learning_room_title'},this.state.room_name)),notesdata!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},notesdata!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,notesdata.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_collapsible___default.a,{key:'notes_'+i,trigger:key.notes_title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:key.notes}}),' '));}))))))));}}]);return NotepadPopup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NotepadPopup);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Buddiesnotes=function(_Component){_inherits(Buddiesnotes,_Component);function Buddiesnotes(props){_classCallCheck(this,Buddiesnotes);return _possibleConstructorReturn(this,(Buddiesnotes.__proto__||Object.getPrototypeOf(Buddiesnotes)).call(this,props));}_createClass(Buddiesnotes,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buddies-lr1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"bluetxt seek-head"},"Buddies"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"divSharedlr"}));}}]);return Buddiesnotes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Buddiesnotes);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShareRequests=function(_Component){_inherits(ShareRequests,_Component);function ShareRequests(props){_classCallCheck(this,ShareRequests);var _this=_possibleConstructorReturn(this,(ShareRequests.__proto__||Object.getPrototypeOf(ShareRequests)).call(this,props));_this.state={share_data:props.shareData};_this.ChangeStatus=_this.ChangeStatus.bind(_this);return _this;}_createClass(ShareRequests,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'ChangeStatus',value:function ChangeStatus(status,note_id){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'writing-pad/change-status',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:learnerID,status:status,note_id:note_id})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,'','success');_this2.props.changedStatus('changed');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,'','error');}});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.shareData!=undefined){this.setState({share_data:nextProps.shareData});}}},{key:'render',value:function render(){var _this3=this;var share=[];if(this.state.share_data!=undefined||this.state.share_data!=null){share=this.state.share_data.map(function(sha,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'share_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,sha.learner_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,sha.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'Approve',onClick:function onClick(){return _this3.ChangeStatus(1,sha.share_notes_id);},value:'Approve',alt:'Approve',title:'Approve',style:{float:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'Reject',onClick:function onClick(){return _this3.ChangeStatus(2,sha.share_notes_id);},value:'Reject',alt:'Reject',title:'Reject',className:'button-cancel',style:{float:'none'}})));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'sharedlr_view',className:'table-cont71'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%',className:'myjourney-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Share request from'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Change Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!share.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4'},'No datas found.')):share)));}}]);return ShareRequests;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ShareRequests);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EcProfile=function(_Component){_inherits(EcProfile,_Component);function EcProfile(props){_classCallCheck(this,EcProfile);var _this=_possibleConstructorReturn(this,(EcProfile.__proto__||Object.getPrototypeOf(EcProfile)).call(this,props));_this.state={profile:[]};return _this;}_createClass(EcProfile,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(next){}},{key:'getProfile',value:function getProfile(){var _this2=this;var pinno=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinNo",true);var pinid=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true);var corp=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("corporateID",true);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"ecoach/ecoach-profile",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({pinno:pinno,pinid:pinid,corp_id:corp})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status===0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this2.setState({profile:responseJson.ecoach});}});}},{key:'componentDidMount',value:function componentDidMount(){this.getProfile();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-title-bg journey-tit-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/login_history_img.png",alt:'',border:'0',align:'absmiddle'})),'My E Coach',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtitle'},'My E Coach profile'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scroll1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{lass:'contentbg',style:{clear:'both',paddingBottom:'50px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'thisForm',id:'thisForm'},!this.state.profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ans-explanation',style:{textAlign:'center'}},'No E Coach assigned yet '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ec-profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ec-profile-lft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"/admin/master_ecoach_photo/"+this.state.profile.photo,className:'border',border:'0',width:'150',alt:'Profile Image'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ec-profile-rgt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',id:'Detailview',cellPadding:'5',cellSpacing:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_left',width:'120'},'First Name ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'colon'},':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_right'},this.state.profile.firstname==null?'-':this.state.profile.firstname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_left'},'Last Name ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'colon'},':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_right'},this.state.profile.lastname==null?'-':this.state.profile.lastname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_left'},'Gender ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'colon'},':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_right'},this.state.profile.gender==1?'Male':'Female')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_left'},'Qualification ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'colon'},':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_right'},this.state.profile.qualification==null?'-':this.state.profile.qualification)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_left'},'E-Mail ID ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'colon'},':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'email'},this.state.profile.email))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_left'},'Mobile Number ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'colon'},':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'eprofile_right'},this.state.profile.mobile==null?'-':this.state.profile.mobile))))))))))))))));}}]);return EcProfile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EcProfile);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Radio=function(_Component){_inherits(Radio,_Component);function Radio(props){_classCallCheck(this,Radio);var _this=_possibleConstructorReturn(this,(Radio.__proto__||Object.getPrototypeOf(Radio)).call(this,props));_this.state={};_this.getLrinfo=_this.getLrinfo.bind(_this);return _this;}_createClass(Radio,[{key:'componentDidMount',value:function componentDidMount(){/*
		var text_max = 500;
		$('#max-char').html(text_max +'  '+'characters left');
		
		$('#que-box').keyup(function() {
			var text_length = $('#que-box').val().length;
			var text_remaining = text_max - text_length;
			if(text_remaining < 0)
			{
				$('#que-box').val('');
			}	
			$('#max-char').html(text_remaining+'  '+'characters left');
			
		});

		$("#drop-btn").click(function(){
			$('#que-box').val('');
			$('#max-char').html('500' +'  '+'characters left');
		});
		//Show Suggestion
		$('#suggetion-input').focusin(function(){
			$('.hub-container').fadeOut(500);
			$('.suggestion-box').fadeIn(500);
		});
		$('#srh-btn').click(function(){
			$('.suggestion-box').fadeIn(500);
		});
		$('.clear-btn').click(function(){
			$('.suggestion-box').fadeOut(500);
		});
		
		$('.hun-btn').focusin(function(){	
			$('.suggestion-box').fadeOut(500);
			$('.hub-container').fadeIn(500);
		});
		$('#hub-close').click(function(){
			$('.hub-container').fadeOut(500);
		});
		
		//arechive tab

		$('.archives li').click(function(){
			$(this).find('.fa').toggleClass('fa-plus fa-minus');
			$(this).find('div').toggleClass('a-display');
		});

		$('.archives li').children('div').click(function(e){ e.stopPropagation();})
		*/}},{key:'getLrinfo',value:function getLrinfo(type,lr_id,dlr_id){this.props.switchPanel(type,lr_id,dlr_id);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Radio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Clarify your doubts privately')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'big-textarea'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn btn-ask'},'Ask'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn btn-loud'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'chat-babbles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imgHead'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Hello Radio! Can I ask you a question about an orthodox system of accounting?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'radio-ai'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imgHead'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sure, I will try my best to answer.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imgHead'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'What are the advantages of double accounting system? Do we follow this system in India?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'radio-ai'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imgHead'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Double accounting system has several advantages, even though it is a bit tedious to keep. One, it eliminates errors. Two, it creates multiple accounts by default. Three, it makes sure that the different account heads are created in the system.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For more reading, visit: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.cai.com/accountingsystems',target:'_blank'},'www.cai.com/accountingsystems')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Is there anything else I can help you with?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imgHead'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nothing else. Thank you, Radio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'radio-ai'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imgHead'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please rate my answers; it will help me improve. Thank you')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-rating-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/radio/radio-no-rating.png',alt:'ratings'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/radio/radio-no-rating.png',alt:'ratings'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/radio/radio-no-rating.png',alt:'ratings'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/radio/radio-no-rating.png',alt:'ratings'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/radio/radio-no-rating.png',alt:'ratings'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-btn-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn btn-save'},'Save this interaction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',className:'btn btn-bye'},' Bye, Radio!'))));}}]);return Radio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pdfview__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_collapse__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Ctestonebyone__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Cnormaltest__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cfixedtimetest__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ctimevariabletest__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Ctestresults__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Cvideocomponent__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Careerlaunchertrial__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Canouncement__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Cfeedbackform__ = __webpack_require__(351);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Collapsible from 'react-collapsible';
var $=window.$;var jQuery=window.jQuery;var Careerlauncherrc=function(_Component){_inherits(Careerlauncherrc,_Component);function Careerlauncherrc(props){_classCallCheck(this,Careerlauncherrc);var _this=_possibleConstructorReturn(this,(Careerlauncherrc.__proto__||Object.getPrototypeOf(Careerlauncherrc)).call(this,props));_this.state={product_id:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('productID',true),clist:[],accordinglists:[],completedcomp:[],total_score:'',total_out_of_score:'',componentview:false,component:'',sqe_id:'',compo_type:'',current_component:"0",sub_cur_component:"0"};_this.compolist=_this.compolist.bind(_this);return _this;}_createClass(Careerlauncherrc,[{key:'getCllist',value:function getCllist(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'careerlancher/getcllist',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),product_id:this.state.product_id})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({clist:responseJson.result,accordinglists:responseJson.result.accordinglists,completedcomp:responseJson.competedcomp,total_out_of_score:responseJson.total_out_of_score,total_score:responseJson.total_score});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},1000);});}},{key:'componentDidMount',value:function componentDidMount(){this.getCllist();}},{key:'trd4',value:function trd4(component_list){var _this3=this;var trd4=component_list.map(function(k2,v2){var is_completed=$.inArray(k2,_this3.state.completedcomp)>=0;var sp=k2.split("_");var imageico='spdf.png';var comtitle='Faculty Session VC';if(sp.length>0){if(sp[0]=='vc'){imageico=is_completed>0?'cvls.png':'vlsc.png';comtitle='Faculty session';}if(sp[0]=='mcq'){imageico=is_completed>0?'ctesticon.png':'testiconc.png';comtitle='Assessment';}if(sp[0]=='an'){imageico=is_completed>0?'cannouncement.png':'announcementc.png';comtitle='Information';}if(sp[0]=='fb'){imageico=is_completed>0?'cfeedback.png':'feedbackc.png';comtitle='Feedback';}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:k2,href:'javascript:void(0);',style:{textDecoration:'none',border:'0px'},title:comtitle,onClick:function onClick(e){return _this3.opencomponents(k2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/'+imageico,title:comtitle,alt_text:comtitle}));});return trd4;}},{key:'trd3',value:function trd3(components){var _this4=this;var trd3=components.map(function(k1,v1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"sub"+v1,className:"new-icon ks"+v1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'h last-child'},k1.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icons-set'},_this4.trd4(k1.component_list)));});return trd3;}},{key:'trd2',value:function trd2(sub_title,components){var _this5=this;var trd2=sub_title.map(function(k,v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["b" /* default */],{key:"sub"+v,accordion:true,defaultActiveKey:'subt_'+_this5.state.sub_cur_component,onChange:function onChange(e){return _this5.setsubActivityKey(v);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["a" /* Panel */],{header:k,key:'subt_'+v,onChange:function onChange(e){return _this5.setsubActivityKey(v);}},components.component_list==undefined&&components[v]!=undefined&&_this5.trd3(components[v]),components.component_list!=undefined&&_this5.trd4(components.component_list)));});return trd2;}},{key:'compolist',value:function compolist(cdata){if(cdata.compo_type=='testonebyone'){var compodet=this.getcompoformat('complete',cdata.compseq_id,cdata.id,cdata.compotype);this.setState({componentview:true,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Ctestresults__["a" /* default */],{data:compodet,switchback:this.compolist})});}else{this.state.completedcomp.push(cdata.id);this.setState({componentview:false,component:""});//window.reload();
this.getCllist();}}},{key:'opencomponents',value:function opencomponents(component){var _this6=this;this.setState({current_component:2});var s=component.split('.');if(s[1]!=undefined&&s[1].toLowerCase()=='pdf'){this.setState({componentview:true,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Pdfview__["a" /* default */],{key:'pdf_view_0',pdfpath:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"imeta/"+component,title:'Read Me - All about this session'})});}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var ssd=component.split('_');fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'careerlancher/getcomponent',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),product_id:this.state.product_id,learning_room:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('defaultLRID',true),component:component})}).then(function(response){return response.json();}).then(function(responseJson){_this6.setState({componentview:true,component:_this6.getcompodetails(ssd,responseJson.result)});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},2000);});}}},{key:'getcompoformat',value:function getcompoformat(status,compseq_id,id,compotype){var data={"status":status,"learning_room_id":__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('defaultLRID',true),"compseq_id":compseq_id,"divider_id":"1","dlr_id":0,"learner_id":__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),"is_repeat":"N","look_before":"N","divider_status":1,"is_ag":"","id":id,"name":"","icon":"","alt_text":"","base_line":"","spanclass":"an_active_button","compo_type":compotype,"Isvisible":1,"current_component":this.state.current_component,"sub_current_component":this.state.current_component};return data;}},{key:'getcompodetails',value:function getcompodetails(ssd,responseJson){var compodet='';var opcompo='';var compotype=responseJson.compo_type;if(ssd[0]=='mcq'){compotype=responseJson.status==''?responseJson.compo_type:'testresult';compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],compotype);if(responseJson.status=='completed'){opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Ctestresults__["a" /* default */],{data:compodet,switchback:this.compolist});}else if(compotype=='testonebyone'){opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Ctestonebyone__["a" /* default */],{data:compodet,switchback:this.compolist});}else if(compotype=='normaltest'){opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Cnormaltest__["a" /* default */],{data:compodet,switchback:this.compolist});}}if(ssd[0]=='vc'){compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"videocomponent");opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Cvideocomponent__["a" /* default */],{data:compodet,switchback:this.compolist});}if(ssd[0]=='an'){compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"anouncement");opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Canouncement__["a" /* default */],{data:compodet,switchback:this.compolist});}if(ssd[0]=='fb'){compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"feedbackform");opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Cfeedbackform__["a" /* default */],{data:compodet,switchback:this.compolist});}return opcompo;}},{key:'goback',value:function goback(k){var _this7=this;this.setState({componentview:false,component:''});setTimeout(function(){_this7.setState({current_component:k});},1000);}},{key:'setActivityKey',value:function setActivityKey(k){this.setState({current_component:k});}},{key:'setsubActivityKey',value:function setsubActivityKey(k){this.setState({sub_cur_component:k});}//{"status":"completed","learning_room_id":"2694","compseq_id":"19006","divider_id":"1","dlr_id":0,"learner_id":"101032","is_repeat":"N","look_before":"N","divider_status":1,"is_ag":"","id":"687","name":"dsf","icon":"dsf","alt_text":"dasfdasf","base_line":"dasf","spanclass":"an_active_button","compo_type":"thanks","Isvisible":1}
},{key:'render',value:function render(){var _this8=this;var clistsd=this.state.clist;var accordinglist=this.state.accordinglists;var trd1=accordinglist.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["b" /* default */],{key:"mn"+index,accordion:true,defaultActiveKey:'cus_'+_this8.state.current_component,onChange:function onChange(e){return _this8.setActivityKey(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["a" /* Panel */],{header:key.main_title,key:'cus_'+index,onChange:function onChange(e){return _this8.setActivityKey(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'outer',onClick:function onClick(e){return _this8.setActivityKey(index);}},key.sub_title.length>0&&_this8.trd2(key.sub_title,key.components),key.sub_title.length==0&&_this8.trd3(key.components))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'content',className:'content2'},this.state.clist.is_have_trail!=undefined&&this.state.clist.is_have_trail=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Careerlaunchertrial__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'or1',id:'container2',className:'container2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'accrodion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,clistsd.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'smart-link'},clistsd.introduction_vc!=''&&clistsd.introduction_vc!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:clistsd.introduction_vc,onClick:function onClick(e){return _this8.opencomponents(clistsd.introduction_vc);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/video.png',alt:clistsd.introduction_vc,align:'absmiddle'}),'\xA0\xA0',clistsd.introduction_vc_title)),clistsd.introductoin_pdf!=''&&clistsd.introductoin_pdf!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:clistsd.introductoin_pdf,onClick:function onClick(e){return _this8.opencomponents(clistsd.introductoin_pdf);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/spdf.png',alt:clistsd.introductoin_pdf,align:'absmiddle'}),'\xA0\xA0',clistsd.introductoin_pdf_title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completedcomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/smctick.png'}),' \xA0Completed',this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0 | \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.goback(_this8.state.current_component);}},'Click here to Go Back'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),this.state.total_score>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'perform-score'},'Performance score: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'-'),' (',this.state.total_score+'/'+this.state.total_out_of_score,')'),!this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion',id:'acc2'},' ',trd1,' '),this.state.componentview&&this.state.component,this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completedcomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/smctick.png'}),' \xA0Completed',this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0 | \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.goback(_this8.state.current_component);}},'Click here to Go Back'))))));}}]);return Careerlauncherrc;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Careerlauncherrc);;

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Panel__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function toArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }
  return currentActiveKey;
}

var Collapse = function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    var _this$props = _this.props,
        activeKey = _this$props.activeKey,
        defaultActiveKey = _this$props.defaultActiveKey;

    var currentActiveKey = defaultActiveKey;
    if ('activeKey' in _this.props) {
      currentActiveKey = activeKey;
    }

    _this.state = {
      openAnimation: _this.props.openAnimation || Object(__WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__["a" /* default */])(_this.props.prefixCls),
      activeKey: toArray(currentActiveKey)
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: toArray(nextProps.activeKey)
        });
      }
      if ('openAnimation' in nextProps) {
        this.setState({
          openAnimation: nextProps.openAnimation
        });
      }
    }
  }, {
    key: 'onClickItem',
    value: function onClickItem(key) {
      var activeKey = this.state.activeKey;
      if (this.props.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = [].concat(_toConsumableArray(activeKey));
        var index = activeKey.indexOf(key);
        var isActive = index > -1;
        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }
      this.setActiveKey(activeKey);
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var activeKey = this.state.activeKey;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          accordion = _props.accordion,
          destroyInactivePanel = _props.destroyInactivePanel,
          expandIcon = _props.expandIcon,
          children = _props.children;

      var newChildren = [];
      var childList = Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isFragment"])(children) ? children.props.children : children;

      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(childList, function (child, index) {
        if (!child) return;
        // If there is no key provide, use the panel order as default key
        var key = child.key || String(index);
        var _child$props = child.props,
            header = _child$props.header,
            headerClass = _child$props.headerClass,
            disabled = _child$props.disabled;

        var isActive = false;
        if (accordion) {
          isActive = activeKey[0] === key;
        } else {
          isActive = activeKey.indexOf(key) > -1;
        }

        var props = {
          key: key,
          header: header,
          headerClass: headerClass,
          isActive: isActive,
          prefixCls: prefixCls,
          destroyInactivePanel: destroyInactivePanel,
          openAnimation: _this2.state.openAnimation,
          accordion: accordion,
          children: child.props.children,
          onItemClick: disabled ? null : function () {
            return _this2.onClickItem(key);
          },
          expandIcon: expandIcon
        };

        newChildren.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, props));
      });
      //  ref: https://github.com/ant-design/ant-design/issues/13884
      if (Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isFragment"])(children)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          newChildren
        );
      }

      return newChildren;
    }
  }, {
    key: 'setActiveKey',
    value: function setActiveKey(activeKey) {
      if (!('activeKey' in this.props)) {
        this.setState({ activeKey: activeKey });
      }
      this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          className = _props2.className,
          style = _props2.style,
          accordion = _props2.accordion;

      var collapseClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: collapseClassName, style: style, role: accordion ? 'tablist' : null },
        this.getItems()
      );
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  accordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  expandIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Collapse.defaultProps = {
  prefixCls: 'rc-collapse',
  onChange: function onChange() {},

  accordion: false,
  destroyInactivePanel: false
};

Collapse.Panel = __WEBPACK_IMPORTED_MODULE_2__Panel__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContent__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_animate__ = __webpack_require__(824);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CollapsePanel = function (_Component) {
  _inherits(CollapsePanel, _Component);

  function CollapsePanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CollapsePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function () {
      if (_this.props.onItemClick) {
        _this.props.onItemClick();
      }
    }, _this.handleKeyPress = function (e) {
      if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
        _this.handleItemClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CollapsePanel, [{
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          style = _props.style,
          prefixCls = _props.prefixCls,
          header = _props.header,
          headerClass = _props.headerClass,
          children = _props.children,
          isActive = _props.isActive,
          showArrow = _props.showArrow,
          destroyInactivePanel = _props.destroyInactivePanel,
          disabled = _props.disabled,
          accordion = _props.accordion,
          forceRender = _props.forceRender,
          expandIcon = _props.expandIcon;

      var headerCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
      var itemCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);

      var icon = null;
      if (showArrow && typeof expandIcon === 'function') {
        icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(expandIcon, _extends({}, this.props));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: itemCls, style: style, id: id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: headerCls,
            onClick: this.handleItemClick,
            role: accordion ? 'tab' : 'button',
            tabIndex: disabled ? -1 : 0,
            'aria-expanded': '' + isActive,
            onKeyPress: this.handleKeyPress
          },
          showArrow && (icon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'arrow' })),
          header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_rc_animate__["a" /* default */],
          {
            showProp: 'isActive',
            exclusive: true,
            component: '',
            animation: this.props.openAnimation
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__PanelContent__["a" /* default */],
            {
              prefixCls: prefixCls,
              isActive: isActive,
              destroyInactivePanel: destroyInactivePanel,
              forceRender: forceRender,
              role: accordion ? 'tabpanel' : null
            },
            children
          )
        )
      );
    }
  }]);

  return CollapsePanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CollapsePanel.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  headerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  accordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  expandIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

CollapsePanel.defaultProps = {
  showArrow: true,
  isActive: false,
  destroyInactivePanel: false,
  onItemClick: function onItemClick() {},

  headerClass: '',
  forceRender: false
};

/* harmony default export */ __webpack_exports__["a"] = (CollapsePanel);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelContent = function (_Component) {
  _inherits(PanelContent, _Component);

  function PanelContent() {
    _classCallCheck(this, PanelContent);

    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
  }

  _createClass(PanelContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.forceRender || this.props.isActive || nextProps.isActive;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      this._isActived = this.props.forceRender || this._isActived || this.props.isActive;
      if (!this._isActived) {
        return null;
      }
      var _props = this.props,
          prefixCls = _props.prefixCls,
          isActive = _props.isActive,
          children = _props.children,
          destroyInactivePanel = _props.destroyInactivePanel,
          forceRender = _props.forceRender,
          role = _props.role;

      var contentCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
      var child = !forceRender && !isActive && destroyInactivePanel ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-content-box' },
        children
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: contentCls,
          role: role
        },
        child
      );
    }
  }]);

  return PanelContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PanelContent.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (PanelContent);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_animate__ = __webpack_require__(344);












var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(826);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(827), __esModule: true };

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(828);
module.exports = __webpack_require__(37).Object.assign;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(52);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(829) });


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(87);
var gOPS = __webpack_require__(144);
var pIE = __webpack_require__(89);
var toObject = __webpack_require__(251);
var IObject = __webpack_require__(249);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(67)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(340);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(832);
var $Object = __webpack_require__(37).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(42), 'Object', { defineProperty: __webpack_require__(41).f });


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(344);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(343);
} catch (err) {
  var index = __webpack_require__(343);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_animation__ = __webpack_require__(342);


function animate(node, show, transitionName, done) {
  var height = void 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0_css_animation__["a" /* default */])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = node.offsetHeight + 'px';
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = (show ? height : 0) + 'px';
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, prefixCls + '-anim', done);
    },
    leave: function leave(node, done) {
      return animate(node, false, prefixCls + '-anim', done);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (animation);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pdfview__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_collapse__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Ctestonebyone__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Cnormaltest__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cfixedtimetest__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ctimevariabletest__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Ctestresults__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Cvideocomponent__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Canouncement__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Cfeedbackform__ = __webpack_require__(351);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Collapsible from 'react-collapsible';
var $=window.$;var jQuery=window.jQuery;var Careerlaunchertrial=function(_Component){_inherits(Careerlaunchertrial,_Component);function Careerlaunchertrial(props){_classCallCheck(this,Careerlaunchertrial);var _this=_possibleConstructorReturn(this,(Careerlaunchertrial.__proto__||Object.getPrototypeOf(Careerlaunchertrial)).call(this,props));_this.state={product_id:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('productID',true),clist:[],accordinglists:[],completedcomp:[],total_score:'',total_out_of_score:'',componentview:false,component:'',sqe_id:'',compo_type:'',current_component:"0",sub_cur_component:"0"};_this.compolist=_this.compolist.bind(_this);return _this;}_createClass(Careerlaunchertrial,[{key:'getCllist',value:function getCllist(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'careerlancher/gettriallist',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),product_id:this.state.product_id})}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({clist:responseJson.result,accordinglists:responseJson.result.accordinglists,completedcomp:responseJson.competedcomp,total_out_of_score:responseJson.total_out_of_score,total_score:responseJson.total_score});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},1000);});}},{key:'componentDidMount',value:function componentDidMount(){this.getCllist();}},{key:'trd4',value:function trd4(component_list){var _this3=this;var trd4=component_list.map(function(k2,v2){var is_completed=$.inArray(k2,_this3.state.completedcomp)>=0;var sp=k2.split("_");var imageico='spdf.png';var comtitle='Faculty Session VC';if(sp.length>0){if(sp[0]=='vc'){imageico=is_completed>0?'cvls.png':'vlsc.png';comtitle='Faculty session';}if(sp[0]=='mcq'){imageico=is_completed>0?'ctesticon.png':'testiconc.png';comtitle='Assessment';}if(sp[0]=='an'){imageico=is_completed>0?'cannouncement.png':'announcementc.png';comtitle='Information';}if(sp[0]=='fb'){imageico=is_completed>0?'cfeedback.png':'feedbackc.png';comtitle='Feedback';}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:k2,href:'javascript:void(0);',style:{textDecoration:'none',border:'0px'},title:comtitle,onClick:function onClick(e){return _this3.opencomponents(k2);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/'+imageico,title:comtitle,alt_text:comtitle}));});return trd4;}},{key:'trd3',value:function trd3(components){var _this4=this;var trd3=components.map(function(k1,v1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"sub"+v1,className:"new-icon ks"+v1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'h last-child'},k1.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icons-set'},_this4.trd4(k1.component_list)));});return trd3;}},{key:'trd2',value:function trd2(sub_title,components){var _this5=this;var trd2=sub_title.map(function(k,v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["b" /* default */],{key:"sub"+v,accordion:true,defaultActiveKey:'subt_'+_this5.state.sub_cur_component,onChange:function onChange(e){return _this5.setsubActivityKey(v);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["a" /* Panel */],{header:k,key:'subt_'+v,onChange:function onChange(e){return _this5.setsubActivityKey(v);}},components.component_list==undefined&&components[v]!=undefined&&_this5.trd3(components[v]),components.component_list!=undefined&&_this5.trd4(components.component_list)));});return trd2;}},{key:'compolist',value:function compolist(cdata){if(cdata.compo_type=='testonebyone'){var compodet=this.getcompoformat('complete',cdata.compseq_id,cdata.id,cdata.compotype);this.setState({componentview:true,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Ctestresults__["a" /* default */],{data:compodet,switchback:this.compolist})});}else{this.state.completedcomp.push(cdata.id);this.setState({componentview:false,component:""});//window.reload();
this.getCllist();}}},{key:'opencomponents',value:function opencomponents(component){var _this6=this;this.setState({current_component:2});var s=component.split('.');if(s[1]!=undefined&&s[1].toLowerCase()=='pdf'){this.setState({componentview:true,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Pdfview__["a" /* default */],{key:'pdf_view_0',pdfpath:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */]+"imeta/"+component,title:'Read Me - All about this session'})});}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var ssd=component.split('_');fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'careerlancher/getcomponent',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),product_id:this.state.product_id,learning_room:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('defaultLRID',true),component:component})}).then(function(response){return response.json();}).then(function(responseJson){_this6.setState({componentview:true,component:_this6.getcompodetails(ssd,responseJson.result)});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");},2000);});}}},{key:'getcompoformat',value:function getcompoformat(status,compseq_id,id,compotype){var data={"status":status,"learning_room_id":__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]('defaultLRID',true),"compseq_id":compseq_id,"divider_id":"1","dlr_id":0,"learner_id":__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */](),"is_repeat":"N","look_before":"N","divider_status":1,"is_ag":"","id":id,"name":"","icon":"","alt_text":"","base_line":"","spanclass":"an_active_button","compo_type":compotype,"Isvisible":1,"current_component":this.state.current_component,"sub_current_component":this.state.current_component};return data;}},{key:'getcompodetails',value:function getcompodetails(ssd,responseJson){var compodet='';var opcompo='';var compotype=responseJson.compo_type;if(ssd[0]=='mcq'){compotype=responseJson.status==''?responseJson.compo_type:'testresult';compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],compotype);if(responseJson.status=='completed'){opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Ctestresults__["a" /* default */],{data:compodet,switchback:this.compolist});}else if(compotype=='testonebyone'){opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Ctestonebyone__["a" /* default */],{data:compodet,switchback:this.compolist});}else if(compotype=='normaltest'){opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Cnormaltest__["a" /* default */],{data:compodet,switchback:this.compolist});}}if(ssd[0]=='vc'){compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"videocomponent");opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Cvideocomponent__["a" /* default */],{data:compodet,switchback:this.compolist});}if(ssd[0]=='an'){compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"anouncement");opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Canouncement__["a" /* default */],{data:compodet,switchback:this.compolist});}if(ssd[0]=='fb'){compodet=this.getcompoformat(responseJson.status,responseJson.compseq_id,ssd[1],"feedbackform");opcompo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Cfeedbackform__["a" /* default */],{data:compodet,switchback:this.compolist});}return opcompo;}},{key:'goback',value:function goback(k){var _this7=this;this.setState({componentview:false,component:''});setTimeout(function(){_this7.setState({current_component:k});},1000);}},{key:'setActivityKey',value:function setActivityKey(k){this.setState({current_component:k});}},{key:'setsubActivityKey',value:function setsubActivityKey(k){this.setState({sub_cur_component:k});}//{"status":"completed","learning_room_id":"2694","compseq_id":"19006","divider_id":"1","dlr_id":0,"learner_id":"101032","is_repeat":"N","look_before":"N","divider_status":1,"is_ag":"","id":"687","name":"dsf","icon":"dsf","alt_text":"dasfdasf","base_line":"dasf","spanclass":"an_active_button","compo_type":"thanks","Isvisible":1}
},{key:'render',value:function render(){var _this8=this;var clistsd=this.state.clist;var accordinglist=this.state.accordinglists;var trd1=accordinglist.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["b" /* default */],{key:"mn"+index,accordion:true,defaultActiveKey:'cus_'+_this8.state.current_component,onChange:function onChange(e){return _this8.setActivityKey(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_rc_collapse__["a" /* Panel */],{header:key.main_title,key:'cus_'+index,onChange:function onChange(e){return _this8.setActivityKey(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'outer',onClick:function onClick(e){return _this8.setActivityKey(index);}},key.sub_title.length>0&&_this8.trd2(key.sub_title,key.components),key.sub_title.length==0&&_this8.trd3(key.components))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'trial',id:'container2',className:'container2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'accrodion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,clistsd.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'smart-link'},clistsd.introduction_vc!=''&&clistsd.introduction_vc!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:clistsd.introduction_vc,onClick:function onClick(e){return _this8.opencomponents(clistsd.introduction_vc);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/video.png',alt:clistsd.introduction_vc,align:'absmiddle'}),'\xA0\xA0',clistsd.introduction_vc_title)),clistsd.introductoin_pdf!=''&&clistsd.introductoin_pdf!=undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',title:clistsd.introductoin_pdf,onClick:function onClick(e){return _this8.opencomponents(clistsd.introductoin_pdf);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/spdf.png',alt:clistsd.introductoin_pdf,align:'absmiddle'}),'\xA0\xA0',clistsd.introductoin_pdf_title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completedcomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/smctick.png'}),' \xA0Completed',this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0 | \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.goback(_this8.state.current_component);}},'Click here to Go Back'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),this.state.total_score>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'perform-score'},'Performance score: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'-'),' (',this.state.total_score+'/'+this.state.total_out_of_score,')'),!this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accordion',id:'acc2'},' ',trd1,' '),this.state.componentview&&this.state.component,this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completedcomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/smctick.png'}),' \xA0Completed',this.state.componentview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0 | \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this8.goback(_this8.state.current_component);}},'Click here to Go Back')))));}}]);return Careerlaunchertrial;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Careerlaunchertrial);;

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Geolocation = function (_React$Component) {
  _inherits(Geolocation, _React$Component);

  function Geolocation(props) {
    _classCallCheck(this, Geolocation);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getCurrentPosition = function () {
      var _this$props = _this.props,
          enableHighAccuracy = _this$props.enableHighAccuracy,
          timeout = _this$props.timeout,
          maximumAge = _this$props.maximumAge,
          onSuccess = _this$props.onSuccess,
          onError = _this$props.onError;


      _this.setState({ fetchingPosition: true });

      return window.navigator.geolocation.getCurrentPosition(function (position) {
        if (_this.willUnmount) return;

        _this.setState({ position: position, fetchingPosition: false }, function () {
          return onSuccess(position);
        });
      }, function (error) {
        if (_this.willUnmount) return;

        _this.setState({ error: error, fetchingPosition: false }, function () {
          return onError(error);
        });
      }, { enableHighAccuracy: enableHighAccuracy, timeout: timeout, maximumAge: maximumAge });
    };

    _this.state = {
      fetchingPosition: false,
      position: undefined,
      error: undefined
    };
    return _this;
  }

  Geolocation.prototype.componentWillMount = function componentWillMount() {
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object') {
      return;
    }

    if (!('geolocation' in window.navigator)) {
      return;
    }

    if (this.props.lazy) {
      return;
    }

    this.getCurrentPosition();
  };

  Geolocation.prototype.componentWillUnmount = function componentWillUnmount() {
    this.willUnmount = true;
  };

  Geolocation.prototype.render = function render() {
    if (!this.props.render) {
      return null;
    }
    return this.props.render({
      getCurrentPosition: this.getCurrentPosition,
      fetchingPosition: this.state.fetchingPosition,
      position: this.state.position,
      error: this.state.error
    }) || null;
  };

  return Geolocation;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Geolocation.propTypes = {
  // https://developer.mozilla.org/en-US/docs/Web/API/PositionOptions
  enableHighAccuracy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  timeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maximumAge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition
  onSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // Do not call getCurrentPosition on mount
  lazy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

Geolocation.defaultProps = {
  enableHighAccuracy: false,
  timeout: Infinity,
  maximumAge: 0,
  onSuccess: function onSuccess(pos) {},
  // eslint-disable-next-line handle-callback-err
  onError: function onError(err) {},
  lazy: false
};

/* harmony default export */ __webpack_exports__["a"] = (Geolocation);
//# sourceMappingURL=react-geolocation.es.js.map


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_RegisterLayout__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Addobserver__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pinregistration__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Registeruserdetails__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Thankspage__ = __webpack_require__(846);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Register=function(_Component){_inherits(Register,_Component);function Register(props){_classCallCheck(this,Register);//Registrationpanel: <Pinregistration  backToPreviousPage={(e)=>this.backToLogin(e)} submit={(e)=>this.submitStep1()} onChange={(e)=>this.handleChange(e)} />,
// <Registeruserdetails buttonText="Complete Registration" data={[]} submit={(e)=>this.submitStep2()} onChange={(e)=>this.handleChange(e)}/>
// <Pinregistration  backToPreviousPage={(e)=>this.backToLogin(e)} submit={(e)=>this.submitStep1()} onChange={(e)=>this.handleChange(e)} />
var _this=_possibleConstructorReturn(this,(Register.__proto__||Object.getPrototypeOf(Register)).call(this,props));_this.state={register_details_button:'Complete Registration',Registrationpanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Pinregistration__["a" /* default */],{backToPreviousPage:function backToPreviousPage(e){return _this.backToLogin(e);},submit:function submit(e){return _this.submitStep1();},onChange:function onChange(e){return _this.handleChange(e);}}),content:[],email:'',pin:'',key:'',registration_details:[]};// this.handleChange=this.handleChange.bind(this);
return _this;}_createClass(Register,[{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'submitStep1',value:function submitStep1(){var _this2=this;var username="";var pin="";var userkey="";if(document.getElementById('email').value===''){username=this.state.pin;}else{username=document.getElementById('email').value;}if(document.getElementById('pin').value===''){pin=this.state.pin;}else{pin=document.getElementById('pin').value;}if(document.getElementById('Key').value===''){userkey=this.state.pin;}else{userkey=document.getElementById('Key').value;}__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/pinregister",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({//  pin:this.state.pin,
//  key:this.state.key,
//  email:this.state.email
pin:pin,key:userkey,email:username})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status===0){if(responseJson.errors!==""){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("Oops!!",responseJson.message,'error');}}else{var register_details_button=_this2.state.register_details_button;if(responseJson.LearnerData.buttonvalue===1){register_details_button="Next";}_this2.setState({register_details_button:register_details_button});_this2.setState({Registrationpanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Registeruserdetails__["a" /* default */],{buttonText:register_details_button,data:responseJson.LearnerData,submit:function submit(e){return _this2.submitStep2();},onChange:function onChange(e){return _this2.handleChange(e);}})});}});}},{key:'submitStep2',value:function submitStep2(){var _this3=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var formData=new FormData();var registration_details=$('#registration_details').serializeArray();registration_details.map(function(key,index){if(key.name==='hidfilename'){return false;}formData.append(key.name,key.value);});if($('#txtfile')[0].files.length>0){formData.append('txtfile',$('#txtfile')[0].files[0]);}else{formData.append('txtfile','');}fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/registerdetails",{method:"POST",// data: formData,
headers:{'Accept':'application/json'// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status===0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{// Common.message('',responseJson.message,'success');
if(_this3.state.register_details_button==="Next"){_this3.setState({LearnerData:responseJson.data,Registrationpanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Addobserver__["a" /* default */],{data:responseJson.data,submit:function submit(e){return _this3.submitStep3();},onChange:function onChange(e){return _this3.handleChange(e);}})});}else{_this3.setState({LearnerData:responseJson.data,Registrationpanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Thankspage__["a" /* default */],{data:responseJson.data})});}}});// let registration_details=$('#registration_details').serializeArray();
// console.log(registration_details);
//  this.setState({
//   step2:'none',
//   step3:''
// });
}},{key:'submitStep3',value:function submitStep3(){var _this4=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var formData=new FormData();var frmaddobserver=$('#frmaddobserver').serializeArray();frmaddobserver.map(function(key,index){if(key.name==='hidfilename'){return false;}formData.append(key.name,key.value);});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/addobservers",{method:"POST",// data: formData,
headers:{'Accept':'application/json'// 'Content-Type': false
},body:formData}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status===0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{_this4.setState({Registrationpanel:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Thankspage__["a" /* default */],{data:_this4.state.LearnerData})});}});}},{key:'backToPreviousPage',value:function backToPreviousPage(step){if(step===1){this.setState({step1:'',step2:'none'});}}},{key:'backToLogin',value:function backToLogin(){this.props.router.push('/');}},{key:'render',value:function render(){// <Registeruserdetails buttonText={this.state.register_details_button} display={this.state.step2}  data={this.state.learnerData} submit={(e)=>this.submitStep2()} onChange={(e)=>this.handleChange(e)} />
//
// <Addobserver  display={this.state.step3} submit={(e)=>this.submitStep3()} onChange={(e)=>this.handleChange(e)} />
//
// <Thankspage data={this.state.content} display={this.state.step4} />
//
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__layouts_RegisterLayout__["a" /* default */],null,this.state.Registrationpanel);}}]);return Register;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Register);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_RegisterHeader_js__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Footer_js__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterLayout=function(_Component){_inherits(RegisterLayout,_Component);function RegisterLayout(props){_classCallCheck(this,RegisterLayout);var _this=_possibleConstructorReturn(this,(RegisterLayout.__proto__||Object.getPrototypeOf(RegisterLayout)).call(this,props));_this.state={};return _this;}_createClass(RegisterLayout,[{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__partials_RegisterHeader_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},this.props.children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__partials_Footer_js__["a" /* default */],null));}}]);return RegisterLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegisterLayout);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterHeader=function(_Component){_inherits(RegisterHeader,_Component);function RegisterHeader(){_classCallCheck(this,RegisterHeader);return _possibleConstructorReturn(this,(RegisterHeader.__proto__||Object.getPrototypeOf(RegisterHeader)).apply(this,arguments));}_createClass(RegisterHeader,[{key:'render',value:function render(){var monthNames=['January','February','March','April','May','June','July','August','September','October','November','December'];var day=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];var d=new Date(),displayDate=d.getDate(),displayYear=d.getFullYear(),displayAMonth=monthNames[d.getMonth()],displayDay=day[d.getDay()];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),' ',displayDay,', ',displayAMonth,' ',displayDate,', ',displayYear));}}]);return RegisterHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegisterHeader);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Addmore__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var jQuery=window.jQuery;var $=window.$;var Addobserver=function(_Component){_inherits(Addobserver,_Component);function Addobserver(props){_classCallCheck(this,Addobserver);var _this=_possibleConstructorReturn(this,(Addobserver.__proto__||Object.getPrototypeOf(Addobserver)).call(this,props));_this.state={scrollHeight:0,getcountrycodes:[],getrelations:[]// optionGenderField:0
};return _this;}_createClass(Addobserver,[{key:'getrelations',value:function getrelations(product_id){var _this2=this;fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'products/'+product_id+'?expand=relationship',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){if(responseJson.data.relationship.length>0){_this2.setState({getrelations:responseJson.data.relationship});}}});}},{key:'getcountrycodes',value:function getcountrycodes(){var _this3=this;fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"getcountrycodes",{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==2){_this3.setState({getcountrycodes:responseJson.country_data});}});}},{key:'handleChange',value:function handleChange(e){this.props.onClick(e);}},{key:'refreshScroll',value:function refreshScroll(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";setTimeout(function(){$(".current_index").remove();$('div[id^="observer"]').each(function(){var id=$(this).attr('id').split("_");$('#observer_'+id[1]).find(".genderoption").attr('name','gender_'+id[1]);$('#observer_'+id[1]).append('<input type="hidden" name="current_index[]" class="current_index" value="'+id[1]+'" />');});},200);// if(type=="add_observer"){
//
//   // let scrollbar1_height=jQuery('#semana-scroll-register .viewport').height();
//
//   this.setState({optionGenderField:this.state.optionGenderField+1});
//   setTimeout(()=>{
//    $('#observer_'+this.state.optionGenderField).find(".genderoption").attr('name','gender_'+this.state.optionGenderField);
//   },200);
//
// }
//
// if(type=="remove_observer"){
//
//   this.setState({optionGenderField:this.state.optionGenderField-1});
//
// }
var $scrollbar=jQuery('#semana-scroll-register'),$overview=$scrollbar.find(".overview"),loadingData=false;$scrollbar.tinyscrollbar({thumbSize:20});var scrollbarData=$scrollbar.data("plugin_tinyscrollbar");$scrollbar.bind("move",function(){// The threshold will enable us to start loading the text before we reach the end.
//
var threshold=0.9,positionCurrent=scrollbarData.contentPosition+scrollbarData.viewportSize,positionEnd=scrollbarData.contentSize*threshold;// Check if have reached the "end" and that we arent allready in the process of loading new data.
//
if(!loadingData&&positionCurrent>=positionEnd){//loadingData = true;
//
// $.getJSON("data.json", function(data)
// {
//     loadingData = false;
//
//     $overview.append(data.text)
//
// });
scrollbarData.update("relative");}});}},{key:'submit',value:function submit(){this.props.submit();}},{key:'componentDidMount',value:function componentDidMount(){var data=this.props.data;jQuery('#semana-scroll-register').tinyscrollbar();this.getcountrycodes();this.getrelations(data.product);}},{key:'render',value:function render(){var _this4=this,_React$createElement;var data=this.props.data;var contryCodeoptions=this.state.getcountrycodes.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.id},key.name_code);});var relationoptions=this.state.getrelations.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.name},key.name);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Add Observers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'OBSERVERS will be interacting with you right through the program. You choose your own observers, who could be your friends, family, seniors or teachers - anybody who can play a productive role in your learning and development. Many of the works you submit during the program will be reaching your observers for their feedback and rating.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You need ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'at least one observer'),' and a maximum of any number. They will receive a mail through which they can accept your request. Please note that WITHOUT observers, you would not be able to start the program.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please fill in your details below as part of the mandatory process:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box-reg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-register',className:'scrollbar1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'frmaddobserver',id:'frmaddobserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'learner_id',value:data.learner_id_pk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'current_index[]',className:'current_index',value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'gender',value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Addmore__["a" /* default */],{selector:'observer',limit:3,editType:'form',AddLabel:'+ Add Observer',refreshScroll:function refreshScroll(e){return _this4.refreshScroll(e);},compType:'parent',DeleteLabel:'Remove'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Observer Name ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'name[]',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Email Id ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'email[]',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Relationship ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'relation[]',id:'lstrelation'},relationoptions))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Gender ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'gender_0',className:'rdbtn genderoption',type:'radio',value:'1'}),'\xA0Male\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'gender_0',className:'rdbtn genderoption',type:'radio',value:'0'}),'\xA0Female '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Contact Number ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'ISD[]',id:'txtphoneISD1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- select ---'),contryCodeoptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt',style:{marginLeft:'-100px'}},'Phone ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',(_React$createElement={name:'phone[]',type:'text',className:'textbox',id:'txtphone1',maxLength:'10'},_defineProperty(_React$createElement,'className','txtbox-medium'),_defineProperty(_React$createElement,'style',{width:"65%"}),_React$createElement)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btm-divider'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn-green',onClick:function onClick(e){return _this4.submit();},name:'btnsubmit',value:'Complete Registration'}))))))));}}]);return Addobserver;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Addobserver);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Pinregistration=function(_Component){_inherits(Pinregistration,_Component);function Pinregistration(props){_classCallCheck(this,Pinregistration);var _this=_possibleConstructorReturn(this,(Pinregistration.__proto__||Object.getPrototypeOf(Pinregistration)).call(this,props));_this.state={};return _this;}_createClass(Pinregistration,[{key:'componentWillMount',value:function componentWillMount(){var url=window.location.href;var lr_id=url.split('=');if(lr_id['1']&&lr_id['1']!=""){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/getregisterdetails",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({lr_id:lr_id['1']})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status===0){if(responseJson.errors!=""){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,'error');}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("Oops!!",responseJson.message,'error');}}else if(responseJson.status===1){document.getElementById('email').value=responseJson.data.user_name;document.getElementById('pin').value=responseJson.data.pinno;document.getElementById('Key').value=responseJson.data.user_key;}});}}},{key:'handleChange',value:function handleChange(e){this.props.onChange(e);}},{key:'submit',value:function submit(){this.props.submit();}},{key:'backToPreviousPage',value:function backToPreviousPage(){this.props.backToPreviousPage();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'PIN Registration'),'If you have received an email with your PIN number, please register here.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/img-pinreg.jpg',alt:'',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pin-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Username',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'100',id:'email',name:'email',onChange:function onChange(e){return _this2.handleChange(e);}}),'PIN',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',maxLength:'45',id:'pin',name:'pin',onChange:function onChange(e){return _this2.handleChange(e);}}),'Key',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'key',id:'Key',onChange:function onChange(e){return _this2.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'grn-btn',value:'Next',alt:'Next',onClick:function onClick(e){return _this2.submit();},title:'Next'}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'red-btn',onClick:function onClick(e){return _this2.backToPreviousPage();},value:'Cancel',alt:'Cancel',title:'Cancel',className:'button-cancel'})))));}}]);return Pinregistration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Pinregistration);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var jQuery=window.jQuery;var Registeruserdetails=function(_Component){_inherits(Registeruserdetails,_Component);function Registeruserdetails(props){_classCallCheck(this,Registeruserdetails);var _this=_possibleConstructorReturn(this,(Registeruserdetails.__proto__||Object.getPrototypeOf(Registeruserdetails)).call(this,props));_this.state={tr_student:'',tr_Working:'none',othershow:'none',hidOccupation:'',photoDisplay:'none',checkedGenderOption:1,optphotoOption:'Uploadlater',checkedOccupationOption:1,getcountrycodes:[],locations:[],cities:[]};return _this;}_createClass(Registeruserdetails,[{key:'submit',value:function submit(){this.props.submit();}},{key:'showPhotoPanel',value:function showPhotoPanel(type){var show='none';if(type=='Uploadnow'){show='';}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("",'Please upload your photo in few days','info');}this.setState({photoDisplay:show,optphotoOption:type});}},{key:'getcountrycodes',value:function getcountrycodes(){var _this2=this;fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"getcountrycodes",{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){_this2.setState({getcountrycodes:responseJson.country_data});});}},{key:'getlocations_cities',value:function getlocations_cities(){var _this3=this;fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"getlocationscities",{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){_this3.setState({locations:responseJson.location,cities:responseJson.city});});}},{key:'fnOccupation',value:function fnOccupation(Occupation){this.occupation(Occupation);if(Occupation==1){this.setState({hidOccupation:1,tr_student:'',tr_Working:'none',othershow:'none'});}else if(Occupation==2){this.setState({hidOccupation:2,tr_student:'none',tr_Working:'',othershow:'none'});}else if(Occupation==3){this.setState({hidOccupation:3,tr_student:'none',tr_Working:'none',othershow:''});}}},{key:'gender',value:function gender(value){this.setState({checkedGenderOption:value});}},{key:'occupation',value:function occupation(value){this.setState({checkedOccupationOption:value});}},{key:'clearForm',value:function clearForm(e){$('form#registration_details')[0].reset();this.setState({photoDisplay:'none'});}},{key:'handleChange',value:function handleChange(e){this.props.onClick(e);}},{key:'componentDidMount',value:function componentDidMount(){this.getcountrycodes();this.getlocations_cities();setTimeout(function(){$("#txtdob").datepicker({dateFormat:'D, d M, yy',changeMonth:true,changeYear:true,yearRange:"-70:-15",maxDate:'15Y'});jQuery('#semana-scroll-register').tinyscrollbar();},100);}},{key:'render',value:function render(){var _this4=this;var data=this.props.data;var contryCodeoptions=this.state.getcountrycodes.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.id},key.name_code);});var contryoptions=this.state.getcountrycodes.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.id},key.name);});var locations=this.state.locations.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.name},key.name);});var cities=this.state.cities.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:key.name},key.name);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'registration_details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'learner_id',value:data.learner_id_pk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'app_code',value:data.app_code}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'PIN Registration'),'Please fill in the following details to complete PIN Registration. All fields are mandatory to fill.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box-reg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'regdetspan'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.corporate_name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Email (Username)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'regdetspan'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.primaryemail)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'First Name  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'regdetspan',style:{'height':'36px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.firstname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Last Name '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'regdetspan',style:{'height':'36px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.lastname)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Gender ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'optgender',type:'radio',value:'1',checked:this.state.checkedGenderOption==1,onChange:function onChange(e){return _this4.gender(1);}}),'Male \xA0  \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'optgender',type:'radio',value:'2',checked:this.state.checkedGenderOption==2,onChange:function onChange(e){return _this4.gender(2);}}),'Female ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Date of Birth ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'txtdob',className:'txtdob',placeholder:'Select Date',id:'txtdob',readOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Mobile No ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'txtcountrycode',id:'txtcountrycode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select Country Code'),contryCodeoptions),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'txtmobile',className:'txtbox',maxLength:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-txt'},'10 digit Mobile Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Occupation ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'rdoOccupation',type:'radio',value:'1',onChange:function onChange(e){return _this4.fnOccupation(1);},checked:this.state.checkedOccupationOption==1}),'Student \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'rdoOccupation',type:'radio',value:'2',onChange:function onChange(e){return _this4.fnOccupation(2);},checked:this.state.checkedOccupationOption==2}),'Working \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'rdoOccupation',type:'radio',value:'3',onChange:function onChange(e){return _this4.fnOccupation(3);},checked:this.state.checkedOccupationOption==3}),'Other',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'hidOccupation',id:'hidOccupation',value:this.state.hidOccupation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-full'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tr_student',style:{display:this.state.tr_student}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Dept of study ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'st_Studying',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Year of study ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'st_cmbYearofstudy',id:'st_cmbYearofstudy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-- Select --'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'I'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'II'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'III'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'IV')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'College ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'st_College',id:'st_College'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'College Location ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},data.product=="232"||data.product=="231"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'st_college_loc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Select'),locations):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'st_college_loc',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tr_Working',style:{display:this.state.tr_Working}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Designation',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'wor_designation',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Experience ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'exp-yrs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'wor_lstexpyrs',id:'wor_lstexpyrs',style:{width:"60%"},defaultValue:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'11'},'11'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'12'},'12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'13'},'13'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'14'},'14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15'},'15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'16'},'16'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'17'},'17'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'18'},'18'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'19'},'19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'20'},'20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'21'},'21'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'22'},'22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'23'},'23'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'24'},'24'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'25'},'25')),'Years'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'exp-months'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'wor_lstexpmonths',id:'wor_lstexpmonths',style:{width:"60%"},defaultValue:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'11'},'11')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingTop:"13px",display:"inline-block"}},'Months')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Education',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'wor_Education'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Office Location ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},data.product=="232"||data.product=="231"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'wor_office_Location'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Select'),locations):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'wor_office_Location',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'othershow',style:{display:this.state.othershow}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Others Type ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'oth_others',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Location ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},data.product=="232"||data.product=="231"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'oth_rLocation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Select'),locations):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'oth_rLocation',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'City / Town ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},data.product=="232"||data.product=="231"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'com_CityTown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Select'),cities):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'com_CityTown',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Region / State ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'com_RegionState',type:'text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Country ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'com_cmbCountry',id:'com_cmbCountry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Select'),contryoptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-large'},' Any other info about Me ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'txtaboutyourself',id:'txtaboutyourself',className:'textarea word-count-check',onKeyUp:function onKeyUp(e){return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Fields__["c" /* countWords */])(e);},'data-total-words':'200'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'max-words'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red lefttxt'},'Max words: 200')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'word-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'balance-words',style:{float:'right'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'typing-words',style:{visibility:'hidden'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photo-box'},'Please upload a photo of yours. It is required for the purpose of this programme. You can choose to upload it now or later.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-photo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Upload photo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'optphoto',className:'rdbtn',id:'optphoto',value:'Uploadnow',checked:this.state.optphotoOption=='Uploadnow',onChange:function onChange(e){return _this4.showPhotoPanel('Uploadnow');}}),'now \xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',className:'rdbtn',name:'optphoto',id:'optphoto',value:'Uploadlater',checked:this.state.optphotoOption=='Uploadlater',onChange:function onChange(e){return _this4.showPhotoPanel('Uploadlater');}}),'later '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-photo',id:'photo',style:{display:this.state.photoDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Photo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt dynImgText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'txtfile',size:'96',accept:'image/*',className:'txtbox',name:'txtfile'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dynImg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'blah',src:'#',alt:'your image'})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtsmall'},'Preferred size up to 500KB. Maximum upload size is 2MB. ( Only JPEG,GIF Format ) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'hidfilename',type:'hidden',id:'hidfilename',value:''})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*'),' Required fields'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',onClick:function onClick(e){return _this4.submit();},name:'btnsubmit',value:this.props.buttonText,className:'btn-green',alt:this.props.buttonText,title:this.props.buttonText}),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnsubmit',onClick:function onClick(e){return _this4.clearForm();},value:'Cancel',alt:'Cancel',title:'Cancel',className:'btn-red'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'add_height',style:{height:"50px"}}))))))));}}]);return Registeruserdetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Registeruserdetails);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Thankspage=function(_Component){_inherits(Thankspage,_Component);function Thankspage(){_classCallCheck(this,Thankspage);return _possibleConstructorReturn(this,(Thankspage.__proto__||Object.getPrototypeOf(Thankspage)).apply(this,arguments));}_createClass(Thankspage,[{key:'render',value:function render(){var data=this.props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'PIN Registration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box-reg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-register',className:'scroll1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'innerfull',style:{minHeight:'250px',fontSize:'15px',lineHeight:'20px'}},' You have successfully registered for the program ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtxt-prod'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.product_name,'.')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'access-text'},'You can now access your learning space with the following credentials (please note these down with you). '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'user-thanks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Username :'),data.primaryemail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Initial Password :'),data.password),data.unique_app_code!=null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Appcode :'),data.unique_app_code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'After logging in, you may change your password, after which your \'Initial Password\' will not hold good anymore. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You will get our mail communication from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:admin@361dm.com'},'admin@361dm.com'),' and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:puja@361dm.com'},'puja@361dm.com'),'. Remember to look into your spam box too. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_1__config_Config__["g" /* rootDomainUrl */],className:'btn-green'},'Continue to Login')),' ')))))));}}]);return Thankspage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Thankspage);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign $ value to use jquery
var $=window.$;var BirthdayWish=function(_Component){_inherits(BirthdayWish,_Component);function BirthdayWish(props){_classCallCheck(this,BirthdayWish);var _this=_possibleConstructorReturn(this,(BirthdayWish.__proto__||Object.getPrototypeOf(BirthdayWish)).call(this,props));var afterRoutes=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("afterRoutes",true);_this.state={appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],date:afterRoutes[0].date,userName:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["b" /* Username */])()};return _this;}_createClass(BirthdayWish,[{key:'navigateUser',value:function navigateUser(){var _this2=this;// So user did the requested action. Now redirect him to other url's if available
Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","please wait...");var userData=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])());if(userData.afterRoutes.length>1){userData.afterRoutes.splice(0,1);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("afterRoutes",userData.afterRoutes,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");_this2.props.router.push(userData.afterRoutes[0].url);},1200);}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("globalAccess",true,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("afterRoutes",[],true);},500);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");_this2.props.router.push(__WEBPACK_IMPORTED_MODULE_1__config_Config__["i" /* routeAfterLogin */]);},1200);}}},{key:'componentDidMount',value:function componentDidMount(){var player=document.getElementById("birthAudioPlayer");player.play();$("#simple3D").simple3D({moveX:3,moveY:3,bgImage:true,targetAll:true,reverseX:true,reverseY:true});//  $("#my_audio").get(0).play();
}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'birthday-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'simple3D'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dot'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'kinoco'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'star'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-birthday'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo-events.png',alt:'',title:this.state.appImgAlt})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-demo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:'demo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container balloon-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'balloon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/banner.png',alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/cake.png',alt:'',title:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b-per'},this.state.userName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'b-date'},this.state.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bt-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this3.navigateUser();},className:'cnt-btn'},'Continue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,controlsList:'nodownload',id:'birthAudioPlayer',style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:"/rmeta"+"/audio/Karaoke.mp3",type:'audio/mpeg'})))))));}}]);return BirthdayWish;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BirthdayWish);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CorporateLogin=function(_Component){_inherits(CorporateLogin,_Component);function CorporateLogin(){_classCallCheck(this,CorporateLogin);return _possibleConstructorReturn(this,(CorporateLogin.__proto__||Object.getPrototypeOf(CorporateLogin)).apply(this,arguments));}_createClass(CorporateLogin,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"user/login",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({authuser:this.props.params.accessCode,type:'corporate'})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["x" /* setTokenData */])("token",responseJson.token);Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["y" /* setUserData */])("isLoggedIn",true);__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */]("Test","Welcome",'');var date=new Date();date.setSeconds(date.getSeconds()+__WEBPACK_IMPORTED_MODULE_2__config_Config__["j" /* sessExpire */]);Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["y" /* setUserData */])("sessMax",date.getTime());setTimeout(function(){var decodeJson=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["r" /* parseJwt */])(responseJson.token);if(decodeJson.beforeRoutes.length>0){_this2.props.router.push(decodeJson.beforeRoutes[0].url);}else if(decodeJson.afterRoutes.length>0){_this2.props.router.push(decodeJson.afterRoutes[0].url);}else{_this2.props.router.push(decodeJson.routePath);}},500);}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return CorporateLogin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CorporateLogin);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TcsLogin=function(_Component){_inherits(TcsLogin,_Component);function TcsLogin(){_classCallCheck(this,TcsLogin);return _possibleConstructorReturn(this,(TcsLogin.__proto__||Object.getPrototypeOf(TcsLogin)).apply(this,arguments));}_createClass(TcsLogin,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"user/login",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify({authuser:this.props.params.accessCode,type:'tcs'})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["x" /* setTokenData */])("token",responseJson.token);Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["y" /* setUserData */])("isLoggedIn",true);var date=new Date();date.setSeconds(date.getSeconds()+__WEBPACK_IMPORTED_MODULE_2__config_Config__["j" /* sessExpire */]);Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["y" /* setUserData */])("sessMax",date.getTime());setTimeout(function(){var decodeJson=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_Common__["r" /* parseJwt */])(responseJson.token);if(decodeJson.beforeRoutes.length>0){_this2.props.router.push(decodeJson.beforeRoutes[0].url);}else if(decodeJson.afterRoutes.length>0){_this2.props.router.push(decodeJson.afterRoutes[0].url);}else{_this2.props.router.push(decodeJson.routePath);}},500);}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return TcsLogin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TcsLogin);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign $ value to use jquery
var $=window.$;var ChatRate=function(_Component){_inherits(ChatRate,_Component);function ChatRate(props){_classCallCheck(this,ChatRate);var _this=_possibleConstructorReturn(this,(ChatRate.__proto__||Object.getPrototypeOf(ChatRate)).call(this,props));_this.state={date:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("appFullDate",true),chatList:[]};return _this;}_createClass(ChatRate,[{key:'getchatList',value:function getchatList(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/ecoach/chats",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!==0){_this2.setState({chatList:responseJson.data});}});}},{key:'rateChat',value:function rateChat(){var _this3=this;var chatRateForm=$("#chatRateForm").serializeArray(),formData=new FormData();formData.append("user_id",Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])());chatRateForm.map(function(val){formData.append(val.name,val.value);});__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/ecoach/rating",{method:"POST",headers:{'Accept':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]("Success",responseJson.message,"success");var userData=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */](__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]());if(userData.preRoutes.length>1){userData.preRoutes.splice(0,1);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("preRoutes",userData.preRoutes,true);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");_this3.props.router.push(userData.preRoutes[0].url);},1200);}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("globalAccess",true,true);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("preRoutes",[],true);},500);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");_this3.props.router.push(__WEBPACK_IMPORTED_MODULE_1__config_Config__["i" /* routeAfterLogin */]);},1200);}}});}},{key:'componentWillMount',value:function componentWillMount(){this.getchatList();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";}},{key:'render',value:function render(){var _this4=this;var chatHtml=this.state.chatList.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'ratingbox_'+key,className:'ratebox margtop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellpadding:'0',cellspacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colspan:'3'},'Please rate your E-Coach for the chat you had on ',val.date,' from ',val.from,' to ',val.to,'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colspan:'2'},'Your rating : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'chat_id[]',type:'hidden',value:val.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'chat_rating[]'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'8'},'8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'9'},'9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10')))))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pageheight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Rate your E Coach'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'#',method:'post',id:'chatRateForm'},chatHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margtop'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',name:'btnRate',onClick:function onClick(){return _this4.rateChat();},value:'Rate'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null));}}]);return ChatRate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatRate);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign $ value to use jquery
var $=window.$;var TeleCall=function(_Component){_inherits(TeleCall,_Component);function TeleCall(props){_classCallCheck(this,TeleCall);var _this=_possibleConstructorReturn(this,(TeleCall.__proto__||Object.getPrototypeOf(TeleCall)).call(this,props));_this.state={date:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],userName:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["b" /* Username */])(),teleCallBooked:false};return _this;}_createClass(TeleCall,[{key:'checkTelecallStatus',value:function checkTelecallStatus(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/telecall/status",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else if(responseJson.callBooked){_this2.setBackToLoginWithDelay();_this2.setState({teleCallBooked:true,scheduleDate:responseJson.scheduleDate,startTime:responseJson.startTime,endTime:responseJson.endTime});}});}},{key:'setBackToLoginWithDelay',value:function setBackToLoginWithDelay(){var delayTime=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15000;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */])();setTimeout(function(){this.props.router.push("login");}.bind(this),delayTime);}},{key:'scheduleTeleCall',value:function scheduleTeleCall(){var _this3=this;var scheduleDate=this.refs.scheduleDate.value;var startTime=this.refs.startHR.value+":"+this.refs.startMin.value;var endTime=this.refs.endHR.value+":"+this.refs.endMin.value;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/telecall/schedule",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */])(),schedule_date:scheduleDate,start_time:startTime,end_time:endTime})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this3.setState({teleCallBooked:true,scheduleDate:responseJson.scheduleDate,startTime:responseJson.startTime,endTime:responseJson.endTime});var userData=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])());if(userData.beforeRoutes.length>1){userData.beforeRoutes.splice(0,1);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["y" /* setUserData */])("beforeRoutes",userData.beforeRoutes,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this3.props.router.push(userData.beforeRoutes[0].url);},1200);}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this3.setBackToLoginWithDelay();}}});}},{key:'componentWillMount',value:function componentWillMount(){this.checkTelecallStatus();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";$("#scheduleDate").datepicker({dateFormat:'yy-mm-dd',changeMonth:true,yearRange:"-10:+0",changeYear:true}).val();}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Register for Tele-induction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teleinduc grey-lite'},'Hi ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.userName),',',!this.state.teleCallBooked&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nonusere-inner'},'You are logging after more than a month. For inducting you back into the program, your E Coach would like to have a telecall with you.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:"10px"}},'In the space below, please choose your preferred time for this tele-induction.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:"10px"}},'Thanks.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'#',method:'post',className:'FrmSchedule'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellpadding:'0',cellspacing:'0',border:'0',width:'100%',className:'tele-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Date ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',ref:'scheduleDate',id:'scheduleDate',className:'ScheduleDate',readonly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Time (IST)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'startHR'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'00'},'00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'01'},'01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'02'},'02'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'03'},'03'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'04'},'04'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'05'},'05'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'06'},'06'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'07'},'07'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'08'},'08'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'09'},'09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'11'},'11'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'12'},'12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'13'},'13'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'14'},'14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15'},'15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'16'},'16'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'17'},'17'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'18'},'18'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'19'},'19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'20'},'20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'21'},'21'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'22'},'22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'23'},'23')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smaltxt'},'hrs'),' \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'startMin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'00'},'00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15'},'15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'30'},'30'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'45'},'45')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smaltxt'},'mins  \xA0\xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'To'),' \xA0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'endHR'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'00'},'00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'01'},'01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'02'},'02'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'03'},'03'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'04'},'04'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'05'},'05'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'06'},'06'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'07'},'07'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'08'},'08'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'09'},'09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'10'},'10'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'11'},'11'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'12'},'12'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'13'},'13'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'14'},'14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15'},'15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'16'},'16'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'17'},'17'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'18'},'18'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'19'},'19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'20'},'20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'21'},'21'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'22'},'22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'23'},'23')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smaltxt'},'hrs'),' \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'endMin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'00'},'00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'15'},'15'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'30'},'30'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'45'},'45')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smaltxt'},'mins'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colspan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Schedule',title:'Schedule',onClick:function onClick(){return _this4.scheduleTeleCall();}})))))),this.state.teleCallBooked&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:"10px"}},'You have scheduled for the tele-induction on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'greentxt'},this.state.scheduleDate),' from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'greentxt'},this.state.startTime),' to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'greentxt'},this.state.endTime),' IST.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:"10px"}},'Your E Coach shall call you for doing your tele-induction, after which you will be able to proceed with the rest of the Learning Rooms.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null))));}}]);return TeleCall;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TeleCall);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_Footer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputgenerator__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeleCallFeedback=function(_Component){_inherits(TeleCallFeedback,_Component);function TeleCallFeedback(props){_classCallCheck(this,TeleCallFeedback);var _this=_possibleConstructorReturn(this,(TeleCallFeedback.__proto__||Object.getPrototypeOf(TeleCallFeedback)).call(this,props));_this.state={date:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],formDataList:[],questionList:[]};return _this;}_createClass(TeleCallFeedback,[{key:'GetTeleCallInfo',value:function GetTeleCallInfo(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/telecall/questions",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{_this2.setState({formDataList:responseJson.data,questionList:responseJson.data.questions});}});}},{key:'submitFeedback',value:function submitFeedback(){var _this3=this;var jsonFormData=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Fields__["d" /* getFormValues */])(this.state.formDataList);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"post/telecall/feedback",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_User__["a" /* UserId */])(),json_form_data:jsonFormData})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,"error");}else{var userData=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])());if(userData.afterRoutes.length>1){userData.afterRoutes.splice(0,1);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("afterRoutes",userData.afterRoutes,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");_this3.props.router.push(userData.afterRoutes[0].url);},1200);}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("globalAccess",true,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("afterRoutes",[],true);},500);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");_this3.props.router.push(__WEBPACK_IMPORTED_MODULE_1__config_Config__["i" /* routeAfterLogin */]);},1200);}}});}},{key:'componentWillMount',value:function componentWillMount(){this.GetTeleCallInfo();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";}},{key:'render',value:function render(){var _this4=this;var feedbackHtml=this.state.questionList.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'level1_div_'+key,className:'fdbk-questn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greenbg'},key+1),val.questionLabel,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ques-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Inputgenerator__["a" /* default */],{qDetails:val}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{method:'post',action:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Feedback for the Telecall'),'As a way to let us know about outcomes associated with this course, we would like to you to share your thoughts with us:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-register',className:'scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-forms'},feedbackHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txtnoP'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Continue',title:'Continue',onClick:function onClick(){return _this4.submitFeedback();}})))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_Footer__["a" /* default */],null));}}]);return TeleCallFeedback;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TeleCallFeedback);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign $ & window value to use jquery
var $=window.$;var win=window;var Feathers=function(_Component){_inherits(Feathers,_Component);function Feathers(props){_classCallCheck(this,Feathers);var _this=_possibleConstructorReturn(this,(Feathers.__proto__||Object.getPrototypeOf(Feathers)).call(this,props));_this.state={appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],featherList:[]};return _this;}_createClass(Feathers,[{key:'getfeatherList',value:function getfeatherList(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"get/observer/feathers",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status!==0){_this2.setState({featherList:responseJson.feathers});}});}},{key:'navigateUser',value:function navigateUser(length){var _this3=this;var nextItem=length+1;if(this.state.featherList.length!==nextItem){$(".feather-block"+length).fadeOut("fast");$(".feather-block"+nextItem).fadeIn("fast");}else{// Clear the snow fall animation
win.snowFall.snow(document.body,"clear");__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"update/observer/feathers",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!==0){var userData=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */](__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]());if(userData.afterRoutes.length>1){userData.afterRoutes.splice(0,1);__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("afterRoutes",userData.afterRoutes,true);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");_this3.props.router.push(userData.afterRoutes[0].url);},1200);}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("globalAccess",true,true);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */]("afterRoutes",[],true);},500);setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");_this3.props.router.push(__WEBPACK_IMPORTED_MODULE_1__config_Config__["i" /* routeAfterLogin */]);},1200);}}});}}},{key:'componentWillMount',value:function componentWillMount(){this.getfeatherList();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="events-wrapper";win.snowFall.snow(document.body,{image:"images/flake3.png",minSize:10,maxSize:30});win.snowFall.snow(document.body,{image:"images/flake2.png",minSize:10,maxSize:30});win.snowFall.snow(document.body,{image:"images/flake1.png",minSize:10,maxSize:30});}},{key:'render',value:function render(){var _this4=this;var featherHtml=this.state.featherList.map(function(val,key){var attribute=key===0?{display:"block"}:{display:"none"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'level1_div_'+key,className:'feather-block'+key,style:attribute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feather-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'You got New Feather from'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feather-name'},val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feather-no'},'No of new feathers :',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,val.count))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bt-div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(){return _this4.navigateUser(key);},className:'cnt-btn'},'Continue')));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo-361dm.png',alt:'',title:this.state.appImgAlt})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container balloon-con cong-con'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'congrats-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/congrats.png',alt:'',title:''})),featherHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/g-baloon1.png',alt:'',title:'',className:'g-baloon1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/g-baloon.png',alt:'',title:'',className:'g-baloon2'}));}}]);return Feathers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Feathers);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PinExpired=function(_Component){_inherits(PinExpired,_Component);function PinExpired(props){_classCallCheck(this,PinExpired);var _this=_possibleConstructorReturn(this,(PinExpired.__proto__||Object.getPrototypeOf(PinExpired)).call(this,props));_this.state={date:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],userName:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["b" /* Username */])(),productName:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('productName',true)};return _this;}_createClass(PinExpired,[{key:'setBackToLoginWithDelay',value:function setBackToLoginWithDelay(){var delayTime=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15000;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */])();setTimeout(function(){this.props.router.push("login");}.bind(this),delayTime);}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";this.setBackToLoginWithDelay();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent',id:'frmaddobserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'PIN Expired'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greybgcenter'},'Hi ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.userName),',',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sorry! your login has expired for ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.productName),'. Please Write to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:higheredu@361dm.com',target:'_top',style:{color:'#0082c9'}},'higheredu@361dm.com'),'  for extension of your login.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null))));}}]);return PinExpired;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PinExpired);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WaitForLogin=function(_Component){_inherits(WaitForLogin,_Component);function WaitForLogin(props){_classCallCheck(this,WaitForLogin);var _this=_possibleConstructorReturn(this,(WaitForLogin.__proto__||Object.getPrototypeOf(WaitForLogin)).call(this,props));_this.state={productName:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("productName",true),pgmStartDate:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("pgmStartDate",true),supportEmail:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("supportEmail",true),date:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],userName:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["b" /* Username */])()};return _this;}_createClass(WaitForLogin,[{key:'setBackToLoginWithDelay',value:function setBackToLoginWithDelay(){var delayTime=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15000;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */])();setTimeout(function(){this.props.router.push("login");}.bind(this),delayTime);}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";this.setBackToLoginWithDelay(20000);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent',id:'frmaddobserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Please Wait'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greybgcenter'},'Hi ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.userName),',',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You are enrolled for the program ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.productName),'. Your sessions are expected to open on ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.pgmStartDate),'. Further information will be mailed to your email ID. If you have any query, please write to us at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+this.state.supportEmail,className:'greentxt',style:{textDecoration:"underline"}},this.state.supportEmail),'.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null))));}}]);return WaitForLogin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WaitForLogin);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContractCancelled=function(_Component){_inherits(ContractCancelled,_Component);function ContractCancelled(props){_classCallCheck(this,ContractCancelled);var _this=_possibleConstructorReturn(this,(ContractCancelled.__proto__||Object.getPrototypeOf(ContractCancelled)).call(this,props));_this.state={learningRoomName:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("learningRoomName",true),productName:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("productName",true),date:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],userName:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["b" /* Username */])()};return _this;}_createClass(ContractCancelled,[{key:'setBackToLoginWithDelay',value:function setBackToLoginWithDelay(){var delayTime=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15000;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */])();setTimeout(function(){this.props.router.push("login");}.bind(this),delayTime);}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";this.setBackToLoginWithDelay();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent',id:'frmaddobserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Contract Cancelled'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greybgcenter'},'Hi ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.userName),',',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You have cancelled the contract in Learning Room ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.learningRoomName),' of ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.productName),'. Please contact your OAH for further details.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null))));}}]);return ContractCancelled;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ContractCancelled);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PinDeactivated=function(_Component){_inherits(PinDeactivated,_Component);function PinDeactivated(props){_classCallCheck(this,PinDeactivated);var _this=_possibleConstructorReturn(this,(PinDeactivated.__proto__||Object.getPrototypeOf(PinDeactivated)).call(this,props));_this.state={date:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],userName:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["b" /* Username */])(),productName:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])('productName',true)};return _this;}_createClass(PinDeactivated,[{key:'setBackToLoginWithDelay',value:function setBackToLoginWithDelay(){var delayTime=arguments.length>0&&arguments[0]!==undefined?arguments[0]:15000;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["c" /* clearUserData */])();setTimeout(function(){this.props.router.push("login");}.bind(this),delayTime);}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";this.setBackToLoginWithDelay();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reg_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent',id:'frmaddobserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'PIN Deactivated'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greybgcenter'},'Hi ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.userName),',',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Your PIN is deactivated for ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greentxt'},this.state.productName),'. Please Write to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:higheredu@361dm.com',target:'_top',style:{color:'#0082c9'}},'higheredu@361dm.com'),' for details.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null))));}}]);return PinDeactivated;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PinDeactivated);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign $ value to use jquery
var $=window.$;var LoginAddObserver=function(_Component){_inherits(LoginAddObserver,_Component);function LoginAddObserver(props){_classCallCheck(this,LoginAddObserver);var _this=_possibleConstructorReturn(this,(LoginAddObserver.__proto__||Object.getPrototypeOf(LoginAddObserver)).call(this,props));_this.state={date:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],countryCodes:[],relations:[]};return _this;}_createClass(LoginAddObserver,[{key:'getCountryCodes',value:function getCountryCodes(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Loading...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"getcountrycodes",{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==2){_this2.setState({countryCodes:responseJson.country_data});}});}},{key:'getRelations',value:function getRelations(product_id){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Loading...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'products/'+product_id+'?expand=relationship',{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])()}}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status==1&&responseJson.data.relationship.length>0){_this3.setState({relations:responseJson.data.relationship});}});}},{key:'addObserver',value:function addObserver(){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var formData=new FormData(),formInputs=$('#frmAddObserver').serializeArray();formInputs.map(function(val,index){formData.append(val.name,val.value);});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/addobservers",{method:"POST",headers:{'Accept':'application/json'},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===0){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */])(responseJson.message,responseJson.errors,'error');}else{var userData=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */])());if(userData.afterRoutes.length>1){userData.afterRoutes.splice(0,1);Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["y" /* setUserData */])("afterRoutes",userData.afterRoutes,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this4.props.router.push(userData.afterRoutes[0].url);},1200);}else{Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["y" /* setUserData */])("globalAccess",true,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["y" /* setUserData */])("afterRoutes",[],true);},500);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");_this4.props.router.push(__WEBPACK_IMPORTED_MODULE_1__config_Config__["i" /* routeAfterLogin */]);},1200);}}});}},{key:'componentWillMount',value:function componentWillMount(){this.getRelations(Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */])("productID",true));this.getCountryCodes();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";}},{key:'render',value:function render(){var _this5=this;var contryCodeOptions=this.state.countryCodes.map(function(val,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'contry_code_'+index,value:val.id},val.name_code);});var relationOptions=this.state.relations.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'relation_'+index,value:key.name},key.name);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'obslogin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Welcome ',Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["b" /* Username */])(),',')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'OBSERVERS will be interacting with you right through the program. You choose your own observers, who could be your friends, family, seniors or teachers - anybody who can play a productive role in your learning and development. Many of the works you submit during the program will be reaching your observers for their feedback and rating.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You need ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'at least one observer'),' and a maximum of any number. They will receive a mail through which they can accept your request. Please note that without observers, you would not be able to start the program.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'showobs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Please fill in your details below as part of the mandatory process:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'#',method:'post',id:'frmAddObserver'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Observer Name ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'learner_id',value:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_User__["a" /* UserId */])()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'current_index[]',value:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'name[]',className:'txtbox'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Email Id ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'email[]',type:'text',className:'txtbox'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Relationship ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'relation[]'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Select ---'),relationOptions))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Gender ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'gender_0',className:'rdbtn',type:'radio',value:'1',defaultChecked:true}),'\xA0Male \xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'gender_0',className:'rdbtn',type:'radio',value:'0'}),'\xA0Female'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-left-txt'},'Contact Number ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-red'},'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right-txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'ISD[]'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--- Select ---'),contryCodeOptions),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'textbox-mini',name:'STD[]',maxLength:'6',style:{width:"70px"}}),' - ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'txtbox-medium',name:'phone[]',maxLength:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-small'},'STD code \xA0\xA0\xA0\xA0 - \xA0 Phone'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'frm-right'},'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Add Observer',onClick:function onClick(){return _this5.addObserver();}})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_Footer__["a" /* default */],null));}}]);return LoginAddObserver;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginAddObserver);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Validation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_Footer__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign $ value to use jquery
var $=window.$;var ChatRate=function(_Component){_inherits(ChatRate,_Component);function ChatRate(props){_classCallCheck(this,ChatRate);var _this=_possibleConstructorReturn(this,(ChatRate.__proto__||Object.getPrototypeOf(ChatRate)).call(this,props));_this.state={date:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */])("appFullDate",true),selectedIndex:0,dlrList:[]};return _this;}_createClass(ChatRate,[{key:'getDlrList',value:function getDlrList(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show","Please wait...");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/get-dlr-list",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({user_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])()})}).then(function(response){return response.json();}).then(function(responseJson){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");if(responseJson.status!==0){_this2.setState({dlrList:responseJson.data});setTimeout(function(){_this2.initFlexSlider();},600);}});}},{key:'componentWillMount',value:function componentWillMount(){this.getDlrList();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner dlrpage";}},{key:'initFlexSlider',value:function initFlexSlider(){$('.flexslider').flexslider({animation:"slide",start:function start(slider){$('body').removeClass('loading');}});}},{key:'navigateUser',value:function navigateUser(statusMsg){var _this3=this;var userData=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["r" /* parseJwt */])(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])());if(userData.afterRoutes.length>1){userData.afterRoutes.splice(0,1);Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("afterRoutes",userData.afterRoutes,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");_this3.redirectWithMsg(statusMsg,userData.afterRoutes[0].url);},1200);}else{Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("globalAccess",true,true);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["y" /* setUserData */])("afterRoutes",[],true);},500);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("hide");_this3.redirectWithMsg(statusMsg,__WEBPACK_IMPORTED_MODULE_1__config_Config__["i" /* routeAfterLogin */]);},1200);}}},{key:'redirectWithMsg',value:function redirectWithMsg(statusMsg,url){var _this4=this;window.swal("",statusMsg).then(function(value){_this4.props.router.push(url);});}},{key:'changeID',value:function changeID(index,dlrId){$('input[name="'+dlrId+'_hidden"]').val(index);this.setState({selectedIndex:index});}},{key:'noThanks',value:function noThanks(dlrId){var _this5=this;Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/schedule/dlr",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({dlr_id:dlrId,user_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])(),type:'cancel'})}).then(function(response){return response.json();}).then(function(responseJson){var statusMsg=responseJson.status===0?responseJson.errors:responseJson.message;_this5.navigateUser(statusMsg);});}},{key:'bookNow',value:function bookNow(dlrId){var _this6=this;if(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Validation__["a" /* runValidation */])('dlr_'+dlrId)){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */])("show");fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"user/schedule/dlr",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */])()},body:JSON.stringify({dlr_id:dlrId,user_id:Object(__WEBPACK_IMPORTED_MODULE_2__helpers_User__["a" /* UserId */])(),schedule_id:$('input[name="'+dlrId+'_hidden"]').val(),type:'book'})}).then(function(response){return response.json();}).then(function(responseJson){var statusMsg=responseJson.status===0?responseJson.errors:responseJson.message;_this6.navigateUser(statusMsg);});}}},{key:'render',value:function render(){var _this7=this;var dlrHtml=this.state.dlrList.map(function(val,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'dlr_'+key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,val.slug,' . ',val.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'videoicon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/video-icon.png',alt:'',title:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-sessions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,val.schedule.map(function(scheduleVal,scheduleKey){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'schedule_'+val.id+'_'+scheduleKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',value:scheduleVal.id,checked:_this7.state.selectedIndex===scheduleVal.id,onChange:function onChange(){return _this7.changeID(scheduleVal.id,val.id);}}),scheduleVal.date,', ',scheduleVal.from,' to ',scheduleVal.to);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:val.id+'_hidden',className:'required dlr_'+val.id})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sechd-btn',id:'btn_book'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'btn_name',value:'Book',onClick:function onClick(e){return _this7.bookNow(val.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',className:'btn_name',value:'No thanks',onClick:function onClick(e){return _this7.noThanks(val.id);}}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:__WEBPACK_IMPORTED_MODULE_1__config_Config__["b" /* appImgAlt */],border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),this.state.date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Schedule your Dynamic Learning Rooms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gray-box dlrsechdule'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pin-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'You have ',this.state.dlrList.length,' new active DLR(s).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sechdle-video'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexslider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'slides'},dlrHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Note:'),' For good quality viewing of the Live session, we recommend internet speed of 1 MBPS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/schedule-img.jpg',alt:'',title:''}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__partials_Footer__["a" /* default */],null));}}]);return ChatRate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatRate);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Fields__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Feedback=function(_Component){_inherits(Feedback,_Component);function Feedback(props){_classCallCheck(this,Feedback);var _this=_possibleConstructorReturn(this,(Feedback.__proto__||Object.getPrototypeOf(Feedback)).call(this,props));_this.state={ass_id:_this.props.params.ass_id,poll_id:_this.props.params.poll_id,learner:_this.props.params.lr_id,domain:_this.props.params.domain,questions:[],ques:[],assessor_name:'',learner_img:'',dated:'',is_answered:0,lr_name:''};_this.getFeedback=_this.getFeedback.bind(_this);_this.submit=_this.submit.bind(_this);return _this;}_createClass(Feedback,[{key:'getFeedback',value:function getFeedback(){var _this2=this;var asses_id=this.state.ass_id;var pollid=this.state.poll_id;var learner_id=this.state.learner;var doma=this.state.domain;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'personal/feedback-questions',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({assessor_id:asses_id,poll_id:pollid,learner_id:learner_id,domain:doma})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringify(responseJson));
if(responseJson.status!=0){_this2.setState({ques:responseJson.questions,questions:responseJson.questions.questions,assessor_name:responseJson.extra.asse_name,learner_img:responseJson.extra.lr_img,dated:responseJson.extra.date,is_answered:responseJson.extra.is_answered,lr_name:responseJson.extra.lr_name});}});}},{key:'componentDidMount',value:function componentDidMount(){this.getFeedback();var div=document.querySelector('body');div.id='bodyid';div.setAttribute('class','inner');}},{key:'submit',value:function submit(e){var _this3=this;__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("show","Please wait...");//let learnerID = Common.getUserData("id", true);
var asses_id=this.state.ass_id;var pollid=this.state.poll_id;var learner_id=this.state.learner;var jsonFormData=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_Fields__["d" /* getFormValues */])(this.state.ques);// alert(JSON.stringify(jsonFormData));
fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+"personal/observer-vote",{method:"POST",//data: formData,
headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({json_form_data:jsonFormData,asses_id:asses_id,pollid:pollid,learner_id:learner_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */]("hide");//alert(JSON.stringify(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{var content='<span class="redtext">'+responseJson.message+'</span><br/>'+' -'+_this3.state.lr_name;//Common.message("", 'Thank you for your valuable feedback.', "success");
$("#maincontent").html(content);}});}},{key:'render',value:function render(){var _this4=this;var ques='';var length='';if(this.state.questions!=undefined){ques=this.state.questions.map(function(ques,i){// let ans = ques.answers.map((answ,k)=>{
// 	if(answ.choice != ""){
// 		return(
// 			)
// 	}
// })
if(ques.questionLabel!=""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'question_'+i,align:'left',id:"div_snappoll"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'poll_centerbg_mail_snap'},ques.questionLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:"hidqid"+i,id:"hidqid"+i,value:ques.questionId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:"hidtype"+i,id:"hidtype"+i,value:ques.questionTypeId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'poll_txt_mail_snap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'answ_'+i,className:'fdbkradio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Inputgenerator__["a" /* default */],{key:'quess_inputgenerator_'+i,qDetails:ques}))));}});length=this.state.questions.length;}var monthNames=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["p" /* monthNames */];var d=new Date(),jDate=d.getDate(),jMonth=monthNames[d.getMonth()],jYear=d.getFullYear();return!this.state.is_answered?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),this.state.dated)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{align:'center',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Hi ',this.state.assessor_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{height:'28',colSpan:'2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{valign:'top',width:'10%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.state.learner_img}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'I value your feedback immensely.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'I request you to let me know your thoughts about me, by answering the questions below. I look forward to your 100% true feedback, as it is going to help me greatly.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'assessor_snap_form',id:'assessor_snap_form'},ques,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'no',id:'no',value:length}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'button margtop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'btnSubmit',value:'Submit',onClick:function onClick(e){return _this4.submit(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Copyright \xA9 2006-',jYear,','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Threesixtyone Degree Minds Consulting Pvt Ltd.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f-lnk'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Privacy'),'\xA0\xA0|\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Legal')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),this.state.dated)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'redtext'},'You have already submitted your feedback. Thank you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' - ',this.state.lr_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Copyright \xA9 20017-',jYear,','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Threesixtyone Degree Minds Consulting Pvt Ltd.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f-lnk'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Privacy'),'\xA0\xA0|\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Legal'))));}}]);return Feedback;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Feedback);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var Evaluator=function(_Component){_inherits(Evaluator,_Component);function Evaluator(props){_classCallCheck(this,Evaluator);var _this=_possibleConstructorReturn(this,(Evaluator.__proto__||Object.getPrototypeOf(Evaluator)).call(this,props));_this.state={asse_id:_this.props.params.asse_id,learner:_this.props.params.lear_id,dated:'',ass_details:[],lr_details:[],check_done:0,corp:'',prod:'',experience:'',country:''};_this.getEvaluator=_this.getEvaluator.bind(_this);_this.changeState=_this.changeState.bind(_this);_this.AcceptReject=_this.AcceptReject.bind(_this);return _this;}_createClass(Evaluator,[{key:'componentDidMount',value:function componentDidMount(){this.getEvaluator();var div=document.querySelector('body');div.id='bodyid';div.setAttribute('class','inner');}},{key:'AcceptReject',value:function AcceptReject(type){var _this2=this;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'evaluators/update-status',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({assessor_id:this.state.asse_id,learner_id:this.state.learner,type:type,ass_details:this.state.ass_details,lr_details:this.state.lr_details})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringify(responseJson));
if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["o" /* message */]("",responseJson.message,"success");_this2.getEvaluator();$("#Show").css('display','none');}});}},{key:'changeState',value:function changeState(){$('#Show').css('display','');}},{key:'getEvaluator',value:function getEvaluator(){var _this3=this;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'evaluators/getdetails',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({assessor_id:this.state.asse_id,learner_id:this.state.learner})}).then(function(response){return response.json();}).then(function(responseJson){//	alert(JSON.stringify(responseJson));
if(responseJson.status!=0){_this3.setState({ass_details:responseJson.extra.asse_details,lr_details:responseJson.extra.learner_details,check_done:responseJson.extra.check,dated:responseJson.extra.date,corp:responseJson.extra.corporate,prod:responseJson.extra.product,experience:responseJson.extra.experience,country:responseJson.extra.country});}});}},{key:'render',value:function render(){var _this4=this;var monthNames=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["p" /* monthNames */];var d=new Date(),jDate=d.getDate(),jMonth=monthNames[d.getMonth()],jYear=d.getFullYear();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),this.state.dated)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content paymentthanks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.state.check_done==0?'Accept / Decline my request':this.state.ass_details!=undefined?this.state.ass_details.approved==1?'Accepted my request':'Declined my request':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margtop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2',valign:'top'},' Dear ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.ass_details!=undefined?this.state.ass_details.gender==1?'Mr.'+this.state.ass_details.name:'Ms.'+this.state.ass_details.name:'',','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Thanks for considering my request.',this.state.check_done==0?'I would appreciate if you accept to be my Evaluator for this program.':'','Please ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'orange1',onClick:function onClick(e){return _this4.changeState(e);}},'Click Here'),' to  view my complete profile. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Best regards,'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.lr_details!=undefined?this.state.lr_details.firstname+' '+this.state.lr_details.lastname:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{id:'Show',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'8px',borderTop:'dashed 1px #dddddd',margin:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellpadding:'0',cellspacing:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'300'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Customer Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'50'},':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'60%'},this.state.corp)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Program Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.prod)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.email:'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Mobile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.country_code+'-'+this.state.lr_details.mobile:'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Gender')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.gender==1?'Male':'Female':'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Date of Birth')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.dob!='0000-00-00'||this.state.lr_details.dob!=''?this.state.lr_details.dob:'-':'')),this.state.lr_details!=undefined?this.state.lr_details.occupation==1?[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Course')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details.studying)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Year of study')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details.yearofstudy)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'College')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details.college))]:this.state.lr_details.occupation==2?[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Education')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details.education)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Designation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details.designation)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Experience')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.experience))]:this.state.lr_details.occupation==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Occupation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details.others)):'':'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.location:'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'City / Town')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.citytown:'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Region / state')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.regionstate:'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.country)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'trcolor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'About Learner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.state.lr_details!=undefined?this.state.lr_details.aboutyourself:'-')))))))))),this.state.check_done==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'I am happy to Accept',onClick:function onClick(){return _this4.AcceptReject('accept');},style:{marginLeft:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',value:'Sorry. I Decline',onClick:function onClick(){return _this4.AcceptReject('reject');}})):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Copyright \xA9 2006-',jYear,','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Threesixtyone Degree Minds Consulting Pvt Ltd.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f-lnk'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Privacy'),'\xA0\xA0|\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Legal'))));}}]);return Evaluator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Evaluator);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Thanks__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Validation__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var DigitalEvaluation=function(_Component){_inherits(DigitalEvaluation,_Component);function DigitalEvaluation(props){_classCallCheck(this,DigitalEvaluation);var _this=_possibleConstructorReturn(this,(DigitalEvaluation.__proto__||Object.getPrototypeOf(DigitalEvaluation)).call(this,props));_this.state={det:_this.props.params.det,assessor_evaluation:[],assessors_name:'',Asssex:'',sex:'',full_name:'',evaluation_questionaire:[],photo:'',evaluation_question:[],compolist:[],thanksPage:''};return _this;}_createClass(DigitalEvaluation,[{key:'fnEvaluationFormValidate',value:function fnEvaluationFormValidate(){var _this2=this;var learnerID=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true);if(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_Validation__["a" /* runValidation */])('evaluation-block')){var formData=new FormData();var evaluation_form=$('#evaluation_form').serializeArray();evaluation_form.map(function(key,index){formData.append(key.name,key.value);});formData.append('det',this.state.det);fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'evaluation/assessor-evaluation-insert',{method:'POST',headers:{'Accept':'application/json',//'Content-Type': 'application/json',
'Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:formData}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var data={"status":"completed","learning_room_id":responseJson.details.learning_room_id,"compseq_id":responseJson.details.compseq_id,"divider_id":0,"dlr_id":0,"learner_id":learnerID,"is_ag":0,"id":0,"compo_type":"thanks","look_before":responseJson.details.compseq_id,"flowresult":true};_this2.setState({thanksPage:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Thanks__["a" /* default */],{data:data,usableType:'webapp',switchback:_this2.state.compolist})});}});}}},{key:'getAssessorEvaluation',value:function getAssessorEvaluation(){var _this3=this;fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'evaluation/assessor-evaluation',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({det:this.state.det,domain:__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]})}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status!=0){var assessor_evaluation=responseJson.assessor_evaluation!=undefined?responseJson.assessor_evaluation:'';// alert(JSON.stringify(assessor_evaluation));
var assessors_name=responseJson.assessor_evaluation.assessors_name!=undefined?responseJson.assessor_evaluation.assessors_name:'';var Asssex=responseJson.assessor_evaluation.Asssex!=undefined?responseJson.assessor_evaluation.Asssex:'';var photo=responseJson.assessor_evaluation.photo!=undefined?responseJson.assessor_evaluation.photo:'';var sex=responseJson.assessor_evaluation.sex!=undefined?responseJson.assessor_evaluation.sex:'';var full_name=responseJson.assessor_evaluation.full_name!=undefined?responseJson.assessor_evaluation.full_name:'';var evaluation_questionaire=responseJson.assessor_evaluation.evaluation_questionaire!=undefined?responseJson.assessor_evaluation.evaluation_questionaire:'';var evaluation_question=responseJson.assessor_evaluation.evaluation_question!=undefined?responseJson.assessor_evaluation.evaluation_question:'';_this3.setState({assessor_evaluation:assessor_evaluation,assessors_name:assessors_name,Asssex:Asssex,sex:sex,full_name:full_name,evaluation_questionaire:evaluation_questionaire,photo:photo,evaluation_question:evaluation_question});}});}},{key:'componentDidMount',value:function componentDidMount(){var div=document.querySelector('body');div.id='bodyid';div.setAttribute('class','inner');this.getAssessorEvaluation();}},{key:'render',value:function render(){var _this4=this;var monthNames=__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["p" /* monthNames */];var d=new Date(),jDate=d.getDate(),jMonth=monthNames[d.getMonth()],jYear=d.getFullYear();var question=null;if(this.state.evaluation_questionaire!=null||this.state.evaluation_questionaire!=undefined){question=this.state.evaluation_questionaire.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txt'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ev_active_button',title:key.alt_text},key.icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lm_txt'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lm_title'},key.eval_question_name),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blue'},'Number of Questions :',key.no_of_questions),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slash_txt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),key.eval_welcome_message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score_box',style:{width:'750px'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score_explanation'},'Rating Explanation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{size:'2',face:'arial'},key.scoring_explanation,' '),' '))));});}var select_question=null;var r=0;if(this.state.evaluation_question!=null||this.state.evaluation_question!=undefined){select_question=this.state.evaluation_question.map(function(key,index){var rate=[];for(r=key.eval_from;r<=key.eval_to;r++){rate.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:r},r));}var index_val=index+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{id:'evaluation-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',id:'hidQuestionId['+index_val+']',name:'hidQuestionId['+index_val+']',value:key.eval_question_id_pk}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'7px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{name:'bookmark'+index_val}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'question_txt',style:{width:'100%'}},index_val,' . ',key.eval_question,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'cmbbox required  evaluation-block',name:'cmbRate['+index_val+']',id:'cmbRate'+index_val},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--Select--'),rate)),' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'divAnswer'+index_val,className:'errorAsssor',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('font',{color:'#FF0000'})))));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'361\xB0minds\u2122',title:'361\xB0minds\u2122',border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),this.state.dated)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pageheight'},this.state.thanksPage===""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Welcome ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.Asssex,'    ',this.state.assessors_name,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margtop'},' Thank you for being here. Please read the rating explanation before you begin answering.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellspacing:'0',cellpadding:'0',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'80%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{align:'center',width:'100%',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'20%',valign:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{align:'center',width:'100%',border:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},'   ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.photo,className:'border',alt:'',width:'50',border:'0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'date_red'},this.state.full_name,'  '),' '))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colspan:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'evaluation_form',id:'evaluation_form',method:'post',action:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',cellspacing:'0',cellpadding:'0',border:'0'},select_question,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{height:'50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'Submit',onClick:function onClick(e){return _this4.fnEvaluationFormValidate();}}))))))))))))))))),this.state.thanksPage!==""&&this.state.thanksPage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Copyright \xA9 2006-',jYear,','),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Threesixtyone Degree Minds Consulting Pvt Ltd.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f-lnk'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Privacy'),'\xA0\xA0|\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);'},'Legal'))));}}]);return DigitalEvaluation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DigitalEvaluation);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Footer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PracticeResponse=function(_Component){_inherits(PracticeResponse,_Component);function PracticeResponse(props){_classCallCheck(this,PracticeResponse);var _this=_possibleConstructorReturn(this,(PracticeResponse.__proto__||Object.getPrototypeOf(PracticeResponse)).call(this,props));_this.state={date:__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("appFullDate",true),appImgAlt:__WEBPACK_IMPORTED_MODULE_2__config_Config__["b" /* appImgAlt */],score_id:_this.props.params.score_id,fst_name:'',cre_date:'',pr_name:'',comment:'',score:'',rej_reason:'',rej_date:'',reason:'',comm:'',datas:[]};_this.getTr=_this.getTr.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);return _this;}_createClass(PracticeResponse,[{key:'getTr',value:function getTr(val){this.setState({reason:val});}},{key:'handleChange',value:function handleChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));}},{key:'onSubmit',value:function onSubmit(){var _this2=this;var reason=this.state.comm;var page_flag='';var practiceCorner=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("practiceCorner",true);var practiceCornerMini=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("practiceCornerMini",true);//alert(practiceCorner+'--'+practiceCornerMini);
if(practiceCorner!=false){page_flag=1;}else if(practiceCornerMini!=false){page_flag=2;}else{}fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"practice/practice-reject",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({reason:reason,score_id:this.state.score_id,page_flag:page_flag,datas:this.state.datas})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */]('Success',responseJson.message,"success");_this2.GetInfo();}});}},{key:'GetInfo',value:function GetInfo(){var _this3=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var score_id=!this.state.score_id?1:this.state.score_id;fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+"practice/practice-response",{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Authorization':'Bearer '+__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["h" /* getTokenData */]()},body:JSON.stringify({score_id:score_id})}).then(function(response){return response.json();}).then(function(responseJson){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");if(responseJson.status==0){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["o" /* message */](responseJson.message,responseJson.errors,"error");}else{_this3.setState({fst_name:responseJson.datas[0].name,cre_date:responseJson.datas[0].cre_date,pr_name:responseJson.datas[0].pr_name,comment:responseJson.datas[0].comment,score:responseJson.datas[0].score,rej_reason:responseJson.datas[0].rej_reason,rej_date:responseJson.datas[0].rej_date,datas:responseJson.datas});}});}},{key:'componentWillMount',value:function componentWillMount(){this.GetInfo();}},{key:'componentDidMount',value:function componentDidMount(){document.body.className="inner";}},{key:'render',value:function render(){var _this4=this;var page_flag='';var practiceCorner=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("practiceCorner",true);var practiceCornerMini=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["i" /* getUserData */]("practiceCornerMini",true);//alert(practiceCorner+'--'+practiceCornerMini);
if(practiceCorner!=false){page_flag=1;}else if(practiceCornerMini!=false){page_flag=2;}else{}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/logo.png',alt:'',title:this.state.appImgAlt,border:'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-links reg-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+'/images/calendar_icon.png',alt:'',title:'',border:'0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'maincontent emailpage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'contentsection',className:'contentarea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-inner practice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/rmeta"+"/images/img-lr1.png",align:'absmiddle',alt:'',border:'0'})),'Practice Counter Authentication')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'semana-scroll-inner',className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'scrollbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'track'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'thumb'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{border:'0',alt:'',src:"/rmeta"+"/images/img-practiceauth.jpg"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabdiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Practice Counter Authentication'),' -',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red-txt'},this.state.cre_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{width:'100%',id:'myTable',cellspacing:'0',cellpadding:'0',border:'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,page_flag==2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'42%'},'Name '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.fst_name))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'42%'},'CL ite '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.fst_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Practice'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.pr_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Report as per learner '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.comment))),this.state.score!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'befresubmitted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'42%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:function onClick(e){return _this4.getTr('gettr');}},'click here to reject the report'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'42%'},'Rejected Reason '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.rej_reason))),this.state.score!=0?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'42%'},'Rejected on '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.rej_date))),this.state.reason!=''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'befresubmitted',id:'gettr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'42%'},'Rejected for Rejection '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'comm',id:'comment',value:this.state.comm,onChange:function onChange(e){return _this4.handleChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'button',name:'submit',value:'submit',onClick:function onClick(e){return _this4.onSubmit(e);}}),' ')):''))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__partials_Footer__["a" /* default */],null));}}]);return PracticeResponse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PracticeResponse);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Mchat=function(_Component){_inherits(Mchat,_Component);function Mchat(){_classCallCheck(this,Mchat);return _possibleConstructorReturn(this,(Mchat.__proto__||Object.getPrototypeOf(Mchat)).apply(this,arguments));}_createClass(Mchat,[{key:'render',value:function render(){var iframestyle={display:'block',width:'100vw',height:'100vh',maxWidth:'100%',margin:0,padding:0,border:' 0 none',boxSizing:' border-box'};var learnerID=btoa(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true));var pinID=btoa(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true));var productID=btoa(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true));var url=__WEBPACK_IMPORTED_MODULE_1__config_Config__["f" /* rootChatUrl */]+'index.php?learner_id='+learnerID+'&product_id='+productID+'&pinID='+pinID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:url,frameBorder:'0',style:iframestyle}));}}]);return Mchat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Mchat);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chat=function(_Component){_inherits(Chat,_Component);function Chat(props){_classCallCheck(this,Chat);var _this=_possibleConstructorReturn(this,(Chat.__proto__||Object.getPrototypeOf(Chat)).call(this,props));_this.state={ec_id:_this.props.params.ec_id,time_slot_id:_this.props.params.time_slot_id};return _this;}_createClass(Chat,[{key:'render',value:function render(){var iframestyle={display:'block',width:'100vw',height:'100vh',maxWidth:'100%',margin:0,padding:0,border:' 0 none',boxSizing:' border-box'};var learnerID=btoa(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("id",true));var pinID=btoa(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("pinID",true));var productID=btoa(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["i" /* getUserData */]("productID",true));var url=__WEBPACK_IMPORTED_MODULE_1__config_Config__["h" /* rootEcoachChatUrl */]+'index.php?learner_id='+learnerID+'&product_id='+productID+'&pinID='+pinID+'&l='+this.state.ec_id+'&c='+this.state.time_slot_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:url,frameBorder:'0',style:iframestyle}));}}]);return Chat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Chat);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lr_dlr_components_Contracts__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lr_dlr_components_Courseworkcomp__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lr_dlr_components_Practiceassigment__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lr_dlr_components_ContextQuestionnaire__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lr_dlr_components_FeedbackForm__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lr_dlr_components_Webcastlive__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lr_dlr_components_EvaluationForm__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lr_dlr_components_Thanks__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lr_dlr_components_Descriptivetask3__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lr_dlr_components_GridComp__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lr_dlr_components_Testresults__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lr_dlr_components_Ctestonebyone__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var RoomCompLayout=function(_Component){_inherits(RoomCompLayout,_Component);function RoomCompLayout(props){_classCallCheck(this,RoomCompLayout);var _this=_possibleConstructorReturn(this,(RoomCompLayout.__proto__||Object.getPrototypeOf(RoomCompLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(RoomCompLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!"');}},{key:'getComponent',value:function getComponent(){var _this2=this;__WEBPACK_IMPORTED_MODULE_15__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var params=this.props.params;var data=JSON.stringify({learner_id:__WEBPACK_IMPORTED_MODULE_14__helpers_User__["a" /* UserId */](),room_id:params.room_id,dlr_id:params.dlr_id,compseq_id:params.compseq_id});fetch(__WEBPACK_IMPORTED_MODULE_13__config_Config__["d" /* domainUrl */]+'mobile/component/view',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},body:data}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==2){var component=null;var _data=responseJson.lrcomponents[params.divider_id][0];switch(_data.compo_type){case"contract":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lr_dlr_components_Contracts__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"coursework":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__lr_dlr_components_Courseworkcomp__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"practice":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lr_dlr_components_Practiceassigment__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"descriptivetask":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__lr_dlr_components_Descriptivetask3__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"context":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__lr_dlr_components_ContextQuestionnaire__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"feedbackform":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__lr_dlr_components_FeedbackForm__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"webcastlive":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__lr_dlr_components_Webcastlive__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"evaluation":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__lr_dlr_components_EvaluationForm__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"girdcomponent":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__lr_dlr_components_GridComp__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"ctestonebyone":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__lr_dlr_components_Ctestonebyone__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"testresults":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__lr_dlr_components_Testresults__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();},returnthanks:function returnthanks(){return _this2.emptyFunc();}});break;case"thanks":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__lr_dlr_components_Thanks__["a" /* default */],{data:_data,usableType:'mobileapp',switchback:function switchback(){return _this2.emptyFunc();}});break;default:component=_this2.noAuthorizedPage();}_this2.setState({compBlock:component});}__WEBPACK_IMPORTED_MODULE_15__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;__WEBPACK_IMPORTED_MODULE_15__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_15__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_13__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_15__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this3.getComponent();}else{_this3.setState({compBlock:_this3.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_15__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return RoomCompLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RoomCompLayout);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__personal_interactions_observer_MyObserver__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__personal_interactions_iseek_IseekFeedback__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__personal_interactions_ecoach_Ecoach__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personal_interactions_messages_PersonalMessages__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__personal_interactions_ecoach_request_ChatRequest__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__personal_interactions_technical_support_TechSupport__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__personal_interactions_telecall_request_TelecallRequest__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var PersonalInteractionsLayout=function(_Component){_inherits(PersonalInteractionsLayout,_Component);function PersonalInteractionsLayout(props){_classCallCheck(this,PersonalInteractionsLayout);var _this=_possibleConstructorReturn(this,(PersonalInteractionsLayout.__proto__||Object.getPrototypeOf(PersonalInteractionsLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(PersonalInteractionsLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!"');}},{key:'getComponent',value:function getComponent(){var type=this.props.params.type;var component=null;switch(type){case"myobserver":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__personal_interactions_observer_MyObserver__["a" /* default */],null);break;case"seekfeedback":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__personal_interactions_iseek_IseekFeedback__["a" /* default */],null);break;case"telecall":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__personal_interactions_telecall_request_TelecallRequest__["a" /* default */],null);break;case"techsupport":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__personal_interactions_technical_support_TechSupport__["a" /* default */],null);break;case"messages":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__personal_interactions_messages_PersonalMessages__["a" /* default */],null);break;case"ecoach":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__personal_interactions_ecoach_Ecoach__["a" /* default */],null);break;case"chat_request":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__personal_interactions_ecoach_request_ChatRequest__["a" /* default */],null);break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_10__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_10__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_8__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_10__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_10__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return PersonalInteractionsLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PersonalInteractionsLayout);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learning_records_my_performance_MyPerformance__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__learning_records_MyJourney__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__learning_records_MyDiary__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__learning_records_LoginHistory__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__learning_records_recap_Recap__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var LearningRecordsLayout=function(_Component){_inherits(LearningRecordsLayout,_Component);function LearningRecordsLayout(props){_classCallCheck(this,LearningRecordsLayout);var _this=_possibleConstructorReturn(this,(LearningRecordsLayout.__proto__||Object.getPrototypeOf(LearningRecordsLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(LearningRecordsLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!');}},{key:'getComponent',value:function getComponent(){var type=this.props.params.type;var component=null;switch(type){case"myperformance":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__learning_records_my_performance_MyPerformance__["a" /* default */],null);break;case"myjourney":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__learning_records_MyJourney__["a" /* default */],{Webview:'webview'});break;case"mydiary":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__learning_records_MyDiary__["a" /* default */],null);break;case"loginhistory":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__learning_records_LoginHistory__["a" /* default */],null);break;case"recap":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__learning_records_recap_Recap__["a" /* default */],null);break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_8__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_8__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_6__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_8__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_8__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return LearningRecordsLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LearningRecordsLayout);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__practice_PracticeNokia__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__practice_DatewiseComp__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__practice_PracticewiseComp__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var PracticeLayout=function(_Component){_inherits(PracticeLayout,_Component);function PracticeLayout(props){_classCallCheck(this,PracticeLayout);var _this=_possibleConstructorReturn(this,(PracticeLayout.__proto__||Object.getPrototypeOf(PracticeLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(PracticeLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!');}},{key:'getComponent',value:function getComponent(){var typec=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var type=typec==""?this.props.params.type:typec;var component=null;switch(type){case"PracticeNokia":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__practice_PracticeNokia__["a" /* default */],{switchPanel:this.getComponent.bind(this)});break;case"practice_datewise":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__practice_DatewiseComp__["a" /* default */],{switchPanel:this.getComponent.bind(this)});break;case"practice_score":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__practice_PracticewiseComp__["a" /* default */],{switchPanel:this.getComponent.bind(this)});break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_6__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_6__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_4__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_6__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_6__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return PracticeLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PracticeLayout);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_qlink_partials_DoyouKnow__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_qlink_partials_NewPost__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_qlink_partials_NoticeBoard__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_qlink_partials_SupportDesk__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var RightMenuLayout=function(_Component){_inherits(RightMenuLayout,_Component);function RightMenuLayout(props){_classCallCheck(this,RightMenuLayout);var _this=_possibleConstructorReturn(this,(RightMenuLayout.__proto__||Object.getPrototypeOf(RightMenuLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(RightMenuLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!"');}},{key:'getComponent',value:function getComponent(){var type=this.props.params.type;var app_code=this.props.params.app_code;var device_id=this.props.params.device_id;var component=null;switch(type){case"doyouknow":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__partials_qlink_partials_DoyouKnow__["a" /* default */],{Webview:'webview'});break;case"newpost":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__partials_qlink_partials_NewPost__["a" /* default */],{Webview:'webview',appcode:app_code,device_id:device_id});break;case"notice-board":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__partials_qlink_partials_NoticeBoard__["a" /* default */],{Webview:'webview'});break;case"support-desk":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__partials_qlink_partials_SupportDesk__["a" /* default */],{Webview:'webview'});break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_5__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_7__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return RightMenuLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RightMenuLayout);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learning_resources_Courseware__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__learning_resources_library_Mylibrary__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var LearningResourcesLayout=function(_Component){_inherits(LearningResourcesLayout,_Component);function LearningResourcesLayout(props){_classCallCheck(this,LearningResourcesLayout);var _this=_possibleConstructorReturn(this,(LearningResourcesLayout.__proto__||Object.getPrototypeOf(LearningResourcesLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(LearningResourcesLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!"');}},{key:'getComponent',value:function getComponent(){var type=this.props.params.type;var component=null;switch(type){case"library":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__learning_resources_library_Mylibrary__["a" /* default */],{usableType:'mobileapp'});break;case"courseware":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__learning_resources_Courseware__["a" /* default */],{usableType:'mobileapp'});break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_3__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_5__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return LearningResourcesLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LearningResourcesLayout);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__group_interactions_OpinionPoll__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_User__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var GroupInteractionsLayout=function(_Component){_inherits(GroupInteractionsLayout,_Component);function GroupInteractionsLayout(props){_classCallCheck(this,GroupInteractionsLayout);var _this=_possibleConstructorReturn(this,(GroupInteractionsLayout.__proto__||Object.getPrototypeOf(GroupInteractionsLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(GroupInteractionsLayout,[{key:'emptyFunc',value:function emptyFunc(){}},{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!');}},{key:'getComponent',value:function getComponent(){var type=this.props.params.type;var component=null;switch(type){case"opinionpolls":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__group_interactions_OpinionPoll__["a" /* default */],null);break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_4__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return GroupInteractionsLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GroupInteractionsLayout);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xrecap_XRecap__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Common__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var XrecapLayout=function(_Component){_inherits(XrecapLayout,_Component);function XrecapLayout(props){_classCallCheck(this,XrecapLayout);var _this=_possibleConstructorReturn(this,(XrecapLayout.__proto__||Object.getPrototypeOf(XrecapLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(XrecapLayout,[{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!');}},{key:'getComponent',value:function getComponent(){var type=this.props.params.type;var component=null;switch(type){case"xrecap":component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__xrecap_XRecap__["a" /* default */],null);break;default:component=this.noAuthorizedPage();}this.setState({compBlock:component});$("#contentsection").addClass('mobileapp');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("show","Please wait...");var query_data=__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["q" /* objToSlashString */]({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_2__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status==1){__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["x" /* setTokenData */]("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}__WEBPACK_IMPORTED_MODULE_3__helpers_Common__["u" /* reactLoader */]("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return XrecapLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (XrecapLayout);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_DmWall__ = __webpack_require__(208);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var $=window.$;var styles={justifyContent:'center',alignItems:'center',display:'flex',float:'left',width:'100%',position:'absolute',height:'100%'};var DmWallLayout=function(_Component){_inherits(DmWallLayout,_Component);function DmWallLayout(props){_classCallCheck(this,DmWallLayout);var _this=_possibleConstructorReturn(this,(DmWallLayout.__proto__||Object.getPrototypeOf(DmWallLayout)).call(this,props));_this.state={compBlock:null};return _this;}_createClass(DmWallLayout,[{key:'noAuthorizedPage',value:function noAuthorizedPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles},'You are not authorized to access this page!');}},{key:'getComponent',value:function getComponent(){this.setState({compBlock:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__partials_DmWall__["a" /* default */],{autoload:true})});}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("show","Please wait...");var query_data=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["q" /* objToSlashString */])({app_code:this.props.params.app_code,device_id:this.props.params.device_id});fetch(__WEBPACK_IMPORTED_MODULE_1__config_Config__["d" /* domainUrl */]+'mobile/learner/check'+query_data,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(response){return response.json();}).then(function(responseJson){if(responseJson.status===1){Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["x" /* setTokenData */])("token",responseJson.data.token);_this2.getComponent();}else{_this2.setState({compBlock:_this2.noAuthorizedPage()});}Object(__WEBPACK_IMPORTED_MODULE_2__helpers_Common__["u" /* reactLoader */])("hide");});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.compBlock);}}]);return DmWallLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DmWallLayout);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_promise__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_logger__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers__ = __webpack_require__(884);
//import {createStore, applyMiddleware} from 'redux';
/*use compose for dev mode for redux */// Reducers
// const configureStore = createStore(
//     allReducers,
//     applyMiddleware(thunk, promise)
// );
/* development mode for redux */var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */];var configureStore=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_5__reducers__["a" /* default */],composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3_redux_promise___default.a)));/* harmony default export */ __webpack_exports__["a"] = (configureStore);//applyMiddleware(thunk, promise, logger)

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = promiseMiddleware;

var _fluxStandardAction = __webpack_require__(878);

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function promiseMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      if (!_fluxStandardAction.isFSA(action)) {
        return isPromise(action) ? action.then(dispatch) : next(action);
      }

      return isPromise(action.payload) ? action.payload.then(function (result) {
        return dispatch(_extends({}, action, { payload: result }));
      }, function (error) {
        return dispatch(_extends({}, action, { payload: error, error: true }));
      }) : next(action);
    };
  };
}

module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashIsplainobject = __webpack_require__(879);

var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);

var validKeys = ['type', 'payload', 'error', 'meta'];

function isValidKey(key) {
  return validKeys.indexOf(key) > -1;
}

function isFSA(action) {
  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(880),
    isArguments = __webpack_require__(352),
    keysIn = __webpack_require__(881);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty.call(value, result);
}

module.exports = isPlainObject;


/***/ }),
/* 880 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * Creates a base function for methods like `_.forIn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = baseFor;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(352),
    isArray = __webpack_require__(882);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 882 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LearningroomReducer__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionGoalReducer__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewpostReducer__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InboxReducer__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProfileReducer__ = __webpack_require__(889);
var allReducers=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({learningRoom:__WEBPACK_IMPORTED_MODULE_1__LearningroomReducer__["a" /* default */],actionGoal:__WEBPACK_IMPORTED_MODULE_2__ActionGoalReducer__["a" /* default */],newPost:__WEBPACK_IMPORTED_MODULE_3__NewpostReducer__["a" /* default */],inbox:__WEBPACK_IMPORTED_MODULE_4__InboxReducer__["a" /* default */],profile:__WEBPACK_IMPORTED_MODULE_5__ProfileReducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (allReducers);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LearningroomReducer;
function LearningroomReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"SET_LEARNING_ROOM":return action.learningRoom;default:return state;}}

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ActionGoalReducer;
function ActionGoalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"GET_ACTION_GOAL":return action.actionGoal;default:return state;}}

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NewpostReducer;
function NewpostReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"SET_NEW_POST":return action.newPost;default:return state;}}

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = InboxReducer;
function InboxReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"SET_INBOX":return action.inbox;default:return state;}}

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProfileReducer;
function ProfileReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"SET_PROFILE":return action.profile;default:return state;}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.d4dd28fe.js